(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["orquestra-web-vue"] = factory(require("vue"));
	else
		root["orquestra-web-vue"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__7203__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 2960:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
// runtime helper for setting properties on components
// in a tree-shakable way
exports.Z = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};

/***/ }),

/***/ 4917:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(560);__webpack_require__(4224);__webpack_require__(1121);__webpack_require__(7133);__webpack_require__(8858);__webpack_require__(1318);__webpack_require__(3228);__webpack_require__(1719);typeof navigator!=="undefined"&&function(global,factory){ true?module.exports=factory():0;}(this,function(){'use strict';var svgNS='http://www.w3.org/2000/svg';var locationHref='';var _useWebWorker=false;var initialDefaultFrame=-999999;var setWebWorker=function setWebWorker(flag){_useWebWorker=!!flag;};var getWebWorker=function getWebWorker(){return _useWebWorker;};var setLocationHref=function setLocationHref(value){locationHref=value;};var getLocationHref=function getLocationHref(){return locationHref;};function createTag(type){// return {appendChild:function(){},setAttribute:function(){},style:{}}
return document.createElement(type);}function extendPrototype(sources,destination){var i;var len=sources.length;var sourcePrototype;for(i=0;i<len;i+=1){sourcePrototype=sources[i].prototype;for(var attr in sourcePrototype){if(Object.prototype.hasOwnProperty.call(sourcePrototype,attr))destination.prototype[attr]=sourcePrototype[attr];}}}function getDescriptor(object,prop){return Object.getOwnPropertyDescriptor(object,prop);}function createProxyFunction(prototype){function ProxyFunction(){}ProxyFunction.prototype=prototype;return ProxyFunction;}// import Howl from '../../3rd_party/howler';
var audioControllerFactory=function(){function AudioController(audioFactory){this.audios=[];this.audioFactory=audioFactory;this._volume=1;this._isMuted=false;}AudioController.prototype={addAudio:function addAudio(audio){this.audios.push(audio);},pause:function pause(){var i;var len=this.audios.length;for(i=0;i<len;i+=1){this.audios[i].pause();}},resume:function resume(){var i;var len=this.audios.length;for(i=0;i<len;i+=1){this.audios[i].resume();}},setRate:function setRate(rateValue){var i;var len=this.audios.length;for(i=0;i<len;i+=1){this.audios[i].setRate(rateValue);}},createAudio:function createAudio(assetPath){if(this.audioFactory){return this.audioFactory(assetPath);}if(window.Howl){return new window.Howl({src:[assetPath]});}return{isPlaying:false,play:function play(){this.isPlaying=true;},seek:function seek(){this.isPlaying=false;},playing:function playing(){},rate:function rate(){},setVolume:function setVolume(){}};},setAudioFactory:function setAudioFactory(audioFactory){this.audioFactory=audioFactory;},setVolume:function setVolume(value){this._volume=value;this._updateVolume();},mute:function mute(){this._isMuted=true;this._updateVolume();},unmute:function unmute(){this._isMuted=false;this._updateVolume();},getVolume:function getVolume(){return this._volume;},_updateVolume:function _updateVolume(){var i;var len=this.audios.length;for(i=0;i<len;i+=1){this.audios[i].volume(this._volume*(this._isMuted?0:1));}}};return function(){return new AudioController();};}();var createTypedArray=function(){function createRegularArray(type,len){var i=0;var arr=[];var value;switch(type){case'int16':case'uint8c':value=1;break;default:value=1.1;break;}for(i=0;i<len;i+=1){arr.push(value);}return arr;}function createTypedArrayFactory(type,len){if(type==='float32'){return new Float32Array(len);}if(type==='int16'){return new Int16Array(len);}if(type==='uint8c'){return new Uint8ClampedArray(len);}return createRegularArray(type,len);}if(typeof Uint8ClampedArray==='function'&&typeof Float32Array==='function'){return createTypedArrayFactory;}return createRegularArray;}();function createSizedArray(len){return Array.apply(null,{length:len});}function _typeof$6(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$6=function _typeof(obj){return typeof obj;};}else{_typeof$6=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$6(obj);}var subframeEnabled=true;var expressionsPlugin=null;var expressionsInterfaces=null;var idPrefix$1='';var isSafari=/^((?!chrome|android).)*safari/i.test(navigator.userAgent);var _shouldRoundValues=false;var bmPow=Math.pow;var bmSqrt=Math.sqrt;var bmFloor=Math.floor;var bmMax=Math.max;var bmMin=Math.min;var BMMath={};(function(){var propertyNames=['abs','acos','acosh','asin','asinh','atan','atanh','atan2','ceil','cbrt','expm1','clz32','cos','cosh','exp','floor','fround','hypot','imul','log','log1p','log2','log10','max','min','pow','random','round','sign','sin','sinh','sqrt','tan','tanh','trunc','E','LN10','LN2','LOG10E','LOG2E','PI','SQRT1_2','SQRT2'];var i;var len=propertyNames.length;for(i=0;i<len;i+=1){BMMath[propertyNames[i]]=Math[propertyNames[i]];}})();function ProjectInterface$1(){return{};}BMMath.random=Math.random;BMMath.abs=function(val){var tOfVal=_typeof$6(val);if(tOfVal==='object'&&val.length){var absArr=createSizedArray(val.length);var i;var len=val.length;for(i=0;i<len;i+=1){absArr[i]=Math.abs(val[i]);}return absArr;}return Math.abs(val);};var defaultCurveSegments=150;var degToRads=Math.PI/180;var roundCorner=0.5519;function roundValues(flag){_shouldRoundValues=!!flag;}function bmRnd(value){if(_shouldRoundValues){return Math.round(value);}return value;}function styleDiv(element){element.style.position='absolute';element.style.top=0;element.style.left=0;element.style.display='block';element.style.transformOrigin='0 0';element.style.webkitTransformOrigin='0 0';element.style.backfaceVisibility='visible';element.style.webkitBackfaceVisibility='visible';element.style.transformStyle='preserve-3d';element.style.webkitTransformStyle='preserve-3d';element.style.mozTransformStyle='preserve-3d';}function BMEnterFrameEvent(type,currentTime,totalTime,frameMultiplier){this.type=type;this.currentTime=currentTime;this.totalTime=totalTime;this.direction=frameMultiplier<0?-1:1;}function BMCompleteEvent(type,frameMultiplier){this.type=type;this.direction=frameMultiplier<0?-1:1;}function BMCompleteLoopEvent(type,totalLoops,currentLoop,frameMultiplier){this.type=type;this.currentLoop=currentLoop;this.totalLoops=totalLoops;this.direction=frameMultiplier<0?-1:1;}function BMSegmentStartEvent(type,firstFrame,totalFrames){this.type=type;this.firstFrame=firstFrame;this.totalFrames=totalFrames;}function BMDestroyEvent(type,target){this.type=type;this.target=target;}function BMRenderFrameErrorEvent(nativeError,currentTime){this.type='renderFrameError';this.nativeError=nativeError;this.currentTime=currentTime;}function BMConfigErrorEvent(nativeError){this.type='configError';this.nativeError=nativeError;}function BMAnimationConfigErrorEvent(type,nativeError){this.type=type;this.nativeError=nativeError;}var createElementID=function(){var _count=0;return function createID(){_count+=1;return idPrefix$1+'__lottie_element_'+_count;};}();function HSVtoRGB(h,s,v){var r;var g;var b;var i;var f;var p;var q;var t;i=Math.floor(h*6);f=h*6-i;p=v*(1-s);q=v*(1-f*s);t=v*(1-(1-f)*s);switch(i%6){case 0:r=v;g=t;b=p;break;case 1:r=q;g=v;b=p;break;case 2:r=p;g=v;b=t;break;case 3:r=p;g=q;b=v;break;case 4:r=t;g=p;b=v;break;case 5:r=v;g=p;b=q;break;default:break;}return[r,g,b];}function RGBtoHSV(r,g,b){var max=Math.max(r,g,b);var min=Math.min(r,g,b);var d=max-min;var h;var s=max===0?0:d/max;var v=max/255;switch(max){case min:h=0;break;case r:h=g-b+d*(g<b?6:0);h/=6*d;break;case g:h=b-r+d*2;h/=6*d;break;case b:h=r-g+d*4;h/=6*d;break;default:break;}return[h,s,v];}function addSaturationToRGB(color,offset){var hsv=RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);hsv[1]+=offset;if(hsv[1]>1){hsv[1]=1;}else if(hsv[1]<=0){hsv[1]=0;}return HSVtoRGB(hsv[0],hsv[1],hsv[2]);}function addBrightnessToRGB(color,offset){var hsv=RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);hsv[2]+=offset;if(hsv[2]>1){hsv[2]=1;}else if(hsv[2]<0){hsv[2]=0;}return HSVtoRGB(hsv[0],hsv[1],hsv[2]);}function addHueToRGB(color,offset){var hsv=RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);hsv[0]+=offset/360;if(hsv[0]>1){hsv[0]-=1;}else if(hsv[0]<0){hsv[0]+=1;}return HSVtoRGB(hsv[0],hsv[1],hsv[2]);}var rgbToHex=function(){var colorMap=[];var i;var hex;for(i=0;i<256;i+=1){hex=i.toString(16);colorMap[i]=hex.length===1?'0'+hex:hex;}return function(r,g,b){if(r<0){r=0;}if(g<0){g=0;}if(b<0){b=0;}return'#'+colorMap[r]+colorMap[g]+colorMap[b];};}();var setSubframeEnabled=function setSubframeEnabled(flag){subframeEnabled=!!flag;};var getSubframeEnabled=function getSubframeEnabled(){return subframeEnabled;};var setExpressionsPlugin=function setExpressionsPlugin(value){expressionsPlugin=value;};var getExpressionsPlugin=function getExpressionsPlugin(){return expressionsPlugin;};var setExpressionInterfaces=function setExpressionInterfaces(value){expressionsInterfaces=value;};var getExpressionInterfaces=function getExpressionInterfaces(){return expressionsInterfaces;};var setDefaultCurveSegments=function setDefaultCurveSegments(value){defaultCurveSegments=value;};var getDefaultCurveSegments=function getDefaultCurveSegments(){return defaultCurveSegments;};var setIdPrefix=function setIdPrefix(value){idPrefix$1=value;};var getIdPrefix=function getIdPrefix(){return idPrefix$1;};function createNS(type){// return {appendChild:function(){},setAttribute:function(){},style:{}}
return document.createElementNS(svgNS,type);}function _typeof$5(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$5=function _typeof(obj){return typeof obj;};}else{_typeof$5=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$5(obj);}var dataManager=function(){var _counterId=1;var processes=[];var workerFn;var workerInstance;var workerProxy={onmessage:function onmessage(){},postMessage:function postMessage(path){workerFn({data:path});}};var _workerSelf={postMessage:function postMessage(data){workerProxy.onmessage({data:data});}};function createWorker(fn){if(window.Worker&&window.Blob&&getWebWorker()){var blob=new Blob(['var _workerSelf = self; self.onmessage = ',fn.toString()],{type:'text/javascript'});// var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
var url=URL.createObjectURL(blob);return new Worker(url);}workerFn=fn;return workerProxy;}function setupWorker(){if(!workerInstance){workerInstance=createWorker(function workerStart(e){function dataFunctionManager(){function completeLayers(layers,comps){var layerData;var i;var len=layers.length;var j;var jLen;var k;var kLen;for(i=0;i<len;i+=1){layerData=layers[i];if('ks'in layerData&&!layerData.completed){layerData.completed=true;if(layerData.hasMask){var maskProps=layerData.masksProperties;jLen=maskProps.length;for(j=0;j<jLen;j+=1){if(maskProps[j].pt.k.i){convertPathsToAbsoluteValues(maskProps[j].pt.k);}else{kLen=maskProps[j].pt.k.length;for(k=0;k<kLen;k+=1){if(maskProps[j].pt.k[k].s){convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);}if(maskProps[j].pt.k[k].e){convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);}}}}}if(layerData.ty===0){layerData.layers=findCompLayers(layerData.refId,comps);completeLayers(layerData.layers,comps);}else if(layerData.ty===4){completeShapes(layerData.shapes);}else if(layerData.ty===5){completeText(layerData);}}}}function completeChars(chars,assets){if(chars){var i=0;var len=chars.length;for(i=0;i<len;i+=1){if(chars[i].t===1){// var compData = findComp(chars[i].data.refId, assets);
chars[i].data.layers=findCompLayers(chars[i].data.refId,assets);// chars[i].data.ip = 0;
// chars[i].data.op = 99999;
// chars[i].data.st = 0;
// chars[i].data.sr = 1;
// chars[i].w = compData.w;
// chars[i].data.ks = {
//   a: { k: [0, 0, 0], a: 0 },
//   p: { k: [0, -compData.h, 0], a: 0 },
//   r: { k: 0, a: 0 },
//   s: { k: [100, 100], a: 0 },
//   o: { k: 100, a: 0 },
// };
completeLayers(chars[i].data.layers,assets);}}}}function findComp(id,comps){var i=0;var len=comps.length;while(i<len){if(comps[i].id===id){return comps[i];}i+=1;}return null;}function findCompLayers(id,comps){var comp=findComp(id,comps);if(comp){if(!comp.layers.__used){comp.layers.__used=true;return comp.layers;}return JSON.parse(JSON.stringify(comp.layers));}return null;}function completeShapes(arr){var i;var len=arr.length;var j;var jLen;for(i=len-1;i>=0;i-=1){if(arr[i].ty==='sh'){if(arr[i].ks.k.i){convertPathsToAbsoluteValues(arr[i].ks.k);}else{jLen=arr[i].ks.k.length;for(j=0;j<jLen;j+=1){if(arr[i].ks.k[j].s){convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);}if(arr[i].ks.k[j].e){convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);}}}}else if(arr[i].ty==='gr'){completeShapes(arr[i].it);}}}function convertPathsToAbsoluteValues(path){var i;var len=path.i.length;for(i=0;i<len;i+=1){path.i[i][0]+=path.v[i][0];path.i[i][1]+=path.v[i][1];path.o[i][0]+=path.v[i][0];path.o[i][1]+=path.v[i][1];}}function checkVersion(minimum,animVersionString){var animVersion=animVersionString?animVersionString.split('.'):[100,100,100];if(minimum[0]>animVersion[0]){return true;}if(animVersion[0]>minimum[0]){return false;}if(minimum[1]>animVersion[1]){return true;}if(animVersion[1]>minimum[1]){return false;}if(minimum[2]>animVersion[2]){return true;}if(animVersion[2]>minimum[2]){return false;}return null;}var checkText=function(){var minimumVersion=[4,4,14];function updateTextLayer(textLayer){var documentData=textLayer.t.d;textLayer.t.d={k:[{s:documentData,t:0}]};}function iterateLayers(layers){var i;var len=layers.length;for(i=0;i<len;i+=1){if(layers[i].ty===5){updateTextLayer(layers[i]);}}}return function(animationData){if(checkVersion(minimumVersion,animationData.v)){iterateLayers(animationData.layers);if(animationData.assets){var i;var len=animationData.assets.length;for(i=0;i<len;i+=1){if(animationData.assets[i].layers){iterateLayers(animationData.assets[i].layers);}}}}};}();var checkChars=function(){var minimumVersion=[4,7,99];return function(animationData){if(animationData.chars&&!checkVersion(minimumVersion,animationData.v)){var i;var len=animationData.chars.length;for(i=0;i<len;i+=1){var charData=animationData.chars[i];if(charData.data&&charData.data.shapes){completeShapes(charData.data.shapes);charData.data.ip=0;charData.data.op=99999;charData.data.st=0;charData.data.sr=1;charData.data.ks={p:{k:[0,0],a:0},s:{k:[100,100],a:0},a:{k:[0,0],a:0},r:{k:0,a:0},o:{k:100,a:0}};if(!animationData.chars[i].t){charData.data.shapes.push({ty:'no'});charData.data.shapes[0].it.push({p:{k:[0,0],a:0},s:{k:[100,100],a:0},a:{k:[0,0],a:0},r:{k:0,a:0},o:{k:100,a:0},sk:{k:0,a:0},sa:{k:0,a:0},ty:'tr'});}}}}};}();var checkPathProperties=function(){var minimumVersion=[5,7,15];function updateTextLayer(textLayer){var pathData=textLayer.t.p;if(typeof pathData.a==='number'){pathData.a={a:0,k:pathData.a};}if(typeof pathData.p==='number'){pathData.p={a:0,k:pathData.p};}if(typeof pathData.r==='number'){pathData.r={a:0,k:pathData.r};}}function iterateLayers(layers){var i;var len=layers.length;for(i=0;i<len;i+=1){if(layers[i].ty===5){updateTextLayer(layers[i]);}}}return function(animationData){if(checkVersion(minimumVersion,animationData.v)){iterateLayers(animationData.layers);if(animationData.assets){var i;var len=animationData.assets.length;for(i=0;i<len;i+=1){if(animationData.assets[i].layers){iterateLayers(animationData.assets[i].layers);}}}}};}();var checkColors=function(){var minimumVersion=[4,1,9];function iterateShapes(shapes){var i;var len=shapes.length;var j;var jLen;for(i=0;i<len;i+=1){if(shapes[i].ty==='gr'){iterateShapes(shapes[i].it);}else if(shapes[i].ty==='fl'||shapes[i].ty==='st'){if(shapes[i].c.k&&shapes[i].c.k[0].i){jLen=shapes[i].c.k.length;for(j=0;j<jLen;j+=1){if(shapes[i].c.k[j].s){shapes[i].c.k[j].s[0]/=255;shapes[i].c.k[j].s[1]/=255;shapes[i].c.k[j].s[2]/=255;shapes[i].c.k[j].s[3]/=255;}if(shapes[i].c.k[j].e){shapes[i].c.k[j].e[0]/=255;shapes[i].c.k[j].e[1]/=255;shapes[i].c.k[j].e[2]/=255;shapes[i].c.k[j].e[3]/=255;}}}else{shapes[i].c.k[0]/=255;shapes[i].c.k[1]/=255;shapes[i].c.k[2]/=255;shapes[i].c.k[3]/=255;}}}}function iterateLayers(layers){var i;var len=layers.length;for(i=0;i<len;i+=1){if(layers[i].ty===4){iterateShapes(layers[i].shapes);}}}return function(animationData){if(checkVersion(minimumVersion,animationData.v)){iterateLayers(animationData.layers);if(animationData.assets){var i;var len=animationData.assets.length;for(i=0;i<len;i+=1){if(animationData.assets[i].layers){iterateLayers(animationData.assets[i].layers);}}}}};}();var checkShapes=function(){var minimumVersion=[4,4,18];function completeClosingShapes(arr){var i;var len=arr.length;var j;var jLen;for(i=len-1;i>=0;i-=1){if(arr[i].ty==='sh'){if(arr[i].ks.k.i){arr[i].ks.k.c=arr[i].closed;}else{jLen=arr[i].ks.k.length;for(j=0;j<jLen;j+=1){if(arr[i].ks.k[j].s){arr[i].ks.k[j].s[0].c=arr[i].closed;}if(arr[i].ks.k[j].e){arr[i].ks.k[j].e[0].c=arr[i].closed;}}}}else if(arr[i].ty==='gr'){completeClosingShapes(arr[i].it);}}}function iterateLayers(layers){var layerData;var i;var len=layers.length;var j;var jLen;var k;var kLen;for(i=0;i<len;i+=1){layerData=layers[i];if(layerData.hasMask){var maskProps=layerData.masksProperties;jLen=maskProps.length;for(j=0;j<jLen;j+=1){if(maskProps[j].pt.k.i){maskProps[j].pt.k.c=maskProps[j].cl;}else{kLen=maskProps[j].pt.k.length;for(k=0;k<kLen;k+=1){if(maskProps[j].pt.k[k].s){maskProps[j].pt.k[k].s[0].c=maskProps[j].cl;}if(maskProps[j].pt.k[k].e){maskProps[j].pt.k[k].e[0].c=maskProps[j].cl;}}}}}if(layerData.ty===4){completeClosingShapes(layerData.shapes);}}}return function(animationData){if(checkVersion(minimumVersion,animationData.v)){iterateLayers(animationData.layers);if(animationData.assets){var i;var len=animationData.assets.length;for(i=0;i<len;i+=1){if(animationData.assets[i].layers){iterateLayers(animationData.assets[i].layers);}}}}};}();function completeData(animationData){if(animationData.__complete){return;}checkColors(animationData);checkText(animationData);checkChars(animationData);checkPathProperties(animationData);checkShapes(animationData);completeLayers(animationData.layers,animationData.assets);completeChars(animationData.chars,animationData.assets);animationData.__complete=true;}function completeText(data){if(data.t.a.length===0&&!('m'in data.t.p)){// data.singleShape = true;
}}var moduleOb={};moduleOb.completeData=completeData;moduleOb.checkColors=checkColors;moduleOb.checkChars=checkChars;moduleOb.checkPathProperties=checkPathProperties;moduleOb.checkShapes=checkShapes;moduleOb.completeLayers=completeLayers;return moduleOb;}if(!_workerSelf.dataManager){_workerSelf.dataManager=dataFunctionManager();}if(!_workerSelf.assetLoader){_workerSelf.assetLoader=function(){function formatResponse(xhr){// using typeof doubles the time of execution of this method,
// so if available, it's better to use the header to validate the type
var contentTypeHeader=xhr.getResponseHeader('content-type');if(contentTypeHeader&&xhr.responseType==='json'&&contentTypeHeader.indexOf('json')!==-1){return xhr.response;}if(xhr.response&&_typeof$5(xhr.response)==='object'){return xhr.response;}if(xhr.response&&typeof xhr.response==='string'){return JSON.parse(xhr.response);}if(xhr.responseText){return JSON.parse(xhr.responseText);}return null;}function loadAsset(path,fullPath,callback,errorCallback){var response;var xhr=new XMLHttpRequest();// set responseType after calling open or IE will break.
try{// This crashes on Android WebView prior to KitKat
xhr.responseType='json';}catch(err){}// eslint-disable-line no-empty
xhr.onreadystatechange=function(){if(xhr.readyState===4){if(xhr.status===200){response=formatResponse(xhr);callback(response);}else{try{response=formatResponse(xhr);callback(response);}catch(err){if(errorCallback){errorCallback(err);}}}}};try{// Hack to workaround banner validation
xhr.open(['G','E','T'].join(''),path,true);}catch(error){// Hack to workaround banner validation
xhr.open(['G','E','T'].join(''),fullPath+'/'+path,true);}xhr.send();}return{load:loadAsset};}();}if(e.data.type==='loadAnimation'){_workerSelf.assetLoader.load(e.data.path,e.data.fullPath,function(data){_workerSelf.dataManager.completeData(data);_workerSelf.postMessage({id:e.data.id,payload:data,status:'success'});},function(){_workerSelf.postMessage({id:e.data.id,status:'error'});});}else if(e.data.type==='complete'){var animation=e.data.animation;_workerSelf.dataManager.completeData(animation);_workerSelf.postMessage({id:e.data.id,payload:animation,status:'success'});}else if(e.data.type==='loadData'){_workerSelf.assetLoader.load(e.data.path,e.data.fullPath,function(data){_workerSelf.postMessage({id:e.data.id,payload:data,status:'success'});},function(){_workerSelf.postMessage({id:e.data.id,status:'error'});});}});workerInstance.onmessage=function(event){var data=event.data;var id=data.id;var process=processes[id];processes[id]=null;if(data.status==='success'){process.onComplete(data.payload);}else if(process.onError){process.onError();}};}}function createProcess(onComplete,onError){_counterId+=1;var id='processId_'+_counterId;processes[id]={onComplete:onComplete,onError:onError};return id;}function loadAnimation(path,onComplete,onError){setupWorker();var processId=createProcess(onComplete,onError);workerInstance.postMessage({type:'loadAnimation',path:path,fullPath:window.location.origin+window.location.pathname,id:processId});}function loadData(path,onComplete,onError){setupWorker();var processId=createProcess(onComplete,onError);workerInstance.postMessage({type:'loadData',path:path,fullPath:window.location.origin+window.location.pathname,id:processId});}function completeAnimation(anim,onComplete,onError){setupWorker();var processId=createProcess(onComplete,onError);workerInstance.postMessage({type:'complete',animation:anim,id:processId});}return{loadAnimation:loadAnimation,loadData:loadData,completeAnimation:completeAnimation};}();var ImagePreloader=function(){var proxyImage=function(){var canvas=createTag('canvas');canvas.width=1;canvas.height=1;var ctx=canvas.getContext('2d');ctx.fillStyle='rgba(0,0,0,0)';ctx.fillRect(0,0,1,1);return canvas;}();function imageLoaded(){this.loadedAssets+=1;if(this.loadedAssets===this.totalImages&&this.loadedFootagesCount===this.totalFootages){if(this.imagesLoadedCb){this.imagesLoadedCb(null);}}}function footageLoaded(){this.loadedFootagesCount+=1;if(this.loadedAssets===this.totalImages&&this.loadedFootagesCount===this.totalFootages){if(this.imagesLoadedCb){this.imagesLoadedCb(null);}}}function getAssetsPath(assetData,assetsPath,originalPath){var path='';if(assetData.e){path=assetData.p;}else if(assetsPath){var imagePath=assetData.p;if(imagePath.indexOf('images/')!==-1){imagePath=imagePath.split('/')[1];}path=assetsPath+imagePath;}else{path=originalPath;path+=assetData.u?assetData.u:'';path+=assetData.p;}return path;}function testImageLoaded(img){var _count=0;var intervalId=setInterval(function(){var box=img.getBBox();if(box.width||_count>500){this._imageLoaded();clearInterval(intervalId);}_count+=1;}.bind(this),50);}function createImageData(assetData){var path=getAssetsPath(assetData,this.assetsPath,this.path);var img=createNS('image');if(isSafari){this.testImageLoaded(img);}else{img.addEventListener('load',this._imageLoaded,false);}img.addEventListener('error',function(){ob.img=proxyImage;this._imageLoaded();}.bind(this),false);img.setAttributeNS('http://www.w3.org/1999/xlink','href',path);if(this._elementHelper.append){this._elementHelper.append(img);}else{this._elementHelper.appendChild(img);}var ob={img:img,assetData:assetData};return ob;}function createImgData(assetData){var path=getAssetsPath(assetData,this.assetsPath,this.path);var img=createTag('img');img.crossOrigin='anonymous';img.addEventListener('load',this._imageLoaded,false);img.addEventListener('error',function(){ob.img=proxyImage;this._imageLoaded();}.bind(this),false);img.src=path;var ob={img:img,assetData:assetData};return ob;}function createFootageData(data){var ob={assetData:data};var path=getAssetsPath(data,this.assetsPath,this.path);dataManager.loadData(path,function(footageData){ob.img=footageData;this._footageLoaded();}.bind(this),function(){ob.img={};this._footageLoaded();}.bind(this));return ob;}function loadAssets(assets,cb){this.imagesLoadedCb=cb;var i;var len=assets.length;for(i=0;i<len;i+=1){if(!assets[i].layers){if(!assets[i].t||assets[i].t==='seq'){this.totalImages+=1;this.images.push(this._createImageData(assets[i]));}else if(assets[i].t===3){this.totalFootages+=1;this.images.push(this.createFootageData(assets[i]));}}}}function setPath(path){this.path=path||'';}function setAssetsPath(path){this.assetsPath=path||'';}function getAsset(assetData){var i=0;var len=this.images.length;while(i<len){if(this.images[i].assetData===assetData){return this.images[i].img;}i+=1;}return null;}function destroy(){this.imagesLoadedCb=null;this.images.length=0;}function loadedImages(){return this.totalImages===this.loadedAssets;}function loadedFootages(){return this.totalFootages===this.loadedFootagesCount;}function setCacheType(type,elementHelper){if(type==='svg'){this._elementHelper=elementHelper;this._createImageData=this.createImageData.bind(this);}else{this._createImageData=this.createImgData.bind(this);}}function ImagePreloaderFactory(){this._imageLoaded=imageLoaded.bind(this);this._footageLoaded=footageLoaded.bind(this);this.testImageLoaded=testImageLoaded.bind(this);this.createFootageData=createFootageData.bind(this);this.assetsPath='';this.path='';this.totalImages=0;this.totalFootages=0;this.loadedAssets=0;this.loadedFootagesCount=0;this.imagesLoadedCb=null;this.images=[];}ImagePreloaderFactory.prototype={loadAssets:loadAssets,setAssetsPath:setAssetsPath,setPath:setPath,loadedImages:loadedImages,loadedFootages:loadedFootages,destroy:destroy,getAsset:getAsset,createImgData:createImgData,createImageData:createImageData,imageLoaded:imageLoaded,footageLoaded:footageLoaded,setCacheType:setCacheType};return ImagePreloaderFactory;}();function BaseEvent(){}BaseEvent.prototype={triggerEvent:function triggerEvent(eventName,args){if(this._cbs[eventName]){var callbacks=this._cbs[eventName];for(var i=0;i<callbacks.length;i+=1){callbacks[i](args);}}},addEventListener:function addEventListener(eventName,callback){if(!this._cbs[eventName]){this._cbs[eventName]=[];}this._cbs[eventName].push(callback);return function(){this.removeEventListener(eventName,callback);}.bind(this);},removeEventListener:function removeEventListener(eventName,callback){if(!callback){this._cbs[eventName]=null;}else if(this._cbs[eventName]){var i=0;var len=this._cbs[eventName].length;while(i<len){if(this._cbs[eventName][i]===callback){this._cbs[eventName].splice(i,1);i-=1;len-=1;}i+=1;}if(!this._cbs[eventName].length){this._cbs[eventName]=null;}}}};var markerParser=function(){function parsePayloadLines(payload){var lines=payload.split('\r\n');var keys={};var line;var keysCount=0;for(var i=0;i<lines.length;i+=1){line=lines[i].split(':');if(line.length===2){keys[line[0]]=line[1].trim();keysCount+=1;}}if(keysCount===0){throw new Error();}return keys;}return function(_markers){var markers=[];for(var i=0;i<_markers.length;i+=1){var _marker=_markers[i];var markerData={time:_marker.tm,duration:_marker.dr};try{markerData.payload=JSON.parse(_markers[i].cm);}catch(_){try{markerData.payload=parsePayloadLines(_markers[i].cm);}catch(__){markerData.payload={name:_markers[i].cm};}}markers.push(markerData);}return markers;};}();var ProjectInterface=function(){function registerComposition(comp){this.compositions.push(comp);}return function(){function _thisProjectFunction(name){var i=0;var len=this.compositions.length;while(i<len){if(this.compositions[i].data&&this.compositions[i].data.nm===name){if(this.compositions[i].prepareFrame&&this.compositions[i].data.xt){this.compositions[i].prepareFrame(this.currentFrame);}return this.compositions[i].compInterface;}i+=1;}return null;}_thisProjectFunction.compositions=[];_thisProjectFunction.currentFrame=0;_thisProjectFunction.registerComposition=registerComposition;return _thisProjectFunction;};}();var renderers={};var registerRenderer=function registerRenderer(key,value){renderers[key]=value;};function getRenderer(key){return renderers[key];}function getRegisteredRenderer(){// Returns canvas by default for compatibility
if(renderers.canvas){return'canvas';}// Returns any renderer that is registered
for(var key in renderers){if(renderers[key]){return key;}}return'';}function _typeof$4(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$4=function _typeof(obj){return typeof obj;};}else{_typeof$4=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$4(obj);}var AnimationItem=function AnimationItem(){this._cbs=[];this.name='';this.path='';this.isLoaded=false;this.currentFrame=0;this.currentRawFrame=0;this.firstFrame=0;this.totalFrames=0;this.frameRate=0;this.frameMult=0;this.playSpeed=1;this.playDirection=1;this.playCount=0;this.animationData={};this.assets=[];this.isPaused=true;this.autoplay=false;this.loop=true;this.renderer=null;this.animationID=createElementID();this.assetsPath='';this.timeCompleted=0;this.segmentPos=0;this.isSubframeEnabled=getSubframeEnabled();this.segments=[];this._idle=true;this._completedLoop=false;this.projectInterface=ProjectInterface();this.imagePreloader=new ImagePreloader();this.audioController=audioControllerFactory();this.markers=[];this.configAnimation=this.configAnimation.bind(this);this.onSetupError=this.onSetupError.bind(this);this.onSegmentComplete=this.onSegmentComplete.bind(this);this.drawnFrameEvent=new BMEnterFrameEvent('drawnFrame',0,0,0);this.expressionsPlugin=getExpressionsPlugin();};extendPrototype([BaseEvent],AnimationItem);AnimationItem.prototype.setParams=function(params){if(params.wrapper||params.container){this.wrapper=params.wrapper||params.container;}var animType='svg';if(params.animType){animType=params.animType;}else if(params.renderer){animType=params.renderer;}var RendererClass=getRenderer(animType);this.renderer=new RendererClass(this,params.rendererSettings);this.imagePreloader.setCacheType(animType,this.renderer.globalData.defs);this.renderer.setProjectInterface(this.projectInterface);this.animType=animType;if(params.loop===''||params.loop===null||params.loop===undefined||params.loop===true){this.loop=true;}else if(params.loop===false){this.loop=false;}else{this.loop=parseInt(params.loop,10);}this.autoplay='autoplay'in params?params.autoplay:true;this.name=params.name?params.name:'';this.autoloadSegments=Object.prototype.hasOwnProperty.call(params,'autoloadSegments')?params.autoloadSegments:true;this.assetsPath=params.assetsPath;this.initialSegment=params.initialSegment;if(params.audioFactory){this.audioController.setAudioFactory(params.audioFactory);}if(params.animationData){this.setupAnimation(params.animationData);}else if(params.path){if(params.path.lastIndexOf('\\')!==-1){this.path=params.path.substr(0,params.path.lastIndexOf('\\')+1);}else{this.path=params.path.substr(0,params.path.lastIndexOf('/')+1);}this.fileName=params.path.substr(params.path.lastIndexOf('/')+1);this.fileName=this.fileName.substr(0,this.fileName.lastIndexOf('.json'));dataManager.loadAnimation(params.path,this.configAnimation,this.onSetupError);}};AnimationItem.prototype.onSetupError=function(){this.trigger('data_failed');};AnimationItem.prototype.setupAnimation=function(data){dataManager.completeAnimation(data,this.configAnimation);};AnimationItem.prototype.setData=function(wrapper,animationData){if(animationData){if(_typeof$4(animationData)!=='object'){animationData=JSON.parse(animationData);}}var params={wrapper:wrapper,animationData:animationData};var wrapperAttributes=wrapper.attributes;params.path=wrapperAttributes.getNamedItem('data-animation-path')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-animation-path').value:wrapperAttributes.getNamedItem('data-bm-path')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-bm-path').value:wrapperAttributes.getNamedItem('bm-path')?wrapperAttributes.getNamedItem('bm-path').value:'';params.animType=wrapperAttributes.getNamedItem('data-anim-type')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-anim-type').value:wrapperAttributes.getNamedItem('data-bm-type')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-bm-type').value:wrapperAttributes.getNamedItem('bm-type')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('bm-type').value:wrapperAttributes.getNamedItem('data-bm-renderer')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-bm-renderer').value:wrapperAttributes.getNamedItem('bm-renderer')?wrapperAttributes.getNamedItem('bm-renderer').value:getRegisteredRenderer()||'canvas';var loop=wrapperAttributes.getNamedItem('data-anim-loop')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-anim-loop').value:wrapperAttributes.getNamedItem('data-bm-loop')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-bm-loop').value:wrapperAttributes.getNamedItem('bm-loop')?wrapperAttributes.getNamedItem('bm-loop').value:'';if(loop==='false'){params.loop=false;}else if(loop==='true'){params.loop=true;}else if(loop!==''){params.loop=parseInt(loop,10);}var autoplay=wrapperAttributes.getNamedItem('data-anim-autoplay')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-anim-autoplay').value:wrapperAttributes.getNamedItem('data-bm-autoplay')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-bm-autoplay').value:wrapperAttributes.getNamedItem('bm-autoplay')?wrapperAttributes.getNamedItem('bm-autoplay').value:true;params.autoplay=autoplay!=='false';params.name=wrapperAttributes.getNamedItem('data-name')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-name').value:wrapperAttributes.getNamedItem('data-bm-name')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-bm-name').value:wrapperAttributes.getNamedItem('bm-name')?wrapperAttributes.getNamedItem('bm-name').value:'';var prerender=wrapperAttributes.getNamedItem('data-anim-prerender')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-anim-prerender').value:wrapperAttributes.getNamedItem('data-bm-prerender')// eslint-disable-line no-nested-ternary
?wrapperAttributes.getNamedItem('data-bm-prerender').value:wrapperAttributes.getNamedItem('bm-prerender')?wrapperAttributes.getNamedItem('bm-prerender').value:'';if(prerender==='false'){params.prerender=false;}if(!params.path){this.trigger('destroy');}else{this.setParams(params);}};AnimationItem.prototype.includeLayers=function(data){if(data.op>this.animationData.op){this.animationData.op=data.op;this.totalFrames=Math.floor(data.op-this.animationData.ip);}var layers=this.animationData.layers;var i;var len=layers.length;var newLayers=data.layers;var j;var jLen=newLayers.length;for(j=0;j<jLen;j+=1){i=0;while(i<len){if(layers[i].id===newLayers[j].id){layers[i]=newLayers[j];break;}i+=1;}}if(data.chars||data.fonts){this.renderer.globalData.fontManager.addChars(data.chars);this.renderer.globalData.fontManager.addFonts(data.fonts,this.renderer.globalData.defs);}if(data.assets){len=data.assets.length;for(i=0;i<len;i+=1){this.animationData.assets.push(data.assets[i]);}}this.animationData.__complete=false;dataManager.completeAnimation(this.animationData,this.onSegmentComplete);};AnimationItem.prototype.onSegmentComplete=function(data){this.animationData=data;var expressionsPlugin=getExpressionsPlugin();if(expressionsPlugin){expressionsPlugin.initExpressions(this);}this.loadNextSegment();};AnimationItem.prototype.loadNextSegment=function(){var segments=this.animationData.segments;if(!segments||segments.length===0||!this.autoloadSegments){this.trigger('data_ready');this.timeCompleted=this.totalFrames;return;}var segment=segments.shift();this.timeCompleted=segment.time*this.frameRate;var segmentPath=this.path+this.fileName+'_'+this.segmentPos+'.json';this.segmentPos+=1;dataManager.loadData(segmentPath,this.includeLayers.bind(this),function(){this.trigger('data_failed');}.bind(this));};AnimationItem.prototype.loadSegments=function(){var segments=this.animationData.segments;if(!segments){this.timeCompleted=this.totalFrames;}this.loadNextSegment();};AnimationItem.prototype.imagesLoaded=function(){this.trigger('loaded_images');this.checkLoaded();};AnimationItem.prototype.preloadImages=function(){this.imagePreloader.setAssetsPath(this.assetsPath);this.imagePreloader.setPath(this.path);this.imagePreloader.loadAssets(this.animationData.assets,this.imagesLoaded.bind(this));};AnimationItem.prototype.configAnimation=function(animData){if(!this.renderer){return;}try{this.animationData=animData;if(this.initialSegment){this.totalFrames=Math.floor(this.initialSegment[1]-this.initialSegment[0]);this.firstFrame=Math.round(this.initialSegment[0]);}else{this.totalFrames=Math.floor(this.animationData.op-this.animationData.ip);this.firstFrame=Math.round(this.animationData.ip);}this.renderer.configAnimation(animData);if(!animData.assets){animData.assets=[];}this.assets=this.animationData.assets;this.frameRate=this.animationData.fr;this.frameMult=this.animationData.fr/1000;this.renderer.searchExtraCompositions(animData.assets);this.markers=markerParser(animData.markers||[]);this.trigger('config_ready');this.preloadImages();this.loadSegments();this.updaFrameModifier();this.waitForFontsLoaded();if(this.isPaused){this.audioController.pause();}}catch(error){this.triggerConfigError(error);}};AnimationItem.prototype.waitForFontsLoaded=function(){if(!this.renderer){return;}if(this.renderer.globalData.fontManager.isLoaded){this.checkLoaded();}else{setTimeout(this.waitForFontsLoaded.bind(this),20);}};AnimationItem.prototype.checkLoaded=function(){if(!this.isLoaded&&this.renderer.globalData.fontManager.isLoaded&&(this.imagePreloader.loadedImages()||this.renderer.rendererType!=='canvas')&&this.imagePreloader.loadedFootages()){this.isLoaded=true;var expressionsPlugin=getExpressionsPlugin();if(expressionsPlugin){expressionsPlugin.initExpressions(this);}this.renderer.initItems();setTimeout(function(){this.trigger('DOMLoaded');}.bind(this),0);this.gotoFrame();if(this.autoplay){this.play();}}};AnimationItem.prototype.resize=function(width,height){// Adding this validation for backwards compatibility in case an event object was being passed down
var _width=typeof width==='number'?width:undefined;var _height=typeof height==='number'?height:undefined;this.renderer.updateContainerSize(_width,_height);};AnimationItem.prototype.setSubframe=function(flag){this.isSubframeEnabled=!!flag;};AnimationItem.prototype.gotoFrame=function(){this.currentFrame=this.isSubframeEnabled?this.currentRawFrame:~~this.currentRawFrame;// eslint-disable-line no-bitwise
if(this.timeCompleted!==this.totalFrames&&this.currentFrame>this.timeCompleted){this.currentFrame=this.timeCompleted;}this.trigger('enterFrame');this.renderFrame();this.trigger('drawnFrame');};AnimationItem.prototype.renderFrame=function(){if(this.isLoaded===false||!this.renderer){return;}try{if(this.expressionsPlugin){this.expressionsPlugin.resetFrame();}this.renderer.renderFrame(this.currentFrame+this.firstFrame);}catch(error){this.triggerRenderFrameError(error);}};AnimationItem.prototype.play=function(name){if(name&&this.name!==name){return;}if(this.isPaused===true){this.isPaused=false;this.trigger('_play');this.audioController.resume();if(this._idle){this._idle=false;this.trigger('_active');}}};AnimationItem.prototype.pause=function(name){if(name&&this.name!==name){return;}if(this.isPaused===false){this.isPaused=true;this.trigger('_pause');this._idle=true;this.trigger('_idle');this.audioController.pause();}};AnimationItem.prototype.togglePause=function(name){if(name&&this.name!==name){return;}if(this.isPaused===true){this.play();}else{this.pause();}};AnimationItem.prototype.stop=function(name){if(name&&this.name!==name){return;}this.pause();this.playCount=0;this._completedLoop=false;this.setCurrentRawFrameValue(0);};AnimationItem.prototype.getMarkerData=function(markerName){var marker;for(var i=0;i<this.markers.length;i+=1){marker=this.markers[i];if(marker.payload&&marker.payload.name===markerName){return marker;}}return null;};AnimationItem.prototype.goToAndStop=function(value,isFrame,name){if(name&&this.name!==name){return;}var numValue=Number(value);if(isNaN(numValue)){var marker=this.getMarkerData(value);if(marker){this.goToAndStop(marker.time,true);}}else if(isFrame){this.setCurrentRawFrameValue(value);}else{this.setCurrentRawFrameValue(value*this.frameModifier);}this.pause();};AnimationItem.prototype.goToAndPlay=function(value,isFrame,name){if(name&&this.name!==name){return;}var numValue=Number(value);if(isNaN(numValue)){var marker=this.getMarkerData(value);if(marker){if(!marker.duration){this.goToAndStop(marker.time,true);}else{this.playSegments([marker.time,marker.time+marker.duration],true);}}}else{this.goToAndStop(numValue,isFrame,name);}this.play();};AnimationItem.prototype.advanceTime=function(value){if(this.isPaused===true||this.isLoaded===false){return;}var nextValue=this.currentRawFrame+value*this.frameModifier;var _isComplete=false;// Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
// If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
if(nextValue>=this.totalFrames-1&&this.frameModifier>0){if(!this.loop||this.playCount===this.loop){if(!this.checkSegments(nextValue>this.totalFrames?nextValue%this.totalFrames:0)){_isComplete=true;nextValue=this.totalFrames-1;}}else if(nextValue>=this.totalFrames){this.playCount+=1;if(!this.checkSegments(nextValue%this.totalFrames)){this.setCurrentRawFrameValue(nextValue%this.totalFrames);this._completedLoop=true;this.trigger('loopComplete');}}else{this.setCurrentRawFrameValue(nextValue);}}else if(nextValue<0){if(!this.checkSegments(nextValue%this.totalFrames)){if(this.loop&&!(this.playCount--<=0&&this.loop!==true)){// eslint-disable-line no-plusplus
this.setCurrentRawFrameValue(this.totalFrames+nextValue%this.totalFrames);if(!this._completedLoop){this._completedLoop=true;}else{this.trigger('loopComplete');}}else{_isComplete=true;nextValue=0;}}}else{this.setCurrentRawFrameValue(nextValue);}if(_isComplete){this.setCurrentRawFrameValue(nextValue);this.pause();this.trigger('complete');}};AnimationItem.prototype.adjustSegment=function(arr,offset){this.playCount=0;if(arr[1]<arr[0]){if(this.frameModifier>0){if(this.playSpeed<0){this.setSpeed(-this.playSpeed);}else{this.setDirection(-1);}}this.totalFrames=arr[0]-arr[1];this.timeCompleted=this.totalFrames;this.firstFrame=arr[1];this.setCurrentRawFrameValue(this.totalFrames-0.001-offset);}else if(arr[1]>arr[0]){if(this.frameModifier<0){if(this.playSpeed<0){this.setSpeed(-this.playSpeed);}else{this.setDirection(1);}}this.totalFrames=arr[1]-arr[0];this.timeCompleted=this.totalFrames;this.firstFrame=arr[0];this.setCurrentRawFrameValue(0.001+offset);}this.trigger('segmentStart');};AnimationItem.prototype.setSegment=function(init,end){var pendingFrame=-1;if(this.isPaused){if(this.currentRawFrame+this.firstFrame<init){pendingFrame=init;}else if(this.currentRawFrame+this.firstFrame>end){pendingFrame=end-init;}}this.firstFrame=init;this.totalFrames=end-init;this.timeCompleted=this.totalFrames;if(pendingFrame!==-1){this.goToAndStop(pendingFrame,true);}};AnimationItem.prototype.playSegments=function(arr,forceFlag){if(forceFlag){this.segments.length=0;}if(_typeof$4(arr[0])==='object'){var i;var len=arr.length;for(i=0;i<len;i+=1){this.segments.push(arr[i]);}}else{this.segments.push(arr);}if(this.segments.length&&forceFlag){this.adjustSegment(this.segments.shift(),0);}if(this.isPaused){this.play();}};AnimationItem.prototype.resetSegments=function(forceFlag){this.segments.length=0;this.segments.push([this.animationData.ip,this.animationData.op]);if(forceFlag){this.checkSegments(0);}};AnimationItem.prototype.checkSegments=function(offset){if(this.segments.length){this.adjustSegment(this.segments.shift(),offset);return true;}return false;};AnimationItem.prototype.destroy=function(name){if(name&&this.name!==name||!this.renderer){return;}this.renderer.destroy();this.imagePreloader.destroy();this.trigger('destroy');this._cbs=null;this.onEnterFrame=null;this.onLoopComplete=null;this.onComplete=null;this.onSegmentStart=null;this.onDestroy=null;this.renderer=null;this.expressionsPlugin=null;this.imagePreloader=null;this.projectInterface=null;};AnimationItem.prototype.setCurrentRawFrameValue=function(value){this.currentRawFrame=value;this.gotoFrame();};AnimationItem.prototype.setSpeed=function(val){this.playSpeed=val;this.updaFrameModifier();};AnimationItem.prototype.setDirection=function(val){this.playDirection=val<0?-1:1;this.updaFrameModifier();};AnimationItem.prototype.setLoop=function(isLooping){this.loop=isLooping;};AnimationItem.prototype.setVolume=function(val,name){if(name&&this.name!==name){return;}this.audioController.setVolume(val);};AnimationItem.prototype.getVolume=function(){return this.audioController.getVolume();};AnimationItem.prototype.mute=function(name){if(name&&this.name!==name){return;}this.audioController.mute();};AnimationItem.prototype.unmute=function(name){if(name&&this.name!==name){return;}this.audioController.unmute();};AnimationItem.prototype.updaFrameModifier=function(){this.frameModifier=this.frameMult*this.playSpeed*this.playDirection;this.audioController.setRate(this.playSpeed*this.playDirection);};AnimationItem.prototype.getPath=function(){return this.path;};AnimationItem.prototype.getAssetsPath=function(assetData){var path='';if(assetData.e){path=assetData.p;}else if(this.assetsPath){var imagePath=assetData.p;if(imagePath.indexOf('images/')!==-1){imagePath=imagePath.split('/')[1];}path=this.assetsPath+imagePath;}else{path=this.path;path+=assetData.u?assetData.u:'';path+=assetData.p;}return path;};AnimationItem.prototype.getAssetData=function(id){var i=0;var len=this.assets.length;while(i<len){if(id===this.assets[i].id){return this.assets[i];}i+=1;}return null;};AnimationItem.prototype.hide=function(){this.renderer.hide();};AnimationItem.prototype.show=function(){this.renderer.show();};AnimationItem.prototype.getDuration=function(isFrame){return isFrame?this.totalFrames:this.totalFrames/this.frameRate;};AnimationItem.prototype.updateDocumentData=function(path,documentData,index){try{var element=this.renderer.getElementByPath(path);element.updateDocumentData(documentData,index);}catch(error){// TODO: decide how to handle catch case
}};AnimationItem.prototype.trigger=function(name){if(this._cbs&&this._cbs[name]){switch(name){case'enterFrame':this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameModifier));break;case'drawnFrame':this.drawnFrameEvent.currentTime=this.currentFrame;this.drawnFrameEvent.totalTime=this.totalFrames;this.drawnFrameEvent.direction=this.frameModifier;this.triggerEvent(name,this.drawnFrameEvent);break;case'loopComplete':this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));break;case'complete':this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));break;case'segmentStart':this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));break;case'destroy':this.triggerEvent(name,new BMDestroyEvent(name,this));break;default:this.triggerEvent(name);}}if(name==='enterFrame'&&this.onEnterFrame){this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));}if(name==='loopComplete'&&this.onLoopComplete){this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));}if(name==='complete'&&this.onComplete){this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));}if(name==='segmentStart'&&this.onSegmentStart){this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));}if(name==='destroy'&&this.onDestroy){this.onDestroy.call(this,new BMDestroyEvent(name,this));}};AnimationItem.prototype.triggerRenderFrameError=function(nativeError){var error=new BMRenderFrameErrorEvent(nativeError,this.currentFrame);this.triggerEvent('error',error);if(this.onError){this.onError.call(this,error);}};AnimationItem.prototype.triggerConfigError=function(nativeError){var error=new BMConfigErrorEvent(nativeError,this.currentFrame);this.triggerEvent('error',error);if(this.onError){this.onError.call(this,error);}};var animationManager=function(){var moduleOb={};var registeredAnimations=[];var initTime=0;var len=0;var playingAnimationsNum=0;var _stopped=true;var _isFrozen=false;function removeElement(ev){var i=0;var animItem=ev.target;while(i<len){if(registeredAnimations[i].animation===animItem){registeredAnimations.splice(i,1);i-=1;len-=1;if(!animItem.isPaused){subtractPlayingCount();}}i+=1;}}function registerAnimation(element,animationData){if(!element){return null;}var i=0;while(i<len){if(registeredAnimations[i].elem===element&&registeredAnimations[i].elem!==null){return registeredAnimations[i].animation;}i+=1;}var animItem=new AnimationItem();setupAnimation(animItem,element);animItem.setData(element,animationData);return animItem;}function getRegisteredAnimations(){var i;var lenAnims=registeredAnimations.length;var animations=[];for(i=0;i<lenAnims;i+=1){animations.push(registeredAnimations[i].animation);}return animations;}function addPlayingCount(){playingAnimationsNum+=1;activate();}function subtractPlayingCount(){playingAnimationsNum-=1;}function setupAnimation(animItem,element){animItem.addEventListener('destroy',removeElement);animItem.addEventListener('_active',addPlayingCount);animItem.addEventListener('_idle',subtractPlayingCount);registeredAnimations.push({elem:element,animation:animItem});len+=1;}function loadAnimation(params){var animItem=new AnimationItem();setupAnimation(animItem,null);animItem.setParams(params);return animItem;}function setSpeed(val,animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.setSpeed(val,animation);}}function setDirection(val,animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.setDirection(val,animation);}}function play(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.play(animation);}}function resume(nowTime){var elapsedTime=nowTime-initTime;var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.advanceTime(elapsedTime);}initTime=nowTime;if(playingAnimationsNum&&!_isFrozen){window.requestAnimationFrame(resume);}else{_stopped=true;}}function first(nowTime){initTime=nowTime;window.requestAnimationFrame(resume);}function pause(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.pause(animation);}}function goToAndStop(value,isFrame,animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);}}function stop(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.stop(animation);}}function togglePause(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.togglePause(animation);}}function destroy(animation){var i;for(i=len-1;i>=0;i-=1){registeredAnimations[i].animation.destroy(animation);}}function searchAnimations(animationData,standalone,renderer){var animElements=[].concat([].slice.call(document.getElementsByClassName('lottie')),[].slice.call(document.getElementsByClassName('bodymovin')));var i;var lenAnims=animElements.length;for(i=0;i<lenAnims;i+=1){if(renderer){animElements[i].setAttribute('data-bm-type',renderer);}registerAnimation(animElements[i],animationData);}if(standalone&&lenAnims===0){if(!renderer){renderer='svg';}var body=document.getElementsByTagName('body')[0];body.innerText='';var div=createTag('div');div.style.width='100%';div.style.height='100%';div.setAttribute('data-bm-type',renderer);body.appendChild(div);registerAnimation(div,animationData);}}function resize(){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.resize();}}function activate(){if(!_isFrozen&&playingAnimationsNum){if(_stopped){window.requestAnimationFrame(first);_stopped=false;}}}function freeze(){_isFrozen=true;}function unfreeze(){_isFrozen=false;activate();}function setVolume(val,animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.setVolume(val,animation);}}function mute(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.mute(animation);}}function unmute(animation){var i;for(i=0;i<len;i+=1){registeredAnimations[i].animation.unmute(animation);}}moduleOb.registerAnimation=registerAnimation;moduleOb.loadAnimation=loadAnimation;moduleOb.setSpeed=setSpeed;moduleOb.setDirection=setDirection;moduleOb.play=play;moduleOb.pause=pause;moduleOb.stop=stop;moduleOb.togglePause=togglePause;moduleOb.searchAnimations=searchAnimations;moduleOb.resize=resize;// moduleOb.start = start;
moduleOb.goToAndStop=goToAndStop;moduleOb.destroy=destroy;moduleOb.freeze=freeze;moduleOb.unfreeze=unfreeze;moduleOb.setVolume=setVolume;moduleOb.mute=mute;moduleOb.unmute=unmute;moduleOb.getRegisteredAnimations=getRegisteredAnimations;return moduleOb;}();/* eslint-disable */var BezierFactory=function(){/**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */var ob={};ob.getBezierEasing=getBezierEasing;var beziers={};function getBezierEasing(a,b,c,d,nm){var str=nm||('bez_'+a+'_'+b+'_'+c+'_'+d).replace(/\./g,'p');if(beziers[str]){return beziers[str];}var bezEasing=new BezierEasing([a,b,c,d]);beziers[str]=bezEasing;return bezEasing;}// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS=4;var NEWTON_MIN_SLOPE=0.001;var SUBDIVISION_PRECISION=0.0000001;var SUBDIVISION_MAX_ITERATIONS=10;var kSplineTableSize=11;var kSampleStepSize=1.0/(kSplineTableSize-1.0);var float32ArraySupported=typeof Float32Array==='function';function A(aA1,aA2){return 1.0-3.0*aA2+3.0*aA1;}function B(aA1,aA2){return 3.0*aA2-6.0*aA1;}function C(aA1){return 3.0*aA1;}// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier(aT,aA1,aA2){return((A(aA1,aA2)*aT+B(aA1,aA2))*aT+C(aA1))*aT;}// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope(aT,aA1,aA2){return 3.0*A(aA1,aA2)*aT*aT+2.0*B(aA1,aA2)*aT+C(aA1);}function binarySubdivide(aX,aA,aB,mX1,mX2){var currentX,currentT,i=0;do{currentT=aA+(aB-aA)/2.0;currentX=calcBezier(currentT,mX1,mX2)-aX;if(currentX>0.0){aB=currentT;}else{aA=currentT;}}while(Math.abs(currentX)>SUBDIVISION_PRECISION&&++i<SUBDIVISION_MAX_ITERATIONS);return currentT;}function newtonRaphsonIterate(aX,aGuessT,mX1,mX2){for(var i=0;i<NEWTON_ITERATIONS;++i){var currentSlope=getSlope(aGuessT,mX1,mX2);if(currentSlope===0.0)return aGuessT;var currentX=calcBezier(aGuessT,mX1,mX2)-aX;aGuessT-=currentX/currentSlope;}return aGuessT;}/**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */function BezierEasing(points){this._p=points;this._mSampleValues=float32ArraySupported?new Float32Array(kSplineTableSize):new Array(kSplineTableSize);this._precomputed=false;this.get=this.get.bind(this);}BezierEasing.prototype={get:function get(x){var mX1=this._p[0],mY1=this._p[1],mX2=this._p[2],mY2=this._p[3];if(!this._precomputed)this._precompute();if(mX1===mY1&&mX2===mY2)return x;// linear
// Because JavaScript number are imprecise, we should guarantee the extremes are right.
if(x===0)return 0;if(x===1)return 1;return calcBezier(this._getTForX(x),mY1,mY2);},// Private part
_precompute:function _precompute(){var mX1=this._p[0],mY1=this._p[1],mX2=this._p[2],mY2=this._p[3];this._precomputed=true;if(mX1!==mY1||mX2!==mY2){this._calcSampleValues();}},_calcSampleValues:function _calcSampleValues(){var mX1=this._p[0],mX2=this._p[2];for(var i=0;i<kSplineTableSize;++i){this._mSampleValues[i]=calcBezier(i*kSampleStepSize,mX1,mX2);}},/**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */_getTForX:function _getTForX(aX){var mX1=this._p[0],mX2=this._p[2],mSampleValues=this._mSampleValues;var intervalStart=0.0;var currentSample=1;var lastSample=kSplineTableSize-1;for(;currentSample!==lastSample&&mSampleValues[currentSample]<=aX;++currentSample){intervalStart+=kSampleStepSize;}--currentSample;// Interpolate to provide an initial guess for t
var dist=(aX-mSampleValues[currentSample])/(mSampleValues[currentSample+1]-mSampleValues[currentSample]);var guessForT=intervalStart+dist*kSampleStepSize;var initialSlope=getSlope(guessForT,mX1,mX2);if(initialSlope>=NEWTON_MIN_SLOPE){return newtonRaphsonIterate(aX,guessForT,mX1,mX2);}if(initialSlope===0.0){return guessForT;}return binarySubdivide(aX,intervalStart,intervalStart+kSampleStepSize,mX1,mX2);}};return ob;}();var pooling=function(){function _double(arr){return arr.concat(createSizedArray(arr.length));}return{"double":_double};}();var poolFactory=function(){return function(initialLength,_create,_release){var _length=0;var _maxLength=initialLength;var pool=createSizedArray(_maxLength);var ob={newElement:newElement,release:release};function newElement(){var element;if(_length){_length-=1;element=pool[_length];}else{element=_create();}return element;}function release(element){if(_length===_maxLength){pool=pooling["double"](pool);_maxLength*=2;}if(_release){_release(element);}pool[_length]=element;_length+=1;}return ob;};}();var bezierLengthPool=function(){function create(){return{addedLength:0,percents:createTypedArray('float32',getDefaultCurveSegments()),lengths:createTypedArray('float32',getDefaultCurveSegments())};}return poolFactory(8,create);}();var segmentsLengthPool=function(){function create(){return{lengths:[],totalLength:0};}function release(element){var i;var len=element.lengths.length;for(i=0;i<len;i+=1){bezierLengthPool.release(element.lengths[i]);}element.lengths.length=0;}return poolFactory(8,create,release);}();function bezFunction(){var math=Math;function pointOnLine2D(x1,y1,x2,y2,x3,y3){var det1=x1*y2+y1*x3+x2*y3-x3*y2-y3*x1-x2*y1;return det1>-0.001&&det1<0.001;}function pointOnLine3D(x1,y1,z1,x2,y2,z2,x3,y3,z3){if(z1===0&&z2===0&&z3===0){return pointOnLine2D(x1,y1,x2,y2,x3,y3);}var dist1=math.sqrt(math.pow(x2-x1,2)+math.pow(y2-y1,2)+math.pow(z2-z1,2));var dist2=math.sqrt(math.pow(x3-x1,2)+math.pow(y3-y1,2)+math.pow(z3-z1,2));var dist3=math.sqrt(math.pow(x3-x2,2)+math.pow(y3-y2,2)+math.pow(z3-z2,2));var diffDist;if(dist1>dist2){if(dist1>dist3){diffDist=dist1-dist2-dist3;}else{diffDist=dist3-dist2-dist1;}}else if(dist3>dist2){diffDist=dist3-dist2-dist1;}else{diffDist=dist2-dist1-dist3;}return diffDist>-0.0001&&diffDist<0.0001;}var getBezierLength=function(){return function(pt1,pt2,pt3,pt4){var curveSegments=getDefaultCurveSegments();var k;var i;var len;var ptCoord;var perc;var addedLength=0;var ptDistance;var point=[];var lastPoint=[];var lengthData=bezierLengthPool.newElement();len=pt3.length;for(k=0;k<curveSegments;k+=1){perc=k/(curveSegments-1);ptDistance=0;for(i=0;i<len;i+=1){ptCoord=bmPow(1-perc,3)*pt1[i]+3*bmPow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bmPow(perc,2)*pt4[i]+bmPow(perc,3)*pt2[i];point[i]=ptCoord;if(lastPoint[i]!==null){ptDistance+=bmPow(point[i]-lastPoint[i],2);}lastPoint[i]=point[i];}if(ptDistance){ptDistance=bmSqrt(ptDistance);addedLength+=ptDistance;}lengthData.percents[k]=perc;lengthData.lengths[k]=addedLength;}lengthData.addedLength=addedLength;return lengthData;};}();function getSegmentsLength(shapeData){var segmentsLength=segmentsLengthPool.newElement();var closed=shapeData.c;var pathV=shapeData.v;var pathO=shapeData.o;var pathI=shapeData.i;var i;var len=shapeData._length;var lengths=segmentsLength.lengths;var totalLength=0;for(i=0;i<len-1;i+=1){lengths[i]=getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);totalLength+=lengths[i].addedLength;}if(closed&&len){lengths[i]=getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);totalLength+=lengths[i].addedLength;}segmentsLength.totalLength=totalLength;return segmentsLength;}function BezierData(length){this.segmentLength=0;this.points=new Array(length);}function PointData(partial,point){this.partialLength=partial;this.point=point;}var buildBezierData=function(){var storedData={};return function(pt1,pt2,pt3,pt4){var bezierName=(pt1[0]+'_'+pt1[1]+'_'+pt2[0]+'_'+pt2[1]+'_'+pt3[0]+'_'+pt3[1]+'_'+pt4[0]+'_'+pt4[1]).replace(/\./g,'p');if(!storedData[bezierName]){var curveSegments=getDefaultCurveSegments();var k;var i;var len;var ptCoord;var perc;var addedLength=0;var ptDistance;var point;var lastPoint=null;if(pt1.length===2&&(pt1[0]!==pt2[0]||pt1[1]!==pt2[1])&&pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1])&&pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){curveSegments=2;}var bezierData=new BezierData(curveSegments);len=pt3.length;for(k=0;k<curveSegments;k+=1){point=createSizedArray(len);perc=k/(curveSegments-1);ptDistance=0;for(i=0;i<len;i+=1){ptCoord=bmPow(1-perc,3)*pt1[i]+3*bmPow(1-perc,2)*perc*(pt1[i]+pt3[i])+3*(1-perc)*bmPow(perc,2)*(pt2[i]+pt4[i])+bmPow(perc,3)*pt2[i];point[i]=ptCoord;if(lastPoint!==null){ptDistance+=bmPow(point[i]-lastPoint[i],2);}}ptDistance=bmSqrt(ptDistance);addedLength+=ptDistance;bezierData.points[k]=new PointData(ptDistance,point);lastPoint=point;}bezierData.segmentLength=addedLength;storedData[bezierName]=bezierData;}return storedData[bezierName];};}();function getDistancePerc(perc,bezierData){var percents=bezierData.percents;var lengths=bezierData.lengths;var len=percents.length;var initPos=bmFloor((len-1)*perc);var lengthPos=perc*bezierData.addedLength;var lPerc=0;if(initPos===len-1||initPos===0||lengthPos===lengths[initPos]){return percents[initPos];}var dir=lengths[initPos]>lengthPos?-1:1;var flag=true;while(flag){if(lengths[initPos]<=lengthPos&&lengths[initPos+1]>lengthPos){lPerc=(lengthPos-lengths[initPos])/(lengths[initPos+1]-lengths[initPos]);flag=false;}else{initPos+=dir;}if(initPos<0||initPos>=len-1){// FIX for TypedArrays that don't store floating point values with enough accuracy
if(initPos===len-1){return percents[initPos];}flag=false;}}return percents[initPos]+(percents[initPos+1]-percents[initPos])*lPerc;}function getPointInSegment(pt1,pt2,pt3,pt4,percent,bezierData){var t1=getDistancePerc(percent,bezierData);var u1=1-t1;var ptX=math.round((u1*u1*u1*pt1[0]+(t1*u1*u1+u1*t1*u1+u1*u1*t1)*pt3[0]+(t1*t1*u1+u1*t1*t1+t1*u1*t1)*pt4[0]+t1*t1*t1*pt2[0])*1000)/1000;var ptY=math.round((u1*u1*u1*pt1[1]+(t1*u1*u1+u1*t1*u1+u1*u1*t1)*pt3[1]+(t1*t1*u1+u1*t1*t1+t1*u1*t1)*pt4[1]+t1*t1*t1*pt2[1])*1000)/1000;return[ptX,ptY];}var bezierSegmentPoints=createTypedArray('float32',8);function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc,bezierData){if(startPerc<0){startPerc=0;}else if(startPerc>1){startPerc=1;}var t0=getDistancePerc(startPerc,bezierData);endPerc=endPerc>1?1:endPerc;var t1=getDistancePerc(endPerc,bezierData);var i;var len=pt1.length;var u0=1-t0;var u1=1-t1;var u0u0u0=u0*u0*u0;var t0u0u0_3=t0*u0*u0*3;// eslint-disable-line camelcase
var t0t0u0_3=t0*t0*u0*3;// eslint-disable-line camelcase
var t0t0t0=t0*t0*t0;//
var u0u0u1=u0*u0*u1;var t0u0u1_3=t0*u0*u1+u0*t0*u1+u0*u0*t1;// eslint-disable-line camelcase
var t0t0u1_3=t0*t0*u1+u0*t0*t1+t0*u0*t1;// eslint-disable-line camelcase
var t0t0t1=t0*t0*t1;//
var u0u1u1=u0*u1*u1;var t0u1u1_3=t0*u1*u1+u0*t1*u1+u0*u1*t1;// eslint-disable-line camelcase
var t0t1u1_3=t0*t1*u1+u0*t1*t1+t0*u1*t1;// eslint-disable-line camelcase
var t0t1t1=t0*t1*t1;//
var u1u1u1=u1*u1*u1;var t1u1u1_3=t1*u1*u1+u1*t1*u1+u1*u1*t1;// eslint-disable-line camelcase
var t1t1u1_3=t1*t1*u1+u1*t1*t1+t1*u1*t1;// eslint-disable-line camelcase
var t1t1t1=t1*t1*t1;for(i=0;i<len;i+=1){bezierSegmentPoints[i*4]=math.round((u0u0u0*pt1[i]+t0u0u0_3*pt3[i]+t0t0u0_3*pt4[i]+t0t0t0*pt2[i])*1000)/1000;// eslint-disable-line camelcase
bezierSegmentPoints[i*4+1]=math.round((u0u0u1*pt1[i]+t0u0u1_3*pt3[i]+t0t0u1_3*pt4[i]+t0t0t1*pt2[i])*1000)/1000;// eslint-disable-line camelcase
bezierSegmentPoints[i*4+2]=math.round((u0u1u1*pt1[i]+t0u1u1_3*pt3[i]+t0t1u1_3*pt4[i]+t0t1t1*pt2[i])*1000)/1000;// eslint-disable-line camelcase
bezierSegmentPoints[i*4+3]=math.round((u1u1u1*pt1[i]+t1u1u1_3*pt3[i]+t1t1u1_3*pt4[i]+t1t1t1*pt2[i])*1000)/1000;// eslint-disable-line camelcase
}return bezierSegmentPoints;}return{getSegmentsLength:getSegmentsLength,getNewSegment:getNewSegment,getPointInSegment:getPointInSegment,buildBezierData:buildBezierData,pointOnLine2D:pointOnLine2D,pointOnLine3D:pointOnLine3D};}var bez=bezFunction();var initFrame=initialDefaultFrame;var mathAbs=Math.abs;function interpolateValue(frameNum,caching){var offsetTime=this.offsetTime;var newValue;if(this.propType==='multidimensional'){newValue=createTypedArray('float32',this.pv.length);}var iterationIndex=caching.lastIndex;var i=iterationIndex;var len=this.keyframes.length-1;var flag=true;var keyData;var nextKeyData;var keyframeMetadata;while(flag){keyData=this.keyframes[i];nextKeyData=this.keyframes[i+1];if(i===len-1&&frameNum>=nextKeyData.t-offsetTime){if(keyData.h){keyData=nextKeyData;}iterationIndex=0;break;}if(nextKeyData.t-offsetTime>frameNum){iterationIndex=i;break;}if(i<len-1){i+=1;}else{iterationIndex=0;flag=false;}}keyframeMetadata=this.keyframesMetadata[i]||{};var k;var kLen;var perc;var jLen;var j;var fnc;var nextKeyTime=nextKeyData.t-offsetTime;var keyTime=keyData.t-offsetTime;var endValue;if(keyData.to){if(!keyframeMetadata.bezierData){keyframeMetadata.bezierData=bez.buildBezierData(keyData.s,nextKeyData.s||keyData.e,keyData.to,keyData.ti);}var bezierData=keyframeMetadata.bezierData;if(frameNum>=nextKeyTime||frameNum<keyTime){var ind=frameNum>=nextKeyTime?bezierData.points.length-1:0;kLen=bezierData.points[ind].point.length;for(k=0;k<kLen;k+=1){newValue[k]=bezierData.points[ind].point[k];}// caching._lastKeyframeIndex = -1;
}else{if(keyframeMetadata.__fnct){fnc=keyframeMetadata.__fnct;}else{fnc=BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n).get;keyframeMetadata.__fnct=fnc;}perc=fnc((frameNum-keyTime)/(nextKeyTime-keyTime));var distanceInLine=bezierData.segmentLength*perc;var segmentPerc;var addedLength=caching.lastFrame<frameNum&&caching._lastKeyframeIndex===i?caching._lastAddedLength:0;j=caching.lastFrame<frameNum&&caching._lastKeyframeIndex===i?caching._lastPoint:0;flag=true;jLen=bezierData.points.length;while(flag){addedLength+=bezierData.points[j].partialLength;if(distanceInLine===0||perc===0||j===bezierData.points.length-1){kLen=bezierData.points[j].point.length;for(k=0;k<kLen;k+=1){newValue[k]=bezierData.points[j].point[k];}break;}else if(distanceInLine>=addedLength&&distanceInLine<addedLength+bezierData.points[j+1].partialLength){segmentPerc=(distanceInLine-addedLength)/bezierData.points[j+1].partialLength;kLen=bezierData.points[j].point.length;for(k=0;k<kLen;k+=1){newValue[k]=bezierData.points[j].point[k]+(bezierData.points[j+1].point[k]-bezierData.points[j].point[k])*segmentPerc;}break;}if(j<jLen-1){j+=1;}else{flag=false;}}caching._lastPoint=j;caching._lastAddedLength=addedLength-bezierData.points[j].partialLength;caching._lastKeyframeIndex=i;}}else{var outX;var outY;var inX;var inY;var keyValue;len=keyData.s.length;endValue=nextKeyData.s||keyData.e;if(this.sh&&keyData.h!==1){if(frameNum>=nextKeyTime){newValue[0]=endValue[0];newValue[1]=endValue[1];newValue[2]=endValue[2];}else if(frameNum<=keyTime){newValue[0]=keyData.s[0];newValue[1]=keyData.s[1];newValue[2]=keyData.s[2];}else{var quatStart=createQuaternion(keyData.s);var quatEnd=createQuaternion(endValue);var time=(frameNum-keyTime)/(nextKeyTime-keyTime);quaternionToEuler(newValue,slerp(quatStart,quatEnd,time));}}else{for(i=0;i<len;i+=1){if(keyData.h!==1){if(frameNum>=nextKeyTime){perc=1;}else if(frameNum<keyTime){perc=0;}else{if(keyData.o.x.constructor===Array){if(!keyframeMetadata.__fnct){keyframeMetadata.__fnct=[];}if(!keyframeMetadata.__fnct[i]){outX=keyData.o.x[i]===undefined?keyData.o.x[0]:keyData.o.x[i];outY=keyData.o.y[i]===undefined?keyData.o.y[0]:keyData.o.y[i];inX=keyData.i.x[i]===undefined?keyData.i.x[0]:keyData.i.x[i];inY=keyData.i.y[i]===undefined?keyData.i.y[0]:keyData.i.y[i];fnc=BezierFactory.getBezierEasing(outX,outY,inX,inY).get;keyframeMetadata.__fnct[i]=fnc;}else{fnc=keyframeMetadata.__fnct[i];}}else if(!keyframeMetadata.__fnct){outX=keyData.o.x;outY=keyData.o.y;inX=keyData.i.x;inY=keyData.i.y;fnc=BezierFactory.getBezierEasing(outX,outY,inX,inY).get;keyData.keyframeMetadata=fnc;}else{fnc=keyframeMetadata.__fnct;}perc=fnc((frameNum-keyTime)/(nextKeyTime-keyTime));}}endValue=nextKeyData.s||keyData.e;keyValue=keyData.h===1?keyData.s[i]:keyData.s[i]+(endValue[i]-keyData.s[i])*perc;if(this.propType==='multidimensional'){newValue[i]=keyValue;}else{newValue=keyValue;}}}}caching.lastIndex=iterationIndex;return newValue;}// based on @Toji's https://github.com/toji/gl-matrix/
function slerp(a,b,t){var out=[];var ax=a[0];var ay=a[1];var az=a[2];var aw=a[3];var bx=b[0];var by=b[1];var bz=b[2];var bw=b[3];var omega;var cosom;var sinom;var scale0;var scale1;cosom=ax*bx+ay*by+az*bz+aw*bw;if(cosom<0.0){cosom=-cosom;bx=-bx;by=-by;bz=-bz;bw=-bw;}if(1.0-cosom>0.000001){omega=Math.acos(cosom);sinom=Math.sin(omega);scale0=Math.sin((1.0-t)*omega)/sinom;scale1=Math.sin(t*omega)/sinom;}else{scale0=1.0-t;scale1=t;}out[0]=scale0*ax+scale1*bx;out[1]=scale0*ay+scale1*by;out[2]=scale0*az+scale1*bz;out[3]=scale0*aw+scale1*bw;return out;}function quaternionToEuler(out,quat){var qx=quat[0];var qy=quat[1];var qz=quat[2];var qw=quat[3];var heading=Math.atan2(2*qy*qw-2*qx*qz,1-2*qy*qy-2*qz*qz);var attitude=Math.asin(2*qx*qy+2*qz*qw);var bank=Math.atan2(2*qx*qw-2*qy*qz,1-2*qx*qx-2*qz*qz);out[0]=heading/degToRads;out[1]=attitude/degToRads;out[2]=bank/degToRads;}function createQuaternion(values){var heading=values[0]*degToRads;var attitude=values[1]*degToRads;var bank=values[2]*degToRads;var c1=Math.cos(heading/2);var c2=Math.cos(attitude/2);var c3=Math.cos(bank/2);var s1=Math.sin(heading/2);var s2=Math.sin(attitude/2);var s3=Math.sin(bank/2);var w=c1*c2*c3-s1*s2*s3;var x=s1*s2*c3+c1*c2*s3;var y=s1*c2*c3+c1*s2*s3;var z=c1*s2*c3-s1*c2*s3;return[x,y,z,w];}function getValueAtCurrentTime(){var frameNum=this.comp.renderedFrame-this.offsetTime;var initTime=this.keyframes[0].t-this.offsetTime;var endTime=this.keyframes[this.keyframes.length-1].t-this.offsetTime;if(!(frameNum===this._caching.lastFrame||this._caching.lastFrame!==initFrame&&(this._caching.lastFrame>=endTime&&frameNum>=endTime||this._caching.lastFrame<initTime&&frameNum<initTime))){if(this._caching.lastFrame>=frameNum){this._caching._lastKeyframeIndex=-1;this._caching.lastIndex=0;}var renderResult=this.interpolateValue(frameNum,this._caching);this.pv=renderResult;}this._caching.lastFrame=frameNum;return this.pv;}function setVValue(val){var multipliedValue;if(this.propType==='unidimensional'){multipliedValue=val*this.mult;if(mathAbs(this.v-multipliedValue)>0.00001){this.v=multipliedValue;this._mdf=true;}}else{var i=0;var len=this.v.length;while(i<len){multipliedValue=val[i]*this.mult;if(mathAbs(this.v[i]-multipliedValue)>0.00001){this.v[i]=multipliedValue;this._mdf=true;}i+=1;}}}function processEffectsSequence(){if(this.elem.globalData.frameId===this.frameId||!this.effectsSequence.length){return;}if(this.lock){this.setVValue(this.pv);return;}this.lock=true;this._mdf=this._isFirstFrame;var i;var len=this.effectsSequence.length;var finalValue=this.kf?this.pv:this.data.k;for(i=0;i<len;i+=1){finalValue=this.effectsSequence[i](finalValue);}this.setVValue(finalValue);this._isFirstFrame=false;this.lock=false;this.frameId=this.elem.globalData.frameId;}function addEffect(effectFunction){this.effectsSequence.push(effectFunction);this.container.addDynamicProperty(this);}function ValueProperty(elem,data,mult,container){this.propType='unidimensional';this.mult=mult||1;this.data=data;this.v=mult?data.k*mult:data.k;this.pv=data.k;this._mdf=false;this.elem=elem;this.container=container;this.comp=elem.comp;this.k=false;this.kf=false;this.vel=0;this.effectsSequence=[];this._isFirstFrame=true;this.getValue=processEffectsSequence;this.setVValue=setVValue;this.addEffect=addEffect;}function MultiDimensionalProperty(elem,data,mult,container){this.propType='multidimensional';this.mult=mult||1;this.data=data;this._mdf=false;this.elem=elem;this.container=container;this.comp=elem.comp;this.k=false;this.kf=false;this.frameId=-1;var i;var len=data.k.length;this.v=createTypedArray('float32',len);this.pv=createTypedArray('float32',len);this.vel=createTypedArray('float32',len);for(i=0;i<len;i+=1){this.v[i]=data.k[i]*this.mult;this.pv[i]=data.k[i];}this._isFirstFrame=true;this.effectsSequence=[];this.getValue=processEffectsSequence;this.setVValue=setVValue;this.addEffect=addEffect;}function KeyframedValueProperty(elem,data,mult,container){this.propType='unidimensional';this.keyframes=data.k;this.keyframesMetadata=[];this.offsetTime=elem.data.st;this.frameId=-1;this._caching={lastFrame:initFrame,lastIndex:0,value:0,_lastKeyframeIndex:-1};this.k=true;this.kf=true;this.data=data;this.mult=mult||1;this.elem=elem;this.container=container;this.comp=elem.comp;this.v=initFrame;this.pv=initFrame;this._isFirstFrame=true;this.getValue=processEffectsSequence;this.setVValue=setVValue;this.interpolateValue=interpolateValue;this.effectsSequence=[getValueAtCurrentTime.bind(this)];this.addEffect=addEffect;}function KeyframedMultidimensionalProperty(elem,data,mult,container){this.propType='multidimensional';var i;var len=data.k.length;var s;var e;var to;var ti;for(i=0;i<len-1;i+=1){if(data.k[i].to&&data.k[i].s&&data.k[i+1]&&data.k[i+1].s){s=data.k[i].s;e=data.k[i+1].s;to=data.k[i].to;ti=data.k[i].ti;if(s.length===2&&!(s[0]===e[0]&&s[1]===e[1])&&bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0]+to[0],s[1]+to[1])&&bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0]+ti[0],e[1]+ti[1])||s.length===3&&!(s[0]===e[0]&&s[1]===e[1]&&s[2]===e[2])&&bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0]+to[0],s[1]+to[1],s[2]+to[2])&&bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0]+ti[0],e[1]+ti[1],e[2]+ti[2])){data.k[i].to=null;data.k[i].ti=null;}if(s[0]===e[0]&&s[1]===e[1]&&to[0]===0&&to[1]===0&&ti[0]===0&&ti[1]===0){if(s.length===2||s[2]===e[2]&&to[2]===0&&ti[2]===0){data.k[i].to=null;data.k[i].ti=null;}}}}this.effectsSequence=[getValueAtCurrentTime.bind(this)];this.data=data;this.keyframes=data.k;this.keyframesMetadata=[];this.offsetTime=elem.data.st;this.k=true;this.kf=true;this._isFirstFrame=true;this.mult=mult||1;this.elem=elem;this.container=container;this.comp=elem.comp;this.getValue=processEffectsSequence;this.setVValue=setVValue;this.interpolateValue=interpolateValue;this.frameId=-1;var arrLen=data.k[0].s.length;this.v=createTypedArray('float32',arrLen);this.pv=createTypedArray('float32',arrLen);for(i=0;i<arrLen;i+=1){this.v[i]=initFrame;this.pv[i]=initFrame;}this._caching={lastFrame:initFrame,lastIndex:0,value:createTypedArray('float32',arrLen)};this.addEffect=addEffect;}var PropertyFactory=function(){function getProp(elem,data,type,mult,container){if(data.sid){data=elem.globalData.slotManager.getProp(data);}var p;if(!data.k.length){p=new ValueProperty(elem,data,mult,container);}else if(typeof data.k[0]==='number'){p=new MultiDimensionalProperty(elem,data,mult,container);}else{switch(type){case 0:p=new KeyframedValueProperty(elem,data,mult,container);break;case 1:p=new KeyframedMultidimensionalProperty(elem,data,mult,container);break;default:break;}}if(p.effectsSequence.length){container.addDynamicProperty(p);}return p;}var ob={getProp:getProp};return ob;}();function DynamicPropertyContainer(){}DynamicPropertyContainer.prototype={addDynamicProperty:function addDynamicProperty(prop){if(this.dynamicProperties.indexOf(prop)===-1){this.dynamicProperties.push(prop);this.container.addDynamicProperty(this);this._isAnimated=true;}},iterateDynamicProperties:function iterateDynamicProperties(){this._mdf=false;var i;var len=this.dynamicProperties.length;for(i=0;i<len;i+=1){this.dynamicProperties[i].getValue();if(this.dynamicProperties[i]._mdf){this._mdf=true;}}},initDynamicPropertyContainer:function initDynamicPropertyContainer(container){this.container=container;this.dynamicProperties=[];this._mdf=false;this._isAnimated=false;}};var pointPool=function(){function create(){return createTypedArray('float32',2);}return poolFactory(8,create);}();function ShapePath(){this.c=false;this._length=0;this._maxLength=8;this.v=createSizedArray(this._maxLength);this.o=createSizedArray(this._maxLength);this.i=createSizedArray(this._maxLength);}ShapePath.prototype.setPathData=function(closed,len){this.c=closed;this.setLength(len);var i=0;while(i<len){this.v[i]=pointPool.newElement();this.o[i]=pointPool.newElement();this.i[i]=pointPool.newElement();i+=1;}};ShapePath.prototype.setLength=function(len){while(this._maxLength<len){this.doubleArrayLength();}this._length=len;};ShapePath.prototype.doubleArrayLength=function(){this.v=this.v.concat(createSizedArray(this._maxLength));this.i=this.i.concat(createSizedArray(this._maxLength));this.o=this.o.concat(createSizedArray(this._maxLength));this._maxLength*=2;};ShapePath.prototype.setXYAt=function(x,y,type,pos,replace){var arr;this._length=Math.max(this._length,pos+1);if(this._length>=this._maxLength){this.doubleArrayLength();}switch(type){case'v':arr=this.v;break;case'i':arr=this.i;break;case'o':arr=this.o;break;default:arr=[];break;}if(!arr[pos]||arr[pos]&&!replace){arr[pos]=pointPool.newElement();}arr[pos][0]=x;arr[pos][1]=y;};ShapePath.prototype.setTripleAt=function(vX,vY,oX,oY,iX,iY,pos,replace){this.setXYAt(vX,vY,'v',pos,replace);this.setXYAt(oX,oY,'o',pos,replace);this.setXYAt(iX,iY,'i',pos,replace);};ShapePath.prototype.reverse=function(){var newPath=new ShapePath();newPath.setPathData(this.c,this._length);var vertices=this.v;var outPoints=this.o;var inPoints=this.i;var init=0;if(this.c){newPath.setTripleAt(vertices[0][0],vertices[0][1],inPoints[0][0],inPoints[0][1],outPoints[0][0],outPoints[0][1],0,false);init=1;}var cnt=this._length-1;var len=this._length;var i;for(i=init;i<len;i+=1){newPath.setTripleAt(vertices[cnt][0],vertices[cnt][1],inPoints[cnt][0],inPoints[cnt][1],outPoints[cnt][0],outPoints[cnt][1],i,false);cnt-=1;}return newPath;};ShapePath.prototype.length=function(){return this._length;};var shapePool=function(){function create(){return new ShapePath();}function release(shapePath){var len=shapePath._length;var i;for(i=0;i<len;i+=1){pointPool.release(shapePath.v[i]);pointPool.release(shapePath.i[i]);pointPool.release(shapePath.o[i]);shapePath.v[i]=null;shapePath.i[i]=null;shapePath.o[i]=null;}shapePath._length=0;shapePath.c=false;}function clone(shape){var cloned=factory.newElement();var i;var len=shape._length===undefined?shape.v.length:shape._length;cloned.setLength(len);cloned.c=shape.c;for(i=0;i<len;i+=1){cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1],i);}return cloned;}var factory=poolFactory(4,create,release);factory.clone=clone;return factory;}();function ShapeCollection(){this._length=0;this._maxLength=4;this.shapes=createSizedArray(this._maxLength);}ShapeCollection.prototype.addShape=function(shapeData){if(this._length===this._maxLength){this.shapes=this.shapes.concat(createSizedArray(this._maxLength));this._maxLength*=2;}this.shapes[this._length]=shapeData;this._length+=1;};ShapeCollection.prototype.releaseShapes=function(){var i;for(i=0;i<this._length;i+=1){shapePool.release(this.shapes[i]);}this._length=0;};var shapeCollectionPool=function(){var ob={newShapeCollection:newShapeCollection,release:release};var _length=0;var _maxLength=4;var pool=createSizedArray(_maxLength);function newShapeCollection(){var shapeCollection;if(_length){_length-=1;shapeCollection=pool[_length];}else{shapeCollection=new ShapeCollection();}return shapeCollection;}function release(shapeCollection){var i;var len=shapeCollection._length;for(i=0;i<len;i+=1){shapePool.release(shapeCollection.shapes[i]);}shapeCollection._length=0;if(_length===_maxLength){pool=pooling["double"](pool);_maxLength*=2;}pool[_length]=shapeCollection;_length+=1;}return ob;}();var ShapePropertyFactory=function(){var initFrame=-999999;function interpolateShape(frameNum,previousValue,caching){var iterationIndex=caching.lastIndex;var keyPropS;var keyPropE;var isHold;var j;var k;var jLen;var kLen;var perc;var vertexValue;var kf=this.keyframes;if(frameNum<kf[0].t-this.offsetTime){keyPropS=kf[0].s[0];isHold=true;iterationIndex=0;}else if(frameNum>=kf[kf.length-1].t-this.offsetTime){keyPropS=kf[kf.length-1].s?kf[kf.length-1].s[0]:kf[kf.length-2].e[0];/* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */isHold=true;}else{var i=iterationIndex;var len=kf.length-1;var flag=true;var keyData;var nextKeyData;var keyframeMetadata;while(flag){keyData=kf[i];nextKeyData=kf[i+1];if(nextKeyData.t-this.offsetTime>frameNum){break;}if(i<len-1){i+=1;}else{flag=false;}}keyframeMetadata=this.keyframesMetadata[i]||{};isHold=keyData.h===1;iterationIndex=i;if(!isHold){if(frameNum>=nextKeyData.t-this.offsetTime){perc=1;}else if(frameNum<keyData.t-this.offsetTime){perc=0;}else{var fnc;if(keyframeMetadata.__fnct){fnc=keyframeMetadata.__fnct;}else{fnc=BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;keyframeMetadata.__fnct=fnc;}perc=fnc((frameNum-(keyData.t-this.offsetTime))/(nextKeyData.t-this.offsetTime-(keyData.t-this.offsetTime)));}keyPropE=nextKeyData.s?nextKeyData.s[0]:keyData.e[0];}keyPropS=keyData.s[0];}jLen=previousValue._length;kLen=keyPropS.i[0].length;caching.lastIndex=iterationIndex;for(j=0;j<jLen;j+=1){for(k=0;k<kLen;k+=1){vertexValue=isHold?keyPropS.i[j][k]:keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;previousValue.i[j][k]=vertexValue;vertexValue=isHold?keyPropS.o[j][k]:keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;previousValue.o[j][k]=vertexValue;vertexValue=isHold?keyPropS.v[j][k]:keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;previousValue.v[j][k]=vertexValue;}}}function interpolateShapeCurrentTime(){var frameNum=this.comp.renderedFrame-this.offsetTime;var initTime=this.keyframes[0].t-this.offsetTime;var endTime=this.keyframes[this.keyframes.length-1].t-this.offsetTime;var lastFrame=this._caching.lastFrame;if(!(lastFrame!==initFrame&&(lastFrame<initTime&&frameNum<initTime||lastFrame>endTime&&frameNum>endTime))){/// /
this._caching.lastIndex=lastFrame<frameNum?this._caching.lastIndex:0;this.interpolateShape(frameNum,this.pv,this._caching);/// /
}this._caching.lastFrame=frameNum;return this.pv;}function resetShape(){this.paths=this.localShapeCollection;}function shapesEqual(shape1,shape2){if(shape1._length!==shape2._length||shape1.c!==shape2.c){return false;}var i;var len=shape1._length;for(i=0;i<len;i+=1){if(shape1.v[i][0]!==shape2.v[i][0]||shape1.v[i][1]!==shape2.v[i][1]||shape1.o[i][0]!==shape2.o[i][0]||shape1.o[i][1]!==shape2.o[i][1]||shape1.i[i][0]!==shape2.i[i][0]||shape1.i[i][1]!==shape2.i[i][1]){return false;}}return true;}function setVValue(newPath){if(!shapesEqual(this.v,newPath)){this.v=shapePool.clone(newPath);this.localShapeCollection.releaseShapes();this.localShapeCollection.addShape(this.v);this._mdf=true;this.paths=this.localShapeCollection;}}function processEffectsSequence(){if(this.elem.globalData.frameId===this.frameId){return;}if(!this.effectsSequence.length){this._mdf=false;return;}if(this.lock){this.setVValue(this.pv);return;}this.lock=true;this._mdf=false;var finalValue;if(this.kf){finalValue=this.pv;}else if(this.data.ks){finalValue=this.data.ks.k;}else{finalValue=this.data.pt.k;}var i;var len=this.effectsSequence.length;for(i=0;i<len;i+=1){finalValue=this.effectsSequence[i](finalValue);}this.setVValue(finalValue);this.lock=false;this.frameId=this.elem.globalData.frameId;}function ShapeProperty(elem,data,type){this.propType='shape';this.comp=elem.comp;this.container=elem;this.elem=elem;this.data=data;this.k=false;this.kf=false;this._mdf=false;var pathData=type===3?data.pt.k:data.ks.k;this.v=shapePool.clone(pathData);this.pv=shapePool.clone(this.v);this.localShapeCollection=shapeCollectionPool.newShapeCollection();this.paths=this.localShapeCollection;this.paths.addShape(this.v);this.reset=resetShape;this.effectsSequence=[];}function addEffect(effectFunction){this.effectsSequence.push(effectFunction);this.container.addDynamicProperty(this);}ShapeProperty.prototype.interpolateShape=interpolateShape;ShapeProperty.prototype.getValue=processEffectsSequence;ShapeProperty.prototype.setVValue=setVValue;ShapeProperty.prototype.addEffect=addEffect;function KeyframedShapeProperty(elem,data,type){this.propType='shape';this.comp=elem.comp;this.elem=elem;this.container=elem;this.offsetTime=elem.data.st;this.keyframes=type===3?data.pt.k:data.ks.k;this.keyframesMetadata=[];this.k=true;this.kf=true;var len=this.keyframes[0].s[0].i.length;this.v=shapePool.newElement();this.v.setPathData(this.keyframes[0].s[0].c,len);this.pv=shapePool.clone(this.v);this.localShapeCollection=shapeCollectionPool.newShapeCollection();this.paths=this.localShapeCollection;this.paths.addShape(this.v);this.lastFrame=initFrame;this.reset=resetShape;this._caching={lastFrame:initFrame,lastIndex:0};this.effectsSequence=[interpolateShapeCurrentTime.bind(this)];}KeyframedShapeProperty.prototype.getValue=processEffectsSequence;KeyframedShapeProperty.prototype.interpolateShape=interpolateShape;KeyframedShapeProperty.prototype.setVValue=setVValue;KeyframedShapeProperty.prototype.addEffect=addEffect;var EllShapeProperty=function(){var cPoint=roundCorner;function EllShapePropertyFactory(elem,data){this.v=shapePool.newElement();this.v.setPathData(true,4);this.localShapeCollection=shapeCollectionPool.newShapeCollection();this.paths=this.localShapeCollection;this.localShapeCollection.addShape(this.v);this.d=data.d;this.elem=elem;this.comp=elem.comp;this.frameId=-1;this.initDynamicPropertyContainer(elem);this.p=PropertyFactory.getProp(elem,data.p,1,0,this);this.s=PropertyFactory.getProp(elem,data.s,1,0,this);if(this.dynamicProperties.length){this.k=true;}else{this.k=false;this.convertEllToPath();}}EllShapePropertyFactory.prototype={reset:resetShape,getValue:function getValue(){if(this.elem.globalData.frameId===this.frameId){return;}this.frameId=this.elem.globalData.frameId;this.iterateDynamicProperties();if(this._mdf){this.convertEllToPath();}},convertEllToPath:function convertEllToPath(){var p0=this.p.v[0];var p1=this.p.v[1];var s0=this.s.v[0]/2;var s1=this.s.v[1]/2;var _cw=this.d!==3;var _v=this.v;_v.v[0][0]=p0;_v.v[0][1]=p1-s1;_v.v[1][0]=_cw?p0+s0:p0-s0;_v.v[1][1]=p1;_v.v[2][0]=p0;_v.v[2][1]=p1+s1;_v.v[3][0]=_cw?p0-s0:p0+s0;_v.v[3][1]=p1;_v.i[0][0]=_cw?p0-s0*cPoint:p0+s0*cPoint;_v.i[0][1]=p1-s1;_v.i[1][0]=_cw?p0+s0:p0-s0;_v.i[1][1]=p1-s1*cPoint;_v.i[2][0]=_cw?p0+s0*cPoint:p0-s0*cPoint;_v.i[2][1]=p1+s1;_v.i[3][0]=_cw?p0-s0:p0+s0;_v.i[3][1]=p1+s1*cPoint;_v.o[0][0]=_cw?p0+s0*cPoint:p0-s0*cPoint;_v.o[0][1]=p1-s1;_v.o[1][0]=_cw?p0+s0:p0-s0;_v.o[1][1]=p1+s1*cPoint;_v.o[2][0]=_cw?p0-s0*cPoint:p0+s0*cPoint;_v.o[2][1]=p1+s1;_v.o[3][0]=_cw?p0-s0:p0+s0;_v.o[3][1]=p1-s1*cPoint;}};extendPrototype([DynamicPropertyContainer],EllShapePropertyFactory);return EllShapePropertyFactory;}();var StarShapeProperty=function(){function StarShapePropertyFactory(elem,data){this.v=shapePool.newElement();this.v.setPathData(true,0);this.elem=elem;this.comp=elem.comp;this.data=data;this.frameId=-1;this.d=data.d;this.initDynamicPropertyContainer(elem);if(data.sy===1){this.ir=PropertyFactory.getProp(elem,data.ir,0,0,this);this.is=PropertyFactory.getProp(elem,data.is,0,0.01,this);this.convertToPath=this.convertStarToPath;}else{this.convertToPath=this.convertPolygonToPath;}this.pt=PropertyFactory.getProp(elem,data.pt,0,0,this);this.p=PropertyFactory.getProp(elem,data.p,1,0,this);this.r=PropertyFactory.getProp(elem,data.r,0,degToRads,this);this.or=PropertyFactory.getProp(elem,data.or,0,0,this);this.os=PropertyFactory.getProp(elem,data.os,0,0.01,this);this.localShapeCollection=shapeCollectionPool.newShapeCollection();this.localShapeCollection.addShape(this.v);this.paths=this.localShapeCollection;if(this.dynamicProperties.length){this.k=true;}else{this.k=false;this.convertToPath();}}StarShapePropertyFactory.prototype={reset:resetShape,getValue:function getValue(){if(this.elem.globalData.frameId===this.frameId){return;}this.frameId=this.elem.globalData.frameId;this.iterateDynamicProperties();if(this._mdf){this.convertToPath();}},convertStarToPath:function convertStarToPath(){var numPts=Math.floor(this.pt.v)*2;var angle=Math.PI*2/numPts;/* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */var longFlag=true;var longRad=this.or.v;var shortRad=this.ir.v;var longRound=this.os.v;var shortRound=this.is.v;var longPerimSegment=2*Math.PI*longRad/(numPts*2);var shortPerimSegment=2*Math.PI*shortRad/(numPts*2);var i;var rad;var roundness;var perimSegment;var currentAng=-Math.PI/2;currentAng+=this.r.v;var dir=this.data.d===3?-1:1;this.v._length=0;for(i=0;i<numPts;i+=1){rad=longFlag?longRad:shortRad;roundness=longFlag?longRound:shortRound;perimSegment=longFlag?longPerimSegment:shortPerimSegment;var x=rad*Math.cos(currentAng);var y=rad*Math.sin(currentAng);var ox=x===0&&y===0?0:y/Math.sqrt(x*x+y*y);var oy=x===0&&y===0?0:-x/Math.sqrt(x*x+y*y);x+=+this.p.v[0];y+=+this.p.v[1];this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir,i,true);/* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */longFlag=!longFlag;currentAng+=angle*dir;}},convertPolygonToPath:function convertPolygonToPath(){var numPts=Math.floor(this.pt.v);var angle=Math.PI*2/numPts;var rad=this.or.v;var roundness=this.os.v;var perimSegment=2*Math.PI*rad/(numPts*4);var i;var currentAng=-Math.PI*0.5;var dir=this.data.d===3?-1:1;currentAng+=this.r.v;this.v._length=0;for(i=0;i<numPts;i+=1){var x=rad*Math.cos(currentAng);var y=rad*Math.sin(currentAng);var ox=x===0&&y===0?0:y/Math.sqrt(x*x+y*y);var oy=x===0&&y===0?0:-x/Math.sqrt(x*x+y*y);x+=+this.p.v[0];y+=+this.p.v[1];this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir,i,true);currentAng+=angle*dir;}this.paths.length=0;this.paths[0]=this.v;}};extendPrototype([DynamicPropertyContainer],StarShapePropertyFactory);return StarShapePropertyFactory;}();var RectShapeProperty=function(){function RectShapePropertyFactory(elem,data){this.v=shapePool.newElement();this.v.c=true;this.localShapeCollection=shapeCollectionPool.newShapeCollection();this.localShapeCollection.addShape(this.v);this.paths=this.localShapeCollection;this.elem=elem;this.comp=elem.comp;this.frameId=-1;this.d=data.d;this.initDynamicPropertyContainer(elem);this.p=PropertyFactory.getProp(elem,data.p,1,0,this);this.s=PropertyFactory.getProp(elem,data.s,1,0,this);this.r=PropertyFactory.getProp(elem,data.r,0,0,this);if(this.dynamicProperties.length){this.k=true;}else{this.k=false;this.convertRectToPath();}}RectShapePropertyFactory.prototype={convertRectToPath:function convertRectToPath(){var p0=this.p.v[0];var p1=this.p.v[1];var v0=this.s.v[0]/2;var v1=this.s.v[1]/2;var round=bmMin(v0,v1,this.r.v);var cPoint=round*(1-roundCorner);this.v._length=0;if(this.d===2||this.d===1){this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,0,true);this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,p0+v0,p1+v1-round,1,true);if(round!==0){this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2,true);this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3,true);this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4,true);this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5,true);this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6,true);this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7,true);}else{this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);}}else{this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0,true);if(round!==0){this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1,true);this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2,true);this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3,true);this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4,true);this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5,true);this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6,true);this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7,true);}else{this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1,true);this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2,true);this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3,true);}}},getValue:function getValue(){if(this.elem.globalData.frameId===this.frameId){return;}this.frameId=this.elem.globalData.frameId;this.iterateDynamicProperties();if(this._mdf){this.convertRectToPath();}},reset:resetShape};extendPrototype([DynamicPropertyContainer],RectShapePropertyFactory);return RectShapePropertyFactory;}();function getShapeProp(elem,data,type){var prop;if(type===3||type===4){var dataProp=type===3?data.pt:data.ks;var keys=dataProp.k;if(keys.length){prop=new KeyframedShapeProperty(elem,data,type);}else{prop=new ShapeProperty(elem,data,type);}}else if(type===5){prop=new RectShapeProperty(elem,data);}else if(type===6){prop=new EllShapeProperty(elem,data);}else if(type===7){prop=new StarShapeProperty(elem,data);}if(prop.k){elem.addDynamicProperty(prop);}return prop;}function getConstructorFunction(){return ShapeProperty;}function getKeyframedConstructorFunction(){return KeyframedShapeProperty;}var ob={};ob.getShapeProp=getShapeProp;ob.getConstructorFunction=getConstructorFunction;ob.getKeyframedConstructorFunction=getKeyframedConstructorFunction;return ob;}();/*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */var Matrix=function(){var _cos=Math.cos;var _sin=Math.sin;var _tan=Math.tan;var _rnd=Math.round;function reset(){this.props[0]=1;this.props[1]=0;this.props[2]=0;this.props[3]=0;this.props[4]=0;this.props[5]=1;this.props[6]=0;this.props[7]=0;this.props[8]=0;this.props[9]=0;this.props[10]=1;this.props[11]=0;this.props[12]=0;this.props[13]=0;this.props[14]=0;this.props[15]=1;return this;}function rotate(angle){if(angle===0){return this;}var mCos=_cos(angle);var mSin=_sin(angle);return this._t(mCos,-mSin,0,0,mSin,mCos,0,0,0,0,1,0,0,0,0,1);}function rotateX(angle){if(angle===0){return this;}var mCos=_cos(angle);var mSin=_sin(angle);return this._t(1,0,0,0,0,mCos,-mSin,0,0,mSin,mCos,0,0,0,0,1);}function rotateY(angle){if(angle===0){return this;}var mCos=_cos(angle);var mSin=_sin(angle);return this._t(mCos,0,mSin,0,0,1,0,0,-mSin,0,mCos,0,0,0,0,1);}function rotateZ(angle){if(angle===0){return this;}var mCos=_cos(angle);var mSin=_sin(angle);return this._t(mCos,-mSin,0,0,mSin,mCos,0,0,0,0,1,0,0,0,0,1);}function shear(sx,sy){return this._t(1,sy,sx,1,0,0);}function skew(ax,ay){return this.shear(_tan(ax),_tan(ay));}function skewFromAxis(ax,angle){var mCos=_cos(angle);var mSin=_sin(angle);return this._t(mCos,mSin,0,0,-mSin,mCos,0,0,0,0,1,0,0,0,0,1)._t(1,0,0,0,_tan(ax),1,0,0,0,0,1,0,0,0,0,1)._t(mCos,-mSin,0,0,mSin,mCos,0,0,0,0,1,0,0,0,0,1);// return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
}function scale(sx,sy,sz){if(!sz&&sz!==0){sz=1;}if(sx===1&&sy===1&&sz===1){return this;}return this._t(sx,0,0,0,0,sy,0,0,0,0,sz,0,0,0,0,1);}function setTransform(a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p){this.props[0]=a;this.props[1]=b;this.props[2]=c;this.props[3]=d;this.props[4]=e;this.props[5]=f;this.props[6]=g;this.props[7]=h;this.props[8]=i;this.props[9]=j;this.props[10]=k;this.props[11]=l;this.props[12]=m;this.props[13]=n;this.props[14]=o;this.props[15]=p;return this;}function translate(tx,ty,tz){tz=tz||0;if(tx!==0||ty!==0||tz!==0){return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);}return this;}function transform(a2,b2,c2,d2,e2,f2,g2,h2,i2,j2,k2,l2,m2,n2,o2,p2){var _p=this.props;if(a2===1&&b2===0&&c2===0&&d2===0&&e2===0&&f2===1&&g2===0&&h2===0&&i2===0&&j2===0&&k2===1&&l2===0){// NOTE: commenting this condition because TurboFan deoptimizes code when present
// if(m2 !== 0 || n2 !== 0 || o2 !== 0){
_p[12]=_p[12]*a2+_p[15]*m2;_p[13]=_p[13]*f2+_p[15]*n2;_p[14]=_p[14]*k2+_p[15]*o2;_p[15]*=p2;// }
this._identityCalculated=false;return this;}var a1=_p[0];var b1=_p[1];var c1=_p[2];var d1=_p[3];var e1=_p[4];var f1=_p[5];var g1=_p[6];var h1=_p[7];var i1=_p[8];var j1=_p[9];var k1=_p[10];var l1=_p[11];var m1=_p[12];var n1=_p[13];var o1=_p[14];var p1=_p[15];/* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */_p[0]=a1*a2+b1*e2+c1*i2+d1*m2;_p[1]=a1*b2+b1*f2+c1*j2+d1*n2;_p[2]=a1*c2+b1*g2+c1*k2+d1*o2;_p[3]=a1*d2+b1*h2+c1*l2+d1*p2;_p[4]=e1*a2+f1*e2+g1*i2+h1*m2;_p[5]=e1*b2+f1*f2+g1*j2+h1*n2;_p[6]=e1*c2+f1*g2+g1*k2+h1*o2;_p[7]=e1*d2+f1*h2+g1*l2+h1*p2;_p[8]=i1*a2+j1*e2+k1*i2+l1*m2;_p[9]=i1*b2+j1*f2+k1*j2+l1*n2;_p[10]=i1*c2+j1*g2+k1*k2+l1*o2;_p[11]=i1*d2+j1*h2+k1*l2+l1*p2;_p[12]=m1*a2+n1*e2+o1*i2+p1*m2;_p[13]=m1*b2+n1*f2+o1*j2+p1*n2;_p[14]=m1*c2+n1*g2+o1*k2+p1*o2;_p[15]=m1*d2+n1*h2+o1*l2+p1*p2;this._identityCalculated=false;return this;}function multiply(matrix){var matrixProps=matrix.props;return this.transform(matrixProps[0],matrixProps[1],matrixProps[2],matrixProps[3],matrixProps[4],matrixProps[5],matrixProps[6],matrixProps[7],matrixProps[8],matrixProps[9],matrixProps[10],matrixProps[11],matrixProps[12],matrixProps[13],matrixProps[14],matrixProps[15]);}function isIdentity(){if(!this._identityCalculated){this._identity=!(this.props[0]!==1||this.props[1]!==0||this.props[2]!==0||this.props[3]!==0||this.props[4]!==0||this.props[5]!==1||this.props[6]!==0||this.props[7]!==0||this.props[8]!==0||this.props[9]!==0||this.props[10]!==1||this.props[11]!==0||this.props[12]!==0||this.props[13]!==0||this.props[14]!==0||this.props[15]!==1);this._identityCalculated=true;}return this._identity;}function equals(matr){var i=0;while(i<16){if(matr.props[i]!==this.props[i]){return false;}i+=1;}return true;}function clone(matr){var i;for(i=0;i<16;i+=1){matr.props[i]=this.props[i];}return matr;}function cloneFromProps(props){var i;for(i=0;i<16;i+=1){this.props[i]=props[i];}}function applyToPoint(x,y,z){return{x:x*this.props[0]+y*this.props[4]+z*this.props[8]+this.props[12],y:x*this.props[1]+y*this.props[5]+z*this.props[9]+this.props[13],z:x*this.props[2]+y*this.props[6]+z*this.props[10]+this.props[14]};/* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */}function applyToX(x,y,z){return x*this.props[0]+y*this.props[4]+z*this.props[8]+this.props[12];}function applyToY(x,y,z){return x*this.props[1]+y*this.props[5]+z*this.props[9]+this.props[13];}function applyToZ(x,y,z){return x*this.props[2]+y*this.props[6]+z*this.props[10]+this.props[14];}function getInverseMatrix(){var determinant=this.props[0]*this.props[5]-this.props[1]*this.props[4];var a=this.props[5]/determinant;var b=-this.props[1]/determinant;var c=-this.props[4]/determinant;var d=this.props[0]/determinant;var e=(this.props[4]*this.props[13]-this.props[5]*this.props[12])/determinant;var f=-(this.props[0]*this.props[13]-this.props[1]*this.props[12])/determinant;var inverseMatrix=new Matrix();inverseMatrix.props[0]=a;inverseMatrix.props[1]=b;inverseMatrix.props[4]=c;inverseMatrix.props[5]=d;inverseMatrix.props[12]=e;inverseMatrix.props[13]=f;return inverseMatrix;}function inversePoint(pt){var inverseMatrix=this.getInverseMatrix();return inverseMatrix.applyToPointArray(pt[0],pt[1],pt[2]||0);}function inversePoints(pts){var i;var len=pts.length;var retPts=[];for(i=0;i<len;i+=1){retPts[i]=inversePoint(pts[i]);}return retPts;}function applyToTriplePoints(pt1,pt2,pt3){var arr=createTypedArray('float32',6);if(this.isIdentity()){arr[0]=pt1[0];arr[1]=pt1[1];arr[2]=pt2[0];arr[3]=pt2[1];arr[4]=pt3[0];arr[5]=pt3[1];}else{var p0=this.props[0];var p1=this.props[1];var p4=this.props[4];var p5=this.props[5];var p12=this.props[12];var p13=this.props[13];arr[0]=pt1[0]*p0+pt1[1]*p4+p12;arr[1]=pt1[0]*p1+pt1[1]*p5+p13;arr[2]=pt2[0]*p0+pt2[1]*p4+p12;arr[3]=pt2[0]*p1+pt2[1]*p5+p13;arr[4]=pt3[0]*p0+pt3[1]*p4+p12;arr[5]=pt3[0]*p1+pt3[1]*p5+p13;}return arr;}function applyToPointArray(x,y,z){var arr;if(this.isIdentity()){arr=[x,y,z];}else{arr=[x*this.props[0]+y*this.props[4]+z*this.props[8]+this.props[12],x*this.props[1]+y*this.props[5]+z*this.props[9]+this.props[13],x*this.props[2]+y*this.props[6]+z*this.props[10]+this.props[14]];}return arr;}function applyToPointStringified(x,y){if(this.isIdentity()){return x+','+y;}var _p=this.props;return Math.round((x*_p[0]+y*_p[4]+_p[12])*100)/100+','+Math.round((x*_p[1]+y*_p[5]+_p[13])*100)/100;}function toCSS(){// Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
/* if(this.isIdentity()) {
              return '';
          } */var i=0;var props=this.props;var cssValue='matrix3d(';var v=10000;while(i<16){cssValue+=_rnd(props[i]*v)/v;cssValue+=i===15?')':',';i+=1;}return cssValue;}function roundMatrixProperty(val){var v=10000;if(val<0.000001&&val>0||val>-0.000001&&val<0){return _rnd(val*v)/v;}return val;}function to2dCSS(){// Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
/* if(this.isIdentity()) {
              return '';
          } */var props=this.props;var _a=roundMatrixProperty(props[0]);var _b=roundMatrixProperty(props[1]);var _c=roundMatrixProperty(props[4]);var _d=roundMatrixProperty(props[5]);var _e=roundMatrixProperty(props[12]);var _f=roundMatrixProperty(props[13]);return'matrix('+_a+','+_b+','+_c+','+_d+','+_e+','+_f+')';}return function(){this.reset=reset;this.rotate=rotate;this.rotateX=rotateX;this.rotateY=rotateY;this.rotateZ=rotateZ;this.skew=skew;this.skewFromAxis=skewFromAxis;this.shear=shear;this.scale=scale;this.setTransform=setTransform;this.translate=translate;this.transform=transform;this.multiply=multiply;this.applyToPoint=applyToPoint;this.applyToX=applyToX;this.applyToY=applyToY;this.applyToZ=applyToZ;this.applyToPointArray=applyToPointArray;this.applyToTriplePoints=applyToTriplePoints;this.applyToPointStringified=applyToPointStringified;this.toCSS=toCSS;this.to2dCSS=to2dCSS;this.clone=clone;this.cloneFromProps=cloneFromProps;this.equals=equals;this.inversePoints=inversePoints;this.inversePoint=inversePoint;this.getInverseMatrix=getInverseMatrix;this._t=this.transform;this.isIdentity=isIdentity;this._identity=true;this._identityCalculated=false;this.props=createTypedArray('float32',16);this.reset();};}();function _typeof$3(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$3=function _typeof(obj){return typeof obj;};}else{_typeof$3=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$3(obj);}var lottie={};var standalone='__[STANDALONE]__';var animationData='__[ANIMATIONDATA]__';var renderer='';function setLocation(href){setLocationHref(href);}function searchAnimations(){if(standalone===true){animationManager.searchAnimations(animationData,standalone,renderer);}else{animationManager.searchAnimations();}}function setSubframeRendering(flag){setSubframeEnabled(flag);}function setPrefix(prefix){setIdPrefix(prefix);}function loadAnimation(params){if(standalone===true){params.animationData=JSON.parse(animationData);}return animationManager.loadAnimation(params);}function setQuality(value){if(typeof value==='string'){switch(value){case'high':setDefaultCurveSegments(200);break;default:case'medium':setDefaultCurveSegments(50);break;case'low':setDefaultCurveSegments(10);break;}}else if(!isNaN(value)&&value>1){setDefaultCurveSegments(value);}if(getDefaultCurveSegments()>=50){roundValues(false);}else{roundValues(true);}}function inBrowser(){return typeof navigator!=='undefined';}function installPlugin(type,plugin){if(type==='expressions'){setExpressionsPlugin(plugin);}}function getFactory(name){switch(name){case'propertyFactory':return PropertyFactory;case'shapePropertyFactory':return ShapePropertyFactory;case'matrix':return Matrix;default:return null;}}lottie.play=animationManager.play;lottie.pause=animationManager.pause;lottie.setLocationHref=setLocation;lottie.togglePause=animationManager.togglePause;lottie.setSpeed=animationManager.setSpeed;lottie.setDirection=animationManager.setDirection;lottie.stop=animationManager.stop;lottie.searchAnimations=searchAnimations;lottie.registerAnimation=animationManager.registerAnimation;lottie.loadAnimation=loadAnimation;lottie.setSubframeRendering=setSubframeRendering;lottie.resize=animationManager.resize;// lottie.start = start;
lottie.goToAndStop=animationManager.goToAndStop;lottie.destroy=animationManager.destroy;lottie.setQuality=setQuality;lottie.inBrowser=inBrowser;lottie.installPlugin=installPlugin;lottie.freeze=animationManager.freeze;lottie.unfreeze=animationManager.unfreeze;lottie.setVolume=animationManager.setVolume;lottie.mute=animationManager.mute;lottie.unmute=animationManager.unmute;lottie.getRegisteredAnimations=animationManager.getRegisteredAnimations;lottie.useWebWorker=setWebWorker;lottie.setIDPrefix=setPrefix;lottie.__getFactory=getFactory;lottie.version='5.12.2';function checkReady(){if(document.readyState==='complete'){clearInterval(readyStateCheckInterval);searchAnimations();}}function getQueryVariable(variable){var vars=queryString.split('&');for(var i=0;i<vars.length;i+=1){var pair=vars[i].split('=');if(decodeURIComponent(pair[0])==variable){// eslint-disable-line eqeqeq
return decodeURIComponent(pair[1]);}}return null;}var queryString='';if(standalone){var scripts=document.getElementsByTagName('script');var index=scripts.length-1;var myScript=scripts[index]||{src:''};queryString=myScript.src?myScript.src.replace(/^[^\?]+\??/,''):'';// eslint-disable-line no-useless-escape
renderer=getQueryVariable('renderer');}var readyStateCheckInterval=setInterval(checkReady,100);// this adds bodymovin to the window object for backwards compatibility
try{if(!(( false?0:_typeof$3(exports))==='object'&&"object"!=='undefined')&&!( true&&__webpack_require__.amdO)// eslint-disable-line no-undef
){}}catch(err){//
}var ShapeModifiers=function(){var ob={};var modifiers={};ob.registerModifier=registerModifier;ob.getModifier=getModifier;function registerModifier(nm,factory){if(!modifiers[nm]){modifiers[nm]=factory;}}function getModifier(nm,elem,data){return new modifiers[nm](elem,data);}return ob;}();function ShapeModifier(){}ShapeModifier.prototype.initModifierProperties=function(){};ShapeModifier.prototype.addShapeToModifier=function(){};ShapeModifier.prototype.addShape=function(data){if(!this.closed){// Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
data.sh.container.addDynamicProperty(data.sh);var shapeData={shape:data.sh,data:data,localShapeCollection:shapeCollectionPool.newShapeCollection()};this.shapes.push(shapeData);this.addShapeToModifier(shapeData);if(this._isAnimated){data.setAsAnimated();}}};ShapeModifier.prototype.init=function(elem,data){this.shapes=[];this.elem=elem;this.initDynamicPropertyContainer(elem);this.initModifierProperties(elem,data);this.frameId=initialDefaultFrame;this.closed=false;this.k=false;if(this.dynamicProperties.length){this.k=true;}else{this.getValue(true);}};ShapeModifier.prototype.processKeys=function(){if(this.elem.globalData.frameId===this.frameId){return;}this.frameId=this.elem.globalData.frameId;this.iterateDynamicProperties();};extendPrototype([DynamicPropertyContainer],ShapeModifier);function TrimModifier(){}extendPrototype([ShapeModifier],TrimModifier);TrimModifier.prototype.initModifierProperties=function(elem,data){this.s=PropertyFactory.getProp(elem,data.s,0,0.01,this);this.e=PropertyFactory.getProp(elem,data.e,0,0.01,this);this.o=PropertyFactory.getProp(elem,data.o,0,0,this);this.sValue=0;this.eValue=0;this.getValue=this.processKeys;this.m=data.m;this._isAnimated=!!this.s.effectsSequence.length||!!this.e.effectsSequence.length||!!this.o.effectsSequence.length;};TrimModifier.prototype.addShapeToModifier=function(shapeData){shapeData.pathsData=[];};TrimModifier.prototype.calculateShapeEdges=function(s,e,shapeLength,addedLength,totalModifierLength){var segments=[];if(e<=1){segments.push({s:s,e:e});}else if(s>=1){segments.push({s:s-1,e:e-1});}else{segments.push({s:s,e:1});segments.push({s:0,e:e-1});}var shapeSegments=[];var i;var len=segments.length;var segmentOb;for(i=0;i<len;i+=1){segmentOb=segments[i];if(!(segmentOb.e*totalModifierLength<addedLength||segmentOb.s*totalModifierLength>addedLength+shapeLength)){var shapeS;var shapeE;if(segmentOb.s*totalModifierLength<=addedLength){shapeS=0;}else{shapeS=(segmentOb.s*totalModifierLength-addedLength)/shapeLength;}if(segmentOb.e*totalModifierLength>=addedLength+shapeLength){shapeE=1;}else{shapeE=(segmentOb.e*totalModifierLength-addedLength)/shapeLength;}shapeSegments.push([shapeS,shapeE]);}}if(!shapeSegments.length){shapeSegments.push([0,0]);}return shapeSegments;};TrimModifier.prototype.releasePathsData=function(pathsData){var i;var len=pathsData.length;for(i=0;i<len;i+=1){segmentsLengthPool.release(pathsData[i]);}pathsData.length=0;return pathsData;};TrimModifier.prototype.processShapes=function(_isFirstFrame){var s;var e;if(this._mdf||_isFirstFrame){var o=this.o.v%360/360;if(o<0){o+=1;}if(this.s.v>1){s=1+o;}else if(this.s.v<0){s=0+o;}else{s=this.s.v+o;}if(this.e.v>1){e=1+o;}else if(this.e.v<0){e=0+o;}else{e=this.e.v+o;}if(s>e){var _s=s;s=e;e=_s;}s=Math.round(s*10000)*0.0001;e=Math.round(e*10000)*0.0001;this.sValue=s;this.eValue=e;}else{s=this.sValue;e=this.eValue;}var shapePaths;var i;var len=this.shapes.length;var j;var jLen;var pathsData;var pathData;var totalShapeLength;var totalModifierLength=0;if(e===s){for(i=0;i<len;i+=1){this.shapes[i].localShapeCollection.releaseShapes();this.shapes[i].shape._mdf=true;this.shapes[i].shape.paths=this.shapes[i].localShapeCollection;if(this._mdf){this.shapes[i].pathsData.length=0;}}}else if(!(e===1&&s===0||e===0&&s===1)){var segments=[];var shapeData;var localShapeCollection;for(i=0;i<len;i+=1){shapeData=this.shapes[i];// if shape hasn't changed and trim properties haven't changed, cached previous path can be used
if(!shapeData.shape._mdf&&!this._mdf&&!_isFirstFrame&&this.m!==2){shapeData.shape.paths=shapeData.localShapeCollection;}else{shapePaths=shapeData.shape.paths;jLen=shapePaths._length;totalShapeLength=0;if(!shapeData.shape._mdf&&shapeData.pathsData.length){totalShapeLength=shapeData.totalShapeLength;}else{pathsData=this.releasePathsData(shapeData.pathsData);for(j=0;j<jLen;j+=1){pathData=bez.getSegmentsLength(shapePaths.shapes[j]);pathsData.push(pathData);totalShapeLength+=pathData.totalLength;}shapeData.totalShapeLength=totalShapeLength;shapeData.pathsData=pathsData;}totalModifierLength+=totalShapeLength;shapeData.shape._mdf=true;}}var shapeS=s;var shapeE=e;var addedLength=0;var edges;for(i=len-1;i>=0;i-=1){shapeData=this.shapes[i];if(shapeData.shape._mdf){localShapeCollection=shapeData.localShapeCollection;localShapeCollection.releaseShapes();// if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
if(this.m===2&&len>1){edges=this.calculateShapeEdges(s,e,shapeData.totalShapeLength,addedLength,totalModifierLength);addedLength+=shapeData.totalShapeLength;}else{edges=[[shapeS,shapeE]];}jLen=edges.length;for(j=0;j<jLen;j+=1){shapeS=edges[j][0];shapeE=edges[j][1];segments.length=0;if(shapeE<=1){segments.push({s:shapeData.totalShapeLength*shapeS,e:shapeData.totalShapeLength*shapeE});}else if(shapeS>=1){segments.push({s:shapeData.totalShapeLength*(shapeS-1),e:shapeData.totalShapeLength*(shapeE-1)});}else{segments.push({s:shapeData.totalShapeLength*shapeS,e:shapeData.totalShapeLength});segments.push({s:0,e:shapeData.totalShapeLength*(shapeE-1)});}var newShapesData=this.addShapes(shapeData,segments[0]);if(segments[0].s!==segments[0].e){if(segments.length>1){var lastShapeInCollection=shapeData.shape.paths.shapes[shapeData.shape.paths._length-1];if(lastShapeInCollection.c){var lastShape=newShapesData.pop();this.addPaths(newShapesData,localShapeCollection);newShapesData=this.addShapes(shapeData,segments[1],lastShape);}else{this.addPaths(newShapesData,localShapeCollection);newShapesData=this.addShapes(shapeData,segments[1]);}}this.addPaths(newShapesData,localShapeCollection);}}shapeData.shape.paths=localShapeCollection;}}}else if(this._mdf){for(i=0;i<len;i+=1){// Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
// Don't remove this even if it's losing cached info.
this.shapes[i].pathsData.length=0;this.shapes[i].shape._mdf=true;}}};TrimModifier.prototype.addPaths=function(newPaths,localShapeCollection){var i;var len=newPaths.length;for(i=0;i<len;i+=1){localShapeCollection.addShape(newPaths[i]);}};TrimModifier.prototype.addSegment=function(pt1,pt2,pt3,pt4,shapePath,pos,newShape){shapePath.setXYAt(pt2[0],pt2[1],'o',pos);shapePath.setXYAt(pt3[0],pt3[1],'i',pos+1);if(newShape){shapePath.setXYAt(pt1[0],pt1[1],'v',pos);}shapePath.setXYAt(pt4[0],pt4[1],'v',pos+1);};TrimModifier.prototype.addSegmentFromArray=function(points,shapePath,pos,newShape){shapePath.setXYAt(points[1],points[5],'o',pos);shapePath.setXYAt(points[2],points[6],'i',pos+1);if(newShape){shapePath.setXYAt(points[0],points[4],'v',pos);}shapePath.setXYAt(points[3],points[7],'v',pos+1);};TrimModifier.prototype.addShapes=function(shapeData,shapeSegment,shapePath){var pathsData=shapeData.pathsData;var shapePaths=shapeData.shape.paths.shapes;var i;var len=shapeData.shape.paths._length;var j;var jLen;var addedLength=0;var currentLengthData;var segmentCount;var lengths;var segment;var shapes=[];var initPos;var newShape=true;if(!shapePath){shapePath=shapePool.newElement();segmentCount=0;initPos=0;}else{segmentCount=shapePath._length;initPos=shapePath._length;}shapes.push(shapePath);for(i=0;i<len;i+=1){lengths=pathsData[i].lengths;shapePath.c=shapePaths[i].c;jLen=shapePaths[i].c?lengths.length:lengths.length+1;for(j=1;j<jLen;j+=1){currentLengthData=lengths[j-1];if(addedLength+currentLengthData.addedLength<shapeSegment.s){addedLength+=currentLengthData.addedLength;shapePath.c=false;}else if(addedLength>shapeSegment.e){shapePath.c=false;break;}else{if(shapeSegment.s<=addedLength&&shapeSegment.e>=addedLength+currentLengthData.addedLength){this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[j],shapePaths[i].v[j],shapePath,segmentCount,newShape);newShape=false;}else{segment=bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[j],shapePaths[i].o[j-1],shapePaths[i].i[j],(shapeSegment.s-addedLength)/currentLengthData.addedLength,(shapeSegment.e-addedLength)/currentLengthData.addedLength,lengths[j-1]);this.addSegmentFromArray(segment,shapePath,segmentCount,newShape);// this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
newShape=false;shapePath.c=false;}addedLength+=currentLengthData.addedLength;segmentCount+=1;}}if(shapePaths[i].c&&lengths.length){currentLengthData=lengths[j-1];if(addedLength<=shapeSegment.e){var segmentLength=lengths[j-1].addedLength;if(shapeSegment.s<=addedLength&&shapeSegment.e>=addedLength+segmentLength){this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[0],shapePaths[i].v[0],shapePath,segmentCount,newShape);newShape=false;}else{segment=bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[0],shapePaths[i].o[j-1],shapePaths[i].i[0],(shapeSegment.s-addedLength)/segmentLength,(shapeSegment.e-addedLength)/segmentLength,lengths[j-1]);this.addSegmentFromArray(segment,shapePath,segmentCount,newShape);// this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
newShape=false;shapePath.c=false;}}else{shapePath.c=false;}addedLength+=currentLengthData.addedLength;segmentCount+=1;}if(shapePath._length){shapePath.setXYAt(shapePath.v[initPos][0],shapePath.v[initPos][1],'i',initPos);shapePath.setXYAt(shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1],'o',shapePath._length-1);}if(addedLength>shapeSegment.e){break;}if(i<len-1){shapePath=shapePool.newElement();newShape=true;shapes.push(shapePath);segmentCount=0;}}return shapes;};function PuckerAndBloatModifier(){}extendPrototype([ShapeModifier],PuckerAndBloatModifier);PuckerAndBloatModifier.prototype.initModifierProperties=function(elem,data){this.getValue=this.processKeys;this.amount=PropertyFactory.getProp(elem,data.a,0,null,this);this._isAnimated=!!this.amount.effectsSequence.length;};PuckerAndBloatModifier.prototype.processPath=function(path,amount){var percent=amount/100;var centerPoint=[0,0];var pathLength=path._length;var i=0;for(i=0;i<pathLength;i+=1){centerPoint[0]+=path.v[i][0];centerPoint[1]+=path.v[i][1];}centerPoint[0]/=pathLength;centerPoint[1]/=pathLength;var clonedPath=shapePool.newElement();clonedPath.c=path.c;var vX;var vY;var oX;var oY;var iX;var iY;for(i=0;i<pathLength;i+=1){vX=path.v[i][0]+(centerPoint[0]-path.v[i][0])*percent;vY=path.v[i][1]+(centerPoint[1]-path.v[i][1])*percent;oX=path.o[i][0]+(centerPoint[0]-path.o[i][0])*-percent;oY=path.o[i][1]+(centerPoint[1]-path.o[i][1])*-percent;iX=path.i[i][0]+(centerPoint[0]-path.i[i][0])*-percent;iY=path.i[i][1]+(centerPoint[1]-path.i[i][1])*-percent;clonedPath.setTripleAt(vX,vY,oX,oY,iX,iY,i);}return clonedPath;};PuckerAndBloatModifier.prototype.processShapes=function(_isFirstFrame){var shapePaths;var i;var len=this.shapes.length;var j;var jLen;var amount=this.amount.v;if(amount!==0){var shapeData;var localShapeCollection;for(i=0;i<len;i+=1){shapeData=this.shapes[i];localShapeCollection=shapeData.localShapeCollection;if(!(!shapeData.shape._mdf&&!this._mdf&&!_isFirstFrame)){localShapeCollection.releaseShapes();shapeData.shape._mdf=true;shapePaths=shapeData.shape.paths.shapes;jLen=shapeData.shape.paths._length;for(j=0;j<jLen;j+=1){localShapeCollection.addShape(this.processPath(shapePaths[j],amount));}}shapeData.shape.paths=shapeData.localShapeCollection;}}if(!this.dynamicProperties.length){this._mdf=false;}};var TransformPropertyFactory=function(){var defaultVector=[0,0];function applyToMatrix(mat){var _mdf=this._mdf;this.iterateDynamicProperties();this._mdf=this._mdf||_mdf;if(this.a){mat.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);}if(this.s){mat.scale(this.s.v[0],this.s.v[1],this.s.v[2]);}if(this.sk){mat.skewFromAxis(-this.sk.v,this.sa.v);}if(this.r){mat.rotate(-this.r.v);}else{mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);}if(this.data.p.s){if(this.data.p.z){mat.translate(this.px.v,this.py.v,-this.pz.v);}else{mat.translate(this.px.v,this.py.v,0);}}else{mat.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);}}function processKeys(forceRender){if(this.elem.globalData.frameId===this.frameId){return;}if(this._isDirty){this.precalculateMatrix();this._isDirty=false;}this.iterateDynamicProperties();if(this._mdf||forceRender){var frameRate;this.v.cloneFromProps(this.pre.props);if(this.appliedTransformations<1){this.v.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);}if(this.appliedTransformations<2){this.v.scale(this.s.v[0],this.s.v[1],this.s.v[2]);}if(this.sk&&this.appliedTransformations<3){this.v.skewFromAxis(-this.sk.v,this.sa.v);}if(this.r&&this.appliedTransformations<4){this.v.rotate(-this.r.v);}else if(!this.r&&this.appliedTransformations<4){this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);}if(this.autoOriented){var v1;var v2;frameRate=this.elem.globalData.frameRate;if(this.p&&this.p.keyframes&&this.p.getValueAtTime){if(this.p._caching.lastFrame+this.p.offsetTime<=this.p.keyframes[0].t){v1=this.p.getValueAtTime((this.p.keyframes[0].t+0.01)/frameRate,0);v2=this.p.getValueAtTime(this.p.keyframes[0].t/frameRate,0);}else if(this.p._caching.lastFrame+this.p.offsetTime>=this.p.keyframes[this.p.keyframes.length-1].t){v1=this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length-1].t/frameRate,0);v2=this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length-1].t-0.05)/frameRate,0);}else{v1=this.p.pv;v2=this.p.getValueAtTime((this.p._caching.lastFrame+this.p.offsetTime-0.01)/frameRate,this.p.offsetTime);}}else if(this.px&&this.px.keyframes&&this.py.keyframes&&this.px.getValueAtTime&&this.py.getValueAtTime){v1=[];v2=[];var px=this.px;var py=this.py;if(px._caching.lastFrame+px.offsetTime<=px.keyframes[0].t){v1[0]=px.getValueAtTime((px.keyframes[0].t+0.01)/frameRate,0);v1[1]=py.getValueAtTime((py.keyframes[0].t+0.01)/frameRate,0);v2[0]=px.getValueAtTime(px.keyframes[0].t/frameRate,0);v2[1]=py.getValueAtTime(py.keyframes[0].t/frameRate,0);}else if(px._caching.lastFrame+px.offsetTime>=px.keyframes[px.keyframes.length-1].t){v1[0]=px.getValueAtTime(px.keyframes[px.keyframes.length-1].t/frameRate,0);v1[1]=py.getValueAtTime(py.keyframes[py.keyframes.length-1].t/frameRate,0);v2[0]=px.getValueAtTime((px.keyframes[px.keyframes.length-1].t-0.01)/frameRate,0);v2[1]=py.getValueAtTime((py.keyframes[py.keyframes.length-1].t-0.01)/frameRate,0);}else{v1=[px.pv,py.pv];v2[0]=px.getValueAtTime((px._caching.lastFrame+px.offsetTime-0.01)/frameRate,px.offsetTime);v2[1]=py.getValueAtTime((py._caching.lastFrame+py.offsetTime-0.01)/frameRate,py.offsetTime);}}else{v2=defaultVector;v1=v2;}this.v.rotate(-Math.atan2(v1[1]-v2[1],v1[0]-v2[0]));}if(this.data.p&&this.data.p.s){if(this.data.p.z){this.v.translate(this.px.v,this.py.v,-this.pz.v);}else{this.v.translate(this.px.v,this.py.v,0);}}else{this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);}}this.frameId=this.elem.globalData.frameId;}function precalculateMatrix(){this.appliedTransformations=0;this.pre.reset();if(!this.a.effectsSequence.length){this.pre.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);this.appliedTransformations=1;}else{return;}if(!this.s.effectsSequence.length){this.pre.scale(this.s.v[0],this.s.v[1],this.s.v[2]);this.appliedTransformations=2;}else{return;}if(this.sk){if(!this.sk.effectsSequence.length&&!this.sa.effectsSequence.length){this.pre.skewFromAxis(-this.sk.v,this.sa.v);this.appliedTransformations=3;}else{return;}}if(this.r){if(!this.r.effectsSequence.length){this.pre.rotate(-this.r.v);this.appliedTransformations=4;}}else if(!this.rz.effectsSequence.length&&!this.ry.effectsSequence.length&&!this.rx.effectsSequence.length&&!this.or.effectsSequence.length){this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);this.appliedTransformations=4;}}function autoOrient(){//
// var prevP = this.getValueAtTime();
}function addDynamicProperty(prop){this._addDynamicProperty(prop);this.elem.addDynamicProperty(prop);this._isDirty=true;}function TransformProperty(elem,data,container){this.elem=elem;this.frameId=-1;this.propType='transform';this.data=data;this.v=new Matrix();// Precalculated matrix with non animated properties
this.pre=new Matrix();this.appliedTransformations=0;this.initDynamicPropertyContainer(container||elem);if(data.p&&data.p.s){this.px=PropertyFactory.getProp(elem,data.p.x,0,0,this);this.py=PropertyFactory.getProp(elem,data.p.y,0,0,this);if(data.p.z){this.pz=PropertyFactory.getProp(elem,data.p.z,0,0,this);}}else{this.p=PropertyFactory.getProp(elem,data.p||{k:[0,0,0]},1,0,this);}if(data.rx){this.rx=PropertyFactory.getProp(elem,data.rx,0,degToRads,this);this.ry=PropertyFactory.getProp(elem,data.ry,0,degToRads,this);this.rz=PropertyFactory.getProp(elem,data.rz,0,degToRads,this);if(data.or.k[0].ti){var i;var len=data.or.k.length;for(i=0;i<len;i+=1){data.or.k[i].to=null;data.or.k[i].ti=null;}}this.or=PropertyFactory.getProp(elem,data.or,1,degToRads,this);// sh Indicates it needs to be capped between -180 and 180
this.or.sh=true;}else{this.r=PropertyFactory.getProp(elem,data.r||{k:0},0,degToRads,this);}if(data.sk){this.sk=PropertyFactory.getProp(elem,data.sk,0,degToRads,this);this.sa=PropertyFactory.getProp(elem,data.sa,0,degToRads,this);}this.a=PropertyFactory.getProp(elem,data.a||{k:[0,0,0]},1,0,this);this.s=PropertyFactory.getProp(elem,data.s||{k:[100,100,100]},1,0.01,this);// Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
if(data.o){this.o=PropertyFactory.getProp(elem,data.o,0,0.01,elem);}else{this.o={_mdf:false,v:1};}this._isDirty=true;if(!this.dynamicProperties.length){this.getValue(true);}}TransformProperty.prototype={applyToMatrix:applyToMatrix,getValue:processKeys,precalculateMatrix:precalculateMatrix,autoOrient:autoOrient};extendPrototype([DynamicPropertyContainer],TransformProperty);TransformProperty.prototype.addDynamicProperty=addDynamicProperty;TransformProperty.prototype._addDynamicProperty=DynamicPropertyContainer.prototype.addDynamicProperty;function getTransformProperty(elem,data,container){return new TransformProperty(elem,data,container);}return{getTransformProperty:getTransformProperty};}();function RepeaterModifier(){}extendPrototype([ShapeModifier],RepeaterModifier);RepeaterModifier.prototype.initModifierProperties=function(elem,data){this.getValue=this.processKeys;this.c=PropertyFactory.getProp(elem,data.c,0,null,this);this.o=PropertyFactory.getProp(elem,data.o,0,null,this);this.tr=TransformPropertyFactory.getTransformProperty(elem,data.tr,this);this.so=PropertyFactory.getProp(elem,data.tr.so,0,0.01,this);this.eo=PropertyFactory.getProp(elem,data.tr.eo,0,0.01,this);this.data=data;if(!this.dynamicProperties.length){this.getValue(true);}this._isAnimated=!!this.dynamicProperties.length;this.pMatrix=new Matrix();this.rMatrix=new Matrix();this.sMatrix=new Matrix();this.tMatrix=new Matrix();this.matrix=new Matrix();};RepeaterModifier.prototype.applyTransforms=function(pMatrix,rMatrix,sMatrix,transform,perc,inv){var dir=inv?-1:1;var scaleX=transform.s.v[0]+(1-transform.s.v[0])*(1-perc);var scaleY=transform.s.v[1]+(1-transform.s.v[1])*(1-perc);pMatrix.translate(transform.p.v[0]*dir*perc,transform.p.v[1]*dir*perc,transform.p.v[2]);rMatrix.translate(-transform.a.v[0],-transform.a.v[1],transform.a.v[2]);rMatrix.rotate(-transform.r.v*dir*perc);rMatrix.translate(transform.a.v[0],transform.a.v[1],transform.a.v[2]);sMatrix.translate(-transform.a.v[0],-transform.a.v[1],transform.a.v[2]);sMatrix.scale(inv?1/scaleX:scaleX,inv?1/scaleY:scaleY);sMatrix.translate(transform.a.v[0],transform.a.v[1],transform.a.v[2]);};RepeaterModifier.prototype.init=function(elem,arr,pos,elemsData){this.elem=elem;this.arr=arr;this.pos=pos;this.elemsData=elemsData;this._currentCopies=0;this._elements=[];this._groups=[];this.frameId=-1;this.initDynamicPropertyContainer(elem);this.initModifierProperties(elem,arr[pos]);while(pos>0){pos-=1;// this._elements.unshift(arr.splice(pos,1)[0]);
this._elements.unshift(arr[pos]);}if(this.dynamicProperties.length){this.k=true;}else{this.getValue(true);}};RepeaterModifier.prototype.resetElements=function(elements){var i;var len=elements.length;for(i=0;i<len;i+=1){elements[i]._processed=false;if(elements[i].ty==='gr'){this.resetElements(elements[i].it);}}};RepeaterModifier.prototype.cloneElements=function(elements){var newElements=JSON.parse(JSON.stringify(elements));this.resetElements(newElements);return newElements;};RepeaterModifier.prototype.changeGroupRender=function(elements,renderFlag){var i;var len=elements.length;for(i=0;i<len;i+=1){elements[i]._render=renderFlag;if(elements[i].ty==='gr'){this.changeGroupRender(elements[i].it,renderFlag);}}};RepeaterModifier.prototype.processShapes=function(_isFirstFrame){var items;var itemsTransform;var i;var dir;var cont;var hasReloaded=false;if(this._mdf||_isFirstFrame){var copies=Math.ceil(this.c.v);if(this._groups.length<copies){while(this._groups.length<copies){var group={it:this.cloneElements(this._elements),ty:'gr'};group.it.push({a:{a:0,ix:1,k:[0,0]},nm:'Transform',o:{a:0,ix:7,k:100},p:{a:0,ix:2,k:[0,0]},r:{a:1,ix:6,k:[{s:0,e:0,t:0},{s:0,e:0,t:1}]},s:{a:0,ix:3,k:[100,100]},sa:{a:0,ix:5,k:0},sk:{a:0,ix:4,k:0},ty:'tr'});this.arr.splice(0,0,group);this._groups.splice(0,0,group);this._currentCopies+=1;}this.elem.reloadShapes();hasReloaded=true;}cont=0;var renderFlag;for(i=0;i<=this._groups.length-1;i+=1){renderFlag=cont<copies;this._groups[i]._render=renderFlag;this.changeGroupRender(this._groups[i].it,renderFlag);if(!renderFlag){var elems=this.elemsData[i].it;var transformData=elems[elems.length-1];if(transformData.transform.op.v!==0){transformData.transform.op._mdf=true;transformData.transform.op.v=0;}else{transformData.transform.op._mdf=false;}}cont+=1;}this._currentCopies=copies;/// /
var offset=this.o.v;var offsetModulo=offset%1;var roundOffset=offset>0?Math.floor(offset):Math.ceil(offset);var pProps=this.pMatrix.props;var rProps=this.rMatrix.props;var sProps=this.sMatrix.props;this.pMatrix.reset();this.rMatrix.reset();this.sMatrix.reset();this.tMatrix.reset();this.matrix.reset();var iteration=0;if(offset>0){while(iteration<roundOffset){this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,1,false);iteration+=1;}if(offsetModulo){this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,offsetModulo,false);iteration+=offsetModulo;}}else if(offset<0){while(iteration>roundOffset){this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,1,true);iteration-=1;}if(offsetModulo){this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,-offsetModulo,true);iteration-=offsetModulo;}}i=this.data.m===1?0:this._currentCopies-1;dir=this.data.m===1?1:-1;cont=this._currentCopies;var j;var jLen;while(cont){items=this.elemsData[i].it;itemsTransform=items[items.length-1].transform.mProps.v.props;jLen=itemsTransform.length;items[items.length-1].transform.mProps._mdf=true;items[items.length-1].transform.op._mdf=true;items[items.length-1].transform.op.v=this._currentCopies===1?this.so.v:this.so.v+(this.eo.v-this.so.v)*(i/(this._currentCopies-1));if(iteration!==0){if(i!==0&&dir===1||i!==this._currentCopies-1&&dir===-1){this.applyTransforms(this.pMatrix,this.rMatrix,this.sMatrix,this.tr,1,false);}this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);for(j=0;j<jLen;j+=1){itemsTransform[j]=this.matrix.props[j];}this.matrix.reset();}else{this.matrix.reset();for(j=0;j<jLen;j+=1){itemsTransform[j]=this.matrix.props[j];}}iteration+=1;cont-=1;i+=dir;}}else{cont=this._currentCopies;i=0;dir=1;while(cont){items=this.elemsData[i].it;itemsTransform=items[items.length-1].transform.mProps.v.props;items[items.length-1].transform.mProps._mdf=false;items[items.length-1].transform.op._mdf=false;cont-=1;i+=dir;}}return hasReloaded;};RepeaterModifier.prototype.addShape=function(){};function RoundCornersModifier(){}extendPrototype([ShapeModifier],RoundCornersModifier);RoundCornersModifier.prototype.initModifierProperties=function(elem,data){this.getValue=this.processKeys;this.rd=PropertyFactory.getProp(elem,data.r,0,null,this);this._isAnimated=!!this.rd.effectsSequence.length;};RoundCornersModifier.prototype.processPath=function(path,round){var clonedPath=shapePool.newElement();clonedPath.c=path.c;var i;var len=path._length;var currentV;var currentI;var currentO;var closerV;var distance;var newPosPerc;var index=0;var vX;var vY;var oX;var oY;var iX;var iY;for(i=0;i<len;i+=1){currentV=path.v[i];currentO=path.o[i];currentI=path.i[i];if(currentV[0]===currentO[0]&&currentV[1]===currentO[1]&&currentV[0]===currentI[0]&&currentV[1]===currentI[1]){if((i===0||i===len-1)&&!path.c){clonedPath.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);/* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */index+=1;}else{if(i===0){closerV=path.v[len-1];}else{closerV=path.v[i-1];}distance=Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));newPosPerc=distance?Math.min(distance/2,round)/distance:0;iX=currentV[0]+(closerV[0]-currentV[0])*newPosPerc;vX=iX;iY=currentV[1]-(currentV[1]-closerV[1])*newPosPerc;vY=iY;oX=vX-(vX-currentV[0])*roundCorner;oY=vY-(vY-currentV[1])*roundCorner;clonedPath.setTripleAt(vX,vY,oX,oY,iX,iY,index);index+=1;if(i===len-1){closerV=path.v[0];}else{closerV=path.v[i+1];}distance=Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));newPosPerc=distance?Math.min(distance/2,round)/distance:0;oX=currentV[0]+(closerV[0]-currentV[0])*newPosPerc;vX=oX;oY=currentV[1]+(closerV[1]-currentV[1])*newPosPerc;vY=oY;iX=vX-(vX-currentV[0])*roundCorner;iY=vY-(vY-currentV[1])*roundCorner;clonedPath.setTripleAt(vX,vY,oX,oY,iX,iY,index);index+=1;}}else{clonedPath.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);index+=1;}}return clonedPath;};RoundCornersModifier.prototype.processShapes=function(_isFirstFrame){var shapePaths;var i;var len=this.shapes.length;var j;var jLen;var rd=this.rd.v;if(rd!==0){var shapeData;var localShapeCollection;for(i=0;i<len;i+=1){shapeData=this.shapes[i];localShapeCollection=shapeData.localShapeCollection;if(!(!shapeData.shape._mdf&&!this._mdf&&!_isFirstFrame)){localShapeCollection.releaseShapes();shapeData.shape._mdf=true;shapePaths=shapeData.shape.paths.shapes;jLen=shapeData.shape.paths._length;for(j=0;j<jLen;j+=1){localShapeCollection.addShape(this.processPath(shapePaths[j],rd));}}shapeData.shape.paths=shapeData.localShapeCollection;}}if(!this.dynamicProperties.length){this._mdf=false;}};function floatEqual(a,b){return Math.abs(a-b)*100000<=Math.min(Math.abs(a),Math.abs(b));}function floatZero(f){return Math.abs(f)<=0.00001;}function lerp(p0,p1,amount){return p0*(1-amount)+p1*amount;}function lerpPoint(p0,p1,amount){return[lerp(p0[0],p1[0],amount),lerp(p0[1],p1[1],amount)];}function quadRoots(a,b,c){// no root
if(a===0)return[];var s=b*b-4*a*c;// Complex roots
if(s<0)return[];var singleRoot=-b/(2*a);// 1 root
if(s===0)return[singleRoot];var delta=Math.sqrt(s)/(2*a);// 2 roots
return[singleRoot-delta,singleRoot+delta];}function polynomialCoefficients(p0,p1,p2,p3){return[-p0+3*p1-3*p2+p3,3*p0-6*p1+3*p2,-3*p0+3*p1,p0];}function singlePoint(p){return new PolynomialBezier(p,p,p,p,false);}function PolynomialBezier(p0,p1,p2,p3,linearize){if(linearize&&pointEqual(p0,p1)){p1=lerpPoint(p0,p3,1/3);}if(linearize&&pointEqual(p2,p3)){p2=lerpPoint(p0,p3,2/3);}var coeffx=polynomialCoefficients(p0[0],p1[0],p2[0],p3[0]);var coeffy=polynomialCoefficients(p0[1],p1[1],p2[1],p3[1]);this.a=[coeffx[0],coeffy[0]];this.b=[coeffx[1],coeffy[1]];this.c=[coeffx[2],coeffy[2]];this.d=[coeffx[3],coeffy[3]];this.points=[p0,p1,p2,p3];}PolynomialBezier.prototype.point=function(t){return[((this.a[0]*t+this.b[0])*t+this.c[0])*t+this.d[0],((this.a[1]*t+this.b[1])*t+this.c[1])*t+this.d[1]];};PolynomialBezier.prototype.derivative=function(t){return[(3*t*this.a[0]+2*this.b[0])*t+this.c[0],(3*t*this.a[1]+2*this.b[1])*t+this.c[1]];};PolynomialBezier.prototype.tangentAngle=function(t){var p=this.derivative(t);return Math.atan2(p[1],p[0]);};PolynomialBezier.prototype.normalAngle=function(t){var p=this.derivative(t);return Math.atan2(p[0],p[1]);};PolynomialBezier.prototype.inflectionPoints=function(){var denom=this.a[1]*this.b[0]-this.a[0]*this.b[1];if(floatZero(denom))return[];var tcusp=-0.5*(this.a[1]*this.c[0]-this.a[0]*this.c[1])/denom;var square=tcusp*tcusp-1/3*(this.b[1]*this.c[0]-this.b[0]*this.c[1])/denom;if(square<0)return[];var root=Math.sqrt(square);if(floatZero(root)){if(root>0&&root<1)return[tcusp];return[];}return[tcusp-root,tcusp+root].filter(function(r){return r>0&&r<1;});};PolynomialBezier.prototype.split=function(t){if(t<=0)return[singlePoint(this.points[0]),this];if(t>=1)return[this,singlePoint(this.points[this.points.length-1])];var p10=lerpPoint(this.points[0],this.points[1],t);var p11=lerpPoint(this.points[1],this.points[2],t);var p12=lerpPoint(this.points[2],this.points[3],t);var p20=lerpPoint(p10,p11,t);var p21=lerpPoint(p11,p12,t);var p3=lerpPoint(p20,p21,t);return[new PolynomialBezier(this.points[0],p10,p20,p3,true),new PolynomialBezier(p3,p21,p12,this.points[3],true)];};function extrema(bez,comp){var min=bez.points[0][comp];var max=bez.points[bez.points.length-1][comp];if(min>max){var e=max;max=min;min=e;}// Derivative roots to find min/max
var f=quadRoots(3*bez.a[comp],2*bez.b[comp],bez.c[comp]);for(var i=0;i<f.length;i+=1){if(f[i]>0&&f[i]<1){var val=bez.point(f[i])[comp];if(val<min)min=val;else if(val>max)max=val;}}return{min:min,max:max};}PolynomialBezier.prototype.bounds=function(){return{x:extrema(this,0),y:extrema(this,1)};};PolynomialBezier.prototype.boundingBox=function(){var bounds=this.bounds();return{left:bounds.x.min,right:bounds.x.max,top:bounds.y.min,bottom:bounds.y.max,width:bounds.x.max-bounds.x.min,height:bounds.y.max-bounds.y.min,cx:(bounds.x.max+bounds.x.min)/2,cy:(bounds.y.max+bounds.y.min)/2};};function intersectData(bez,t1,t2){var box=bez.boundingBox();return{cx:box.cx,cy:box.cy,width:box.width,height:box.height,bez:bez,t:(t1+t2)/2,t1:t1,t2:t2};}function splitData(data){var split=data.bez.split(0.5);return[intersectData(split[0],data.t1,data.t),intersectData(split[1],data.t,data.t2)];}function boxIntersect(b1,b2){return Math.abs(b1.cx-b2.cx)*2<b1.width+b2.width&&Math.abs(b1.cy-b2.cy)*2<b1.height+b2.height;}function intersectsImpl(d1,d2,depth,tolerance,intersections,maxRecursion){if(!boxIntersect(d1,d2))return;if(depth>=maxRecursion||d1.width<=tolerance&&d1.height<=tolerance&&d2.width<=tolerance&&d2.height<=tolerance){intersections.push([d1.t,d2.t]);return;}var d1s=splitData(d1);var d2s=splitData(d2);intersectsImpl(d1s[0],d2s[0],depth+1,tolerance,intersections,maxRecursion);intersectsImpl(d1s[0],d2s[1],depth+1,tolerance,intersections,maxRecursion);intersectsImpl(d1s[1],d2s[0],depth+1,tolerance,intersections,maxRecursion);intersectsImpl(d1s[1],d2s[1],depth+1,tolerance,intersections,maxRecursion);}PolynomialBezier.prototype.intersections=function(other,tolerance,maxRecursion){if(tolerance===undefined)tolerance=2;if(maxRecursion===undefined)maxRecursion=7;var intersections=[];intersectsImpl(intersectData(this,0,1),intersectData(other,0,1),0,tolerance,intersections,maxRecursion);return intersections;};PolynomialBezier.shapeSegment=function(shapePath,index){var nextIndex=(index+1)%shapePath.length();return new PolynomialBezier(shapePath.v[index],shapePath.o[index],shapePath.i[nextIndex],shapePath.v[nextIndex],true);};PolynomialBezier.shapeSegmentInverted=function(shapePath,index){var nextIndex=(index+1)%shapePath.length();return new PolynomialBezier(shapePath.v[nextIndex],shapePath.i[nextIndex],shapePath.o[index],shapePath.v[index],true);};function crossProduct(a,b){return[a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]];}function lineIntersection(start1,end1,start2,end2){var v1=[start1[0],start1[1],1];var v2=[end1[0],end1[1],1];var v3=[start2[0],start2[1],1];var v4=[end2[0],end2[1],1];var r=crossProduct(crossProduct(v1,v2),crossProduct(v3,v4));if(floatZero(r[2]))return null;return[r[0]/r[2],r[1]/r[2]];}function polarOffset(p,angle,length){return[p[0]+Math.cos(angle)*length,p[1]-Math.sin(angle)*length];}function pointDistance(p1,p2){return Math.hypot(p1[0]-p2[0],p1[1]-p2[1]);}function pointEqual(p1,p2){return floatEqual(p1[0],p2[0])&&floatEqual(p1[1],p2[1]);}function ZigZagModifier(){}extendPrototype([ShapeModifier],ZigZagModifier);ZigZagModifier.prototype.initModifierProperties=function(elem,data){this.getValue=this.processKeys;this.amplitude=PropertyFactory.getProp(elem,data.s,0,null,this);this.frequency=PropertyFactory.getProp(elem,data.r,0,null,this);this.pointsType=PropertyFactory.getProp(elem,data.pt,0,null,this);this._isAnimated=this.amplitude.effectsSequence.length!==0||this.frequency.effectsSequence.length!==0||this.pointsType.effectsSequence.length!==0;};function setPoint(outputBezier,point,angle,direction,amplitude,outAmplitude,inAmplitude){var angO=angle-Math.PI/2;var angI=angle+Math.PI/2;var px=point[0]+Math.cos(angle)*direction*amplitude;var py=point[1]-Math.sin(angle)*direction*amplitude;outputBezier.setTripleAt(px,py,px+Math.cos(angO)*outAmplitude,py-Math.sin(angO)*outAmplitude,px+Math.cos(angI)*inAmplitude,py-Math.sin(angI)*inAmplitude,outputBezier.length());}function getPerpendicularVector(pt1,pt2){var vector=[pt2[0]-pt1[0],pt2[1]-pt1[1]];var rot=-Math.PI*0.5;var rotatedVector=[Math.cos(rot)*vector[0]-Math.sin(rot)*vector[1],Math.sin(rot)*vector[0]+Math.cos(rot)*vector[1]];return rotatedVector;}function getProjectingAngle(path,cur){var prevIndex=cur===0?path.length()-1:cur-1;var nextIndex=(cur+1)%path.length();var prevPoint=path.v[prevIndex];var nextPoint=path.v[nextIndex];var pVector=getPerpendicularVector(prevPoint,nextPoint);return Math.atan2(0,1)-Math.atan2(pVector[1],pVector[0]);}function zigZagCorner(outputBezier,path,cur,amplitude,frequency,pointType,direction){var angle=getProjectingAngle(path,cur);var point=path.v[cur%path._length];var prevPoint=path.v[cur===0?path._length-1:cur-1];var nextPoint=path.v[(cur+1)%path._length];var prevDist=pointType===2?Math.sqrt(Math.pow(point[0]-prevPoint[0],2)+Math.pow(point[1]-prevPoint[1],2)):0;var nextDist=pointType===2?Math.sqrt(Math.pow(point[0]-nextPoint[0],2)+Math.pow(point[1]-nextPoint[1],2)):0;setPoint(outputBezier,path.v[cur%path._length],angle,direction,amplitude,nextDist/((frequency+1)*2),prevDist/((frequency+1)*2),pointType);}function zigZagSegment(outputBezier,segment,amplitude,frequency,pointType,direction){for(var i=0;i<frequency;i+=1){var t=(i+1)/(frequency+1);var dist=pointType===2?Math.sqrt(Math.pow(segment.points[3][0]-segment.points[0][0],2)+Math.pow(segment.points[3][1]-segment.points[0][1],2)):0;var angle=segment.normalAngle(t);var point=segment.point(t);setPoint(outputBezier,point,angle,direction,amplitude,dist/((frequency+1)*2),dist/((frequency+1)*2),pointType);direction=-direction;}return direction;}ZigZagModifier.prototype.processPath=function(path,amplitude,frequency,pointType){var count=path._length;var clonedPath=shapePool.newElement();clonedPath.c=path.c;if(!path.c){count-=1;}if(count===0)return clonedPath;var direction=-1;var segment=PolynomialBezier.shapeSegment(path,0);zigZagCorner(clonedPath,path,0,amplitude,frequency,pointType,direction);for(var i=0;i<count;i+=1){direction=zigZagSegment(clonedPath,segment,amplitude,frequency,pointType,-direction);if(i===count-1&&!path.c){segment=null;}else{segment=PolynomialBezier.shapeSegment(path,(i+1)%count);}zigZagCorner(clonedPath,path,i+1,amplitude,frequency,pointType,direction);}return clonedPath;};ZigZagModifier.prototype.processShapes=function(_isFirstFrame){var shapePaths;var i;var len=this.shapes.length;var j;var jLen;var amplitude=this.amplitude.v;var frequency=Math.max(0,Math.round(this.frequency.v));var pointType=this.pointsType.v;if(amplitude!==0){var shapeData;var localShapeCollection;for(i=0;i<len;i+=1){shapeData=this.shapes[i];localShapeCollection=shapeData.localShapeCollection;if(!(!shapeData.shape._mdf&&!this._mdf&&!_isFirstFrame)){localShapeCollection.releaseShapes();shapeData.shape._mdf=true;shapePaths=shapeData.shape.paths.shapes;jLen=shapeData.shape.paths._length;for(j=0;j<jLen;j+=1){localShapeCollection.addShape(this.processPath(shapePaths[j],amplitude,frequency,pointType));}}shapeData.shape.paths=shapeData.localShapeCollection;}}if(!this.dynamicProperties.length){this._mdf=false;}};function linearOffset(p1,p2,amount){var angle=Math.atan2(p2[0]-p1[0],p2[1]-p1[1]);return[polarOffset(p1,angle,amount),polarOffset(p2,angle,amount)];}function offsetSegment(segment,amount){var p0;var p1a;var p1b;var p2b;var p2a;var p3;var e;e=linearOffset(segment.points[0],segment.points[1],amount);p0=e[0];p1a=e[1];e=linearOffset(segment.points[1],segment.points[2],amount);p1b=e[0];p2b=e[1];e=linearOffset(segment.points[2],segment.points[3],amount);p2a=e[0];p3=e[1];var p1=lineIntersection(p0,p1a,p1b,p2b);if(p1===null)p1=p1a;var p2=lineIntersection(p2a,p3,p1b,p2b);if(p2===null)p2=p2a;return new PolynomialBezier(p0,p1,p2,p3);}function joinLines(outputBezier,seg1,seg2,lineJoin,miterLimit){var p0=seg1.points[3];var p1=seg2.points[0];// Bevel
if(lineJoin===3)return p0;// Connected, they don't need a joint
if(pointEqual(p0,p1))return p0;// Round
if(lineJoin===2){var angleOut=-seg1.tangentAngle(1);var angleIn=-seg2.tangentAngle(0)+Math.PI;var center=lineIntersection(p0,polarOffset(p0,angleOut+Math.PI/2,100),p1,polarOffset(p1,angleOut+Math.PI/2,100));var radius=center?pointDistance(center,p0):pointDistance(p0,p1)/2;var tan=polarOffset(p0,angleOut,2*radius*roundCorner);outputBezier.setXYAt(tan[0],tan[1],'o',outputBezier.length()-1);tan=polarOffset(p1,angleIn,2*radius*roundCorner);outputBezier.setTripleAt(p1[0],p1[1],p1[0],p1[1],tan[0],tan[1],outputBezier.length());return p1;}// Miter
var t0=pointEqual(p0,seg1.points[2])?seg1.points[0]:seg1.points[2];var t1=pointEqual(p1,seg2.points[1])?seg2.points[3]:seg2.points[1];var intersection=lineIntersection(t0,p0,p1,t1);if(intersection&&pointDistance(intersection,p0)<miterLimit){outputBezier.setTripleAt(intersection[0],intersection[1],intersection[0],intersection[1],intersection[0],intersection[1],outputBezier.length());return intersection;}return p0;}function getIntersection(a,b){var intersect=a.intersections(b);if(intersect.length&&floatEqual(intersect[0][0],1))intersect.shift();if(intersect.length)return intersect[0];return null;}function pruneSegmentIntersection(a,b){var outa=a.slice();var outb=b.slice();var intersect=getIntersection(a[a.length-1],b[0]);if(intersect){outa[a.length-1]=a[a.length-1].split(intersect[0])[0];outb[0]=b[0].split(intersect[1])[1];}if(a.length>1&&b.length>1){intersect=getIntersection(a[0],b[b.length-1]);if(intersect){return[[a[0].split(intersect[0])[0]],[b[b.length-1].split(intersect[1])[1]]];}}return[outa,outb];}function pruneIntersections(segments){var e;for(var i=1;i<segments.length;i+=1){e=pruneSegmentIntersection(segments[i-1],segments[i]);segments[i-1]=e[0];segments[i]=e[1];}if(segments.length>1){e=pruneSegmentIntersection(segments[segments.length-1],segments[0]);segments[segments.length-1]=e[0];segments[0]=e[1];}return segments;}function offsetSegmentSplit(segment,amount){/*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */var flex=segment.inflectionPoints();var left;var right;var split;var mid;if(flex.length===0){return[offsetSegment(segment,amount)];}if(flex.length===1||floatEqual(flex[1],1)){split=segment.split(flex[0]);left=split[0];right=split[1];return[offsetSegment(left,amount),offsetSegment(right,amount)];}split=segment.split(flex[0]);left=split[0];var t=(flex[1]-flex[0])/(1-flex[0]);split=split[1].split(t);mid=split[0];right=split[1];return[offsetSegment(left,amount),offsetSegment(mid,amount),offsetSegment(right,amount)];}function OffsetPathModifier(){}extendPrototype([ShapeModifier],OffsetPathModifier);OffsetPathModifier.prototype.initModifierProperties=function(elem,data){this.getValue=this.processKeys;this.amount=PropertyFactory.getProp(elem,data.a,0,null,this);this.miterLimit=PropertyFactory.getProp(elem,data.ml,0,null,this);this.lineJoin=data.lj;this._isAnimated=this.amount.effectsSequence.length!==0;};OffsetPathModifier.prototype.processPath=function(inputBezier,amount,lineJoin,miterLimit){var outputBezier=shapePool.newElement();outputBezier.c=inputBezier.c;var count=inputBezier.length();if(!inputBezier.c){count-=1;}var i;var j;var segment;var multiSegments=[];for(i=0;i<count;i+=1){segment=PolynomialBezier.shapeSegment(inputBezier,i);multiSegments.push(offsetSegmentSplit(segment,amount));}if(!inputBezier.c){for(i=count-1;i>=0;i-=1){segment=PolynomialBezier.shapeSegmentInverted(inputBezier,i);multiSegments.push(offsetSegmentSplit(segment,amount));}}multiSegments=pruneIntersections(multiSegments);// Add bezier segments to the output and apply line joints
var lastPoint=null;var lastSeg=null;for(i=0;i<multiSegments.length;i+=1){var multiSegment=multiSegments[i];if(lastSeg)lastPoint=joinLines(outputBezier,lastSeg,multiSegment[0],lineJoin,miterLimit);lastSeg=multiSegment[multiSegment.length-1];for(j=0;j<multiSegment.length;j+=1){segment=multiSegment[j];if(lastPoint&&pointEqual(segment.points[0],lastPoint)){outputBezier.setXYAt(segment.points[1][0],segment.points[1][1],'o',outputBezier.length()-1);}else{outputBezier.setTripleAt(segment.points[0][0],segment.points[0][1],segment.points[1][0],segment.points[1][1],segment.points[0][0],segment.points[0][1],outputBezier.length());}outputBezier.setTripleAt(segment.points[3][0],segment.points[3][1],segment.points[3][0],segment.points[3][1],segment.points[2][0],segment.points[2][1],outputBezier.length());lastPoint=segment.points[3];}}if(multiSegments.length)joinLines(outputBezier,lastSeg,multiSegments[0][0],lineJoin,miterLimit);return outputBezier;};OffsetPathModifier.prototype.processShapes=function(_isFirstFrame){var shapePaths;var i;var len=this.shapes.length;var j;var jLen;var amount=this.amount.v;var miterLimit=this.miterLimit.v;var lineJoin=this.lineJoin;if(amount!==0){var shapeData;var localShapeCollection;for(i=0;i<len;i+=1){shapeData=this.shapes[i];localShapeCollection=shapeData.localShapeCollection;if(!(!shapeData.shape._mdf&&!this._mdf&&!_isFirstFrame)){localShapeCollection.releaseShapes();shapeData.shape._mdf=true;shapePaths=shapeData.shape.paths.shapes;jLen=shapeData.shape.paths._length;for(j=0;j<jLen;j+=1){localShapeCollection.addShape(this.processPath(shapePaths[j],amount,lineJoin,miterLimit));}}shapeData.shape.paths=shapeData.localShapeCollection;}}if(!this.dynamicProperties.length){this._mdf=false;}};function getFontProperties(fontData){var styles=fontData.fStyle?fontData.fStyle.split(' '):[];var fWeight='normal';var fStyle='normal';var len=styles.length;var styleName;for(var i=0;i<len;i+=1){styleName=styles[i].toLowerCase();switch(styleName){case'italic':fStyle='italic';break;case'bold':fWeight='700';break;case'black':fWeight='900';break;case'medium':fWeight='500';break;case'regular':case'normal':fWeight='400';break;case'light':case'thin':fWeight='200';break;default:break;}}return{style:fStyle,weight:fontData.fWeight||fWeight};}var FontManager=function(){var maxWaitingTime=5000;var emptyChar={w:0,size:0,shapes:[],data:{shapes:[]}};var combinedCharacters=[];// Hindi characters
combinedCharacters=combinedCharacters.concat([2304,2305,2306,2307,2362,2363,2364,2364,2366,2367,2368,2369,2370,2371,2372,2373,2374,2375,2376,2377,2378,2379,2380,2381,2382,2383,2387,2388,2389,2390,2391,2402,2403]);var BLACK_FLAG_CODE_POINT=127988;var CANCEL_TAG_CODE_POINT=917631;var A_TAG_CODE_POINT=917601;var Z_TAG_CODE_POINT=917626;var VARIATION_SELECTOR_16_CODE_POINT=65039;var ZERO_WIDTH_JOINER_CODE_POINT=8205;var REGIONAL_CHARACTER_A_CODE_POINT=127462;var REGIONAL_CHARACTER_Z_CODE_POINT=127487;var surrogateModifiers=['d83cdffb','d83cdffc','d83cdffd','d83cdffe','d83cdfff'];function trimFontOptions(font){var familyArray=font.split(',');var i;var len=familyArray.length;var enabledFamilies=[];for(i=0;i<len;i+=1){if(familyArray[i]!=='sans-serif'&&familyArray[i]!=='monospace'){enabledFamilies.push(familyArray[i]);}}return enabledFamilies.join(',');}function setUpNode(font,family){var parentNode=createTag('span');// Node is invisible to screen readers.
parentNode.setAttribute('aria-hidden',true);parentNode.style.fontFamily=family;var node=createTag('span');// Characters that vary significantly among different fonts
node.innerText='giItT1WQy@!-/#';// Visible - so we can measure it - but not on the screen
parentNode.style.position='absolute';parentNode.style.left='-10000px';parentNode.style.top='-10000px';// Large font size makes even subtle changes obvious
parentNode.style.fontSize='300px';// Reset any font properties
parentNode.style.fontVariant='normal';parentNode.style.fontStyle='normal';parentNode.style.fontWeight='normal';parentNode.style.letterSpacing='0';parentNode.appendChild(node);document.body.appendChild(parentNode);// Remember width with no applied web font
var width=node.offsetWidth;node.style.fontFamily=trimFontOptions(font)+', '+family;return{node:node,w:width,parent:parentNode};}function checkLoadedFonts(){var i;var len=this.fonts.length;var node;var w;var loadedCount=len;for(i=0;i<len;i+=1){if(this.fonts[i].loaded){loadedCount-=1;}else if(this.fonts[i].fOrigin==='n'||this.fonts[i].origin===0){this.fonts[i].loaded=true;}else{node=this.fonts[i].monoCase.node;w=this.fonts[i].monoCase.w;if(node.offsetWidth!==w){loadedCount-=1;this.fonts[i].loaded=true;}else{node=this.fonts[i].sansCase.node;w=this.fonts[i].sansCase.w;if(node.offsetWidth!==w){loadedCount-=1;this.fonts[i].loaded=true;}}if(this.fonts[i].loaded){this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);}}}if(loadedCount!==0&&Date.now()-this.initTime<maxWaitingTime){setTimeout(this.checkLoadedFontsBinded,20);}else{setTimeout(this.setIsLoadedBinded,10);}}function createHelper(fontData,def){var engine=document.body&&def?'svg':'canvas';var helper;var fontProps=getFontProperties(fontData);if(engine==='svg'){var tHelper=createNS('text');tHelper.style.fontSize='100px';// tHelper.style.fontFamily = fontData.fFamily;
tHelper.setAttribute('font-family',fontData.fFamily);tHelper.setAttribute('font-style',fontProps.style);tHelper.setAttribute('font-weight',fontProps.weight);tHelper.textContent='1';if(fontData.fClass){tHelper.style.fontFamily='inherit';tHelper.setAttribute('class',fontData.fClass);}else{tHelper.style.fontFamily=fontData.fFamily;}def.appendChild(tHelper);helper=tHelper;}else{var tCanvasHelper=new OffscreenCanvas(500,500).getContext('2d');tCanvasHelper.font=fontProps.style+' '+fontProps.weight+' 100px '+fontData.fFamily;helper=tCanvasHelper;}function measure(text){if(engine==='svg'){helper.textContent=text;return helper.getComputedTextLength();}return helper.measureText(text).width;}return{measureText:measure};}function addFonts(fontData,defs){if(!fontData){this.isLoaded=true;return;}if(this.chars){this.isLoaded=true;this.fonts=fontData.list;return;}if(!document.body){this.isLoaded=true;fontData.list.forEach(function(data){data.helper=createHelper(data);data.cache={};});this.fonts=fontData.list;return;}var fontArr=fontData.list;var i;var len=fontArr.length;var _pendingFonts=len;for(i=0;i<len;i+=1){var shouldLoadFont=true;var loadedSelector;var j;fontArr[i].loaded=false;fontArr[i].monoCase=setUpNode(fontArr[i].fFamily,'monospace');fontArr[i].sansCase=setUpNode(fontArr[i].fFamily,'sans-serif');if(!fontArr[i].fPath){fontArr[i].loaded=true;_pendingFonts-=1;}else if(fontArr[i].fOrigin==='p'||fontArr[i].origin===3){loadedSelector=document.querySelectorAll('style[f-forigin="p"][f-family="'+fontArr[i].fFamily+'"], style[f-origin="3"][f-family="'+fontArr[i].fFamily+'"]');if(loadedSelector.length>0){shouldLoadFont=false;}if(shouldLoadFont){var s=createTag('style');s.setAttribute('f-forigin',fontArr[i].fOrigin);s.setAttribute('f-origin',fontArr[i].origin);s.setAttribute('f-family',fontArr[i].fFamily);s.type='text/css';s.innerText='@font-face {font-family: '+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";defs.appendChild(s);}}else if(fontArr[i].fOrigin==='g'||fontArr[i].origin===1){loadedSelector=document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');for(j=0;j<loadedSelector.length;j+=1){if(loadedSelector[j].href.indexOf(fontArr[i].fPath)!==-1){// Font is already loaded
shouldLoadFont=false;}}if(shouldLoadFont){var l=createTag('link');l.setAttribute('f-forigin',fontArr[i].fOrigin);l.setAttribute('f-origin',fontArr[i].origin);l.type='text/css';l.rel='stylesheet';l.href=fontArr[i].fPath;document.body.appendChild(l);}}else if(fontArr[i].fOrigin==='t'||fontArr[i].origin===2){loadedSelector=document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');for(j=0;j<loadedSelector.length;j+=1){if(fontArr[i].fPath===loadedSelector[j].src){// Font is already loaded
shouldLoadFont=false;}}if(shouldLoadFont){var sc=createTag('link');sc.setAttribute('f-forigin',fontArr[i].fOrigin);sc.setAttribute('f-origin',fontArr[i].origin);sc.setAttribute('rel','stylesheet');sc.setAttribute('href',fontArr[i].fPath);defs.appendChild(sc);}}fontArr[i].helper=createHelper(fontArr[i],defs);fontArr[i].cache={};this.fonts.push(fontArr[i]);}if(_pendingFonts===0){this.isLoaded=true;}else{// On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
// Adding this timeout seems to fix it
setTimeout(this.checkLoadedFonts.bind(this),100);}}function addChars(chars){if(!chars){return;}if(!this.chars){this.chars=[];}var i;var len=chars.length;var j;var jLen=this.chars.length;var found;for(i=0;i<len;i+=1){j=0;found=false;while(j<jLen){if(this.chars[j].style===chars[i].style&&this.chars[j].fFamily===chars[i].fFamily&&this.chars[j].ch===chars[i].ch){found=true;}j+=1;}if(!found){this.chars.push(chars[i]);jLen+=1;}}}function getCharData(_char,style,font){var i=0;var len=this.chars.length;while(i<len){if(this.chars[i].ch===_char&&this.chars[i].style===style&&this.chars[i].fFamily===font){return this.chars[i];}i+=1;}if((typeof _char==='string'&&_char.charCodeAt(0)!==13||!_char)&&console&&console.warn// eslint-disable-line no-console
&&!this._warned){this._warned=true;console.warn('Missing character from exported characters list: ',_char,style,font);// eslint-disable-line no-console
}return emptyChar;}function measureText(_char2,fontName,size){var fontData=this.getFontByName(fontName);// Using the char instead of char.charCodeAt(0)
// to avoid collisions between equal chars
var index=_char2;if(!fontData.cache[index]){var tHelper=fontData.helper;if(_char2===' '){var doubleSize=tHelper.measureText('|'+_char2+'|');var singleSize=tHelper.measureText('||');fontData.cache[index]=(doubleSize-singleSize)/100;}else{fontData.cache[index]=tHelper.measureText(_char2)/100;}}return fontData.cache[index]*size;}function getFontByName(name){var i=0;var len=this.fonts.length;while(i<len){if(this.fonts[i].fName===name){return this.fonts[i];}i+=1;}return this.fonts[0];}function getCodePoint(string){var codePoint=0;var first=string.charCodeAt(0);if(first>=0xD800&&first<=0xDBFF){var second=string.charCodeAt(1);if(second>=0xDC00&&second<=0xDFFF){codePoint=(first-0xD800)*0x400+second-0xDC00+0x10000;}}return codePoint;}// Skin tone modifiers
function isModifier(firstCharCode,secondCharCode){var sum=firstCharCode.toString(16)+secondCharCode.toString(16);return surrogateModifiers.indexOf(sum)!==-1;}function isZeroWidthJoiner(charCode){return charCode===ZERO_WIDTH_JOINER_CODE_POINT;}// This codepoint may change the appearance of the preceding character.
// If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
// as a colorful image as compared to a monochrome text variant.
function isVariationSelector(charCode){return charCode===VARIATION_SELECTOR_16_CODE_POINT;}// The regional indicator symbols are a set of 26 alphabetic Unicode
/// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
// two-letter country codes in a way that allows optional special treatment.
function isRegionalCode(string){var codePoint=getCodePoint(string);if(codePoint>=REGIONAL_CHARACTER_A_CODE_POINT&&codePoint<=REGIONAL_CHARACTER_Z_CODE_POINT){return true;}return false;}// Some Emoji implementations represent combinations of
// two “regional indicator” letters as a single flag symbol.
function isFlagEmoji(string){return isRegionalCode(string.substr(0,2))&&isRegionalCode(string.substr(2,2));}function isCombinedCharacter(_char3){return combinedCharacters.indexOf(_char3)!==-1;}// Regional flags start with a BLACK_FLAG_CODE_POINT
// folowed by 5 chars in the TAG range
// and end with a CANCEL_TAG_CODE_POINT
function isRegionalFlag(text,index){var codePoint=getCodePoint(text.substr(index,2));if(codePoint!==BLACK_FLAG_CODE_POINT){return false;}var count=0;index+=2;while(count<5){codePoint=getCodePoint(text.substr(index,2));if(codePoint<A_TAG_CODE_POINT||codePoint>Z_TAG_CODE_POINT){return false;}count+=1;index+=2;}return getCodePoint(text.substr(index,2))===CANCEL_TAG_CODE_POINT;}function setIsLoaded(){this.isLoaded=true;}var Font=function Font(){this.fonts=[];this.chars=null;this.typekitLoaded=0;this.isLoaded=false;this._warned=false;this.initTime=Date.now();this.setIsLoadedBinded=this.setIsLoaded.bind(this);this.checkLoadedFontsBinded=this.checkLoadedFonts.bind(this);};Font.isModifier=isModifier;Font.isZeroWidthJoiner=isZeroWidthJoiner;Font.isFlagEmoji=isFlagEmoji;Font.isRegionalCode=isRegionalCode;Font.isCombinedCharacter=isCombinedCharacter;Font.isRegionalFlag=isRegionalFlag;Font.isVariationSelector=isVariationSelector;Font.BLACK_FLAG_CODE_POINT=BLACK_FLAG_CODE_POINT;var fontPrototype={addChars:addChars,addFonts:addFonts,getCharData:getCharData,getFontByName:getFontByName,measureText:measureText,checkLoadedFonts:checkLoadedFonts,setIsLoaded:setIsLoaded};Font.prototype=fontPrototype;return Font;}();function SlotManager(animationData){this.animationData=animationData;}SlotManager.prototype.getProp=function(data){if(this.animationData.slots&&this.animationData.slots[data.sid]){return Object.assign(data,this.animationData.slots[data.sid].p);}return data;};function slotFactory(animationData){return new SlotManager(animationData);}function RenderableElement(){}RenderableElement.prototype={initRenderable:function initRenderable(){// layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
this.isInRange=false;// layer's display state
this.hidden=false;// If layer's transparency equals 0, it can be hidden
this.isTransparent=false;// list of animated components
this.renderableComponents=[];},addRenderableComponent:function addRenderableComponent(component){if(this.renderableComponents.indexOf(component)===-1){this.renderableComponents.push(component);}},removeRenderableComponent:function removeRenderableComponent(component){if(this.renderableComponents.indexOf(component)!==-1){this.renderableComponents.splice(this.renderableComponents.indexOf(component),1);}},prepareRenderableFrame:function prepareRenderableFrame(num){this.checkLayerLimits(num);},checkTransparency:function checkTransparency(){if(this.finalTransform.mProp.o.v<=0){if(!this.isTransparent&&this.globalData.renderConfig.hideOnTransparent){this.isTransparent=true;this.hide();}}else if(this.isTransparent){this.isTransparent=false;this.show();}},/**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */checkLayerLimits:function checkLayerLimits(num){if(this.data.ip-this.data.st<=num&&this.data.op-this.data.st>num){if(this.isInRange!==true){this.globalData._mdf=true;this._mdf=true;this.isInRange=true;this.show();}}else if(this.isInRange!==false){this.globalData._mdf=true;this.isInRange=false;this.hide();}},renderRenderable:function renderRenderable(){var i;var len=this.renderableComponents.length;for(i=0;i<len;i+=1){this.renderableComponents[i].renderFrame(this._isFirstFrame);}/* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */},sourceRectAtTime:function sourceRectAtTime(){return{top:0,left:0,width:100,height:100};},getLayerSize:function getLayerSize(){if(this.data.ty===5){return{w:this.data.textData.width,h:this.data.textData.height};}return{w:this.data.width,h:this.data.height};}};var getBlendMode=function(){var blendModeEnums={0:'source-over',1:'multiply',2:'screen',3:'overlay',4:'darken',5:'lighten',6:'color-dodge',7:'color-burn',8:'hard-light',9:'soft-light',10:'difference',11:'exclusion',12:'hue',13:'saturation',14:'color',15:'luminosity'};return function(mode){return blendModeEnums[mode]||'';};}();function SliderEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,0,0,container);}function AngleEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,0,0,container);}function ColorEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,1,0,container);}function PointEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,1,0,container);}function LayerIndexEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,0,0,container);}function MaskIndexEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,0,0,container);}function CheckboxEffect(data,elem,container){this.p=PropertyFactory.getProp(elem,data.v,0,0,container);}function NoValueEffect(){this.p={};}function EffectsManager(data,element){var effects=data.ef||[];this.effectElements=[];var i;var len=effects.length;var effectItem;for(i=0;i<len;i+=1){effectItem=new GroupEffect(effects[i],element);this.effectElements.push(effectItem);}}function GroupEffect(data,element){this.init(data,element);}extendPrototype([DynamicPropertyContainer],GroupEffect);GroupEffect.prototype.getValue=GroupEffect.prototype.iterateDynamicProperties;GroupEffect.prototype.init=function(data,element){this.data=data;this.effectElements=[];this.initDynamicPropertyContainer(element);var i;var len=this.data.ef.length;var eff;var effects=this.data.ef;for(i=0;i<len;i+=1){eff=null;switch(effects[i].ty){case 0:eff=new SliderEffect(effects[i],element,this);break;case 1:eff=new AngleEffect(effects[i],element,this);break;case 2:eff=new ColorEffect(effects[i],element,this);break;case 3:eff=new PointEffect(effects[i],element,this);break;case 4:case 7:eff=new CheckboxEffect(effects[i],element,this);break;case 10:eff=new LayerIndexEffect(effects[i],element,this);break;case 11:eff=new MaskIndexEffect(effects[i],element,this);break;case 5:eff=new EffectsManager(effects[i],element,this);break;// case 6:
default:eff=new NoValueEffect(effects[i],element,this);break;}if(eff){this.effectElements.push(eff);}}};function BaseElement(){}BaseElement.prototype={checkMasks:function checkMasks(){if(!this.data.hasMask){return false;}var i=0;var len=this.data.masksProperties.length;while(i<len){if(this.data.masksProperties[i].mode!=='n'&&this.data.masksProperties[i].cl!==false){return true;}i+=1;}return false;},initExpressions:function initExpressions(){var expressionsInterfaces=getExpressionInterfaces();if(!expressionsInterfaces){return;}var LayerExpressionInterface=expressionsInterfaces('layer');var EffectsExpressionInterface=expressionsInterfaces('effects');var ShapeExpressionInterface=expressionsInterfaces('shape');var TextExpressionInterface=expressionsInterfaces('text');var CompExpressionInterface=expressionsInterfaces('comp');this.layerInterface=LayerExpressionInterface(this);if(this.data.hasMask&&this.maskManager){this.layerInterface.registerMaskInterface(this.maskManager);}var effectsInterface=EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);this.layerInterface.registerEffectsInterface(effectsInterface);if(this.data.ty===0||this.data.xt){this.compInterface=CompExpressionInterface(this);}else if(this.data.ty===4){this.layerInterface.shapeInterface=ShapeExpressionInterface(this.shapesData,this.itemsData,this.layerInterface);this.layerInterface.content=this.layerInterface.shapeInterface;}else if(this.data.ty===5){this.layerInterface.textInterface=TextExpressionInterface(this);this.layerInterface.text=this.layerInterface.textInterface;}},setBlendMode:function setBlendMode(){var blendModeValue=getBlendMode(this.data.bm);var elem=this.baseElement||this.layerElement;elem.style['mix-blend-mode']=blendModeValue;},initBaseData:function initBaseData(data,globalData,comp){this.globalData=globalData;this.comp=comp;this.data=data;this.layerId=createElementID();// Stretch factor for old animations missing this property.
if(!this.data.sr){this.data.sr=1;}// effects manager
this.effectsManager=new EffectsManager(this.data,this,this.dynamicProperties);},getType:function getType(){return this.type;},sourceRectAtTime:function sourceRectAtTime(){}};/**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */function FrameElement(){}FrameElement.prototype={/**
       * @function
       * Initializes frame related properties.
       *
       */initFrame:function initFrame(){// set to true when inpoint is rendered
this._isFirstFrame=false;// list of animated properties
this.dynamicProperties=[];// If layer has been modified in current tick this will be true
this._mdf=false;},/**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */prepareProperties:function prepareProperties(num,isVisible){var i;var len=this.dynamicProperties.length;for(i=0;i<len;i+=1){if(isVisible||this._isParent&&this.dynamicProperties[i].propType==='transform'){this.dynamicProperties[i].getValue();if(this.dynamicProperties[i]._mdf){this.globalData._mdf=true;this._mdf=true;}}}},addDynamicProperty:function addDynamicProperty(prop){if(this.dynamicProperties.indexOf(prop)===-1){this.dynamicProperties.push(prop);}}};function FootageElement(data,globalData,comp){this.initFrame();this.initRenderable();this.assetData=globalData.getAssetData(data.refId);this.footageData=globalData.imageLoader.getAsset(this.assetData);this.initBaseData(data,globalData,comp);}FootageElement.prototype.prepareFrame=function(){};extendPrototype([RenderableElement,BaseElement,FrameElement],FootageElement);FootageElement.prototype.getBaseElement=function(){return null;};FootageElement.prototype.renderFrame=function(){};FootageElement.prototype.destroy=function(){};FootageElement.prototype.initExpressions=function(){var expressionsInterfaces=getExpressionInterfaces();if(!expressionsInterfaces){return;}var FootageInterface=expressionsInterfaces('footage');this.layerInterface=FootageInterface(this);};FootageElement.prototype.getFootageData=function(){return this.footageData;};function AudioElement(data,globalData,comp){this.initFrame();this.initRenderable();this.assetData=globalData.getAssetData(data.refId);this.initBaseData(data,globalData,comp);this._isPlaying=false;this._canPlay=false;var assetPath=this.globalData.getAssetsPath(this.assetData);this.audio=this.globalData.audioController.createAudio(assetPath);this._currentTime=0;this.globalData.audioController.addAudio(this);this._volumeMultiplier=1;this._volume=1;this._previousVolume=null;this.tm=data.tm?PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this):{_placeholder:true};this.lv=PropertyFactory.getProp(this,data.au&&data.au.lv?data.au.lv:{k:[100]},1,0.01,this);}AudioElement.prototype.prepareFrame=function(num){this.prepareRenderableFrame(num,true);this.prepareProperties(num,true);if(!this.tm._placeholder){var timeRemapped=this.tm.v;this._currentTime=timeRemapped;}else{this._currentTime=num/this.data.sr;}this._volume=this.lv.v[0];var totalVolume=this._volume*this._volumeMultiplier;if(this._previousVolume!==totalVolume){this._previousVolume=totalVolume;this.audio.volume(totalVolume);}};extendPrototype([RenderableElement,BaseElement,FrameElement],AudioElement);AudioElement.prototype.renderFrame=function(){if(this.isInRange&&this._canPlay){if(!this._isPlaying){this.audio.play();this.audio.seek(this._currentTime/this.globalData.frameRate);this._isPlaying=true;}else if(!this.audio.playing()||Math.abs(this._currentTime/this.globalData.frameRate-this.audio.seek())>0.1){this.audio.seek(this._currentTime/this.globalData.frameRate);}}};AudioElement.prototype.show=function(){// this.audio.play()
};AudioElement.prototype.hide=function(){this.audio.pause();this._isPlaying=false;};AudioElement.prototype.pause=function(){this.audio.pause();this._isPlaying=false;this._canPlay=false;};AudioElement.prototype.resume=function(){this._canPlay=true;};AudioElement.prototype.setRate=function(rateValue){this.audio.rate(rateValue);};AudioElement.prototype.volume=function(volumeValue){this._volumeMultiplier=volumeValue;this._previousVolume=volumeValue*this._volume;this.audio.volume(this._previousVolume);};AudioElement.prototype.getBaseElement=function(){return null;};AudioElement.prototype.destroy=function(){};AudioElement.prototype.sourceRectAtTime=function(){};AudioElement.prototype.initExpressions=function(){};function BaseRenderer(){}BaseRenderer.prototype.checkLayers=function(num){var i;var len=this.layers.length;var data;this.completeLayers=true;for(i=len-1;i>=0;i-=1){if(!this.elements[i]){data=this.layers[i];if(data.ip-data.st<=num-this.layers[i].st&&data.op-data.st>num-this.layers[i].st){this.buildItem(i);}}this.completeLayers=this.elements[i]?this.completeLayers:false;}this.checkPendingElements();};BaseRenderer.prototype.createItem=function(layer){switch(layer.ty){case 2:return this.createImage(layer);case 0:return this.createComp(layer);case 1:return this.createSolid(layer);case 3:return this.createNull(layer);case 4:return this.createShape(layer);case 5:return this.createText(layer);case 6:return this.createAudio(layer);case 13:return this.createCamera(layer);case 15:return this.createFootage(layer);default:return this.createNull(layer);}};BaseRenderer.prototype.createCamera=function(){throw new Error('You\'re using a 3d camera. Try the html renderer.');};BaseRenderer.prototype.createAudio=function(data){return new AudioElement(data,this.globalData,this);};BaseRenderer.prototype.createFootage=function(data){return new FootageElement(data,this.globalData,this);};BaseRenderer.prototype.buildAllItems=function(){var i;var len=this.layers.length;for(i=0;i<len;i+=1){this.buildItem(i);}this.checkPendingElements();};BaseRenderer.prototype.includeLayers=function(newLayers){this.completeLayers=false;var i;var len=newLayers.length;var j;var jLen=this.layers.length;for(i=0;i<len;i+=1){j=0;while(j<jLen){if(this.layers[j].id===newLayers[i].id){this.layers[j]=newLayers[i];break;}j+=1;}}};BaseRenderer.prototype.setProjectInterface=function(pInterface){this.globalData.projectInterface=pInterface;};BaseRenderer.prototype.initItems=function(){if(!this.globalData.progressiveLoad){this.buildAllItems();}};BaseRenderer.prototype.buildElementParenting=function(element,parentName,hierarchy){var elements=this.elements;var layers=this.layers;var i=0;var len=layers.length;while(i<len){if(layers[i].ind==parentName){// eslint-disable-line eqeqeq
if(!elements[i]||elements[i]===true){this.buildItem(i);this.addPendingElement(element);}else{hierarchy.push(elements[i]);elements[i].setAsParent();if(layers[i].parent!==undefined){this.buildElementParenting(element,layers[i].parent,hierarchy);}else{element.setHierarchy(hierarchy);}}}i+=1;}};BaseRenderer.prototype.addPendingElement=function(element){this.pendingElements.push(element);};BaseRenderer.prototype.searchExtraCompositions=function(assets){var i;var len=assets.length;for(i=0;i<len;i+=1){if(assets[i].xt){var comp=this.createComp(assets[i]);comp.initExpressions();this.globalData.projectInterface.registerComposition(comp);}}};BaseRenderer.prototype.getElementById=function(ind){var i;var len=this.elements.length;for(i=0;i<len;i+=1){if(this.elements[i].data.ind===ind){return this.elements[i];}}return null;};BaseRenderer.prototype.getElementByPath=function(path){var pathValue=path.shift();var element;if(typeof pathValue==='number'){element=this.elements[pathValue];}else{var i;var len=this.elements.length;for(i=0;i<len;i+=1){if(this.elements[i].data.nm===pathValue){element=this.elements[i];break;}}}if(path.length===0){return element;}return element.getElementByPath(path);};BaseRenderer.prototype.setupGlobalData=function(animData,fontsContainer){this.globalData.fontManager=new FontManager();this.globalData.slotManager=slotFactory(animData);this.globalData.fontManager.addChars(animData.chars);this.globalData.fontManager.addFonts(animData.fonts,fontsContainer);this.globalData.getAssetData=this.animationItem.getAssetData.bind(this.animationItem);this.globalData.getAssetsPath=this.animationItem.getAssetsPath.bind(this.animationItem);this.globalData.imageLoader=this.animationItem.imagePreloader;this.globalData.audioController=this.animationItem.audioController;this.globalData.frameId=0;this.globalData.frameRate=animData.fr;this.globalData.nm=animData.nm;this.globalData.compSize={w:animData.w,h:animData.h};};var effectTypes={TRANSFORM_EFFECT:'transformEFfect'};function TransformElement(){}TransformElement.prototype={initTransform:function initTransform(){var mat=new Matrix();this.finalTransform={mProp:this.data.ks?TransformPropertyFactory.getTransformProperty(this,this.data.ks,this):{o:0},_matMdf:false,_localMatMdf:false,_opMdf:false,mat:mat,localMat:mat,localOpacity:1};if(this.data.ao){this.finalTransform.mProp.autoOriented=true;}// TODO: check TYPE 11: Guided elements
if(this.data.ty!==11){// this.createElements();
}},renderTransform:function renderTransform(){this.finalTransform._opMdf=this.finalTransform.mProp.o._mdf||this._isFirstFrame;this.finalTransform._matMdf=this.finalTransform.mProp._mdf||this._isFirstFrame;if(this.hierarchy){var mat;var finalMat=this.finalTransform.mat;var i=0;var len=this.hierarchy.length;// Checking if any of the transformation matrices in the hierarchy chain has changed.
if(!this.finalTransform._matMdf){while(i<len){if(this.hierarchy[i].finalTransform.mProp._mdf){this.finalTransform._matMdf=true;break;}i+=1;}}if(this.finalTransform._matMdf){mat=this.finalTransform.mProp.v.props;finalMat.cloneFromProps(mat);for(i=0;i<len;i+=1){finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);}}}if(this.finalTransform._matMdf){this.finalTransform._localMatMdf=this.finalTransform._matMdf;}if(this.finalTransform._opMdf){this.finalTransform.localOpacity=this.finalTransform.mProp.o.v;}},renderLocalTransform:function renderLocalTransform(){if(this.localTransforms){var i=0;var len=this.localTransforms.length;this.finalTransform._localMatMdf=this.finalTransform._matMdf;if(!this.finalTransform._localMatMdf||!this.finalTransform._opMdf){while(i<len){if(this.localTransforms[i]._mdf){this.finalTransform._localMatMdf=true;}if(this.localTransforms[i]._opMdf&&!this.finalTransform._opMdf){this.finalTransform.localOpacity=this.finalTransform.mProp.o.v;this.finalTransform._opMdf=true;}i+=1;}}if(this.finalTransform._localMatMdf){var localMat=this.finalTransform.localMat;this.localTransforms[0].matrix.clone(localMat);for(i=1;i<len;i+=1){var lmat=this.localTransforms[i].matrix;localMat.multiply(lmat);}localMat.multiply(this.finalTransform.mat);}if(this.finalTransform._opMdf){var localOp=this.finalTransform.localOpacity;for(i=0;i<len;i+=1){localOp*=this.localTransforms[i].opacity*0.01;}this.finalTransform.localOpacity=localOp;}}},searchEffectTransforms:function searchEffectTransforms(){if(this.renderableEffectsManager){var transformEffects=this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);if(transformEffects.length){this.localTransforms=[];this.finalTransform.localMat=new Matrix();var i=0;var len=transformEffects.length;for(i=0;i<len;i+=1){this.localTransforms.push(transformEffects[i]);}}}},globalToLocal:function globalToLocal(pt){var transforms=[];transforms.push(this.finalTransform);var flag=true;var comp=this.comp;while(flag){if(comp.finalTransform){if(comp.data.hasMask){transforms.splice(0,0,comp.finalTransform);}comp=comp.comp;}else{flag=false;}}var i;var len=transforms.length;var ptNew;for(i=0;i<len;i+=1){ptNew=transforms[i].mat.applyToPointArray(0,0,0);// ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
pt=[pt[0]-ptNew[0],pt[1]-ptNew[1],0];}return pt;},mHelper:new Matrix()};function MaskElement(data,element,globalData){this.data=data;this.element=element;this.globalData=globalData;this.storedData=[];this.masksProperties=this.data.masksProperties||[];this.maskElement=null;var defs=this.globalData.defs;var i;var len=this.masksProperties?this.masksProperties.length:0;this.viewData=createSizedArray(len);this.solidPath='';var path;var properties=this.masksProperties;var count=0;var currentMasks=[];var j;var jLen;var layerId=createElementID();var rect;var expansor;var feMorph;var x;var maskType='clipPath';var maskRef='clip-path';for(i=0;i<len;i+=1){if(properties[i].mode!=='a'&&properties[i].mode!=='n'||properties[i].inv||properties[i].o.k!==100||properties[i].o.x){maskType='mask';maskRef='mask';}if((properties[i].mode==='s'||properties[i].mode==='i')&&count===0){rect=createNS('rect');rect.setAttribute('fill','#ffffff');rect.setAttribute('width',this.element.comp.data.w||0);rect.setAttribute('height',this.element.comp.data.h||0);currentMasks.push(rect);}else{rect=null;}path=createNS('path');if(properties[i].mode==='n'){// TODO move this to a factory or to a constructor
this.viewData[i]={op:PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3),elem:path,lastPath:''};defs.appendChild(path);}else{count+=1;path.setAttribute('fill',properties[i].mode==='s'?'#000000':'#ffffff');path.setAttribute('clip-rule','nonzero');var filterID;if(properties[i].x.k!==0){maskType='mask';maskRef='mask';x=PropertyFactory.getProp(this.element,properties[i].x,0,null,this.element);filterID=createElementID();expansor=createNS('filter');expansor.setAttribute('id',filterID);feMorph=createNS('feMorphology');feMorph.setAttribute('operator','erode');feMorph.setAttribute('in','SourceGraphic');feMorph.setAttribute('radius','0');expansor.appendChild(feMorph);defs.appendChild(expansor);path.setAttribute('stroke',properties[i].mode==='s'?'#000000':'#ffffff');}else{feMorph=null;x=null;}// TODO move this to a factory or to a constructor
this.storedData[i]={elem:path,x:x,expan:feMorph,lastPath:'',lastOperator:'',filterId:filterID,lastRadius:0};if(properties[i].mode==='i'){jLen=currentMasks.length;var g=createNS('g');for(j=0;j<jLen;j+=1){g.appendChild(currentMasks[j]);}var mask=createNS('mask');mask.setAttribute('mask-type','alpha');mask.setAttribute('id',layerId+'_'+count);mask.appendChild(path);defs.appendChild(mask);g.setAttribute('mask','url('+getLocationHref()+'#'+layerId+'_'+count+')');currentMasks.length=0;currentMasks.push(g);}else{currentMasks.push(path);}if(properties[i].inv&&!this.solidPath){this.solidPath=this.createLayerSolidPath();}// TODO move this to a factory or to a constructor
this.viewData[i]={elem:path,lastPath:'',op:PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.element),prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3),invRect:rect};if(!this.viewData[i].prop.k){this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);}}}this.maskElement=createNS(maskType);len=currentMasks.length;for(i=0;i<len;i+=1){this.maskElement.appendChild(currentMasks[i]);}if(count>0){this.maskElement.setAttribute('id',layerId);this.element.maskedElement.setAttribute(maskRef,'url('+getLocationHref()+'#'+layerId+')');defs.appendChild(this.maskElement);}if(this.viewData.length){this.element.addRenderableComponent(this);}}MaskElement.prototype.getMaskProperty=function(pos){return this.viewData[pos].prop;};MaskElement.prototype.renderFrame=function(isFirstFrame){var finalMat=this.element.finalTransform.mat;var i;var len=this.masksProperties.length;for(i=0;i<len;i+=1){if(this.viewData[i].prop._mdf||isFirstFrame){this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);}if(this.viewData[i].op._mdf||isFirstFrame){this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);}if(this.masksProperties[i].mode!=='n'){if(this.viewData[i].invRect&&(this.element.finalTransform.mProp._mdf||isFirstFrame)){this.viewData[i].invRect.setAttribute('transform',finalMat.getInverseMatrix().to2dCSS());}if(this.storedData[i].x&&(this.storedData[i].x._mdf||isFirstFrame)){var feMorph=this.storedData[i].expan;if(this.storedData[i].x.v<0){if(this.storedData[i].lastOperator!=='erode'){this.storedData[i].lastOperator='erode';this.storedData[i].elem.setAttribute('filter','url('+getLocationHref()+'#'+this.storedData[i].filterId+')');}feMorph.setAttribute('radius',-this.storedData[i].x.v);}else{if(this.storedData[i].lastOperator!=='dilate'){this.storedData[i].lastOperator='dilate';this.storedData[i].elem.setAttribute('filter',null);}this.storedData[i].elem.setAttribute('stroke-width',this.storedData[i].x.v*2);}}}}};MaskElement.prototype.getMaskelement=function(){return this.maskElement;};MaskElement.prototype.createLayerSolidPath=function(){var path='M0,0 ';path+=' h'+this.globalData.compSize.w;path+=' v'+this.globalData.compSize.h;path+=' h-'+this.globalData.compSize.w;path+=' v-'+this.globalData.compSize.h+' ';return path;};MaskElement.prototype.drawPath=function(pathData,pathNodes,viewData){var pathString=' M'+pathNodes.v[0][0]+','+pathNodes.v[0][1];var i;var len;len=pathNodes._length;for(i=1;i<len;i+=1){// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
pathString+=' C'+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1]+' '+pathNodes.i[i][0]+','+pathNodes.i[i][1]+' '+pathNodes.v[i][0]+','+pathNodes.v[i][1];}// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
if(pathNodes.c&&len>1){pathString+=' C'+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1]+' '+pathNodes.i[0][0]+','+pathNodes.i[0][1]+' '+pathNodes.v[0][0]+','+pathNodes.v[0][1];}// pathNodes.__renderedString = pathString;
if(viewData.lastPath!==pathString){var pathShapeValue='';if(viewData.elem){if(pathNodes.c){pathShapeValue=pathData.inv?this.solidPath+pathString:pathString;}viewData.elem.setAttribute('d',pathShapeValue);}viewData.lastPath=pathString;}};MaskElement.prototype.destroy=function(){this.element=null;this.globalData=null;this.maskElement=null;this.data=null;this.masksProperties=null;};var filtersFactory=function(){var ob={};ob.createFilter=createFilter;ob.createAlphaToLuminanceFilter=createAlphaToLuminanceFilter;function createFilter(filId,skipCoordinates){var fil=createNS('filter');fil.setAttribute('id',filId);if(skipCoordinates!==true){fil.setAttribute('filterUnits','objectBoundingBox');fil.setAttribute('x','0%');fil.setAttribute('y','0%');fil.setAttribute('width','100%');fil.setAttribute('height','100%');}return fil;}function createAlphaToLuminanceFilter(){var feColorMatrix=createNS('feColorMatrix');feColorMatrix.setAttribute('type','matrix');feColorMatrix.setAttribute('color-interpolation-filters','sRGB');feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');return feColorMatrix;}return ob;}();var featureSupport=function(){var ob={maskType:true,svgLumaHidden:true,offscreenCanvas:typeof OffscreenCanvas!=='undefined'};if(/MSIE 10/i.test(navigator.userAgent)||/MSIE 9/i.test(navigator.userAgent)||/rv:11.0/i.test(navigator.userAgent)||/Edge\/\d./i.test(navigator.userAgent)){ob.maskType=false;}if(/firefox/i.test(navigator.userAgent)){ob.svgLumaHidden=false;}return ob;}();var registeredEffects$1={};var idPrefix='filter_result_';function SVGEffects(elem){var i;var source='SourceGraphic';var len=elem.data.ef?elem.data.ef.length:0;var filId=createElementID();var fil=filtersFactory.createFilter(filId,true);var count=0;this.filters=[];var filterManager;for(i=0;i<len;i+=1){filterManager=null;var type=elem.data.ef[i].ty;if(registeredEffects$1[type]){var Effect=registeredEffects$1[type].effect;filterManager=new Effect(fil,elem.effectsManager.effectElements[i],elem,idPrefix+count,source);source=idPrefix+count;if(registeredEffects$1[type].countsAsEffect){count+=1;}}if(filterManager){this.filters.push(filterManager);}}if(count){elem.globalData.defs.appendChild(fil);elem.layerElement.setAttribute('filter','url('+getLocationHref()+'#'+filId+')');}if(this.filters.length){elem.addRenderableComponent(this);}}SVGEffects.prototype.renderFrame=function(_isFirstFrame){var i;var len=this.filters.length;for(i=0;i<len;i+=1){this.filters[i].renderFrame(_isFirstFrame);}};SVGEffects.prototype.getEffects=function(type){var i;var len=this.filters.length;var effects=[];for(i=0;i<len;i+=1){if(this.filters[i].type===type){effects.push(this.filters[i]);}}return effects;};function registerEffect$1(id,effect,countsAsEffect){registeredEffects$1[id]={effect:effect,countsAsEffect:countsAsEffect};}function SVGBaseElement(){}SVGBaseElement.prototype={initRendererElement:function initRendererElement(){this.layerElement=createNS('g');},createContainerElements:function createContainerElements(){this.matteElement=createNS('g');this.transformedElement=this.layerElement;this.maskedElement=this.layerElement;this._sizeChanged=false;var layerElementParent=null;// If this layer acts as a mask for the following layer
if(this.data.td){this.matteMasks={};var gg=createNS('g');gg.setAttribute('id',this.layerId);gg.appendChild(this.layerElement);layerElementParent=gg;this.globalData.defs.appendChild(gg);}else if(this.data.tt){this.matteElement.appendChild(this.layerElement);layerElementParent=this.matteElement;this.baseElement=this.matteElement;}else{this.baseElement=this.layerElement;}if(this.data.ln){this.layerElement.setAttribute('id',this.data.ln);}if(this.data.cl){this.layerElement.setAttribute('class',this.data.cl);}// Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
if(this.data.ty===0&&!this.data.hd){var cp=createNS('clipPath');var pt=createNS('path');pt.setAttribute('d','M0,0 L'+this.data.w+',0 L'+this.data.w+','+this.data.h+' L0,'+this.data.h+'z');var clipId=createElementID();cp.setAttribute('id',clipId);cp.appendChild(pt);this.globalData.defs.appendChild(cp);if(this.checkMasks()){var cpGroup=createNS('g');cpGroup.setAttribute('clip-path','url('+getLocationHref()+'#'+clipId+')');cpGroup.appendChild(this.layerElement);this.transformedElement=cpGroup;if(layerElementParent){layerElementParent.appendChild(this.transformedElement);}else{this.baseElement=this.transformedElement;}}else{this.layerElement.setAttribute('clip-path','url('+getLocationHref()+'#'+clipId+')');}}if(this.data.bm!==0){this.setBlendMode();}},renderElement:function renderElement(){if(this.finalTransform._localMatMdf){this.transformedElement.setAttribute('transform',this.finalTransform.localMat.to2dCSS());}if(this.finalTransform._opMdf){this.transformedElement.setAttribute('opacity',this.finalTransform.localOpacity);}},destroyBaseElement:function destroyBaseElement(){this.layerElement=null;this.matteElement=null;this.maskManager.destroy();},getBaseElement:function getBaseElement(){if(this.data.hd){return null;}return this.baseElement;},createRenderableComponents:function createRenderableComponents(){this.maskManager=new MaskElement(this.data,this,this.globalData);this.renderableEffectsManager=new SVGEffects(this);this.searchEffectTransforms();},getMatte:function getMatte(matteType){// This should not be a common case. But for backward compatibility, we'll create the matte object.
// It solves animations that have two consecutive layers marked as matte masks.
// Which is an undefined behavior in AE.
if(!this.matteMasks){this.matteMasks={};}if(!this.matteMasks[matteType]){var id=this.layerId+'_'+matteType;var filId;var fil;var useElement;var gg;if(matteType===1||matteType===3){var masker=createNS('mask');masker.setAttribute('id',id);masker.setAttribute('mask-type',matteType===3?'luminance':'alpha');useElement=createNS('use');useElement.setAttributeNS('http://www.w3.org/1999/xlink','href','#'+this.layerId);masker.appendChild(useElement);this.globalData.defs.appendChild(masker);if(!featureSupport.maskType&&matteType===1){masker.setAttribute('mask-type','luminance');filId=createElementID();fil=filtersFactory.createFilter(filId);this.globalData.defs.appendChild(fil);fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());gg=createNS('g');gg.appendChild(useElement);masker.appendChild(gg);gg.setAttribute('filter','url('+getLocationHref()+'#'+filId+')');}}else if(matteType===2){var maskGroup=createNS('mask');maskGroup.setAttribute('id',id);maskGroup.setAttribute('mask-type','alpha');var maskGrouper=createNS('g');maskGroup.appendChild(maskGrouper);filId=createElementID();fil=filtersFactory.createFilter(filId);/// /
var feCTr=createNS('feComponentTransfer');feCTr.setAttribute('in','SourceGraphic');fil.appendChild(feCTr);var feFunc=createNS('feFuncA');feFunc.setAttribute('type','table');feFunc.setAttribute('tableValues','1.0 0.0');feCTr.appendChild(feFunc);/// /
this.globalData.defs.appendChild(fil);var alphaRect=createNS('rect');alphaRect.setAttribute('width',this.comp.data.w);alphaRect.setAttribute('height',this.comp.data.h);alphaRect.setAttribute('x','0');alphaRect.setAttribute('y','0');alphaRect.setAttribute('fill','#ffffff');alphaRect.setAttribute('opacity','0');maskGrouper.setAttribute('filter','url('+getLocationHref()+'#'+filId+')');maskGrouper.appendChild(alphaRect);useElement=createNS('use');useElement.setAttributeNS('http://www.w3.org/1999/xlink','href','#'+this.layerId);maskGrouper.appendChild(useElement);if(!featureSupport.maskType){maskGroup.setAttribute('mask-type','luminance');fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());gg=createNS('g');maskGrouper.appendChild(alphaRect);gg.appendChild(this.layerElement);maskGrouper.appendChild(gg);}this.globalData.defs.appendChild(maskGroup);}this.matteMasks[matteType]=id;}return this.matteMasks[matteType];},setMatte:function setMatte(id){if(!this.matteElement){return;}this.matteElement.setAttribute('mask','url('+getLocationHref()+'#'+id+')');}};/**
   * @file
   * Handles AE's layer parenting property.
   *
   */function HierarchyElement(){}HierarchyElement.prototype={/**
       * @function
       * Initializes hierarchy properties
       *
       */initHierarchy:function initHierarchy(){// element's parent list
this.hierarchy=[];// if element is parent of another layer _isParent will be true
this._isParent=false;this.checkParenting();},/**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */setHierarchy:function setHierarchy(hierarchy){this.hierarchy=hierarchy;},/**
       * @function
       * Sets layer as parent.
       *
       */setAsParent:function setAsParent(){this._isParent=true;},/**
       * @function
       * Searches layer's parenting chain
       *
       */checkParenting:function checkParenting(){if(this.data.parent!==undefined){this.comp.buildElementParenting(this,this.data.parent,[]);}}};function RenderableDOMElement(){}(function(){var _prototype={initElement:function initElement(data,globalData,comp){this.initFrame();this.initBaseData(data,globalData,comp);this.initTransform(data,globalData,comp);this.initHierarchy();this.initRenderable();this.initRendererElement();this.createContainerElements();this.createRenderableComponents();this.createContent();this.hide();},hide:function hide(){// console.log('HIDE', this);
if(!this.hidden&&(!this.isInRange||this.isTransparent)){var elem=this.baseElement||this.layerElement;elem.style.display='none';this.hidden=true;}},show:function show(){// console.log('SHOW', this);
if(this.isInRange&&!this.isTransparent){if(!this.data.hd){var elem=this.baseElement||this.layerElement;elem.style.display='block';}this.hidden=false;this._isFirstFrame=true;}},renderFrame:function renderFrame(){// If it is exported as hidden (data.hd === true) no need to render
// If it is not visible no need to render
if(this.data.hd||this.hidden){return;}this.renderTransform();this.renderRenderable();this.renderLocalTransform();this.renderElement();this.renderInnerContent();if(this._isFirstFrame){this._isFirstFrame=false;}},renderInnerContent:function renderInnerContent(){},prepareFrame:function prepareFrame(num){this._mdf=false;this.prepareRenderableFrame(num);this.prepareProperties(num,this.isInRange);this.checkTransparency();},destroy:function destroy(){this.innerElem=null;this.destroyBaseElement();}};extendPrototype([RenderableElement,createProxyFunction(_prototype)],RenderableDOMElement);})();function IImageElement(data,globalData,comp){this.assetData=globalData.getAssetData(data.refId);if(this.assetData&&this.assetData.sid){this.assetData=globalData.slotManager.getProp(this.assetData);}this.initElement(data,globalData,comp);this.sourceRect={top:0,left:0,width:this.assetData.w,height:this.assetData.h};}extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement],IImageElement);IImageElement.prototype.createContent=function(){var assetPath=this.globalData.getAssetsPath(this.assetData);this.innerElem=createNS('image');this.innerElem.setAttribute('width',this.assetData.w+'px');this.innerElem.setAttribute('height',this.assetData.h+'px');this.innerElem.setAttribute('preserveAspectRatio',this.assetData.pr||this.globalData.renderConfig.imagePreserveAspectRatio);this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);this.layerElement.appendChild(this.innerElem);};IImageElement.prototype.sourceRectAtTime=function(){return this.sourceRect;};function ProcessedElement(element,position){this.elem=element;this.pos=position;}function IShapeElement(){}IShapeElement.prototype={addShapeToModifiers:function addShapeToModifiers(data){var i;var len=this.shapeModifiers.length;for(i=0;i<len;i+=1){this.shapeModifiers[i].addShape(data);}},isShapeInAnimatedModifiers:function isShapeInAnimatedModifiers(data){var i=0;var len=this.shapeModifiers.length;while(i<len){if(this.shapeModifiers[i].isAnimatedWithShape(data)){return true;}}return false;},renderModifiers:function renderModifiers(){if(!this.shapeModifiers.length){return;}var i;var len=this.shapes.length;for(i=0;i<len;i+=1){this.shapes[i].sh.reset();}len=this.shapeModifiers.length;var shouldBreakProcess;for(i=len-1;i>=0;i-=1){shouldBreakProcess=this.shapeModifiers[i].processShapes(this._isFirstFrame);// workaround to fix cases where a repeater resets the shape so the following processes get called twice
// TODO: find a better solution for this
if(shouldBreakProcess){break;}}},searchProcessedElement:function searchProcessedElement(elem){var elements=this.processedElements;var i=0;var len=elements.length;while(i<len){if(elements[i].elem===elem){return elements[i].pos;}i+=1;}return 0;},addProcessedElement:function addProcessedElement(elem,pos){var elements=this.processedElements;var i=elements.length;while(i){i-=1;if(elements[i].elem===elem){elements[i].pos=pos;return;}}elements.push(new ProcessedElement(elem,pos));},prepareFrame:function prepareFrame(num){this.prepareRenderableFrame(num);this.prepareProperties(num,this.isInRange);}};var lineCapEnum={1:'butt',2:'round',3:'square'};var lineJoinEnum={1:'miter',2:'round',3:'bevel'};function SVGShapeData(transformers,level,shape){this.caches=[];this.styles=[];this.transformers=transformers;this.lStr='';this.sh=shape;this.lvl=level;// TODO find if there are some cases where _isAnimated can be false.
// For now, since shapes add up with other shapes. They have to be calculated every time.
// One way of finding out is checking if all styles associated to this shape depend only of this shape
this._isAnimated=!!shape.k;// TODO: commenting this for now since all shapes are animated
var i=0;var len=transformers.length;while(i<len){if(transformers[i].mProps.dynamicProperties.length){this._isAnimated=true;break;}i+=1;}}SVGShapeData.prototype.setAsAnimated=function(){this._isAnimated=true;};function SVGStyleData(data,level){this.data=data;this.type=data.ty;this.d='';this.lvl=level;this._mdf=false;this.closed=data.hd===true;this.pElem=createNS('path');this.msElem=null;}SVGStyleData.prototype.reset=function(){this.d='';this._mdf=false;};function DashProperty(elem,data,renderer,container){this.elem=elem;this.frameId=-1;this.dataProps=createSizedArray(data.length);this.renderer=renderer;this.k=false;this.dashStr='';this.dashArray=createTypedArray('float32',data.length?data.length-1:0);this.dashoffset=createTypedArray('float32',1);this.initDynamicPropertyContainer(container);var i;var len=data.length||0;var prop;for(i=0;i<len;i+=1){prop=PropertyFactory.getProp(elem,data[i].v,0,0,this);this.k=prop.k||this.k;this.dataProps[i]={n:data[i].n,p:prop};}if(!this.k){this.getValue(true);}this._isAnimated=this.k;}DashProperty.prototype.getValue=function(forceRender){if(this.elem.globalData.frameId===this.frameId&&!forceRender){return;}this.frameId=this.elem.globalData.frameId;this.iterateDynamicProperties();this._mdf=this._mdf||forceRender;if(this._mdf){var i=0;var len=this.dataProps.length;if(this.renderer==='svg'){this.dashStr='';}for(i=0;i<len;i+=1){if(this.dataProps[i].n!=='o'){if(this.renderer==='svg'){this.dashStr+=' '+this.dataProps[i].p.v;}else{this.dashArray[i]=this.dataProps[i].p.v;}}else{this.dashoffset[0]=this.dataProps[i].p.v;}}}};extendPrototype([DynamicPropertyContainer],DashProperty);function SVGStrokeStyleData(elem,data,styleOb){this.initDynamicPropertyContainer(elem);this.getValue=this.iterateDynamicProperties;this.o=PropertyFactory.getProp(elem,data.o,0,0.01,this);this.w=PropertyFactory.getProp(elem,data.w,0,null,this);this.d=new DashProperty(elem,data.d||{},'svg',this);this.c=PropertyFactory.getProp(elem,data.c,1,255,this);this.style=styleOb;this._isAnimated=!!this._isAnimated;}extendPrototype([DynamicPropertyContainer],SVGStrokeStyleData);function SVGFillStyleData(elem,data,styleOb){this.initDynamicPropertyContainer(elem);this.getValue=this.iterateDynamicProperties;this.o=PropertyFactory.getProp(elem,data.o,0,0.01,this);this.c=PropertyFactory.getProp(elem,data.c,1,255,this);this.style=styleOb;}extendPrototype([DynamicPropertyContainer],SVGFillStyleData);function SVGNoStyleData(elem,data,styleOb){this.initDynamicPropertyContainer(elem);this.getValue=this.iterateDynamicProperties;this.style=styleOb;}extendPrototype([DynamicPropertyContainer],SVGNoStyleData);function GradientProperty(elem,data,container){this.data=data;this.c=createTypedArray('uint8c',data.p*4);var cLength=data.k.k[0].s?data.k.k[0].s.length-data.p*4:data.k.k.length-data.p*4;this.o=createTypedArray('float32',cLength);this._cmdf=false;this._omdf=false;this._collapsable=this.checkCollapsable();this._hasOpacity=cLength;this.initDynamicPropertyContainer(container);this.prop=PropertyFactory.getProp(elem,data.k,1,null,this);this.k=this.prop.k;this.getValue(true);}GradientProperty.prototype.comparePoints=function(values,points){var i=0;var len=this.o.length/2;var diff;while(i<len){diff=Math.abs(values[i*4]-values[points*4+i*2]);if(diff>0.01){return false;}i+=1;}return true;};GradientProperty.prototype.checkCollapsable=function(){if(this.o.length/2!==this.c.length/4){return false;}if(this.data.k.k[0].s){var i=0;var len=this.data.k.k.length;while(i<len){if(!this.comparePoints(this.data.k.k[i].s,this.data.p)){return false;}i+=1;}}else if(!this.comparePoints(this.data.k.k,this.data.p)){return false;}return true;};GradientProperty.prototype.getValue=function(forceRender){this.prop.getValue();this._mdf=false;this._cmdf=false;this._omdf=false;if(this.prop._mdf||forceRender){var i;var len=this.data.p*4;var mult;var val;for(i=0;i<len;i+=1){mult=i%4===0?100:255;val=Math.round(this.prop.v[i]*mult);if(this.c[i]!==val){this.c[i]=val;this._cmdf=!forceRender;}}if(this.o.length){len=this.prop.v.length;for(i=this.data.p*4;i<len;i+=1){mult=i%2===0?100:1;val=i%2===0?Math.round(this.prop.v[i]*100):this.prop.v[i];if(this.o[i-this.data.p*4]!==val){this.o[i-this.data.p*4]=val;this._omdf=!forceRender;}}}this._mdf=!forceRender;}};extendPrototype([DynamicPropertyContainer],GradientProperty);function SVGGradientFillStyleData(elem,data,styleOb){this.initDynamicPropertyContainer(elem);this.getValue=this.iterateDynamicProperties;this.initGradientData(elem,data,styleOb);}SVGGradientFillStyleData.prototype.initGradientData=function(elem,data,styleOb){this.o=PropertyFactory.getProp(elem,data.o,0,0.01,this);this.s=PropertyFactory.getProp(elem,data.s,1,null,this);this.e=PropertyFactory.getProp(elem,data.e,1,null,this);this.h=PropertyFactory.getProp(elem,data.h||{k:0},0,0.01,this);this.a=PropertyFactory.getProp(elem,data.a||{k:0},0,degToRads,this);this.g=new GradientProperty(elem,data.g,this);this.style=styleOb;this.stops=[];this.setGradientData(styleOb.pElem,data);this.setGradientOpacity(data,styleOb);this._isAnimated=!!this._isAnimated;};SVGGradientFillStyleData.prototype.setGradientData=function(pathElement,data){var gradientId=createElementID();var gfill=createNS(data.t===1?'linearGradient':'radialGradient');gfill.setAttribute('id',gradientId);gfill.setAttribute('spreadMethod','pad');gfill.setAttribute('gradientUnits','userSpaceOnUse');var stops=[];var stop;var j;var jLen;jLen=data.g.p*4;for(j=0;j<jLen;j+=4){stop=createNS('stop');gfill.appendChild(stop);stops.push(stop);}pathElement.setAttribute(data.ty==='gf'?'fill':'stroke','url('+getLocationHref()+'#'+gradientId+')');this.gf=gfill;this.cst=stops;};SVGGradientFillStyleData.prototype.setGradientOpacity=function(data,styleOb){if(this.g._hasOpacity&&!this.g._collapsable){var stop;var j;var jLen;var mask=createNS('mask');var maskElement=createNS('path');mask.appendChild(maskElement);var opacityId=createElementID();var maskId=createElementID();mask.setAttribute('id',maskId);var opFill=createNS(data.t===1?'linearGradient':'radialGradient');opFill.setAttribute('id',opacityId);opFill.setAttribute('spreadMethod','pad');opFill.setAttribute('gradientUnits','userSpaceOnUse');jLen=data.g.k.k[0].s?data.g.k.k[0].s.length:data.g.k.k.length;var stops=this.stops;for(j=data.g.p*4;j<jLen;j+=2){stop=createNS('stop');stop.setAttribute('stop-color','rgb(255,255,255)');opFill.appendChild(stop);stops.push(stop);}maskElement.setAttribute(data.ty==='gf'?'fill':'stroke','url('+getLocationHref()+'#'+opacityId+')');if(data.ty==='gs'){maskElement.setAttribute('stroke-linecap',lineCapEnum[data.lc||2]);maskElement.setAttribute('stroke-linejoin',lineJoinEnum[data.lj||2]);if(data.lj===1){maskElement.setAttribute('stroke-miterlimit',data.ml);}}this.of=opFill;this.ms=mask;this.ost=stops;this.maskId=maskId;styleOb.msElem=maskElement;}};extendPrototype([DynamicPropertyContainer],SVGGradientFillStyleData);function SVGGradientStrokeStyleData(elem,data,styleOb){this.initDynamicPropertyContainer(elem);this.getValue=this.iterateDynamicProperties;this.w=PropertyFactory.getProp(elem,data.w,0,null,this);this.d=new DashProperty(elem,data.d||{},'svg',this);this.initGradientData(elem,data,styleOb);this._isAnimated=!!this._isAnimated;}extendPrototype([SVGGradientFillStyleData,DynamicPropertyContainer],SVGGradientStrokeStyleData);function ShapeGroupData(){this.it=[];this.prevViewData=[];this.gr=createNS('g');}function SVGTransformData(mProps,op,container){this.transform={mProps:mProps,op:op,container:container};this.elements=[];this._isAnimated=this.transform.mProps.dynamicProperties.length||this.transform.op.effectsSequence.length;}var buildShapeString=function buildShapeString(pathNodes,length,closed,mat){if(length===0){return'';}var _o=pathNodes.o;var _i=pathNodes.i;var _v=pathNodes.v;var i;var shapeString=' M'+mat.applyToPointStringified(_v[0][0],_v[0][1]);for(i=1;i<length;i+=1){shapeString+=' C'+mat.applyToPointStringified(_o[i-1][0],_o[i-1][1])+' '+mat.applyToPointStringified(_i[i][0],_i[i][1])+' '+mat.applyToPointStringified(_v[i][0],_v[i][1]);}if(closed&&length){shapeString+=' C'+mat.applyToPointStringified(_o[i-1][0],_o[i-1][1])+' '+mat.applyToPointStringified(_i[0][0],_i[0][1])+' '+mat.applyToPointStringified(_v[0][0],_v[0][1]);shapeString+='z';}return shapeString;};var SVGElementsRenderer=function(){var _identityMatrix=new Matrix();var _matrixHelper=new Matrix();var ob={createRenderFunction:createRenderFunction};function createRenderFunction(data){switch(data.ty){case'fl':return renderFill;case'gf':return renderGradient;case'gs':return renderGradientStroke;case'st':return renderStroke;case'sh':case'el':case'rc':case'sr':return renderPath;case'tr':return renderContentTransform;case'no':return renderNoop;default:return null;}}function renderContentTransform(styleData,itemData,isFirstFrame){if(isFirstFrame||itemData.transform.op._mdf){itemData.transform.container.setAttribute('opacity',itemData.transform.op.v);}if(isFirstFrame||itemData.transform.mProps._mdf){itemData.transform.container.setAttribute('transform',itemData.transform.mProps.v.to2dCSS());}}function renderNoop(){}function renderPath(styleData,itemData,isFirstFrame){var j;var jLen;var pathStringTransformed;var redraw;var pathNodes;var l;var lLen=itemData.styles.length;var lvl=itemData.lvl;var paths;var mat;var iterations;var k;for(l=0;l<lLen;l+=1){redraw=itemData.sh._mdf||isFirstFrame;if(itemData.styles[l].lvl<lvl){mat=_matrixHelper.reset();iterations=lvl-itemData.styles[l].lvl;k=itemData.transformers.length-1;while(!redraw&&iterations>0){redraw=itemData.transformers[k].mProps._mdf||redraw;iterations-=1;k-=1;}if(redraw){iterations=lvl-itemData.styles[l].lvl;k=itemData.transformers.length-1;while(iterations>0){mat.multiply(itemData.transformers[k].mProps.v);iterations-=1;k-=1;}}}else{mat=_identityMatrix;}paths=itemData.sh.paths;jLen=paths._length;if(redraw){pathStringTransformed='';for(j=0;j<jLen;j+=1){pathNodes=paths.shapes[j];if(pathNodes&&pathNodes._length){pathStringTransformed+=buildShapeString(pathNodes,pathNodes._length,pathNodes.c,mat);}}itemData.caches[l]=pathStringTransformed;}else{pathStringTransformed=itemData.caches[l];}itemData.styles[l].d+=styleData.hd===true?'':pathStringTransformed;itemData.styles[l]._mdf=redraw||itemData.styles[l]._mdf;}}function renderFill(styleData,itemData,isFirstFrame){var styleElem=itemData.style;if(itemData.c._mdf||isFirstFrame){styleElem.pElem.setAttribute('fill','rgb('+bmFloor(itemData.c.v[0])+','+bmFloor(itemData.c.v[1])+','+bmFloor(itemData.c.v[2])+')');}if(itemData.o._mdf||isFirstFrame){styleElem.pElem.setAttribute('fill-opacity',itemData.o.v);}}function renderGradientStroke(styleData,itemData,isFirstFrame){renderGradient(styleData,itemData,isFirstFrame);renderStroke(styleData,itemData,isFirstFrame);}function renderGradient(styleData,itemData,isFirstFrame){var gfill=itemData.gf;var hasOpacity=itemData.g._hasOpacity;var pt1=itemData.s.v;var pt2=itemData.e.v;if(itemData.o._mdf||isFirstFrame){var attr=styleData.ty==='gf'?'fill-opacity':'stroke-opacity';itemData.style.pElem.setAttribute(attr,itemData.o.v);}if(itemData.s._mdf||isFirstFrame){var attr1=styleData.t===1?'x1':'cx';var attr2=attr1==='x1'?'y1':'cy';gfill.setAttribute(attr1,pt1[0]);gfill.setAttribute(attr2,pt1[1]);if(hasOpacity&&!itemData.g._collapsable){itemData.of.setAttribute(attr1,pt1[0]);itemData.of.setAttribute(attr2,pt1[1]);}}var stops;var i;var len;var stop;if(itemData.g._cmdf||isFirstFrame){stops=itemData.cst;var cValues=itemData.g.c;len=stops.length;for(i=0;i<len;i+=1){stop=stops[i];stop.setAttribute('offset',cValues[i*4]+'%');stop.setAttribute('stop-color','rgb('+cValues[i*4+1]+','+cValues[i*4+2]+','+cValues[i*4+3]+')');}}if(hasOpacity&&(itemData.g._omdf||isFirstFrame)){var oValues=itemData.g.o;if(itemData.g._collapsable){stops=itemData.cst;}else{stops=itemData.ost;}len=stops.length;for(i=0;i<len;i+=1){stop=stops[i];if(!itemData.g._collapsable){stop.setAttribute('offset',oValues[i*2]+'%');}stop.setAttribute('stop-opacity',oValues[i*2+1]);}}if(styleData.t===1){if(itemData.e._mdf||isFirstFrame){gfill.setAttribute('x2',pt2[0]);gfill.setAttribute('y2',pt2[1]);if(hasOpacity&&!itemData.g._collapsable){itemData.of.setAttribute('x2',pt2[0]);itemData.of.setAttribute('y2',pt2[1]);}}}else{var rad;if(itemData.s._mdf||itemData.e._mdf||isFirstFrame){rad=Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));gfill.setAttribute('r',rad);if(hasOpacity&&!itemData.g._collapsable){itemData.of.setAttribute('r',rad);}}if(itemData.e._mdf||itemData.h._mdf||itemData.a._mdf||isFirstFrame){if(!rad){rad=Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));}var ang=Math.atan2(pt2[1]-pt1[1],pt2[0]-pt1[0]);var percent=itemData.h.v;if(percent>=1){percent=0.99;}else if(percent<=-1){percent=-0.99;}var dist=rad*percent;var x=Math.cos(ang+itemData.a.v)*dist+pt1[0];var y=Math.sin(ang+itemData.a.v)*dist+pt1[1];gfill.setAttribute('fx',x);gfill.setAttribute('fy',y);if(hasOpacity&&!itemData.g._collapsable){itemData.of.setAttribute('fx',x);itemData.of.setAttribute('fy',y);}}// gfill.setAttribute('fy','200');
}}function renderStroke(styleData,itemData,isFirstFrame){var styleElem=itemData.style;var d=itemData.d;if(d&&(d._mdf||isFirstFrame)&&d.dashStr){styleElem.pElem.setAttribute('stroke-dasharray',d.dashStr);styleElem.pElem.setAttribute('stroke-dashoffset',d.dashoffset[0]);}if(itemData.c&&(itemData.c._mdf||isFirstFrame)){styleElem.pElem.setAttribute('stroke','rgb('+bmFloor(itemData.c.v[0])+','+bmFloor(itemData.c.v[1])+','+bmFloor(itemData.c.v[2])+')');}if(itemData.o._mdf||isFirstFrame){styleElem.pElem.setAttribute('stroke-opacity',itemData.o.v);}if(itemData.w._mdf||isFirstFrame){styleElem.pElem.setAttribute('stroke-width',itemData.w.v);if(styleElem.msElem){styleElem.msElem.setAttribute('stroke-width',itemData.w.v);}}}return ob;}();function SVGShapeElement(data,globalData,comp){// List of drawable elements
this.shapes=[];// Full shape data
this.shapesData=data.shapes;// List of styles that will be applied to shapes
this.stylesList=[];// List of modifiers that will be applied to shapes
this.shapeModifiers=[];// List of items in shape tree
this.itemsData=[];// List of items in previous shape tree
this.processedElements=[];// List of animated components
this.animatedContents=[];this.initElement(data,globalData,comp);// Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
// List of elements that have been created
this.prevViewData=[];// Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
}extendPrototype([BaseElement,TransformElement,SVGBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableDOMElement],SVGShapeElement);SVGShapeElement.prototype.initSecondaryElement=function(){};SVGShapeElement.prototype.identityMatrix=new Matrix();SVGShapeElement.prototype.buildExpressionInterface=function(){};SVGShapeElement.prototype.createContent=function(){this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,0,[],true);this.filterUniqueShapes();};/*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */SVGShapeElement.prototype.filterUniqueShapes=function(){var i;var len=this.shapes.length;var shape;var j;var jLen=this.stylesList.length;var style;var tempShapes=[];var areAnimated=false;for(j=0;j<jLen;j+=1){style=this.stylesList[j];areAnimated=false;tempShapes.length=0;for(i=0;i<len;i+=1){shape=this.shapes[i];if(shape.styles.indexOf(style)!==-1){tempShapes.push(shape);areAnimated=shape._isAnimated||areAnimated;}}if(tempShapes.length>1&&areAnimated){this.setShapesAsAnimated(tempShapes);}}};SVGShapeElement.prototype.setShapesAsAnimated=function(shapes){var i;var len=shapes.length;for(i=0;i<len;i+=1){shapes[i].setAsAnimated();}};SVGShapeElement.prototype.createStyleElement=function(data,level){// TODO: prevent drawing of hidden styles
var elementData;var styleOb=new SVGStyleData(data,level);var pathElement=styleOb.pElem;if(data.ty==='st'){elementData=new SVGStrokeStyleData(this,data,styleOb);}else if(data.ty==='fl'){elementData=new SVGFillStyleData(this,data,styleOb);}else if(data.ty==='gf'||data.ty==='gs'){var GradientConstructor=data.ty==='gf'?SVGGradientFillStyleData:SVGGradientStrokeStyleData;elementData=new GradientConstructor(this,data,styleOb);this.globalData.defs.appendChild(elementData.gf);if(elementData.maskId){this.globalData.defs.appendChild(elementData.ms);this.globalData.defs.appendChild(elementData.of);pathElement.setAttribute('mask','url('+getLocationHref()+'#'+elementData.maskId+')');}}else if(data.ty==='no'){elementData=new SVGNoStyleData(this,data,styleOb);}if(data.ty==='st'||data.ty==='gs'){pathElement.setAttribute('stroke-linecap',lineCapEnum[data.lc||2]);pathElement.setAttribute('stroke-linejoin',lineJoinEnum[data.lj||2]);pathElement.setAttribute('fill-opacity','0');if(data.lj===1){pathElement.setAttribute('stroke-miterlimit',data.ml);}}if(data.r===2){pathElement.setAttribute('fill-rule','evenodd');}if(data.ln){pathElement.setAttribute('id',data.ln);}if(data.cl){pathElement.setAttribute('class',data.cl);}if(data.bm){pathElement.style['mix-blend-mode']=getBlendMode(data.bm);}this.stylesList.push(styleOb);this.addToAnimatedContents(data,elementData);return elementData;};SVGShapeElement.prototype.createGroupElement=function(data){var elementData=new ShapeGroupData();if(data.ln){elementData.gr.setAttribute('id',data.ln);}if(data.cl){elementData.gr.setAttribute('class',data.cl);}if(data.bm){elementData.gr.style['mix-blend-mode']=getBlendMode(data.bm);}return elementData;};SVGShapeElement.prototype.createTransformElement=function(data,container){var transformProperty=TransformPropertyFactory.getTransformProperty(this,data,this);var elementData=new SVGTransformData(transformProperty,transformProperty.o,container);this.addToAnimatedContents(data,elementData);return elementData;};SVGShapeElement.prototype.createShapeElement=function(data,ownTransformers,level){var ty=4;if(data.ty==='rc'){ty=5;}else if(data.ty==='el'){ty=6;}else if(data.ty==='sr'){ty=7;}var shapeProperty=ShapePropertyFactory.getShapeProp(this,data,ty,this);var elementData=new SVGShapeData(ownTransformers,level,shapeProperty);this.shapes.push(elementData);this.addShapeToModifiers(elementData);this.addToAnimatedContents(data,elementData);return elementData;};SVGShapeElement.prototype.addToAnimatedContents=function(data,element){var i=0;var len=this.animatedContents.length;while(i<len){if(this.animatedContents[i].element===element){return;}i+=1;}this.animatedContents.push({fn:SVGElementsRenderer.createRenderFunction(data),element:element,data:data});};SVGShapeElement.prototype.setElementStyles=function(elementData){var arr=elementData.styles;var j;var jLen=this.stylesList.length;for(j=0;j<jLen;j+=1){if(!this.stylesList[j].closed){arr.push(this.stylesList[j]);}}};SVGShapeElement.prototype.reloadShapes=function(){this._isFirstFrame=true;var i;var len=this.itemsData.length;for(i=0;i<len;i+=1){this.prevViewData[i]=this.itemsData[i];}this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,0,[],true);this.filterUniqueShapes();len=this.dynamicProperties.length;for(i=0;i<len;i+=1){this.dynamicProperties[i].getValue();}this.renderModifiers();};SVGShapeElement.prototype.searchShapes=function(arr,itemsData,prevViewData,container,level,transformers,render){var ownTransformers=[].concat(transformers);var i;var len=arr.length-1;var j;var jLen;var ownStyles=[];var ownModifiers=[];var currentTransform;var modifier;var processedPos;for(i=len;i>=0;i-=1){processedPos=this.searchProcessedElement(arr[i]);if(!processedPos){arr[i]._render=render;}else{itemsData[i]=prevViewData[processedPos-1];}if(arr[i].ty==='fl'||arr[i].ty==='st'||arr[i].ty==='gf'||arr[i].ty==='gs'||arr[i].ty==='no'){if(!processedPos){itemsData[i]=this.createStyleElement(arr[i],level);}else{itemsData[i].style.closed=false;}if(arr[i]._render){if(itemsData[i].style.pElem.parentNode!==container){container.appendChild(itemsData[i].style.pElem);}}ownStyles.push(itemsData[i].style);}else if(arr[i].ty==='gr'){if(!processedPos){itemsData[i]=this.createGroupElement(arr[i]);}else{jLen=itemsData[i].it.length;for(j=0;j<jLen;j+=1){itemsData[i].prevViewData[j]=itemsData[i].it[j];}}this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,itemsData[i].gr,level+1,ownTransformers,render);if(arr[i]._render){if(itemsData[i].gr.parentNode!==container){container.appendChild(itemsData[i].gr);}}}else if(arr[i].ty==='tr'){if(!processedPos){itemsData[i]=this.createTransformElement(arr[i],container);}currentTransform=itemsData[i].transform;ownTransformers.push(currentTransform);}else if(arr[i].ty==='sh'||arr[i].ty==='rc'||arr[i].ty==='el'||arr[i].ty==='sr'){if(!processedPos){itemsData[i]=this.createShapeElement(arr[i],ownTransformers,level);}this.setElementStyles(itemsData[i]);}else if(arr[i].ty==='tm'||arr[i].ty==='rd'||arr[i].ty==='ms'||arr[i].ty==='pb'||arr[i].ty==='zz'||arr[i].ty==='op'){if(!processedPos){modifier=ShapeModifiers.getModifier(arr[i].ty);modifier.init(this,arr[i]);itemsData[i]=modifier;this.shapeModifiers.push(modifier);}else{modifier=itemsData[i];modifier.closed=false;}ownModifiers.push(modifier);}else if(arr[i].ty==='rp'){if(!processedPos){modifier=ShapeModifiers.getModifier(arr[i].ty);itemsData[i]=modifier;modifier.init(this,arr,i,itemsData);this.shapeModifiers.push(modifier);render=false;}else{modifier=itemsData[i];modifier.closed=true;}ownModifiers.push(modifier);}this.addProcessedElement(arr[i],i+1);}len=ownStyles.length;for(i=0;i<len;i+=1){ownStyles[i].closed=true;}len=ownModifiers.length;for(i=0;i<len;i+=1){ownModifiers[i].closed=true;}};SVGShapeElement.prototype.renderInnerContent=function(){this.renderModifiers();var i;var len=this.stylesList.length;for(i=0;i<len;i+=1){this.stylesList[i].reset();}this.renderShape();for(i=0;i<len;i+=1){if(this.stylesList[i]._mdf||this._isFirstFrame){if(this.stylesList[i].msElem){this.stylesList[i].msElem.setAttribute('d',this.stylesList[i].d);// Adding M0 0 fixes same mask bug on all browsers
this.stylesList[i].d='M0 0'+this.stylesList[i].d;}this.stylesList[i].pElem.setAttribute('d',this.stylesList[i].d||'M0 0');}}};SVGShapeElement.prototype.renderShape=function(){var i;var len=this.animatedContents.length;var animatedContent;for(i=0;i<len;i+=1){animatedContent=this.animatedContents[i];if((this._isFirstFrame||animatedContent.element._isAnimated)&&animatedContent.data!==true){animatedContent.fn(animatedContent.data,animatedContent.element,this._isFirstFrame);}}};SVGShapeElement.prototype.destroy=function(){this.destroyBaseElement();this.shapesData=null;this.itemsData=null;};function LetterProps(o,sw,sc,fc,m,p){this.o=o;this.sw=sw;this.sc=sc;this.fc=fc;this.m=m;this.p=p;this._mdf={o:true,sw:!!sw,sc:!!sc,fc:!!fc,m:true,p:true};}LetterProps.prototype.update=function(o,sw,sc,fc,m,p){this._mdf.o=false;this._mdf.sw=false;this._mdf.sc=false;this._mdf.fc=false;this._mdf.m=false;this._mdf.p=false;var updated=false;if(this.o!==o){this.o=o;this._mdf.o=true;updated=true;}if(this.sw!==sw){this.sw=sw;this._mdf.sw=true;updated=true;}if(this.sc!==sc){this.sc=sc;this._mdf.sc=true;updated=true;}if(this.fc!==fc){this.fc=fc;this._mdf.fc=true;updated=true;}if(this.m!==m){this.m=m;this._mdf.m=true;updated=true;}if(p.length&&(this.p[0]!==p[0]||this.p[1]!==p[1]||this.p[4]!==p[4]||this.p[5]!==p[5]||this.p[12]!==p[12]||this.p[13]!==p[13])){this.p=p;this._mdf.p=true;updated=true;}return updated;};function TextProperty(elem,data){this._frameId=initialDefaultFrame;this.pv='';this.v='';this.kf=false;this._isFirstFrame=true;this._mdf=false;if(data.d&&data.d.sid){data.d=elem.globalData.slotManager.getProp(data.d);}this.data=data;this.elem=elem;this.comp=this.elem.comp;this.keysIndex=0;this.canResize=false;this.minimumFontSize=1;this.effectsSequence=[];this.currentData={ascent:0,boxWidth:this.defaultBoxWidth,f:'',fStyle:'',fWeight:'',fc:'',j:'',justifyOffset:'',l:[],lh:0,lineWidths:[],ls:'',of:'',s:'',sc:'',sw:0,t:0,tr:0,sz:0,ps:null,fillColorAnim:false,strokeColorAnim:false,strokeWidthAnim:false,yOffset:0,finalSize:0,finalText:[],finalLineHeight:0,__complete:false};this.copyData(this.currentData,this.data.d.k[0].s);if(!this.searchProperty()){this.completeTextData(this.currentData);}}TextProperty.prototype.defaultBoxWidth=[0,0];TextProperty.prototype.copyData=function(obj,data){for(var s in data){if(Object.prototype.hasOwnProperty.call(data,s)){obj[s]=data[s];}}return obj;};TextProperty.prototype.setCurrentData=function(data){if(!data.__complete){this.completeTextData(data);}this.currentData=data;this.currentData.boxWidth=this.currentData.boxWidth||this.defaultBoxWidth;this._mdf=true;};TextProperty.prototype.searchProperty=function(){return this.searchKeyframes();};TextProperty.prototype.searchKeyframes=function(){this.kf=this.data.d.k.length>1;if(this.kf){this.addEffect(this.getKeyframeValue.bind(this));}return this.kf;};TextProperty.prototype.addEffect=function(effectFunction){this.effectsSequence.push(effectFunction);this.elem.addDynamicProperty(this);};TextProperty.prototype.getValue=function(_finalValue){if((this.elem.globalData.frameId===this.frameId||!this.effectsSequence.length)&&!_finalValue){return;}this.currentData.t=this.data.d.k[this.keysIndex].s.t;var currentValue=this.currentData;var currentIndex=this.keysIndex;if(this.lock){this.setCurrentData(this.currentData);return;}this.lock=true;this._mdf=false;var i;var len=this.effectsSequence.length;var finalValue=_finalValue||this.data.d.k[this.keysIndex].s;for(i=0;i<len;i+=1){// Checking if index changed to prevent creating a new object every time the expression updates.
if(currentIndex!==this.keysIndex){finalValue=this.effectsSequence[i](finalValue,finalValue.t);}else{finalValue=this.effectsSequence[i](this.currentData,finalValue.t);}}if(currentValue!==finalValue){this.setCurrentData(finalValue);}this.v=this.currentData;this.pv=this.v;this.lock=false;this.frameId=this.elem.globalData.frameId;};TextProperty.prototype.getKeyframeValue=function(){var textKeys=this.data.d.k;var frameNum=this.elem.comp.renderedFrame;var i=0;var len=textKeys.length;while(i<=len-1){if(i===len-1||textKeys[i+1].t>frameNum){break;}i+=1;}if(this.keysIndex!==i){this.keysIndex=i;}return this.data.d.k[this.keysIndex].s;};TextProperty.prototype.buildFinalText=function(text){var charactersArray=[];var i=0;var len=text.length;var charCode;var secondCharCode;var shouldCombine=false;var shouldCombineNext=false;var currentChars='';while(i<len){shouldCombine=shouldCombineNext;shouldCombineNext=false;charCode=text.charCodeAt(i);currentChars=text.charAt(i);if(FontManager.isCombinedCharacter(charCode)){shouldCombine=true;// It's a potential surrogate pair (this is the High surrogate)
}else if(charCode>=0xD800&&charCode<=0xDBFF){if(FontManager.isRegionalFlag(text,i)){currentChars=text.substr(i,14);}else{secondCharCode=text.charCodeAt(i+1);// It's a surrogate pair (this is the Low surrogate)
if(secondCharCode>=0xDC00&&secondCharCode<=0xDFFF){if(FontManager.isModifier(charCode,secondCharCode)){currentChars=text.substr(i,2);shouldCombine=true;}else if(FontManager.isFlagEmoji(text.substr(i,4))){currentChars=text.substr(i,4);}else{currentChars=text.substr(i,2);}}}}else if(charCode>0xDBFF){secondCharCode=text.charCodeAt(i+1);if(FontManager.isVariationSelector(charCode)){shouldCombine=true;}}else if(FontManager.isZeroWidthJoiner(charCode)){shouldCombine=true;shouldCombineNext=true;}if(shouldCombine){charactersArray[charactersArray.length-1]+=currentChars;shouldCombine=false;}else{charactersArray.push(currentChars);}i+=currentChars.length;}return charactersArray;};TextProperty.prototype.completeTextData=function(documentData){documentData.__complete=true;var fontManager=this.elem.globalData.fontManager;var data=this.data;var letters=[];var i;var len;var newLineFlag;var index=0;var val;var anchorGrouping=data.m.g;var currentSize=0;var currentPos=0;var currentLine=0;var lineWidths=[];var lineWidth=0;var maxLineWidth=0;var j;var jLen;var fontData=fontManager.getFontByName(documentData.f);var charData;var cLength=0;var fontProps=getFontProperties(fontData);documentData.fWeight=fontProps.weight;documentData.fStyle=fontProps.style;documentData.finalSize=documentData.s;documentData.finalText=this.buildFinalText(documentData.t);len=documentData.finalText.length;documentData.finalLineHeight=documentData.lh;var trackingOffset=documentData.tr/1000*documentData.finalSize;var charCode;if(documentData.sz){var flag=true;var boxWidth=documentData.sz[0];var boxHeight=documentData.sz[1];var currentHeight;var finalText;while(flag){finalText=this.buildFinalText(documentData.t);currentHeight=0;lineWidth=0;len=finalText.length;trackingOffset=documentData.tr/1000*documentData.finalSize;var lastSpaceIndex=-1;for(i=0;i<len;i+=1){charCode=finalText[i].charCodeAt(0);newLineFlag=false;if(finalText[i]===' '){lastSpaceIndex=i;}else if(charCode===13||charCode===3){lineWidth=0;newLineFlag=true;currentHeight+=documentData.finalLineHeight||documentData.finalSize*1.2;}if(fontManager.chars){charData=fontManager.getCharData(finalText[i],fontData.fStyle,fontData.fFamily);cLength=newLineFlag?0:charData.w*documentData.finalSize/100;}else{// tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
cLength=fontManager.measureText(finalText[i],documentData.f,documentData.finalSize);}if(lineWidth+cLength>boxWidth&&finalText[i]!==' '){if(lastSpaceIndex===-1){len+=1;}else{i=lastSpaceIndex;}currentHeight+=documentData.finalLineHeight||documentData.finalSize*1.2;finalText.splice(i,lastSpaceIndex===i?1:0,'\r');// finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
lastSpaceIndex=-1;lineWidth=0;}else{lineWidth+=cLength;lineWidth+=trackingOffset;}}currentHeight+=fontData.ascent*documentData.finalSize/100;if(this.canResize&&documentData.finalSize>this.minimumFontSize&&boxHeight<currentHeight){documentData.finalSize-=1;documentData.finalLineHeight=documentData.finalSize*documentData.lh/documentData.s;}else{documentData.finalText=finalText;len=documentData.finalText.length;flag=false;}}}lineWidth=-trackingOffset;cLength=0;var uncollapsedSpaces=0;var currentChar;for(i=0;i<len;i+=1){newLineFlag=false;currentChar=documentData.finalText[i];charCode=currentChar.charCodeAt(0);if(charCode===13||charCode===3){uncollapsedSpaces=0;lineWidths.push(lineWidth);maxLineWidth=lineWidth>maxLineWidth?lineWidth:maxLineWidth;lineWidth=-2*trackingOffset;val='';newLineFlag=true;currentLine+=1;}else{val=currentChar;}if(fontManager.chars){charData=fontManager.getCharData(currentChar,fontData.fStyle,fontManager.getFontByName(documentData.f).fFamily);cLength=newLineFlag?0:charData.w*documentData.finalSize/100;}else{// var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
// tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
cLength=fontManager.measureText(val,documentData.f,documentData.finalSize);}//
if(currentChar===' '){uncollapsedSpaces+=cLength+trackingOffset;}else{lineWidth+=cLength+trackingOffset+uncollapsedSpaces;uncollapsedSpaces=0;}letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag,anIndexes:[],val:val,line:currentLine,animatorJustifyOffset:0});if(anchorGrouping==2){// eslint-disable-line eqeqeq
currentSize+=cLength;if(val===''||val===' '||i===len-1){if(val===''||val===' '){currentSize-=cLength;}while(currentPos<=i){letters[currentPos].an=currentSize;letters[currentPos].ind=index;letters[currentPos].extra=cLength;currentPos+=1;}index+=1;currentSize=0;}}else if(anchorGrouping==3){// eslint-disable-line eqeqeq
currentSize+=cLength;if(val===''||i===len-1){if(val===''){currentSize-=cLength;}while(currentPos<=i){letters[currentPos].an=currentSize;letters[currentPos].ind=index;letters[currentPos].extra=cLength;currentPos+=1;}currentSize=0;index+=1;}}else{letters[index].ind=index;letters[index].extra=0;index+=1;}}documentData.l=letters;maxLineWidth=lineWidth>maxLineWidth?lineWidth:maxLineWidth;lineWidths.push(lineWidth);if(documentData.sz){documentData.boxWidth=documentData.sz[0];documentData.justifyOffset=0;}else{documentData.boxWidth=maxLineWidth;switch(documentData.j){case 1:documentData.justifyOffset=-documentData.boxWidth;break;case 2:documentData.justifyOffset=-documentData.boxWidth/2;break;default:documentData.justifyOffset=0;}}documentData.lineWidths=lineWidths;var animators=data.a;var animatorData;var letterData;jLen=animators.length;var based;var ind;var indexes=[];for(j=0;j<jLen;j+=1){animatorData=animators[j];if(animatorData.a.sc){documentData.strokeColorAnim=true;}if(animatorData.a.sw){documentData.strokeWidthAnim=true;}if(animatorData.a.fc||animatorData.a.fh||animatorData.a.fs||animatorData.a.fb){documentData.fillColorAnim=true;}ind=0;based=animatorData.s.b;for(i=0;i<len;i+=1){letterData=letters[i];letterData.anIndexes[j]=ind;if(based==1&&letterData.val!==''||based==2&&letterData.val!==''&&letterData.val!==' '||based==3&&(letterData.n||letterData.val==' '||i==len-1)||based==4&&(letterData.n||i==len-1)){// eslint-disable-line eqeqeq
if(animatorData.s.rn===1){indexes.push(ind);}ind+=1;}}data.a[j].s.totalChars=ind;var currentInd=-1;var newInd;if(animatorData.s.rn===1){for(i=0;i<len;i+=1){letterData=letters[i];if(currentInd!=letterData.anIndexes[j]){// eslint-disable-line eqeqeq
currentInd=letterData.anIndexes[j];newInd=indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];}letterData.anIndexes[j]=newInd;}}}documentData.yOffset=documentData.finalLineHeight||documentData.finalSize*1.2;documentData.ls=documentData.ls||0;documentData.ascent=fontData.ascent*documentData.finalSize/100;};TextProperty.prototype.updateDocumentData=function(newData,index){index=index===undefined?this.keysIndex:index;var dData=this.copyData({},this.data.d.k[index].s);dData=this.copyData(dData,newData);this.data.d.k[index].s=dData;this.recalculate(index);this.setCurrentData(dData);this.elem.addDynamicProperty(this);};TextProperty.prototype.recalculate=function(index){var dData=this.data.d.k[index].s;dData.__complete=false;this.keysIndex=0;this._isFirstFrame=true;this.getValue(dData);};TextProperty.prototype.canResizeFont=function(_canResize){this.canResize=_canResize;this.recalculate(this.keysIndex);this.elem.addDynamicProperty(this);};TextProperty.prototype.setMinimumFontSize=function(_fontValue){this.minimumFontSize=Math.floor(_fontValue)||1;this.recalculate(this.keysIndex);this.elem.addDynamicProperty(this);};var TextSelectorProp=function(){var max=Math.max;var min=Math.min;var floor=Math.floor;function TextSelectorPropFactory(elem,data){this._currentTextLength=-1;this.k=false;this.data=data;this.elem=elem;this.comp=elem.comp;this.finalS=0;this.finalE=0;this.initDynamicPropertyContainer(elem);this.s=PropertyFactory.getProp(elem,data.s||{k:0},0,0,this);if('e'in data){this.e=PropertyFactory.getProp(elem,data.e,0,0,this);}else{this.e={v:100};}this.o=PropertyFactory.getProp(elem,data.o||{k:0},0,0,this);this.xe=PropertyFactory.getProp(elem,data.xe||{k:0},0,0,this);this.ne=PropertyFactory.getProp(elem,data.ne||{k:0},0,0,this);this.sm=PropertyFactory.getProp(elem,data.sm||{k:100},0,0,this);this.a=PropertyFactory.getProp(elem,data.a,0,0.01,this);if(!this.dynamicProperties.length){this.getValue();}}TextSelectorPropFactory.prototype={getMult:function getMult(ind){if(this._currentTextLength!==this.elem.textProperty.currentData.l.length){this.getValue();}var x1=0;var y1=0;var x2=1;var y2=1;if(this.ne.v>0){x1=this.ne.v/100.0;}else{y1=-this.ne.v/100.0;}if(this.xe.v>0){x2=1.0-this.xe.v/100.0;}else{y2=1.0+this.xe.v/100.0;}var easer=BezierFactory.getBezierEasing(x1,y1,x2,y2).get;var mult=0;var s=this.finalS;var e=this.finalE;var type=this.data.sh;if(type===2){if(e===s){mult=ind>=e?1:0;}else{mult=max(0,min(0.5/(e-s)+(ind-s)/(e-s),1));}mult=easer(mult);}else if(type===3){if(e===s){mult=ind>=e?0:1;}else{mult=1-max(0,min(0.5/(e-s)+(ind-s)/(e-s),1));}mult=easer(mult);}else if(type===4){if(e===s){mult=0;}else{mult=max(0,min(0.5/(e-s)+(ind-s)/(e-s),1));if(mult<0.5){mult*=2;}else{mult=1-2*(mult-0.5);}}mult=easer(mult);}else if(type===5){if(e===s){mult=0;}else{var tot=e-s;/* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ind=min(max(0,ind+0.5-s),e-s);var x=-tot/2+ind;var a=tot/2;mult=Math.sqrt(1-x*x/(a*a));}mult=easer(mult);}else if(type===6){if(e===s){mult=0;}else{ind=min(max(0,ind+0.5-s),e-s);mult=(1+Math.cos(Math.PI+Math.PI*2*ind/(e-s)))/2;// eslint-disable-line
}mult=easer(mult);}else{if(ind>=floor(s)){if(ind-s<0){mult=max(0,min(min(e,1)-(s-ind),1));}else{mult=max(0,min(e-ind,1));}}mult=easer(mult);}// Smoothness implementation.
// The smoothness represents a reduced range of the original [0; 1] range.
// if smoothness is 25%, the new range will be [0.375; 0.625]
// Steps are:
// - find the lower value of the new range (threshold)
// - if multiplier is smaller than that value, floor it to 0
// - if it is larger,
//     - subtract the threshold
//     - divide it by the smoothness (this will return the range to [0; 1])
// Note: If it doesn't work on some scenarios, consider applying it before the easer.
if(this.sm.v!==100){var smoothness=this.sm.v*0.01;if(smoothness===0){smoothness=0.00000001;}var threshold=0.5-smoothness*0.5;if(mult<threshold){mult=0;}else{mult=(mult-threshold)/smoothness;if(mult>1){mult=1;}}}return mult*this.a.v;},getValue:function getValue(newCharsFlag){this.iterateDynamicProperties();this._mdf=newCharsFlag||this._mdf;this._currentTextLength=this.elem.textProperty.currentData.l.length||0;if(newCharsFlag&&this.data.r===2){this.e.v=this._currentTextLength;}var divisor=this.data.r===2?1:100/this.data.totalChars;var o=this.o.v/divisor;var s=this.s.v/divisor+o;var e=this.e.v/divisor+o;if(s>e){var _s=s;s=e;e=_s;}this.finalS=s;this.finalE=e;}};extendPrototype([DynamicPropertyContainer],TextSelectorPropFactory);function getTextSelectorProp(elem,data,arr){return new TextSelectorPropFactory(elem,data,arr);}return{getTextSelectorProp:getTextSelectorProp};}();function TextAnimatorDataProperty(elem,animatorProps,container){var defaultData={propType:false};var getProp=PropertyFactory.getProp;var textAnimatorAnimatables=animatorProps.a;this.a={r:textAnimatorAnimatables.r?getProp(elem,textAnimatorAnimatables.r,0,degToRads,container):defaultData,rx:textAnimatorAnimatables.rx?getProp(elem,textAnimatorAnimatables.rx,0,degToRads,container):defaultData,ry:textAnimatorAnimatables.ry?getProp(elem,textAnimatorAnimatables.ry,0,degToRads,container):defaultData,sk:textAnimatorAnimatables.sk?getProp(elem,textAnimatorAnimatables.sk,0,degToRads,container):defaultData,sa:textAnimatorAnimatables.sa?getProp(elem,textAnimatorAnimatables.sa,0,degToRads,container):defaultData,s:textAnimatorAnimatables.s?getProp(elem,textAnimatorAnimatables.s,1,0.01,container):defaultData,a:textAnimatorAnimatables.a?getProp(elem,textAnimatorAnimatables.a,1,0,container):defaultData,o:textAnimatorAnimatables.o?getProp(elem,textAnimatorAnimatables.o,0,0.01,container):defaultData,p:textAnimatorAnimatables.p?getProp(elem,textAnimatorAnimatables.p,1,0,container):defaultData,sw:textAnimatorAnimatables.sw?getProp(elem,textAnimatorAnimatables.sw,0,0,container):defaultData,sc:textAnimatorAnimatables.sc?getProp(elem,textAnimatorAnimatables.sc,1,0,container):defaultData,fc:textAnimatorAnimatables.fc?getProp(elem,textAnimatorAnimatables.fc,1,0,container):defaultData,fh:textAnimatorAnimatables.fh?getProp(elem,textAnimatorAnimatables.fh,0,0,container):defaultData,fs:textAnimatorAnimatables.fs?getProp(elem,textAnimatorAnimatables.fs,0,0.01,container):defaultData,fb:textAnimatorAnimatables.fb?getProp(elem,textAnimatorAnimatables.fb,0,0.01,container):defaultData,t:textAnimatorAnimatables.t?getProp(elem,textAnimatorAnimatables.t,0,0,container):defaultData};this.s=TextSelectorProp.getTextSelectorProp(elem,animatorProps.s,container);this.s.t=animatorProps.s.t;}function TextAnimatorProperty(textData,renderType,elem){this._isFirstFrame=true;this._hasMaskedPath=false;this._frameId=-1;this._textData=textData;this._renderType=renderType;this._elem=elem;this._animatorsData=createSizedArray(this._textData.a.length);this._pathData={};this._moreOptions={alignment:{}};this.renderedLetters=[];this.lettersChangedFlag=false;this.initDynamicPropertyContainer(elem);}TextAnimatorProperty.prototype.searchProperties=function(){var i;var len=this._textData.a.length;var animatorProps;var getProp=PropertyFactory.getProp;for(i=0;i<len;i+=1){animatorProps=this._textData.a[i];this._animatorsData[i]=new TextAnimatorDataProperty(this._elem,animatorProps,this);}if(this._textData.p&&'m'in this._textData.p){this._pathData={a:getProp(this._elem,this._textData.p.a,0,0,this),f:getProp(this._elem,this._textData.p.f,0,0,this),l:getProp(this._elem,this._textData.p.l,0,0,this),r:getProp(this._elem,this._textData.p.r,0,0,this),p:getProp(this._elem,this._textData.p.p,0,0,this),m:this._elem.maskManager.getMaskProperty(this._textData.p.m)};this._hasMaskedPath=true;}else{this._hasMaskedPath=false;}this._moreOptions.alignment=getProp(this._elem,this._textData.m.a,1,0,this);};TextAnimatorProperty.prototype.getMeasures=function(documentData,lettersChangedFlag){this.lettersChangedFlag=lettersChangedFlag;if(!this._mdf&&!this._isFirstFrame&&!lettersChangedFlag&&(!this._hasMaskedPath||!this._pathData.m._mdf)){return;}this._isFirstFrame=false;var alignment=this._moreOptions.alignment.v;var animators=this._animatorsData;var textData=this._textData;var matrixHelper=this.mHelper;var renderType=this._renderType;var renderedLettersCount=this.renderedLetters.length;var xPos;var yPos;var i;var len;var letters=documentData.l;var pathInfo;var currentLength;var currentPoint;var segmentLength;var flag;var pointInd;var segmentInd;var prevPoint;var points;var segments;var partialLength;var totalLength;var perc;var tanAngle;var mask;if(this._hasMaskedPath){mask=this._pathData.m;if(!this._pathData.n||this._pathData._mdf){var paths=mask.v;if(this._pathData.r.v){paths=paths.reverse();}// TODO: release bezier data cached from previous pathInfo: this._pathData.pi
pathInfo={tLength:0,segments:[]};len=paths._length-1;var bezierData;totalLength=0;for(i=0;i<len;i+=1){bezierData=bez.buildBezierData(paths.v[i],paths.v[i+1],[paths.o[i][0]-paths.v[i][0],paths.o[i][1]-paths.v[i][1]],[paths.i[i+1][0]-paths.v[i+1][0],paths.i[i+1][1]-paths.v[i+1][1]]);pathInfo.tLength+=bezierData.segmentLength;pathInfo.segments.push(bezierData);totalLength+=bezierData.segmentLength;}i=len;if(mask.v.c){bezierData=bez.buildBezierData(paths.v[i],paths.v[0],[paths.o[i][0]-paths.v[i][0],paths.o[i][1]-paths.v[i][1]],[paths.i[0][0]-paths.v[0][0],paths.i[0][1]-paths.v[0][1]]);pathInfo.tLength+=bezierData.segmentLength;pathInfo.segments.push(bezierData);totalLength+=bezierData.segmentLength;}this._pathData.pi=pathInfo;}pathInfo=this._pathData.pi;currentLength=this._pathData.f.v;segmentInd=0;pointInd=1;segmentLength=0;flag=true;segments=pathInfo.segments;if(currentLength<0&&mask.v.c){if(pathInfo.tLength<Math.abs(currentLength)){currentLength=-Math.abs(currentLength)%pathInfo.tLength;}segmentInd=segments.length-1;points=segments[segmentInd].points;pointInd=points.length-1;while(currentLength<0){currentLength+=points[pointInd].partialLength;pointInd-=1;if(pointInd<0){segmentInd-=1;points=segments[segmentInd].points;pointInd=points.length-1;}}}points=segments[segmentInd].points;prevPoint=points[pointInd-1];currentPoint=points[pointInd];partialLength=currentPoint.partialLength;}len=letters.length;xPos=0;yPos=0;var yOff=documentData.finalSize*1.2*0.714;var firstLine=true;var animatorProps;var animatorSelector;var j;var jLen;var letterValue;jLen=animators.length;var mult;var ind=-1;var offf;var xPathPos;var yPathPos;var initPathPos=currentLength;var initSegmentInd=segmentInd;var initPointInd=pointInd;var currentLine=-1;var elemOpacity;var sc;var sw;var fc;var k;var letterSw;var letterSc;var letterFc;var letterM='';var letterP=this.defaultPropsArray;var letterO;//
if(documentData.j===2||documentData.j===1){var animatorJustifyOffset=0;var animatorFirstCharOffset=0;var justifyOffsetMult=documentData.j===2?-0.5:-1;var lastIndex=0;var isNewLine=true;for(i=0;i<len;i+=1){if(letters[i].n){if(animatorJustifyOffset){animatorJustifyOffset+=animatorFirstCharOffset;}while(lastIndex<i){letters[lastIndex].animatorJustifyOffset=animatorJustifyOffset;lastIndex+=1;}animatorJustifyOffset=0;isNewLine=true;}else{for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.t.propType){if(isNewLine&&documentData.j===2){animatorFirstCharOffset+=animatorProps.t.v*justifyOffsetMult;}animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(mult.length){animatorJustifyOffset+=animatorProps.t.v*mult[0]*justifyOffsetMult;}else{animatorJustifyOffset+=animatorProps.t.v*mult*justifyOffsetMult;}}}isNewLine=false;}}if(animatorJustifyOffset){animatorJustifyOffset+=animatorFirstCharOffset;}while(lastIndex<i){letters[lastIndex].animatorJustifyOffset=animatorJustifyOffset;lastIndex+=1;}}//
for(i=0;i<len;i+=1){matrixHelper.reset();elemOpacity=1;if(letters[i].n){xPos=0;yPos+=documentData.yOffset;yPos+=firstLine?1:0;currentLength=initPathPos;firstLine=false;if(this._hasMaskedPath){segmentInd=initSegmentInd;pointInd=initPointInd;points=segments[segmentInd].points;prevPoint=points[pointInd-1];currentPoint=points[pointInd];partialLength=currentPoint.partialLength;segmentLength=0;}letterM='';letterFc='';letterSw='';letterO='';letterP=this.defaultPropsArray;}else{if(this._hasMaskedPath){if(currentLine!==letters[i].line){switch(documentData.j){case 1:currentLength+=totalLength-documentData.lineWidths[letters[i].line];break;case 2:currentLength+=(totalLength-documentData.lineWidths[letters[i].line])/2;break;default:break;}currentLine=letters[i].line;}if(ind!==letters[i].ind){if(letters[ind]){currentLength+=letters[ind].extra;}currentLength+=letters[i].an/2;ind=letters[i].ind;}currentLength+=alignment[0]*letters[i].an*0.005;var animatorOffset=0;for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.p.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(mult.length){animatorOffset+=animatorProps.p.v[0]*mult[0];}else{animatorOffset+=animatorProps.p.v[0]*mult;}}if(animatorProps.a.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(mult.length){animatorOffset+=animatorProps.a.v[0]*mult[0];}else{animatorOffset+=animatorProps.a.v[0]*mult;}}}flag=true;// Force alignment only works with a single line for now
if(this._pathData.a.v){currentLength=letters[0].an*0.5+(totalLength-this._pathData.f.v-letters[0].an*0.5-letters[letters.length-1].an*0.5)*ind/(len-1);currentLength+=this._pathData.f.v;}while(flag){if(segmentLength+partialLength>=currentLength+animatorOffset||!points){perc=(currentLength+animatorOffset-segmentLength)/currentPoint.partialLength;xPathPos=prevPoint.point[0]+(currentPoint.point[0]-prevPoint.point[0])*perc;yPathPos=prevPoint.point[1]+(currentPoint.point[1]-prevPoint.point[1])*perc;matrixHelper.translate(-alignment[0]*letters[i].an*0.005,-(alignment[1]*yOff)*0.01);flag=false;}else if(points){segmentLength+=currentPoint.partialLength;pointInd+=1;if(pointInd>=points.length){pointInd=0;segmentInd+=1;if(!segments[segmentInd]){if(mask.v.c){pointInd=0;segmentInd=0;points=segments[segmentInd].points;}else{segmentLength-=currentPoint.partialLength;points=null;}}else{points=segments[segmentInd].points;}}if(points){prevPoint=currentPoint;currentPoint=points[pointInd];partialLength=currentPoint.partialLength;}}}offf=letters[i].an/2-letters[i].add;matrixHelper.translate(-offf,0,0);}else{offf=letters[i].an/2-letters[i].add;matrixHelper.translate(-offf,0,0);// Grouping alignment
matrixHelper.translate(-alignment[0]*letters[i].an*0.005,-alignment[1]*yOff*0.01,0);}for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.t.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);// This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
if(xPos!==0||documentData.j!==0){if(this._hasMaskedPath){if(mult.length){currentLength+=animatorProps.t.v*mult[0];}else{currentLength+=animatorProps.t.v*mult;}}else if(mult.length){xPos+=animatorProps.t.v*mult[0];}else{xPos+=animatorProps.t.v*mult;}}}}if(documentData.strokeWidthAnim){sw=documentData.sw||0;}if(documentData.strokeColorAnim){if(documentData.sc){sc=[documentData.sc[0],documentData.sc[1],documentData.sc[2]];}else{sc=[0,0,0];}}if(documentData.fillColorAnim&&documentData.fc){fc=[documentData.fc[0],documentData.fc[1],documentData.fc[2]];}for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.a.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(mult.length){matrixHelper.translate(-animatorProps.a.v[0]*mult[0],-animatorProps.a.v[1]*mult[1],animatorProps.a.v[2]*mult[2]);}else{matrixHelper.translate(-animatorProps.a.v[0]*mult,-animatorProps.a.v[1]*mult,animatorProps.a.v[2]*mult);}}}for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.s.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(mult.length){matrixHelper.scale(1+(animatorProps.s.v[0]-1)*mult[0],1+(animatorProps.s.v[1]-1)*mult[1],1);}else{matrixHelper.scale(1+(animatorProps.s.v[0]-1)*mult,1+(animatorProps.s.v[1]-1)*mult,1);}}}for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(animatorProps.sk.propType){if(mult.length){matrixHelper.skewFromAxis(-animatorProps.sk.v*mult[0],animatorProps.sa.v*mult[1]);}else{matrixHelper.skewFromAxis(-animatorProps.sk.v*mult,animatorProps.sa.v*mult);}}if(animatorProps.r.propType){if(mult.length){matrixHelper.rotateZ(-animatorProps.r.v*mult[2]);}else{matrixHelper.rotateZ(-animatorProps.r.v*mult);}}if(animatorProps.ry.propType){if(mult.length){matrixHelper.rotateY(animatorProps.ry.v*mult[1]);}else{matrixHelper.rotateY(animatorProps.ry.v*mult);}}if(animatorProps.rx.propType){if(mult.length){matrixHelper.rotateX(animatorProps.rx.v*mult[0]);}else{matrixHelper.rotateX(animatorProps.rx.v*mult);}}if(animatorProps.o.propType){if(mult.length){elemOpacity+=(animatorProps.o.v*mult[0]-elemOpacity)*mult[0];}else{elemOpacity+=(animatorProps.o.v*mult-elemOpacity)*mult;}}if(documentData.strokeWidthAnim&&animatorProps.sw.propType){if(mult.length){sw+=animatorProps.sw.v*mult[0];}else{sw+=animatorProps.sw.v*mult;}}if(documentData.strokeColorAnim&&animatorProps.sc.propType){for(k=0;k<3;k+=1){if(mult.length){sc[k]+=(animatorProps.sc.v[k]-sc[k])*mult[0];}else{sc[k]+=(animatorProps.sc.v[k]-sc[k])*mult;}}}if(documentData.fillColorAnim&&documentData.fc){if(animatorProps.fc.propType){for(k=0;k<3;k+=1){if(mult.length){fc[k]+=(animatorProps.fc.v[k]-fc[k])*mult[0];}else{fc[k]+=(animatorProps.fc.v[k]-fc[k])*mult;}}}if(animatorProps.fh.propType){if(mult.length){fc=addHueToRGB(fc,animatorProps.fh.v*mult[0]);}else{fc=addHueToRGB(fc,animatorProps.fh.v*mult);}}if(animatorProps.fs.propType){if(mult.length){fc=addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);}else{fc=addSaturationToRGB(fc,animatorProps.fs.v*mult);}}if(animatorProps.fb.propType){if(mult.length){fc=addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);}else{fc=addBrightnessToRGB(fc,animatorProps.fb.v*mult);}}}}for(j=0;j<jLen;j+=1){animatorProps=animators[j].a;if(animatorProps.p.propType){animatorSelector=animators[j].s;mult=animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);if(this._hasMaskedPath){if(mult.length){matrixHelper.translate(0,animatorProps.p.v[1]*mult[0],-animatorProps.p.v[2]*mult[1]);}else{matrixHelper.translate(0,animatorProps.p.v[1]*mult,-animatorProps.p.v[2]*mult);}}else if(mult.length){matrixHelper.translate(animatorProps.p.v[0]*mult[0],animatorProps.p.v[1]*mult[1],-animatorProps.p.v[2]*mult[2]);}else{matrixHelper.translate(animatorProps.p.v[0]*mult,animatorProps.p.v[1]*mult,-animatorProps.p.v[2]*mult);}}}if(documentData.strokeWidthAnim){letterSw=sw<0?0:sw;}if(documentData.strokeColorAnim){letterSc='rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';}if(documentData.fillColorAnim&&documentData.fc){letterFc='rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';}if(this._hasMaskedPath){matrixHelper.translate(0,-documentData.ls);matrixHelper.translate(0,alignment[1]*yOff*0.01+yPos,0);if(this._pathData.p.v){tanAngle=(currentPoint.point[1]-prevPoint.point[1])/(currentPoint.point[0]-prevPoint.point[0]);var rot=Math.atan(tanAngle)*180/Math.PI;if(currentPoint.point[0]<prevPoint.point[0]){rot+=180;}matrixHelper.rotate(-rot*Math.PI/180);}matrixHelper.translate(xPathPos,yPathPos,0);currentLength-=alignment[0]*letters[i].an*0.005;if(letters[i+1]&&ind!==letters[i+1].ind){currentLength+=letters[i].an/2;currentLength+=documentData.tr*0.001*documentData.finalSize;}}else{matrixHelper.translate(xPos,yPos,0);if(documentData.ps){// matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
matrixHelper.translate(documentData.ps[0],documentData.ps[1]+documentData.ascent,0);}switch(documentData.j){case 1:matrixHelper.translate(letters[i].animatorJustifyOffset+documentData.justifyOffset+(documentData.boxWidth-documentData.lineWidths[letters[i].line]),0,0);break;case 2:matrixHelper.translate(letters[i].animatorJustifyOffset+documentData.justifyOffset+(documentData.boxWidth-documentData.lineWidths[letters[i].line])/2,0,0);break;default:break;}matrixHelper.translate(0,-documentData.ls);matrixHelper.translate(offf,0,0);matrixHelper.translate(alignment[0]*letters[i].an*0.005,alignment[1]*yOff*0.01,0);xPos+=letters[i].l+documentData.tr*0.001*documentData.finalSize;}if(renderType==='html'){letterM=matrixHelper.toCSS();}else if(renderType==='svg'){letterM=matrixHelper.to2dCSS();}else{letterP=[matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];}letterO=elemOpacity;}if(renderedLettersCount<=i){letterValue=new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);this.renderedLetters.push(letterValue);renderedLettersCount+=1;this.lettersChangedFlag=true;}else{letterValue=this.renderedLetters[i];this.lettersChangedFlag=letterValue.update(letterO,letterSw,letterSc,letterFc,letterM,letterP)||this.lettersChangedFlag;}}};TextAnimatorProperty.prototype.getValue=function(){if(this._elem.globalData.frameId===this._frameId){return;}this._frameId=this._elem.globalData.frameId;this.iterateDynamicProperties();};TextAnimatorProperty.prototype.mHelper=new Matrix();TextAnimatorProperty.prototype.defaultPropsArray=[];extendPrototype([DynamicPropertyContainer],TextAnimatorProperty);function ITextElement(){}ITextElement.prototype.initElement=function(data,globalData,comp){this.lettersChangedFlag=true;this.initFrame();this.initBaseData(data,globalData,comp);this.textProperty=new TextProperty(this,data.t,this.dynamicProperties);this.textAnimator=new TextAnimatorProperty(data.t,this.renderType,this);this.initTransform(data,globalData,comp);this.initHierarchy();this.initRenderable();this.initRendererElement();this.createContainerElements();this.createRenderableComponents();this.createContent();this.hide();this.textAnimator.searchProperties(this.dynamicProperties);};ITextElement.prototype.prepareFrame=function(num){this._mdf=false;this.prepareRenderableFrame(num);this.prepareProperties(num,this.isInRange);};ITextElement.prototype.createPathShape=function(matrixHelper,shapes){var j;var jLen=shapes.length;var pathNodes;var shapeStr='';for(j=0;j<jLen;j+=1){if(shapes[j].ty==='sh'){pathNodes=shapes[j].ks.k;shapeStr+=buildShapeString(pathNodes,pathNodes.i.length,true,matrixHelper);}}return shapeStr;};ITextElement.prototype.updateDocumentData=function(newData,index){this.textProperty.updateDocumentData(newData,index);};ITextElement.prototype.canResizeFont=function(_canResize){this.textProperty.canResizeFont(_canResize);};ITextElement.prototype.setMinimumFontSize=function(_fontSize){this.textProperty.setMinimumFontSize(_fontSize);};ITextElement.prototype.applyTextPropertiesToMatrix=function(documentData,matrixHelper,lineNumber,xPos,yPos){if(documentData.ps){matrixHelper.translate(documentData.ps[0],documentData.ps[1]+documentData.ascent,0);}matrixHelper.translate(0,-documentData.ls,0);switch(documentData.j){case 1:matrixHelper.translate(documentData.justifyOffset+(documentData.boxWidth-documentData.lineWidths[lineNumber]),0,0);break;case 2:matrixHelper.translate(documentData.justifyOffset+(documentData.boxWidth-documentData.lineWidths[lineNumber])/2,0,0);break;default:break;}matrixHelper.translate(xPos,yPos,0);};ITextElement.prototype.buildColor=function(colorData){return'rgb('+Math.round(colorData[0]*255)+','+Math.round(colorData[1]*255)+','+Math.round(colorData[2]*255)+')';};ITextElement.prototype.emptyProp=new LetterProps();ITextElement.prototype.destroy=function(){};ITextElement.prototype.validateText=function(){if(this.textProperty._mdf||this.textProperty._isFirstFrame){this.buildNewText();this.textProperty._isFirstFrame=false;this.textProperty._mdf=false;}};var emptyShapeData={shapes:[]};function SVGTextLottieElement(data,globalData,comp){this.textSpans=[];this.renderType='svg';this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,SVGBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement],SVGTextLottieElement);SVGTextLottieElement.prototype.createContent=function(){if(this.data.singleShape&&!this.globalData.fontManager.chars){this.textContainer=createNS('text');}};SVGTextLottieElement.prototype.buildTextContents=function(textArray){var i=0;var len=textArray.length;var textContents=[];var currentTextContent='';while(i<len){if(textArray[i]===String.fromCharCode(13)||textArray[i]===String.fromCharCode(3)){textContents.push(currentTextContent);currentTextContent='';}else{currentTextContent+=textArray[i];}i+=1;}textContents.push(currentTextContent);return textContents;};SVGTextLottieElement.prototype.buildShapeData=function(data,scale){// data should probably be cloned to apply scale separately to each instance of a text on different layers
// but since text internal content gets only rendered once and then it's never rerendered,
// it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
// Avoiding cloning is preferred since cloning each character shape data is expensive
if(data.shapes&&data.shapes.length){var shape=data.shapes[0];if(shape.it){var shapeItem=shape.it[shape.it.length-1];if(shapeItem.s){shapeItem.s.k[0]=scale;shapeItem.s.k[1]=scale;}}}return data;};SVGTextLottieElement.prototype.buildNewText=function(){this.addDynamicProperty(this);var i;var len;var documentData=this.textProperty.currentData;this.renderedLetters=createSizedArray(documentData?documentData.l.length:0);if(documentData.fc){this.layerElement.setAttribute('fill',this.buildColor(documentData.fc));}else{this.layerElement.setAttribute('fill','rgba(0,0,0,0)');}if(documentData.sc){this.layerElement.setAttribute('stroke',this.buildColor(documentData.sc));this.layerElement.setAttribute('stroke-width',documentData.sw);}this.layerElement.setAttribute('font-size',documentData.finalSize);var fontData=this.globalData.fontManager.getFontByName(documentData.f);if(fontData.fClass){this.layerElement.setAttribute('class',fontData.fClass);}else{this.layerElement.setAttribute('font-family',fontData.fFamily);var fWeight=documentData.fWeight;var fStyle=documentData.fStyle;this.layerElement.setAttribute('font-style',fStyle);this.layerElement.setAttribute('font-weight',fWeight);}this.layerElement.setAttribute('aria-label',documentData.t);var letters=documentData.l||[];var usesGlyphs=!!this.globalData.fontManager.chars;len=letters.length;var tSpan;var matrixHelper=this.mHelper;var shapeStr='';var singleShape=this.data.singleShape;var xPos=0;var yPos=0;var firstLine=true;var trackingOffset=documentData.tr*0.001*documentData.finalSize;if(singleShape&&!usesGlyphs&&!documentData.sz){var tElement=this.textContainer;var justify='start';switch(documentData.j){case 1:justify='end';break;case 2:justify='middle';break;default:justify='start';break;}tElement.setAttribute('text-anchor',justify);tElement.setAttribute('letter-spacing',trackingOffset);var textContent=this.buildTextContents(documentData.finalText);len=textContent.length;yPos=documentData.ps?documentData.ps[1]+documentData.ascent:0;for(i=0;i<len;i+=1){tSpan=this.textSpans[i].span||createNS('tspan');tSpan.textContent=textContent[i];tSpan.setAttribute('x',0);tSpan.setAttribute('y',yPos);tSpan.style.display='inherit';tElement.appendChild(tSpan);if(!this.textSpans[i]){this.textSpans[i]={span:null,glyph:null};}this.textSpans[i].span=tSpan;yPos+=documentData.finalLineHeight;}this.layerElement.appendChild(tElement);}else{var cachedSpansLength=this.textSpans.length;var charData;for(i=0;i<len;i+=1){if(!this.textSpans[i]){this.textSpans[i]={span:null,childSpan:null,glyph:null};}if(!usesGlyphs||!singleShape||i===0){tSpan=cachedSpansLength>i?this.textSpans[i].span:createNS(usesGlyphs?'g':'text');if(cachedSpansLength<=i){tSpan.setAttribute('stroke-linecap','butt');tSpan.setAttribute('stroke-linejoin','round');tSpan.setAttribute('stroke-miterlimit','4');this.textSpans[i].span=tSpan;if(usesGlyphs){var childSpan=createNS('g');tSpan.appendChild(childSpan);this.textSpans[i].childSpan=childSpan;}this.textSpans[i].span=tSpan;this.layerElement.appendChild(tSpan);}tSpan.style.display='inherit';}matrixHelper.reset();if(singleShape){if(letters[i].n){xPos=-trackingOffset;yPos+=documentData.yOffset;yPos+=firstLine?1:0;firstLine=false;}this.applyTextPropertiesToMatrix(documentData,matrixHelper,letters[i].line,xPos,yPos);xPos+=letters[i].l||0;// xPos += letters[i].val === ' ' ? 0 : trackingOffset;
xPos+=trackingOffset;}if(usesGlyphs){charData=this.globalData.fontManager.getCharData(documentData.finalText[i],fontData.fStyle,this.globalData.fontManager.getFontByName(documentData.f).fFamily);var glyphElement;// t === 1 means the character has been replaced with an animated shaped
if(charData.t===1){glyphElement=new SVGCompElement(charData.data,this.globalData,this);}else{var data=emptyShapeData;if(charData.data&&charData.data.shapes){data=this.buildShapeData(charData.data,documentData.finalSize);}glyphElement=new SVGShapeElement(data,this.globalData,this);}if(this.textSpans[i].glyph){var glyph=this.textSpans[i].glyph;this.textSpans[i].childSpan.removeChild(glyph.layerElement);glyph.destroy();}this.textSpans[i].glyph=glyphElement;glyphElement._debug=true;glyphElement.prepareFrame(0);glyphElement.renderFrame();this.textSpans[i].childSpan.appendChild(glyphElement.layerElement);// when using animated shapes, the layer will be scaled instead of replacing the internal scale
// this might have issues with strokes and might need a different solution
if(charData.t===1){this.textSpans[i].childSpan.setAttribute('transform','scale('+documentData.finalSize/100+','+documentData.finalSize/100+')');}}else{if(singleShape){tSpan.setAttribute('transform','translate('+matrixHelper.props[12]+','+matrixHelper.props[13]+')');}tSpan.textContent=letters[i].val;tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace','xml:space','preserve');}//
}if(singleShape&&tSpan){tSpan.setAttribute('d',shapeStr);}}while(i<this.textSpans.length){this.textSpans[i].span.style.display='none';i+=1;}this._sizeChanged=true;};SVGTextLottieElement.prototype.sourceRectAtTime=function(){this.prepareFrame(this.comp.renderedFrame-this.data.st);this.renderInnerContent();if(this._sizeChanged){this._sizeChanged=false;var textBox=this.layerElement.getBBox();this.bbox={top:textBox.y,left:textBox.x,width:textBox.width,height:textBox.height};}return this.bbox;};SVGTextLottieElement.prototype.getValue=function(){var i;var len=this.textSpans.length;var glyphElement;this.renderedFrame=this.comp.renderedFrame;for(i=0;i<len;i+=1){glyphElement=this.textSpans[i].glyph;if(glyphElement){glyphElement.prepareFrame(this.comp.renderedFrame-this.data.st);if(glyphElement._mdf){this._mdf=true;}}}};SVGTextLottieElement.prototype.renderInnerContent=function(){this.validateText();if(!this.data.singleShape||this._mdf){this.textAnimator.getMeasures(this.textProperty.currentData,this.lettersChangedFlag);if(this.lettersChangedFlag||this.textAnimator.lettersChangedFlag){this._sizeChanged=true;var i;var len;var renderedLetters=this.textAnimator.renderedLetters;var letters=this.textProperty.currentData.l;len=letters.length;var renderedLetter;var textSpan;var glyphElement;for(i=0;i<len;i+=1){if(!letters[i].n){renderedLetter=renderedLetters[i];textSpan=this.textSpans[i].span;glyphElement=this.textSpans[i].glyph;if(glyphElement){glyphElement.renderFrame();}if(renderedLetter._mdf.m){textSpan.setAttribute('transform',renderedLetter.m);}if(renderedLetter._mdf.o){textSpan.setAttribute('opacity',renderedLetter.o);}if(renderedLetter._mdf.sw){textSpan.setAttribute('stroke-width',renderedLetter.sw);}if(renderedLetter._mdf.sc){textSpan.setAttribute('stroke',renderedLetter.sc);}if(renderedLetter._mdf.fc){textSpan.setAttribute('fill',renderedLetter.fc);}}}}}};function ISolidElement(data,globalData,comp){this.initElement(data,globalData,comp);}extendPrototype([IImageElement],ISolidElement);ISolidElement.prototype.createContent=function(){var rect=createNS('rect');/// /rect.style.width = this.data.sw;
/// /rect.style.height = this.data.sh;
/// /rect.style.fill = this.data.sc;
rect.setAttribute('width',this.data.sw);rect.setAttribute('height',this.data.sh);rect.setAttribute('fill',this.data.sc);this.layerElement.appendChild(rect);};function NullElement(data,globalData,comp){this.initFrame();this.initBaseData(data,globalData,comp);this.initFrame();this.initTransform(data,globalData,comp);this.initHierarchy();}NullElement.prototype.prepareFrame=function(num){this.prepareProperties(num,true);};NullElement.prototype.renderFrame=function(){};NullElement.prototype.getBaseElement=function(){return null;};NullElement.prototype.destroy=function(){};NullElement.prototype.sourceRectAtTime=function(){};NullElement.prototype.hide=function(){};extendPrototype([BaseElement,TransformElement,HierarchyElement,FrameElement],NullElement);function SVGRendererBase(){}extendPrototype([BaseRenderer],SVGRendererBase);SVGRendererBase.prototype.createNull=function(data){return new NullElement(data,this.globalData,this);};SVGRendererBase.prototype.createShape=function(data){return new SVGShapeElement(data,this.globalData,this);};SVGRendererBase.prototype.createText=function(data){return new SVGTextLottieElement(data,this.globalData,this);};SVGRendererBase.prototype.createImage=function(data){return new IImageElement(data,this.globalData,this);};SVGRendererBase.prototype.createSolid=function(data){return new ISolidElement(data,this.globalData,this);};SVGRendererBase.prototype.configAnimation=function(animData){this.svgElement.setAttribute('xmlns','http://www.w3.org/2000/svg');this.svgElement.setAttribute('xmlns:xlink','http://www.w3.org/1999/xlink');if(this.renderConfig.viewBoxSize){this.svgElement.setAttribute('viewBox',this.renderConfig.viewBoxSize);}else{this.svgElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);}if(!this.renderConfig.viewBoxOnly){this.svgElement.setAttribute('width',animData.w);this.svgElement.setAttribute('height',animData.h);this.svgElement.style.width='100%';this.svgElement.style.height='100%';this.svgElement.style.transform='translate3d(0,0,0)';this.svgElement.style.contentVisibility=this.renderConfig.contentVisibility;}if(this.renderConfig.width){this.svgElement.setAttribute('width',this.renderConfig.width);}if(this.renderConfig.height){this.svgElement.setAttribute('height',this.renderConfig.height);}if(this.renderConfig.className){this.svgElement.setAttribute('class',this.renderConfig.className);}if(this.renderConfig.id){this.svgElement.setAttribute('id',this.renderConfig.id);}if(this.renderConfig.focusable!==undefined){this.svgElement.setAttribute('focusable',this.renderConfig.focusable);}this.svgElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);// this.layerElement.style.transform = 'translate3d(0,0,0)';
// this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
this.animationItem.wrapper.appendChild(this.svgElement);// Mask animation
var defs=this.globalData.defs;this.setupGlobalData(animData,defs);this.globalData.progressiveLoad=this.renderConfig.progressiveLoad;this.data=animData;var maskElement=createNS('clipPath');var rect=createNS('rect');rect.setAttribute('width',animData.w);rect.setAttribute('height',animData.h);rect.setAttribute('x',0);rect.setAttribute('y',0);var maskId=createElementID();maskElement.setAttribute('id',maskId);maskElement.appendChild(rect);this.layerElement.setAttribute('clip-path','url('+getLocationHref()+'#'+maskId+')');defs.appendChild(maskElement);this.layers=animData.layers;this.elements=createSizedArray(animData.layers.length);};SVGRendererBase.prototype.destroy=function(){if(this.animationItem.wrapper){this.animationItem.wrapper.innerText='';}this.layerElement=null;this.globalData.defs=null;var i;var len=this.layers?this.layers.length:0;for(i=0;i<len;i+=1){if(this.elements[i]&&this.elements[i].destroy){this.elements[i].destroy();}}this.elements.length=0;this.destroyed=true;this.animationItem=null;};SVGRendererBase.prototype.updateContainerSize=function(){};SVGRendererBase.prototype.findIndexByInd=function(ind){var i=0;var len=this.layers.length;for(i=0;i<len;i+=1){if(this.layers[i].ind===ind){return i;}}return-1;};SVGRendererBase.prototype.buildItem=function(pos){var elements=this.elements;if(elements[pos]||this.layers[pos].ty===99){return;}elements[pos]=true;var element=this.createItem(this.layers[pos]);elements[pos]=element;if(getExpressionsPlugin()){if(this.layers[pos].ty===0){this.globalData.projectInterface.registerComposition(element);}element.initExpressions();}this.appendElementInPos(element,pos);if(this.layers[pos].tt){var elementIndex='tp'in this.layers[pos]?this.findIndexByInd(this.layers[pos].tp):pos-1;if(elementIndex===-1){return;}if(!this.elements[elementIndex]||this.elements[elementIndex]===true){this.buildItem(elementIndex);this.addPendingElement(element);}else{var matteElement=elements[elementIndex];var matteMask=matteElement.getMatte(this.layers[pos].tt);element.setMatte(matteMask);}}};SVGRendererBase.prototype.checkPendingElements=function(){while(this.pendingElements.length){var element=this.pendingElements.pop();element.checkParenting();if(element.data.tt){var i=0;var len=this.elements.length;while(i<len){if(this.elements[i]===element){var elementIndex='tp'in element.data?this.findIndexByInd(element.data.tp):i-1;var matteElement=this.elements[elementIndex];var matteMask=matteElement.getMatte(this.layers[i].tt);element.setMatte(matteMask);break;}i+=1;}}}};SVGRendererBase.prototype.renderFrame=function(num){if(this.renderedFrame===num||this.destroyed){return;}if(num===null){num=this.renderedFrame;}else{this.renderedFrame=num;}// console.log('-------');
// console.log('FRAME ',num);
this.globalData.frameNum=num;this.globalData.frameId+=1;this.globalData.projectInterface.currentFrame=num;this.globalData._mdf=false;var i;var len=this.layers.length;if(!this.completeLayers){this.checkLayers(num);}for(i=len-1;i>=0;i-=1){if(this.completeLayers||this.elements[i]){this.elements[i].prepareFrame(num-this.layers[i].st);}}if(this.globalData._mdf){for(i=0;i<len;i+=1){if(this.completeLayers||this.elements[i]){this.elements[i].renderFrame();}}}};SVGRendererBase.prototype.appendElementInPos=function(element,pos){var newElement=element.getBaseElement();if(!newElement){return;}var i=0;var nextElement;while(i<pos){if(this.elements[i]&&this.elements[i]!==true&&this.elements[i].getBaseElement()){nextElement=this.elements[i].getBaseElement();}i+=1;}if(nextElement){this.layerElement.insertBefore(newElement,nextElement);}else{this.layerElement.appendChild(newElement);}};SVGRendererBase.prototype.hide=function(){this.layerElement.style.display='none';};SVGRendererBase.prototype.show=function(){this.layerElement.style.display='block';};function ICompElement(){}extendPrototype([BaseElement,TransformElement,HierarchyElement,FrameElement,RenderableDOMElement],ICompElement);ICompElement.prototype.initElement=function(data,globalData,comp){this.initFrame();this.initBaseData(data,globalData,comp);this.initTransform(data,globalData,comp);this.initRenderable();this.initHierarchy();this.initRendererElement();this.createContainerElements();this.createRenderableComponents();if(this.data.xt||!globalData.progressiveLoad){this.buildAllItems();}this.hide();};/* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ICompElement.prototype.prepareFrame=function(num){this._mdf=false;this.prepareRenderableFrame(num);this.prepareProperties(num,this.isInRange);if(!this.isInRange&&!this.data.xt){return;}if(!this.tm._placeholder){var timeRemapped=this.tm.v;if(timeRemapped===this.data.op){timeRemapped=this.data.op-1;}this.renderedFrame=timeRemapped;}else{this.renderedFrame=num/this.data.sr;}var i;var len=this.elements.length;if(!this.completeLayers){this.checkLayers(this.renderedFrame);}// This iteration needs to be backwards because of how expressions connect between each other
for(i=len-1;i>=0;i-=1){if(this.completeLayers||this.elements[i]){this.elements[i].prepareFrame(this.renderedFrame-this.layers[i].st);if(this.elements[i]._mdf){this._mdf=true;}}}};ICompElement.prototype.renderInnerContent=function(){var i;var len=this.layers.length;for(i=0;i<len;i+=1){if(this.completeLayers||this.elements[i]){this.elements[i].renderFrame();}}};ICompElement.prototype.setElements=function(elems){this.elements=elems;};ICompElement.prototype.getElements=function(){return this.elements;};ICompElement.prototype.destroyElements=function(){var i;var len=this.layers.length;for(i=0;i<len;i+=1){if(this.elements[i]){this.elements[i].destroy();}}};ICompElement.prototype.destroy=function(){this.destroyElements();this.destroyBaseElement();};function SVGCompElement(data,globalData,comp){this.layers=data.layers;this.supports3d=true;this.completeLayers=false;this.pendingElements=[];this.elements=this.layers?createSizedArray(this.layers.length):[];this.initElement(data,globalData,comp);this.tm=data.tm?PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this):{_placeholder:true};}extendPrototype([SVGRendererBase,ICompElement,SVGBaseElement],SVGCompElement);SVGCompElement.prototype.createComp=function(data){return new SVGCompElement(data,this.globalData,this);};function SVGRenderer(animationItem,config){this.animationItem=animationItem;this.layers=null;this.renderedFrame=-1;this.svgElement=createNS('svg');var ariaLabel='';if(config&&config.title){var titleElement=createNS('title');var titleId=createElementID();titleElement.setAttribute('id',titleId);titleElement.textContent=config.title;this.svgElement.appendChild(titleElement);ariaLabel+=titleId;}if(config&&config.description){var descElement=createNS('desc');var descId=createElementID();descElement.setAttribute('id',descId);descElement.textContent=config.description;this.svgElement.appendChild(descElement);ariaLabel+=' '+descId;}if(ariaLabel){this.svgElement.setAttribute('aria-labelledby',ariaLabel);}var defs=createNS('defs');this.svgElement.appendChild(defs);var maskElement=createNS('g');this.svgElement.appendChild(maskElement);this.layerElement=maskElement;this.renderConfig={preserveAspectRatio:config&&config.preserveAspectRatio||'xMidYMid meet',imagePreserveAspectRatio:config&&config.imagePreserveAspectRatio||'xMidYMid slice',contentVisibility:config&&config.contentVisibility||'visible',progressiveLoad:config&&config.progressiveLoad||false,hideOnTransparent:!(config&&config.hideOnTransparent===false),viewBoxOnly:config&&config.viewBoxOnly||false,viewBoxSize:config&&config.viewBoxSize||false,className:config&&config.className||'',id:config&&config.id||'',focusable:config&&config.focusable,filterSize:{width:config&&config.filterSize&&config.filterSize.width||'100%',height:config&&config.filterSize&&config.filterSize.height||'100%',x:config&&config.filterSize&&config.filterSize.x||'0%',y:config&&config.filterSize&&config.filterSize.y||'0%'},width:config&&config.width,height:config&&config.height,runExpressions:!config||config.runExpressions===undefined||config.runExpressions};this.globalData={_mdf:false,frameNum:-1,defs:defs,renderConfig:this.renderConfig};this.elements=[];this.pendingElements=[];this.destroyed=false;this.rendererType='svg';}extendPrototype([SVGRendererBase],SVGRenderer);SVGRenderer.prototype.createComp=function(data){return new SVGCompElement(data,this.globalData,this);};function ShapeTransformManager(){this.sequences={};this.sequenceList=[];this.transform_key_count=0;}ShapeTransformManager.prototype={addTransformSequence:function addTransformSequence(transforms){var i;var len=transforms.length;var key='_';for(i=0;i<len;i+=1){key+=transforms[i].transform.key+'_';}var sequence=this.sequences[key];if(!sequence){sequence={transforms:[].concat(transforms),finalTransform:new Matrix(),_mdf:false};this.sequences[key]=sequence;this.sequenceList.push(sequence);}return sequence;},processSequence:function processSequence(sequence,isFirstFrame){var i=0;var len=sequence.transforms.length;var _mdf=isFirstFrame;while(i<len&&!isFirstFrame){if(sequence.transforms[i].transform.mProps._mdf){_mdf=true;break;}i+=1;}if(_mdf){sequence.finalTransform.reset();for(i=len-1;i>=0;i-=1){sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);}}sequence._mdf=_mdf;},processSequences:function processSequences(isFirstFrame){var i;var len=this.sequenceList.length;for(i=0;i<len;i+=1){this.processSequence(this.sequenceList[i],isFirstFrame);}},getNewKey:function getNewKey(){this.transform_key_count+=1;return'_'+this.transform_key_count;}};var lumaLoader=function lumaLoader(){var id='__lottie_element_luma_buffer';var lumaBuffer=null;var lumaBufferCtx=null;var svg=null;// This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
// Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
// For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
// Naming it solution 2 to mark the extra comment lines.
/*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */function createLumaSvgFilter(){var _svg=createNS('svg');var fil=createNS('filter');var matrix=createNS('feColorMatrix');fil.setAttribute('id',id);matrix.setAttribute('type','matrix');matrix.setAttribute('color-interpolation-filters','sRGB');matrix.setAttribute('values','0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');fil.appendChild(matrix);_svg.appendChild(fil);_svg.setAttribute('id',id+'_svg');if(featureSupport.svgLumaHidden){_svg.style.display='none';}return _svg;}function loadLuma(){if(!lumaBuffer){svg=createLumaSvgFilter();document.body.appendChild(svg);lumaBuffer=createTag('canvas');lumaBufferCtx=lumaBuffer.getContext('2d');// lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
lumaBufferCtx.filter='url(#'+id+')';lumaBufferCtx.fillStyle='rgba(0,0,0,0)';lumaBufferCtx.fillRect(0,0,1,1);}}function getLuma(canvas){if(!lumaBuffer){loadLuma();}lumaBuffer.width=canvas.width;lumaBuffer.height=canvas.height;// lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
lumaBufferCtx.filter='url(#'+id+')';return lumaBuffer;}return{load:loadLuma,get:getLuma};};function createCanvas(width,height){if(featureSupport.offscreenCanvas){return new OffscreenCanvas(width,height);}var canvas=createTag('canvas');canvas.width=width;canvas.height=height;return canvas;}var assetLoader=function(){return{loadLumaCanvas:lumaLoader.load,getLumaCanvas:lumaLoader.get,createCanvas:createCanvas};}();var registeredEffects={};function CVEffects(elem){var i;var len=elem.data.ef?elem.data.ef.length:0;this.filters=[];var filterManager;for(i=0;i<len;i+=1){filterManager=null;var type=elem.data.ef[i].ty;if(registeredEffects[type]){var Effect=registeredEffects[type].effect;filterManager=new Effect(elem.effectsManager.effectElements[i],elem);}if(filterManager){this.filters.push(filterManager);}}if(this.filters.length){elem.addRenderableComponent(this);}}CVEffects.prototype.renderFrame=function(_isFirstFrame){var i;var len=this.filters.length;for(i=0;i<len;i+=1){this.filters[i].renderFrame(_isFirstFrame);}};CVEffects.prototype.getEffects=function(type){var i;var len=this.filters.length;var effects=[];for(i=0;i<len;i+=1){if(this.filters[i].type===type){effects.push(this.filters[i]);}}return effects;};function registerEffect(id,effect){registeredEffects[id]={effect:effect};}function CVMaskElement(data,element){this.data=data;this.element=element;this.masksProperties=this.data.masksProperties||[];this.viewData=createSizedArray(this.masksProperties.length);var i;var len=this.masksProperties.length;var hasMasks=false;for(i=0;i<len;i+=1){if(this.masksProperties[i].mode!=='n'){hasMasks=true;}this.viewData[i]=ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3);}this.hasMasks=hasMasks;if(hasMasks){this.element.addRenderableComponent(this);}}CVMaskElement.prototype.renderFrame=function(){if(!this.hasMasks){return;}var transform=this.element.finalTransform.mat;var ctx=this.element.canvasContext;var i;var len=this.masksProperties.length;var pt;var pts;var data;ctx.beginPath();for(i=0;i<len;i+=1){if(this.masksProperties[i].mode!=='n'){if(this.masksProperties[i].inv){ctx.moveTo(0,0);ctx.lineTo(this.element.globalData.compSize.w,0);ctx.lineTo(this.element.globalData.compSize.w,this.element.globalData.compSize.h);ctx.lineTo(0,this.element.globalData.compSize.h);ctx.lineTo(0,0);}data=this.viewData[i].v;pt=transform.applyToPointArray(data.v[0][0],data.v[0][1],0);ctx.moveTo(pt[0],pt[1]);var j;var jLen=data._length;for(j=1;j<jLen;j+=1){pts=transform.applyToTriplePoints(data.o[j-1],data.i[j],data.v[j]);ctx.bezierCurveTo(pts[0],pts[1],pts[2],pts[3],pts[4],pts[5]);}pts=transform.applyToTriplePoints(data.o[j-1],data.i[0],data.v[0]);ctx.bezierCurveTo(pts[0],pts[1],pts[2],pts[3],pts[4],pts[5]);}}this.element.globalData.renderer.save(true);ctx.clip();};CVMaskElement.prototype.getMaskProperty=MaskElement.prototype.getMaskProperty;CVMaskElement.prototype.destroy=function(){this.element=null;};function CVBaseElement(){}var operationsMap={1:'source-in',2:'source-out',3:'source-in',4:'source-out'};CVBaseElement.prototype={createElements:function createElements(){},initRendererElement:function initRendererElement(){},createContainerElements:function createContainerElements(){// If the layer is masked we will use two buffers to store each different states of the drawing
// This solution is not ideal for several reason. But unfortunately, because of the recursive
// nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
// TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
// It might be challenging because the layer most likely is transformed in some way
if(this.data.tt>=1){this.buffers=[];var canvasContext=this.globalData.canvasContext;var bufferCanvas=assetLoader.createCanvas(canvasContext.canvas.width,canvasContext.canvas.height);this.buffers.push(bufferCanvas);var bufferCanvas2=assetLoader.createCanvas(canvasContext.canvas.width,canvasContext.canvas.height);this.buffers.push(bufferCanvas2);if(this.data.tt>=3&&!document._isProxy){assetLoader.loadLumaCanvas();}}this.canvasContext=this.globalData.canvasContext;this.transformCanvas=this.globalData.transformCanvas;this.renderableEffectsManager=new CVEffects(this);this.searchEffectTransforms();},createContent:function createContent(){},setBlendMode:function setBlendMode(){var globalData=this.globalData;if(globalData.blendMode!==this.data.bm){globalData.blendMode=this.data.bm;var blendModeValue=getBlendMode(this.data.bm);globalData.canvasContext.globalCompositeOperation=blendModeValue;}},createRenderableComponents:function createRenderableComponents(){this.maskManager=new CVMaskElement(this.data,this);this.transformEffects=this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);},hideElement:function hideElement(){if(!this.hidden&&(!this.isInRange||this.isTransparent)){this.hidden=true;}},showElement:function showElement(){if(this.isInRange&&!this.isTransparent){this.hidden=false;this._isFirstFrame=true;this.maskManager._isFirstFrame=true;}},clearCanvas:function clearCanvas(canvasContext){canvasContext.clearRect(this.transformCanvas.tx,this.transformCanvas.ty,this.transformCanvas.w*this.transformCanvas.sx,this.transformCanvas.h*this.transformCanvas.sy);},prepareLayer:function prepareLayer(){if(this.data.tt>=1){var buffer=this.buffers[0];var bufferCtx=buffer.getContext('2d');this.clearCanvas(bufferCtx);// on the first buffer we store the current state of the global drawing
bufferCtx.drawImage(this.canvasContext.canvas,0,0);// The next four lines are to clear the canvas
// TODO: Check if there is a way to clear the canvas without resetting the transform
this.currentTransform=this.canvasContext.getTransform();this.canvasContext.setTransform(1,0,0,1,0,0);this.clearCanvas(this.canvasContext);this.canvasContext.setTransform(this.currentTransform);}},exitLayer:function exitLayer(){if(this.data.tt>=1){var buffer=this.buffers[1];// On the second buffer we store the current state of the global drawing
// that only contains the content of this layer
// (if it is a composition, it also includes the nested layers)
var bufferCtx=buffer.getContext('2d');this.clearCanvas(bufferCtx);bufferCtx.drawImage(this.canvasContext.canvas,0,0);// We clear the canvas again
this.canvasContext.setTransform(1,0,0,1,0,0);this.clearCanvas(this.canvasContext);this.canvasContext.setTransform(this.currentTransform);// We draw the mask
var mask=this.comp.getElementById('tp'in this.data?this.data.tp:this.data.ind-1);mask.renderFrame(true);// We draw the second buffer (that contains the content of this layer)
this.canvasContext.setTransform(1,0,0,1,0,0);// If the mask is a Luma matte, we need to do two extra painting operations
// the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
if(this.data.tt>=3&&!document._isProxy){// We copy the painted mask to a buffer that has a color matrix filter applied to it
// that applies the rgb values to the alpha channel
var lumaBuffer=assetLoader.getLumaCanvas(this.canvasContext.canvas);var lumaBufferCtx=lumaBuffer.getContext('2d');lumaBufferCtx.drawImage(this.canvasContext.canvas,0,0);this.clearCanvas(this.canvasContext);// we repaint the context with the mask applied to it
this.canvasContext.drawImage(lumaBuffer,0,0);}this.canvasContext.globalCompositeOperation=operationsMap[this.data.tt];this.canvasContext.drawImage(buffer,0,0);// We finally draw the first buffer (that contains the content of the global drawing)
// We use destination-over to draw the global drawing below the current layer
this.canvasContext.globalCompositeOperation='destination-over';this.canvasContext.drawImage(this.buffers[0],0,0);this.canvasContext.setTransform(this.currentTransform);// We reset the globalCompositeOperation to source-over, the standard type of operation
this.canvasContext.globalCompositeOperation='source-over';}},renderFrame:function renderFrame(forceRender){if(this.hidden||this.data.hd){return;}if(this.data.td===1&&!forceRender){return;}this.renderTransform();this.renderRenderable();this.renderLocalTransform();this.setBlendMode();var forceRealStack=this.data.ty===0;this.prepareLayer();this.globalData.renderer.save(forceRealStack);this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);this.renderInnerContent();this.globalData.renderer.restore(forceRealStack);this.exitLayer();if(this.maskManager.hasMasks){this.globalData.renderer.restore(true);}if(this._isFirstFrame){this._isFirstFrame=false;}},destroy:function destroy(){this.canvasContext=null;this.data=null;this.globalData=null;this.maskManager.destroy();},mHelper:new Matrix()};CVBaseElement.prototype.hide=CVBaseElement.prototype.hideElement;CVBaseElement.prototype.show=CVBaseElement.prototype.showElement;function CVShapeData(element,data,styles,transformsManager){this.styledShapes=[];this.tr=[0,0,0,0,0,0];var ty=4;if(data.ty==='rc'){ty=5;}else if(data.ty==='el'){ty=6;}else if(data.ty==='sr'){ty=7;}this.sh=ShapePropertyFactory.getShapeProp(element,data,ty,element);var i;var len=styles.length;var styledShape;for(i=0;i<len;i+=1){if(!styles[i].closed){styledShape={transforms:transformsManager.addTransformSequence(styles[i].transforms),trNodes:[]};this.styledShapes.push(styledShape);styles[i].elements.push(styledShape);}}}CVShapeData.prototype.setAsAnimated=SVGShapeData.prototype.setAsAnimated;function CVShapeElement(data,globalData,comp){this.shapes=[];this.shapesData=data.shapes;this.stylesList=[];this.itemsData=[];this.prevViewData=[];this.shapeModifiers=[];this.processedElements=[];this.transformsManager=new ShapeTransformManager();this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,CVBaseElement,IShapeElement,HierarchyElement,FrameElement,RenderableElement],CVShapeElement);CVShapeElement.prototype.initElement=RenderableDOMElement.prototype.initElement;CVShapeElement.prototype.transformHelper={opacity:1,_opMdf:false};CVShapeElement.prototype.dashResetter=[];CVShapeElement.prototype.createContent=function(){this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,true,[]);};CVShapeElement.prototype.createStyleElement=function(data,transforms){var styleElem={data:data,type:data.ty,preTransforms:this.transformsManager.addTransformSequence(transforms),transforms:[],elements:[],closed:data.hd===true};var elementData={};if(data.ty==='fl'||data.ty==='st'){elementData.c=PropertyFactory.getProp(this,data.c,1,255,this);if(!elementData.c.k){styleElem.co='rgb('+bmFloor(elementData.c.v[0])+','+bmFloor(elementData.c.v[1])+','+bmFloor(elementData.c.v[2])+')';}}else if(data.ty==='gf'||data.ty==='gs'){elementData.s=PropertyFactory.getProp(this,data.s,1,null,this);elementData.e=PropertyFactory.getProp(this,data.e,1,null,this);elementData.h=PropertyFactory.getProp(this,data.h||{k:0},0,0.01,this);elementData.a=PropertyFactory.getProp(this,data.a||{k:0},0,degToRads,this);elementData.g=new GradientProperty(this,data.g,this);}elementData.o=PropertyFactory.getProp(this,data.o,0,0.01,this);if(data.ty==='st'||data.ty==='gs'){styleElem.lc=lineCapEnum[data.lc||2];styleElem.lj=lineJoinEnum[data.lj||2];if(data.lj==1){// eslint-disable-line eqeqeq
styleElem.ml=data.ml;}elementData.w=PropertyFactory.getProp(this,data.w,0,null,this);if(!elementData.w.k){styleElem.wi=elementData.w.v;}if(data.d){var d=new DashProperty(this,data.d,'canvas',this);elementData.d=d;if(!elementData.d.k){styleElem.da=elementData.d.dashArray;styleElem["do"]=elementData.d.dashoffset[0];}}}else{styleElem.r=data.r===2?'evenodd':'nonzero';}this.stylesList.push(styleElem);elementData.style=styleElem;return elementData;};CVShapeElement.prototype.createGroupElement=function(){var elementData={it:[],prevViewData:[]};return elementData;};CVShapeElement.prototype.createTransformElement=function(data){var elementData={transform:{opacity:1,_opMdf:false,key:this.transformsManager.getNewKey(),op:PropertyFactory.getProp(this,data.o,0,0.01,this),mProps:TransformPropertyFactory.getTransformProperty(this,data,this)}};return elementData;};CVShapeElement.prototype.createShapeElement=function(data){var elementData=new CVShapeData(this,data,this.stylesList,this.transformsManager);this.shapes.push(elementData);this.addShapeToModifiers(elementData);return elementData;};CVShapeElement.prototype.reloadShapes=function(){this._isFirstFrame=true;var i;var len=this.itemsData.length;for(i=0;i<len;i+=1){this.prevViewData[i]=this.itemsData[i];}this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,true,[]);len=this.dynamicProperties.length;for(i=0;i<len;i+=1){this.dynamicProperties[i].getValue();}this.renderModifiers();this.transformsManager.processSequences(this._isFirstFrame);};CVShapeElement.prototype.addTransformToStyleList=function(transform){var i;var len=this.stylesList.length;for(i=0;i<len;i+=1){if(!this.stylesList[i].closed){this.stylesList[i].transforms.push(transform);}}};CVShapeElement.prototype.removeTransformFromStyleList=function(){var i;var len=this.stylesList.length;for(i=0;i<len;i+=1){if(!this.stylesList[i].closed){this.stylesList[i].transforms.pop();}}};CVShapeElement.prototype.closeStyles=function(styles){var i;var len=styles.length;for(i=0;i<len;i+=1){styles[i].closed=true;}};CVShapeElement.prototype.searchShapes=function(arr,itemsData,prevViewData,shouldRender,transforms){var i;var len=arr.length-1;var j;var jLen;var ownStyles=[];var ownModifiers=[];var processedPos;var modifier;var currentTransform;var ownTransforms=[].concat(transforms);for(i=len;i>=0;i-=1){processedPos=this.searchProcessedElement(arr[i]);if(!processedPos){arr[i]._shouldRender=shouldRender;}else{itemsData[i]=prevViewData[processedPos-1];}if(arr[i].ty==='fl'||arr[i].ty==='st'||arr[i].ty==='gf'||arr[i].ty==='gs'){if(!processedPos){itemsData[i]=this.createStyleElement(arr[i],ownTransforms);}else{itemsData[i].style.closed=false;}ownStyles.push(itemsData[i].style);}else if(arr[i].ty==='gr'){if(!processedPos){itemsData[i]=this.createGroupElement(arr[i]);}else{jLen=itemsData[i].it.length;for(j=0;j<jLen;j+=1){itemsData[i].prevViewData[j]=itemsData[i].it[j];}}this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,shouldRender,ownTransforms);}else if(arr[i].ty==='tr'){if(!processedPos){currentTransform=this.createTransformElement(arr[i]);itemsData[i]=currentTransform;}ownTransforms.push(itemsData[i]);this.addTransformToStyleList(itemsData[i]);}else if(arr[i].ty==='sh'||arr[i].ty==='rc'||arr[i].ty==='el'||arr[i].ty==='sr'){if(!processedPos){itemsData[i]=this.createShapeElement(arr[i]);}}else if(arr[i].ty==='tm'||arr[i].ty==='rd'||arr[i].ty==='pb'||arr[i].ty==='zz'||arr[i].ty==='op'){if(!processedPos){modifier=ShapeModifiers.getModifier(arr[i].ty);modifier.init(this,arr[i]);itemsData[i]=modifier;this.shapeModifiers.push(modifier);}else{modifier=itemsData[i];modifier.closed=false;}ownModifiers.push(modifier);}else if(arr[i].ty==='rp'){if(!processedPos){modifier=ShapeModifiers.getModifier(arr[i].ty);itemsData[i]=modifier;modifier.init(this,arr,i,itemsData);this.shapeModifiers.push(modifier);shouldRender=false;}else{modifier=itemsData[i];modifier.closed=true;}ownModifiers.push(modifier);}this.addProcessedElement(arr[i],i+1);}this.removeTransformFromStyleList();this.closeStyles(ownStyles);len=ownModifiers.length;for(i=0;i<len;i+=1){ownModifiers[i].closed=true;}};CVShapeElement.prototype.renderInnerContent=function(){this.transformHelper.opacity=1;this.transformHelper._opMdf=false;this.renderModifiers();this.transformsManager.processSequences(this._isFirstFrame);this.renderShape(this.transformHelper,this.shapesData,this.itemsData,true);};CVShapeElement.prototype.renderShapeTransform=function(parentTransform,groupTransform){if(parentTransform._opMdf||groupTransform.op._mdf||this._isFirstFrame){groupTransform.opacity=parentTransform.opacity;groupTransform.opacity*=groupTransform.op.v;groupTransform._opMdf=true;}};CVShapeElement.prototype.drawLayer=function(){var i;var len=this.stylesList.length;var j;var jLen;var k;var kLen;var elems;var nodes;var renderer=this.globalData.renderer;var ctx=this.globalData.canvasContext;var type;var currentStyle;for(i=0;i<len;i+=1){currentStyle=this.stylesList[i];type=currentStyle.type;// Skipping style when
// Stroke width equals 0
// style should not be rendered (extra unused repeaters)
// current opacity equals 0
// global opacity equals 0
if(!((type==='st'||type==='gs')&&currentStyle.wi===0||!currentStyle.data._shouldRender||currentStyle.coOp===0||this.globalData.currentGlobalAlpha===0)){renderer.save();elems=currentStyle.elements;if(type==='st'||type==='gs'){renderer.ctxStrokeStyle(type==='st'?currentStyle.co:currentStyle.grd);// ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
renderer.ctxLineWidth(currentStyle.wi);// ctx.lineWidth = currentStyle.wi;
renderer.ctxLineCap(currentStyle.lc);// ctx.lineCap = currentStyle.lc;
renderer.ctxLineJoin(currentStyle.lj);// ctx.lineJoin = currentStyle.lj;
renderer.ctxMiterLimit(currentStyle.ml||0);// ctx.miterLimit = currentStyle.ml || 0;
}else{renderer.ctxFillStyle(type==='fl'?currentStyle.co:currentStyle.grd);// ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
}renderer.ctxOpacity(currentStyle.coOp);if(type!=='st'&&type!=='gs'){ctx.beginPath();}renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);jLen=elems.length;for(j=0;j<jLen;j+=1){if(type==='st'||type==='gs'){ctx.beginPath();if(currentStyle.da){ctx.setLineDash(currentStyle.da);ctx.lineDashOffset=currentStyle["do"];}}nodes=elems[j].trNodes;kLen=nodes.length;for(k=0;k<kLen;k+=1){if(nodes[k].t==='m'){ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);}else if(nodes[k].t==='c'){ctx.bezierCurveTo(nodes[k].pts[0],nodes[k].pts[1],nodes[k].pts[2],nodes[k].pts[3],nodes[k].pts[4],nodes[k].pts[5]);}else{ctx.closePath();}}if(type==='st'||type==='gs'){// ctx.stroke();
renderer.ctxStroke();if(currentStyle.da){ctx.setLineDash(this.dashResetter);}}}if(type!=='st'&&type!=='gs'){// ctx.fill(currentStyle.r);
this.globalData.renderer.ctxFill(currentStyle.r);}renderer.restore();}}};CVShapeElement.prototype.renderShape=function(parentTransform,items,data,isMain){var i;var len=items.length-1;var groupTransform;groupTransform=parentTransform;for(i=len;i>=0;i-=1){if(items[i].ty==='tr'){groupTransform=data[i].transform;this.renderShapeTransform(parentTransform,groupTransform);}else if(items[i].ty==='sh'||items[i].ty==='el'||items[i].ty==='rc'||items[i].ty==='sr'){this.renderPath(items[i],data[i]);}else if(items[i].ty==='fl'){this.renderFill(items[i],data[i],groupTransform);}else if(items[i].ty==='st'){this.renderStroke(items[i],data[i],groupTransform);}else if(items[i].ty==='gf'||items[i].ty==='gs'){this.renderGradientFill(items[i],data[i],groupTransform);}else if(items[i].ty==='gr'){this.renderShape(groupTransform,items[i].it,data[i].it);}else if(items[i].ty==='tm'){//
}}if(isMain){this.drawLayer();}};CVShapeElement.prototype.renderStyledShape=function(styledShape,shape){if(this._isFirstFrame||shape._mdf||styledShape.transforms._mdf){var shapeNodes=styledShape.trNodes;var paths=shape.paths;var i;var len;var j;var jLen=paths._length;shapeNodes.length=0;var groupTransformMat=styledShape.transforms.finalTransform;for(j=0;j<jLen;j+=1){var pathNodes=paths.shapes[j];if(pathNodes&&pathNodes.v){len=pathNodes._length;for(i=1;i<len;i+=1){if(i===1){shapeNodes.push({t:'m',p:groupTransformMat.applyToPointArray(pathNodes.v[0][0],pathNodes.v[0][1],0)});}shapeNodes.push({t:'c',pts:groupTransformMat.applyToTriplePoints(pathNodes.o[i-1],pathNodes.i[i],pathNodes.v[i])});}if(len===1){shapeNodes.push({t:'m',p:groupTransformMat.applyToPointArray(pathNodes.v[0][0],pathNodes.v[0][1],0)});}if(pathNodes.c&&len){shapeNodes.push({t:'c',pts:groupTransformMat.applyToTriplePoints(pathNodes.o[i-1],pathNodes.i[0],pathNodes.v[0])});shapeNodes.push({t:'z'});}}}styledShape.trNodes=shapeNodes;}};CVShapeElement.prototype.renderPath=function(pathData,itemData){if(pathData.hd!==true&&pathData._shouldRender){var i;var len=itemData.styledShapes.length;for(i=0;i<len;i+=1){this.renderStyledShape(itemData.styledShapes[i],itemData.sh);}}};CVShapeElement.prototype.renderFill=function(styleData,itemData,groupTransform){var styleElem=itemData.style;if(itemData.c._mdf||this._isFirstFrame){styleElem.co='rgb('+bmFloor(itemData.c.v[0])+','+bmFloor(itemData.c.v[1])+','+bmFloor(itemData.c.v[2])+')';}if(itemData.o._mdf||groupTransform._opMdf||this._isFirstFrame){styleElem.coOp=itemData.o.v*groupTransform.opacity;}};CVShapeElement.prototype.renderGradientFill=function(styleData,itemData,groupTransform){var styleElem=itemData.style;var grd;if(!styleElem.grd||itemData.g._mdf||itemData.s._mdf||itemData.e._mdf||styleData.t!==1&&(itemData.h._mdf||itemData.a._mdf)){var ctx=this.globalData.canvasContext;var pt1=itemData.s.v;var pt2=itemData.e.v;if(styleData.t===1){grd=ctx.createLinearGradient(pt1[0],pt1[1],pt2[0],pt2[1]);}else{var rad=Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));var ang=Math.atan2(pt2[1]-pt1[1],pt2[0]-pt1[0]);var percent=itemData.h.v;if(percent>=1){percent=0.99;}else if(percent<=-1){percent=-0.99;}var dist=rad*percent;var x=Math.cos(ang+itemData.a.v)*dist+pt1[0];var y=Math.sin(ang+itemData.a.v)*dist+pt1[1];grd=ctx.createRadialGradient(x,y,0,pt1[0],pt1[1],rad);}var i;var len=styleData.g.p;var cValues=itemData.g.c;var opacity=1;for(i=0;i<len;i+=1){if(itemData.g._hasOpacity&&itemData.g._collapsable){opacity=itemData.g.o[i*2+1];}grd.addColorStop(cValues[i*4]/100,'rgba('+cValues[i*4+1]+','+cValues[i*4+2]+','+cValues[i*4+3]+','+opacity+')');}styleElem.grd=grd;}styleElem.coOp=itemData.o.v*groupTransform.opacity;};CVShapeElement.prototype.renderStroke=function(styleData,itemData,groupTransform){var styleElem=itemData.style;var d=itemData.d;if(d&&(d._mdf||this._isFirstFrame)){styleElem.da=d.dashArray;styleElem["do"]=d.dashoffset[0];}if(itemData.c._mdf||this._isFirstFrame){styleElem.co='rgb('+bmFloor(itemData.c.v[0])+','+bmFloor(itemData.c.v[1])+','+bmFloor(itemData.c.v[2])+')';}if(itemData.o._mdf||groupTransform._opMdf||this._isFirstFrame){styleElem.coOp=itemData.o.v*groupTransform.opacity;}if(itemData.w._mdf||this._isFirstFrame){styleElem.wi=itemData.w.v;}};CVShapeElement.prototype.destroy=function(){this.shapesData=null;this.globalData=null;this.canvasContext=null;this.stylesList.length=0;this.itemsData.length=0;};function CVTextElement(data,globalData,comp){this.textSpans=[];this.yOffset=0;this.fillColorAnim=false;this.strokeColorAnim=false;this.strokeWidthAnim=false;this.stroke=false;this.fill=false;this.justifyOffset=0;this.currentRender=null;this.renderType='canvas';this.values={fill:'rgba(0,0,0,0)',stroke:'rgba(0,0,0,0)',sWidth:0,fValue:''};this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,CVBaseElement,HierarchyElement,FrameElement,RenderableElement,ITextElement],CVTextElement);CVTextElement.prototype.tHelper=createTag('canvas').getContext('2d');CVTextElement.prototype.buildNewText=function(){var documentData=this.textProperty.currentData;this.renderedLetters=createSizedArray(documentData.l?documentData.l.length:0);var hasFill=false;if(documentData.fc){hasFill=true;this.values.fill=this.buildColor(documentData.fc);}else{this.values.fill='rgba(0,0,0,0)';}this.fill=hasFill;var hasStroke=false;if(documentData.sc){hasStroke=true;this.values.stroke=this.buildColor(documentData.sc);this.values.sWidth=documentData.sw;}var fontData=this.globalData.fontManager.getFontByName(documentData.f);var i;var len;var letters=documentData.l;var matrixHelper=this.mHelper;this.stroke=hasStroke;this.values.fValue=documentData.finalSize+'px '+this.globalData.fontManager.getFontByName(documentData.f).fFamily;len=documentData.finalText.length;// this.tHelper.font = this.values.fValue;
var charData;var shapeData;var k;var kLen;var shapes;var j;var jLen;var pathNodes;var commands;var pathArr;var singleShape=this.data.singleShape;var trackingOffset=documentData.tr*0.001*documentData.finalSize;var xPos=0;var yPos=0;var firstLine=true;var cnt=0;for(i=0;i<len;i+=1){charData=this.globalData.fontManager.getCharData(documentData.finalText[i],fontData.fStyle,this.globalData.fontManager.getFontByName(documentData.f).fFamily);shapeData=charData&&charData.data||{};matrixHelper.reset();if(singleShape&&letters[i].n){xPos=-trackingOffset;yPos+=documentData.yOffset;yPos+=firstLine?1:0;firstLine=false;}shapes=shapeData.shapes?shapeData.shapes[0].it:[];jLen=shapes.length;matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);if(singleShape){this.applyTextPropertiesToMatrix(documentData,matrixHelper,letters[i].line,xPos,yPos);}commands=createSizedArray(jLen-1);var commandsCounter=0;for(j=0;j<jLen;j+=1){if(shapes[j].ty==='sh'){kLen=shapes[j].ks.k.i.length;pathNodes=shapes[j].ks.k;pathArr=[];for(k=1;k<kLen;k+=1){if(k===1){pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));}pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));}pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));commands[commandsCounter]=pathArr;commandsCounter+=1;}}if(singleShape){xPos+=letters[i].l;xPos+=trackingOffset;}if(this.textSpans[cnt]){this.textSpans[cnt].elem=commands;}else{this.textSpans[cnt]={elem:commands};}cnt+=1;}};CVTextElement.prototype.renderInnerContent=function(){this.validateText();var ctx=this.canvasContext;ctx.font=this.values.fValue;this.globalData.renderer.ctxLineCap('butt');// ctx.lineCap = 'butt';
this.globalData.renderer.ctxLineJoin('miter');// ctx.lineJoin = 'miter';
this.globalData.renderer.ctxMiterLimit(4);// ctx.miterLimit = 4;
if(!this.data.singleShape){this.textAnimator.getMeasures(this.textProperty.currentData,this.lettersChangedFlag);}var i;var len;var j;var jLen;var k;var kLen;var renderedLetters=this.textAnimator.renderedLetters;var letters=this.textProperty.currentData.l;len=letters.length;var renderedLetter;var lastFill=null;var lastStroke=null;var lastStrokeW=null;var commands;var pathArr;var renderer=this.globalData.renderer;for(i=0;i<len;i+=1){if(!letters[i].n){renderedLetter=renderedLetters[i];if(renderedLetter){renderer.save();renderer.ctxTransform(renderedLetter.p);renderer.ctxOpacity(renderedLetter.o);}if(this.fill){if(renderedLetter&&renderedLetter.fc){if(lastFill!==renderedLetter.fc){renderer.ctxFillStyle(renderedLetter.fc);lastFill=renderedLetter.fc;// ctx.fillStyle = renderedLetter.fc;
}}else if(lastFill!==this.values.fill){lastFill=this.values.fill;renderer.ctxFillStyle(this.values.fill);// ctx.fillStyle = this.values.fill;
}commands=this.textSpans[i].elem;jLen=commands.length;this.globalData.canvasContext.beginPath();for(j=0;j<jLen;j+=1){pathArr=commands[j];kLen=pathArr.length;this.globalData.canvasContext.moveTo(pathArr[0],pathArr[1]);for(k=2;k<kLen;k+=6){this.globalData.canvasContext.bezierCurveTo(pathArr[k],pathArr[k+1],pathArr[k+2],pathArr[k+3],pathArr[k+4],pathArr[k+5]);}}this.globalData.canvasContext.closePath();renderer.ctxFill();// this.globalData.canvasContext.fill();
/// ctx.fillText(this.textSpans[i].val,0,0);
}if(this.stroke){if(renderedLetter&&renderedLetter.sw){if(lastStrokeW!==renderedLetter.sw){lastStrokeW=renderedLetter.sw;renderer.ctxLineWidth(renderedLetter.sw);// ctx.lineWidth = renderedLetter.sw;
}}else if(lastStrokeW!==this.values.sWidth){lastStrokeW=this.values.sWidth;renderer.ctxLineWidth(this.values.sWidth);// ctx.lineWidth = this.values.sWidth;
}if(renderedLetter&&renderedLetter.sc){if(lastStroke!==renderedLetter.sc){lastStroke=renderedLetter.sc;renderer.ctxStrokeStyle(renderedLetter.sc);// ctx.strokeStyle = renderedLetter.sc;
}}else if(lastStroke!==this.values.stroke){lastStroke=this.values.stroke;renderer.ctxStrokeStyle(this.values.stroke);// ctx.strokeStyle = this.values.stroke;
}commands=this.textSpans[i].elem;jLen=commands.length;this.globalData.canvasContext.beginPath();for(j=0;j<jLen;j+=1){pathArr=commands[j];kLen=pathArr.length;this.globalData.canvasContext.moveTo(pathArr[0],pathArr[1]);for(k=2;k<kLen;k+=6){this.globalData.canvasContext.bezierCurveTo(pathArr[k],pathArr[k+1],pathArr[k+2],pathArr[k+3],pathArr[k+4],pathArr[k+5]);}}this.globalData.canvasContext.closePath();renderer.ctxStroke();// this.globalData.canvasContext.stroke();
/// ctx.strokeText(letters[i].val,0,0);
}if(renderedLetter){this.globalData.renderer.restore();}}}};function CVImageElement(data,globalData,comp){this.assetData=globalData.getAssetData(data.refId);this.img=globalData.imageLoader.getAsset(this.assetData);this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,CVBaseElement,HierarchyElement,FrameElement,RenderableElement],CVImageElement);CVImageElement.prototype.initElement=SVGShapeElement.prototype.initElement;CVImageElement.prototype.prepareFrame=IImageElement.prototype.prepareFrame;CVImageElement.prototype.createContent=function(){if(this.img.width&&(this.assetData.w!==this.img.width||this.assetData.h!==this.img.height)){var canvas=createTag('canvas');canvas.width=this.assetData.w;canvas.height=this.assetData.h;var ctx=canvas.getContext('2d');var imgW=this.img.width;var imgH=this.img.height;var imgRel=imgW/imgH;var canvasRel=this.assetData.w/this.assetData.h;var widthCrop;var heightCrop;var par=this.assetData.pr||this.globalData.renderConfig.imagePreserveAspectRatio;if(imgRel>canvasRel&&par==='xMidYMid slice'||imgRel<canvasRel&&par!=='xMidYMid slice'){heightCrop=imgH;widthCrop=heightCrop*canvasRel;}else{widthCrop=imgW;heightCrop=widthCrop/canvasRel;}ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);this.img=canvas;}};CVImageElement.prototype.renderInnerContent=function(){this.canvasContext.drawImage(this.img,0,0);};CVImageElement.prototype.destroy=function(){this.img=null;};function CVSolidElement(data,globalData,comp){this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,CVBaseElement,HierarchyElement,FrameElement,RenderableElement],CVSolidElement);CVSolidElement.prototype.initElement=SVGShapeElement.prototype.initElement;CVSolidElement.prototype.prepareFrame=IImageElement.prototype.prepareFrame;CVSolidElement.prototype.renderInnerContent=function(){// var ctx = this.canvasContext;
this.globalData.renderer.ctxFillStyle(this.data.sc);// ctx.fillStyle = this.data.sc;
this.globalData.renderer.ctxFillRect(0,0,this.data.sw,this.data.sh);// ctx.fillRect(0, 0, this.data.sw, this.data.sh);
//
};function CanvasRendererBase(){}extendPrototype([BaseRenderer],CanvasRendererBase);CanvasRendererBase.prototype.createShape=function(data){return new CVShapeElement(data,this.globalData,this);};CanvasRendererBase.prototype.createText=function(data){return new CVTextElement(data,this.globalData,this);};CanvasRendererBase.prototype.createImage=function(data){return new CVImageElement(data,this.globalData,this);};CanvasRendererBase.prototype.createSolid=function(data){return new CVSolidElement(data,this.globalData,this);};CanvasRendererBase.prototype.createNull=SVGRenderer.prototype.createNull;CanvasRendererBase.prototype.ctxTransform=function(props){if(props[0]===1&&props[1]===0&&props[4]===0&&props[5]===1&&props[12]===0&&props[13]===0){return;}this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);};CanvasRendererBase.prototype.ctxOpacity=function(op){this.canvasContext.globalAlpha*=op<0?0:op;};CanvasRendererBase.prototype.ctxFillStyle=function(value){this.canvasContext.fillStyle=value;};CanvasRendererBase.prototype.ctxStrokeStyle=function(value){this.canvasContext.strokeStyle=value;};CanvasRendererBase.prototype.ctxLineWidth=function(value){this.canvasContext.lineWidth=value;};CanvasRendererBase.prototype.ctxLineCap=function(value){this.canvasContext.lineCap=value;};CanvasRendererBase.prototype.ctxLineJoin=function(value){this.canvasContext.lineJoin=value;};CanvasRendererBase.prototype.ctxMiterLimit=function(value){this.canvasContext.miterLimit=value;};CanvasRendererBase.prototype.ctxFill=function(rule){this.canvasContext.fill(rule);};CanvasRendererBase.prototype.ctxFillRect=function(x,y,w,h){this.canvasContext.fillRect(x,y,w,h);};CanvasRendererBase.prototype.ctxStroke=function(){this.canvasContext.stroke();};CanvasRendererBase.prototype.reset=function(){if(!this.renderConfig.clearCanvas){this.canvasContext.restore();return;}this.contextData.reset();};CanvasRendererBase.prototype.save=function(){this.canvasContext.save();};CanvasRendererBase.prototype.restore=function(actionFlag){if(!this.renderConfig.clearCanvas){this.canvasContext.restore();return;}if(actionFlag){this.globalData.blendMode='source-over';}this.contextData.restore(actionFlag);};CanvasRendererBase.prototype.configAnimation=function(animData){if(this.animationItem.wrapper){this.animationItem.container=createTag('canvas');var containerStyle=this.animationItem.container.style;containerStyle.width='100%';containerStyle.height='100%';var origin='0px 0px 0px';containerStyle.transformOrigin=origin;containerStyle.mozTransformOrigin=origin;containerStyle.webkitTransformOrigin=origin;containerStyle['-webkit-transform']=origin;containerStyle.contentVisibility=this.renderConfig.contentVisibility;this.animationItem.wrapper.appendChild(this.animationItem.container);this.canvasContext=this.animationItem.container.getContext('2d');if(this.renderConfig.className){this.animationItem.container.setAttribute('class',this.renderConfig.className);}if(this.renderConfig.id){this.animationItem.container.setAttribute('id',this.renderConfig.id);}}else{this.canvasContext=this.renderConfig.context;}this.contextData.setContext(this.canvasContext);this.data=animData;this.layers=animData.layers;this.transformCanvas={w:animData.w,h:animData.h,sx:0,sy:0,tx:0,ty:0};this.setupGlobalData(animData,document.body);this.globalData.canvasContext=this.canvasContext;this.globalData.renderer=this;this.globalData.isDashed=false;this.globalData.progressiveLoad=this.renderConfig.progressiveLoad;this.globalData.transformCanvas=this.transformCanvas;this.elements=createSizedArray(animData.layers.length);this.updateContainerSize();};CanvasRendererBase.prototype.updateContainerSize=function(width,height){this.reset();var elementWidth;var elementHeight;if(width){elementWidth=width;elementHeight=height;this.canvasContext.canvas.width=elementWidth;this.canvasContext.canvas.height=elementHeight;}else{if(this.animationItem.wrapper&&this.animationItem.container){elementWidth=this.animationItem.wrapper.offsetWidth;elementHeight=this.animationItem.wrapper.offsetHeight;}else{elementWidth=this.canvasContext.canvas.width;elementHeight=this.canvasContext.canvas.height;}this.canvasContext.canvas.width=elementWidth*this.renderConfig.dpr;this.canvasContext.canvas.height=elementHeight*this.renderConfig.dpr;}var elementRel;var animationRel;if(this.renderConfig.preserveAspectRatio.indexOf('meet')!==-1||this.renderConfig.preserveAspectRatio.indexOf('slice')!==-1){var par=this.renderConfig.preserveAspectRatio.split(' ');var fillType=par[1]||'meet';var pos=par[0]||'xMidYMid';var xPos=pos.substr(0,4);var yPos=pos.substr(4);elementRel=elementWidth/elementHeight;animationRel=this.transformCanvas.w/this.transformCanvas.h;if(animationRel>elementRel&&fillType==='meet'||animationRel<elementRel&&fillType==='slice'){this.transformCanvas.sx=elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);this.transformCanvas.sy=elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);}else{this.transformCanvas.sx=elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);this.transformCanvas.sy=elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);}if(xPos==='xMid'&&(animationRel<elementRel&&fillType==='meet'||animationRel>elementRel&&fillType==='slice')){this.transformCanvas.tx=(elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;}else if(xPos==='xMax'&&(animationRel<elementRel&&fillType==='meet'||animationRel>elementRel&&fillType==='slice')){this.transformCanvas.tx=(elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;}else{this.transformCanvas.tx=0;}if(yPos==='YMid'&&(animationRel>elementRel&&fillType==='meet'||animationRel<elementRel&&fillType==='slice')){this.transformCanvas.ty=(elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2*this.renderConfig.dpr;}else if(yPos==='YMax'&&(animationRel>elementRel&&fillType==='meet'||animationRel<elementRel&&fillType==='slice')){this.transformCanvas.ty=(elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))*this.renderConfig.dpr;}else{this.transformCanvas.ty=0;}}else if(this.renderConfig.preserveAspectRatio==='none'){this.transformCanvas.sx=elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);this.transformCanvas.sy=elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);this.transformCanvas.tx=0;this.transformCanvas.ty=0;}else{this.transformCanvas.sx=this.renderConfig.dpr;this.transformCanvas.sy=this.renderConfig.dpr;this.transformCanvas.tx=0;this.transformCanvas.ty=0;}this.transformCanvas.props=[this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];/* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */this.ctxTransform(this.transformCanvas.props);this.canvasContext.beginPath();this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);this.canvasContext.closePath();this.canvasContext.clip();this.renderFrame(this.renderedFrame,true);};CanvasRendererBase.prototype.destroy=function(){if(this.renderConfig.clearCanvas&&this.animationItem.wrapper){this.animationItem.wrapper.innerText='';}var i;var len=this.layers?this.layers.length:0;for(i=len-1;i>=0;i-=1){if(this.elements[i]&&this.elements[i].destroy){this.elements[i].destroy();}}this.elements.length=0;this.globalData.canvasContext=null;this.animationItem.container=null;this.destroyed=true;};CanvasRendererBase.prototype.renderFrame=function(num,forceRender){if(this.renderedFrame===num&&this.renderConfig.clearCanvas===true&&!forceRender||this.destroyed||num===-1){return;}this.renderedFrame=num;this.globalData.frameNum=num-this.animationItem._isFirstFrame;this.globalData.frameId+=1;this.globalData._mdf=!this.renderConfig.clearCanvas||forceRender;this.globalData.projectInterface.currentFrame=num;// console.log('--------');
// console.log('NEW: ',num);
var i;var len=this.layers.length;if(!this.completeLayers){this.checkLayers(num);}for(i=len-1;i>=0;i-=1){if(this.completeLayers||this.elements[i]){this.elements[i].prepareFrame(num-this.layers[i].st);}}if(this.globalData._mdf){if(this.renderConfig.clearCanvas===true){this.canvasContext.clearRect(0,0,this.transformCanvas.w,this.transformCanvas.h);}else{this.save();}for(i=len-1;i>=0;i-=1){if(this.completeLayers||this.elements[i]){this.elements[i].renderFrame();}}if(this.renderConfig.clearCanvas!==true){this.restore();}}};CanvasRendererBase.prototype.buildItem=function(pos){var elements=this.elements;if(elements[pos]||this.layers[pos].ty===99){return;}var element=this.createItem(this.layers[pos],this,this.globalData);elements[pos]=element;element.initExpressions();/* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */};CanvasRendererBase.prototype.checkPendingElements=function(){while(this.pendingElements.length){var element=this.pendingElements.pop();element.checkParenting();}};CanvasRendererBase.prototype.hide=function(){this.animationItem.container.style.display='none';};CanvasRendererBase.prototype.show=function(){this.animationItem.container.style.display='block';};function CanvasContext(){this.opacity=-1;this.transform=createTypedArray('float32',16);this.fillStyle='';this.strokeStyle='';this.lineWidth='';this.lineCap='';this.lineJoin='';this.miterLimit='';this.id=Math.random();}function CVContextData(){this.stack=[];this.cArrPos=0;this.cTr=new Matrix();var i;var len=15;for(i=0;i<len;i+=1){var canvasContext=new CanvasContext();this.stack[i]=canvasContext;}this._length=len;this.nativeContext=null;this.transformMat=new Matrix();this.currentOpacity=1;//
this.currentFillStyle='';this.appliedFillStyle='';//
this.currentStrokeStyle='';this.appliedStrokeStyle='';//
this.currentLineWidth='';this.appliedLineWidth='';//
this.currentLineCap='';this.appliedLineCap='';//
this.currentLineJoin='';this.appliedLineJoin='';//
this.appliedMiterLimit='';this.currentMiterLimit='';}CVContextData.prototype.duplicate=function(){var newLength=this._length*2;var i=0;for(i=this._length;i<newLength;i+=1){this.stack[i]=new CanvasContext();}this._length=newLength;};CVContextData.prototype.reset=function(){this.cArrPos=0;this.cTr.reset();this.stack[this.cArrPos].opacity=1;};CVContextData.prototype.restore=function(forceRestore){this.cArrPos-=1;var currentContext=this.stack[this.cArrPos];var transform=currentContext.transform;var i;var arr=this.cTr.props;for(i=0;i<16;i+=1){arr[i]=transform[i];}if(forceRestore){this.nativeContext.restore();var prevStack=this.stack[this.cArrPos+1];this.appliedFillStyle=prevStack.fillStyle;this.appliedStrokeStyle=prevStack.strokeStyle;this.appliedLineWidth=prevStack.lineWidth;this.appliedLineCap=prevStack.lineCap;this.appliedLineJoin=prevStack.lineJoin;this.appliedMiterLimit=prevStack.miterLimit;}this.nativeContext.setTransform(transform[0],transform[1],transform[4],transform[5],transform[12],transform[13]);if(forceRestore||currentContext.opacity!==-1&&this.currentOpacity!==currentContext.opacity){this.nativeContext.globalAlpha=currentContext.opacity;this.currentOpacity=currentContext.opacity;}this.currentFillStyle=currentContext.fillStyle;this.currentStrokeStyle=currentContext.strokeStyle;this.currentLineWidth=currentContext.lineWidth;this.currentLineCap=currentContext.lineCap;this.currentLineJoin=currentContext.lineJoin;this.currentMiterLimit=currentContext.miterLimit;};CVContextData.prototype.save=function(saveOnNativeFlag){if(saveOnNativeFlag){this.nativeContext.save();}var props=this.cTr.props;if(this._length<=this.cArrPos){this.duplicate();}var currentStack=this.stack[this.cArrPos];var i;for(i=0;i<16;i+=1){currentStack.transform[i]=props[i];}this.cArrPos+=1;var newStack=this.stack[this.cArrPos];newStack.opacity=currentStack.opacity;newStack.fillStyle=currentStack.fillStyle;newStack.strokeStyle=currentStack.strokeStyle;newStack.lineWidth=currentStack.lineWidth;newStack.lineCap=currentStack.lineCap;newStack.lineJoin=currentStack.lineJoin;newStack.miterLimit=currentStack.miterLimit;};CVContextData.prototype.setOpacity=function(value){this.stack[this.cArrPos].opacity=value;};CVContextData.prototype.setContext=function(value){this.nativeContext=value;};CVContextData.prototype.fillStyle=function(value){if(this.stack[this.cArrPos].fillStyle!==value){this.currentFillStyle=value;this.stack[this.cArrPos].fillStyle=value;}};CVContextData.prototype.strokeStyle=function(value){if(this.stack[this.cArrPos].strokeStyle!==value){this.currentStrokeStyle=value;this.stack[this.cArrPos].strokeStyle=value;}};CVContextData.prototype.lineWidth=function(value){if(this.stack[this.cArrPos].lineWidth!==value){this.currentLineWidth=value;this.stack[this.cArrPos].lineWidth=value;}};CVContextData.prototype.lineCap=function(value){if(this.stack[this.cArrPos].lineCap!==value){this.currentLineCap=value;this.stack[this.cArrPos].lineCap=value;}};CVContextData.prototype.lineJoin=function(value){if(this.stack[this.cArrPos].lineJoin!==value){this.currentLineJoin=value;this.stack[this.cArrPos].lineJoin=value;}};CVContextData.prototype.miterLimit=function(value){if(this.stack[this.cArrPos].miterLimit!==value){this.currentMiterLimit=value;this.stack[this.cArrPos].miterLimit=value;}};CVContextData.prototype.transform=function(props){this.transformMat.cloneFromProps(props);// Taking the last transform value from the stored stack of transforms
var currentTransform=this.cTr;// Applying the last transform value after the new transform to respect the order of transformations
this.transformMat.multiply(currentTransform);// Storing the new transformed value in the stored transform
currentTransform.cloneFromProps(this.transformMat.props);var trProps=currentTransform.props;// Applying the new transform to the canvas
this.nativeContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);};CVContextData.prototype.opacity=function(op){var currentOpacity=this.stack[this.cArrPos].opacity;currentOpacity*=op<0?0:op;if(this.stack[this.cArrPos].opacity!==currentOpacity){if(this.currentOpacity!==op){this.nativeContext.globalAlpha=op;this.currentOpacity=op;}this.stack[this.cArrPos].opacity=currentOpacity;}};CVContextData.prototype.fill=function(rule){if(this.appliedFillStyle!==this.currentFillStyle){this.appliedFillStyle=this.currentFillStyle;this.nativeContext.fillStyle=this.appliedFillStyle;}this.nativeContext.fill(rule);};CVContextData.prototype.fillRect=function(x,y,w,h){if(this.appliedFillStyle!==this.currentFillStyle){this.appliedFillStyle=this.currentFillStyle;this.nativeContext.fillStyle=this.appliedFillStyle;}this.nativeContext.fillRect(x,y,w,h);};CVContextData.prototype.stroke=function(){if(this.appliedStrokeStyle!==this.currentStrokeStyle){this.appliedStrokeStyle=this.currentStrokeStyle;this.nativeContext.strokeStyle=this.appliedStrokeStyle;}if(this.appliedLineWidth!==this.currentLineWidth){this.appliedLineWidth=this.currentLineWidth;this.nativeContext.lineWidth=this.appliedLineWidth;}if(this.appliedLineCap!==this.currentLineCap){this.appliedLineCap=this.currentLineCap;this.nativeContext.lineCap=this.appliedLineCap;}if(this.appliedLineJoin!==this.currentLineJoin){this.appliedLineJoin=this.currentLineJoin;this.nativeContext.lineJoin=this.appliedLineJoin;}if(this.appliedMiterLimit!==this.currentMiterLimit){this.appliedMiterLimit=this.currentMiterLimit;this.nativeContext.miterLimit=this.appliedMiterLimit;}this.nativeContext.stroke();};function CVCompElement(data,globalData,comp){this.completeLayers=false;this.layers=data.layers;this.pendingElements=[];this.elements=createSizedArray(this.layers.length);this.initElement(data,globalData,comp);this.tm=data.tm?PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this):{_placeholder:true};}extendPrototype([CanvasRendererBase,ICompElement,CVBaseElement],CVCompElement);CVCompElement.prototype.renderInnerContent=function(){var ctx=this.canvasContext;ctx.beginPath();ctx.moveTo(0,0);ctx.lineTo(this.data.w,0);ctx.lineTo(this.data.w,this.data.h);ctx.lineTo(0,this.data.h);ctx.lineTo(0,0);ctx.clip();var i;var len=this.layers.length;for(i=len-1;i>=0;i-=1){if(this.completeLayers||this.elements[i]){this.elements[i].renderFrame();}}};CVCompElement.prototype.destroy=function(){var i;var len=this.layers.length;for(i=len-1;i>=0;i-=1){if(this.elements[i]){this.elements[i].destroy();}}this.layers=null;this.elements=null;};CVCompElement.prototype.createComp=function(data){return new CVCompElement(data,this.globalData,this);};function CanvasRenderer(animationItem,config){this.animationItem=animationItem;this.renderConfig={clearCanvas:config&&config.clearCanvas!==undefined?config.clearCanvas:true,context:config&&config.context||null,progressiveLoad:config&&config.progressiveLoad||false,preserveAspectRatio:config&&config.preserveAspectRatio||'xMidYMid meet',imagePreserveAspectRatio:config&&config.imagePreserveAspectRatio||'xMidYMid slice',contentVisibility:config&&config.contentVisibility||'visible',className:config&&config.className||'',id:config&&config.id||'',runExpressions:!config||config.runExpressions===undefined||config.runExpressions};this.renderConfig.dpr=config&&config.dpr||1;if(this.animationItem.wrapper){this.renderConfig.dpr=config&&config.dpr||window.devicePixelRatio||1;}this.renderedFrame=-1;this.globalData={frameNum:-1,_mdf:false,renderConfig:this.renderConfig,currentGlobalAlpha:-1};this.contextData=new CVContextData();this.elements=[];this.pendingElements=[];this.transformMat=new Matrix();this.completeLayers=false;this.rendererType='canvas';if(this.renderConfig.clearCanvas){this.ctxTransform=this.contextData.transform.bind(this.contextData);this.ctxOpacity=this.contextData.opacity.bind(this.contextData);this.ctxFillStyle=this.contextData.fillStyle.bind(this.contextData);this.ctxStrokeStyle=this.contextData.strokeStyle.bind(this.contextData);this.ctxLineWidth=this.contextData.lineWidth.bind(this.contextData);this.ctxLineCap=this.contextData.lineCap.bind(this.contextData);this.ctxLineJoin=this.contextData.lineJoin.bind(this.contextData);this.ctxMiterLimit=this.contextData.miterLimit.bind(this.contextData);this.ctxFill=this.contextData.fill.bind(this.contextData);this.ctxFillRect=this.contextData.fillRect.bind(this.contextData);this.ctxStroke=this.contextData.stroke.bind(this.contextData);this.save=this.contextData.save.bind(this.contextData);}}extendPrototype([CanvasRendererBase],CanvasRenderer);CanvasRenderer.prototype.createComp=function(data){return new CVCompElement(data,this.globalData,this);};function HBaseElement(){}HBaseElement.prototype={checkBlendMode:function checkBlendMode(){},initRendererElement:function initRendererElement(){this.baseElement=createTag(this.data.tg||'div');if(this.data.hasMask){this.svgElement=createNS('svg');this.layerElement=createNS('g');this.maskedElement=this.layerElement;this.svgElement.appendChild(this.layerElement);this.baseElement.appendChild(this.svgElement);}else{this.layerElement=this.baseElement;}styleDiv(this.baseElement);},createContainerElements:function createContainerElements(){this.renderableEffectsManager=new CVEffects(this);this.transformedElement=this.baseElement;this.maskedElement=this.layerElement;if(this.data.ln){this.layerElement.setAttribute('id',this.data.ln);}if(this.data.cl){this.layerElement.setAttribute('class',this.data.cl);}if(this.data.bm!==0){this.setBlendMode();}},renderElement:function renderElement(){var transformedElementStyle=this.transformedElement?this.transformedElement.style:{};if(this.finalTransform._matMdf){var matrixValue=this.finalTransform.mat.toCSS();transformedElementStyle.transform=matrixValue;transformedElementStyle.webkitTransform=matrixValue;}if(this.finalTransform._opMdf){transformedElementStyle.opacity=this.finalTransform.mProp.o.v;}},renderFrame:function renderFrame(){// If it is exported as hidden (data.hd === true) no need to render
// If it is not visible no need to render
if(this.data.hd||this.hidden){return;}this.renderTransform();this.renderRenderable();this.renderElement();this.renderInnerContent();if(this._isFirstFrame){this._isFirstFrame=false;}},destroy:function destroy(){this.layerElement=null;this.transformedElement=null;if(this.matteElement){this.matteElement=null;}if(this.maskManager){this.maskManager.destroy();this.maskManager=null;}},createRenderableComponents:function createRenderableComponents(){this.maskManager=new MaskElement(this.data,this,this.globalData);},addEffects:function addEffects(){},setMatte:function setMatte(){}};HBaseElement.prototype.getBaseElement=SVGBaseElement.prototype.getBaseElement;HBaseElement.prototype.destroyBaseElement=HBaseElement.prototype.destroy;HBaseElement.prototype.buildElementParenting=BaseRenderer.prototype.buildElementParenting;function HSolidElement(data,globalData,comp){this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement],HSolidElement);HSolidElement.prototype.createContent=function(){var rect;if(this.data.hasMask){rect=createNS('rect');rect.setAttribute('width',this.data.sw);rect.setAttribute('height',this.data.sh);rect.setAttribute('fill',this.data.sc);this.svgElement.setAttribute('width',this.data.sw);this.svgElement.setAttribute('height',this.data.sh);}else{rect=createTag('div');rect.style.width=this.data.sw+'px';rect.style.height=this.data.sh+'px';rect.style.backgroundColor=this.data.sc;}this.layerElement.appendChild(rect);};function HShapeElement(data,globalData,comp){// List of drawable elements
this.shapes=[];// Full shape data
this.shapesData=data.shapes;// List of styles that will be applied to shapes
this.stylesList=[];// List of modifiers that will be applied to shapes
this.shapeModifiers=[];// List of items in shape tree
this.itemsData=[];// List of items in previous shape tree
this.processedElements=[];// List of animated components
this.animatedContents=[];this.shapesContainer=createNS('g');this.initElement(data,globalData,comp);// Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
// List of elements that have been created
this.prevViewData=[];this.currentBBox={x:999999,y:-999999,h:0,w:0};}extendPrototype([BaseElement,TransformElement,HSolidElement,SVGShapeElement,HBaseElement,HierarchyElement,FrameElement,RenderableElement],HShapeElement);HShapeElement.prototype._renderShapeFrame=HShapeElement.prototype.renderInnerContent;HShapeElement.prototype.createContent=function(){var cont;this.baseElement.style.fontSize=0;if(this.data.hasMask){this.layerElement.appendChild(this.shapesContainer);cont=this.svgElement;}else{cont=createNS('svg');var size=this.comp.data?this.comp.data:this.globalData.compSize;cont.setAttribute('width',size.w);cont.setAttribute('height',size.h);cont.appendChild(this.shapesContainer);this.layerElement.appendChild(cont);}this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.shapesContainer,0,[],true);this.filterUniqueShapes();this.shapeCont=cont;};HShapeElement.prototype.getTransformedPoint=function(transformers,point){var i;var len=transformers.length;for(i=0;i<len;i+=1){point=transformers[i].mProps.v.applyToPointArray(point[0],point[1],0);}return point;};HShapeElement.prototype.calculateShapeBoundingBox=function(item,boundingBox){var shape=item.sh.v;var transformers=item.transformers;var i;var len=shape._length;var vPoint;var oPoint;var nextIPoint;var nextVPoint;if(len<=1){return;}for(i=0;i<len-1;i+=1){vPoint=this.getTransformedPoint(transformers,shape.v[i]);oPoint=this.getTransformedPoint(transformers,shape.o[i]);nextIPoint=this.getTransformedPoint(transformers,shape.i[i+1]);nextVPoint=this.getTransformedPoint(transformers,shape.v[i+1]);this.checkBounds(vPoint,oPoint,nextIPoint,nextVPoint,boundingBox);}if(shape.c){vPoint=this.getTransformedPoint(transformers,shape.v[i]);oPoint=this.getTransformedPoint(transformers,shape.o[i]);nextIPoint=this.getTransformedPoint(transformers,shape.i[0]);nextVPoint=this.getTransformedPoint(transformers,shape.v[0]);this.checkBounds(vPoint,oPoint,nextIPoint,nextVPoint,boundingBox);}};HShapeElement.prototype.checkBounds=function(vPoint,oPoint,nextIPoint,nextVPoint,boundingBox){this.getBoundsOfCurve(vPoint,oPoint,nextIPoint,nextVPoint);var bounds=this.shapeBoundingBox;boundingBox.x=bmMin(bounds.left,boundingBox.x);boundingBox.xMax=bmMax(bounds.right,boundingBox.xMax);boundingBox.y=bmMin(bounds.top,boundingBox.y);boundingBox.yMax=bmMax(bounds.bottom,boundingBox.yMax);};HShapeElement.prototype.shapeBoundingBox={left:0,right:0,top:0,bottom:0};HShapeElement.prototype.tempBoundingBox={x:0,xMax:0,y:0,yMax:0,width:0,height:0};HShapeElement.prototype.getBoundsOfCurve=function(p0,p1,p2,p3){var bounds=[[p0[0],p3[0]],[p0[1],p3[1]]];for(var a,b,c,t,b2ac,t1,t2,i=0;i<2;++i){// eslint-disable-line no-plusplus
b=6*p0[i]-12*p1[i]+6*p2[i];a=-3*p0[i]+9*p1[i]-9*p2[i]+3*p3[i];c=3*p1[i]-3*p0[i];b|=0;// eslint-disable-line no-bitwise
a|=0;// eslint-disable-line no-bitwise
c|=0;// eslint-disable-line no-bitwise
if(a===0&&b===0){//
}else if(a===0){t=-c/b;if(t>0&&t<1){bounds[i].push(this.calculateF(t,p0,p1,p2,p3,i));}}else{b2ac=b*b-4*c*a;if(b2ac>=0){t1=(-b+bmSqrt(b2ac))/(2*a);if(t1>0&&t1<1)bounds[i].push(this.calculateF(t1,p0,p1,p2,p3,i));t2=(-b-bmSqrt(b2ac))/(2*a);if(t2>0&&t2<1)bounds[i].push(this.calculateF(t2,p0,p1,p2,p3,i));}}}this.shapeBoundingBox.left=bmMin.apply(null,bounds[0]);this.shapeBoundingBox.top=bmMin.apply(null,bounds[1]);this.shapeBoundingBox.right=bmMax.apply(null,bounds[0]);this.shapeBoundingBox.bottom=bmMax.apply(null,bounds[1]);};HShapeElement.prototype.calculateF=function(t,p0,p1,p2,p3,i){return bmPow(1-t,3)*p0[i]+3*bmPow(1-t,2)*t*p1[i]+3*(1-t)*bmPow(t,2)*p2[i]+bmPow(t,3)*p3[i];};HShapeElement.prototype.calculateBoundingBox=function(itemsData,boundingBox){var i;var len=itemsData.length;for(i=0;i<len;i+=1){if(itemsData[i]&&itemsData[i].sh){this.calculateShapeBoundingBox(itemsData[i],boundingBox);}else if(itemsData[i]&&itemsData[i].it){this.calculateBoundingBox(itemsData[i].it,boundingBox);}else if(itemsData[i]&&itemsData[i].style&&itemsData[i].w){this.expandStrokeBoundingBox(itemsData[i].w,boundingBox);}}};HShapeElement.prototype.expandStrokeBoundingBox=function(widthProperty,boundingBox){var width=0;if(widthProperty.keyframes){for(var i=0;i<widthProperty.keyframes.length;i+=1){var kfw=widthProperty.keyframes[i].s;if(kfw>width){width=kfw;}}width*=widthProperty.mult;}else{width=widthProperty.v*widthProperty.mult;}boundingBox.x-=width;boundingBox.xMax+=width;boundingBox.y-=width;boundingBox.yMax+=width;};HShapeElement.prototype.currentBoxContains=function(box){return this.currentBBox.x<=box.x&&this.currentBBox.y<=box.y&&this.currentBBox.width+this.currentBBox.x>=box.x+box.width&&this.currentBBox.height+this.currentBBox.y>=box.y+box.height;};HShapeElement.prototype.renderInnerContent=function(){this._renderShapeFrame();if(!this.hidden&&(this._isFirstFrame||this._mdf)){var tempBoundingBox=this.tempBoundingBox;var max=999999;tempBoundingBox.x=max;tempBoundingBox.xMax=-max;tempBoundingBox.y=max;tempBoundingBox.yMax=-max;this.calculateBoundingBox(this.itemsData,tempBoundingBox);tempBoundingBox.width=tempBoundingBox.xMax<tempBoundingBox.x?0:tempBoundingBox.xMax-tempBoundingBox.x;tempBoundingBox.height=tempBoundingBox.yMax<tempBoundingBox.y?0:tempBoundingBox.yMax-tempBoundingBox.y;// var tempBoundingBox = this.shapeCont.getBBox();
if(this.currentBoxContains(tempBoundingBox)){return;}var changed=false;if(this.currentBBox.w!==tempBoundingBox.width){this.currentBBox.w=tempBoundingBox.width;this.shapeCont.setAttribute('width',tempBoundingBox.width);changed=true;}if(this.currentBBox.h!==tempBoundingBox.height){this.currentBBox.h=tempBoundingBox.height;this.shapeCont.setAttribute('height',tempBoundingBox.height);changed=true;}if(changed||this.currentBBox.x!==tempBoundingBox.x||this.currentBBox.y!==tempBoundingBox.y){this.currentBBox.w=tempBoundingBox.width;this.currentBBox.h=tempBoundingBox.height;this.currentBBox.x=tempBoundingBox.x;this.currentBBox.y=tempBoundingBox.y;this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);var shapeStyle=this.shapeCont.style;var shapeTransform='translate('+this.currentBBox.x+'px,'+this.currentBBox.y+'px)';shapeStyle.transform=shapeTransform;shapeStyle.webkitTransform=shapeTransform;}}};function HTextElement(data,globalData,comp){this.textSpans=[];this.textPaths=[];this.currentBBox={x:999999,y:-999999,h:0,w:0};this.renderType='svg';this.isMasked=false;this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,HBaseElement,HierarchyElement,FrameElement,RenderableDOMElement,ITextElement],HTextElement);HTextElement.prototype.createContent=function(){this.isMasked=this.checkMasks();if(this.isMasked){this.renderType='svg';this.compW=this.comp.data.w;this.compH=this.comp.data.h;this.svgElement.setAttribute('width',this.compW);this.svgElement.setAttribute('height',this.compH);var g=createNS('g');this.maskedElement.appendChild(g);this.innerElem=g;}else{this.renderType='html';this.innerElem=this.layerElement;}this.checkParenting();};HTextElement.prototype.buildNewText=function(){var documentData=this.textProperty.currentData;this.renderedLetters=createSizedArray(documentData.l?documentData.l.length:0);var innerElemStyle=this.innerElem.style;var textColor=documentData.fc?this.buildColor(documentData.fc):'rgba(0,0,0,0)';innerElemStyle.fill=textColor;innerElemStyle.color=textColor;if(documentData.sc){innerElemStyle.stroke=this.buildColor(documentData.sc);innerElemStyle.strokeWidth=documentData.sw+'px';}var fontData=this.globalData.fontManager.getFontByName(documentData.f);if(!this.globalData.fontManager.chars){innerElemStyle.fontSize=documentData.finalSize+'px';innerElemStyle.lineHeight=documentData.finalSize+'px';if(fontData.fClass){this.innerElem.className=fontData.fClass;}else{innerElemStyle.fontFamily=fontData.fFamily;var fWeight=documentData.fWeight;var fStyle=documentData.fStyle;innerElemStyle.fontStyle=fStyle;innerElemStyle.fontWeight=fWeight;}}var i;var len;var letters=documentData.l;len=letters.length;var tSpan;var tParent;var tCont;var matrixHelper=this.mHelper;var shapes;var shapeStr='';var cnt=0;for(i=0;i<len;i+=1){if(this.globalData.fontManager.chars){if(!this.textPaths[cnt]){tSpan=createNS('path');tSpan.setAttribute('stroke-linecap',lineCapEnum[1]);tSpan.setAttribute('stroke-linejoin',lineJoinEnum[2]);tSpan.setAttribute('stroke-miterlimit','4');}else{tSpan=this.textPaths[cnt];}if(!this.isMasked){if(this.textSpans[cnt]){tParent=this.textSpans[cnt];tCont=tParent.children[0];}else{tParent=createTag('div');tParent.style.lineHeight=0;tCont=createNS('svg');tCont.appendChild(tSpan);styleDiv(tParent);}}}else if(!this.isMasked){if(this.textSpans[cnt]){tParent=this.textSpans[cnt];tSpan=this.textPaths[cnt];}else{tParent=createTag('span');styleDiv(tParent);tSpan=createTag('span');styleDiv(tSpan);tParent.appendChild(tSpan);}}else{tSpan=this.textPaths[cnt]?this.textPaths[cnt]:createNS('text');}// tSpan.setAttribute('visibility', 'hidden');
if(this.globalData.fontManager.chars){var charData=this.globalData.fontManager.getCharData(documentData.finalText[i],fontData.fStyle,this.globalData.fontManager.getFontByName(documentData.f).fFamily);var shapeData;if(charData){shapeData=charData.data;}else{shapeData=null;}matrixHelper.reset();if(shapeData&&shapeData.shapes&&shapeData.shapes.length){shapes=shapeData.shapes[0].it;matrixHelper.scale(documentData.finalSize/100,documentData.finalSize/100);shapeStr=this.createPathShape(matrixHelper,shapes);tSpan.setAttribute('d',shapeStr);}if(!this.isMasked){this.innerElem.appendChild(tParent);if(shapeData&&shapeData.shapes){// document.body.appendChild is needed to get exact measure of shape
document.body.appendChild(tCont);var boundingBox=tCont.getBBox();tCont.setAttribute('width',boundingBox.width+2);tCont.setAttribute('height',boundingBox.height+2);tCont.setAttribute('viewBox',boundingBox.x-1+' '+(boundingBox.y-1)+' '+(boundingBox.width+2)+' '+(boundingBox.height+2));var tContStyle=tCont.style;var tContTranslation='translate('+(boundingBox.x-1)+'px,'+(boundingBox.y-1)+'px)';tContStyle.transform=tContTranslation;tContStyle.webkitTransform=tContTranslation;letters[i].yOffset=boundingBox.y-1;}else{tCont.setAttribute('width',1);tCont.setAttribute('height',1);}tParent.appendChild(tCont);}else{this.innerElem.appendChild(tSpan);}}else{tSpan.textContent=letters[i].val;tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace','xml:space','preserve');if(!this.isMasked){this.innerElem.appendChild(tParent);//
var tStyle=tSpan.style;var tSpanTranslation='translate3d(0,'+-documentData.finalSize/1.2+'px,0)';tStyle.transform=tSpanTranslation;tStyle.webkitTransform=tSpanTranslation;}else{this.innerElem.appendChild(tSpan);}}//
if(!this.isMasked){this.textSpans[cnt]=tParent;}else{this.textSpans[cnt]=tSpan;}this.textSpans[cnt].style.display='block';this.textPaths[cnt]=tSpan;cnt+=1;}while(cnt<this.textSpans.length){this.textSpans[cnt].style.display='none';cnt+=1;}};HTextElement.prototype.renderInnerContent=function(){this.validateText();var svgStyle;if(this.data.singleShape){if(!this._isFirstFrame&&!this.lettersChangedFlag){return;}if(this.isMasked&&this.finalTransform._matMdf){// Todo Benchmark if using this is better than getBBox
this.svgElement.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+-this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);svgStyle=this.svgElement.style;var translation='translate('+-this.finalTransform.mProp.p.v[0]+'px,'+-this.finalTransform.mProp.p.v[1]+'px)';svgStyle.transform=translation;svgStyle.webkitTransform=translation;}}this.textAnimator.getMeasures(this.textProperty.currentData,this.lettersChangedFlag);if(!this.lettersChangedFlag&&!this.textAnimator.lettersChangedFlag){return;}var i;var len;var count=0;var renderedLetters=this.textAnimator.renderedLetters;var letters=this.textProperty.currentData.l;len=letters.length;var renderedLetter;var textSpan;var textPath;for(i=0;i<len;i+=1){if(letters[i].n){count+=1;}else{textSpan=this.textSpans[i];textPath=this.textPaths[i];renderedLetter=renderedLetters[count];count+=1;if(renderedLetter._mdf.m){if(!this.isMasked){textSpan.style.webkitTransform=renderedLetter.m;textSpan.style.transform=renderedLetter.m;}else{textSpan.setAttribute('transform',renderedLetter.m);}}/// /textSpan.setAttribute('opacity',renderedLetter.o);
textSpan.style.opacity=renderedLetter.o;if(renderedLetter.sw&&renderedLetter._mdf.sw){textPath.setAttribute('stroke-width',renderedLetter.sw);}if(renderedLetter.sc&&renderedLetter._mdf.sc){textPath.setAttribute('stroke',renderedLetter.sc);}if(renderedLetter.fc&&renderedLetter._mdf.fc){textPath.setAttribute('fill',renderedLetter.fc);textPath.style.color=renderedLetter.fc;}}}if(this.innerElem.getBBox&&!this.hidden&&(this._isFirstFrame||this._mdf)){var boundingBox=this.innerElem.getBBox();if(this.currentBBox.w!==boundingBox.width){this.currentBBox.w=boundingBox.width;this.svgElement.setAttribute('width',boundingBox.width);}if(this.currentBBox.h!==boundingBox.height){this.currentBBox.h=boundingBox.height;this.svgElement.setAttribute('height',boundingBox.height);}var margin=1;if(this.currentBBox.w!==boundingBox.width+margin*2||this.currentBBox.h!==boundingBox.height+margin*2||this.currentBBox.x!==boundingBox.x-margin||this.currentBBox.y!==boundingBox.y-margin){this.currentBBox.w=boundingBox.width+margin*2;this.currentBBox.h=boundingBox.height+margin*2;this.currentBBox.x=boundingBox.x-margin;this.currentBBox.y=boundingBox.y-margin;this.svgElement.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);svgStyle=this.svgElement.style;var svgTransform='translate('+this.currentBBox.x+'px,'+this.currentBBox.y+'px)';svgStyle.transform=svgTransform;svgStyle.webkitTransform=svgTransform;}}};function HCameraElement(data,globalData,comp){this.initFrame();this.initBaseData(data,globalData,comp);this.initHierarchy();var getProp=PropertyFactory.getProp;this.pe=getProp(this,data.pe,0,0,this);if(data.ks.p.s){this.px=getProp(this,data.ks.p.x,1,0,this);this.py=getProp(this,data.ks.p.y,1,0,this);this.pz=getProp(this,data.ks.p.z,1,0,this);}else{this.p=getProp(this,data.ks.p,1,0,this);}if(data.ks.a){this.a=getProp(this,data.ks.a,1,0,this);}if(data.ks.or.k.length&&data.ks.or.k[0].to){var i;var len=data.ks.or.k.length;for(i=0;i<len;i+=1){data.ks.or.k[i].to=null;data.ks.or.k[i].ti=null;}}this.or=getProp(this,data.ks.or,1,degToRads,this);this.or.sh=true;this.rx=getProp(this,data.ks.rx,0,degToRads,this);this.ry=getProp(this,data.ks.ry,0,degToRads,this);this.rz=getProp(this,data.ks.rz,0,degToRads,this);this.mat=new Matrix();this._prevMat=new Matrix();this._isFirstFrame=true;// TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
this.finalTransform={mProp:this};}extendPrototype([BaseElement,FrameElement,HierarchyElement],HCameraElement);HCameraElement.prototype.setup=function(){var i;var len=this.comp.threeDElements.length;var comp;var perspectiveStyle;var containerStyle;for(i=0;i<len;i+=1){// [perspectiveElem,container]
comp=this.comp.threeDElements[i];if(comp.type==='3d'){perspectiveStyle=comp.perspectiveElem.style;containerStyle=comp.container.style;var perspective=this.pe.v+'px';var origin='0px 0px 0px';var matrix='matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';perspectiveStyle.perspective=perspective;perspectiveStyle.webkitPerspective=perspective;containerStyle.transformOrigin=origin;containerStyle.mozTransformOrigin=origin;containerStyle.webkitTransformOrigin=origin;perspectiveStyle.transform=matrix;perspectiveStyle.webkitTransform=matrix;}}};HCameraElement.prototype.createElements=function(){};HCameraElement.prototype.hide=function(){};HCameraElement.prototype.renderFrame=function(){var _mdf=this._isFirstFrame;var i;var len;if(this.hierarchy){len=this.hierarchy.length;for(i=0;i<len;i+=1){_mdf=this.hierarchy[i].finalTransform.mProp._mdf||_mdf;}}if(_mdf||this.pe._mdf||this.p&&this.p._mdf||this.px&&(this.px._mdf||this.py._mdf||this.pz._mdf)||this.rx._mdf||this.ry._mdf||this.rz._mdf||this.or._mdf||this.a&&this.a._mdf){this.mat.reset();if(this.hierarchy){len=this.hierarchy.length-1;for(i=len;i>=0;i-=1){var mTransf=this.hierarchy[i].finalTransform.mProp;this.mat.translate(-mTransf.p.v[0],-mTransf.p.v[1],mTransf.p.v[2]);this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);this.mat.scale(1/mTransf.s.v[0],1/mTransf.s.v[1],1/mTransf.s.v[2]);this.mat.translate(mTransf.a.v[0],mTransf.a.v[1],mTransf.a.v[2]);}}if(this.p){this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);}else{this.mat.translate(-this.px.v,-this.py.v,this.pz.v);}if(this.a){var diffVector;if(this.p){diffVector=[this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];}else{diffVector=[this.px.v-this.a.v[0],this.py.v-this.a.v[1],this.pz.v-this.a.v[2]];}var mag=Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));// var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
var lookDir=[diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];var lookLengthOnXZ=Math.sqrt(lookDir[2]*lookDir[2]+lookDir[0]*lookDir[0]);var mRotationX=Math.atan2(lookDir[1],lookLengthOnXZ);var mRotationY=Math.atan2(lookDir[0],-lookDir[2]);this.mat.rotateY(mRotationY).rotateX(-mRotationX);}this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);this.mat.translate(0,0,this.pe.v);var hasMatrixChanged=!this._prevMat.equals(this.mat);if((hasMatrixChanged||this.pe._mdf)&&this.comp.threeDElements){len=this.comp.threeDElements.length;var comp;var perspectiveStyle;var containerStyle;for(i=0;i<len;i+=1){comp=this.comp.threeDElements[i];if(comp.type==='3d'){if(hasMatrixChanged){var matValue=this.mat.toCSS();containerStyle=comp.container.style;containerStyle.transform=matValue;containerStyle.webkitTransform=matValue;}if(this.pe._mdf){perspectiveStyle=comp.perspectiveElem.style;perspectiveStyle.perspective=this.pe.v+'px';perspectiveStyle.webkitPerspective=this.pe.v+'px';}}}this.mat.clone(this._prevMat);}}this._isFirstFrame=false;};HCameraElement.prototype.prepareFrame=function(num){this.prepareProperties(num,true);};HCameraElement.prototype.destroy=function(){};HCameraElement.prototype.getBaseElement=function(){return null;};function HImageElement(data,globalData,comp){this.assetData=globalData.getAssetData(data.refId);this.initElement(data,globalData,comp);}extendPrototype([BaseElement,TransformElement,HBaseElement,HSolidElement,HierarchyElement,FrameElement,RenderableElement],HImageElement);HImageElement.prototype.createContent=function(){var assetPath=this.globalData.getAssetsPath(this.assetData);var img=new Image();if(this.data.hasMask){this.imageElem=createNS('image');this.imageElem.setAttribute('width',this.assetData.w+'px');this.imageElem.setAttribute('height',this.assetData.h+'px');this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);this.layerElement.appendChild(this.imageElem);this.baseElement.setAttribute('width',this.assetData.w);this.baseElement.setAttribute('height',this.assetData.h);}else{this.layerElement.appendChild(img);}img.crossOrigin='anonymous';img.src=assetPath;if(this.data.ln){this.baseElement.setAttribute('id',this.data.ln);}};function HybridRendererBase(animationItem,config){this.animationItem=animationItem;this.layers=null;this.renderedFrame=-1;this.renderConfig={className:config&&config.className||'',imagePreserveAspectRatio:config&&config.imagePreserveAspectRatio||'xMidYMid slice',hideOnTransparent:!(config&&config.hideOnTransparent===false),filterSize:{width:config&&config.filterSize&&config.filterSize.width||'400%',height:config&&config.filterSize&&config.filterSize.height||'400%',x:config&&config.filterSize&&config.filterSize.x||'-100%',y:config&&config.filterSize&&config.filterSize.y||'-100%'}};this.globalData={_mdf:false,frameNum:-1,renderConfig:this.renderConfig};this.pendingElements=[];this.elements=[];this.threeDElements=[];this.destroyed=false;this.camera=null;this.supports3d=true;this.rendererType='html';}extendPrototype([BaseRenderer],HybridRendererBase);HybridRendererBase.prototype.buildItem=SVGRenderer.prototype.buildItem;HybridRendererBase.prototype.checkPendingElements=function(){while(this.pendingElements.length){var element=this.pendingElements.pop();element.checkParenting();}};HybridRendererBase.prototype.appendElementInPos=function(element,pos){var newDOMElement=element.getBaseElement();if(!newDOMElement){return;}var layer=this.layers[pos];if(!layer.ddd||!this.supports3d){if(this.threeDElements){this.addTo3dContainer(newDOMElement,pos);}else{var i=0;var nextDOMElement;var nextLayer;var tmpDOMElement;while(i<pos){if(this.elements[i]&&this.elements[i]!==true&&this.elements[i].getBaseElement){nextLayer=this.elements[i];tmpDOMElement=this.layers[i].ddd?this.getThreeDContainerByPos(i):nextLayer.getBaseElement();nextDOMElement=tmpDOMElement||nextDOMElement;}i+=1;}if(nextDOMElement){if(!layer.ddd||!this.supports3d){this.layerElement.insertBefore(newDOMElement,nextDOMElement);}}else if(!layer.ddd||!this.supports3d){this.layerElement.appendChild(newDOMElement);}}}else{this.addTo3dContainer(newDOMElement,pos);}};HybridRendererBase.prototype.createShape=function(data){if(!this.supports3d){return new SVGShapeElement(data,this.globalData,this);}return new HShapeElement(data,this.globalData,this);};HybridRendererBase.prototype.createText=function(data){if(!this.supports3d){return new SVGTextLottieElement(data,this.globalData,this);}return new HTextElement(data,this.globalData,this);};HybridRendererBase.prototype.createCamera=function(data){this.camera=new HCameraElement(data,this.globalData,this);return this.camera;};HybridRendererBase.prototype.createImage=function(data){if(!this.supports3d){return new IImageElement(data,this.globalData,this);}return new HImageElement(data,this.globalData,this);};HybridRendererBase.prototype.createSolid=function(data){if(!this.supports3d){return new ISolidElement(data,this.globalData,this);}return new HSolidElement(data,this.globalData,this);};HybridRendererBase.prototype.createNull=SVGRenderer.prototype.createNull;HybridRendererBase.prototype.getThreeDContainerByPos=function(pos){var i=0;var len=this.threeDElements.length;while(i<len){if(this.threeDElements[i].startPos<=pos&&this.threeDElements[i].endPos>=pos){return this.threeDElements[i].perspectiveElem;}i+=1;}return null;};HybridRendererBase.prototype.createThreeDContainer=function(pos,type){var perspectiveElem=createTag('div');var style;var containerStyle;styleDiv(perspectiveElem);var container=createTag('div');styleDiv(container);if(type==='3d'){style=perspectiveElem.style;style.width=this.globalData.compSize.w+'px';style.height=this.globalData.compSize.h+'px';var center='50% 50%';style.webkitTransformOrigin=center;style.mozTransformOrigin=center;style.transformOrigin=center;containerStyle=container.style;var matrix='matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';containerStyle.transform=matrix;containerStyle.webkitTransform=matrix;}perspectiveElem.appendChild(container);// this.resizerElem.appendChild(perspectiveElem);
var threeDContainerData={container:container,perspectiveElem:perspectiveElem,startPos:pos,endPos:pos,type:type};this.threeDElements.push(threeDContainerData);return threeDContainerData;};HybridRendererBase.prototype.build3dContainers=function(){var i;var len=this.layers.length;var lastThreeDContainerData;var currentContainer='';for(i=0;i<len;i+=1){if(this.layers[i].ddd&&this.layers[i].ty!==3){if(currentContainer!=='3d'){currentContainer='3d';lastThreeDContainerData=this.createThreeDContainer(i,'3d');}lastThreeDContainerData.endPos=Math.max(lastThreeDContainerData.endPos,i);}else{if(currentContainer!=='2d'){currentContainer='2d';lastThreeDContainerData=this.createThreeDContainer(i,'2d');}lastThreeDContainerData.endPos=Math.max(lastThreeDContainerData.endPos,i);}}len=this.threeDElements.length;for(i=len-1;i>=0;i-=1){this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);}};HybridRendererBase.prototype.addTo3dContainer=function(elem,pos){var i=0;var len=this.threeDElements.length;while(i<len){if(pos<=this.threeDElements[i].endPos){var j=this.threeDElements[i].startPos;var nextElement;while(j<pos){if(this.elements[j]&&this.elements[j].getBaseElement){nextElement=this.elements[j].getBaseElement();}j+=1;}if(nextElement){this.threeDElements[i].container.insertBefore(elem,nextElement);}else{this.threeDElements[i].container.appendChild(elem);}break;}i+=1;}};HybridRendererBase.prototype.configAnimation=function(animData){var resizerElem=createTag('div');var wrapper=this.animationItem.wrapper;var style=resizerElem.style;style.width=animData.w+'px';style.height=animData.h+'px';this.resizerElem=resizerElem;styleDiv(resizerElem);style.transformStyle='flat';style.mozTransformStyle='flat';style.webkitTransformStyle='flat';if(this.renderConfig.className){resizerElem.setAttribute('class',this.renderConfig.className);}wrapper.appendChild(resizerElem);style.overflow='hidden';var svg=createNS('svg');svg.setAttribute('width','1');svg.setAttribute('height','1');styleDiv(svg);this.resizerElem.appendChild(svg);var defs=createNS('defs');svg.appendChild(defs);this.data=animData;// Mask animation
this.setupGlobalData(animData,svg);this.globalData.defs=defs;this.layers=animData.layers;this.layerElement=this.resizerElem;this.build3dContainers();this.updateContainerSize();};HybridRendererBase.prototype.destroy=function(){if(this.animationItem.wrapper){this.animationItem.wrapper.innerText='';}this.animationItem.container=null;this.globalData.defs=null;var i;var len=this.layers?this.layers.length:0;for(i=0;i<len;i+=1){if(this.elements[i]&&this.elements[i].destroy){this.elements[i].destroy();}}this.elements.length=0;this.destroyed=true;this.animationItem=null;};HybridRendererBase.prototype.updateContainerSize=function(){var elementWidth=this.animationItem.wrapper.offsetWidth;var elementHeight=this.animationItem.wrapper.offsetHeight;var elementRel=elementWidth/elementHeight;var animationRel=this.globalData.compSize.w/this.globalData.compSize.h;var sx;var sy;var tx;var ty;if(animationRel>elementRel){sx=elementWidth/this.globalData.compSize.w;sy=elementWidth/this.globalData.compSize.w;tx=0;ty=(elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2;}else{sx=elementHeight/this.globalData.compSize.h;sy=elementHeight/this.globalData.compSize.h;tx=(elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;ty=0;}var style=this.resizerElem.style;style.webkitTransform='matrix3d('+sx+',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';style.transform=style.webkitTransform;};HybridRendererBase.prototype.renderFrame=SVGRenderer.prototype.renderFrame;HybridRendererBase.prototype.hide=function(){this.resizerElem.style.display='none';};HybridRendererBase.prototype.show=function(){this.resizerElem.style.display='block';};HybridRendererBase.prototype.initItems=function(){this.buildAllItems();if(this.camera){this.camera.setup();}else{var cWidth=this.globalData.compSize.w;var cHeight=this.globalData.compSize.h;var i;var len=this.threeDElements.length;for(i=0;i<len;i+=1){var style=this.threeDElements[i].perspectiveElem.style;style.webkitPerspective=Math.sqrt(Math.pow(cWidth,2)+Math.pow(cHeight,2))+'px';style.perspective=style.webkitPerspective;}}};HybridRendererBase.prototype.searchExtraCompositions=function(assets){var i;var len=assets.length;var floatingContainer=createTag('div');for(i=0;i<len;i+=1){if(assets[i].xt){var comp=this.createComp(assets[i],floatingContainer,this.globalData.comp,null);comp.initExpressions();this.globalData.projectInterface.registerComposition(comp);}}};function HCompElement(data,globalData,comp){this.layers=data.layers;this.supports3d=!data.hasMask;this.completeLayers=false;this.pendingElements=[];this.elements=this.layers?createSizedArray(this.layers.length):[];this.initElement(data,globalData,comp);this.tm=data.tm?PropertyFactory.getProp(this,data.tm,0,globalData.frameRate,this):{_placeholder:true};}extendPrototype([HybridRendererBase,ICompElement,HBaseElement],HCompElement);HCompElement.prototype._createBaseContainerElements=HCompElement.prototype.createContainerElements;HCompElement.prototype.createContainerElements=function(){this._createBaseContainerElements();// divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
if(this.data.hasMask){this.svgElement.setAttribute('width',this.data.w);this.svgElement.setAttribute('height',this.data.h);this.transformedElement=this.baseElement;}else{this.transformedElement=this.layerElement;}};HCompElement.prototype.addTo3dContainer=function(elem,pos){var j=0;var nextElement;while(j<pos){if(this.elements[j]&&this.elements[j].getBaseElement){nextElement=this.elements[j].getBaseElement();}j+=1;}if(nextElement){this.layerElement.insertBefore(elem,nextElement);}else{this.layerElement.appendChild(elem);}};HCompElement.prototype.createComp=function(data){if(!this.supports3d){return new SVGCompElement(data,this.globalData,this);}return new HCompElement(data,this.globalData,this);};function HybridRenderer(animationItem,config){this.animationItem=animationItem;this.layers=null;this.renderedFrame=-1;this.renderConfig={className:config&&config.className||'',imagePreserveAspectRatio:config&&config.imagePreserveAspectRatio||'xMidYMid slice',hideOnTransparent:!(config&&config.hideOnTransparent===false),filterSize:{width:config&&config.filterSize&&config.filterSize.width||'400%',height:config&&config.filterSize&&config.filterSize.height||'400%',x:config&&config.filterSize&&config.filterSize.x||'-100%',y:config&&config.filterSize&&config.filterSize.y||'-100%'},runExpressions:!config||config.runExpressions===undefined||config.runExpressions};this.globalData={_mdf:false,frameNum:-1,renderConfig:this.renderConfig};this.pendingElements=[];this.elements=[];this.threeDElements=[];this.destroyed=false;this.camera=null;this.supports3d=true;this.rendererType='html';}extendPrototype([HybridRendererBase],HybridRenderer);HybridRenderer.prototype.createComp=function(data){if(!this.supports3d){return new SVGCompElement(data,this.globalData,this);}return new HCompElement(data,this.globalData,this);};var CompExpressionInterface=function(){return function(comp){function _thisLayerFunction(name){var i=0;var len=comp.layers.length;while(i<len){if(comp.layers[i].nm===name||comp.layers[i].ind===name){return comp.elements[i].layerInterface;}i+=1;}return null;// return {active:false};
}Object.defineProperty(_thisLayerFunction,'_name',{value:comp.data.nm});_thisLayerFunction.layer=_thisLayerFunction;_thisLayerFunction.pixelAspect=1;_thisLayerFunction.height=comp.data.h||comp.globalData.compSize.h;_thisLayerFunction.width=comp.data.w||comp.globalData.compSize.w;_thisLayerFunction.pixelAspect=1;_thisLayerFunction.frameDuration=1/comp.globalData.frameRate;_thisLayerFunction.displayStartTime=0;_thisLayerFunction.numLayers=comp.layers.length;return _thisLayerFunction;};}();function _typeof$2(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$2=function _typeof(obj){return typeof obj;};}else{_typeof$2=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$2(obj);}/* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */function seedRandom(pool,math){//
// The following constants are related to IEEE 754 limits.
//
var global=this,width=256,// each RC4 output is 0 <= x < 256
chunks=6,// at least six RC4 outputs for each double
digits=52,// there are 52 significant digits in a double
rngname='random',// rngname: name for Math.random and Math.seedrandom
startdenom=math.pow(width,chunks),significance=math.pow(2,digits),overflow=significance*2,mask=width-1,nodecrypto;// node.js crypto module, initialized at the bottom.
//
// seedrandom()
// This is the seedrandom function described above.
//
function seedrandom(seed,options,callback){var key=[];options=options===true?{entropy:true}:options||{};// Flatten the seed string or build one from local entropy if needed.
var shortseed=mixkey(flatten(options.entropy?[seed,tostring(pool)]:seed===null?autoseed():seed,3),key);// Use the seed to initialize an ARC4 generator.
var arc4=new ARC4(key);// This function returns a random double in [0, 1) that contains
// randomness in every bit of the mantissa of the IEEE 754 value.
var prng=function prng(){var n=arc4.g(chunks),// Start with a numerator n < 2 ^ 48
d=startdenom,//   and denominator d = 2 ^ 48.
x=0;//   and no 'extra last byte'.
while(n<significance){// Fill up all significant digits by
n=(n+x)*width;//   shifting numerator and
d*=width;//   denominator and generating a
x=arc4.g(1);//   new least-significant-byte.
}while(n>=overflow){// To avoid rounding up, before adding
n/=2;//   last byte, shift everything
d/=2;//   right using integer math until
x>>>=1;//   we have exactly the desired bits.
}return(n+x)/d;// Form the number within [0, 1).
};prng.int32=function(){return arc4.g(4)|0;};prng.quick=function(){return arc4.g(4)/0x100000000;};prng["double"]=prng;// Mix the randomness into accumulated entropy.
mixkey(tostring(arc4.S),pool);// Calling convention: what to return as a function of prng, seed, is_math.
return(options.pass||callback||function(prng,seed,is_math_call,state){if(state){// Load the arc4 state from the given state if it has an S array.
if(state.S){copy(state,arc4);}// Only provide the .state method if requested via options.state.
prng.state=function(){return copy(arc4,{});};}// If called as a method of Math (Math.seedrandom()), mutate
// Math.random because that is how seedrandom.js has worked since v1.0.
if(is_math_call){math[rngname]=prng;return seed;}// Otherwise, it is a newer calling convention, so return the
// prng directly.
else return prng;})(prng,shortseed,'global'in options?options.global:this==math,options.state);}math['seed'+rngname]=seedrandom;//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
function ARC4(key){var t,keylen=key.length,me=this,i=0,j=me.i=me.j=0,s=me.S=[];// The empty key [] is treated as [0].
if(!keylen){key=[keylen++];}// Set up S using the standard key scheduling algorithm.
while(i<width){s[i]=i++;}for(i=0;i<width;i++){s[i]=s[j=mask&j+key[i%keylen]+(t=s[i])];s[j]=t;}// The "g" method returns the next (count) outputs as one number.
me.g=function(count){// Using instance members instead of closure state nearly doubles speed.
var t,r=0,i=me.i,j=me.j,s=me.S;while(count--){t=s[i=mask&i+1];r=r*width+s[mask&(s[i]=s[j=mask&j+t])+(s[j]=t)];}me.i=i;me.j=j;return r;// For robust unpredictability, the function call below automatically
// discards an initial batch of values.  This is called RC4-drop[256].
// See http://google.com/search?q=rsa+fluhrer+response&btnI
};}//
// copy()
// Copies internal state of ARC4 to or from a plain object.
//
function copy(f,t){t.i=f.i;t.j=f.j;t.S=f.S.slice();return t;}//
// flatten()
// Converts an object tree to nested arrays of strings.
//
function flatten(obj,depth){var result=[],typ=_typeof$2(obj),prop;if(depth&&typ=='object'){for(prop in obj){try{result.push(flatten(obj[prop],depth-1));}catch(e){}}}return result.length?result:typ=='string'?obj:obj+'\0';}//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
function mixkey(seed,key){var stringseed=seed+'',smear,j=0;while(j<stringseed.length){key[mask&j]=mask&(smear^=key[mask&j]*19)+stringseed.charCodeAt(j++);}return tostring(key);}//
// autoseed()
// Returns an object for autoseeding, using window.crypto and Node crypto
// module if available.
//
function autoseed(){try{if(nodecrypto){return tostring(nodecrypto.randomBytes(width));}var out=new Uint8Array(width);(global.crypto||global.msCrypto).getRandomValues(out);return tostring(out);}catch(e){var browser=global.navigator,plugins=browser&&browser.plugins;return[+new Date(),global,plugins,global.screen,tostring(pool)];}}//
// tostring()
// Converts an array of charcodes to a string
//
function tostring(a){return String.fromCharCode.apply(0,a);}//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to interfere with deterministic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
mixkey(math.random(),pool);//
// Nodejs and AMD support: export the implementation as a module using
// either convention.
//
// End anonymous scope, and pass initial values.
};function initialize$2(BMMath){seedRandom([],BMMath);}var propTypes={SHAPE:'shape'};function _typeof$1(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof$1=function _typeof(obj){return typeof obj;};}else{_typeof$1=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof$1(obj);}var ExpressionManager=function(){'use strict';var ob={};var Math=BMMath;var window=null;var document=null;var XMLHttpRequest=null;var fetch=null;var frames=null;var _lottieGlobal={};initialize$2(BMMath);function resetFrame(){_lottieGlobal={};}function $bm_isInstanceOfArray(arr){return arr.constructor===Array||arr.constructor===Float32Array;}function isNumerable(tOfV,v){return tOfV==='number'||v instanceof Number||tOfV==='boolean'||tOfV==='string';}function $bm_neg(a){var tOfA=_typeof$1(a);if(tOfA==='number'||a instanceof Number||tOfA==='boolean'){return-a;}if($bm_isInstanceOfArray(a)){var i;var lenA=a.length;var retArr=[];for(i=0;i<lenA;i+=1){retArr[i]=-a[i];}return retArr;}if(a.propType){return a.v;}return-a;}var easeInBez=BezierFactory.getBezierEasing(0.333,0,0.833,0.833,'easeIn').get;var easeOutBez=BezierFactory.getBezierEasing(0.167,0.167,0.667,1,'easeOut').get;var easeInOutBez=BezierFactory.getBezierEasing(0.33,0,0.667,1,'easeInOut').get;function sum(a,b){var tOfA=_typeof$1(a);var tOfB=_typeof$1(b);if(isNumerable(tOfA,a)&&isNumerable(tOfB,b)||tOfA==='string'||tOfB==='string'){return a+b;}if($bm_isInstanceOfArray(a)&&isNumerable(tOfB,b)){a=a.slice(0);a[0]+=b;return a;}if(isNumerable(tOfA,a)&&$bm_isInstanceOfArray(b)){b=b.slice(0);b[0]=a+b[0];return b;}if($bm_isInstanceOfArray(a)&&$bm_isInstanceOfArray(b)){var i=0;var lenA=a.length;var lenB=b.length;var retArr=[];while(i<lenA||i<lenB){if((typeof a[i]==='number'||a[i]instanceof Number)&&(typeof b[i]==='number'||b[i]instanceof Number)){retArr[i]=a[i]+b[i];}else{retArr[i]=b[i]===undefined?a[i]:a[i]||b[i];}i+=1;}return retArr;}return 0;}var add=sum;function sub(a,b){var tOfA=_typeof$1(a);var tOfB=_typeof$1(b);if(isNumerable(tOfA,a)&&isNumerable(tOfB,b)){if(tOfA==='string'){a=parseInt(a,10);}if(tOfB==='string'){b=parseInt(b,10);}return a-b;}if($bm_isInstanceOfArray(a)&&isNumerable(tOfB,b)){a=a.slice(0);a[0]-=b;return a;}if(isNumerable(tOfA,a)&&$bm_isInstanceOfArray(b)){b=b.slice(0);b[0]=a-b[0];return b;}if($bm_isInstanceOfArray(a)&&$bm_isInstanceOfArray(b)){var i=0;var lenA=a.length;var lenB=b.length;var retArr=[];while(i<lenA||i<lenB){if((typeof a[i]==='number'||a[i]instanceof Number)&&(typeof b[i]==='number'||b[i]instanceof Number)){retArr[i]=a[i]-b[i];}else{retArr[i]=b[i]===undefined?a[i]:a[i]||b[i];}i+=1;}return retArr;}return 0;}function mul(a,b){var tOfA=_typeof$1(a);var tOfB=_typeof$1(b);var arr;if(isNumerable(tOfA,a)&&isNumerable(tOfB,b)){return a*b;}var i;var len;if($bm_isInstanceOfArray(a)&&isNumerable(tOfB,b)){len=a.length;arr=createTypedArray('float32',len);for(i=0;i<len;i+=1){arr[i]=a[i]*b;}return arr;}if(isNumerable(tOfA,a)&&$bm_isInstanceOfArray(b)){len=b.length;arr=createTypedArray('float32',len);for(i=0;i<len;i+=1){arr[i]=a*b[i];}return arr;}return 0;}function div(a,b){var tOfA=_typeof$1(a);var tOfB=_typeof$1(b);var arr;if(isNumerable(tOfA,a)&&isNumerable(tOfB,b)){return a/b;}var i;var len;if($bm_isInstanceOfArray(a)&&isNumerable(tOfB,b)){len=a.length;arr=createTypedArray('float32',len);for(i=0;i<len;i+=1){arr[i]=a[i]/b;}return arr;}if(isNumerable(tOfA,a)&&$bm_isInstanceOfArray(b)){len=b.length;arr=createTypedArray('float32',len);for(i=0;i<len;i+=1){arr[i]=a/b[i];}return arr;}return 0;}function mod(a,b){if(typeof a==='string'){a=parseInt(a,10);}if(typeof b==='string'){b=parseInt(b,10);}return a%b;}var $bm_sum=sum;var $bm_sub=sub;var $bm_mul=mul;var $bm_div=div;var $bm_mod=mod;function clamp(num,min,max){if(min>max){var mm=max;max=min;min=mm;}return Math.min(Math.max(num,min),max);}function radiansToDegrees(val){return val/degToRads;}var radians_to_degrees=radiansToDegrees;function degreesToRadians(val){return val*degToRads;}var degrees_to_radians=radiansToDegrees;var helperLengthArray=[0,0,0,0,0,0];function length(arr1,arr2){if(typeof arr1==='number'||arr1 instanceof Number){arr2=arr2||0;return Math.abs(arr1-arr2);}if(!arr2){arr2=helperLengthArray;}var i;var len=Math.min(arr1.length,arr2.length);var addedLength=0;for(i=0;i<len;i+=1){addedLength+=Math.pow(arr2[i]-arr1[i],2);}return Math.sqrt(addedLength);}function normalize(vec){return div(vec,length(vec));}function rgbToHsl(val){var r=val[0];var g=val[1];var b=val[2];var max=Math.max(r,g,b);var min=Math.min(r,g,b);var h;var s;var l=(max+min)/2;if(max===min){h=0;// achromatic
s=0;// achromatic
}else{var d=max-min;s=l>0.5?d/(2-max-min):d/(max+min);switch(max){case r:h=(g-b)/d+(g<b?6:0);break;case g:h=(b-r)/d+2;break;case b:h=(r-g)/d+4;break;default:break;}h/=6;}return[h,s,l,val[3]];}function hue2rgb(p,q,t){if(t<0)t+=1;if(t>1)t-=1;if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p;}function hslToRgb(val){var h=val[0];var s=val[1];var l=val[2];var r;var g;var b;if(s===0){r=l;// achromatic
b=l;// achromatic
g=l;// achromatic
}else{var q=l<0.5?l*(1+s):l+s-l*s;var p=2*l-q;r=hue2rgb(p,q,h+1/3);g=hue2rgb(p,q,h);b=hue2rgb(p,q,h-1/3);}return[r,g,b,val[3]];}function linear(t,tMin,tMax,value1,value2){if(value1===undefined||value2===undefined){value1=tMin;value2=tMax;tMin=0;tMax=1;}if(tMax<tMin){var _tMin=tMax;tMax=tMin;tMin=_tMin;}if(t<=tMin){return value1;}if(t>=tMax){return value2;}var perc=tMax===tMin?0:(t-tMin)/(tMax-tMin);if(!value1.length){return value1+(value2-value1)*perc;}var i;var len=value1.length;var arr=createTypedArray('float32',len);for(i=0;i<len;i+=1){arr[i]=value1[i]+(value2[i]-value1[i])*perc;}return arr;}function random(min,max){if(max===undefined){if(min===undefined){min=0;max=1;}else{max=min;min=undefined;}}if(max.length){var i;var len=max.length;if(!min){min=createTypedArray('float32',len);}var arr=createTypedArray('float32',len);var rnd=BMMath.random();for(i=0;i<len;i+=1){arr[i]=min[i]+rnd*(max[i]-min[i]);}return arr;}if(min===undefined){min=0;}var rndm=BMMath.random();return min+rndm*(max-min);}function createPath(points,inTangents,outTangents,closed){var i;var len=points.length;var path=shapePool.newElement();path.setPathData(!!closed,len);var arrPlaceholder=[0,0];var inVertexPoint;var outVertexPoint;for(i=0;i<len;i+=1){inVertexPoint=inTangents&&inTangents[i]?inTangents[i]:arrPlaceholder;outVertexPoint=outTangents&&outTangents[i]?outTangents[i]:arrPlaceholder;path.setTripleAt(points[i][0],points[i][1],outVertexPoint[0]+points[i][0],outVertexPoint[1]+points[i][1],inVertexPoint[0]+points[i][0],inVertexPoint[1]+points[i][1],i,true);}return path;}function initiateExpression(elem,data,property){// Bail out if we don't want expressions
function noOp(_value){return _value;}if(!elem.globalData.renderConfig.runExpressions){return noOp;}var val=data.x;var needsVelocity=/velocity(?![\w\d])/.test(val);var _needsRandom=val.indexOf('random')!==-1;var elemType=elem.data.ty;var transform;var $bm_transform;var content;var effect;var thisProperty=property;thisProperty.valueAtTime=thisProperty.getValueAtTime;Object.defineProperty(thisProperty,'value',{get:function get(){return thisProperty.v;}});elem.comp.frameDuration=1/elem.comp.globalData.frameRate;elem.comp.displayStartTime=0;var inPoint=elem.data.ip/elem.comp.globalData.frameRate;var outPoint=elem.data.op/elem.comp.globalData.frameRate;var width=elem.data.sw?elem.data.sw:0;var height=elem.data.sh?elem.data.sh:0;var name=elem.data.nm;var loopIn;var loop_in;var loopOut;var loop_out;var smooth;var toWorld;var fromWorld;var fromComp;var toComp;var fromCompToSurface;var position;var rotation;var anchorPoint;var scale;var thisLayer;var thisComp;var mask;var valueAtTime;var velocityAtTime;var scoped_bm_rt;// val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
var expression_function=eval('[function _expression_function(){'+val+';scoped_bm_rt=$bm_rt}]')[0];// eslint-disable-line no-eval
var numKeys=property.kf?data.k.length:0;var active=!this.data||this.data.hd!==true;var wiggle=function wiggle(freq,amp){var iWiggle;var j;var lenWiggle=this.pv.length?this.pv.length:1;var addedAmps=createTypedArray('float32',lenWiggle);freq=5;var iterations=Math.floor(time*freq);iWiggle=0;j=0;while(iWiggle<iterations){// var rnd = BMMath.random();
for(j=0;j<lenWiggle;j+=1){addedAmps[j]+=-amp+amp*2*BMMath.random();// addedAmps[j] += -amp + amp*2*rnd;
}iWiggle+=1;}// var rnd2 = BMMath.random();
var periods=time*freq;var perc=periods-Math.floor(periods);var arr=createTypedArray('float32',lenWiggle);if(lenWiggle>1){for(j=0;j<lenWiggle;j+=1){arr[j]=this.pv[j]+addedAmps[j]+(-amp+amp*2*BMMath.random())*perc;// arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
// arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
}return arr;}return this.pv+addedAmps[0]+(-amp+amp*2*BMMath.random())*perc;}.bind(this);if(thisProperty.loopIn){loopIn=thisProperty.loopIn.bind(thisProperty);loop_in=loopIn;}if(thisProperty.loopOut){loopOut=thisProperty.loopOut.bind(thisProperty);loop_out=loopOut;}if(thisProperty.smooth){smooth=thisProperty.smooth.bind(thisProperty);}function loopInDuration(type,duration){return loopIn(type,duration,true);}function loopOutDuration(type,duration){return loopOut(type,duration,true);}if(this.getValueAtTime){valueAtTime=this.getValueAtTime.bind(this);}if(this.getVelocityAtTime){velocityAtTime=this.getVelocityAtTime.bind(this);}var comp=elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);function lookAt(elem1,elem2){var fVec=[elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];var pitch=Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;var yaw=-Math.atan2(fVec[1],fVec[2])/degToRads;return[yaw,pitch,0];}function easeOut(t,tMin,tMax,val1,val2){return applyEase(easeOutBez,t,tMin,tMax,val1,val2);}function easeIn(t,tMin,tMax,val1,val2){return applyEase(easeInBez,t,tMin,tMax,val1,val2);}function ease(t,tMin,tMax,val1,val2){return applyEase(easeInOutBez,t,tMin,tMax,val1,val2);}function applyEase(fn,t,tMin,tMax,val1,val2){if(val1===undefined){val1=tMin;val2=tMax;}else{t=(t-tMin)/(tMax-tMin);}if(t>1){t=1;}else if(t<0){t=0;}var mult=fn(t);if($bm_isInstanceOfArray(val1)){var iKey;var lenKey=val1.length;var arr=createTypedArray('float32',lenKey);for(iKey=0;iKey<lenKey;iKey+=1){arr[iKey]=(val2[iKey]-val1[iKey])*mult+val1[iKey];}return arr;}return(val2-val1)*mult+val1;}function nearestKey(time){var iKey;var lenKey=data.k.length;var index;var keyTime;if(!data.k.length||typeof data.k[0]==='number'){index=0;keyTime=0;}else{index=-1;time*=elem.comp.globalData.frameRate;if(time<data.k[0].t){index=1;keyTime=data.k[0].t;}else{for(iKey=0;iKey<lenKey-1;iKey+=1){if(time===data.k[iKey].t){index=iKey+1;keyTime=data.k[iKey].t;break;}else if(time>data.k[iKey].t&&time<data.k[iKey+1].t){if(time-data.k[iKey].t>data.k[iKey+1].t-time){index=iKey+2;keyTime=data.k[iKey+1].t;}else{index=iKey+1;keyTime=data.k[iKey].t;}break;}}if(index===-1){index=iKey+1;keyTime=data.k[iKey].t;}}}var obKey={};obKey.index=index;obKey.time=keyTime/elem.comp.globalData.frameRate;return obKey;}function key(ind){var obKey;var iKey;var lenKey;if(!data.k.length||typeof data.k[0]==='number'){throw new Error('The property has no keyframe at index '+ind);}ind-=1;obKey={time:data.k[ind].t/elem.comp.globalData.frameRate,value:[]};var arr=Object.prototype.hasOwnProperty.call(data.k[ind],'s')?data.k[ind].s:data.k[ind-1].e;lenKey=arr.length;for(iKey=0;iKey<lenKey;iKey+=1){obKey[iKey]=arr[iKey];obKey.value[iKey]=arr[iKey];}return obKey;}function framesToTime(fr,fps){if(!fps){fps=elem.comp.globalData.frameRate;}return fr/fps;}function timeToFrames(t,fps){if(!t&&t!==0){t=time;}if(!fps){fps=elem.comp.globalData.frameRate;}return t*fps;}function seedRandom(seed){BMMath.seedrandom(randSeed+seed);}function sourceRectAtTime(){return elem.sourceRectAtTime();}function substring(init,end){if(typeof value==='string'){if(end===undefined){return value.substring(init);}return value.substring(init,end);}return'';}function substr(init,end){if(typeof value==='string'){if(end===undefined){return value.substr(init);}return value.substr(init,end);}return'';}function posterizeTime(framesPerSecond){time=framesPerSecond===0?0:Math.floor(time*framesPerSecond)/framesPerSecond;value=valueAtTime(time);}var time;var velocity;var value;var text;var textIndex;var textTotal;var selectorValue;var index=elem.data.ind;var hasParent=!!(elem.hierarchy&&elem.hierarchy.length);var parent;var randSeed=Math.floor(Math.random()*1000000);var globalData=elem.globalData;function executeExpression(_value){// globalData.pushExpression();
value=_value;if(this.frameExpressionId===elem.globalData.frameId&&this.propType!=='textSelector'){return value;}if(this.propType==='textSelector'){textIndex=this.textIndex;textTotal=this.textTotal;selectorValue=this.selectorValue;}if(!thisLayer){text=elem.layerInterface.text;thisLayer=elem.layerInterface;thisComp=elem.comp.compInterface;toWorld=thisLayer.toWorld.bind(thisLayer);fromWorld=thisLayer.fromWorld.bind(thisLayer);fromComp=thisLayer.fromComp.bind(thisLayer);toComp=thisLayer.toComp.bind(thisLayer);mask=thisLayer.mask?thisLayer.mask.bind(thisLayer):null;fromCompToSurface=fromComp;}if(!transform){transform=elem.layerInterface('ADBE Transform Group');$bm_transform=transform;if(transform){anchorPoint=transform.anchorPoint;/* position = transform.position;
                      rotation = transform.rotation;
                      scale = transform.scale; */}}if(elemType===4&&!content){content=thisLayer('ADBE Root Vectors Group');}if(!effect){effect=thisLayer(4);}hasParent=!!(elem.hierarchy&&elem.hierarchy.length);if(hasParent&&!parent){parent=elem.hierarchy[0].layerInterface;}time=this.comp.renderedFrame/this.comp.globalData.frameRate;if(_needsRandom){seedRandom(randSeed+time);}if(needsVelocity){velocity=velocityAtTime(time);}expression_function();this.frameExpressionId=elem.globalData.frameId;// TODO: Check if it's possible to return on ShapeInterface the .v value
// Changed this to a ternary operation because Rollup failed compiling it correctly
scoped_bm_rt=scoped_bm_rt.propType===propTypes.SHAPE?scoped_bm_rt.v:scoped_bm_rt;return scoped_bm_rt;}// Bundlers will see these as dead code and unless we reference them
executeExpression.__preventDeadCodeRemoval=[$bm_transform,anchorPoint,time,velocity,inPoint,outPoint,width,height,name,loop_in,loop_out,smooth,toComp,fromCompToSurface,toWorld,fromWorld,mask,position,rotation,scale,thisComp,numKeys,active,wiggle,loopInDuration,loopOutDuration,comp,lookAt,easeOut,easeIn,ease,nearestKey,key,text,textIndex,textTotal,selectorValue,framesToTime,timeToFrames,sourceRectAtTime,substring,substr,posterizeTime,index,globalData];return executeExpression;}ob.initiateExpression=initiateExpression;ob.__preventDeadCodeRemoval=[window,document,XMLHttpRequest,fetch,frames,$bm_neg,add,$bm_sum,$bm_sub,$bm_mul,$bm_div,$bm_mod,clamp,radians_to_degrees,degreesToRadians,degrees_to_radians,normalize,rgbToHsl,hslToRgb,linear,random,createPath,_lottieGlobal];ob.resetFrame=resetFrame;return ob;}();var Expressions=function(){var ob={};ob.initExpressions=initExpressions;ob.resetFrame=ExpressionManager.resetFrame;function initExpressions(animation){var stackCount=0;var registers=[];function pushExpression(){stackCount+=1;}function popExpression(){stackCount-=1;if(stackCount===0){releaseInstances();}}function registerExpressionProperty(expression){if(registers.indexOf(expression)===-1){registers.push(expression);}}function releaseInstances(){var i;var len=registers.length;for(i=0;i<len;i+=1){registers[i].release();}registers.length=0;}animation.renderer.compInterface=CompExpressionInterface(animation.renderer);animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);animation.renderer.globalData.pushExpression=pushExpression;animation.renderer.globalData.popExpression=popExpression;animation.renderer.globalData.registerExpressionProperty=registerExpressionProperty;}return ob;}();var MaskManagerInterface=function(){function MaskInterface(mask,data){this._mask=mask;this._data=data;}Object.defineProperty(MaskInterface.prototype,'maskPath',{get:function get(){if(this._mask.prop.k){this._mask.prop.getValue();}return this._mask.prop;}});Object.defineProperty(MaskInterface.prototype,'maskOpacity',{get:function get(){if(this._mask.op.k){this._mask.op.getValue();}return this._mask.op.v*100;}});var MaskManager=function MaskManager(maskManager){var _masksInterfaces=createSizedArray(maskManager.viewData.length);var i;var len=maskManager.viewData.length;for(i=0;i<len;i+=1){_masksInterfaces[i]=new MaskInterface(maskManager.viewData[i],maskManager.masksProperties[i]);}var maskFunction=function maskFunction(name){i=0;while(i<len){if(maskManager.masksProperties[i].nm===name){return _masksInterfaces[i];}i+=1;}return null;};return maskFunction;};return MaskManager;}();var ExpressionPropertyInterface=function(){var defaultUnidimensionalValue={pv:0,v:0,mult:1};var defaultMultidimensionalValue={pv:[0,0,0],v:[0,0,0],mult:1};function completeProperty(expressionValue,property,type){Object.defineProperty(expressionValue,'velocity',{get:function get(){return property.getVelocityAtTime(property.comp.currentFrame);}});expressionValue.numKeys=property.keyframes?property.keyframes.length:0;expressionValue.key=function(pos){if(!expressionValue.numKeys){return 0;}var value='';if('s'in property.keyframes[pos-1]){value=property.keyframes[pos-1].s;}else if('e'in property.keyframes[pos-2]){value=property.keyframes[pos-2].e;}else{value=property.keyframes[pos-2].s;}var valueProp=type==='unidimensional'?new Number(value):Object.assign({},value);// eslint-disable-line no-new-wrappers
valueProp.time=property.keyframes[pos-1].t/property.elem.comp.globalData.frameRate;valueProp.value=type==='unidimensional'?value[0]:value;return valueProp;};expressionValue.valueAtTime=property.getValueAtTime;expressionValue.speedAtTime=property.getSpeedAtTime;expressionValue.velocityAtTime=property.getVelocityAtTime;expressionValue.propertyGroup=property.propertyGroup;}function UnidimensionalPropertyInterface(property){if(!property||!('pv'in property)){property=defaultUnidimensionalValue;}var mult=1/property.mult;var val=property.pv*mult;var expressionValue=new Number(val);// eslint-disable-line no-new-wrappers
expressionValue.value=val;completeProperty(expressionValue,property,'unidimensional');return function(){if(property.k){property.getValue();}val=property.v*mult;if(expressionValue.value!==val){expressionValue=new Number(val);// eslint-disable-line no-new-wrappers
expressionValue.value=val;completeProperty(expressionValue,property,'unidimensional');}return expressionValue;};}function MultidimensionalPropertyInterface(property){if(!property||!('pv'in property)){property=defaultMultidimensionalValue;}var mult=1/property.mult;var len=property.data&&property.data.l||property.pv.length;var expressionValue=createTypedArray('float32',len);var arrValue=createTypedArray('float32',len);expressionValue.value=arrValue;completeProperty(expressionValue,property,'multidimensional');return function(){if(property.k){property.getValue();}for(var i=0;i<len;i+=1){arrValue[i]=property.v[i]*mult;expressionValue[i]=arrValue[i];}return expressionValue;};}// TODO: try to avoid using this getter
function defaultGetter(){return defaultUnidimensionalValue;}return function(property){if(!property){return defaultGetter;}if(property.propType==='unidimensional'){return UnidimensionalPropertyInterface(property);}return MultidimensionalPropertyInterface(property);};}();var TransformExpressionInterface=function(){return function(transform){function _thisFunction(name){switch(name){case'scale':case'Scale':case'ADBE Scale':case 6:return _thisFunction.scale;case'rotation':case'Rotation':case'ADBE Rotation':case'ADBE Rotate Z':case 10:return _thisFunction.rotation;case'ADBE Rotate X':return _thisFunction.xRotation;case'ADBE Rotate Y':return _thisFunction.yRotation;case'position':case'Position':case'ADBE Position':case 2:return _thisFunction.position;case'ADBE Position_0':return _thisFunction.xPosition;case'ADBE Position_1':return _thisFunction.yPosition;case'ADBE Position_2':return _thisFunction.zPosition;case'anchorPoint':case'AnchorPoint':case'Anchor Point':case'ADBE AnchorPoint':case 1:return _thisFunction.anchorPoint;case'opacity':case'Opacity':case 11:return _thisFunction.opacity;default:return null;}}Object.defineProperty(_thisFunction,'rotation',{get:ExpressionPropertyInterface(transform.r||transform.rz)});Object.defineProperty(_thisFunction,'zRotation',{get:ExpressionPropertyInterface(transform.rz||transform.r)});Object.defineProperty(_thisFunction,'xRotation',{get:ExpressionPropertyInterface(transform.rx)});Object.defineProperty(_thisFunction,'yRotation',{get:ExpressionPropertyInterface(transform.ry)});Object.defineProperty(_thisFunction,'scale',{get:ExpressionPropertyInterface(transform.s)});var _px;var _py;var _pz;var _transformFactory;if(transform.p){_transformFactory=ExpressionPropertyInterface(transform.p);}else{_px=ExpressionPropertyInterface(transform.px);_py=ExpressionPropertyInterface(transform.py);if(transform.pz){_pz=ExpressionPropertyInterface(transform.pz);}}Object.defineProperty(_thisFunction,'position',{get:function get(){if(transform.p){return _transformFactory();}return[_px(),_py(),_pz?_pz():0];}});Object.defineProperty(_thisFunction,'xPosition',{get:ExpressionPropertyInterface(transform.px)});Object.defineProperty(_thisFunction,'yPosition',{get:ExpressionPropertyInterface(transform.py)});Object.defineProperty(_thisFunction,'zPosition',{get:ExpressionPropertyInterface(transform.pz)});Object.defineProperty(_thisFunction,'anchorPoint',{get:ExpressionPropertyInterface(transform.a)});Object.defineProperty(_thisFunction,'opacity',{get:ExpressionPropertyInterface(transform.o)});Object.defineProperty(_thisFunction,'skew',{get:ExpressionPropertyInterface(transform.sk)});Object.defineProperty(_thisFunction,'skewAxis',{get:ExpressionPropertyInterface(transform.sa)});Object.defineProperty(_thisFunction,'orientation',{get:ExpressionPropertyInterface(transform.or)});return _thisFunction;};}();var LayerExpressionInterface=function(){function getMatrix(time){var toWorldMat=new Matrix();if(time!==undefined){var propMatrix=this._elem.finalTransform.mProp.getValueAtTime(time);propMatrix.clone(toWorldMat);}else{var transformMat=this._elem.finalTransform.mProp;transformMat.applyToMatrix(toWorldMat);}return toWorldMat;}function toWorldVec(arr,time){var toWorldMat=this.getMatrix(time);toWorldMat.props[12]=0;toWorldMat.props[13]=0;toWorldMat.props[14]=0;return this.applyPoint(toWorldMat,arr);}function toWorld(arr,time){var toWorldMat=this.getMatrix(time);return this.applyPoint(toWorldMat,arr);}function fromWorldVec(arr,time){var toWorldMat=this.getMatrix(time);toWorldMat.props[12]=0;toWorldMat.props[13]=0;toWorldMat.props[14]=0;return this.invertPoint(toWorldMat,arr);}function fromWorld(arr,time){var toWorldMat=this.getMatrix(time);return this.invertPoint(toWorldMat,arr);}function applyPoint(matrix,arr){if(this._elem.hierarchy&&this._elem.hierarchy.length){var i;var len=this._elem.hierarchy.length;for(i=0;i<len;i+=1){this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);}}return matrix.applyToPointArray(arr[0],arr[1],arr[2]||0);}function invertPoint(matrix,arr){if(this._elem.hierarchy&&this._elem.hierarchy.length){var i;var len=this._elem.hierarchy.length;for(i=0;i<len;i+=1){this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);}}return matrix.inversePoint(arr);}function fromComp(arr){var toWorldMat=new Matrix();toWorldMat.reset();this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);if(this._elem.hierarchy&&this._elem.hierarchy.length){var i;var len=this._elem.hierarchy.length;for(i=0;i<len;i+=1){this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);}return toWorldMat.inversePoint(arr);}return toWorldMat.inversePoint(arr);}function sampleImage(){return[1,1,1,1];}return function(elem){var transformInterface;function _registerMaskInterface(maskManager){_thisLayerFunction.mask=new MaskManagerInterface(maskManager,elem);}function _registerEffectsInterface(effects){_thisLayerFunction.effect=effects;}function _thisLayerFunction(name){switch(name){case'ADBE Root Vectors Group':case'Contents':case 2:return _thisLayerFunction.shapeInterface;case 1:case 6:case'Transform':case'transform':case'ADBE Transform Group':return transformInterface;case 4:case'ADBE Effect Parade':case'effects':case'Effects':return _thisLayerFunction.effect;case'ADBE Text Properties':return _thisLayerFunction.textInterface;default:return null;}}_thisLayerFunction.getMatrix=getMatrix;_thisLayerFunction.invertPoint=invertPoint;_thisLayerFunction.applyPoint=applyPoint;_thisLayerFunction.toWorld=toWorld;_thisLayerFunction.toWorldVec=toWorldVec;_thisLayerFunction.fromWorld=fromWorld;_thisLayerFunction.fromWorldVec=fromWorldVec;_thisLayerFunction.toComp=toWorld;_thisLayerFunction.fromComp=fromComp;_thisLayerFunction.sampleImage=sampleImage;_thisLayerFunction.sourceRectAtTime=elem.sourceRectAtTime.bind(elem);_thisLayerFunction._elem=elem;transformInterface=TransformExpressionInterface(elem.finalTransform.mProp);var anchorPointDescriptor=getDescriptor(transformInterface,'anchorPoint');Object.defineProperties(_thisLayerFunction,{hasParent:{get:function get(){return elem.hierarchy.length;}},parent:{get:function get(){return elem.hierarchy[0].layerInterface;}},rotation:getDescriptor(transformInterface,'rotation'),scale:getDescriptor(transformInterface,'scale'),position:getDescriptor(transformInterface,'position'),opacity:getDescriptor(transformInterface,'opacity'),anchorPoint:anchorPointDescriptor,anchor_point:anchorPointDescriptor,transform:{get:function get(){return transformInterface;}},active:{get:function get(){return elem.isInRange;}}});_thisLayerFunction.startTime=elem.data.st;_thisLayerFunction.index=elem.data.ind;_thisLayerFunction.source=elem.data.refId;_thisLayerFunction.height=elem.data.ty===0?elem.data.h:100;_thisLayerFunction.width=elem.data.ty===0?elem.data.w:100;_thisLayerFunction.inPoint=elem.data.ip/elem.comp.globalData.frameRate;_thisLayerFunction.outPoint=elem.data.op/elem.comp.globalData.frameRate;_thisLayerFunction._name=elem.data.nm;_thisLayerFunction.registerMaskInterface=_registerMaskInterface;_thisLayerFunction.registerEffectsInterface=_registerEffectsInterface;return _thisLayerFunction;};}();var propertyGroupFactory=function(){return function(interfaceFunction,parentPropertyGroup){return function(val){val=val===undefined?1:val;if(val<=0){return interfaceFunction;}return parentPropertyGroup(val-1);};};}();var PropertyInterface=function(){return function(propertyName,propertyGroup){var interfaceFunction={_name:propertyName};function _propertyGroup(val){val=val===undefined?1:val;if(val<=0){return interfaceFunction;}return propertyGroup(val-1);}return _propertyGroup;};}();var EffectsExpressionInterface=function(){var ob={createEffectsInterface:createEffectsInterface};function createEffectsInterface(elem,propertyGroup){if(elem.effectsManager){var effectElements=[];var effectsData=elem.data.ef;var i;var len=elem.effectsManager.effectElements.length;for(i=0;i<len;i+=1){effectElements.push(createGroupInterface(effectsData[i],elem.effectsManager.effectElements[i],propertyGroup,elem));}var effects=elem.data.ef||[];var groupInterface=function groupInterface(name){i=0;len=effects.length;while(i<len){if(name===effects[i].nm||name===effects[i].mn||name===effects[i].ix){return effectElements[i];}i+=1;}return null;};Object.defineProperty(groupInterface,'numProperties',{get:function get(){return effects.length;}});return groupInterface;}return null;}function createGroupInterface(data,elements,propertyGroup,elem){function groupInterface(name){var effects=data.ef;var i=0;var len=effects.length;while(i<len){if(name===effects[i].nm||name===effects[i].mn||name===effects[i].ix){if(effects[i].ty===5){return effectElements[i];}return effectElements[i]();}i+=1;}throw new Error();}var _propertyGroup=propertyGroupFactory(groupInterface,propertyGroup);var effectElements=[];var i;var len=data.ef.length;for(i=0;i<len;i+=1){if(data.ef[i].ty===5){effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],elements.effectElements[i].propertyGroup,elem));}else{effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty,elem,_propertyGroup));}}if(data.mn==='ADBE Color Control'){Object.defineProperty(groupInterface,'color',{get:function get(){return effectElements[0]();}});}Object.defineProperties(groupInterface,{numProperties:{get:function get(){return data.np;}},_name:{value:data.nm},propertyGroup:{value:_propertyGroup}});groupInterface.enabled=data.en!==0;groupInterface.active=groupInterface.enabled;return groupInterface;}function createValueInterface(element,type,elem,propertyGroup){var expressionProperty=ExpressionPropertyInterface(element.p);function interfaceFunction(){if(type===10){return elem.comp.compInterface(element.p.v);}return expressionProperty();}if(element.p.setGroupProperty){element.p.setGroupProperty(PropertyInterface('',propertyGroup));}return interfaceFunction;}return ob;}();var ShapePathInterface=function(){return function pathInterfaceFactory(shape,view,propertyGroup){var prop=view.sh;function interfaceFunction(val){if(val==='Shape'||val==='shape'||val==='Path'||val==='path'||val==='ADBE Vector Shape'||val===2){return interfaceFunction.path;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);prop.setGroupProperty(PropertyInterface('Path',_propertyGroup));Object.defineProperties(interfaceFunction,{path:{get:function get(){if(prop.k){prop.getValue();}return prop;}},shape:{get:function get(){if(prop.k){prop.getValue();}return prop;}},_name:{value:shape.nm},ix:{value:shape.ix},propertyIndex:{value:shape.ix},mn:{value:shape.mn},propertyGroup:{value:propertyGroup}});return interfaceFunction;};}();var ShapeExpressionInterface=function(){function iterateElements(shapes,view,propertyGroup){var arr=[];var i;var len=shapes?shapes.length:0;for(i=0;i<len;i+=1){if(shapes[i].ty==='gr'){arr.push(groupInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='fl'){arr.push(fillInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='st'){arr.push(strokeInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='tm'){arr.push(trimInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='tr'){// arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
}else if(shapes[i].ty==='el'){arr.push(ellipseInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='sr'){arr.push(starInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='sh'){arr.push(ShapePathInterface(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='rc'){arr.push(rectInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='rd'){arr.push(roundedInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='rp'){arr.push(repeaterInterfaceFactory(shapes[i],view[i],propertyGroup));}else if(shapes[i].ty==='gf'){arr.push(gradientFillInterfaceFactory(shapes[i],view[i],propertyGroup));}else{arr.push(defaultInterfaceFactory(shapes[i],view[i],propertyGroup));}}return arr;}function contentsInterfaceFactory(shape,view,propertyGroup){var interfaces;var interfaceFunction=function _interfaceFunction(value){var i=0;var len=interfaces.length;while(i<len){if(interfaces[i]._name===value||interfaces[i].mn===value||interfaces[i].propertyIndex===value||interfaces[i].ix===value||interfaces[i].ind===value){return interfaces[i];}i+=1;}if(typeof value==='number'){return interfaces[value-1];}return null;};interfaceFunction.propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);interfaces=iterateElements(shape.it,view.it,interfaceFunction.propertyGroup);interfaceFunction.numProperties=interfaces.length;var transformInterface=transformInterfaceFactory(shape.it[shape.it.length-1],view.it[view.it.length-1],interfaceFunction.propertyGroup);interfaceFunction.transform=transformInterface;interfaceFunction.propertyIndex=shape.cix;interfaceFunction._name=shape.nm;return interfaceFunction;}function groupInterfaceFactory(shape,view,propertyGroup){var interfaceFunction=function _interfaceFunction(value){switch(value){case'ADBE Vectors Group':case'Contents':case 2:return interfaceFunction.content;// Not necessary for now. Keeping them here in case a new case appears
// case 'ADBE Vector Transform Group':
// case 3:
default:return interfaceFunction.transform;}};interfaceFunction.propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var content=contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);var transformInterface=transformInterfaceFactory(shape.it[shape.it.length-1],view.it[view.it.length-1],interfaceFunction.propertyGroup);interfaceFunction.content=content;interfaceFunction.transform=transformInterface;Object.defineProperty(interfaceFunction,'_name',{get:function get(){return shape.nm;}});// interfaceFunction.content = interfaceFunction;
interfaceFunction.numProperties=shape.np;interfaceFunction.propertyIndex=shape.ix;interfaceFunction.nm=shape.nm;interfaceFunction.mn=shape.mn;return interfaceFunction;}function fillInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(val){if(val==='Color'||val==='color'){return interfaceFunction.color;}if(val==='Opacity'||val==='opacity'){return interfaceFunction.opacity;}return null;}Object.defineProperties(interfaceFunction,{color:{get:ExpressionPropertyInterface(view.c)},opacity:{get:ExpressionPropertyInterface(view.o)},_name:{value:shape.nm},mn:{value:shape.mn}});view.c.setGroupProperty(PropertyInterface('Color',propertyGroup));view.o.setGroupProperty(PropertyInterface('Opacity',propertyGroup));return interfaceFunction;}function gradientFillInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(val){if(val==='Start Point'||val==='start point'){return interfaceFunction.startPoint;}if(val==='End Point'||val==='end point'){return interfaceFunction.endPoint;}if(val==='Opacity'||val==='opacity'){return interfaceFunction.opacity;}return null;}Object.defineProperties(interfaceFunction,{startPoint:{get:ExpressionPropertyInterface(view.s)},endPoint:{get:ExpressionPropertyInterface(view.e)},opacity:{get:ExpressionPropertyInterface(view.o)},type:{get:function get(){return'a';}},_name:{value:shape.nm},mn:{value:shape.mn}});view.s.setGroupProperty(PropertyInterface('Start Point',propertyGroup));view.e.setGroupProperty(PropertyInterface('End Point',propertyGroup));view.o.setGroupProperty(PropertyInterface('Opacity',propertyGroup));return interfaceFunction;}function defaultInterfaceFactory(){function interfaceFunction(){return null;}return interfaceFunction;}function strokeInterfaceFactory(shape,view,propertyGroup){var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var _dashPropertyGroup=propertyGroupFactory(dashOb,_propertyGroup);function addPropertyToDashOb(i){Object.defineProperty(dashOb,shape.d[i].nm,{get:ExpressionPropertyInterface(view.d.dataProps[i].p)});}var i;var len=shape.d?shape.d.length:0;var dashOb={};for(i=0;i<len;i+=1){addPropertyToDashOb(i);view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);}function interfaceFunction(val){if(val==='Color'||val==='color'){return interfaceFunction.color;}if(val==='Opacity'||val==='opacity'){return interfaceFunction.opacity;}if(val==='Stroke Width'||val==='stroke width'){return interfaceFunction.strokeWidth;}return null;}Object.defineProperties(interfaceFunction,{color:{get:ExpressionPropertyInterface(view.c)},opacity:{get:ExpressionPropertyInterface(view.o)},strokeWidth:{get:ExpressionPropertyInterface(view.w)},dash:{get:function get(){return dashOb;}},_name:{value:shape.nm},mn:{value:shape.mn}});view.c.setGroupProperty(PropertyInterface('Color',_propertyGroup));view.o.setGroupProperty(PropertyInterface('Opacity',_propertyGroup));view.w.setGroupProperty(PropertyInterface('Stroke Width',_propertyGroup));return interfaceFunction;}function trimInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(val){if(val===shape.e.ix||val==='End'||val==='end'){return interfaceFunction.end;}if(val===shape.s.ix){return interfaceFunction.start;}if(val===shape.o.ix){return interfaceFunction.offset;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);interfaceFunction.propertyIndex=shape.ix;view.s.setGroupProperty(PropertyInterface('Start',_propertyGroup));view.e.setGroupProperty(PropertyInterface('End',_propertyGroup));view.o.setGroupProperty(PropertyInterface('Offset',_propertyGroup));interfaceFunction.propertyIndex=shape.ix;interfaceFunction.propertyGroup=propertyGroup;Object.defineProperties(interfaceFunction,{start:{get:ExpressionPropertyInterface(view.s)},end:{get:ExpressionPropertyInterface(view.e)},offset:{get:ExpressionPropertyInterface(view.o)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}function transformInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.a.ix===value||value==='Anchor Point'){return interfaceFunction.anchorPoint;}if(shape.o.ix===value||value==='Opacity'){return interfaceFunction.opacity;}if(shape.p.ix===value||value==='Position'){return interfaceFunction.position;}if(shape.r.ix===value||value==='Rotation'||value==='ADBE Vector Rotation'){return interfaceFunction.rotation;}if(shape.s.ix===value||value==='Scale'){return interfaceFunction.scale;}if(shape.sk&&shape.sk.ix===value||value==='Skew'){return interfaceFunction.skew;}if(shape.sa&&shape.sa.ix===value||value==='Skew Axis'){return interfaceFunction.skewAxis;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity',_propertyGroup));view.transform.mProps.p.setGroupProperty(PropertyInterface('Position',_propertyGroup));view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point',_propertyGroup));view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale',_propertyGroup));view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation',_propertyGroup));if(view.transform.mProps.sk){view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew',_propertyGroup));view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle',_propertyGroup));}view.transform.op.setGroupProperty(PropertyInterface('Opacity',_propertyGroup));Object.defineProperties(interfaceFunction,{opacity:{get:ExpressionPropertyInterface(view.transform.mProps.o)},position:{get:ExpressionPropertyInterface(view.transform.mProps.p)},anchorPoint:{get:ExpressionPropertyInterface(view.transform.mProps.a)},scale:{get:ExpressionPropertyInterface(view.transform.mProps.s)},rotation:{get:ExpressionPropertyInterface(view.transform.mProps.r)},skew:{get:ExpressionPropertyInterface(view.transform.mProps.sk)},skewAxis:{get:ExpressionPropertyInterface(view.transform.mProps.sa)},_name:{value:shape.nm}});interfaceFunction.ty='tr';interfaceFunction.mn=shape.mn;interfaceFunction.propertyGroup=propertyGroup;return interfaceFunction;}function ellipseInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.p.ix===value){return interfaceFunction.position;}if(shape.s.ix===value){return interfaceFunction.size;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);interfaceFunction.propertyIndex=shape.ix;var prop=view.sh.ty==='tm'?view.sh.prop:view.sh;prop.s.setGroupProperty(PropertyInterface('Size',_propertyGroup));prop.p.setGroupProperty(PropertyInterface('Position',_propertyGroup));Object.defineProperties(interfaceFunction,{size:{get:ExpressionPropertyInterface(prop.s)},position:{get:ExpressionPropertyInterface(prop.p)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}function starInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.p.ix===value){return interfaceFunction.position;}if(shape.r.ix===value){return interfaceFunction.rotation;}if(shape.pt.ix===value){return interfaceFunction.points;}if(shape.or.ix===value||value==='ADBE Vector Star Outer Radius'){return interfaceFunction.outerRadius;}if(shape.os.ix===value){return interfaceFunction.outerRoundness;}if(shape.ir&&(shape.ir.ix===value||value==='ADBE Vector Star Inner Radius')){return interfaceFunction.innerRadius;}if(shape.is&&shape.is.ix===value){return interfaceFunction.innerRoundness;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var prop=view.sh.ty==='tm'?view.sh.prop:view.sh;interfaceFunction.propertyIndex=shape.ix;prop.or.setGroupProperty(PropertyInterface('Outer Radius',_propertyGroup));prop.os.setGroupProperty(PropertyInterface('Outer Roundness',_propertyGroup));prop.pt.setGroupProperty(PropertyInterface('Points',_propertyGroup));prop.p.setGroupProperty(PropertyInterface('Position',_propertyGroup));prop.r.setGroupProperty(PropertyInterface('Rotation',_propertyGroup));if(shape.ir){prop.ir.setGroupProperty(PropertyInterface('Inner Radius',_propertyGroup));prop.is.setGroupProperty(PropertyInterface('Inner Roundness',_propertyGroup));}Object.defineProperties(interfaceFunction,{position:{get:ExpressionPropertyInterface(prop.p)},rotation:{get:ExpressionPropertyInterface(prop.r)},points:{get:ExpressionPropertyInterface(prop.pt)},outerRadius:{get:ExpressionPropertyInterface(prop.or)},outerRoundness:{get:ExpressionPropertyInterface(prop.os)},innerRadius:{get:ExpressionPropertyInterface(prop.ir)},innerRoundness:{get:ExpressionPropertyInterface(prop.is)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}function rectInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.p.ix===value){return interfaceFunction.position;}if(shape.r.ix===value){return interfaceFunction.roundness;}if(shape.s.ix===value||value==='Size'||value==='ADBE Vector Rect Size'){return interfaceFunction.size;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var prop=view.sh.ty==='tm'?view.sh.prop:view.sh;interfaceFunction.propertyIndex=shape.ix;prop.p.setGroupProperty(PropertyInterface('Position',_propertyGroup));prop.s.setGroupProperty(PropertyInterface('Size',_propertyGroup));prop.r.setGroupProperty(PropertyInterface('Rotation',_propertyGroup));Object.defineProperties(interfaceFunction,{position:{get:ExpressionPropertyInterface(prop.p)},roundness:{get:ExpressionPropertyInterface(prop.r)},size:{get:ExpressionPropertyInterface(prop.s)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}function roundedInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.r.ix===value||value==='Round Corners 1'){return interfaceFunction.radius;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var prop=view;interfaceFunction.propertyIndex=shape.ix;prop.rd.setGroupProperty(PropertyInterface('Radius',_propertyGroup));Object.defineProperties(interfaceFunction,{radius:{get:ExpressionPropertyInterface(prop.rd)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}function repeaterInterfaceFactory(shape,view,propertyGroup){function interfaceFunction(value){if(shape.c.ix===value||value==='Copies'){return interfaceFunction.copies;}if(shape.o.ix===value||value==='Offset'){return interfaceFunction.offset;}return null;}var _propertyGroup=propertyGroupFactory(interfaceFunction,propertyGroup);var prop=view;interfaceFunction.propertyIndex=shape.ix;prop.c.setGroupProperty(PropertyInterface('Copies',_propertyGroup));prop.o.setGroupProperty(PropertyInterface('Offset',_propertyGroup));Object.defineProperties(interfaceFunction,{copies:{get:ExpressionPropertyInterface(prop.c)},offset:{get:ExpressionPropertyInterface(prop.o)},_name:{value:shape.nm}});interfaceFunction.mn=shape.mn;return interfaceFunction;}return function(shapes,view,propertyGroup){var interfaces;function _interfaceFunction(value){if(typeof value==='number'){value=value===undefined?1:value;if(value===0){return propertyGroup;}return interfaces[value-1];}var i=0;var len=interfaces.length;while(i<len){if(interfaces[i]._name===value){return interfaces[i];}i+=1;}return null;}function parentGroupWrapper(){return propertyGroup;}_interfaceFunction.propertyGroup=propertyGroupFactory(_interfaceFunction,parentGroupWrapper);interfaces=iterateElements(shapes,view,_interfaceFunction.propertyGroup);_interfaceFunction.numProperties=interfaces.length;_interfaceFunction._name='Contents';return _interfaceFunction;};}();var TextExpressionInterface=function(){return function(elem){var _sourceText;function _thisLayerFunction(name){switch(name){case'ADBE Text Document':return _thisLayerFunction.sourceText;default:return null;}}Object.defineProperty(_thisLayerFunction,'sourceText',{get:function get(){elem.textProperty.getValue();var stringValue=elem.textProperty.currentData.t;if(!_sourceText||stringValue!==_sourceText.value){_sourceText=new String(stringValue);// eslint-disable-line no-new-wrappers
// If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
_sourceText.value=stringValue||new String(stringValue);// eslint-disable-line no-new-wrappers
Object.defineProperty(_sourceText,'style',{get:function get(){return{fillColor:elem.textProperty.currentData.fc};}});}return _sourceText;}});return _thisLayerFunction;};}();function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}var FootageInterface=function(){var outlineInterfaceFactory=function outlineInterfaceFactory(elem){var currentPropertyName='';var currentProperty=elem.getFootageData();function init(){currentPropertyName='';currentProperty=elem.getFootageData();return searchProperty;}function searchProperty(value){if(currentProperty[value]){currentPropertyName=value;currentProperty=currentProperty[value];if(_typeof(currentProperty)==='object'){return searchProperty;}return currentProperty;}var propertyNameIndex=value.indexOf(currentPropertyName);if(propertyNameIndex!==-1){var index=parseInt(value.substr(propertyNameIndex+currentPropertyName.length),10);currentProperty=currentProperty[index];if(_typeof(currentProperty)==='object'){return searchProperty;}return currentProperty;}return'';}return init;};var dataInterfaceFactory=function dataInterfaceFactory(elem){function interfaceFunction(value){if(value==='Outline'){return interfaceFunction.outlineInterface();}return null;}interfaceFunction._name='Outline';interfaceFunction.outlineInterface=outlineInterfaceFactory(elem);return interfaceFunction;};return function(elem){function _interfaceFunction(value){if(value==='Data'){return _interfaceFunction.dataInterface;}return null;}_interfaceFunction._name='Data';_interfaceFunction.dataInterface=dataInterfaceFactory(elem);return _interfaceFunction;};}();var interfaces={layer:LayerExpressionInterface,effects:EffectsExpressionInterface,comp:CompExpressionInterface,shape:ShapeExpressionInterface,text:TextExpressionInterface,footage:FootageInterface};function getInterface(type){return interfaces[type]||null;}var expressionHelpers=function(){function searchExpressions(elem,data,prop){if(data.x){prop.k=true;prop.x=true;prop.initiateExpression=ExpressionManager.initiateExpression;prop.effectsSequence.push(prop.initiateExpression(elem,data,prop).bind(prop));}}function getValueAtTime(frameNum){frameNum*=this.elem.globalData.frameRate;frameNum-=this.offsetTime;if(frameNum!==this._cachingAtTime.lastFrame){this._cachingAtTime.lastIndex=this._cachingAtTime.lastFrame<frameNum?this._cachingAtTime.lastIndex:0;this._cachingAtTime.value=this.interpolateValue(frameNum,this._cachingAtTime);this._cachingAtTime.lastFrame=frameNum;}return this._cachingAtTime.value;}function getSpeedAtTime(frameNum){var delta=-0.01;var v1=this.getValueAtTime(frameNum);var v2=this.getValueAtTime(frameNum+delta);var speed=0;if(v1.length){var i;for(i=0;i<v1.length;i+=1){speed+=Math.pow(v2[i]-v1[i],2);}speed=Math.sqrt(speed)*100;}else{speed=0;}return speed;}function getVelocityAtTime(frameNum){if(this.vel!==undefined){return this.vel;}var delta=-0.001;// frameNum += this.elem.data.st;
var v1=this.getValueAtTime(frameNum);var v2=this.getValueAtTime(frameNum+delta);var velocity;if(v1.length){velocity=createTypedArray('float32',v1.length);var i;for(i=0;i<v1.length;i+=1){// removing frameRate
// if needed, don't add it here
// velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
velocity[i]=(v2[i]-v1[i])/delta;}}else{velocity=(v2-v1)/delta;}return velocity;}function getStaticValueAtTime(){return this.pv;}function setGroupProperty(propertyGroup){this.propertyGroup=propertyGroup;}return{searchExpressions:searchExpressions,getSpeedAtTime:getSpeedAtTime,getVelocityAtTime:getVelocityAtTime,getValueAtTime:getValueAtTime,getStaticValueAtTime:getStaticValueAtTime,setGroupProperty:setGroupProperty};}();function addPropertyDecorator(){function loopOut(type,duration,durationFlag){if(!this.k||!this.keyframes){return this.pv;}type=type?type.toLowerCase():'';var currentFrame=this.comp.renderedFrame;var keyframes=this.keyframes;var lastKeyFrame=keyframes[keyframes.length-1].t;if(currentFrame<=lastKeyFrame){return this.pv;}var cycleDuration;var firstKeyFrame;if(!durationFlag){if(!duration||duration>keyframes.length-1){duration=keyframes.length-1;}firstKeyFrame=keyframes[keyframes.length-1-duration].t;cycleDuration=lastKeyFrame-firstKeyFrame;}else{if(!duration){cycleDuration=Math.max(0,lastKeyFrame-this.elem.data.ip);}else{cycleDuration=Math.abs(lastKeyFrame-this.elem.comp.globalData.frameRate*duration);}firstKeyFrame=lastKeyFrame-cycleDuration;}var i;var len;var ret;if(type==='pingpong'){var iterations=Math.floor((currentFrame-firstKeyFrame)/cycleDuration);if(iterations%2!==0){return this.getValueAtTime((cycleDuration-(currentFrame-firstKeyFrame)%cycleDuration+firstKeyFrame)/this.comp.globalData.frameRate,0);// eslint-disable-line
}}else if(type==='offset'){var initV=this.getValueAtTime(firstKeyFrame/this.comp.globalData.frameRate,0);var endV=this.getValueAtTime(lastKeyFrame/this.comp.globalData.frameRate,0);var current=this.getValueAtTime(((currentFrame-firstKeyFrame)%cycleDuration+firstKeyFrame)/this.comp.globalData.frameRate,0);// eslint-disable-line
var repeats=Math.floor((currentFrame-firstKeyFrame)/cycleDuration);if(this.pv.length){ret=new Array(initV.length);len=ret.length;for(i=0;i<len;i+=1){ret[i]=(endV[i]-initV[i])*repeats+current[i];}return ret;}return(endV-initV)*repeats+current;}else if(type==='continue'){var lastValue=this.getValueAtTime(lastKeyFrame/this.comp.globalData.frameRate,0);var nextLastValue=this.getValueAtTime((lastKeyFrame-0.001)/this.comp.globalData.frameRate,0);if(this.pv.length){ret=new Array(lastValue.length);len=ret.length;for(i=0;i<len;i+=1){ret[i]=lastValue[i]+(lastValue[i]-nextLastValue[i])*((currentFrame-lastKeyFrame)/this.comp.globalData.frameRate)/0.0005;// eslint-disable-line
}return ret;}return lastValue+(lastValue-nextLastValue)*((currentFrame-lastKeyFrame)/0.001);}return this.getValueAtTime(((currentFrame-firstKeyFrame)%cycleDuration+firstKeyFrame)/this.comp.globalData.frameRate,0);// eslint-disable-line
}function loopIn(type,duration,durationFlag){if(!this.k){return this.pv;}type=type?type.toLowerCase():'';var currentFrame=this.comp.renderedFrame;var keyframes=this.keyframes;var firstKeyFrame=keyframes[0].t;if(currentFrame>=firstKeyFrame){return this.pv;}var cycleDuration;var lastKeyFrame;if(!durationFlag){if(!duration||duration>keyframes.length-1){duration=keyframes.length-1;}lastKeyFrame=keyframes[duration].t;cycleDuration=lastKeyFrame-firstKeyFrame;}else{if(!duration){cycleDuration=Math.max(0,this.elem.data.op-firstKeyFrame);}else{cycleDuration=Math.abs(this.elem.comp.globalData.frameRate*duration);}lastKeyFrame=firstKeyFrame+cycleDuration;}var i;var len;var ret;if(type==='pingpong'){var iterations=Math.floor((firstKeyFrame-currentFrame)/cycleDuration);if(iterations%2===0){return this.getValueAtTime(((firstKeyFrame-currentFrame)%cycleDuration+firstKeyFrame)/this.comp.globalData.frameRate,0);// eslint-disable-line
}}else if(type==='offset'){var initV=this.getValueAtTime(firstKeyFrame/this.comp.globalData.frameRate,0);var endV=this.getValueAtTime(lastKeyFrame/this.comp.globalData.frameRate,0);var current=this.getValueAtTime((cycleDuration-(firstKeyFrame-currentFrame)%cycleDuration+firstKeyFrame)/this.comp.globalData.frameRate,0);var repeats=Math.floor((firstKeyFrame-currentFrame)/cycleDuration)+1;if(this.pv.length){ret=new Array(initV.length);len=ret.length;for(i=0;i<len;i+=1){ret[i]=current[i]-(endV[i]-initV[i])*repeats;}return ret;}return current-(endV-initV)*repeats;}else if(type==='continue'){var firstValue=this.getValueAtTime(firstKeyFrame/this.comp.globalData.frameRate,0);var nextFirstValue=this.getValueAtTime((firstKeyFrame+0.001)/this.comp.globalData.frameRate,0);if(this.pv.length){ret=new Array(firstValue.length);len=ret.length;for(i=0;i<len;i+=1){ret[i]=firstValue[i]+(firstValue[i]-nextFirstValue[i])*(firstKeyFrame-currentFrame)/0.001;}return ret;}return firstValue+(firstValue-nextFirstValue)*(firstKeyFrame-currentFrame)/0.001;}return this.getValueAtTime((cycleDuration-((firstKeyFrame-currentFrame)%cycleDuration+firstKeyFrame))/this.comp.globalData.frameRate,0);// eslint-disable-line
}function smooth(width,samples){if(!this.k){return this.pv;}width=(width||0.4)*0.5;samples=Math.floor(samples||5);if(samples<=1){return this.pv;}var currentTime=this.comp.renderedFrame/this.comp.globalData.frameRate;var initFrame=currentTime-width;var endFrame=currentTime+width;var sampleFrequency=samples>1?(endFrame-initFrame)/(samples-1):1;var i=0;var j=0;var value;if(this.pv.length){value=createTypedArray('float32',this.pv.length);}else{value=0;}var sampleValue;while(i<samples){sampleValue=this.getValueAtTime(initFrame+i*sampleFrequency);if(this.pv.length){for(j=0;j<this.pv.length;j+=1){value[j]+=sampleValue[j];}}else{value+=sampleValue;}i+=1;}if(this.pv.length){for(j=0;j<this.pv.length;j+=1){value[j]/=samples;}}else{value/=samples;}return value;}function getTransformValueAtTime(time){if(!this._transformCachingAtTime){this._transformCachingAtTime={v:new Matrix()};}/// /
var matrix=this._transformCachingAtTime.v;matrix.cloneFromProps(this.pre.props);if(this.appliedTransformations<1){var anchor=this.a.getValueAtTime(time);matrix.translate(-anchor[0]*this.a.mult,-anchor[1]*this.a.mult,anchor[2]*this.a.mult);}if(this.appliedTransformations<2){var scale=this.s.getValueAtTime(time);matrix.scale(scale[0]*this.s.mult,scale[1]*this.s.mult,scale[2]*this.s.mult);}if(this.sk&&this.appliedTransformations<3){var skew=this.sk.getValueAtTime(time);var skewAxis=this.sa.getValueAtTime(time);matrix.skewFromAxis(-skew*this.sk.mult,skewAxis*this.sa.mult);}if(this.r&&this.appliedTransformations<4){var rotation=this.r.getValueAtTime(time);matrix.rotate(-rotation*this.r.mult);}else if(!this.r&&this.appliedTransformations<4){var rotationZ=this.rz.getValueAtTime(time);var rotationY=this.ry.getValueAtTime(time);var rotationX=this.rx.getValueAtTime(time);var orientation=this.or.getValueAtTime(time);matrix.rotateZ(-rotationZ*this.rz.mult).rotateY(rotationY*this.ry.mult).rotateX(rotationX*this.rx.mult).rotateZ(-orientation[2]*this.or.mult).rotateY(orientation[1]*this.or.mult).rotateX(orientation[0]*this.or.mult);}if(this.data.p&&this.data.p.s){var positionX=this.px.getValueAtTime(time);var positionY=this.py.getValueAtTime(time);if(this.data.p.z){var positionZ=this.pz.getValueAtTime(time);matrix.translate(positionX*this.px.mult,positionY*this.py.mult,-positionZ*this.pz.mult);}else{matrix.translate(positionX*this.px.mult,positionY*this.py.mult,0);}}else{var position=this.p.getValueAtTime(time);matrix.translate(position[0]*this.p.mult,position[1]*this.p.mult,-position[2]*this.p.mult);}return matrix;/// /
}function getTransformStaticValueAtTime(){return this.v.clone(new Matrix());}var getTransformProperty=TransformPropertyFactory.getTransformProperty;TransformPropertyFactory.getTransformProperty=function(elem,data,container){var prop=getTransformProperty(elem,data,container);if(prop.dynamicProperties.length){prop.getValueAtTime=getTransformValueAtTime.bind(prop);}else{prop.getValueAtTime=getTransformStaticValueAtTime.bind(prop);}prop.setGroupProperty=expressionHelpers.setGroupProperty;return prop;};var propertyGetProp=PropertyFactory.getProp;PropertyFactory.getProp=function(elem,data,type,mult,container){var prop=propertyGetProp(elem,data,type,mult,container);// prop.getVelocityAtTime = getVelocityAtTime;
// prop.loopOut = loopOut;
// prop.loopIn = loopIn;
if(prop.kf){prop.getValueAtTime=expressionHelpers.getValueAtTime.bind(prop);}else{prop.getValueAtTime=expressionHelpers.getStaticValueAtTime.bind(prop);}prop.setGroupProperty=expressionHelpers.setGroupProperty;prop.loopOut=loopOut;prop.loopIn=loopIn;prop.smooth=smooth;prop.getVelocityAtTime=expressionHelpers.getVelocityAtTime.bind(prop);prop.getSpeedAtTime=expressionHelpers.getSpeedAtTime.bind(prop);prop.numKeys=data.a===1?data.k.length:0;prop.propertyIndex=data.ix;var value=0;if(type!==0){value=createTypedArray('float32',data.a===1?data.k[0].s.length:data.k.length);}prop._cachingAtTime={lastFrame:initialDefaultFrame,lastIndex:0,value:value};expressionHelpers.searchExpressions(elem,data,prop);if(prop.k){container.addDynamicProperty(prop);}return prop;};function getShapeValueAtTime(frameNum){// For now this caching object is created only when needed instead of creating it when the shape is initialized.
if(!this._cachingAtTime){this._cachingAtTime={shapeValue:shapePool.clone(this.pv),lastIndex:0,lastTime:initialDefaultFrame};}frameNum*=this.elem.globalData.frameRate;frameNum-=this.offsetTime;if(frameNum!==this._cachingAtTime.lastTime){this._cachingAtTime.lastIndex=this._cachingAtTime.lastTime<frameNum?this._caching.lastIndex:0;this._cachingAtTime.lastTime=frameNum;this.interpolateShape(frameNum,this._cachingAtTime.shapeValue,this._cachingAtTime);}return this._cachingAtTime.shapeValue;}var ShapePropertyConstructorFunction=ShapePropertyFactory.getConstructorFunction();var KeyframedShapePropertyConstructorFunction=ShapePropertyFactory.getKeyframedConstructorFunction();function ShapeExpressions(){}ShapeExpressions.prototype={vertices:function vertices(prop,time){if(this.k){this.getValue();}var shapePath=this.v;if(time!==undefined){shapePath=this.getValueAtTime(time,0);}var i;var len=shapePath._length;var vertices=shapePath[prop];var points=shapePath.v;var arr=createSizedArray(len);for(i=0;i<len;i+=1){if(prop==='i'||prop==='o'){arr[i]=[vertices[i][0]-points[i][0],vertices[i][1]-points[i][1]];}else{arr[i]=[vertices[i][0],vertices[i][1]];}}return arr;},points:function points(time){return this.vertices('v',time);},inTangents:function inTangents(time){return this.vertices('i',time);},outTangents:function outTangents(time){return this.vertices('o',time);},isClosed:function isClosed(){return this.v.c;},pointOnPath:function pointOnPath(perc,time){var shapePath=this.v;if(time!==undefined){shapePath=this.getValueAtTime(time,0);}if(!this._segmentsLength){this._segmentsLength=bez.getSegmentsLength(shapePath);}var segmentsLength=this._segmentsLength;var lengths=segmentsLength.lengths;var lengthPos=segmentsLength.totalLength*perc;var i=0;var len=lengths.length;var accumulatedLength=0;var pt;while(i<len){if(accumulatedLength+lengths[i].addedLength>lengthPos){var initIndex=i;var endIndex=shapePath.c&&i===len-1?0:i+1;var segmentPerc=(lengthPos-accumulatedLength)/lengths[i].addedLength;pt=bez.getPointInSegment(shapePath.v[initIndex],shapePath.v[endIndex],shapePath.o[initIndex],shapePath.i[endIndex],segmentPerc,lengths[i]);break;}else{accumulatedLength+=lengths[i].addedLength;}i+=1;}if(!pt){pt=shapePath.c?[shapePath.v[0][0],shapePath.v[0][1]]:[shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1]];}return pt;},vectorOnPath:function vectorOnPath(perc,time,vectorType){// perc doesn't use triple equality because it can be a Number object as well as a primitive.
if(perc==1){// eslint-disable-line eqeqeq
perc=this.v.c;}else if(perc==0){// eslint-disable-line eqeqeq
perc=0.999;}var pt1=this.pointOnPath(perc,time);var pt2=this.pointOnPath(perc+0.001,time);var xLength=pt2[0]-pt1[0];var yLength=pt2[1]-pt1[1];var magnitude=Math.sqrt(Math.pow(xLength,2)+Math.pow(yLength,2));if(magnitude===0){return[0,0];}var unitVector=vectorType==='tangent'?[xLength/magnitude,yLength/magnitude]:[-yLength/magnitude,xLength/magnitude];return unitVector;},tangentOnPath:function tangentOnPath(perc,time){return this.vectorOnPath(perc,time,'tangent');},normalOnPath:function normalOnPath(perc,time){return this.vectorOnPath(perc,time,'normal');},setGroupProperty:expressionHelpers.setGroupProperty,getValueAtTime:expressionHelpers.getStaticValueAtTime};extendPrototype([ShapeExpressions],ShapePropertyConstructorFunction);extendPrototype([ShapeExpressions],KeyframedShapePropertyConstructorFunction);KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime=getShapeValueAtTime;KeyframedShapePropertyConstructorFunction.prototype.initiateExpression=ExpressionManager.initiateExpression;var propertyGetShapeProp=ShapePropertyFactory.getShapeProp;ShapePropertyFactory.getShapeProp=function(elem,data,type,arr,trims){var prop=propertyGetShapeProp(elem,data,type,arr,trims);prop.propertyIndex=data.ix;prop.lock=false;if(type===3){expressionHelpers.searchExpressions(elem,data.pt,prop);}else if(type===4){expressionHelpers.searchExpressions(elem,data.ks,prop);}if(prop.k){elem.addDynamicProperty(prop);}return prop;};}function initialize$1(){addPropertyDecorator();}function addDecorator(){function searchExpressions(){if(this.data.d.x){this.calculateExpression=ExpressionManager.initiateExpression.bind(this)(this.elem,this.data.d,this);this.addEffect(this.getExpressionValue.bind(this));return true;}return null;}TextProperty.prototype.getExpressionValue=function(currentValue,text){var newValue=this.calculateExpression(text);if(currentValue.t!==newValue){var newData={};this.copyData(newData,currentValue);newData.t=newValue.toString();newData.__complete=false;return newData;}return currentValue;};TextProperty.prototype.searchProperty=function(){var isKeyframed=this.searchKeyframes();var hasExpressions=this.searchExpressions();this.kf=isKeyframed||hasExpressions;return this.kf;};TextProperty.prototype.searchExpressions=searchExpressions;}function initialize(){addDecorator();}function SVGComposableEffect(){}SVGComposableEffect.prototype={createMergeNode:function createMergeNode(resultId,ins){var feMerge=createNS('feMerge');feMerge.setAttribute('result',resultId);var feMergeNode;var i;for(i=0;i<ins.length;i+=1){feMergeNode=createNS('feMergeNode');feMergeNode.setAttribute('in',ins[i]);feMerge.appendChild(feMergeNode);feMerge.appendChild(feMergeNode);}return feMerge;}};var linearFilterValue='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';function SVGTintFilter(filter,filterManager,elem,id,source){this.filterManager=filterManager;var feColorMatrix=createNS('feColorMatrix');feColorMatrix.setAttribute('type','matrix');feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');feColorMatrix.setAttribute('values',linearFilterValue+' 1 0');this.linearFilter=feColorMatrix;feColorMatrix.setAttribute('result',id+'_tint_1');filter.appendChild(feColorMatrix);feColorMatrix=createNS('feColorMatrix');feColorMatrix.setAttribute('type','matrix');feColorMatrix.setAttribute('color-interpolation-filters','sRGB');feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');feColorMatrix.setAttribute('result',id+'_tint_2');filter.appendChild(feColorMatrix);this.matrixFilter=feColorMatrix;var feMerge=this.createMergeNode(id,[source,id+'_tint_1',id+'_tint_2']);filter.appendChild(feMerge);}extendPrototype([SVGComposableEffect],SVGTintFilter);SVGTintFilter.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){var colorBlack=this.filterManager.effectElements[0].p.v;var colorWhite=this.filterManager.effectElements[1].p.v;var opacity=this.filterManager.effectElements[2].p.v/100;this.linearFilter.setAttribute('values',linearFilterValue+' '+opacity+' 0');this.matrixFilter.setAttribute('values',colorWhite[0]-colorBlack[0]+' 0 0 0 '+colorBlack[0]+' '+(colorWhite[1]-colorBlack[1])+' 0 0 0 '+colorBlack[1]+' '+(colorWhite[2]-colorBlack[2])+' 0 0 0 '+colorBlack[2]+' 0 0 0 1 0');}};function SVGFillFilter(filter,filterManager,elem,id){this.filterManager=filterManager;var feColorMatrix=createNS('feColorMatrix');feColorMatrix.setAttribute('type','matrix');feColorMatrix.setAttribute('color-interpolation-filters','sRGB');feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');feColorMatrix.setAttribute('result',id);filter.appendChild(feColorMatrix);this.matrixFilter=feColorMatrix;}SVGFillFilter.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){var color=this.filterManager.effectElements[2].p.v;var opacity=this.filterManager.effectElements[6].p.v;this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');}};function SVGStrokeEffect(fil,filterManager,elem){this.initialized=false;this.filterManager=filterManager;this.elem=elem;this.paths=[];}SVGStrokeEffect.prototype.initialize=function(){var elemChildren=this.elem.layerElement.children||this.elem.layerElement.childNodes;var path;var groupPath;var i;var len;if(this.filterManager.effectElements[1].p.v===1){len=this.elem.maskManager.masksProperties.length;i=0;}else{i=this.filterManager.effectElements[0].p.v-1;len=i+1;}groupPath=createNS('g');groupPath.setAttribute('fill','none');groupPath.setAttribute('stroke-linecap','round');groupPath.setAttribute('stroke-dashoffset',1);for(i;i<len;i+=1){path=createNS('path');groupPath.appendChild(path);this.paths.push({p:path,m:i});}if(this.filterManager.effectElements[10].p.v===3){var mask=createNS('mask');var id=createElementID();mask.setAttribute('id',id);mask.setAttribute('mask-type','alpha');mask.appendChild(groupPath);this.elem.globalData.defs.appendChild(mask);var g=createNS('g');g.setAttribute('mask','url('+getLocationHref()+'#'+id+')');while(elemChildren[0]){g.appendChild(elemChildren[0]);}this.elem.layerElement.appendChild(g);this.masker=mask;groupPath.setAttribute('stroke','#fff');}else if(this.filterManager.effectElements[10].p.v===1||this.filterManager.effectElements[10].p.v===2){if(this.filterManager.effectElements[10].p.v===2){elemChildren=this.elem.layerElement.children||this.elem.layerElement.childNodes;while(elemChildren.length){this.elem.layerElement.removeChild(elemChildren[0]);}}this.elem.layerElement.appendChild(groupPath);this.elem.layerElement.removeAttribute('mask');groupPath.setAttribute('stroke','#fff');}this.initialized=true;this.pathMasker=groupPath;};SVGStrokeEffect.prototype.renderFrame=function(forceRender){if(!this.initialized){this.initialize();}var i;var len=this.paths.length;var mask;var path;for(i=0;i<len;i+=1){if(this.paths[i].m!==-1){mask=this.elem.maskManager.viewData[this.paths[i].m];path=this.paths[i].p;if(forceRender||this.filterManager._mdf||mask.prop._mdf){path.setAttribute('d',mask.lastPath);}if(forceRender||this.filterManager.effectElements[9].p._mdf||this.filterManager.effectElements[4].p._mdf||this.filterManager.effectElements[7].p._mdf||this.filterManager.effectElements[8].p._mdf||mask.prop._mdf){var dasharrayValue;if(this.filterManager.effectElements[7].p.v!==0||this.filterManager.effectElements[8].p.v!==100){var s=Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)*0.01;var e=Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)*0.01;var l=path.getTotalLength();dasharrayValue='0 0 0 '+l*s+' ';var lineLength=l*(e-s);var segment=1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v*0.01;var units=Math.floor(lineLength/segment);var j;for(j=0;j<units;j+=1){dasharrayValue+='1 '+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v*0.01+' ';}dasharrayValue+='0 '+l*10+' 0 0';}else{dasharrayValue='1 '+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v*0.01;}path.setAttribute('stroke-dasharray',dasharrayValue);}}}if(forceRender||this.filterManager.effectElements[4].p._mdf){this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);}if(forceRender||this.filterManager.effectElements[6].p._mdf){this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);}if(this.filterManager.effectElements[10].p.v===1||this.filterManager.effectElements[10].p.v===2){if(forceRender||this.filterManager.effectElements[3].p._mdf){var color=this.filterManager.effectElements[3].p.v;this.pathMasker.setAttribute('stroke','rgb('+bmFloor(color[0]*255)+','+bmFloor(color[1]*255)+','+bmFloor(color[2]*255)+')');}}};function SVGTritoneFilter(filter,filterManager,elem,id){this.filterManager=filterManager;var feColorMatrix=createNS('feColorMatrix');feColorMatrix.setAttribute('type','matrix');feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');filter.appendChild(feColorMatrix);var feComponentTransfer=createNS('feComponentTransfer');feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');feComponentTransfer.setAttribute('result',id);this.matrixFilter=feComponentTransfer;var feFuncR=createNS('feFuncR');feFuncR.setAttribute('type','table');feComponentTransfer.appendChild(feFuncR);this.feFuncR=feFuncR;var feFuncG=createNS('feFuncG');feFuncG.setAttribute('type','table');feComponentTransfer.appendChild(feFuncG);this.feFuncG=feFuncG;var feFuncB=createNS('feFuncB');feFuncB.setAttribute('type','table');feComponentTransfer.appendChild(feFuncB);this.feFuncB=feFuncB;filter.appendChild(feComponentTransfer);}SVGTritoneFilter.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){var color1=this.filterManager.effectElements[0].p.v;var color2=this.filterManager.effectElements[1].p.v;var color3=this.filterManager.effectElements[2].p.v;var tableR=color3[0]+' '+color2[0]+' '+color1[0];var tableG=color3[1]+' '+color2[1]+' '+color1[1];var tableB=color3[2]+' '+color2[2]+' '+color1[2];this.feFuncR.setAttribute('tableValues',tableR);this.feFuncG.setAttribute('tableValues',tableG);this.feFuncB.setAttribute('tableValues',tableB);}};function SVGProLevelsFilter(filter,filterManager,elem,id){this.filterManager=filterManager;var effectElements=this.filterManager.effectElements;var feComponentTransfer=createNS('feComponentTransfer');// Red
if(effectElements[10].p.k||effectElements[10].p.v!==0||effectElements[11].p.k||effectElements[11].p.v!==1||effectElements[12].p.k||effectElements[12].p.v!==1||effectElements[13].p.k||effectElements[13].p.v!==0||effectElements[14].p.k||effectElements[14].p.v!==1){this.feFuncR=this.createFeFunc('feFuncR',feComponentTransfer);}// Green
if(effectElements[17].p.k||effectElements[17].p.v!==0||effectElements[18].p.k||effectElements[18].p.v!==1||effectElements[19].p.k||effectElements[19].p.v!==1||effectElements[20].p.k||effectElements[20].p.v!==0||effectElements[21].p.k||effectElements[21].p.v!==1){this.feFuncG=this.createFeFunc('feFuncG',feComponentTransfer);}// Blue
if(effectElements[24].p.k||effectElements[24].p.v!==0||effectElements[25].p.k||effectElements[25].p.v!==1||effectElements[26].p.k||effectElements[26].p.v!==1||effectElements[27].p.k||effectElements[27].p.v!==0||effectElements[28].p.k||effectElements[28].p.v!==1){this.feFuncB=this.createFeFunc('feFuncB',feComponentTransfer);}// Alpha
if(effectElements[31].p.k||effectElements[31].p.v!==0||effectElements[32].p.k||effectElements[32].p.v!==1||effectElements[33].p.k||effectElements[33].p.v!==1||effectElements[34].p.k||effectElements[34].p.v!==0||effectElements[35].p.k||effectElements[35].p.v!==1){this.feFuncA=this.createFeFunc('feFuncA',feComponentTransfer);}// RGB
if(this.feFuncR||this.feFuncG||this.feFuncB||this.feFuncA){feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');filter.appendChild(feComponentTransfer);}if(effectElements[3].p.k||effectElements[3].p.v!==0||effectElements[4].p.k||effectElements[4].p.v!==1||effectElements[5].p.k||effectElements[5].p.v!==1||effectElements[6].p.k||effectElements[6].p.v!==0||effectElements[7].p.k||effectElements[7].p.v!==1){feComponentTransfer=createNS('feComponentTransfer');feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');feComponentTransfer.setAttribute('result',id);filter.appendChild(feComponentTransfer);this.feFuncRComposed=this.createFeFunc('feFuncR',feComponentTransfer);this.feFuncGComposed=this.createFeFunc('feFuncG',feComponentTransfer);this.feFuncBComposed=this.createFeFunc('feFuncB',feComponentTransfer);}}SVGProLevelsFilter.prototype.createFeFunc=function(type,feComponentTransfer){var feFunc=createNS(type);feFunc.setAttribute('type','table');feComponentTransfer.appendChild(feFunc);return feFunc;};SVGProLevelsFilter.prototype.getTableValue=function(inputBlack,inputWhite,gamma,outputBlack,outputWhite){var cnt=0;var segments=256;var perc;var min=Math.min(inputBlack,inputWhite);var max=Math.max(inputBlack,inputWhite);var table=Array.call(null,{length:segments});var colorValue;var pos=0;var outputDelta=outputWhite-outputBlack;var inputDelta=inputWhite-inputBlack;while(cnt<=256){perc=cnt/256;if(perc<=min){colorValue=inputDelta<0?outputWhite:outputBlack;}else if(perc>=max){colorValue=inputDelta<0?outputBlack:outputWhite;}else{colorValue=outputBlack+outputDelta*Math.pow((perc-inputBlack)/inputDelta,1/gamma);}table[pos]=colorValue;pos+=1;cnt+=256/(segments-1);}return table.join(' ');};SVGProLevelsFilter.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){var val;var effectElements=this.filterManager.effectElements;if(this.feFuncRComposed&&(forceRender||effectElements[3].p._mdf||effectElements[4].p._mdf||effectElements[5].p._mdf||effectElements[6].p._mdf||effectElements[7].p._mdf)){val=this.getTableValue(effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v,effectElements[7].p.v);this.feFuncRComposed.setAttribute('tableValues',val);this.feFuncGComposed.setAttribute('tableValues',val);this.feFuncBComposed.setAttribute('tableValues',val);}if(this.feFuncR&&(forceRender||effectElements[10].p._mdf||effectElements[11].p._mdf||effectElements[12].p._mdf||effectElements[13].p._mdf||effectElements[14].p._mdf)){val=this.getTableValue(effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v,effectElements[14].p.v);this.feFuncR.setAttribute('tableValues',val);}if(this.feFuncG&&(forceRender||effectElements[17].p._mdf||effectElements[18].p._mdf||effectElements[19].p._mdf||effectElements[20].p._mdf||effectElements[21].p._mdf)){val=this.getTableValue(effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v,effectElements[21].p.v);this.feFuncG.setAttribute('tableValues',val);}if(this.feFuncB&&(forceRender||effectElements[24].p._mdf||effectElements[25].p._mdf||effectElements[26].p._mdf||effectElements[27].p._mdf||effectElements[28].p._mdf)){val=this.getTableValue(effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v,effectElements[28].p.v);this.feFuncB.setAttribute('tableValues',val);}if(this.feFuncA&&(forceRender||effectElements[31].p._mdf||effectElements[32].p._mdf||effectElements[33].p._mdf||effectElements[34].p._mdf||effectElements[35].p._mdf)){val=this.getTableValue(effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v,effectElements[35].p.v);this.feFuncA.setAttribute('tableValues',val);}}};function SVGDropShadowEffect(filter,filterManager,elem,id,source){var globalFilterSize=filterManager.container.globalData.renderConfig.filterSize;var filterSize=filterManager.data.fs||globalFilterSize;filter.setAttribute('x',filterSize.x||globalFilterSize.x);filter.setAttribute('y',filterSize.y||globalFilterSize.y);filter.setAttribute('width',filterSize.width||globalFilterSize.width);filter.setAttribute('height',filterSize.height||globalFilterSize.height);this.filterManager=filterManager;var feGaussianBlur=createNS('feGaussianBlur');feGaussianBlur.setAttribute('in','SourceAlpha');feGaussianBlur.setAttribute('result',id+'_drop_shadow_1');feGaussianBlur.setAttribute('stdDeviation','0');this.feGaussianBlur=feGaussianBlur;filter.appendChild(feGaussianBlur);var feOffset=createNS('feOffset');feOffset.setAttribute('dx','25');feOffset.setAttribute('dy','0');feOffset.setAttribute('in',id+'_drop_shadow_1');feOffset.setAttribute('result',id+'_drop_shadow_2');this.feOffset=feOffset;filter.appendChild(feOffset);var feFlood=createNS('feFlood');feFlood.setAttribute('flood-color','#00ff00');feFlood.setAttribute('flood-opacity','1');feFlood.setAttribute('result',id+'_drop_shadow_3');this.feFlood=feFlood;filter.appendChild(feFlood);var feComposite=createNS('feComposite');feComposite.setAttribute('in',id+'_drop_shadow_3');feComposite.setAttribute('in2',id+'_drop_shadow_2');feComposite.setAttribute('operator','in');feComposite.setAttribute('result',id+'_drop_shadow_4');filter.appendChild(feComposite);var feMerge=this.createMergeNode(id,[id+'_drop_shadow_4',source]);filter.appendChild(feMerge);//
}extendPrototype([SVGComposableEffect],SVGDropShadowEffect);SVGDropShadowEffect.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){if(forceRender||this.filterManager.effectElements[4].p._mdf){this.feGaussianBlur.setAttribute('stdDeviation',this.filterManager.effectElements[4].p.v/4);}if(forceRender||this.filterManager.effectElements[0].p._mdf){var col=this.filterManager.effectElements[0].p.v;this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));}if(forceRender||this.filterManager.effectElements[1].p._mdf){this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);}if(forceRender||this.filterManager.effectElements[2].p._mdf||this.filterManager.effectElements[3].p._mdf){var distance=this.filterManager.effectElements[3].p.v;var angle=(this.filterManager.effectElements[2].p.v-90)*degToRads;var x=distance*Math.cos(angle);var y=distance*Math.sin(angle);this.feOffset.setAttribute('dx',x);this.feOffset.setAttribute('dy',y);}}};var _svgMatteSymbols=[];function SVGMatte3Effect(filterElem,filterManager,elem){this.initialized=false;this.filterManager=filterManager;this.filterElem=filterElem;this.elem=elem;elem.matteElement=createNS('g');elem.matteElement.appendChild(elem.layerElement);elem.matteElement.appendChild(elem.transformedElement);elem.baseElement=elem.matteElement;}SVGMatte3Effect.prototype.findSymbol=function(mask){var i=0;var len=_svgMatteSymbols.length;while(i<len){if(_svgMatteSymbols[i]===mask){return _svgMatteSymbols[i];}i+=1;}return null;};SVGMatte3Effect.prototype.replaceInParent=function(mask,symbolId){var parentNode=mask.layerElement.parentNode;if(!parentNode){return;}var children=parentNode.children;var i=0;var len=children.length;while(i<len){if(children[i]===mask.layerElement){break;}i+=1;}var nextChild;if(i<=len-2){nextChild=children[i+1];}var useElem=createNS('use');useElem.setAttribute('href','#'+symbolId);if(nextChild){parentNode.insertBefore(useElem,nextChild);}else{parentNode.appendChild(useElem);}};SVGMatte3Effect.prototype.setElementAsMask=function(elem,mask){if(!this.findSymbol(mask)){var symbolId=createElementID();var masker=createNS('mask');masker.setAttribute('id',mask.layerId);masker.setAttribute('mask-type','alpha');_svgMatteSymbols.push(mask);var defs=elem.globalData.defs;defs.appendChild(masker);var symbol=createNS('symbol');symbol.setAttribute('id',symbolId);this.replaceInParent(mask,symbolId);symbol.appendChild(mask.layerElement);defs.appendChild(symbol);var useElem=createNS('use');useElem.setAttribute('href','#'+symbolId);masker.appendChild(useElem);mask.data.hd=false;mask.show();}elem.setMatte(mask.layerId);};SVGMatte3Effect.prototype.initialize=function(){var ind=this.filterManager.effectElements[0].p.v;var elements=this.elem.comp.elements;var i=0;var len=elements.length;while(i<len){if(elements[i]&&elements[i].data.ind===ind){this.setElementAsMask(this.elem,elements[i]);}i+=1;}this.initialized=true;};SVGMatte3Effect.prototype.renderFrame=function(){if(!this.initialized){this.initialize();}};function SVGGaussianBlurEffect(filter,filterManager,elem,id){// Outset the filter region by 100% on all sides to accommodate blur expansion.
filter.setAttribute('x','-100%');filter.setAttribute('y','-100%');filter.setAttribute('width','300%');filter.setAttribute('height','300%');this.filterManager=filterManager;var feGaussianBlur=createNS('feGaussianBlur');feGaussianBlur.setAttribute('result',id);filter.appendChild(feGaussianBlur);this.feGaussianBlur=feGaussianBlur;}SVGGaussianBlurEffect.prototype.renderFrame=function(forceRender){if(forceRender||this.filterManager._mdf){// Empirical value, matching AE's blur appearance.
var kBlurrinessToSigma=0.3;var sigma=this.filterManager.effectElements[0].p.v*kBlurrinessToSigma;// Dimensions mapping:
//
//   1 -> horizontal & vertical
//   2 -> horizontal only
//   3 -> vertical only
//
var dimensions=this.filterManager.effectElements[1].p.v;var sigmaX=dimensions==3?0:sigma;// eslint-disable-line eqeqeq
var sigmaY=dimensions==2?0:sigma;// eslint-disable-line eqeqeq
this.feGaussianBlur.setAttribute('stdDeviation',sigmaX+' '+sigmaY);// Repeat edges mapping:
//
//   0 -> off -> duplicate
//   1 -> on  -> wrap
var edgeMode=this.filterManager.effectElements[2].p.v==1?'wrap':'duplicate';// eslint-disable-line eqeqeq
this.feGaussianBlur.setAttribute('edgeMode',edgeMode);}};function TransformEffect(){}TransformEffect.prototype.init=function(effectsManager){this.effectsManager=effectsManager;this.type=effectTypes.TRANSFORM_EFFECT;this.matrix=new Matrix();this.opacity=-1;this._mdf=false;this._opMdf=false;};TransformEffect.prototype.renderFrame=function(forceFrame){this._opMdf=false;this._mdf=false;if(forceFrame||this.effectsManager._mdf){var effectElements=this.effectsManager.effectElements;var anchor=effectElements[0].p.v;var position=effectElements[1].p.v;var isUniformScale=effectElements[2].p.v===1;var scaleHeight=effectElements[3].p.v;var scaleWidth=isUniformScale?scaleHeight:effectElements[4].p.v;var skew=effectElements[5].p.v;var skewAxis=effectElements[6].p.v;var rotation=effectElements[7].p.v;this.matrix.reset();this.matrix.translate(-anchor[0],-anchor[1],anchor[2]);this.matrix.scale(scaleWidth*0.01,scaleHeight*0.01,1);this.matrix.rotate(-rotation*degToRads);this.matrix.skewFromAxis(-skew*degToRads,(skewAxis+90)*degToRads);this.matrix.translate(position[0],position[1],0);this._mdf=true;if(this.opacity!==effectElements[8].p.v){this.opacity=effectElements[8].p.v;this._opMdf=true;}}};function SVGTransformEffect(_,filterManager){this.init(filterManager);}extendPrototype([TransformEffect],SVGTransformEffect);function CVTransformEffect(effectsManager){this.init(effectsManager);}extendPrototype([TransformEffect],CVTransformEffect);registerRenderer('canvas',CanvasRenderer);registerRenderer('html',HybridRenderer);registerRenderer('svg',SVGRenderer);// Registering shape modifiers
ShapeModifiers.registerModifier('tm',TrimModifier);ShapeModifiers.registerModifier('pb',PuckerAndBloatModifier);ShapeModifiers.registerModifier('rp',RepeaterModifier);ShapeModifiers.registerModifier('rd',RoundCornersModifier);ShapeModifiers.registerModifier('zz',ZigZagModifier);ShapeModifiers.registerModifier('op',OffsetPathModifier);// Registering expression plugin
setExpressionsPlugin(Expressions);setExpressionInterfaces(getInterface);initialize$1();initialize();// Registering svg effects
registerEffect$1(20,SVGTintFilter,true);registerEffect$1(21,SVGFillFilter,true);registerEffect$1(22,SVGStrokeEffect,false);registerEffect$1(23,SVGTritoneFilter,true);registerEffect$1(24,SVGProLevelsFilter,true);registerEffect$1(25,SVGDropShadowEffect,true);registerEffect$1(28,SVGMatte3Effect,false);registerEffect$1(29,SVGGaussianBlurEffect,true);registerEffect$1(35,SVGTransformEffect,false);registerEffect(35,CVTransformEffect);return lottie;});

/***/ }),

/***/ 3081:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ed: function() { return /* binding */ Vue3Lottie; }
/* harmony export */ });
/* unused harmony exports default, install */
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(560);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7203);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4917);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lottie_web__WEBPACK_IMPORTED_MODULE_2__);
/* module decorator */ module = __webpack_require__.hmd(module);



var freeGlobal = typeof __webpack_require__.g == "object" && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;
var freeGlobal$1 = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function("return this")();
var root$1 = root;
var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;
var objectProto$e = Object.prototype;
var hasOwnProperty$b = objectProto$e.hasOwnProperty;
var nativeObjectToString$1 = objectProto$e.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$d = Object.prototype;
var nativeObjectToString = objectProto$d.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]",
  undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isArray = Array.isArray;
var isArray$1 = isArray;
function isObject(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var asyncTag = "[object AsyncFunction]",
  funcTag$2 = "[object Function]",
  genTag$1 = "[object GeneratorFunction]",
  proxyTag = "[object Proxy]";
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"];
var coreJsData$1 = coreJsData;
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return func + "";
    } catch (e) {}
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype,
  objectProto$c = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$a = objectProto$c.hasOwnProperty;
var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$a).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue(object, key) {
  return object == null ? void 0 : object[key];
}
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var WeakMap = getNative(root$1, "WeakMap");
var WeakMap$1 = WeakMap;
var objectCreate = Object.create;
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = void 0;
    return result;
  };
}();
var baseCreate$1 = baseCreate;
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}
var defineProperty = function () {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e) {}
}();
var defineProperty$1 = defineProperty;
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
function baseAssignValue(object, key, value) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var objectProto$b = Object.prototype;
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$9.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
var objectProto$a = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == "function" && Ctor.prototype || objectProto$a;
  return value === proto;
}
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$3;
}
var objectProto$9 = Object.prototype;
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$8.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
var isArguments$1 = isArguments;
function stubFalse() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && "object" == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$1 = moduleExports$2 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;
var argsTag$2 = "[object Arguments]",
  arrayTag$2 = "[object Array]",
  boolTag$3 = "[object Boolean]",
  dateTag$3 = "[object Date]",
  errorTag$2 = "[object Error]",
  funcTag$1 = "[object Function]",
  mapTag$5 = "[object Map]",
  numberTag$3 = "[object Number]",
  objectTag$3 = "[object Object]",
  regexpTag$3 = "[object RegExp]",
  setTag$5 = "[object Set]",
  stringTag$3 = "[object String]",
  weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$3 = "[object ArrayBuffer]",
  dataViewTag$4 = "[object DataView]",
  float32Tag$2 = "[object Float32Array]",
  float64Tag$2 = "[object Float64Array]",
  int8Tag$2 = "[object Int8Array]",
  int16Tag$2 = "[object Int16Array]",
  int32Tag$2 = "[object Int32Array]",
  uint8Tag$2 = "[object Uint8Array]",
  uint8ClampedTag$2 = "[object Uint8ClampedArray]",
  uint16Tag$2 = "[object Uint16Array]",
  uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] = typedArrayTags[weakMapTag$2] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && "object" == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal$1.process;
var nodeUtil = function () {
  try {
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e) {}
}();
var nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;
var objectProto$8 = Object.prototype;
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
    isArg = !isArr && isArguments$1(value),
    isBuff = !isArr && !isArg && isBuffer$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;
var objectProto$7 = Object.prototype;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$6.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$5.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
var nativeCreate = getNative(Object, "create");
var nativeCreate$1 = nativeCreate;
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$4.call(data, key) ? data[key] : void 0;
}
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$3.call(data, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? void 0 : data[index][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map = getNative(root$1, "Map");
var Map$1 = Map;
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data = this.__data__,
    result = data["delete"](key);
  this.size = data.size;
  return result;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && "object" == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer = moduleExports ? root$1.Buffer : void 0,
  allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$3 = Object.prototype;
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;
function copySymbols(source, object) {
  return copyObject(source, getSymbols$1(source), object);
}
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};
var getSymbolsIn$1 = getSymbolsIn;
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}
var DataView = getNative(root$1, "DataView");
var DataView$1 = DataView;
var Promise$1 = getNative(root$1, "Promise");
var Promise$2 = Promise$1;
var Set = getNative(root$1, "Set");
var Set$1 = Set;
var mapTag$4 = "[object Map]",
  objectTag$2 = "[object Object]",
  promiseTag = "[object Promise]",
  setTag$4 = "[object Set]",
  weakMapTag$1 = "[object WeakMap]";
var dataViewTag$3 = "[object DataView]";
var dataViewCtorString = toSource(DataView$1),
  mapCtorString = toSource(Map$1),
  promiseCtorString = toSource(Promise$2),
  setCtorString = toSource(Set$1),
  weakMapCtorString = toSource(WeakMap$1);
var getTag = baseGetTag;
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$3 || Map$1 && getTag(new Map$1()) != mapTag$4 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$4 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) {
  getTag = function (value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag$2 ? value.constructor : void 0,
      ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$3;
        case mapCtorString:
          return mapTag$4;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$4;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);
  if (length && typeof array[0] == "string" && hasOwnProperty$2.call(array, "index")) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}
var Uint8Array = root$1.Uint8Array;
var Uint8Array$1 = Uint8Array;
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0,
  symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var boolTag$2 = "[object Boolean]",
  dateTag$2 = "[object Date]",
  mapTag$3 = "[object Map]",
  numberTag$2 = "[object Number]",
  regexpTag$2 = "[object RegExp]",
  setTag$3 = "[object Set]",
  stringTag$2 = "[object String]",
  symbolTag$2 = "[object Symbol]";
var arrayBufferTag$2 = "[object ArrayBuffer]",
  dataViewTag$2 = "[object DataView]",
  float32Tag$1 = "[object Float32Array]",
  float64Tag$1 = "[object Float64Array]",
  int8Tag$1 = "[object Int8Array]",
  int16Tag$1 = "[object Int16Array]",
  int32Tag$1 = "[object Int32Array]",
  uint8Tag$1 = "[object Uint8Array]",
  uint8ClampedTag$1 = "[object Uint8ClampedArray]",
  uint16Tag$1 = "[object Uint16Array]",
  uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object);
    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object);
    case dataViewTag$2:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$3:
      return new Ctor();
    case numberTag$2:
    case stringTag$2:
      return new Ctor(object);
    case regexpTag$2:
      return cloneRegExp(object);
    case setTag$3:
      return new Ctor();
    case symbolTag$2:
      return cloneSymbol(object);
  }
}
function initCloneObject(object) {
  return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
}
var mapTag$2 = "[object Map]";
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$2;
}
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;
var setTag$2 = "[object Set]";
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$2;
}
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;
var CLONE_DEEP_FLAG$1 = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG$1 = 4;
var argsTag$1 = "[object Arguments]",
  arrayTag$1 = "[object Array]",
  boolTag$1 = "[object Boolean]",
  dateTag$1 = "[object Date]",
  errorTag$1 = "[object Error]",
  funcTag = "[object Function]",
  genTag = "[object GeneratorFunction]",
  mapTag$1 = "[object Map]",
  numberTag$1 = "[object Number]",
  objectTag$1 = "[object Object]",
  regexpTag$1 = "[object RegExp]",
  setTag$1 = "[object Set]",
  stringTag$1 = "[object String]",
  symbolTag$1 = "[object Symbol]",
  weakMapTag = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]",
  dataViewTag$1 = "[object DataView]",
  float32Tag = "[object Float32Array]",
  float64Tag = "[object Float64Array]",
  int8Tag = "[object Int8Array]",
  int16Tag = "[object Int16Array]",
  int32Tag = "[object Int32Array]",
  uint8Tag = "[object Uint8Array]",
  uint8ClampedTag = "[object Uint8ClampedArray]",
  uint16Tag = "[object Uint16Array]",
  uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$1] = cloneableTags[numberTag$1] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$1] = cloneableTags[stringTag$1] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG$1,
    isFlat = bitmask & CLONE_FLAT_FLAG,
    isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray$1(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
      isFunc = tag == funcTag || tag == genTag;
    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag$1 || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key2) {
      result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? void 0 : keysFunc(value);
  arrayEach(props || value, function (subValue, key2) {
    if (props) {
      key2 = subValue;
      subValue = value[key2];
    }
    assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
  });
  return result;
}
var CLONE_DEEP_FLAG = 1,
  CLONE_SYMBOLS_FLAG = 4;
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
function SetCache(values) {
  var index = -1,
    length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache, key) {
  return cache.has(key);
}
var COMPARE_PARTIAL_FLAG$3 = 1,
  COMPARE_UNORDERED_FLAG$1 = 2;
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
    arrLength = array.length,
    othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
    result = true,
    seen = bitmask & COMPARE_UNORDERED_FLAG$1 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index < arrLength) {
    var arrValue = array[index],
      othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function (othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
function mapToArray(map) {
  var index = -1,
    result = Array(map.size);
  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}
function setToArray(set) {
  var index = -1,
    result = Array(set.size);
  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$2 = 1,
  COMPARE_UNORDERED_FLAG = 2;
var boolTag = "[object Boolean]",
  dateTag = "[object Date]",
  errorTag = "[object Error]",
  mapTag = "[object Map]",
  numberTag = "[object Number]",
  regexpTag = "[object RegExp]",
  setTag = "[object Set]",
  stringTag = "[object String]",
  symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]",
  dataViewTag = "[object DataView]";
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0,
  symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      return object == other + "";
    case mapTag:
      var convert = mapToArray;
    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var COMPARE_PARTIAL_FLAG$1 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1,
    objProps = getAllKeys(object),
    objLength = objProps.length,
    othProps = getAllKeys(other),
    othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
      othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
      othCtor = other.constructor;
    if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result;
}
var COMPARE_PARTIAL_FLAG = 1;
var argsTag = "[object Arguments]",
  arrayTag = "[object Array]",
  objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object),
    othIsArr = isArray$1(other),
    objTag = objIsArr ? arrayTag : getTag$1(object),
    othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag,
    othIsObj = othTag == objectTag,
    isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"),
      othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
        othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
function isEqual(value, other) {
  return baseIsEqual(value, other);
}
var vue3Lottie_vue_vue_type_style_index_0_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main = (0,vue__WEBPACK_IMPORTED_MODULE_1__.defineComponent)({
  props: {
    animationData: {
      type: Object,
      default: () => ({})
    },
    animationLink: {
      type: String,
      default: ""
    },
    loop: {
      type: [Boolean, Number],
      default: true
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
    width: {
      type: [Number, String],
      default: "100%"
    },
    height: {
      type: [Number, String],
      default: "100%"
    },
    speed: {
      type: Number,
      default: 1
    },
    delay: {
      type: Number,
      default: 0
    },
    direction: {
      type: String,
      default: "forward"
    },
    pauseOnHover: {
      type: Boolean,
      default: false
    },
    playOnHover: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: "transparent"
    },
    pauseAnimation: {
      type: Boolean,
      default: false
    },
    renderer: {
      type: String,
      default: "svg"
    },
    rendererSettings: {
      type: Object,
      default: () => ({})
    },
    assetsPath: {
      type: String,
      default: ""
    }
  },
  emits: {
    onComplete: null,
    onLoopComplete: null,
    onEnterFrame: null,
    onSegmentStart: null,
    onAnimationLoaded: null
  },
  setup(props, {
    emit: emits
  }) {
    let lottieAnimation = (0,vue__WEBPACK_IMPORTED_MODULE_1__.ref)(null);
    const elementid = (0,vue__WEBPACK_IMPORTED_MODULE_1__.ref)("");
    let direction = 1;
    const checkIfContainerExists = elementID => {
      if (document.querySelector(`[data-id="${elementID}"]`) !== null) {
        return true;
      } else {
        return false;
      }
    };
    const loadLottie = async element => {
      let autoPlay = props.autoPlay;
      if (props.playOnHover) {
        autoPlay = false;
      }
      let animationData = {};
      if (isEqual(props.animationData, {}) === false) {
        animationData = cloneDeep(props.animationData);
      }
      if (props.animationLink != "") {
        try {
          const response = await fetch(props.animationLink);
          const json = await response.json();
          animationData = json;
        } catch (error) {
          console.error(error);
          return;
        }
      }
      let loop = props.loop;
      if (typeof loop === "number") {
        if (loop > 0) {
          loop = loop - 1;
        }
      }
      if (props.delay > 0) {
        autoPlay = false;
      }
      const lottieAnimationConfig = {
        container: element,
        renderer: props.renderer,
        loop,
        autoplay: autoPlay,
        animationData,
        assetsPath: props.assetsPath
      };
      if (isEqual(props.rendererSettings, {}) === false) {
        lottieAnimationConfig.rendererSettings = props.rendererSettings;
      }
      lottieAnimation = lottie_web__WEBPACK_IMPORTED_MODULE_2___default().loadAnimation(lottieAnimationConfig);
      setTimeout(() => {
        autoPlay = props.autoPlay;
        if (props.playOnHover) {
          lottieAnimation.pause();
        } else {
          if (autoPlay) {
            lottieAnimation.play();
          } else {
            lottieAnimation.pause();
          }
        }
        emits("onAnimationLoaded");
      }, props.delay);
      lottieAnimation.setSpeed(props.speed);
      if (props.direction === "reverse") {
        lottieAnimation.setDirection(-1);
      }
      if (props.direction === "normal") {
        lottieAnimation.setDirection(1);
      }
      if (props.pauseAnimation) {
        lottieAnimation.pause();
      } else {
        if (props.playOnHover) {
          lottieAnimation.pause();
        }
      }
      lottieAnimation.addEventListener("loopComplete", () => {
        if (props.direction === "alternate") {
          lottieAnimation.stop();
          direction = direction * -1;
          lottieAnimation.setDirection(direction);
          lottieAnimation.play();
        }
        emits("onLoopComplete");
      });
      lottieAnimation.addEventListener("complete", () => {
        emits("onComplete");
      });
      lottieAnimation.addEventListener("enterFrame", () => {
        emits("onEnterFrame");
      });
      lottieAnimation.addEventListener("segmentStart", () => {
        emits("onSegmentStart");
      });
    };
    const getCurrentStyle = (0,vue__WEBPACK_IMPORTED_MODULE_1__.computed)(() => {
      let width = props.width;
      let height = props.height;
      if (typeof props.width === "number") {
        width = `${props.width}px`;
      }
      if (typeof props.height === "number") {
        height = `${props.height}px`;
      }
      let cssVariables = {
        "--lottie-animation-container-width": width,
        "--lottie-animation-container-height": height,
        "--lottie-animation-container-background-color": props.backgroundColor
      };
      return cssVariables;
    });
    const hoverStarted = () => {
      if (lottieAnimation && props.pauseOnHover) {
        lottieAnimation.pause();
      }
      if (lottieAnimation && props.playOnHover) {
        lottieAnimation.play();
      }
    };
    const hoverEnded = () => {
      if (lottieAnimation && props.pauseOnHover) {
        lottieAnimation.play();
      }
      if (lottieAnimation && props.playOnHover) {
        lottieAnimation.pause();
      }
    };
    (0,vue__WEBPACK_IMPORTED_MODULE_1__.watch)(() => props.pauseAnimation, () => {
      if ((props.pauseOnHover || props.playOnHover) && props.pauseAnimation) {
        console.error("If you are using pauseAnimation prop for Vue3-Lottie, please remove the props pauseOnHover and playOnHover");
        return;
      }
      if (lottieAnimation) {
        if (props.pauseAnimation) {
          lottieAnimation.pause();
        } else {
          lottieAnimation.play();
        }
      }
    });
    const play = () => {
      if (lottieAnimation) {
        lottieAnimation.play();
      }
    };
    const pause = () => {
      if (lottieAnimation) {
        lottieAnimation.pause();
      }
    };
    const stop = () => {
      if (lottieAnimation) {
        lottieAnimation.stop();
      }
    };
    const destroy = () => {
      if (lottieAnimation) {
        lottieAnimation.destroy();
      }
    };
    const setSpeed = (speed = 1) => {
      if (speed <= 0) {
        throw new Error("Speed must be greater than 0");
      }
      if (lottieAnimation) {
        lottieAnimation.setSpeed(speed);
      }
    };
    const setDirection = direction2 => {
      if (lottieAnimation) {
        if (direction2 === "forward") {
          lottieAnimation.setDirection(1);
        } else if (direction2 === "reverse") {
          lottieAnimation.setDirection(-1);
        }
      }
    };
    const goToAndStop = (frame, isFrame = true) => {
      if (lottieAnimation) {
        lottieAnimation.goToAndStop(frame, isFrame);
      }
    };
    const goToAndPlay = (frame, isFrame = true) => {
      if (lottieAnimation) {
        lottieAnimation.goToAndPlay(frame, isFrame);
      }
    };
    const playSegments = (segments, forceFlag = false) => {
      if (lottieAnimation) {
        lottieAnimation.playSegments(segments, forceFlag);
      }
    };
    const setSubFrame = (useSubFrame = true) => {
      if (lottieAnimation) {
        lottieAnimation.setSubframe(useSubFrame);
      }
    };
    const getDuration = (inFrames = true) => {
      if (lottieAnimation) {
        return lottieAnimation.getDuration(inFrames);
      }
    };
    const updateDocumentData = (documentData, index = 0) => {
      if (lottieAnimation) {
        lottieAnimation.renderer.elements[index].updateDocumentData(documentData);
      }
    };
    const makeid = length => {
      var result = "";
      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    };
    const setupLottie = elementID => {
      if (props.pauseOnHover && props.playOnHover) {
        throw new Error("You cannot set pauseOnHover and playOnHover for Vue3-Lottie at the same time.");
      }
      if (props.animationLink === "" && isEqual(props.animationData, {})) {
        throw new Error("You must provide either animationLink or animationData");
      }
      const interval = setInterval(() => {
        if (checkIfContainerExists(elementID)) {
          clearInterval(interval);
          const element = document.querySelector(`[data-id="${elementID}" ]`);
          if (element) {
            loadLottie(element);
          }
        }
      }, 0);
    };
    (0,vue__WEBPACK_IMPORTED_MODULE_1__.onMounted)(async () => {
      elementid.value = makeid(20);
      setupLottie(elementid.value);
    });
    return {
      elementid,
      hoverEnded,
      hoverStarted,
      getCurrentStyle,
      play,
      pause,
      stop,
      destroy,
      setSpeed,
      setDirection,
      goToAndStop,
      goToAndPlay,
      playSegments,
      setSubFrame,
      getDuration,
      updateDocumentData
    };
  }
});
const _hoisted_1 = ["data-id"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,vue__WEBPACK_IMPORTED_MODULE_1__.openBlock)(), (0,vue__WEBPACK_IMPORTED_MODULE_1__.createElementBlock)("div", {
    "data-id": _ctx.elementid,
    class: "lottie-animation-container",
    style: (0,vue__WEBPACK_IMPORTED_MODULE_1__.normalizeStyle)(_ctx.getCurrentStyle),
    onMouseenter: _cache[0] || (_cache[0] = (...args) => _ctx.hoverStarted && _ctx.hoverStarted(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => _ctx.hoverEnded && _ctx.hoverEnded(...args))
  }, null, 44, _hoisted_1);
}
var Vue3Lottie = /* @__PURE__ */_export_sfc(_sfc_main, [["render", _sfc_render]]);
function install(app, options) {
  const finalOptions = Object.assign({}, {
    name: "Vue3Lottie"
  }, options);
  app.component(`${finalOptions.name}`, Vue3Lottie);
}
const plugin = {
  version: "2.7.4",
  install
};


/***/ }),

/***/ 7203:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7203__;

/***/ }),

/***/ 509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(9985);
var tryToString = __webpack_require__(3691);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 3550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(9985);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 5027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(8999);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 7075:
/***/ (function(module) {

"use strict";

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ 4872:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__(7075);
var DESCRIPTORS = __webpack_require__(7697);
var global = __webpack_require__(9037);
var isCallable = __webpack_require__(9985);
var isObject = __webpack_require__(8999);
var hasOwn = __webpack_require__(6812);
var classof = __webpack_require__(926);
var tryToString = __webpack_require__(3691);
var createNonEnumerableProperty = __webpack_require__(5773);
var defineBuiltIn = __webpack_require__(1880);
var defineBuiltInAccessor = __webpack_require__(2148);
var isPrototypeOf = __webpack_require__(3622);
var getPrototypeOf = __webpack_require__(1868);
var setPrototypeOf = __webpack_require__(9385);
var wellKnownSymbol = __webpack_require__(4201);
var uid = __webpack_require__(4630);
var InternalStateModule = __webpack_require__(618);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw new TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw new TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw new TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ 9976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(6310);

module.exports = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),

/***/ 4328:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(5290);
var toAbsoluteIndex = __webpack_require__(7578);
var lengthOfArrayLike = __webpack_require__(6310);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 5649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(7697);
var isArray = __webpack_require__(2297);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 6166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(6310);

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
module.exports = function (O, C) {
  var len = lengthOfArrayLike(O);
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = O[len - k - 1];
  return A;
};


/***/ }),

/***/ 6134:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var lengthOfArrayLike = __webpack_require__(6310);
var toIntegerOrInfinity = __webpack_require__(8700);

var $RangeError = RangeError;

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
module.exports = function (O, C, index, value) {
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) throw new $RangeError('Incorrect index');
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
  return A;
};


/***/ }),

/***/ 6648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(8844);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 926:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(3043);
var isCallable = __webpack_require__(9985);
var classofRaw = __webpack_require__(6648);
var wellKnownSymbol = __webpack_require__(4201);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 8758:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(6812);
var ownKeys = __webpack_require__(9152);
var getOwnPropertyDescriptorModule = __webpack_require__(2474);
var definePropertyModule = __webpack_require__(2560);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 1748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3689);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 5773:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(7697);
var definePropertyModule = __webpack_require__(2560);
var createPropertyDescriptor = __webpack_require__(5684);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 5684:
/***/ (function(module) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 2148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__(8702);
var defineProperty = __webpack_require__(2560);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 1880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(9985);
var definePropertyModule = __webpack_require__(2560);
var makeBuiltIn = __webpack_require__(8702);
var defineGlobalProperty = __webpack_require__(5014);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 5014:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9037);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 8494:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var tryToString = __webpack_require__(3691);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),

/***/ 7697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3689);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ 2659:
/***/ (function(module) {

"use strict";

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 6420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9037);
var isObject = __webpack_require__(8999);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 5565:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 71:
/***/ (function(module) {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 3615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9037);
var userAgent = __webpack_require__(71);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 2739:
/***/ (function(module) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 9989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9037);
var getOwnPropertyDescriptor = (__webpack_require__(2474).f);
var createNonEnumerableProperty = __webpack_require__(5773);
var defineBuiltIn = __webpack_require__(1880);
var defineGlobalProperty = __webpack_require__(5014);
var copyConstructorProperties = __webpack_require__(8758);
var isForced = __webpack_require__(5266);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 3689:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 7215:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3689);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 2615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(7215);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 1236:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(7697);
var hasOwn = __webpack_require__(6812);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 2743:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(8844);
var aCallable = __webpack_require__(509);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 8844:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(7215);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 6058:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9037);
var isCallable = __webpack_require__(9985);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 4849:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(509);
var isNullOrUndefined = __webpack_require__(981);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 9037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 6812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(8844);
var toObject = __webpack_require__(690);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 7248:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 8506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(7697);
var fails = __webpack_require__(3689);
var createElement = __webpack_require__(6420);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ 4413:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(8844);
var fails = __webpack_require__(3689);
var classof = __webpack_require__(6648);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 6738:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(8844);
var isCallable = __webpack_require__(9985);
var store = __webpack_require__(4091);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(9834);
var global = __webpack_require__(9037);
var isObject = __webpack_require__(8999);
var createNonEnumerableProperty = __webpack_require__(5773);
var hasOwn = __webpack_require__(6812);
var shared = __webpack_require__(4091);
var sharedKey = __webpack_require__(2713);
var hiddenKeys = __webpack_require__(7248);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 2297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(6648);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ 9401:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(926);

module.exports = function (it) {
  var klass = classof(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};


/***/ }),

/***/ 9985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $documentAll = __webpack_require__(2659);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 5266:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(3689);
var isCallable = __webpack_require__(9985);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 981:
/***/ (function(module) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 8999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(9985);
var $documentAll = __webpack_require__(2659);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 3931:
/***/ (function(module) {

"use strict";

module.exports = false;


/***/ }),

/***/ 734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(6058);
var isCallable = __webpack_require__(9985);
var isPrototypeOf = __webpack_require__(3622);
var USE_SYMBOL_AS_UID = __webpack_require__(9525);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 6310:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__(3126);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 8702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(8844);
var fails = __webpack_require__(3689);
var isCallable = __webpack_require__(9985);
var hasOwn = __webpack_require__(6812);
var DESCRIPTORS = __webpack_require__(7697);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(1236).CONFIGURABLE);
var inspectSource = __webpack_require__(6738);
var InternalStateModule = __webpack_require__(618);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 8828:
/***/ (function(module) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 2560:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(7697);
var IE8_DOM_DEFINE = __webpack_require__(8506);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(5648);
var anObject = __webpack_require__(5027);
var toPropertyKey = __webpack_require__(8360);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 2474:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(7697);
var call = __webpack_require__(2615);
var propertyIsEnumerableModule = __webpack_require__(9556);
var createPropertyDescriptor = __webpack_require__(5684);
var toIndexedObject = __webpack_require__(5290);
var toPropertyKey = __webpack_require__(8360);
var hasOwn = __webpack_require__(6812);
var IE8_DOM_DEFINE = __webpack_require__(8506);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 2741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(4948);
var enumBugKeys = __webpack_require__(2739);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 7518:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 1868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(6812);
var isCallable = __webpack_require__(9985);
var toObject = __webpack_require__(690);
var sharedKey = __webpack_require__(2713);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(1748);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 3622:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(8844);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 4948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(8844);
var hasOwn = __webpack_require__(6812);
var toIndexedObject = __webpack_require__(5290);
var indexOf = (__webpack_require__(4328).indexOf);
var hiddenKeys = __webpack_require__(7248);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 9556:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 9385:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(2743);
var anObject = __webpack_require__(5027);
var aPossiblePrototype = __webpack_require__(3550);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 5899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(2615);
var isCallable = __webpack_require__(9985);
var isObject = __webpack_require__(8999);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 9152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(6058);
var uncurryThis = __webpack_require__(8844);
var getOwnPropertyNamesModule = __webpack_require__(2741);
var getOwnPropertySymbolsModule = __webpack_require__(7518);
var anObject = __webpack_require__(5027);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 4684:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__(981);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 2713:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__(3430);
var uid = __webpack_require__(4630);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 4091:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9037);
var defineGlobalProperty = __webpack_require__(5014);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 3430:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(3931);
var store = __webpack_require__(4091);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.33.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.33.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 146:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(3615);
var fails = __webpack_require__(3689);
var global = __webpack_require__(9037);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 7578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(8700);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 1530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(8732);

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw new $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};


/***/ }),

/***/ 5290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(4413);
var requireObjectCoercible = __webpack_require__(4684);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 8700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__(8828);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 3126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(8700);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 690:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__(4684);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 8732:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(2615);
var isObject = __webpack_require__(8999);
var isSymbol = __webpack_require__(734);
var getMethod = __webpack_require__(4849);
var ordinaryToPrimitive = __webpack_require__(5899);
var wellKnownSymbol = __webpack_require__(4201);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 8360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(8732);
var isSymbol = __webpack_require__(734);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 3043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(4201);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 4327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(926);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 3691:
/***/ (function(module) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 4630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(8844);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 9525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(146);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 5648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(7697);
var fails = __webpack_require__(3689);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ 1500:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 9834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9037);
var isCallable = __webpack_require__(9985);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 4201:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9037);
var shared = __webpack_require__(3430);
var hasOwn = __webpack_require__(6812);
var uid = __webpack_require__(4630);
var NATIVE_SYMBOL = __webpack_require__(146);
var USE_SYMBOL_AS_UID = __webpack_require__(9525);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 560:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(9989);
var toObject = __webpack_require__(690);
var lengthOfArrayLike = __webpack_require__(6310);
var setArrayLength = __webpack_require__(5649);
var doesNotExceedSafeInteger = __webpack_require__(5565);
var fails = __webpack_require__(3689);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 1719:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(9989);
var toObject = __webpack_require__(690);
var lengthOfArrayLike = __webpack_require__(6310);
var setArrayLength = __webpack_require__(5649);
var deletePropertyOrThrow = __webpack_require__(8494);
var doesNotExceedSafeInteger = __webpack_require__(5565);

// IE8-
var INCORRECT_RESULT = [].unshift(0) !== 1;

// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).unshift();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_RESULT || !properErrorOnNonWritableLength();

// `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function unshift(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    if (argCount) {
      doesNotExceedSafeInteger(len + argCount);
      var k = len;
      while (k--) {
        var to = k + argCount;
        if (k in O) O[to] = O[k];
        else deletePropertyOrThrow(O, to);
      }
      for (var j = 0; j < argCount; j++) {
        O[j] = arguments[j];
      }
    } return setArrayLength(O, len + argCount);
  }
});


/***/ }),

/***/ 4224:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arrayToReversed = __webpack_require__(6166);
var ArrayBufferViewCore = __webpack_require__(4872);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// `%TypedArray%.prototype.toReversed` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.toreversed
exportTypedArrayMethod('toReversed', function toReversed() {
  return arrayToReversed(aTypedArray(this), getTypedArrayConstructor(this));
});


/***/ }),

/***/ 1121:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ArrayBufferViewCore = __webpack_require__(4872);
var uncurryThis = __webpack_require__(8844);
var aCallable = __webpack_require__(509);
var arrayFromConstructorAndList = __webpack_require__(9976);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var sort = uncurryThis(ArrayBufferViewCore.TypedArrayPrototype.sort);

// `%TypedArray%.prototype.toSorted` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tosorted
exportTypedArrayMethod('toSorted', function toSorted(compareFn) {
  if (compareFn !== undefined) aCallable(compareFn);
  var O = aTypedArray(this);
  var A = arrayFromConstructorAndList(getTypedArrayConstructor(O), O);
  return sort(A, compareFn);
});


/***/ }),

/***/ 7133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arrayWith = __webpack_require__(6134);
var ArrayBufferViewCore = __webpack_require__(4872);
var isBigIntArray = __webpack_require__(9401);
var toIntegerOrInfinity = __webpack_require__(8700);
var toBigInt = __webpack_require__(1530);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var PROPER_ORDER = !!function () {
  try {
    // eslint-disable-next-line no-throw-literal, es/no-typed-arrays, es/no-array-prototype-with -- required for testing
    new Int8Array(1)['with'](2, { valueOf: function () { throw 8; } });
  } catch (error) {
    // some early implementations, like WebKit, does not follow the final semantic
    // https://github.com/tc39/proposal-change-array-by-copy/pull/86
    return error === 8;
  }
}();

// `%TypedArray%.prototype.with` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.with
exportTypedArrayMethod('with', { 'with': function (index, value) {
  var O = aTypedArray(this);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualValue = isBigIntArray(O) ? toBigInt(value) : +value;
  return arrayWith(O, getTypedArrayConstructor(O), relativeIndex, actualValue);
} }['with'], !PROPER_ORDER);


/***/ }),

/***/ 8858:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(1880);
var uncurryThis = __webpack_require__(8844);
var toString = __webpack_require__(4327);
var validateArgumentsLength = __webpack_require__(1500);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var append = uncurryThis(URLSearchParamsPrototype.append);
var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
var push = uncurryThis([].push);
var params = new $URLSearchParams('a=1&a=2&b=3');

params['delete']('a', 1);
// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
params['delete']('b', undefined);

if (params + '' !== 'a=2') {
  defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $delete(this, name);
    var entries = [];
    forEach(this, function (v, k) { // also validates `this`
      push(entries, { key: k, value: v });
    });
    validateArgumentsLength(length, 1);
    var key = toString(name);
    var value = toString($value);
    var index = 0;
    var dindex = 0;
    var found = false;
    var entriesLength = entries.length;
    var entry;
    while (index < entriesLength) {
      entry = entries[index++];
      if (found || entry.key === key) {
        found = true;
        $delete(this, entry.key);
      } else dindex++;
    }
    while (dindex < entriesLength) {
      entry = entries[dindex++];
      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
    }
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ 1318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineBuiltIn = __webpack_require__(1880);
var uncurryThis = __webpack_require__(8844);
var toString = __webpack_require__(4327);
var validateArgumentsLength = __webpack_require__(1500);

var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
var $has = uncurryThis(URLSearchParamsPrototype.has);
var params = new $URLSearchParams('a=1');

// `undefined` case is a Chromium 117 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=14222
if (params.has('a', 2) || !params.has('a', undefined)) {
  defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
    var length = arguments.length;
    var $value = length < 2 ? undefined : arguments[1];
    if (length && $value === undefined) return $has(this, name);
    var values = getAll(this, name); // also validates `this`
    validateArgumentsLength(length, 1);
    var value = toString($value);
    var index = 0;
    while (index < values.length) {
      if (values[index++] === value) return true;
    } return false;
  }, { enumerable: true, unsafe: true });
}


/***/ }),

/***/ 3228:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(7697);
var uncurryThis = __webpack_require__(8844);
var defineBuiltInAccessor = __webpack_require__(2148);

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd options */
/******/ 	!function() {
/******/ 		__webpack_require__.amdO = {};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.hmd = function(module) {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: function() {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  OrqAccordion: function() { return /* reexport */ Accordion; },
  OrqAvatar: function() { return /* reexport */ Avatar; },
  OrqBadge: function() { return /* reexport */ Badge; },
  OrqBanner: function() { return /* reexport */ Banner; },
  OrqBreadcrumb: function() { return /* reexport */ Breadcrumb; },
  OrqBullet: function() { return /* reexport */ Bullet; },
  OrqButton: function() { return /* reexport */ Button; },
  OrqButtonIcon: function() { return /* reexport */ ButtonIcon; },
  OrqButtonShortcut: function() { return /* reexport */ ButtonShortcut; },
  OrqCalendar: function() { return /* reexport */ Calendar; },
  OrqCheckbox: function() { return /* reexport */ Checkbox; },
  OrqCodeSnippet: function() { return /* reexport */ CodeSnippet; },
  OrqContentSwitcher: function() { return /* reexport */ ContentSwitcher; },
  OrqCounter: function() { return /* reexport */ Counter; },
  OrqDivider: function() { return /* reexport */ Divider; },
  OrqDropdown: function() { return /* reexport */ Dropdown; },
  OrqDropdownItem: function() { return /* reexport */ DropdownItem; },
  OrqEmptyState: function() { return /* reexport */ EmptyState; },
  OrqFileUploader: function() { return /* reexport */ FileUploader; },
  OrqFilter: function() { return /* reexport */ Filter; },
  OrqFilterCalendar: function() { return /* reexport */ FilterCalendar; },
  OrqFilterItem: function() { return /* reexport */ FilterItem; },
  OrqFilterList: function() { return /* reexport */ FilterList; },
  OrqFloatingAction: function() { return /* reexport */ FloatingAction; },
  OrqFloatingActionItem: function() { return /* reexport */ FloatingActionItem; },
  OrqIconContainer: function() { return /* reexport */ IconContainer; },
  OrqImageContainer: function() { return /* reexport */ ImageContainer; },
  OrqImageGroup: function() { return /* reexport */ ImageGroup; },
  OrqInput: function() { return /* reexport */ Input; },
  OrqInputTag: function() { return /* reexport */ InputTag; },
  OrqInputTextArea: function() { return /* reexport */ InputTextArea; },
  OrqLink: function() { return /* reexport */ Link; },
  OrqList: function() { return /* reexport */ List; },
  OrqLoader: function() { return /* reexport */ Loader; },
  OrqLockscreen: function() { return /* reexport */ Lockscreen; },
  OrqModal: function() { return /* reexport */ Modal; },
  OrqNotification: function() { return /* reexport */ Notification; },
  OrqNotificationFloater: function() { return /* reexport */ NotificationFloater; },
  OrqNotificationHub: function() { return /* reexport */ NotificationHub; },
  OrqNotificationInline: function() { return /* reexport */ NotificationInline; },
  OrqPagination: function() { return /* reexport */ Pagination; },
  OrqProgressBar: function() { return /* reexport */ ProgressBar; },
  OrqProgressIndicator: function() { return /* reexport */ ProgressIndicator; },
  OrqProgressRing: function() { return /* reexport */ ProgressRing; },
  OrqProgressTracker: function() { return /* reexport */ ProgressTracker; },
  OrqRadioButton: function() { return /* reexport */ RadioButton; },
  OrqSearch: function() { return /* reexport */ Search; },
  OrqSelect: function() { return /* reexport */ Select; },
  OrqSelectInline: function() { return /* reexport */ SelectInline; },
  OrqShimmer: function() { return /* reexport */ Shimmer; },
  OrqSwitcher: function() { return /* reexport */ Switcher; },
  OrqTab: function() { return /* reexport */ Tab; },
  OrqTabItem: function() { return /* reexport */ TabItem; },
  OrqTag: function() { return /* reexport */ Tag; },
  OrqTheme: function() { return /* reexport */ Theme; },
  OrqTooltip: function() { return /* reexport */ Tooltip; }
});

// NAMESPACE OBJECT: ./src/components/Shimmer/templates/index.ts
var templates_namespaceObject = {};
__webpack_require__.r(templates_namespaceObject);
__webpack_require__.d(templates_namespaceObject, {
  accordion: function() { return ShimmerAccordion; },
  avatar: function() { return ShimmerAvatar; },
  badge: function() { return ShimmerBadge; },
  banner: function() { return ShimmerBanner; },
  button: function() { return ShimmerButton; },
  buttonFoward: function() { return ShimmerButtonFoward; },
  checkbox: function() { return ShimmerCheckbox; },
  contentSwitcher: function() { return ShimmerContentSwitcher; },
  fileUploader: function() { return ShimmerFileUploader; },
  image: function() { return ShimmerImage; },
  imageGroup: function() { return ShimmerImageGroup; },
  input: function() { return ShimmerInput; },
  list: function() { return ShimmerList; },
  notification: function() { return ShimmerNotification; },
  progressBar: function() { return ShimmerProgressBar; },
  progressRing: function() { return ShimmerProgressRing; },
  progressTracker: function() { return ShimmerProgressTracker; },
  radioButton: function() { return ShimmerRadioButton; },
  select: function() { return ShimmerSelect; },
  selectInline: function() { return ShimmerSelectInline; },
  slider: function() { return ShimmerSlider; },
  switcher: function() { return ShimmerSwitcher; },
  tab: function() { return ShimmerTab; },
  tag: function() { return ShimmerTag; },
  text: function() { return ShimmerText; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Accordion/Accordion.vue?vue&type=template&id=cb33d720&ts=true

const _hoisted_1 = ["id"];
const _hoisted_2 = {
  class: "orq-accordion__header__title"
};
const _hoisted_3 = {
  class: "orq-accordion__title"
};
const _hoisted_4 = {
  style: {
    "float": "right"
  }
};
const _hoisted_5 = {
  class: "orq-accordion__header__icon"
};
const _hoisted_6 = {
  class: "orq-accordion__content"
};
const _hoisted_7 = {
  class: "orq-accordion__item__text"
};
const _hoisted_8 = {
  key: 0,
  class: "orq-accordion__badge"
};
const _hoisted_9 = {
  key: 1,
  class: "orq-accordion__button"
};
const _hoisted_10 = {
  class: "orq-accordion__item__content-projection orq-accordion__item"
};
const _hoisted_11 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
  class: "orq-accordion__line"
}, null, -1);
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("IconContainer");
  const _component_OrqBadge = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqBadge");
  const _component_OrqButton = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqButton");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.accordionClass)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
    class: "orq-accordion__radio",
    type: "checkbox",
    id: `identifiar-${_ctx.id}`,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onClick($event))
  }, null, 8, _hoisted_1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", {
    class: "orq-accordion__header",
    onClick: _cache[1] || (_cache[1] = $event => !_ctx.disabled ? _ctx.onOpen($event) : '')
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", _hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("small", _hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.subTitle), 1)])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_IconContainer, {
    name: "chevron-down",
    size: 24,
    color: _ctx.getIconColor
  }, null, 8, ["color"])])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_6, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.contentItems, (item, length) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [length + 1 <= _ctx.numberContentItems && length < 5 && _ctx.contentItems && !_ctx.disabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: length,
      class: "orq-accordion__item"
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", _hoisted_7, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.paragraph), 1), _ctx.type === 'badge' && _ctx.opened ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqBadge, {
      type: "system",
      label: item?.badge?.label,
      inverse: _ctx.inverse,
      size: "large",
      appearance: item.badge?.appearance
    }, null, 8, ["label", "inverse", "appearance"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'button' && _ctx.opened ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_9, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqButton, {
      appearance: "line",
      size: "compact",
      iconName: "",
      label: item.button?.label,
      inverse: _ctx.inverse,
      onClick: $event => _ctx.buttonClick(item.button)
    }, null, 8, ["label", "inverse", "onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
  }), 256)), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_10, [!_ctx.disabled ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {
    key: 0
  }) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])]), _hoisted_11], 2);
}
;// CONCATENATED MODULE: ./src/components/Accordion/Accordion.vue?vue&type=template&id=cb33d720&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/IconContainer/IconContainer.vue?vue&type=template&id=902547cc&ts=true

const IconContainervue_type_template_id_902547cc_ts_true_hoisted_1 = ["role"];
function IconContainervue_type_template_id_902547cc_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqBullet = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqBullet");
  const _component_OrqCounter = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqCounter");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.circleValidation() ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.containerClasses),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.containerStyle),
    role: _ctx.role,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onClick())
  }, [_ctx.circle ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("i", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.iconClasses),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.iconCircleStyle)
  }, null, 6)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'none' && !_ctx.circle ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("i", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.iconClasses),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.iconTypeNoneStyle)
  }, null, 6)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'counter' && !_ctx.circle ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 2
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.iconClasses),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.iconTypeCounterStyle)
  }, null, 6), _ctx.iconContainerSize <= 32 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqBullet, {
    key: 0,
    appearance: "info",
    inverse: _ctx.inverse,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.bulletDefaultStyle)
  }, null, 8, ["inverse", "style"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.iconContainerSize > 32 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqCounter, {
    key: 1,
    type: _ctx.counterCircleType,
    size: _ctx.counterDefaultSize,
    value: _ctx.value,
    inverse: _ctx.inverse,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.counterDefaultStyle)
  }, null, 8, ["type", "size", "value", "inverse", "style"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 14, IconContainervue_type_template_id_902547cc_ts_true_hoisted_1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'counter' && _ctx.circle && _ctx.iconContainerSize >= 24 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [_ctx.iconContainerSize <= 32 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqBullet, {
    key: 0,
    appearance: "info",
    inverse: _ctx.inverse,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.bulletCircleStyle)
  }, null, 8, ["inverse", "style"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.iconContainerSize > 32 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqCounter, {
    key: 1,
    type: _ctx.counterCircleType,
    size: _ctx.counterSmallSize,
    value: _ctx.value,
    inverse: _ctx.inverse,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.counterCircleStyle)
  }, null, 8, ["type", "size", "value", "inverse", "style"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'bullet' && _ctx.circle && _ctx.iconContainerSize >= 24 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqBullet, {
    key: 2,
    appearance: "info",
    inverse: _ctx.inverse,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.bulletTypeCircleStyle)
  }, null, 8, ["inverse", "style"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/IconContainer/IconContainer.vue?vue&type=template&id=902547cc&ts=true

;// CONCATENATED MODULE: ./src/components/IconContainer/models/iconContainer.enum.ts
var EiconContainerSize;
(function (EiconContainerSize) {
  EiconContainerSize[EiconContainerSize["dp16"] = 16] = "dp16";
  EiconContainerSize[EiconContainerSize["dp24"] = 24] = "dp24";
  EiconContainerSize[EiconContainerSize["dp32"] = 32] = "dp32";
  EiconContainerSize[EiconContainerSize["dp40"] = 40] = "dp40";
  EiconContainerSize[EiconContainerSize["dp48"] = 48] = "dp48";
  EiconContainerSize[EiconContainerSize["dp64"] = 64] = "dp64";
  EiconContainerSize[EiconContainerSize["dp72"] = 72] = "dp72";
  EiconContainerSize[EiconContainerSize["dp80"] = 80] = "dp80";
  EiconContainerSize[EiconContainerSize["dp96"] = 96] = "dp96";
  EiconContainerSize[EiconContainerSize["dp112"] = 112] = "dp112";
  EiconContainerSize[EiconContainerSize["dp128"] = 128] = "dp128";
})(EiconContainerSize || (EiconContainerSize = {}));
var EiconContainerColor;
(function (EiconContainerColor) {
  EiconContainerColor["emphasisBaseLow"] = "emphasis-base-low";
  EiconContainerColor["emphasisBaseMedium"] = "emphasis-base-medium";
  EiconContainerColor["emphasisBaseHigh"] = "emphasis-base-high";
  EiconContainerColor["emphasisBaseDisabled"] = "emphasis-base-disabled";
  EiconContainerColor["emphasisBaseInverseLow"] = "emphasis-base-low-inverse";
  EiconContainerColor["emphasisBaseInverseMedium"] = "emphasis-base-medium-inverse";
  EiconContainerColor["emphasisBaseInverseHigh"] = "emphasis-base-high-inverse";
  EiconContainerColor["emphasisBaseInverseDisabled"] = "emphasis-base-disabled-inverse";
  EiconContainerColor["emphasisBaseMedium70"] = "emphasis-base-medium-70";
  EiconContainerColor["primaryBase"] = "primary-base";
  EiconContainerColor["primaryBaseInverse"] = "primary-base-inverse";
  EiconContainerColor["statusError"] = "status-error";
  EiconContainerColor["statusErrorInverse"] = "status-error-inverse";
  EiconContainerColor["statusSuccess"] = "status-success";
  EiconContainerColor["statusSuccessInverse"] = "status-success-inverse";
  EiconContainerColor["statusInformative"] = "status-informative";
  EiconContainerColor["statusInformativeInverse"] = "status-informative-inverse";
  EiconContainerColor["statusWarning"] = "status-warning";
  EiconContainerColor["statusWarningInverse"] = "status-warning-inverse";
})(EiconContainerColor || (EiconContainerColor = {}));
var EiconContainerType;
(function (EiconContainerType) {
  EiconContainerType["counter"] = "counter";
  EiconContainerType["bullet"] = "bullet";
  EiconContainerType["none"] = "none";
})(EiconContainerType || (EiconContainerType = {}));
;// CONCATENATED MODULE: ./src/components/Counter/models/Counter.enum.ts
var ECounterType;
(function (ECounterType) {
  ECounterType["circle"] = "circle";
  ECounterType["pill"] = "pill";
})(ECounterType || (ECounterType = {}));
var ECounterSize;
(function (ECounterSize) {
  ECounterSize["small"] = "small";
  ECounterSize["large"] = "large";
})(ECounterSize || (ECounterSize = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Counter/Counter.vue?vue&type=template&id=09e11e70&ts=true

const Countervue_type_template_id_09e11e70_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-counter__value--small"
};
const Countervue_type_template_id_09e11e70_ts_true_hoisted_2 = {
  key: 1,
  class: "orq-counter__value--small"
};
const Countervue_type_template_id_09e11e70_ts_true_hoisted_3 = {
  key: 2,
  class: "orq-counter__value--large"
};
const Countervue_type_template_id_09e11e70_ts_true_hoisted_4 = {
  key: 3,
  class: "orq-counter__value--large"
};
function Countervue_type_template_id_09e11e70_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.counterClasses)
  }, [_ctx.value && _ctx.size === 'small' && _ctx.type === 'circle' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", Countervue_type_template_id_09e11e70_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.counterValueSmallCircle), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.value && _ctx.size === 'small' && _ctx.type === 'pill' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", Countervue_type_template_id_09e11e70_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.counterValueSmallPill), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.value && _ctx.size === 'large' && _ctx.type === 'circle' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", Countervue_type_template_id_09e11e70_ts_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.counterValueLargeCircle), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.value && _ctx.size === 'large' && _ctx.type === 'pill' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", Countervue_type_template_id_09e11e70_ts_true_hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.counterValueLargePill), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/Counter/Counter.vue?vue&type=template&id=09e11e70&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Counter/Counter.vue?vue&type=script&lang=ts

/* harmony default export */ var Countervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqCounter",
  props: {
    value: {
      type: Number,
      default: 0,
      required: true
    },
    size: {
      type: String,
      default: "large"
    },
    type: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      counterValueSmallCircle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === "small" && props.value >= 10 ? "9+" : props.value),
      counterValueSmallPill: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === "small" && props.value >= 999 ? "999+" : props.value),
      counterValueLargeCircle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === "large" && props.value >= 10 ? "9+" : props.value),
      counterValueLargePill: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === "large" && props.value >= 999 ? "999+" : props.value),
      counterClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-counter": true,
          "orq-counter--small orq-counter--small--circle": props.size === "small" && props.type === "circle",
          "orq-counter--small orq-counter--small--pill": props.size === "small" && props.type === "pill",
          "orq-counter--large orq-counter--large--circle": props.size === "large" && props.type === "circle",
          "orq-counter--large orq-counter--large--pill": props.size === "large" && props.type === "pill",
          "orq-counter--inverse": props.inverse
        };
      })
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Counter/Counter.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Counter/Counter.vue?vue&type=style&index=0&id=09e11e70&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Counter/Counter.vue?vue&type=style&index=0&id=09e11e70&lang=scss

// EXTERNAL MODULE: ./node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(2960);
;// CONCATENATED MODULE: ./src/components/Counter/Counter.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Countervue_type_script_lang_ts, [['render',Countervue_type_template_id_09e11e70_ts_true_render]])

/* harmony default export */ var Counter = (__exports__);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Bullet/Bullet.vue?vue&type=template&id=12dbfcde&ts=true

function Bulletvue_type_template_id_12dbfcde_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-bullet ${_ctx.appearanceClasses} ${_ctx.inverseClasses}`)
  }, null, 2);
}
;// CONCATENATED MODULE: ./src/components/Bullet/Bullet.vue?vue&type=template&id=12dbfcde&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Bullet/Bullet.vue?vue&type=script&lang=ts

/* harmony default export */ var Bulletvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "orq-bullet",
  props: {
    appearance: {
      type: String,
      default: "neutral"
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const appearanceClasses = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.appearance ? `orq-bullet--${props.appearance}` : "");
    const inverseClasses = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? `${appearanceClasses.value}--inverse` : "");
    return {
      appearanceClasses,
      inverseClasses
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Bullet/Bullet.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Bullet/Bullet.vue?vue&type=style&index=0&id=12dbfcde&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Bullet/Bullet.vue?vue&type=style&index=0&id=12dbfcde&lang=scss

;// CONCATENATED MODULE: ./src/components/Bullet/Bullet.vue




;


const Bullet_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Bulletvue_type_script_lang_ts, [['render',Bulletvue_type_template_id_12dbfcde_ts_true_render]])

/* harmony default export */ var Bullet = (Bullet_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/IconContainer/IconContainer.vue?vue&type=script&lang=ts





/* harmony default export */ var IconContainervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqIconContainer",
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 16
    },
    circle: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ""
    },
    role: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: "none"
    },
    customCircleBackgroundColor: {
      type: String,
      default: ""
    }
  },
  components: {
    OrqCounter: Counter,
    OrqBullet: Bullet
  },
  emits: ["click"],
  setup(props, {
    emit
  }) {
    let iconContainerSize = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.size);
    let counterDefaultSize = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(iconContainerSize.value > 80 ? "large" : "small");
    let counterSmallSize = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(ECounterSize.small);
    let counterCircleType = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(ECounterType.circle);
    const circleValidation = () => {
      if (props.circle && iconContainerSize.value >= 24 || !props.circle) {
        return true;
      }
    };
    const onClick = () => {
      emit("click");
    };
    return {
      containerClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        "icon-container": true,
        "icon-container__circle": props.circle,
        "icon-container__circle--inverse": props.circle && props.inverse,
        "icon-container__circle--inverse--outline": props.inverse && props.outline,
        "icon-container__circle--outline": props.circle && props.outline
      })),
      iconClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        "icon-container__icon": true,
        [`icon-${props.name}`]: props.name,
        [`icon-container__icon--${props.color}`]: props.color
      })),
      containerStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        width: props.circle ? `${iconContainerSize.value}px` : "",
        height: props.circle ? `${iconContainerSize.value}px` : "",
        backgroundColor: props.customCircleBackgroundColor
      })),
      iconCircleStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        fontSize: props.circle && iconContainerSize.value < EiconContainerSize.dp64 && iconContainerSize.value !== EiconContainerSize.dp48 ? `${iconContainerSize.value / 2 + 4}px` : props.circle && iconContainerSize.value === EiconContainerSize.dp48 ? `${iconContainerSize.value / 2 + 8}px` : props.circle && iconContainerSize.value === EiconContainerSize.dp72 ? `${iconContainerSize.value / 2 + 4}px` : props.circle && iconContainerSize.value > EiconContainerSize.dp64 && iconContainerSize.value !== EiconContainerSize.dp96 ? `${iconContainerSize.value / 2 + 8}px` : props.circle && iconContainerSize.value === EiconContainerSize.dp64 ? `${iconContainerSize.value - EiconContainerSize.dp24}px` : props.circle && iconContainerSize.value === EiconContainerSize.dp96 ? `${iconContainerSize.value - EiconContainerSize.dp32}px` : `${iconContainerSize.value}px`
      })),
      iconTypeNoneStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        fontSize: props.circle && iconContainerSize.value <= EiconContainerSize.dp64 ? `${iconContainerSize.value / 2}px` : props.circle && iconContainerSize.value > EiconContainerSize.dp64 ? `${iconContainerSize.value / 2 + 8}px` : `${iconContainerSize.value}px`
      })),
      iconTypeCounterStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        fontSize: props.circle && iconContainerSize.value <= EiconContainerSize.dp64 ? `${iconContainerSize.value / 2}px` : props.circle && iconContainerSize.value > EiconContainerSize.dp64 ? `${iconContainerSize.value / 2 + 8}px` : `${iconContainerSize.value}px`
      })),
      bulletDefaultStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        marginLeft: iconContainerSize.value === EiconContainerSize.dp16 ? "-8px" : iconContainerSize.value === EiconContainerSize.dp24 ? "-9px" : iconContainerSize.value >= EiconContainerSize.dp32 ? "-12px" : "",
        marginTop: iconContainerSize.value <= EiconContainerSize.dp24 ? "-1px" : iconContainerSize.value >= EiconContainerSize.dp32 ? "3px" : ""
      })),
      counterDefaultStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        marginLeft: iconContainerSize.value <= EiconContainerSize.dp40 ? "-17px" : iconContainerSize.value <= EiconContainerSize.dp48 ? "-17px" : iconContainerSize.value <= EiconContainerSize.dp64 ? "-21px" : iconContainerSize.value <= EiconContainerSize.dp72 ? "-22px" : iconContainerSize.value <= EiconContainerSize.dp80 ? "-24px" : iconContainerSize.value <= EiconContainerSize.dp96 ? "-30px" : iconContainerSize.value <= EiconContainerSize.dp112 ? "-36px" : iconContainerSize.value === EiconContainerSize.dp128 ? "-40px" : "",
        marginTop: iconContainerSize.value <= EiconContainerSize.dp40 ? "-1px" : iconContainerSize.value <= EiconContainerSize.dp48 ? "0px" : iconContainerSize.value <= EiconContainerSize.dp64 ? "3px" : iconContainerSize.value <= EiconContainerSize.dp72 ? "4px" : iconContainerSize.value <= EiconContainerSize.dp80 ? "7px" : iconContainerSize.value <= EiconContainerSize.dp96 ? "4px" : iconContainerSize.value <= EiconContainerSize.dp112 ? "8px" : iconContainerSize.value === EiconContainerSize.dp128 ? "11px" : ""
      })),
      bulletCircleStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        marginLeft: iconContainerSize.value <= EiconContainerSize.dp24 ? "-8px" : iconContainerSize.value <= EiconContainerSize.dp32 ? "-9px" : "",
        marginBottom: iconContainerSize.value === EiconContainerSize.dp16 ? "5px" : iconContainerSize.value <= EiconContainerSize.dp24 ? "12px" : "16px",
        zIndex: "99",
        position: "relative"
      })),
      counterCircleStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        zIndex: "99",
        position: "relative",
        marginTop: iconContainerSize.value === EiconContainerSize.dp40 ? "-42px" : iconContainerSize.value === EiconContainerSize.dp48 ? "-48px" : iconContainerSize.value === EiconContainerSize.dp64 ? "-64px" : iconContainerSize.value === EiconContainerSize.dp72 ? "-72px" : iconContainerSize.value === EiconContainerSize.dp80 ? "-78px" : iconContainerSize.value === EiconContainerSize.dp96 ? "-92px" : iconContainerSize.value === EiconContainerSize.dp112 ? "-104px" : iconContainerSize.value === EiconContainerSize.dp128 ? "-118px" : "",
        marginLeft: iconContainerSize.value <= EiconContainerSize.dp40 ? "24px" : iconContainerSize.value === EiconContainerSize.dp48 ? "32px" : iconContainerSize.value === EiconContainerSize.dp64 ? "48px" : iconContainerSize.value === EiconContainerSize.dp72 ? "52px" : iconContainerSize.value === EiconContainerSize.dp80 ? "56px" : iconContainerSize.value === EiconContainerSize.dp96 ? "70px" : iconContainerSize.value === EiconContainerSize.dp112 ? "86px" : iconContainerSize.value === EiconContainerSize.dp128 ? "98px" : ""
      })),
      bulletTypeCircleStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        marginLeft: iconContainerSize.value <= EiconContainerSize.dp24 ? "-8px" : iconContainerSize.value <= EiconContainerSize.dp32 ? "-9px" : iconContainerSize.value <= EiconContainerSize.dp40 ? "-10px" : iconContainerSize.value === EiconContainerSize.dp48 ? "-12px" : iconContainerSize.value === EiconContainerSize.dp64 ? "-14px" : iconContainerSize.value === EiconContainerSize.dp72 ? "-16px" : iconContainerSize.value === EiconContainerSize.dp80 ? "-17px" : iconContainerSize.value === EiconContainerSize.dp96 ? "-19px" : iconContainerSize.value === EiconContainerSize.dp112 ? "-21px" : iconContainerSize.value === EiconContainerSize.dp128 ? "-24px" : "",
        marginBottom: iconContainerSize.value === EiconContainerSize.dp16 ? "5px" : iconContainerSize.value <= EiconContainerSize.dp24 ? "12px" : iconContainerSize.value === EiconContainerSize.dp32 ? "17px" : iconContainerSize.value === EiconContainerSize.dp40 ? "21px" : iconContainerSize.value === EiconContainerSize.dp48 ? "28px" : iconContainerSize.value === EiconContainerSize.dp64 ? "37px" : iconContainerSize.value === EiconContainerSize.dp72 ? "40px" : iconContainerSize.value === EiconContainerSize.dp80 ? "46px" : iconContainerSize.value === EiconContainerSize.dp96 ? "59px" : iconContainerSize.value === EiconContainerSize.dp112 ? "64px" : iconContainerSize.value === EiconContainerSize.dp128 ? "74px" : "",
        zIndex: "99",
        position: "relative"
      })),
      onClick,
      circleValidation,
      counterDefaultSize,
      counterSmallSize,
      counterCircleType,
      iconContainerSize
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/IconContainer/IconContainer.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/IconContainer/IconContainer.vue?vue&type=style&index=0&id=902547cc&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/IconContainer/IconContainer.vue?vue&type=style&index=0&id=902547cc&lang=scss

;// CONCATENATED MODULE: ./src/components/IconContainer/IconContainer.vue




;


const IconContainer_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(IconContainervue_type_script_lang_ts, [['render',IconContainervue_type_template_id_902547cc_ts_true_render]])

/* harmony default export */ var IconContainer = (IconContainer_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Badge/Badge.vue?vue&type=template&id=025d6abf&ts=true

function Badgevue_type_template_id_025d6abf_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    type: "badge",
    loading: _ctx.loading,
    inverse: _ctx.inverse,
    size: _ctx.size
  }, null, 8, ["loading", "inverse", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    ref: "refBadge",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.badgeClasses)
  }, [_ctx.appearance !== 'default' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, [_ctx.appearance === 'positive' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    name: "status-success",
    type: "none",
    color: _ctx.setColorIcon(),
    size: _ctx.badgeDefaultSize
  }, null, 8, ["color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.appearance === 'warning' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 1,
    name: "status-warning",
    type: "none",
    color: _ctx.setColorIcon(),
    size: _ctx.badgeDefaultSize
  }, null, 8, ["color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.appearance === 'negative' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 2,
    name: "status-disapproved",
    type: "none",
    color: _ctx.setColorIcon(),
    size: _ctx.badgeDefaultSize
  }, null, 8, ["color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.appearance === 'info' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 3,
    name: "info",
    type: "none",
    color: _ctx.setColorIcon(),
    size: _ctx.badgeDefaultSize
  }, null, 8, ["color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    ref: "refSpan",
    class: "orq-badge__text"
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 513)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Badge/Badge.vue?vue&type=template&id=025d6abf&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/Shimmer.vue?vue&type=template&id=2e4977f6&ts=true

function Shimmervue_type_template_id_2e4977f6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDynamicComponent)(_ctx.shimmerComponent), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeProps)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.guardReactiveProps)(_ctx.$props)), null, 16);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/Shimmer.vue?vue&type=template&id=2e4977f6&ts=true

;// CONCATENATED MODULE: ./src/utils/functions/stringConvertion.ts
class StringConversion {
  toCamelCase(text, separator = "") {
    return text.includes(separator) ? text.split(separator).map((word, index) => index === 0 ? word : `${word[0].toUpperCase()}${word.slice(1)}`).join("") : text;
  }
}
const stringConvertion = new StringConversion();
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerAccordion.vue?vue&type=template&id=1fba9297&ts=true

const ShimmerAccordionvue_type_template_id_1fba9297_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerAccordionvue_type_template_id_1fba9297_ts_true_hoisted_2 = {
  "data-test": "orq-shimmer-accordion",
  class: "orq-shimmer__accordion"
};
const ShimmerAccordionvue_type_template_id_1fba9297_ts_true_hoisted_3 = {
  class: "orq-shimmer__accordion--loading"
};
function ShimmerAccordionvue_type_template_id_1fba9297_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerAccordionvue_type_template_id_1fba9297_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerAccordionvue_type_template_id_1fba9297_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerAccordionvue_type_template_id_1fba9297_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__accordion--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__accordion--loading--accordion ${_ctx.inverseClass}`)
  }, null, 2)])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerAccordion.vue?vue&type=template&id=1fba9297&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerAccordion.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerAccordionvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerAccordion",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__accordion--loading--inverse" : "orq-shimmer__accordion--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerAccordion.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerAccordion.vue?vue&type=style&index=0&id=1fba9297&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerAccordion.vue?vue&type=style&index=0&id=1fba9297&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerAccordion.vue




;


const ShimmerAccordion_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerAccordionvue_type_script_lang_ts, [['render',ShimmerAccordionvue_type_template_id_1fba9297_ts_true_render]])

/* harmony default export */ var ShimmerAccordion = (ShimmerAccordion_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerAvatar.vue?vue&type=template&id=45add851&ts=true

const ShimmerAvatarvue_type_template_id_45add851_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerAvatarvue_type_template_id_45add851_ts_true_hoisted_2 = {
  "data-test": "orq-shimmer-avatar",
  class: "orq-shimmer__avatar"
};
function ShimmerAvatarvue_type_template_id_45add851_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerAvatarvue_type_template_id_45add851_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerAvatarvue_type_template_id_45add851_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-shimmer__avatar--loading",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__avatar--loading-rounded orq-shimmer__avatar--loading--size-${_ctx.sizeAvatar} ${_ctx.inverseClass}`)
    }, null, 2)]);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerAvatar.vue?vue&type=template&id=45add851&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerAvatar.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerAvatarvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerAvatar",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    sizeAvatar: {
      type: String,
      default: "24"
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__avatar--loading--inverse" : "orq-shimmer__avatar--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerAvatar.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerAvatar.vue?vue&type=style&index=0&id=45add851&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerAvatar.vue?vue&type=style&index=0&id=45add851&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerAvatar.vue




;


const ShimmerAvatar_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerAvatarvue_type_script_lang_ts, [['render',ShimmerAvatarvue_type_template_id_45add851_ts_true_render]])

/* harmony default export */ var ShimmerAvatar = (ShimmerAvatar_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerBadge.vue?vue&type=template&id=ba716d44&ts=true

const ShimmerBadgevue_type_template_id_ba716d44_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerBadgevue_type_template_id_ba716d44_ts_true_hoisted_2 = {
  class: "orq-shimmer__badge"
};
const ShimmerBadgevue_type_template_id_ba716d44_ts_true_hoisted_3 = {
  class: "orq-shimmer__badge--loading"
};
function ShimmerBadgevue_type_template_id_ba716d44_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerBadgevue_type_template_id_ba716d44_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBadgevue_type_template_id_ba716d44_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBadgevue_type_template_id_ba716d44_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`badge--loading orq-shimmer__badge--loading--${_ctx.size} ${_ctx.inverseClass}`)
  }, null, 2)])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerBadge.vue?vue&type=template&id=ba716d44&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerBadge.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerBadgevue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerBadge",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__badge--loading--inverse" : "orq-shimmer__badge--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerBadge.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerBadge.vue?vue&type=style&index=0&id=ba716d44&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerBadge.vue?vue&type=style&index=0&id=ba716d44&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerBadge.vue




;


const ShimmerBadge_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerBadgevue_type_script_lang_ts, [['render',ShimmerBadgevue_type_template_id_ba716d44_ts_true_render]])

/* harmony default export */ var ShimmerBadge = (ShimmerBadge_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerBanner.vue?vue&type=template&id=0baa4e70&ts=true

const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_2 = {
  class: "orq-shimmer__banner"
};
const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_3 = {
  class: "orq-shimmer__banner--loading--container-xsmall"
};
const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_4 = {
  class: "orq-shimmer__banner--loading--box"
};
const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_5 = {
  class: "orq-shimmer__banner--loading--container-xsmall"
};
const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_6 = {
  class: "orq-shimmer__banner--loading--box"
};
const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_7 = {
  class: "orq-shimmer__banner--loading--container-small"
};
const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_8 = {
  class: "orq-shimmer__banner--loading--box"
};
const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_9 = {
  class: "orq-shimmer__banner--loading--content-box"
};
const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_10 = {
  key: 1,
  class: /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`banner--loading orq-shimmer__banner--loading--small--rounded`)
};
const ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_11 = {
  class: "orq-shimmer__banner--loading--image-box"
};
const _hoisted_12 = {
  class: "orq-shimmer__banner--loading--container-small"
};
const _hoisted_13 = {
  class: "orq-shimmer__banner--loading--box"
};
const _hoisted_14 = {
  class: "orq-shimmer__banner--loading--content-box"
};
const _hoisted_15 = {
  class: "orq-shimmer__banner--loading--container-medium"
};
const _hoisted_16 = {
  class: "orq-shimmer__banner--loading--box"
};
const _hoisted_17 = {
  class: "orq-shimmer__banner--loading--content-box"
};
const _hoisted_18 = {
  key: 1,
  class: /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`banner--loading orq-shimmer__banner--loading--medium--rounded`)
};
const _hoisted_19 = {
  class: "orq-shimmer__banner--loading--image-box"
};
const _hoisted_20 = {
  class: "orq-shimmer__banner--loading--container-medium"
};
const _hoisted_21 = {
  class: "orq-shimmer__banner--loading--box"
};
const _hoisted_22 = {
  class: "orq-shimmer__banner--loading--content-box"
};
const _hoisted_23 = {
  class: "orq-shimmer__banner--loading--container-large"
};
const _hoisted_24 = {
  class: "orq-shimmer__banner--loading--box"
};
const _hoisted_25 = {
  class: "orq-shimmer__banner--loading--content-box"
};
const _hoisted_26 = {
  class: "orq-shimmer__banner--loading--container-large"
};
const _hoisted_27 = {
  class: "orq-shimmer__banner--loading--box"
};
const _hoisted_28 = {
  class: "orq-shimmer__banner--loading--content-box"
};
const _hoisted_29 = {
  class: "orq-shimmer__banner--loading--container-wide"
};
const _hoisted_30 = {
  class: "orq-shimmer__banner--loading--box"
};
const _hoisted_31 = {
  class: "orq-shimmer__banner--loading--content-box"
};
const _hoisted_32 = {
  class: "orq-shimmer__banner--loading--image-box"
};
const _hoisted_33 = {
  class: "orq-shimmer__banner--loading--container-wide"
};
const _hoisted_34 = {
  class: "orq-shimmer__banner--loading--box"
};
const _hoisted_35 = {
  class: "orq-shimmer__banner--loading--content-box"
};
function ShimmerBannervue_type_template_id_0baa4e70_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_2, [_ctx.sizeBanner === 'xsmall' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, [_ctx.defaultOrLargeSize ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`banner--loading orq-shimmer__banner--loading--xsmall--default ${_ctx.defaultAndRoundedSizeBannerImage}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--image ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--card ${_ctx.inverseClass}`)
  }, null, 2)])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.sizeBannerImage === 'rounded' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`banner--loading orq-shimmer__banner--loading--xsmall--rounded ${_ctx.defaultAndRoundedSizeBannerImage}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--image ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--card ${_ctx.inverseClass}`)
  }, null, 2)])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.sizeBanner === 'small' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [_ctx.defaultOrLargeSize ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`banner--loading orq-shimmer__banner--loading--small--default ${_ctx.defaultAndRoundedSizeBannerImage}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--image ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_7, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--subtext ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--card ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--divider ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_9, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--content ${_ctx.inverseClass}`)
  }, null, 2)])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.sizeBannerImage === 'rounded' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_10, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerBannervue_type_template_id_0baa4e70_ts_true_hoisted_11, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--image ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_12, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_13, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--subtext ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--card ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--divider ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_14, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--content ${_ctx.inverseClass}`)
  }, null, 2)])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.sizeBanner === 'medium' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 2
  }, [_ctx.defaultOrLargeSize ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`banner--loading orq-shimmer__banner--loading--medium--default ${_ctx.defaultAndRoundedSizeBannerImage}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--image ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_15, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_16, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--subtext ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--card ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--divider ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_17, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--content ${_ctx.inverseClass}`)
  }, null, 2)])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.sizeBannerImage === 'rounded' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_18, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_19, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--image ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_20, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_21, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--subtext ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--card ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--divider ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_22, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--content ${_ctx.inverseClass}`)
  }, null, 2)])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.sizeBanner === 'large' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 3
  }, [_ctx.defaultOrLargeSize ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`banner--loading orq-shimmer__banner--loading--large--default ${_ctx.defaultAndRoundedSizeBannerImage} ${_ctx.imageAlignRightClass}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--image ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_23, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_24, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--subtext ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--card ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--divider ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_25, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--content ${_ctx.inverseClass}`)
  }, null, 2)])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.sizeBannerImage === 'rounded' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`banner--loading orq-shimmer__banner--loading--large--rounded ${_ctx.imageAlignRightClass}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--image ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_26, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_27, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--subtext ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--card ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--divider ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_28, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--content ${_ctx.inverseClass}`)
  }, null, 2)])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.sizeBanner === 'wide' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 4
  }, [_ctx.defaultOrLargeSize ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`banner--loading orq-shimmer__banner--loading--wide--default ${_ctx.defaultAndRoundedSizeBannerImage} ${_ctx.imageAlignRightClass}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--image ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_29, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_30, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--subtext ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--card ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--divider ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_31, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--content ${_ctx.inverseClass}`)
  }, null, 2)])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.sizeBannerImage === 'rounded' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`banner--loading orq-shimmer__banner--loading--wide--rounded ${_ctx.imageAlignRightClass}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_32, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--image ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_33, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_34, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--text ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--subtext ${_ctx.inverseClass}`)
  }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--card ${_ctx.inverseClass}`)
  }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_35, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__banner--loading--content ${_ctx.inverseClass}`)
  }, null, 2)])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerBanner.vue?vue&type=template&id=0baa4e70&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerBanner.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerBannervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerBanner",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    sizeBanner: {
      type: String,
      default: "large"
    },
    sizeBannerImage: {
      type: String,
      default: "default"
    },
    imageAlignRight: {
      type: String,
      default: "left"
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    const defaultOrLargeSize = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.sizeBannerImage === "default" || props.sizeBannerImage === "large");
    const getDefaultAndLargeSize = () => {
      if (props.sizeBannerImage === "default" || props.sizeBannerImage === "large") {
        return "default";
      } else if (props.sizeBannerImage === "rounded") {
        return "rounded";
      }
      return "";
    };
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__banner--loading--inverse" : "orq-shimmer__banner--loading--default"),
      imageAlignRightClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.imageAlignRight === "right" ? `orq-shimmer__banner--loading--${props.sizeBanner}--${props.sizeBannerImage}--right` : `orq-shimmer__banner--loading--${props.sizeBanner}--${props.sizeBannerImage}--left`),
      defaultAndRoundedSizeBannerImage: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.imageAlignRight === "right" ? `orq-shimmer__banner--loading--${props.sizeBanner}--${getDefaultAndLargeSize()}--right` : `orq-shimmer__banner--loading--${props.sizeBanner}--${getDefaultAndLargeSize()}--left`),
      getDefaultAndLargeSize,
      defaultOrLargeSize
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerBanner.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerBanner.vue?vue&type=style&index=0&id=0baa4e70&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerBanner.vue?vue&type=style&index=0&id=0baa4e70&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerBanner.vue




;


const ShimmerBanner_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerBannervue_type_script_lang_ts, [['render',ShimmerBannervue_type_template_id_0baa4e70_ts_true_render]])

/* harmony default export */ var ShimmerBanner = (ShimmerBanner_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSwitcher.vue?vue&type=template&id=71db5d12&ts=true

const ShimmerSwitchervue_type_template_id_71db5d12_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerSwitchervue_type_template_id_71db5d12_ts_true_hoisted_2 = {
  class: "orq-shimmer__switcher"
};
const ShimmerSwitchervue_type_template_id_71db5d12_ts_true_hoisted_3 = {
  class: "orq-shimmer__switcher--loading"
};
function ShimmerSwitchervue_type_template_id_71db5d12_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerSwitchervue_type_template_id_71db5d12_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerSwitchervue_type_template_id_71db5d12_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerSwitchervue_type_template_id_71db5d12_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`switcher--loading orq-shimmer__switcher--loading--${_ctx.size} ${_ctx.inverseClass}`)
  }, null, 2)])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSwitcher.vue?vue&type=template&id=71db5d12&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSwitcher.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerSwitchervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerSwitcher",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__switcher--loading--inverse" : "orq-shimmer__switcher--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSwitcher.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSwitcher.vue?vue&type=style&index=0&id=71db5d12&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSwitcher.vue?vue&type=style&index=0&id=71db5d12&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSwitcher.vue




;


const ShimmerSwitcher_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerSwitchervue_type_script_lang_ts, [['render',ShimmerSwitchervue_type_template_id_71db5d12_ts_true_render]])

/* harmony default export */ var ShimmerSwitcher = (ShimmerSwitcher_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerButton.vue?vue&type=template&id=c19138dc&ts=true

const ShimmerButtonvue_type_template_id_c19138dc_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerButtonvue_type_template_id_c19138dc_ts_true_hoisted_2 = {
  class: "orq-shimmer__button"
};
const ShimmerButtonvue_type_template_id_c19138dc_ts_true_hoisted_3 = {
  class: "orq-shimmer__button--loading"
};
function ShimmerButtonvue_type_template_id_c19138dc_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerButtonvue_type_template_id_c19138dc_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerButtonvue_type_template_id_c19138dc_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerButtonvue_type_template_id_c19138dc_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`button--loading orq-shimmer__button--loading--${_ctx.size} ${_ctx.inverseClass}`)
  }, null, 2)])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerButton.vue?vue&type=template&id=c19138dc&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerButton.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerButtonvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerButton",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__button--loading--inverse" : "orq-shimmer__button--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerButton.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerButton.vue?vue&type=style&index=0&id=c19138dc&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerButton.vue?vue&type=style&index=0&id=c19138dc&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerButton.vue




;


const ShimmerButton_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerButtonvue_type_script_lang_ts, [['render',ShimmerButtonvue_type_template_id_c19138dc_ts_true_render]])

/* harmony default export */ var ShimmerButton = (ShimmerButton_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerImageGroup.vue?vue&type=template&id=75ddfcf6&ts=true

const ShimmerImageGroupvue_type_template_id_75ddfcf6_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerImageGroupvue_type_template_id_75ddfcf6_ts_true_hoisted_2 = {
  class: "orq-shimmer__image-group"
};
const ShimmerImageGroupvue_type_template_id_75ddfcf6_ts_true_hoisted_3 = {
  class: "orq-shimmer__image-group--loading"
};
function ShimmerImageGroupvue_type_template_id_75ddfcf6_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerImageGroupvue_type_template_id_75ddfcf6_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerImageGroupvue_type_template_id_75ddfcf6_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerImageGroupvue_type_template_id_75ddfcf6_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__image-group--loading-radius orq-shimmer__image-group--loading-main orq-shimmer__image-group--loading-main--${_ctx.size} ${_ctx.inverseClass}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__image-group--loading-radius orq-shimmer__image-group--loading-minor orq-shimmer__image-group--loading-minor--${_ctx.size} ${_ctx.inverseClass}`)
  }, null, 2)], 2)])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerImageGroup.vue?vue&type=template&id=75ddfcf6&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerImageGroup.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerImageGroupvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerImageGroup",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "small"
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__image-group--loading--inverse" : "orq-shimmer__image-group--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerImageGroup.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerImageGroup.vue?vue&type=style&index=0&id=75ddfcf6&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerImageGroup.vue?vue&type=style&index=0&id=75ddfcf6&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerImageGroup.vue




;


const ShimmerImageGroup_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerImageGroupvue_type_script_lang_ts, [['render',ShimmerImageGroupvue_type_template_id_75ddfcf6_ts_true_render]])

/* harmony default export */ var ShimmerImageGroup = (ShimmerImageGroup_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerTag.vue?vue&type=template&id=1b1e4e5a&ts=true

const ShimmerTagvue_type_template_id_1b1e4e5a_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerTagvue_type_template_id_1b1e4e5a_ts_true_hoisted_2 = {
  class: "orq-shimmer__tag"
};
const ShimmerTagvue_type_template_id_1b1e4e5a_ts_true_hoisted_3 = {
  class: "orq-shimmer__tag--loading"
};
function ShimmerTagvue_type_template_id_1b1e4e5a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerTagvue_type_template_id_1b1e4e5a_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerTagvue_type_template_id_1b1e4e5a_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerTagvue_type_template_id_1b1e4e5a_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`tag--loading orq-shimmer__tag--loading--${_ctx.typeTag} ${_ctx.inverseClass}`)
  }, null, 2)])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerTag.vue?vue&type=template&id=1b1e4e5a&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerTag.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerTagvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerTag",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    typeTag: {
      type: String,
      default: "search"
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__tag--loading--inverse" : "orq-shimmer__tag--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerTag.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerTag.vue?vue&type=style&index=0&id=1b1e4e5a&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerTag.vue?vue&type=style&index=0&id=1b1e4e5a&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerTag.vue




;


const ShimmerTag_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerTagvue_type_script_lang_ts, [['render',ShimmerTagvue_type_template_id_1b1e4e5a_ts_true_render]])

/* harmony default export */ var ShimmerTag = (ShimmerTag_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerCheckbox.vue?vue&type=template&id=54bdbfd4&ts=true

const ShimmerCheckboxvue_type_template_id_54bdbfd4_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerCheckboxvue_type_template_id_54bdbfd4_ts_true_hoisted_2 = {
  class: "orq-shimmer__checkbox"
};
function ShimmerCheckboxvue_type_template_id_54bdbfd4_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerCheckboxvue_type_template_id_54bdbfd4_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerCheckboxvue_type_template_id_54bdbfd4_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__checkbox--loading ${_ctx.checkboxPositionClass}`)
  }, [_ctx.checkboxLabel === true ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__checkbox--loading--text ${_ctx.inverseClass}`)
  }, null, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.checkboxLabelClass} ${_ctx.inverseClass}`)
  }, null, 2)], 2)])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerCheckbox.vue?vue&type=template&id=54bdbfd4&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerCheckbox.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerCheckboxvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerCheckbox",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    checkboxPosition: {
      type: String,
      default: "left"
    },
    checkboxLabel: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__checkbox--loading--inverse" : "orq-shimmer__checkbox--loading--default"),
      checkboxPositionClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.checkboxPosition === "left" && props.checkboxLabel ? "orq-shimmer__checkbox--loading-check--inverse" : ""),
      checkboxLabelClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.checkboxLabel && props.checkboxPosition ? "orq-shimmer__checkbox--loading--checkbox" : "orq-shimmer__checkbox--loading--checkbox-minor")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerCheckbox.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerCheckbox.vue?vue&type=style&index=0&id=54bdbfd4&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerCheckbox.vue?vue&type=style&index=0&id=54bdbfd4&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerCheckbox.vue




;


const ShimmerCheckbox_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerCheckboxvue_type_script_lang_ts, [['render',ShimmerCheckboxvue_type_template_id_54bdbfd4_ts_true_render]])

/* harmony default export */ var ShimmerCheckbox = (ShimmerCheckbox_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerContentSwitcher.vue?vue&type=template&id=0e779bd2&ts=true

const ShimmerContentSwitchervue_type_template_id_0e779bd2_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerContentSwitchervue_type_template_id_0e779bd2_ts_true_hoisted_2 = {
  class: "orq-shimmer__content-switcher"
};
const ShimmerContentSwitchervue_type_template_id_0e779bd2_ts_true_hoisted_3 = {
  class: "orq-shimmer__content-switcher--loading"
};
function ShimmerContentSwitchervue_type_template_id_0e779bd2_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerContentSwitchervue_type_template_id_0e779bd2_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerContentSwitchervue_type_template_id_0e779bd2_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerContentSwitchervue_type_template_id_0e779bd2_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`content-switcher--loading ${_ctx.inverseClass}`)
  }, null, 2)])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerContentSwitcher.vue?vue&type=template&id=0e779bd2&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerContentSwitcher.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerContentSwitchervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerContentSwitcher",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__content-switcher--loading--inverse" : "orq-shimmer__content-switcher--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerContentSwitcher.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerContentSwitcher.vue?vue&type=style&index=0&id=0e779bd2&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerContentSwitcher.vue?vue&type=style&index=0&id=0e779bd2&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerContentSwitcher.vue




;


const ShimmerContentSwitcher_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerContentSwitchervue_type_script_lang_ts, [['render',ShimmerContentSwitchervue_type_template_id_0e779bd2_ts_true_render]])

/* harmony default export */ var ShimmerContentSwitcher = (ShimmerContentSwitcher_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerTab.vue?vue&type=template&id=40639dc4&ts=true

const ShimmerTabvue_type_template_id_40639dc4_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerTabvue_type_template_id_40639dc4_ts_true_hoisted_2 = {
  class: "orq-shimmer__tab"
};
const ShimmerTabvue_type_template_id_40639dc4_ts_true_hoisted_3 = {
  class: "orq-shimmer__tab--loading-content"
};
function ShimmerTabvue_type_template_id_40639dc4_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerTabvue_type_template_id_40639dc4_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerTabvue_type_template_id_40639dc4_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-shimmer__tab--loading-container",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerTabvue_type_template_id_40639dc4_ts_true_hoisted_3, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.tabItems), (item, index) => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__progress-bar-loading-status orq-shimmer__tab--loading-content--${_ctx.tabDirection} ${_ctx.inverseClass}`),
        key: index
      }, null, 2);
    }), 128))]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__tab--loading-progress ${_ctx.inverseClass}`)
    }, null, 2)]);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerTab.vue?vue&type=template&id=40639dc4&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerTab.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerTabvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerTab",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    tabItems: {
      type: Number,
      default: 1
    },
    tabDirection: {
      type: String,
      default: "horizontal"
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__tab--loading--inverse" : "orq-shimmer__tab--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerTab.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerTab.vue?vue&type=style&index=0&id=40639dc4&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerTab.vue?vue&type=style&index=0&id=40639dc4&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerTab.vue




;


const ShimmerTab_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerTabvue_type_script_lang_ts, [['render',ShimmerTabvue_type_template_id_40639dc4_ts_true_render]])

/* harmony default export */ var ShimmerTab = (ShimmerTab_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerProgressBar.vue?vue&type=template&id=29f85fb9&ts=true

const ShimmerProgressBarvue_type_template_id_29f85fb9_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerProgressBarvue_type_template_id_29f85fb9_ts_true_hoisted_2 = {
  class: "orq-shimmer__progress-bar"
};
function ShimmerProgressBarvue_type_template_id_29f85fb9_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerProgressBarvue_type_template_id_29f85fb9_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerProgressBarvue_type_template_id_29f85fb9_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-shimmer__progress-bar--loading",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__progress-bar--loading-content ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__progress-bar--loading-status ${_ctx.inverseClass}`)
    }, null, 2)]);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressBar.vue?vue&type=template&id=29f85fb9&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerProgressBar.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerProgressBarvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerProgressBar",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__progress-bar--loading--inverse" : "orq-shimmer__progress-bar--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressBar.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerProgressBar.vue?vue&type=style&index=0&id=29f85fb9&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressBar.vue?vue&type=style&index=0&id=29f85fb9&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressBar.vue




;


const ShimmerProgressBar_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerProgressBarvue_type_script_lang_ts, [['render',ShimmerProgressBarvue_type_template_id_29f85fb9_ts_true_render]])

/* harmony default export */ var ShimmerProgressBar = (ShimmerProgressBar_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerProgressRing.vue?vue&type=template&id=303ff974&ts=true

const ShimmerProgressRingvue_type_template_id_303ff974_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerProgressRingvue_type_template_id_303ff974_ts_true_hoisted_2 = {
  class: "orq-shimmer__progress-ring"
};
function ShimmerProgressRingvue_type_template_id_303ff974_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerProgressRingvue_type_template_id_303ff974_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerProgressRingvue_type_template_id_303ff974_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-shimmer__progress-ring--loading",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__progress-ring--loading-track orq-shimmer__progress-ring--loading-track__${_ctx.typeRing} ${_ctx.loadingTrackSizeClass} ${_ctx.inverseClass}`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__progress-ring--loading-content orq-shimmer__progress-ring--loading-content__${_ctx.typeRing} ${_ctx.loadingContentSizeClass} ${_ctx.inverseContentClass}`)
    }, null, 2)], 2)]);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressRing.vue?vue&type=template&id=303ff974&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerProgressRing.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerProgressRingvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerProgressRing",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    typeRing: {
      type: String,
      default: "image"
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ?  true && "orq-shimmer__progress-ring--loading--inverse" : "orq-shimmer__progress-ring--loading--default"),
      inverseContentClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__progress-ring--loading-content--inverse" : "orq-shimmer__progress-ring--loading-content--default"),
      loadingTrackSizeClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === "large" ? `orq-shimmer__progress-ring--loading-track__${props.typeRing}--${props.size}` : ""),
      loadingContentSizeClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === "large" ? `orq-shimmer__progress-ring--loading-content__${props.typeRing}--${props.size}` : "")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressRing.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerProgressRing.vue?vue&type=style&index=0&id=303ff974&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressRing.vue?vue&type=style&index=0&id=303ff974&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressRing.vue




;


const ShimmerProgressRing_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerProgressRingvue_type_script_lang_ts, [['render',ShimmerProgressRingvue_type_template_id_303ff974_ts_true_render]])

/* harmony default export */ var ShimmerProgressRing = (ShimmerProgressRing_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerProgressTracker.vue?vue&type=template&id=ee405926&ts=true

const ShimmerProgressTrackervue_type_template_id_ee405926_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerProgressTrackervue_type_template_id_ee405926_ts_true_hoisted_2 = {
  class: "orq-shimmer__progress-tracker"
};
const ShimmerProgressTrackervue_type_template_id_ee405926_ts_true_hoisted_3 = {
  class: "orq-shimmer__progress-tracker--loading-content"
};
function ShimmerProgressTrackervue_type_template_id_ee405926_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerProgressTrackervue_type_template_id_ee405926_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerProgressTrackervue_type_template_id_ee405926_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-shimmer__progress-tracker--loading",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__progress-tracker--loading-bar ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerProgressTrackervue_type_template_id_ee405926_ts_true_hoisted_3, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(3).fill(null), (item, index) => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__progress-tracker--loading-status ${_ctx.inverseClass}`),
        key: index
      }, null, 2);
    }), 128))])]);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressTracker.vue?vue&type=template&id=ee405926&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerProgressTracker.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerProgressTrackervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerProgressTracker",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__progress-tracker--loading--inverse" : "orq-shimmer__progress-tracker--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressTracker.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerProgressTracker.vue?vue&type=style&index=0&id=ee405926&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressTracker.vue?vue&type=style&index=0&id=ee405926&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerProgressTracker.vue




;


const ShimmerProgressTracker_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerProgressTrackervue_type_script_lang_ts, [['render',ShimmerProgressTrackervue_type_template_id_ee405926_ts_true_render]])

/* harmony default export */ var ShimmerProgressTracker = (ShimmerProgressTracker_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerRadioButton.vue?vue&type=template&id=33585c4a&ts=true

const ShimmerRadioButtonvue_type_template_id_33585c4a_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerRadioButtonvue_type_template_id_33585c4a_ts_true_hoisted_2 = {
  class: "orq-shimmer__radio-button"
};
function ShimmerRadioButtonvue_type_template_id_33585c4a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerRadioButtonvue_type_template_id_33585c4a_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerRadioButtonvue_type_template_id_33585c4a_ts_true_hoisted_2, [_ctx.typeRadioButton === 'label' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), index => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.positionInverseClass),
      key: index
    }, [_ctx.typeRadioButton === 'label' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__radio-button--loading--radio-button ${_ctx.inverseClass}`)
    }, null, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.typeRadioButton === 'label' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__radio-button--loading--label ${_ctx.inverseClass}`)
    }, null, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
  }), 128)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.typeRadioButton === 'card' || _ctx.typeRadioButton === 'box' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.positionInverseClass)
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), index => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__radio-button--loading--${_ctx.typeRadioButton} ${_ctx.inverseClass}`),
      key: index
    }, null, 2);
  }), 128))], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerRadioButton.vue?vue&type=template&id=33585c4a&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerRadioButton.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerRadioButtonvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerRadioButton",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    radioButtonPosition: {
      type: String,
      default: "left"
    },
    typeRadioButton: {
      type: String,
      default: "label"
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__radio-button--loading--inverse" : "orq-shimmer__radio-button--loading--default"),
      positionInverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-shimmer__radio-button--loading": true,
          "orq-shimmer__radio-button--loading-radio--inverse": props.radioButtonPosition === "left" && props.typeRadioButton === "label"
        };
      })
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerRadioButton.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerRadioButton.vue?vue&type=style&index=0&id=33585c4a&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerRadioButton.vue?vue&type=style&index=0&id=33585c4a&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerRadioButton.vue




;


const ShimmerRadioButton_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerRadioButtonvue_type_script_lang_ts, [['render',ShimmerRadioButtonvue_type_template_id_33585c4a_ts_true_render]])

/* harmony default export */ var ShimmerRadioButton = (ShimmerRadioButton_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSelectInline.vue?vue&type=template&id=b8d67f5c&ts=true

const ShimmerSelectInlinevue_type_template_id_b8d67f5c_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerSelectInlinevue_type_template_id_b8d67f5c_ts_true_hoisted_2 = {
  class: "orq-shimmer__select-inline"
};
function ShimmerSelectInlinevue_type_template_id_b8d67f5c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerSelectInlinevue_type_template_id_b8d67f5c_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerSelectInlinevue_type_template_id_b8d67f5c_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), index => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-shimmer__select-inline--loading",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectInlineTextInverseClass)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectInlineInverseClass)
    }, null, 2)]);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSelectInline.vue?vue&type=template&id=b8d67f5c&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSelectInline.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerSelectInlinevue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerSelectInline",
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      selectInlineInverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-shimmer__select-inline--loading--accordion": true,
          "orq-shimmer__select-inline--loading--inverse": props.inverse,
          "orq-shimmer__select-inline--loading--default": true
        };
      }),
      selectInlineTextInverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-shimmer__select-inline--loading--text": true,
          "orq-shimmer__select-inline--loading--inverse": props.inverse,
          "orq-shimmer__select-inline--loading--default": true
        };
      })
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSelectInline.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSelectInline.vue?vue&type=style&index=0&id=b8d67f5c&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSelectInline.vue?vue&type=style&index=0&id=b8d67f5c&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSelectInline.vue




;


const ShimmerSelectInline_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerSelectInlinevue_type_script_lang_ts, [['render',ShimmerSelectInlinevue_type_template_id_b8d67f5c_ts_true_render]])

/* harmony default export */ var ShimmerSelectInline = (ShimmerSelectInline_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSelect.vue?vue&type=template&id=425d10d5&ts=true

const ShimmerSelectvue_type_template_id_425d10d5_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
function ShimmerSelectvue_type_template_id_425d10d5_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerSelectvue_type_template_id_425d10d5_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__select${_ctx.selectTypeClass}`)
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), index => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: index,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__select${_ctx.selectTypeClass}--loading`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__select${_ctx.selectTypeClass}--loading--title ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__select${_ctx.selectTypeClass}--loading-container`)
    }, [_ctx.typeSelect === 'default' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: 0
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__select--loading--icon${_ctx.sizeIcon} ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__select--loading--description ${_ctx.sizeClass} ${_ctx.inverseClass}`)
    }, null, 2)], 64)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: 1
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__select-two-lines--loading--image ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__select-two-lines--loading--description ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__select-two-lines--loading--icon ${_ctx.inverseClass}`)
    }, null, 2)], 64))], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__select${_ctx.selectTypeClass}--loading--text ${_ctx.inverseClass}`)
    }, null, 2)], 2);
  }), 128))], 2)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 64);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSelect.vue?vue&type=template&id=425d10d5&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSelect.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerSelectvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerSelect",
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "small"
    },
    typeSelect: {
      type: String,
      default: "default"
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    const inverseClass = props.inverse ? "orq-shimmer__select--loading--inverse" : "orq-shimmer__select--loading--default";
    const selectTypeClass = props.typeSelect === "two-lines" ? "-two-lines" : "";
    const sizeClass = props.size === "small" ? "orq-shimmer__select--loading--small" : "";
    const sizeIcon = props.size === "small" ? "-small" : "";
    return {
      inverseClass,
      selectTypeClass,
      sizeClass,
      sizeIcon
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSelect.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSelect.vue?vue&type=style&index=0&id=425d10d5&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSelect.vue?vue&type=style&index=0&id=425d10d5&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSelect.vue




;


const ShimmerSelect_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerSelectvue_type_script_lang_ts, [['render',ShimmerSelectvue_type_template_id_425d10d5_ts_true_render]])

/* harmony default export */ var ShimmerSelect = (ShimmerSelect_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSlider.vue?vue&type=template&id=3089c810&ts=true

const ShimmerSlidervue_type_template_id_3089c810_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerSlidervue_type_template_id_3089c810_ts_true_hoisted_2 = {
  class: "orq-shimmer__slider"
};
const ShimmerSlidervue_type_template_id_3089c810_ts_true_hoisted_3 = {
  class: "orq-shimmer__slider--loading--paragraph"
};
const ShimmerSlidervue_type_template_id_3089c810_ts_true_hoisted_4 = {
  class: "orq-shimmer__slider--loading--caption"
};
function ShimmerSlidervue_type_template_id_3089c810_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerSlidervue_type_template_id_3089c810_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerSlidervue_type_template_id_3089c810_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-shimmer__slider--loading",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerSlidervue_type_template_id_3089c810_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__slider--loading--title ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__slider--loading--value ${_ctx.inverseClass}`)
    }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__slider--loading--slider ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerSlidervue_type_template_id_3089c810_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__slider--loading--title ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__slider--loading--value orq-shimmer__slider--loading--caption-value ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__slider--loading--caption-left ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__slider--loading--caption-right ${_ctx.inverseClass}`)
    }, null, 2)])]);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSlider.vue?vue&type=template&id=3089c810&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSlider.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerSlidervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerSlider",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__slider--loading--inverse" : "orq-shimmer__slider--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSlider.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerSlider.vue?vue&type=style&index=0&id=3089c810&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSlider.vue?vue&type=style&index=0&id=3089c810&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerSlider.vue




;


const ShimmerSlider_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerSlidervue_type_script_lang_ts, [['render',ShimmerSlidervue_type_template_id_3089c810_ts_true_render]])

/* harmony default export */ var ShimmerSlider = (ShimmerSlider_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerInput.vue?vue&type=template&id=52861a2b&ts=true

const ShimmerInputvue_type_template_id_52861a2b_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerInputvue_type_template_id_52861a2b_ts_true_hoisted_2 = {
  class: "orq-shimmer__input"
};
function ShimmerInputvue_type_template_id_52861a2b_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerInputvue_type_template_id_52861a2b_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerInputvue_type_template_id_52861a2b_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-shimmer__input--loading",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__input--loading--title orq-shimmer__input--loading--title--${_ctx.size} ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__input--loading--input orq-shimmer__input--loading--input--${_ctx.size} ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__input--loading--text orq-shimmer__input--loading--text--${_ctx.size} ${_ctx.inverseClass}`)
    }, null, 2)]);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerInput.vue?vue&type=template&id=52861a2b&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerInput.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerInputvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerInput",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__input--loading--inverse" : "orq-shimmer__input--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerInput.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerInput.vue?vue&type=style&index=0&id=52861a2b&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerInput.vue?vue&type=style&index=0&id=52861a2b&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerInput.vue




;


const ShimmerInput_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerInputvue_type_script_lang_ts, [['render',ShimmerInputvue_type_template_id_52861a2b_ts_true_render]])

/* harmony default export */ var ShimmerInput = (ShimmerInput_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerNotification.vue?vue&type=template&id=0d250f5c&ts=true

const ShimmerNotificationvue_type_template_id_0d250f5c_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerNotificationvue_type_template_id_0d250f5c_ts_true_hoisted_2 = {
  class: "orq-shimmer__notification"
};
const ShimmerNotificationvue_type_template_id_0d250f5c_ts_true_hoisted_3 = {
  class: "orq-shimmer__notification--loading-container"
};
function ShimmerNotificationvue_type_template_id_0d250f5c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerNotificationvue_type_template_id_0d250f5c_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerNotificationvue_type_template_id_0d250f5c_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-shimmer__notification--loading",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerNotificationvue_type_template_id_0d250f5c_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__notification--loading--icon
            ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__notification--loading--title
            ${_ctx.inverseClass}`)
    }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__notification--loading--text
          ${_ctx.inverseClass}`)
    }, null, 2)]);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerNotification.vue?vue&type=template&id=0d250f5c&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerNotification.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerNotificationvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerNotification",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__notification--loading--inverse" : "orq-shimmer__notification--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerNotification.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerNotification.vue?vue&type=style&index=0&id=0d250f5c&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerNotification.vue?vue&type=style&index=0&id=0d250f5c&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerNotification.vue




;


const ShimmerNotification_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerNotificationvue_type_script_lang_ts, [['render',ShimmerNotificationvue_type_template_id_0d250f5c_ts_true_render]])

/* harmony default export */ var ShimmerNotification = (ShimmerNotification_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerFileUploader.vue?vue&type=template&id=0801bb87&ts=true

const ShimmerFileUploadervue_type_template_id_0801bb87_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerFileUploadervue_type_template_id_0801bb87_ts_true_hoisted_2 = {
  class: "orq-shimmer__file-uploader"
};
const ShimmerFileUploadervue_type_template_id_0801bb87_ts_true_hoisted_3 = {
  class: "orq-shimmer__file-uploader--loading-container"
};
function ShimmerFileUploadervue_type_template_id_0801bb87_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerFileUploadervue_type_template_id_0801bb87_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerFileUploadervue_type_template_id_0801bb87_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-shimmer__file-uploader--loading",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__file-uploader--loading--upload-area ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerFileUploadervue_type_template_id_0801bb87_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__file-uploader--loading--icon ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__file-uploader--loading--description ${_ctx.inverseClass}`)
    }, null, 2)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__file-uploader--loading--file ${_ctx.inverseClass}`)
    }, null, 2)]);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerFileUploader.vue?vue&type=template&id=0801bb87&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerFileUploader.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerFileUploadervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerFileUploader",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__avatar--loading--inverse" : "orq-shimmer__avatar--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerFileUploader.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerFileUploader.vue?vue&type=style&index=0&id=0801bb87&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerFileUploader.vue?vue&type=style&index=0&id=0801bb87&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerFileUploader.vue




;


const ShimmerFileUploader_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerFileUploadervue_type_script_lang_ts, [['render',ShimmerFileUploadervue_type_template_id_0801bb87_ts_true_render]])

/* harmony default export */ var ShimmerFileUploader = (ShimmerFileUploader_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerImage.vue?vue&type=template&id=5b930910&ts=true

const ShimmerImagevue_type_template_id_5b930910_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerImagevue_type_template_id_5b930910_ts_true_hoisted_2 = {
  class: "orq-shimmer__image"
};
function ShimmerImagevue_type_template_id_5b930910_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerImagevue_type_template_id_5b930910_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerImagevue_type_template_id_5b930910_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__image--loading ${_ctx.inverseClass}`),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.containerStyle)
  }, null, 6)])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerImage.vue?vue&type=template&id=5b930910&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerImage.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerImagevue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerImage",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    cols: {
      type: Number,
      default: 1
    },
    sWidth: {
      type: Number,
      default: 150
    },
    sHeight: {
      type: Number,
      default: 150
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__image--loading--inverse" : "orq-shimmer__image--loading--default"),
      containerStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        width: `${props.sWidth}px`,
        height: `${props.sHeight}px`
      }))
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerImage.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerImage.vue?vue&type=style&index=0&id=5b930910&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerImage.vue?vue&type=style&index=0&id=5b930910&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerImage.vue




;


const ShimmerImage_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerImagevue_type_script_lang_ts, [['render',ShimmerImagevue_type_template_id_5b930910_ts_true_render]])

/* harmony default export */ var ShimmerImage = (ShimmerImage_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerList.vue?vue&type=template&id=4760b554&ts=true

const ShimmerListvue_type_template_id_4760b554_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerListvue_type_template_id_4760b554_ts_true_hoisted_2 = {
  class: "orq-shimmer__list"
};
const ShimmerListvue_type_template_id_4760b554_ts_true_hoisted_3 = {
  class: "orq-shimmer__list--loading"
};
const ShimmerListvue_type_template_id_4760b554_ts_true_hoisted_4 = {
  class: "orq-shimmer__list--loading-container"
};
function ShimmerListvue_type_template_id_4760b554_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerListvue_type_template_id_4760b554_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerListvue_type_template_id_4760b554_ts_true_hoisted_2, [_ctx.showListOverline ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__list--loading--overline ${_ctx.inverseClass}`)
  }, null, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerListvue_type_template_id_4760b554_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__list--loading--avatar ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerListvue_type_template_id_4760b554_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__list--loading--title ${_ctx.inverseClass}`)
    }, null, 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__list--loading--subtitle ${_ctx.inverseClass}`)
    }, null, 2)]), _ctx.showListAction ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__list--loading--action ${_ctx.inverseClass}`)
    }, null, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), index !== new Array(_ctx.$props.rows).length - 1 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__list--loading--split ${_ctx.inverseClass}`)
    }, null, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerList.vue?vue&type=template&id=4760b554&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerList.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerListvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerBadge",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    showListAction: {
      type: Boolean,
      default: false
    },
    showListOverline: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__list--loading--inverse" : "orq-shimmer__list--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerList.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerList.vue?vue&type=style&index=0&id=4760b554&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerList.vue?vue&type=style&index=0&id=4760b554&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerList.vue




;


const ShimmerList_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerListvue_type_script_lang_ts, [['render',ShimmerListvue_type_template_id_4760b554_ts_true_render]])

/* harmony default export */ var ShimmerList = (ShimmerList_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerButtonFoward.vue?vue&type=template&id=c3bb1a12&ts=true

const ShimmerButtonFowardvue_type_template_id_c3bb1a12_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerButtonFowardvue_type_template_id_c3bb1a12_ts_true_hoisted_2 = {
  class: "orq-shimmer__button orq-shimmer__button-foward--loading"
};
function ShimmerButtonFowardvue_type_template_id_c3bb1a12_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerButtonFowardvue_type_template_id_c3bb1a12_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerButtonFowardvue_type_template_id_c3bb1a12_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`button-foward--loading ${_ctx.inverseClass}`)
  }, null, 2)])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerButtonFoward.vue?vue&type=template&id=c3bb1a12&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerButtonFoward.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerButtonFowardvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerButtonFoward",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__button-foward--loading--inverse" : "orq-shimmer__button-foward--loading--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerButtonFoward.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerButtonFoward.vue?vue&type=style&index=0&id=c3bb1a12&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerButtonFoward.vue?vue&type=style&index=0&id=c3bb1a12&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerButtonFoward.vue




;


const ShimmerButtonFoward_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerButtonFowardvue_type_script_lang_ts, [['render',ShimmerButtonFowardvue_type_template_id_c3bb1a12_ts_true_render]])

/* harmony default export */ var ShimmerButtonFoward = (ShimmerButtonFoward_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerText.vue?vue&type=template&id=1651b3ec&ts=true

const ShimmerTextvue_type_template_id_1651b3ec_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-shimmer"
};
const ShimmerTextvue_type_template_id_1651b3ec_ts_true_hoisted_2 = {
  class: "orq-shimmer__text"
};
function ShimmerTextvue_type_template_id_1651b3ec_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ShimmerTextvue_type_template_id_1651b3ec_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ShimmerTextvue_type_template_id_1651b3ec_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(new Array(_ctx.$props.rows), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-shimmer__text-row orq-shimmer__text-row--${_ctx.size} ${_ctx.inverseClass}`),
      key: index
    }, null, 2);
  }), 128))])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerText.vue?vue&type=template&id=1651b3ec&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerText.vue?vue&type=script&lang=ts

/* harmony default export */ var ShimmerTextvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "ShimmerText",
  props: {
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-shimmer__text-row--inverse" : "orq-shimmer__text-row--default")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerText.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/templates/ShimmerText.vue?vue&type=style&index=0&id=1651b3ec&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerText.vue?vue&type=style&index=0&id=1651b3ec&lang=scss

;// CONCATENATED MODULE: ./src/components/Shimmer/templates/ShimmerText.vue




;


const ShimmerText_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ShimmerTextvue_type_script_lang_ts, [['render',ShimmerTextvue_type_template_id_1651b3ec_ts_true_render]])

/* harmony default export */ var ShimmerText = (ShimmerText_exports_);
;// CONCATENATED MODULE: ./src/components/Shimmer/templates/index.ts


















































;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Shimmer/Shimmer.vue?vue&type=script&lang=ts



/* harmony default export */ var Shimmervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqShimmer",
  props: {
    type: {
      type: String,
      required: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "small"
    },
    sizeBanner: {
      type: String,
      default: "large"
    },
    sizeAvatar: {
      type: String,
      default: "24"
    },
    showListAction: {
      type: Boolean,
      default: false
    },
    showListOverline: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    tabItems: {
      type: Number,
      default: 1
    },
    typeTag: {
      type: String,
      default: "search"
    },
    tabDirection: {
      type: String,
      default: "horizontal"
    },
    checkboxPosition: {
      type: String,
      default: "left"
    },
    checkboxLabel: {
      type: Boolean,
      default: true
    },
    radioButtonPosition: {
      type: String,
      default: "left"
    },
    typeRadioButton: {
      type: String,
      default: "label"
    },
    typeRing: {
      type: String,
      default: "image"
    },
    cols: {
      type: Number,
      default: 1
    },
    sWidth: {
      type: Number,
      default: 150
    },
    sHeight: {
      type: Number,
      default: 150
    }
  },
  computed: {
    shimmerComponent() {
      let typeConverted = stringConvertion.toCamelCase(this.type, "-");
      return templates_namespaceObject[typeConverted];
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Shimmer/Shimmer.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/components/Shimmer/Shimmer.vue




;
const Shimmer_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Shimmervue_type_script_lang_ts, [['render',Shimmervue_type_template_id_2e4977f6_ts_true_render]])

/* harmony default export */ var Shimmer = (Shimmer_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Badge/Badge.vue?vue&type=script&lang=ts




/* harmony default export */ var Badgevue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqBadge",
  components: {
    OrqIconContainer: IconContainer,
    OrqShimmer: Shimmer
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    appearance: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "large"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const badgeDefaultSize = 16;
    const badgeClass = "orq-badge";
    const refBadge = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const refSpan = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      if (props.appearance === "default") {
        if (props.color === "base") {
          refBadge.value?.style.setProperty("background-color", `var(--informative${props.inverse ? "-inverse" : ""})`);
          refSpan.value?.style.setProperty("color", `var(--emphasis-base-high${props.inverse ? "" : "-inverse"})`);
        } else {
          refBadge.value?.style.setProperty("background-color", `var(--support-${props.color}-${props.inverse ? "90" : "20"})`);
          refSpan.value?.style.setProperty("color", `var(--emphasis-base-high${props.inverse ? "-inverse" : ""})`);
        }
      }
    });
    const setColorIcon = () => {
      if (props.appearance === "positive") {
        return props.inverse ? EiconContainerColor.statusSuccessInverse : EiconContainerColor.statusSuccess;
      } else if (props.appearance === "warning") {
        return props.inverse ? EiconContainerColor.statusWarningInverse : EiconContainerColor.statusWarning;
      } else if (props.appearance === "negative") {
        return props.inverse ? EiconContainerColor.statusErrorInverse : EiconContainerColor.statusError;
      } else if (props.appearance === "info") {
        return props.inverse ? EiconContainerColor.statusInformativeInverse : EiconContainerColor.statusInformative;
      }
      return EiconContainerColor.emphasisBaseHigh;
    };
    return {
      badgeClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${badgeClass}`]: true,
          [`${badgeClass}--inverse`]: props.inverse,
          [`${badgeClass}--${props.appearance}`]: props.appearance,
          [`${badgeClass}--large`]: props.size === "large"
        };
      }),
      setColorIcon,
      refBadge,
      refSpan,
      badgeClass,
      badgeDefaultSize
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Badge/Badge.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Badge/Badge.vue?vue&type=style&index=0&id=025d6abf&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Badge/Badge.vue?vue&type=style&index=0&id=025d6abf&lang=scss

;// CONCATENATED MODULE: ./src/components/Badge/Badge.vue




;


const Badge_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Badgevue_type_script_lang_ts, [['render',Badgevue_type_template_id_025d6abf_ts_true_render]])

/* harmony default export */ var Badge = (Badge_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Button/Button.vue?vue&type=template&id=3b19d31e&ts=true

const Buttonvue_type_template_id_3b19d31e_ts_true_hoisted_1 = ["disabled", "value", "type"];
function Buttonvue_type_template_id_3b19d31e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("button", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.buttonClasses),
    disabled: _ctx.disabled,
    value: _ctx.value,
    type: _ctx.type,
    onClick: _cache[0] || (_cache[0] = $event => !_ctx.disabled ? _ctx.handleSelectedClick($event) : null)
  }, [_ctx.iconName ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    type: "none",
    name: _ctx.iconName,
    inverse: _ctx.inverse,
    loading: _ctx.loading,
    size: _ctx.getIconSize,
    orientation: _ctx.iconOrientation
  }, null, 8, ["name", "inverse", "loading", "size", "orientation"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.appearance !== 'rounded' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 10, Buttonvue_type_template_id_3b19d31e_ts_true_hoisted_1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqShimmer, {
    type: _ctx.getShimmerButtonType,
    inverse: _ctx.inverse,
    loading: _ctx.loading
  }, null, 8, ["type", "inverse", "loading"])], 64);
}
;// CONCATENATED MODULE: ./src/components/Button/Button.vue?vue&type=template&id=3b19d31e&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Button/Button.vue?vue&type=script&lang=ts




/* harmony default export */ var Buttonvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqButton",
  components: {
    OrqIconContainer: IconContainer,
    OrqShimmer: Shimmer
  },
  props: {
    label: {
      type: String,
      default: "Label"
    },
    appearance: {
      type: String,
      default: "primary"
    },
    iconName: {
      type: String,
      default: ""
    },
    iconOrientation: {
      type: String,
      default: "right"
    },
    size: {
      type: String,
      default: "default"
    },
    value: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    const isSelected = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.selected);
    const roundedIconSize = 24;
    const defaultIconSize = 16;
    const getIconSize = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.appearance === "rounded" && props.size === "large" ? roundedIconSize : defaultIconSize);
    const getShimmerButtonType = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.appearance === "rounded" ? "button-foward" : "button");
    const getSelectedClass = () => {
      return props.appearance === "inline" && isSelected.value || !props.disabled && props.appearance === "inline" && props.selected ? "orq-button--selected" : "";
    };
    const handleSelectedClick = event => {
      isSelected.value = !isSelected.value;
      emit("click", event);
    };
    return {
      buttonClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-button": true,
          [`orq-button__appearance--${props.appearance}`]: true,
          [`orq-button__content orq-button__size--${props.size}`]: props.appearance !== "rounded" && props.appearance !== "inline",
          [`orq-button__type--${props.type}`]: true,
          "orq-button--inverse": props.inverse,
          [`orq-button__position--${props.iconOrientation}`]: props.appearance !== "rounded",
          [`${getSelectedClass()}`]: !props.disabled,
          "orq-button__appearance--rounded--small": props.appearance === "rounded" && props.size === "small",
          "orq-button__appearance--rounded--large": props.appearance === "rounded" && props.size === "large"
        };
      }),
      getSelectedClass,
      iconColors,
      isSelected,
      getIconSize,
      getShimmerButtonType,
      handleSelectedClick
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Button/Button.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Button/Button.vue?vue&type=style&index=0&id=3b19d31e&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Button/Button.vue?vue&type=style&index=0&id=3b19d31e&lang=scss

;// CONCATENATED MODULE: ./src/components/Button/Button.vue




;


const Button_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Buttonvue_type_script_lang_ts, [['render',Buttonvue_type_template_id_3b19d31e_ts_true_render]])

/* harmony default export */ var Button = (Button_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Accordion/Accordion.vue?vue&type=script&lang=ts





/* harmony default export */ var Accordionvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqAccordion",
  components: {
    IconContainer: IconContainer,
    OrqBadge: Badge,
    OrqButton: Button
  },
  props: {
    type: {
      type: String,
      default: "default"
    },
    opened: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    contentItems: {
      type: Array
    },
    numberContentItems: {
      type: Number,
      default: 1
    },
    id: {
      type: String
    }
  },
  setup(props, {
    emit
  }) {
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    const openRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.opened);
    const onOpen = ev => {
      if (!props.disabled) {
        openRef.value = !openRef.value;
      }
      emit("onOpen", openRef.value);
    };
    const buttonClick = ev => {
      emit("buttonClick");
    };
    const onClick = ev => {
      emit("onClick");
    };
    return {
      getIconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        if (props.inverse && !props.disabled) {
          return iconColors.value.emphasisBaseInverseHigh;
        }
        if (props.disabled && !props.inverse) {
          return iconColors.value.emphasisBaseDisabled;
        }
        if (props.inverse && props.disabled) {
          return iconColors.value.emphasisBaseInverseDisabled;
        }
        return iconColors.value.emphasisBaseHigh;
      }),
      accordionClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-accordion": true,
          ["orq-accordion--inverse"]: props.inverse,
          ["orq-accordion--disabled"]: props.disabled,
          ["orq-accordion--expanded"]: openRef.value
        };
      }),
      onOpen,
      buttonClick,
      onClick
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Accordion/Accordion.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Accordion/Accordion.vue?vue&type=style&index=0&id=cb33d720&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Accordion/Accordion.vue?vue&type=style&index=0&id=cb33d720&lang=scss

;// CONCATENATED MODULE: ./src/components/Accordion/Accordion.vue




;


const Accordion_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Accordionvue_type_script_lang_ts, [['render',render]])

/* harmony default export */ var Accordion = (Accordion_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Avatar/Avatar.vue?vue&type=template&id=8286b492&ts=true

const Avatarvue_type_template_id_8286b492_ts_true_hoisted_1 = {
  key: 1,
  class: "orq-avatar"
};
const Avatarvue_type_template_id_8286b492_ts_true_hoisted_2 = {
  class: "orq-avatar__block"
};
const Avatarvue_type_template_id_8286b492_ts_true_hoisted_3 = {
  key: 1
};
const Avatarvue_type_template_id_8286b492_ts_true_hoisted_4 = {
  key: 3
};
function Avatarvue_type_template_id_8286b492_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqBullet = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqBullet");
  const _component_OrqCounter = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqCounter");
  const _component_OrqImageContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqImageContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    type: "avatar",
    sizeAvatar: _ctx.size,
    inverse: _ctx.inverse
  }, null, 8, ["sizeAvatar", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Avatarvue_type_template_id_8286b492_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Avatarvue_type_template_id_8286b492_ts_true_hoisted_2, [_ctx.type === 'initials' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.initialClass),
    tabindex: 0
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.alt.toUpperCase().substring(0, 2)), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.notification === 'default' || _ctx.notification === 'counter' && _ctx.size <= 32 || _ctx.notification === 'status' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Avatarvue_type_template_id_8286b492_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqBullet, {
    size: _ctx.size,
    inverse: _ctx.inverse,
    outline: _ctx.outline,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.bulletClass)
  }, null, 8, ["size", "inverse", "outline", "class"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.notification != 'none' && _ctx.notification == 'counter' && _ctx.size > 32 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 2,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.counterClass)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqCounter, {
    value: _ctx.counterValue,
    inverse: _ctx.inverse,
    size: "large",
    type: "circle"
  }, null, 8, ["value", "inverse"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Avatarvue_type_template_id_8286b492_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqImageContainer, {
    size: _ctx.size,
    src: _ctx.src,
    alt: _ctx.alt,
    shape: "rounded",
    outline: _ctx.outline,
    inverse: _ctx.inverse
  }, null, 8, ["size", "src", "alt", "outline", "inverse"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Avatar/Avatar.vue?vue&type=template&id=8286b492&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ImageContainer/ImageContainer.vue?vue&type=template&id=64c6fdbb&ts=true

const ImageContainervue_type_template_id_64c6fdbb_ts_true_hoisted_1 = {
  class: "orq-image-container"
};
const ImageContainervue_type_template_id_64c6fdbb_ts_true_hoisted_2 = ["src", "alt"];
function ImageContainervue_type_template_id_64c6fdbb_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ImageContainervue_type_template_id_64c6fdbb_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
    src: _ctx.src,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.imageContainerClasses),
    alt: _ctx.alt,
    tabindex: 0
  }, null, 10, ImageContainervue_type_template_id_64c6fdbb_ts_true_hoisted_2)]);
}
;// CONCATENATED MODULE: ./src/components/ImageContainer/ImageContainer.vue?vue&type=template&id=64c6fdbb&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ImageContainer/ImageContainer.vue?vue&type=script&lang=ts

/* harmony default export */ var ImageContainervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqImageContainer",
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    shape: {
      type: String,
      default: "rounded"
    },
    size: {
      type: Number,
      default: 40
    },
    inverse: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const defaultClass = "orq-image-container__image";
    const sizeClass = props.size ? `${defaultClass}--size-${props.size}` : "";
    const shapeClass = props.shape ? `${defaultClass}--size-${props.size}--${props.shape}` : "";
    const inverseClass = props.inverse ? `${defaultClass}--inverse` : "";
    const outlineClass = props.outline ? `${defaultClass}--outline` : "";
    const imageContainerClasses = `${defaultClass} ${sizeClass} ${shapeClass} ${inverseClass} ${outlineClass}`;
    return {
      imageContainerClasses
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/ImageContainer/ImageContainer.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ImageContainer/ImageContainer.vue?vue&type=style&index=0&id=64c6fdbb&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ImageContainer/ImageContainer.vue?vue&type=style&index=0&id=64c6fdbb&lang=scss

;// CONCATENATED MODULE: ./src/components/ImageContainer/ImageContainer.vue




;


const ImageContainer_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ImageContainervue_type_script_lang_ts, [['render',ImageContainervue_type_template_id_64c6fdbb_ts_true_render]])

/* harmony default export */ var ImageContainer = (ImageContainer_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Avatar/Avatar.vue?vue&type=script&lang=ts





/* harmony default export */ var Avatarvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqAvatar",
  components: {
    OrqImageContainer: ImageContainer,
    OrqShimmer: Shimmer,
    OrqCounter: Counter,
    OrqBullet: Bullet
  },
  props: {
    type: {
      type: String,
      default: "initials"
    },
    src: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 24
    },
    notification: {
      type: String,
      default: "none"
    },
    counterValue: {
      type: Number,
      default: 2
    },
    loading: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      initialClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-avatar__block__initials": true,
          "orq-avatar__block__initials--default": true,
          "orq-avatar__block__initials--inverse": props.inverse,
          "orq-avatar__block__initials--outline": props.outline,
          [`orq-avatar__block__initials--size-${props.size}`]: true,
          [`orq-avatar__block__initials--size-${props.size}-outline-inverse`]: props.outline && props.inverse
        };
      }),
      bulletClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-avatar__block__bullet": true,
          "orq-avatar__block__bullet--default": true,
          "orq-avatar__block__bullet--inverse": props.inverse,
          [`orq-avatar__block__bullet--notification--${props.notification === "default" || props.notification === "counter" ? "default" : ""}--size-${props.size}`]: true,
          "orq-bullet": true,
          [`orq-avatar__block__bullet--notification--${props.notification === "status" ? "status" : ""}--size-${props.size}`]: true,
          [`orq-bullet--${props.notification === "default" || props.notification === "counter" && props.size <= 32 ? "info" : ""}`]: props.notification,
          [`orq-bullet--${props.notification === "default" || props.notification === "counter" && props.size <= 32 ? "info" : ""}--inverse`]: props.inverse,
          [`orq-bullet--${props.notification === "status" ? "positive" : ""}`]: props.notification,
          [`orq-bullet--${props.notification === "status" ? "positive" : ""}--inverse`]: props.inverse
        };
      }),
      counterClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-avatar__block__counter": true,
          [`orq-avatar__block__counter--size-${props.size}`]: true,
          "orq-avatar__block__counter--'default": true
        };
      })
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Avatar/Avatar.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Avatar/Avatar.vue?vue&type=style&index=0&id=8286b492&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Avatar/Avatar.vue?vue&type=style&index=0&id=8286b492&lang=scss

;// CONCATENATED MODULE: ./src/components/Avatar/Avatar.vue




;


const Avatar_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Avatarvue_type_script_lang_ts, [['render',Avatarvue_type_template_id_8286b492_ts_true_render]])

/* harmony default export */ var Avatar = (Avatar_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Banner/Banner.vue?vue&type=template&id=7a5c27c9&ts=true

const Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-banner__image"
};
const Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_2 = ["src"];
const Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_3 = {
  class: "orq-banner__container"
};
const Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_4 = {
  key: 0,
  class: "orq-banner__badges"
};
const Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_5 = {
  class: "orq-banner__title"
};
const Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_6 = {
  key: 1,
  class: "orq-banner__subtitle"
};
const Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_7 = {
  class: "orq-banner__content"
};
const Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_8 = {
  key: 2,
  class: "orq-banner__action-link"
};
function Bannervue_type_template_id_7a5c27c9_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqBadge = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqBadge");
  const _component_OrqLink = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqLink");
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["orq-banner", _ctx.bannerClasses])
  }, [_ctx.src ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
    src: _ctx.src
  }, null, 8, Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_2)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_3, [_ctx.badge && !_ctx.isExtraSmall ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqBadge, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.mergeProps)(_ctx.badge, {
    inverse: _ctx.inverse
  }), null, 16, ["inverse"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_5, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1), _ctx.subtitle ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_6, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.subtitle), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_7, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.content), 1)])]), _ctx.linkText ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Bannervue_type_template_id_7a5c27c9_ts_true_hoisted_8, [_ctx.linkText ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqLink, {
    key: 0,
    icon: "default",
    inverse: _ctx.inverse,
    label: _ctx.linkText,
    onClick: _cache[0] || (_cache[0] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)($event => _ctx.linkAction(), ["stop"]))
  }, null, 8, ["inverse", "label"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 1,
    type: "banner",
    sizeBanner: _ctx.size,
    imageAlignRight: _ctx.imageAlign,
    sizeBannerImage: _ctx.imageSize,
    inverse: _ctx.inverse
  }, null, 8, ["sizeBanner", "imageAlignRight", "sizeBannerImage", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Banner/Banner.vue?vue&type=template&id=7a5c27c9&ts=true

;// CONCATENATED MODULE: ./src/components/Banner/models/Banner.enum.ts
var EBannerSize;
(function (EBannerSize) {
  EBannerSize["xsmall"] = "xsmall";
  EBannerSize["small"] = "small";
  EBannerSize["medium"] = "medium";
  EBannerSize["large"] = "large";
  EBannerSize["wide"] = "wide";
})(EBannerSize || (EBannerSize = {}));
var EBannerImageSize;
(function (EBannerImageSize) {
  EBannerImageSize["default"] = "default";
  EBannerImageSize["large"] = "large";
  EBannerImageSize["rounded"] = "rounded";
})(EBannerImageSize || (EBannerImageSize = {}));
var EBannerImageAlign;
(function (EBannerImageAlign) {
  EBannerImageAlign["left"] = "left";
  EBannerImageAlign["right"] = "right";
})(EBannerImageAlign || (EBannerImageAlign = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Link/Link.vue?vue&type=template&id=7af33ed0&ts=true

const Linkvue_type_template_id_7af33ed0_ts_true_hoisted_1 = ["target", "href"];
const Linkvue_type_template_id_7af33ed0_ts_true_hoisted_2 = {
  key: 0,
  class: "orq-link--icon"
};
const Linkvue_type_template_id_7af33ed0_ts_true_hoisted_3 = {
  class: "orq-link__span"
};
function Linkvue_type_template_id_7af33ed0_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqShimmer, {
    type: "text",
    loading: _ctx.loading,
    size: _ctx.size,
    inverse: _ctx.inverse
  }, null, 8, ["loading", "size", "inverse"]), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("a", {
    key: 0,
    target: _ctx.target,
    href: _ctx.href,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([_ctx.linkClasses, _ctx.defaultAndCustomOrientationClass]),
    onClick: _cache[0] || (_cache[0] = $event => !_ctx.disabled ? _ctx.onClick($event) : '')
  }, [_ctx.icon !== 'none' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Linkvue_type_template_id_7af33ed0_ts_true_hoisted_2, [_ctx.orientation && _ctx.icon === 'default' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    type: "none",
    name: `chevron-${_ctx.orientation === 'left' ? 'left' : 'right'}`
  }, null, 8, ["name"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.orientation && _ctx.icon === 'external' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 1,
    type: "none",
    name: "external-link"
  })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.orientation && _ctx.icon === 'custom' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 2,
    type: "none",
    name: _ctx.customIcon
  }, null, 8, ["name"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", Linkvue_type_template_id_7af33ed0_ts_true_hoisted_3, [_ctx.$slots.default ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {
    key: 0
  }) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 1)], 64))])], 10, Linkvue_type_template_id_7af33ed0_ts_true_hoisted_1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Link/Link.vue?vue&type=template&id=7af33ed0&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Link/Link.vue?vue&type=script&lang=ts



/* harmony default export */ var Linkvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqLink",
  components: {
    OrqIconContainer: IconContainer,
    OrqShimmer: Shimmer
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: undefined
    },
    icon: {
      type: String,
      default: ""
    },
    customIcon: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "small"
    },
    orientation: {
      type: String,
      default: "right"
    },
    type: {
      type: String,
      default: "default"
    },
    target: {
      type: String,
      default: "_blank"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    underline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  setup(props, {
    emit
  }) {
    const onClick = event => {
      emit("click", event);
    };
    const linkClass = "orq-link";
    return {
      linkClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${linkClass}`]: true,
          [`${linkClass}--${props.size}`]: props.size,
          [`${linkClass}--${props.orientation}`]: props.icon === "external",
          [`${linkClass}--underline`]: props.underline && props.icon === "none",
          [`${linkClass}${props.type === "primary" ? "--primary" : ""}`]: true,
          [`${linkClass}--disabled`]: props.disabled,
          [`${linkClass}--disabled--inverse`]: props.disabled && props.inverse && props.type,
          [`${linkClass}--inverse--default`]: props.type === "default" && props.inverse,
          [`${linkClass}--primary--inverse`]: props.type === "primary" && props.inverse
        };
      }),
      defaultAndCustomOrientationClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [props.icon === "default" || props.icon === "custom" ? props.orientation === "right" ? "orq-link--right" : "orq-link--left" : ""]: true
        };
      }),
      onClick,
      linkClass
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Link/Link.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Link/Link.vue?vue&type=style&index=0&id=7af33ed0&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Link/Link.vue?vue&type=style&index=0&id=7af33ed0&lang=scss

;// CONCATENATED MODULE: ./src/components/Link/Link.vue




;


const Link_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Linkvue_type_script_lang_ts, [['render',Linkvue_type_template_id_7af33ed0_ts_true_render]])

/* harmony default export */ var Link = (Link_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Banner/Banner.vue?vue&type=script&lang=ts





/* harmony default export */ var Bannervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqBanner",
  components: {
    OrqShimmer: Shimmer,
    OrqLink: Link,
    OrqBadge: Badge
  },
  props: {
    src: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    badge: {
      type: Object
    },
    size: {
      type: String,
      default: EBannerSize.large
    },
    imageSize: {
      type: String,
      default: EBannerImageSize.default
    },
    imageAlign: {
      type: String,
      default: EBannerImageAlign.left
    },
    inverse: {
      type: Boolean,
      default: false
    },
    bgNeutral: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    linkText: {
      type: String,
      default: ""
    }
  },
  emits: ["linkAction"],
  computed: {
    isExtraSmall() {
      return this.size === EBannerSize.xsmall;
    },
    bannerClasses() {
      const classList = {
        "orq-banner": true,
        [`orq-banner--${this.size}`]: true,
        [`orq-banner--image-${this.imageSize}`]: true,
        "orq-banner--image-align-right": (() => {
          const alignment = this.imageAlign === EBannerImageAlign.right;
          const size = this.size !== EBannerSize.small && this.size !== EBannerSize.medium;
          return alignment && size;
        })(),
        "orq-banner--inverse": this.inverse,
        "orq-banner--neutral": this.bgNeutral,
        "orq-banner--image-rounded": this.imageSize === EBannerImageSize.rounded,
        "orq-banner--image-large": this.imageSize === EBannerImageSize.large
      };
      return classList;
    }
  },
  methods: {
    linkAction() {
      this.$emit("linkAction");
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Banner/Banner.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Banner/Banner.vue?vue&type=style&index=0&id=7a5c27c9&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Banner/Banner.vue?vue&type=style&index=0&id=7a5c27c9&lang=scss

;// CONCATENATED MODULE: ./src/components/Banner/Banner.vue




;


const Banner_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Bannervue_type_script_lang_ts, [['render',Bannervue_type_template_id_7a5c27c9_ts_true_render]])

/* harmony default export */ var Banner = (Banner_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Breadcrumb/Breadcrumb.vue?vue&type=template&id=1a7f3de5&ts=true

const Breadcrumbvue_type_template_id_1a7f3de5_ts_true_hoisted_1 = {
  class: "orq-breadcrumb"
};
const Breadcrumbvue_type_template_id_1a7f3de5_ts_true_hoisted_2 = ["onClick"];
const Breadcrumbvue_type_template_id_1a7f3de5_ts_true_hoisted_3 = ["onClick"];
function Breadcrumbvue_type_template_id_1a7f3de5_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("ul", Breadcrumbvue_type_template_id_1a7f3de5_ts_true_hoisted_1, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.$props.items, (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
      key: index
    }, [index === 0 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      role: "button",
      class: "orq-breadcrumb__home-icon",
      onClick: $event => _ctx.action(item.route)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      type: "none",
      name: _ctx.handleDefaultIcon(),
      size: 16,
      inverse: _ctx.inverse,
      color: _ctx.setIconColor()
    }, null, 8, ["name", "inverse", "color"])], 8, Breadcrumbvue_type_template_id_1a7f3de5_ts_true_hoisted_2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
      onClick: $event => index !== _ctx.options?.length - 1 && _ctx.action ? _ctx.action(item.route) : undefined,
      role: "button",
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.breadcrumbLabelClasses)
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item?.label), 11, Breadcrumbvue_type_template_id_1a7f3de5_ts_true_hoisted_3), index !== _ctx.items?.length - 1 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 1,
      role: "button",
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.breadcrumbIconClasses)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      type: "none",
      name: "chevron-right",
      size: 16,
      inverse: _ctx.inverse,
      color: _ctx.setIconColor()
    }, null, 8, ["inverse", "color"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]);
  }), 128))]);
}
;// CONCATENATED MODULE: ./src/components/Breadcrumb/Breadcrumb.vue?vue&type=template&id=1a7f3de5&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Breadcrumb/Breadcrumb.vue?vue&type=script&lang=ts



/* harmony default export */ var Breadcrumbvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqBreadcrumb",
  props: {
    iconName: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrqIconContainer: IconContainer
  },
  setup(props) {
    const options = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.items);
    const handleDefaultIcon = () => {
      return props.iconName ? props.iconName : "";
    };
    const setIconColor = () => {
      return props.inverse ? EiconContainerColor.emphasisBaseInverseHigh : EiconContainerColor.emphasisBaseHigh;
    };
    const emitUrl = url => {
      window.location.href = url;
    };
    const action = url => {
      emitUrl(url);
    };
    return {
      breadcrumbLabelClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-breadcrumb__home-icon": true,
          "orq-breadcrumb__label": true,
          "orq-breadcrumb__label--inverse": props.inverse
        };
      }),
      breadcrumbIconClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-breadcrumb__icon": true,
          "orq-breadcrumb__icon--inverse": props.inverse
        };
      }),
      options,
      handleDefaultIcon,
      setIconColor,
      action
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Breadcrumb/Breadcrumb.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Breadcrumb/Breadcrumb.vue?vue&type=style&index=0&id=1a7f3de5&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Breadcrumb/Breadcrumb.vue?vue&type=style&index=0&id=1a7f3de5&lang=scss

;// CONCATENATED MODULE: ./src/components/Breadcrumb/Breadcrumb.vue




;


const Breadcrumb_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Breadcrumbvue_type_script_lang_ts, [['render',Breadcrumbvue_type_template_id_1a7f3de5_ts_true_render]])

/* harmony default export */ var Breadcrumb = (Breadcrumb_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ButtonIcon/ButtonIcon.vue?vue&type=template&id=fa371134&ts=true

const ButtonIconvue_type_template_id_fa371134_ts_true_hoisted_1 = ["disabled", "value", "type"];
function ButtonIconvue_type_template_id_fa371134_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqShimmer, {
    type: "button-foward",
    loading: _ctx.loading,
    inverse: _ctx.inverse,
    size: _ctx.size
  }, null, 8, ["loading", "inverse", "size"]), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("button", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.buttonClasses),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event)),
    disabled: _ctx.disabled,
    value: _ctx.value,
    type: _ctx.type
  }, [_ctx.iconName ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    type: "none",
    name: _ctx.iconName,
    size: _ctx.size === 'large' ? 24 : 16,
    color: _ctx.iconColor.iconInverseColor
  }, null, 8, ["name", "size", "color"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 10, ButtonIconvue_type_template_id_fa371134_ts_true_hoisted_1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/ButtonIcon/ButtonIcon.vue?vue&type=template&id=fa371134&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ButtonIcon/ButtonIcon.vue?vue&type=script&lang=ts




/* harmony default export */ var ButtonIconvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "orq-button-icon",
  components: {
    OrqIconContainer: IconContainer,
    OrqShimmer: Shimmer
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    iconName: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "button"
    },
    size: {
      type: String,
      default: "large"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    return {
      buttonClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-button-icon": true,
          [`orq-button-icon--${props.size}`]: true,
          "orq-button-icon--inverse": props.inverse
        };
      }),
      iconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        iconInverseColor: props.inverse && !props.disabled ? iconColors.value.emphasisBaseHigh : props.disabled && !props.inverse ? iconColors.value.emphasisBaseDisabled : props.inverse && props.disabled ? iconColors.value.emphasisBaseInverseDisabled : iconColors.value.emphasisBaseInverseHigh
      }))
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/ButtonIcon/ButtonIcon.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ButtonIcon/ButtonIcon.vue?vue&type=style&index=0&id=fa371134&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ButtonIcon/ButtonIcon.vue?vue&type=style&index=0&id=fa371134&lang=scss

;// CONCATENATED MODULE: ./src/components/ButtonIcon/ButtonIcon.vue




;


const ButtonIcon_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ButtonIconvue_type_script_lang_ts, [['render',ButtonIconvue_type_template_id_fa371134_ts_true_render]])

/* harmony default export */ var ButtonIcon = (ButtonIcon_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ButtonShortcut/ButtonShortcut.vue?vue&type=template&id=4ba8af32&scoped=true&ts=true

const _withScopeId = n => (_pushScopeId("data-v-4ba8af32"), n = n(), _popScopeId(), n);
const ButtonShortcutvue_type_template_id_4ba8af32_scoped_true_ts_true_hoisted_1 = ["type"];
const ButtonShortcutvue_type_template_id_4ba8af32_scoped_true_ts_true_hoisted_2 = {
  class: "orq-button-shortcut__header"
};
const ButtonShortcutvue_type_template_id_4ba8af32_scoped_true_ts_true_hoisted_3 = {
  class: "orq-button-shortcut__header--aligned-items"
};
function ButtonShortcutvue_type_template_id_4ba8af32_scoped_true_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqBadge = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqBadge");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("button", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-button-shortcut ${_ctx.buttonSizeClass} ${_ctx.buttonInverseClass} ${_ctx.buttonShortcutKindClass}`),
    type: _ctx.type,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.handleClick($event))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ButtonShortcutvue_type_template_id_4ba8af32_scoped_true_ts_true_hoisted_2, [_ctx.hasBadge ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqBadge, {
    key: 0,
    appearance: "default",
    color: "green",
    size: "small",
    label: _ctx.badgeLabel,
    inverse: _ctx.inverse
  }, null, 8, ["label", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ButtonShortcutvue_type_template_id_4ba8af32_scoped_true_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    color: _ctx.setIconColor,
    name: _ctx.iconName,
    size: 24,
    inverse: _ctx.inverse
  }, null, 8, ["color", "name", "inverse"])])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-button-shortcut__label ${_ctx.labelSizeClass}`)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 3), _ctx.hasDescription ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-button-shortcut__description ${_ctx.descriptionSizeClass}`)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 10, ButtonShortcutvue_type_template_id_4ba8af32_scoped_true_ts_true_hoisted_1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 1,
    type: "image",
    sWidth: 100,
    sHeight: 100,
    inverse: _ctx.inverse,
    loading: _ctx.loading
  }, null, 8, ["inverse", "loading"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/ButtonShortcut/ButtonShortcut.vue?vue&type=template&id=4ba8af32&scoped=true&ts=true

;// CONCATENATED MODULE: ./src/components/ButtonShortcut/models/buttonShortcut.enum.ts
var EButtonShortcutSize;
(function (EButtonShortcutSize) {
  EButtonShortcutSize["small"] = "small";
  EButtonShortcutSize["large"] = "large";
})(EButtonShortcutSize || (EButtonShortcutSize = {}));
var EButtonShortcutKind;
(function (EButtonShortcutKind) {
  EButtonShortcutKind["default"] = "default";
  EButtonShortcutKind["new"] = "new";
})(EButtonShortcutKind || (EButtonShortcutKind = {}));
var EButtonShortcutType;
(function (EButtonShortcutType) {
  EButtonShortcutType["button"] = "button";
  EButtonShortcutType["submit"] = "submit";
})(EButtonShortcutType || (EButtonShortcutType = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ButtonShortcut/ButtonShortcut.vue?vue&type=script&lang=ts





/* harmony default export */ var ButtonShortcutvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqButtonShortcut",
  components: {
    OrqIconContainer: IconContainer,
    OrqBadge: Badge,
    OrqShimmer: Shimmer
  },
  props: {
    kind: {
      type: String,
      default: ""
    },
    badgeLabel: {
      type: String,
      default: ""
    },
    iconName: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    hasBadge: {
      type: Boolean,
      default: true
    },
    hasDescription: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const handleClick = event => {
      emit("onClick", event);
    };
    return {
      handleClick,
      setIconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "primary-base-inverse" : "primary-base"),
      buttonShortcutKindClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.kind === EButtonShortcutKind.new ? "orq-button-shortcut--kind-new" : ""),
      buttonSizeClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === EButtonShortcutSize.large ? "orq-button-shortcut--large" : ""),
      buttonInverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-button-shortcut--inverse" : ""),
      labelSizeClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === EButtonShortcutSize.small ? "orq-button-shortcut__label--small" : "orq-button-shortcut__label--large"),
      descriptionSizeClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === EButtonShortcutSize.small ? "orq-button-shortcut__description--small" : "orq-button-shortcut__description--large")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/ButtonShortcut/ButtonShortcut.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ButtonShortcut/ButtonShortcut.vue?vue&type=style&index=0&id=4ba8af32&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ButtonShortcut/ButtonShortcut.vue?vue&type=style&index=0&id=4ba8af32&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/ButtonShortcut/ButtonShortcut.vue




;


const ButtonShortcut_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ButtonShortcutvue_type_script_lang_ts, [['render',ButtonShortcutvue_type_template_id_4ba8af32_scoped_true_ts_true_render],['__scopeId',"data-v-4ba8af32"]])

/* harmony default export */ var ButtonShortcut = (ButtonShortcut_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/Calendar.vue?vue&type=template&id=27743776&ts=true

function Calendarvue_type_template_id_27743776_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SingleDatePicker = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("SingleDatePicker");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-datepicker ${_ctx.inverseClass}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_SingleDatePicker, {
    range: _ctx.range,
    selectedDays: _ctx.selectedDays,
    daysToShow: _ctx.daysToShowLeftRef,
    value: _ctx.selectedDays,
    mode: _ctx.mode,
    startDateValue: _ctx.startDateValue,
    endDateValue: _ctx.endDateValue,
    inverse: _ctx.inverse,
    weekendAvailable: _ctx.weekendAvailable,
    blockDateList: _ctx.parsedBlockedDates,
    withBlockList: _ctx.withBlockList,
    allowedDateList: _ctx.parsedAllowedDates,
    withAllowedList: _ctx.withAllowedList,
    onGoToNextMonth: _ctx.goToNextMonth,
    onGoToPrevMonth: _ctx.goToPrevMonth,
    onSelectDay: _ctx.selectDay,
    onHandleselectedmonth: _ctx.handleSelectedView,
    onHandleselectedyear: _ctx.handleSelectedView,
    onHandleToday: _ctx.setToday,
    "onUpdate:selectedDays": _cache[0] || (_cache[0] = $event => _ctx.selectedDays = $event)
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]),
    _: 3
  }, 8, ["range", "selectedDays", "daysToShow", "value", "mode", "startDateValue", "endDateValue", "inverse", "weekendAvailable", "blockDateList", "withBlockList", "allowedDateList", "withAllowedList", "onGoToNextMonth", "onGoToPrevMonth", "onSelectDay", "onHandleselectedmonth", "onHandleselectedyear", "onHandleToday"])], 2);
}
;// CONCATENATED MODULE: ./src/components/Calendar/Calendar.vue?vue&type=template&id=27743776&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/CalendarSingleDatePicker.vue?vue&type=template&id=00fc1bb8&ts=true

const CalendarSingleDatePickervue_type_template_id_00fc1bb8_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, "Hoje", -1);
const CalendarSingleDatePickervue_type_template_id_00fc1bb8_ts_true_hoisted_2 = [CalendarSingleDatePickervue_type_template_id_00fc1bb8_ts_true_hoisted_1];
const CalendarSingleDatePickervue_type_template_id_00fc1bb8_ts_true_hoisted_3 = {
  key: 0,
  class: "single-datepicker__buttons"
};
function CalendarSingleDatePickervue_type_template_id_00fc1bb8_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Datepicker = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("Datepicker");
  const _component_SingleDatePickerWrapper = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("SingleDatePickerWrapper");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_SingleDatePickerWrapper, {
    mode: _ctx.mode
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_Datepicker, {
      events: _ctx.events,
      range: _ctx.range,
      selectedDays: _ctx.selectedDaysRef,
      view: _ctx.view,
      startDateValue: _ctx.startDateValue,
      endDateValue: _ctx.endDateValue,
      currentDate: _ctx.currentDate,
      inverse: _ctx.inverse,
      weekendAvailable: _ctx.weekendAvailable,
      blockDateList: _ctx.blockDateList,
      withBlockList: _ctx.withBlockList,
      allowedDateList: _ctx.allowedDateList,
      withAllowedList: _ctx.withAllowedList,
      daysToShow: _ctx.daysToShow,
      onGoToNextMonth: _ctx.goToNextMonth,
      onGoToPrevMonth: _ctx.goToPrevMonth,
      onSelectDay: _ctx.selectDay,
      onHandleswitchview: _ctx.renderclickMonth,
      onHandleselectedmonth: _ctx.handleSelectedMonth,
      onHandlerendermonth: _ctx.handleSelectedYear
    }, null, 8, ["events", "range", "selectedDays", "view", "startDateValue", "endDateValue", "currentDate", "inverse", "weekendAvailable", "blockDateList", "withBlockList", "allowedDateList", "withAllowedList", "daysToShow", "onGoToNextMonth", "onGoToPrevMonth", "onSelectDay", "onHandleswitchview", "onHandleselectedmonth", "onHandlerendermonth"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: "c-datepicker__today pointer",
      onClick: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.setToday && _ctx.setToday(...args))
    }, CalendarSingleDatePickervue_type_template_id_00fc1bb8_ts_true_hoisted_2), _ctx.mode === 'datepicker' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", CalendarSingleDatePickervue_type_template_id_00fc1bb8_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]),
    _: 3
  }, 8, ["mode"]);
}
;// CONCATENATED MODULE: ./src/components/Calendar/CalendarSingleDatePicker.vue?vue&type=template&id=00fc1bb8&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/CalendarSingleDatePickerWrapper.vue?vue&type=template&id=586914a1&ts=true

const CalendarSingleDatePickerWrappervue_type_template_id_586914a1_ts_true_hoisted_1 = {
  class: "c-datepicker"
};
function CalendarSingleDatePickerWrappervue_type_template_id_586914a1_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.mode === 'calendar' ? 'calendar' : 'datepicker')
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", CalendarSingleDatePickerWrappervue_type_template_id_586914a1_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")])], 2);
}
;// CONCATENATED MODULE: ./src/components/Calendar/CalendarSingleDatePickerWrapper.vue?vue&type=template&id=586914a1&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/CalendarSingleDatePickerWrapper.vue?vue&type=script&lang=ts

/* harmony default export */ var CalendarSingleDatePickerWrappervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqCalendarSingleDatePickerWrapper",
  props: {
    mode: {
      type: String
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/CalendarSingleDatePickerWrapper.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/components/Calendar/CalendarSingleDatePickerWrapper.vue




;
const CalendarSingleDatePickerWrapper_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CalendarSingleDatePickerWrappervue_type_script_lang_ts, [['render',CalendarSingleDatePickerWrappervue_type_template_id_586914a1_ts_true_render]])

/* harmony default export */ var CalendarSingleDatePickerWrapper = (CalendarSingleDatePickerWrapper_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarDatePicker.vue?vue&type=template&id=1ba5f93f&ts=true

function CalendarDatePickervue_type_template_id_1ba5f93f_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DayLayout = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DayLayout");
  const _component_MonthLayout = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("MonthLayout");
  const _component_YearLayout = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("YearLayout");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.view === _ctx.OrquestraDatePickerViewEnum.Day ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DayLayout, {
    key: 0,
    events: _ctx.events,
    setView: _ctx.setView,
    currentDate: _ctx.currentDate,
    setCurrentDate: _ctx.setCurrentDate,
    selectedDays: _ctx.selectedDaysRef,
    range: _ctx.range,
    startDateValue: _ctx.startDateValue,
    endDateValue: _ctx.endDateValue,
    inverse: _ctx.inverse,
    weekendAvailable: _ctx.weekendAvailable,
    blockDateList: _ctx.blockDateList,
    withBlockList: _ctx.withBlockList,
    allowedDateList: _ctx.allowedDateList,
    withAllowedList: _ctx.withAllowedList,
    daysToShow: _ctx.daysToShow,
    onHandleclickmonth: _cache[0] || (_cache[0] = $event => _ctx.handleSwitchView('month')),
    onGoToPrevMonth: _ctx.goToPrevMonth,
    onGoToNextMonth: _ctx.goToNextMonth,
    onSelectDay: _ctx.selectDay
  }, null, 8, ["events", "setView", "currentDate", "setCurrentDate", "selectedDays", "range", "startDateValue", "endDateValue", "inverse", "weekendAvailable", "blockDateList", "withBlockList", "allowedDateList", "withAllowedList", "daysToShow", "onGoToPrevMonth", "onGoToNextMonth", "onSelectDay"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.view === _ctx.OrquestraDatePickerViewEnum.Month ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_MonthLayout, {
    key: 1,
    setView: _ctx.setView,
    currentDate: _ctx.currentDate,
    inverse: _ctx.inverse,
    onHandleclickyear: _cache[1] || (_cache[1] = $event => _ctx.handleSwitchView('year')),
    onHandleselectedmonth: _ctx.handleSelectedMonth
  }, null, 8, ["setView", "currentDate", "inverse", "onHandleselectedmonth"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.view === _ctx.OrquestraDatePickerViewEnum.Year ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_YearLayout, {
    key: 2,
    setView: _ctx.setView,
    currentDate: _ctx.currentDate,
    setCurrentDate: _ctx.setCurrentDate,
    inverse: _ctx.inverse,
    onChangeselectedyear: _ctx.handleRenderMonth
  }, null, 8, ["setView", "currentDate", "setCurrentDate", "inverse", "onChangeselectedyear"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarDatePicker.vue?vue&type=template&id=1ba5f93f&ts=true

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(560);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.unshift.js
var es_array_unshift = __webpack_require__(1719);
;// CONCATENATED MODULE: ./src/utils/functions/calendar.utils.ts


const OrquestraDatePickerViewEnum = {
  Year: "year",
  Month: "month",
  Day: "day"
};
const DAYSTOSHOWLENGTH = 42;
const INDEXLASTDAYOFWEEK = 6;
const MONTHS = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
const createDayObject = (date, {
  index
}, events, selectedDays, currentDate, start, finish, blockDateList, allowedDateList) => {
  function isDaySelected(date, selectedDays) {
    return selectedDays.find(sDay => {
      const dateEvent = new Date(sDay);
      return isDateEquals(dateEvent, date);
    });
  }
  function isDateEquals(date, dateCompare) {
    if (!date || !dateCompare) {
      return false;
    }
    return date.getTime() === dateCompare.getTime();
  }
  function formattedDate(event) {
    const [day, month, year] = event.date.split("/");
    return [month, day, year].join("/");
  }
  function isDayEvent(date, events) {
    return events.filter(event => {
      const dateEvent = new Date(formattedDate(event));
      return isDateEquals(dateEvent, date);
    });
  }
  function isDayBlocked(date, blockDateList) {
    const isBlocked = blockDateList.find(event => {
      const dateEvent = new Date(event);
      return isDateEquals(dateEvent, date);
    });
    return isBlocked ? true : false;
  }
  function isDayAllowed(date, allowedDateList) {
    const isAllowed = allowedDateList.find(event => {
      const dateEvent = new Date(event);
      return isDateEquals(dateEvent, date);
    });
    return isAllowed ? true : false;
  }
  function isDayDisabled(day) {
    if (day.getMonth() != currentDate.getMonth() || isDateBeforeMinDate(day, start) || isDateAfterMaxDate(day, finish)) {
      return true;
    }
    return false;
  }
  return {
    date,
    index,
    event: isDayEvent(date, events),
    selected: isDaySelected(date, selectedDays),
    disabled: isDayDisabled(date),
    blocked: isDayBlocked(date, blockDateList),
    allowed: isDayAllowed(date, allowedDateList)
  };
};
const daysToShow = (date, events, selectedDays, currentDate, start, finish, blockDateList, allowedDateList) => {
  const lastMonthDaysToShow = getLastMonthDaysToShow(date);
  const monthDaysToShow = getMonthDaysToShow(date);
  const nextMonthDaysToShow = getNextMonthDaysToShow(date, lastMonthDaysToShow.length + monthDaysToShow.length);
  const days = [...lastMonthDaysToShow, ...monthDaysToShow, ...nextMonthDaysToShow];
  const daysToShow = new Array(DAYSTOSHOWLENGTH);
  for (let i = 0; i < daysToShow.length; i++) {
    daysToShow[i] = createDayObject(days[i], {
      index: i
    }, events, selectedDays, currentDate, start, finish, blockDateList, allowedDateList);
  }
  return daysToShow;
};
const getLastMonthDaysToShow = date => {
  const lastMonth = getPrevMonth(date);
  const lastDay = getLastDayOfMonth(lastMonth);
  const lengthDays = getDaysToShowLengthOfLastMonth(lastDay?.getDay());
  return getLastMonthDays(lengthDays, lastDay);
};
const getPrevMonth = date => new Date(date?.getFullYear(), date?.getMonth() - 1);
const getLastDayOfMonth = date => new Date(date?.getFullYear(), date?.getMonth() + 1, 0);
const getDaysToShowLengthOfLastMonth = weekday => weekday === INDEXLASTDAYOFWEEK ? 0 : weekday + 1;
const getMonthDaysToShow = date => {
  const month = date?.getMonth();
  const year = date?.getFullYear();
  const lastDayMonth = getLastDayOfMonth(date);
  const lastDay = lastDayMonth?.getDate();
  const days = new Array(lastDayMonth);
  for (let i = 0; i < lastDay; i++) {
    const date = new Date(year, month, i + 1);
    days[i] = date;
  }
  return days;
};
const getNextMonthDaysToShow = (date, showDays) => {
  const nextMonth = getNextMonth(date);
  const lengthDays = getDaysToShowLengthOfNextMonth(showDays);
  return getNextMonthDays(lengthDays, nextMonth);
};
const getNextMonth = date => new Date(date?.getFullYear(), date?.getMonth() + 1, 1);
const getDaysToShowLengthOfNextMonth = showDays => DAYSTOSHOWLENGTH - showDays;
const getNextMonthDays = (lengthDays, nextMonth) => {
  const days = [];
  for (let i = 1; days.length < lengthDays; i++) {
    const day = new Date(nextMonth?.getFullYear(), nextMonth?.getMonth(), i);
    days.push(day);
  }
  return days;
};
const getLastMonthDays = (lengthDays, lastDay) => {
  const days = [];
  for (let i = lastDay?.getDate(); days.length < lengthDays; i--) {
    const day = new Date(lastDay?.getFullYear(), lastDay?.getMonth(), i);
    days.unshift(day);
  }
  return days;
};
const isDateBeforeMinDate = (date, start) => {
  if (start) {
    const diff = compareDates(date, start);
    if (diff < 0) {
      return true;
    }
  }
  return false;
};
const isDateAfterMaxDate = (date, finish) => {
  if (finish) {
    const diff = compareDates(date, finish);
    if (diff > 0) {
      return true;
    }
  }
  return false;
};
const compareDates = (date, dateCompare) => {
  return date?.valueOf() - dateCompare?.valueOf();
};
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarDayLayout.vue?vue&type=template&id=b1e06698&ts=true

const CalendarDayLayoutvue_type_template_id_b1e06698_ts_true_hoisted_1 = {
  id: "days-view",
  class: "c-datepicker__days"
};
function CalendarDayLayoutvue_type_template_id_b1e06698_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqHeader = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqHeader");
  const _component_OrqDays = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqDays");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", CalendarDayLayoutvue_type_template_id_b1e06698_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqHeader, {
    view: _ctx.view,
    setView: _ctx.setView,
    currentDate: _ctx.currentDate,
    inverse: _ctx.inverse,
    onGoToNextMonth: _ctx.goToNextMonth,
    onGoToPrevMonth: _ctx.goToPrevMonth,
    onHandleclickmonth: _cache[0] || (_cache[0] = $event => _ctx.handleClickMonth('month'))
  }, null, 8, ["view", "setView", "currentDate", "inverse", "onGoToNextMonth", "onGoToPrevMonth"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqDays, {
    inverse: _ctx.inverse,
    days: _ctx.daysToShow,
    selectedDays: _ctx.selectedDays,
    range: _ctx.range,
    weekendAvailable: _ctx.weekendAvailable,
    withBlockList: _ctx.withBlockList,
    withAllowedList: _ctx.withAllowedList,
    onSelectDay: _ctx.handleClick,
    startDateValue: _ctx.startDateValue,
    endDateValue: _ctx.endDateValue
  }, null, 8, ["inverse", "days", "selectedDays", "range", "weekendAvailable", "withBlockList", "withAllowedList", "onSelectDay", "startDateValue", "endDateValue"])]);
}
;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarDayLayout.vue?vue&type=template&id=b1e06698&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Days.vue?vue&type=template&id=0a7c4a07&ts=true

const Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_1 = {
  class: ""
};
const Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_2 = {
  class: "c-datepicker__days__grid c-datepicker__days__week-days grid"
};
const Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_3 = {
  class: "c-datepicker__days__grid c-datepicker__days__month-days grid"
};
const Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_4 = ["onClick"];
const Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_5 = {
  class: "tooltip"
};
const Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_6 = {
  key: 0,
  class: "today"
};
const Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_7 = {
  class: "event-day"
};
function Daysvue_type_template_id_0a7c4a07_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqBullet = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqBullet");
  const _component_OrqTooltip = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqTooltip");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.WEEKDAYS, (day, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(day), 1)]);
  }), 128))]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_3, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.days, (day, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.handleDay(day)) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([_ctx.applyStyle(day), _ctx.getBlockedClass(day.blocked), _ctx.getAllowedClass(day.allowed)]),
      role: "button",
      onClick: $event => _ctx.handleClick(day, index)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(day.date?.getDate()), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_5, [new Date().toLocaleDateString() === day.date.toLocaleDateString() && !day.selected ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqBullet, {
      appearance: "info",
      inverse: _ctx.inverse,
      value: index
    }, null, 8, ["inverse", "value"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), day.event.length > 0 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqTooltip, {
      key: 1,
      label: day.event[0].message,
      inverse: _ctx.inverse,
      type: "hover",
      direction: "right"
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_7, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqBullet, {
        appearance: "info",
        inverse: _ctx.inverse,
        value: index
      }, null, 8, ["inverse", "value"])])]),
      _: 2
    }, 1032, ["label", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])], 10, Daysvue_type_template_id_0a7c4a07_ts_true_hoisted_4)], 64);
  }), 128))])]);
}
;// CONCATENATED MODULE: ./src/components/Calendar/components/Days.vue?vue&type=template&id=0a7c4a07&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tooltip/Tooltip.vue?vue&type=template&id=ce921f96&ts=true

const Tooltipvue_type_template_id_ce921f96_ts_true_hoisted_1 = {
  class: "orq-tooltip__content"
};
const Tooltipvue_type_template_id_ce921f96_ts_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
  class: "orq-tooltip__arrow"
}, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
  class: "orq-tooltip__arrow__content"
})], -1);
const Tooltipvue_type_template_id_ce921f96_ts_true_hoisted_3 = {
  class: "orq-tooltip__content__inner"
};
const Tooltipvue_type_template_id_ce921f96_ts_true_hoisted_4 = {
  key: 0,
  class: "orq-icon-container",
  role: "button"
};
function Tooltipvue_type_template_id_ce921f96_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    role: "button",
    onMouseover: _cache[0] || (_cache[0] = $event => _ctx.handleTooltipType('hover')),
    onMouseleave: _cache[1] || (_cache[1] = $event => _ctx.handleTooltipType('hover')),
    onClick: _cache[2] || (_cache[2] = $event => _ctx.handleTooltipType('click'))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 32), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.showTooltip)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.tooltipClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Tooltipvue_type_template_id_ce921f96_ts_true_hoisted_1, [Tooltipvue_type_template_id_ce921f96_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Tooltipvue_type_template_id_ce921f96_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label) + " ", 1), _ctx.trigger === 'click' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", Tooltipvue_type_template_id_ce921f96_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    name: "close",
    type: "none",
    inverse: _ctx.inverse,
    color: _ctx.iconColor,
    onClick: _cache[3] || (_cache[3] = $event => _ctx.onClose($event))
  }, null, 8, ["inverse", "color"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])], 2)], 2)], 64);
}
;// CONCATENATED MODULE: ./src/components/Tooltip/Tooltip.vue?vue&type=template&id=ce921f96&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tooltip/Tooltip.vue?vue&type=script&lang=ts



/* harmony default export */ var Tooltipvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqTooltip",
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: "top"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    }
  },
  components: {
    OrqIconContainer: IconContainer
  },
  data() {
    return {
      showTooltip: "orq-tooltip--hide"
    };
  },
  methods: {
    handleTooltipType(action) {
      if (action === "click") {
        if (this.trigger === "click") {
          if (this.showTooltip === "orq-tooltip--hide") {
            this.showTooltip = "orq-tooltip--fade";
          }
        }
      } else {
        if (this.trigger === "hover") {
          if (this.showTooltip === "orq-tooltip--hide") {
            this.showTooltip = "orq-tooltip--fade";
          } else {
            this.showTooltip = "orq-tooltip--hide";
          }
        }
      }
    }
  },
  setup(props, {
    emit
  }) {
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    const onClose = event => {
      emit("close", event);
    };
    return {
      onClose,
      tooltipClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        "orq-tooltip": true,
        [`orq-tooltip--placement-${props.placement}`]: true,
        "orq-tooltip--inverse": props.inverse
      })),
      iconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return props.inverse ? iconColors.value.emphasisBaseHigh : iconColors.value.emphasisBaseInverseHigh;
      })
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Tooltip/Tooltip.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tooltip/Tooltip.vue?vue&type=style&index=0&id=ce921f96&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Tooltip/Tooltip.vue?vue&type=style&index=0&id=ce921f96&lang=scss

;// CONCATENATED MODULE: ./src/components/Tooltip/Tooltip.vue




;


const Tooltip_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Tooltipvue_type_script_lang_ts, [['render',Tooltipvue_type_template_id_ce921f96_ts_true_render]])

/* harmony default export */ var Tooltip = (Tooltip_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Days.vue?vue&type=script&lang=ts




/* harmony default export */ var Daysvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqDays",
  components: {
    OrqBullet: Bullet,
    OrqTooltip: Tooltip
  },
  props: {
    days: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: false
    },
    changeSelectedDay: {
      type: Function
    },
    selectedDays: {
      type: Array
    },
    range: {
      type: Boolean
    },
    weekendAvailable: {
      type: Boolean,
      default: false
    },
    withBlockList: {
      type: Boolean,
      default: false
    },
    withAllowedList: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const WEEKDAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
    const selectedDaysRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.selectedDays);
    const INDEXFIRSTDAYOFWEEK = props.weekendAvailable ? 0 : 1;
    const INDEXLASTDAYOFWEEK = props.weekendAvailable ? 6 : 5;
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.selectedDays, (nv, oldv) => {
      selectedDaysRef.value = nv;
    });
    function applyRangePositionStyle(day) {
      if (props.range === false) {
        return "";
      }
      if (day.date > selectedDaysRef.value[0] && day.date < selectedDaysRef.value[1]) {
        const weekday = day.date.getDay();
        switch (weekday) {
          case INDEXFIRSTDAYOFWEEK:
            return "c-datepicker__days__grid__day--between-left";
          case INDEXLASTDAYOFWEEK:
            return "c-datepicker__days__grid__day--between-right";
          default:
            return "c-datepicker__days__grid__day--between-middle";
        }
      }
      return "";
    }
    function applyRangeStyle(day) {
      if (props.range) if (selectedDaysRef.value[0] && day.date.getTime() === selectedDaysRef.value[0]?.getTime()) {
        if (selectedDaysRef.value[0].getTime() === selectedDaysRef.value[1].getTime()) {
          return "";
        }
        return "c-datepicker__days__grid__day--between-left";
      }
      if (selectedDaysRef.value[1] && day.date.getTime() === selectedDaysRef.value[1]?.getTime()) {
        return "c-datepicker__days__grid__day--between-right";
      }
      return "";
    }
    const disabledClass = "c-datepicker__days__grid__day c-datepicker__days__grid__day--disabled";
    function applyStyle(day) {
      const styles = ["c-datepicker__days__grid__day"];
      if (day.disabled) return disabledClass;
      if (day.selected) {
        styles.push("c-datepicker__days__grid__day--selected");
      }
      if (selectedDaysRef.value.length === 2) {
        styles.push(applyRangeStyle(day));
        styles.push(applyRangePositionStyle(day));
      }
      return styles;
    }
    const getBlockedClass = day => {
      return day && props.withBlockList ? disabledClass : "";
    };
    const getAllowedClass = day => {
      return !day && props.withAllowedList ? disabledClass : "";
    };
    const handleClick = (day, indexDay) => {
      emit("selectDay", day, indexDay);
    };
    const handleDay = day => {
      const getDay = day => {
        return day.getDay();
      };
      if (!props.weekendAvailable) {
        if (getDay(day.date) == 0 || getDay(day.date) == 6) {
          day.disabled = true;
        }
      }
    };
    return {
      selectedDaysRef,
      WEEKDAYS,
      applyStyle,
      getBlockedClass,
      getAllowedClass,
      handleClick,
      handleDay
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/components/Days.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Days.vue?vue&type=style&index=0&id=0a7c4a07&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Calendar/components/Days.vue?vue&type=style&index=0&id=0a7c4a07&lang=scss

;// CONCATENATED MODULE: ./src/components/Calendar/components/Days.vue




;


const Days_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Daysvue_type_script_lang_ts, [['render',Daysvue_type_template_id_0a7c4a07_ts_true_render]])

/* harmony default export */ var Days = (Days_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Header.vue?vue&type=template&id=06a060ac&ts=true

const Headervue_type_template_id_06a060ac_ts_true_hoisted_1 = {
  class: "c-datepicker__header c-datepicker__days-header"
};
function Headervue_type_template_id_06a060ac_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Headervue_type_template_id_06a060ac_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: "arrow-icon pointer",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.goToPrevMonth && _ctx.goToPrevMonth(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "chevron-left",
    size: 24,
    color: _ctx.inverseClass
  }, null, 8, ["color"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    onMousedown: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.onMousePressedHandler && _ctx.onMousePressedHandler(...args)),
    onMouseup: _cache[3] || (_cache[3] =
    //@ts-ignore
    (...args) => _ctx.onMousePressedHandler && _ctx.onMousePressedHandler(...args)),
    class: "c-datepicker__days__header-center pointer"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.handleClick('month'))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(`${_ctx.MONTHS[_ctx.monthsRef]} ${_ctx.currentDate?.getFullYear()}`), 1)], 32), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: "arrow-icon pointer",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.goToNextMonth())
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "chevron-right",
    size: 24,
    color: _ctx.inverseClass
  }, null, 8, ["color"])])]);
}
;// CONCATENATED MODULE: ./src/components/Calendar/components/Header.vue?vue&type=template&id=06a060ac&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Header.vue?vue&type=script&lang=ts



/* harmony default export */ var Headervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqHeader",
  components: {
    OrqIconContainer: IconContainer
  },
  props: {
    setView: {
      type: Function
    },
    view: {
      type: String
    },
    currentDate: {
      type: Date
    },
    setCurrentDate: {
      type: Function
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const monthsRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(MONTHS);
    const currentDateRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.currentDate);
    const inverseClass = props.inverse ? "emphasis-base-medium-inverse" : "emphasis-base-medium";
    const handleClick = i => {
      emit("handleclickmonth", i);
    };
    function goToNextMonth() {
      if (currentDateRef.value.getMonth() === 11) {
        monthsRef.value = 0;
        currentDateRef.value?.setFullYear(currentDateRef.value?.getFullYear() + 1);
        emit("goToNextMonth", monthsRef.value);
        return;
      }
      monthsRef.value = currentDateRef.value.getMonth() + 1;
      emit("goToNextMonth", monthsRef.value);
    }
    function goToPrevMonth() {
      if (currentDateRef.value?.getMonth() === 0) {
        monthsRef.value = 11;
        currentDateRef.value.setFullYear(currentDateRef.value?.getFullYear() - 1);
        emit("goToPrevMonth", monthsRef.value);
        return;
      }
      monthsRef.value = currentDateRef.value?.getMonth() - 1;
      emit("goToPrevMonth", monthsRef.value);
    }
    const onMousePressedHandler = e => {
      e.currentTarget.classList.toggle("pressed");
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      monthsRef.value = currentDateRef.value?.getMonth();
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      monthsRef.value = props.currentDate?.getMonth();
      currentDateRef.value = props.currentDate;
    });
    return {
      inverseClass,
      handleClick,
      goToNextMonth,
      goToPrevMonth,
      onMousePressedHandler,
      MONTHS: MONTHS,
      currentDateRef,
      monthsRef
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/components/Header.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Header.vue?vue&type=style&index=0&id=06a060ac&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Calendar/components/Header.vue?vue&type=style&index=0&id=06a060ac&lang=scss

;// CONCATENATED MODULE: ./src/components/Calendar/components/Header.vue




;


const Header_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Headervue_type_script_lang_ts, [['render',Headervue_type_template_id_06a060ac_ts_true_render]])

/* harmony default export */ var Header = (Header_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarDayLayout.vue?vue&type=script&lang=ts



/* harmony default export */ var CalendarDayLayoutvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "DayLayout",
  components: {
    OrqDays: Days,
    OrqHeader: Header
  },
  props: {
    events: {
      type: Array
    },
    setView: {
      type: Function
    },
    view: {
      type: String
    },
    daysToShow: {
      type: Array,
      default: () => []
    },
    setCurrentDate: {
      type: Function
    },
    selectedDays: {
      type: Array
    },
    currentDate: {
      type: Date
    },
    range: {
      type: Boolean
    },
    inverse: {
      type: Boolean,
      default: false
    },
    weekendAvailable: {
      type: Boolean
    },
    blockDateList: {
      type: Array
    },
    withBlockList: {
      type: Boolean
    },
    allowedDateList: {
      type: Array
    },
    withAllowedList: {
      type: Boolean
    },
    startDateValue: {
      type: String,
      default: ""
    },
    endDateValue: {
      type: String,
      default: ""
    }
  },
  setup(props, {
    emit
  }) {
    const viewRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.view);
    const currentDateRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.currentDate);
    let currentMonth = currentDateRef.value.getMonth();
    const goToPrevMonth = () => {
      currentMonth = currentMonth > 0 ? currentMonth - 1 : 11;
      currentDateRef.value.setMonth(currentMonth);
      emit("goToPrevMonth");
    };
    const goToNextMonth = () => {
      currentMonth = currentMonth < 11 ? currentMonth + 1 : 0;
      currentDateRef.value.setMonth(currentMonth);
      emit("goToNextMonth");
    };
    const canSelectDay = day => {
      if (day.disabled || day.blocked && props.withBlockList || !day.allowed && props.withAllowedList) {
        return false;
      }
      return true;
    };
    const handleClick = (day, indexDay) => {
      if (!canSelectDay(day)) {
        return;
      }
      emit("selectDay", day, indexDay);
    };
    const handleClickMonth = i => {
      emit("handleclickmonth", i);
    };
    return {
      goToNextMonth,
      goToPrevMonth,
      currentDateRef,
      viewRef,
      handleClick,
      handleClickMonth
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarDayLayout.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarDayLayout.vue?vue&type=style&index=0&id=b1e06698&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarDayLayout.vue?vue&type=style&index=0&id=b1e06698&lang=scss

;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarDayLayout.vue




;


const CalendarDayLayout_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CalendarDayLayoutvue_type_script_lang_ts, [['render',CalendarDayLayoutvue_type_template_id_b1e06698_ts_true_render]])

/* harmony default export */ var CalendarDayLayout = (CalendarDayLayout_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarMonthLayout.vue?vue&type=template&id=39775c7c&ts=true

const CalendarMonthLayoutvue_type_template_id_39775c7c_ts_true_hoisted_1 = {
  id: "months-view",
  class: "c-datepicker__months"
};
function CalendarMonthLayoutvue_type_template_id_39775c7c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqMonthsHeader = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqMonthsHeader");
  const _component_OrqMonths = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqMonths");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", CalendarMonthLayoutvue_type_template_id_39775c7c_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqMonthsHeader, {
    view: _ctx.viewRef,
    setView: _ctx.setView,
    currentDate: _ctx.currentDate,
    setCurrentDate: _ctx.setCurrentDate,
    inverse: _ctx.inverse,
    setDate: _ctx.setDate,
    onHandleclickyear: _cache[0] || (_cache[0] = $event => _ctx.handleClickYear('year'))
  }, null, 8, ["view", "setView", "currentDate", "setCurrentDate", "inverse", "setDate"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqMonths, {
    view: _ctx.view,
    setView: _ctx.setView,
    currentDate: _ctx.currentDateRef,
    setCurrentDate: _ctx.setCurrentDate,
    onChangeselectedmonth: _ctx.handleSelectedMonth
  }, null, 8, ["view", "setView", "currentDate", "setCurrentDate", "onChangeselectedmonth"])]);
}
;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarMonthLayout.vue?vue&type=template&id=39775c7c&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/HeaderMonth.vue?vue&type=template&id=46132ca2&ts=true

const HeaderMonthvue_type_template_id_46132ca2_ts_true_hoisted_1 = {
  class: "c-datepicker__header c-datepicker__months__header"
};
function HeaderMonthvue_type_template_id_46132ca2_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", HeaderMonthvue_type_template_id_46132ca2_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: "arrow-icon pointer",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.goToPrevYear && _ctx.goToPrevYear(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "chevron-left",
    size: 24,
    color: _ctx.inverseClass
  }, null, 8, ["color"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    id: "year-button",
    class: "pointer",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.handleClick('year'))
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.currentDateRef?.getFullYear()), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: "arrow-icon pointer",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.goToNextYear && _ctx.goToNextYear(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "chevron-right",
    size: 24,
    color: _ctx.inverseClass
  }, null, 8, ["color"])])]);
}
;// CONCATENATED MODULE: ./src/components/Calendar/components/HeaderMonth.vue?vue&type=template&id=46132ca2&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/HeaderMonth.vue?vue&type=script&lang=ts



/* harmony default export */ var HeaderMonthvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "HeaderMonth",
  components: {
    OrqIconContainer: IconContainer
  },
  props: {
    setView: {
      type: Function
    },
    view: {
      type: String
    },
    currentDate: {
      type: Date
    },
    setCurrentDate: {
      type: Function
    },
    inverse: {
      type: Boolean,
      default: false
    },
    setDate: {
      type: Function
    }
  },
  setup(props, {
    emit
  }) {
    const currentDateRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.currentDate);
    const viewRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.view);
    const setDateRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.setDate);
    const inverseClass = props.inverse ? "emphasis-base-medium-inverse" : "emphasis-base-medium";
    const handleClick = i => {
      emit("handleclickyear", i);
    };
    function goToNextYear() {
      if (currentDateRef.value) {
        currentDateRef.value = new Date(currentDateRef.value.getFullYear() + 1, currentDateRef.value.getMonth(), currentDateRef.value.getDate());
        setDateRef.value(currentDateRef.value);
      }
    }
    function goToPrevYear() {
      if (currentDateRef.value) {
        currentDateRef.value = new Date(currentDateRef.value.getFullYear() - 1, currentDateRef.value.getMonth(), currentDateRef.value.getDate());
        setDateRef.value(currentDateRef.value);
      }
    }
    return {
      inverseClass,
      MONTHS: MONTHS,
      viewRef,
      handleClick,
      goToNextYear,
      goToPrevYear,
      currentDateRef
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/components/HeaderMonth.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/HeaderMonth.vue?vue&type=style&index=0&id=46132ca2&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Calendar/components/HeaderMonth.vue?vue&type=style&index=0&id=46132ca2&lang=scss

;// CONCATENATED MODULE: ./src/components/Calendar/components/HeaderMonth.vue




;


const HeaderMonth_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(HeaderMonthvue_type_script_lang_ts, [['render',HeaderMonthvue_type_template_id_46132ca2_ts_true_render]])

/* harmony default export */ var HeaderMonth = (HeaderMonth_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Months.vue?vue&type=template&id=17b4d55b&ts=true

const Monthsvue_type_template_id_17b4d55b_ts_true_hoisted_1 = {
  class: "c-datepicker__months__grid grid"
};
const Monthsvue_type_template_id_17b4d55b_ts_true_hoisted_2 = ["onClick"];
function Monthsvue_type_template_id_17b4d55b_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Monthsvue_type_template_id_17b4d55b_ts_true_hoisted_1, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.MONTHS, month => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
      key: _ctx.MONTHS.indexOf(month),
      class: "pointer c-datepicker__month--button",
      onClick: $event => _ctx.changeSelectedMonth(month)
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(month), 9, Monthsvue_type_template_id_17b4d55b_ts_true_hoisted_2);
  }), 128))]);
}
;// CONCATENATED MODULE: ./src/components/Calendar/components/Months.vue?vue&type=template&id=17b4d55b&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Months.vue?vue&type=script&lang=ts


/* harmony default export */ var Monthsvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqMonths",
  components: {},
  props: {
    setView: {
      type: Function
    },
    view: {
      type: String
    },
    currentDate: {
      type: Date
    },
    setCurrentDate: {
      type: Function
    }
  },
  setup(props, {
    emit
  }) {
    const setCurrentDateRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.setCurrentDate);
    function changeSelectedMonth(month) {
      setCurrentDateRef.value = new Date(props.currentDate?.getFullYear(), MONTHS?.indexOf(month), props.currentDate?.getDate());
      emit("changeselectedmonth", setCurrentDateRef.value);
    }
    return {
      MONTHS: MONTHS,
      changeSelectedMonth
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/components/Months.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Months.vue?vue&type=style&index=0&id=17b4d55b&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Calendar/components/Months.vue?vue&type=style&index=0&id=17b4d55b&lang=scss

;// CONCATENATED MODULE: ./src/components/Calendar/components/Months.vue




;


const Months_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Monthsvue_type_script_lang_ts, [['render',Monthsvue_type_template_id_17b4d55b_ts_true_render]])

/* harmony default export */ var Months = (Months_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarMonthLayout.vue?vue&type=script&lang=ts



/* harmony default export */ var CalendarMonthLayoutvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "MonthLayout",
  components: {
    OrqMonthsHeader: HeaderMonth,
    OrqMonths: Months
  },
  props: {
    setView: {
      type: Function
    },
    view: {
      type: String
    },
    currentDate: {
      type: Date
    },
    setCurrentDate: {
      type: Function
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const viewRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.view);
    const currentDateRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.currentDate);
    const setDate = date => {
      currentDateRef.value = date;
    };
    const handleClickYear = i => {
      emit("handleclickyear", i);
    };
    const handleSelectedMonth = month => {
      emit("handleselectedmonth", month);
    };
    return {
      handleClickYear,
      viewRef,
      setDate,
      currentDateRef,
      handleSelectedMonth
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarMonthLayout.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarMonthLayout.vue?vue&type=style&index=0&id=39775c7c&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarMonthLayout.vue?vue&type=style&index=0&id=39775c7c&lang=scss

;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarMonthLayout.vue




;


const CalendarMonthLayout_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CalendarMonthLayoutvue_type_script_lang_ts, [['render',CalendarMonthLayoutvue_type_template_id_39775c7c_ts_true_render]])

/* harmony default export */ var CalendarMonthLayout = (CalendarMonthLayout_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarYearLayout.vue?vue&type=template&id=1a4581dd&ts=true

const CalendarYearLayoutvue_type_template_id_1a4581dd_ts_true_hoisted_1 = {
  id: "years-view",
  class: "c-datepicker__years"
};
function CalendarYearLayoutvue_type_template_id_1a4581dd_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HeaderYear = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("HeaderYear");
  const _component_Years = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("Years");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", CalendarYearLayoutvue_type_template_id_1a4581dd_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_HeaderYear, {
    setView: _ctx.setView,
    rangeDate: _ctx.yearRangeRef,
    setCurrentDate: _ctx.setCurrentDate,
    inverse: _ctx.inverse,
    onYearrange: _ctx.getYearRange
  }, null, 8, ["setView", "rangeDate", "setCurrentDate", "inverse", "onYearrange"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_Years, {
    setView: _ctx.setView,
    rangeDate: _ctx.yearRangeRef,
    setCurrentDate: _ctx.setCurrentDate,
    onChangeselectedyear: _ctx.changeSelectedYear
  }, null, 8, ["setView", "rangeDate", "setCurrentDate", "onChangeselectedyear"])]);
}
;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarYearLayout.vue?vue&type=template&id=1a4581dd&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Years.vue?vue&type=template&id=58bc4137&ts=true

const Yearsvue_type_template_id_58bc4137_ts_true_hoisted_1 = {
  class: "c-datepicker__years__grid grid"
};
const Yearsvue_type_template_id_58bc4137_ts_true_hoisted_2 = ["onClick"];
const Yearsvue_type_template_id_58bc4137_ts_true_hoisted_3 = {
  class: "pointer"
};
function Yearsvue_type_template_id_58bc4137_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Yearsvue_type_template_id_58bc4137_ts_true_hoisted_1, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.years, (year, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
      key: index,
      onClick: $event => _ctx.changeSelectedYear(year)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", Yearsvue_type_template_id_58bc4137_ts_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(year), 1)], 8, Yearsvue_type_template_id_58bc4137_ts_true_hoisted_2);
  }), 128))]);
}
;// CONCATENATED MODULE: ./src/components/Calendar/components/Years.vue?vue&type=template&id=58bc4137&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/Years.vue?vue&type=script&lang=ts


/* harmony default export */ var Yearsvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqYears",
  props: {
    setView: {
      type: Function
    },
    rangeDate: {
      type: Array
    },
    setCurrentDate: {
      type: Function
    }
  },
  setup(props, {
    emit
  }) {
    const rangeDateRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.rangeDate);
    const years = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    function getYears() {
      years.value = [];
      for (let i = rangeDateRef.value[0].getFullYear(); i <= rangeDateRef.value[1].getFullYear(); i++) {
        years.value.push(i);
      }
    }
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      getYears();
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.rangeDate, (nv, olv) => {
      rangeDateRef.value = nv;
      getYears();
    });
    function changeSelectedYear(year) {
      emit("changeselectedyear", year);
    }
    return {
      changeSelectedYear,
      getYears,
      years
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/components/Years.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/components/Calendar/components/Years.vue




;
const Years_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Yearsvue_type_script_lang_ts, [['render',Yearsvue_type_template_id_58bc4137_ts_true_render]])

/* harmony default export */ var Years = (Years_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/HeaderYear.vue?vue&type=template&id=06e6d8ee&ts=true

const HeaderYearvue_type_template_id_06e6d8ee_ts_true_hoisted_1 = {
  class: "c-datepicker__header datepicker__years__header"
};
function HeaderYearvue_type_template_id_06e6d8ee_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", HeaderYearvue_type_template_id_06e6d8ee_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: "arrow-icon pointer",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.goToPrevYearRange && _ctx.goToPrevYearRange(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "chevron-left",
    size: 24,
    color: _ctx.inverseClass
  }, null, 8, ["color"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.renderYears), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: "arrow-icon pointer",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.goToNextYearRange && _ctx.goToNextYearRange(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "chevron-right",
    size: 24,
    color: _ctx.inverseClass
  }, null, 8, ["color"])])]);
}
;// CONCATENATED MODULE: ./src/components/Calendar/components/HeaderYear.vue?vue&type=template&id=06e6d8ee&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/HeaderYear.vue?vue&type=script&lang=ts


/* harmony default export */ var HeaderYearvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "HeaderYear",
  components: {
    OrqIconContainer: IconContainer
  },
  props: {
    rangeDate: {
      type: Array
    },
    setCurrentDate: {
      type: Function
    },
    inverse: {
      type: Boolean,
      default: false
    },
    startRangeDate: {
      type: Number
    },
    endRangeDate: {
      type: Number
    }
  },
  setup(props, {
    emit
  }) {
    const rangeDateRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.rangeDate);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.rangeDate, (nv, olv) => {
      rangeDateRef.value = nv;
    });
    const inverseClass = props.inverse ? "emphasis-base-medium-inverse" : "emphasis-base-medium";
    function goToNextYearRange() {
      emit("yearrange", "next");
    }
    function goToPrevYearRange() {
      emit("yearrange", "prev");
    }
    return {
      renderYears: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return rangeDateRef.value[0].getFullYear() + "-" + rangeDateRef.value[1].getFullYear();
      }),
      inverseClass,
      rangeDateRef,
      goToNextYearRange,
      goToPrevYearRange
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/components/HeaderYear.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/components/HeaderYear.vue?vue&type=style&index=0&id=06e6d8ee&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Calendar/components/HeaderYear.vue?vue&type=style&index=0&id=06e6d8ee&lang=scss

;// CONCATENATED MODULE: ./src/components/Calendar/components/HeaderYear.vue




;


const HeaderYear_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(HeaderYearvue_type_script_lang_ts, [['render',HeaderYearvue_type_template_id_06e6d8ee_ts_true_render]])

/* harmony default export */ var HeaderYear = (HeaderYear_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarYearLayout.vue?vue&type=script&lang=ts



/* harmony default export */ var CalendarYearLayoutvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "YearLayout",
  components: {
    Years: Years,
    HeaderYear: HeaderYear
  },
  props: {
    setView: {
      type: Function
    },
    currentDate: {
      type: Date,
      default: new Date()
    },
    setCurrentDate: {
      type: Function
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const yearRangeRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([new Date(props.currentDate.getFullYear() - 9, 0), new Date(props.currentDate.getFullYear() + 10, 0)]);
    function changeYearForwardOrBackward(direction) {
      let currentYear = yearRangeRef.value;
      switch (direction) {
        case "prev":
          yearRangeRef.value = [new Date(currentYear[0].getFullYear() - 10, 0), new Date(currentYear[1].getFullYear() - 10, 0)];
          break;
        case "next":
          yearRangeRef.value = [new Date(currentYear[0].getFullYear() + 10, 0), new Date(currentYear[1].getFullYear() + 10, 0)];
          break;
        default:
          break;
      }
    }
    function getYearRange(direction) {
      changeYearForwardOrBackward(direction);
    }
    function changeSelectedYear(year) {
      emit("changeselectedyear", year);
    }
    return {
      changeSelectedYear,
      getYearRange,
      yearRangeRef
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarYearLayout.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarYearLayout.vue?vue&type=style&index=0&id=1a4581dd&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarYearLayout.vue?vue&type=style&index=0&id=1a4581dd&lang=scss

;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarYearLayout.vue




;


const CalendarYearLayout_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CalendarYearLayoutvue_type_script_lang_ts, [['render',CalendarYearLayoutvue_type_template_id_1a4581dd_ts_true_render]])

/* harmony default export */ var CalendarYearLayout = (CalendarYearLayout_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/views/CalendarDatePicker.vue?vue&type=script&lang=ts





/* harmony default export */ var CalendarDatePickervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqDatepicker",
  components: {
    DayLayout: CalendarDayLayout,
    MonthLayout: CalendarMonthLayout,
    YearLayout: CalendarYearLayout
  },
  props: {
    daysToShow: {
      type: Array,
      default: () => []
    },
    events: {
      type: Array
    },
    range: {
      type: Boolean
    },
    inverse: {
      type: Boolean,
      default: false
    },
    weekendAvailable: {
      type: Boolean
    },
    blockDateList: {
      type: Array
    },
    withBlockList: {
      type: Boolean
    },
    allowedDateList: {
      type: Array
    },
    withAllowedList: {
      type: Boolean
    },
    view: {
      type: String
    },
    setView: {
      type: Function
    },
    setCurrentDate: {
      type: Function
    },
    currentDate: {
      type: Date
    },
    selectedDays: {
      type: Array
    },
    startDateValue: {
      type: String,
      default: ""
    },
    endDateValue: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      OrquestraDatePickerViewEnum: OrquestraDatePickerViewEnum
    };
  },
  setup(props, {
    emit
  }) {
    const viewRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.view);
    const selectedDaysRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.selectedDays);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.selectedDays, (nv, olv) => {
      selectedDaysRef.value = nv;
    });
    const goToPrevMonth = monthRef => {
      emit("goToPrevMonth", monthRef);
    };
    const goToNextMonth = monthRef => {
      emit("goToNextMonth", monthRef);
    };
    const selectDay = (day, indexDay) => {
      emit("selectDay", day, indexDay);
    };
    const handleSwitchView = i => {
      emit("handleswitchview", i);
    };
    const handleSelectedMonth = month => {
      emit("handleselectedmonth", month);
    };
    const handleRenderMonth = year => {
      emit("handlerendermonth", year);
    };
    return {
      selectedDaysRef,
      selectDay,
      goToPrevMonth,
      goToNextMonth,
      handleSwitchView,
      viewRef,
      handleRenderMonth,
      handleSelectedMonth
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarDatePicker.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/components/Calendar/views/CalendarDatePicker.vue




;
const CalendarDatePicker_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CalendarDatePickervue_type_script_lang_ts, [['render',CalendarDatePickervue_type_template_id_1ba5f93f_ts_true_render]])

/* harmony default export */ var CalendarDatePicker = (CalendarDatePicker_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/CalendarSingleDatePicker.vue?vue&type=script&lang=ts



/* harmony default export */ var CalendarSingleDatePickervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "SingleDatePicker",
  components: {
    SingleDatePickerWrapper: CalendarSingleDatePickerWrapper,
    Datepicker: CalendarDatePicker
  },
  props: {
    daysToShow: {
      type: Array,
      default: () => []
    },
    events: {
      type: Array
    },
    range: {
      type: Boolean
    },
    mode: {
      type: String
    },
    inverse: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array
    },
    weekendAvailable: {
      type: Boolean
    },
    blockDateList: {
      type: Array
    },
    withBlockList: {
      type: Boolean
    },
    allowedDateList: {
      type: Array
    },
    withAllowedList: {
      type: Boolean
    },
    setSelectedDays: {
      type: Function
    },
    selectedDays: {
      type: Array
    },
    startDateValue: {
      type: String,
      default: ""
    },
    endDateValue: {
      type: String,
      default: ""
    }
  },
  setup(props, {
    emit
  }) {
    let view = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("day");
    const selectedDaysRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.selectedDays);
    const currentDate = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(Array.isArray(props.value) && props.value?.length > 0 ? props.value[0] !== undefined ? props.value[0] : props.value[1] : new Date());
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.selectedDays, (nv, olv) => {
      selectedDaysRef.value = nv;
    });
    const goToPrevMonth = () => {
      emit("goToPrevMonth");
    };
    const goToNextMonth = () => {
      emit("goToNextMonth");
    };
    const selectDay = (day, indexDay) => {
      emit("selectDay", day, indexDay);
    };
    function setToday() {
      const today = new Date(new Date()?.getFullYear(), new Date()?.getMonth(), new Date()?.getDate());
      currentDate.value = today;
      if (view.value === "year" || view.value === "month") {
        view.value = "day";
      }
      emit("handleToday", today);
    }
    const renderclickMonth = i => {
      view.value = i;
    };
    const handleSelectedMonth = month => {
      currentDate.value.setMonth(month.getMonth());
      view.value = "day";
      emit("handleselectedmonth", month);
    };
    const handleSelectedYear = year => {
      currentDate.value.setFullYear(year);
      view.value = "month";
      emit("handleselectedyear", currentDate.value);
    };
    return {
      setToday,
      view,
      selectDay,
      currentDate,
      selectedDaysRef,
      goToNextMonth,
      goToPrevMonth,
      handleSelectedMonth,
      handleSelectedYear,
      renderclickMonth
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/CalendarSingleDatePicker.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/CalendarSingleDatePicker.vue?vue&type=style&index=0&id=00fc1bb8&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Calendar/CalendarSingleDatePicker.vue?vue&type=style&index=0&id=00fc1bb8&lang=scss

;// CONCATENATED MODULE: ./src/components/Calendar/CalendarSingleDatePicker.vue




;


const CalendarSingleDatePicker_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CalendarSingleDatePickervue_type_script_lang_ts, [['render',CalendarSingleDatePickervue_type_template_id_00fc1bb8_ts_true_render]])

/* harmony default export */ var CalendarSingleDatePicker = (CalendarSingleDatePicker_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/Calendar.vue?vue&type=script&lang=ts



/* harmony default export */ var Calendarvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqCalendar",
  components: {
    SingleDatePicker: CalendarSingleDatePicker
  },
  props: {
    events: {
      type: Array,
      default: () => []
    },
    range: {
      type: Boolean,
      default: false
    },
    startDateValue: {
      type: String,
      default: ""
    },
    endDateValue: {
      type: String,
      default: ""
    },
    onChange: {
      type: Function,
      default: () => []
    },
    mode: {
      type: String,
      default: "datepicker"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => [new Date().toLocaleDateString("pt-br")]
    },
    weekendAvailable: {
      type: Boolean,
      default: false
    },
    blockDateList: {
      type: Array,
      default: () => []
    },
    withBlockList: {
      type: Boolean,
      default: false
    },
    allowedDateList: {
      type: Array,
      default: () => []
    },
    withAllowedList: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const currentDateLeftRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(new Date());
    const daysToShowLeftRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    const innerValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.value);
    const inverseClass = props.inverse ? "inverse" : "";
    const parsedEvents = props.events ? props.events.map(event => ({
      date: event.date || "",
      message: event.message
    })) : [];
    const parsedBlockedDates = props.blockDateList ? props.blockDateList.map(event => event || "") : [];
    const parsedAllowedDates = props.allowedDateList ? props.allowedDateList.map(event => event || "") : [];
    const selectedDays = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(Array.isArray(innerValue) ? innerValue : []);
    const formatDate = date => {
      const [day, month, year] = date?.split("/");
      return new Date(+year, +month - 1, +day);
    };
    const goToPrevMonth = () => {
      const date = currentDateLeftRef.value;
      date?.setMonth(date.getMonth() - 1);
      setDaysToShowRef(date);
    };
    const goToNextMonth = () => {
      const date = currentDateLeftRef.value;
      date?.setMonth(date.getMonth() + 1);
      setDaysToShowRef(date);
    };
    const selectDay = (day, indexDay) => {
      if (props.range) {
        if (selectedDays.value[0] > day.date || selectedDays.value.length >= 2) {
          selectedDays.value = [];
          selectedDays.value.length = 0;
        }
        selectDayRange(day, selectedDays.value.length);
      } else {
        selectDaySingle(day, indexDay);
      }
      emit("selectday", selectedDays.value);
    };
    const setDaysToShowRef = date => {
      currentDateLeftRef.value = date;
      daysToShowLeftRef.value = daysToShow(date, props.events, selectedDays.value, currentDateLeftRef.value, undefined, undefined, props.blockDateList, props.allowedDateList);
    };
    const initDatePicker = date => {
      setDaysToShowRef(date);
    };
    const setToday = today => {
      setDaysToShowRef(today);
      const todayIndex = daysToShowLeftRef.value.find(obj => new Date(obj.date).getTime() === new Date(today).getTime());
      selectedDays.value[todayIndex.index] = [today];
      selectDay(todayIndex, todayIndex.index);
    };
    const parseToOutputFormat = date => {
      return date.toISOString().split("T")[0];
    };
    const selectDaySingle = (day, indexDay) => {
      daysToShowLeftRef.value.forEach((item, itemIndex) => {
        if (itemIndex === indexDay) {
          item.selected = true;
          selectedDays.value = [day.date];
        } else {
          item.selected = false;
        }
      });
      emit("change", parseToOutputFormat(day.date));
    };
    const setValueToTrueOfSelectedItem = () => {
      daysToShowLeftRef.value.map((item, itemIndex) => {
        if (selectedDays.value[0]?.getTime() === item.date.getTime() || selectedDays.value[1]?.getTime() === item.date.getTime()) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
    };
    const selectDayRange = (day, indexDay) => {
      selectedDays.value[indexDay] = day.date;
      setValueToTrueOfSelectedItem();
    };
    const clearSelectedDays = () => {
      selectedDays.value = [];
      setValueToTrueOfSelectedItem();
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      if (props.range) if (props.startDateValue !== null && typeof props.startDateValue === "string") {
        if (props.startDateValue.split("/").length === 3 && props.startDateValue?.length === 10) {
          const startDate = {
            disabled: false,
            date: formatDate(props.startDateValue),
            selected: true,
            blocked: false,
            allowed: false
          };
          selectDayRange(startDate, 0);
        }
      }
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      if (props.range) if (props.endDateValue !== null && typeof props.endDateValue === "string") {
        if (props.endDateValue.split("/").length === 3 && props.endDateValue?.length === 10) {
          const endDate = {
            disabled: false,
            date: formatDate(props.endDateValue),
            selected: true,
            blocked: false,
            allowed: false
          };
          selectDayRange(endDate, 1);
        }
      }
    });
    const handleSelectedView = date => {
      currentDateLeftRef.value = date;
      setDaysToShowRef(date);
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeMount)(() => {
      if (props.range) {
        if (props.startDateValue !== null && typeof props.startDateValue === "string") {
          if (props.startDateValue.split("/").length === 3 && props.startDateValue?.length === 10) {
            const startDate = {
              disabled: false,
              date: formatDate(props.startDateValue),
              selected: true,
              blocked: false,
              allowed: false
            };
            selectDayRange(startDate, 0);
          }
        }
        if (props.endDateValue !== null && typeof props.endDateValue === "string") {
          if (props.endDateValue.split("/").length === 3 && props.endDateValue?.length === 10) {
            const endDate = {
              disabled: false,
              date: formatDate(props.endDateValue),
              selected: true,
              blocked: false,
              allowed: false
            };
            selectDayRange(endDate, 1);
          }
        }
      }
      const initialDate = () => {
        if (props.startDateValue) {
          return formatDate(props.startDateValue);
        }
        return new Date();
      };
      initDatePicker(initialDate());
      setValueToTrueOfSelectedItem();
    });
    return {
      clearSelectedDays,
      innerValue,
      daysToShowLeftRef,
      inverseClass,
      parsedEvents,
      parsedBlockedDates,
      parsedAllowedDates,
      selectedDays,
      goToNextMonth,
      goToPrevMonth,
      selectDay,
      handleSelectedView,
      setToday
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Calendar/Calendar.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Calendar/Calendar.vue?vue&type=style&index=0&id=27743776&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Calendar/Calendar.vue?vue&type=style&index=0&id=27743776&lang=scss

;// CONCATENATED MODULE: ./src/components/Calendar/Calendar.vue




;


const Calendar_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Calendarvue_type_script_lang_ts, [['render',Calendarvue_type_template_id_27743776_ts_true_render]])

/* harmony default export */ var Calendar = (Calendar_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Checkbox/Checkbox.vue?vue&type=template&id=3c916f9a&scoped=true&ts=true

const Checkboxvue_type_template_id_3c916f9a_scoped_true_ts_true_withScopeId = n => (_pushScopeId("data-v-3c916f9a"), n = n(), _popScopeId(), n);
const Checkboxvue_type_template_id_3c916f9a_scoped_true_ts_true_hoisted_1 = ["id"];
const Checkboxvue_type_template_id_3c916f9a_scoped_true_ts_true_hoisted_2 = ["name", "value", "checked", "disabled"];
function Checkboxvue_type_template_id_3c916f9a_scoped_true_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    type: "checkbox",
    checkboxPosition: _ctx.position,
    checkboxLabel: _ctx.checkboxLabel,
    size: _ctx.size,
    inverse: _ctx.inverse
  }, null, 8, ["checkboxPosition", "checkboxLabel", "size", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    id: _ctx.data.inputId,
    class: "orq-checkbox"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.checkboxContentClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.checkboxInputClasses),
    id: "checkmark",
    type: "checkbox",
    name: _ctx.data.name,
    value: _ctx.data.value,
    checked: _ctx.data.checked,
    disabled: _ctx.data.disabled,
    onInput: _cache[0] || (_cache[0] = $event => _ctx.handlerInputChange($event.target.name, $event.target.value, $event.target.checked, $event.target.indeterminate))
  }, null, 42, Checkboxvue_type_template_id_3c916f9a_scoped_true_ts_true_hoisted_2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.checkboxSpanClasses)
  }, null, 2)], 2), _ctx.checkboxLabel === true ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("label", {
    key: 0,
    for: "checkmark",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.checkboxLabelClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 8, Checkboxvue_type_template_id_3c916f9a_scoped_true_ts_true_hoisted_1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.vue?vue&type=template&id=3c916f9a&scoped=true&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Checkbox/Checkbox.vue?vue&type=script&lang=ts


/* harmony default export */ var Checkboxvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqCheckbox",
  components: {
    OrqShimmer: Shimmer
  },
  props: {
    checkboxLabel: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "large"
    },
    label: {
      type: String,
      default: "BTG Checkbox"
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: "left"
    },
    loading: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String
    },
    value: {
      type: String
    },
    name: {
      type: String
    },
    modelValue: {
      type: Array
    }
  },
  setup(props) {
    props = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)(props);
    const data = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)({
      inputId: props.id,
      value: props.value,
      name: props.name,
      checked: props.checked,
      disabled: props.disabled,
      indeterminate: props.indeterminate
    });
    return {
      checkboxContentClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-checkbox__content": true,
          ["orq-checkbox__content--inverse"]: props.inverse,
          [`orq-checkbox__content--${props.position}`]: props.position,
          ["orq-checkbox__content--small"]: !props.checkboxLabel && props.size === "small"
        };
      }),
      checkboxInputClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-checkbox__input": true,
          "orq-checkbox__input--inverse": props.inverse,
          "orq-checkbox__input--small": !props.checkboxLabel && props.size === "small"
        };
      }),
      checkboxSpanClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-checkbox__checkmark": true,
          "orq-checkbox__checkmark--indeterminate": props.indeterminate,
          "orq-checkbox__checkmark--inverse": props.inverse,
          "orq-checkbox__checkmark--small": !props.checkboxLabel && props.size === "small"
        };
      }),
      checkboxLabelClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-checkbox__label": true,
          "orq-checkbox__label--disabled": props.disabled,
          "orq-checkbox__label--inverse": props.inverse
        };
      }),
      data
    };
  },
  watch: {
    checked(nv, oldnv) {
      this.data.checked = nv;
    }
  },
  methods: {
    handlerInputChange(name, value, checked, indeterminate) {
      this.data.checked = checked;
      this.data.indeterminate = indeterminate;
      this.$emit("input", {
        name,
        checked
      });
      this.$emit("changed", name, checked, indeterminate, value);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Checkbox/Checkbox.vue?vue&type=style&index=0&id=3c916f9a&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.vue?vue&type=style&index=0&id=3c916f9a&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.vue




;


const Checkbox_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Checkboxvue_type_script_lang_ts, [['render',Checkboxvue_type_template_id_3c916f9a_scoped_true_ts_true_render],['__scopeId',"data-v-3c916f9a"]])

/* harmony default export */ var Checkbox = (Checkbox_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CodeSnippet/CodeSnippet.vue?vue&type=template&id=07e92e14&scoped=true&ts=true

const CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.pushScopeId)("data-v-07e92e14"), n = n(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.popScopeId)(), n);
const CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_hoisted_1 = {
  class: "orq-code-snippet__header"
};
const CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_hoisted_2 = {
  class: "orq-code-snippet__header-title"
};
const CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_hoisted_3 = {
  class: "orq-code-snippet__content"
};
const CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_hoisted_4 = ["id", "name"];
const CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_hoisted_5 = /*#__PURE__*/CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
  class: "orq-code-snippet__content-space"
}, null, -1));
function CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqButton = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqButton");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-code-snippet ${_ctx.inverseClass}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqButton, {
    label: "Copiar",
    appearance: "inline",
    size: "default",
    iconName: "edit-copy",
    iconOrientation: "right",
    inverse: _ctx.inverse,
    onClick: _ctx.handleCopy
  }, null, 8, ["inverse", "onClick"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("textarea", {
    class: "orq-code-snippet__content-textarea",
    ref: "textarea",
    id: _ctx.id,
    name: _ctx.name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.valueState = $event),
    onInput: _cache[1] || (_cache[1] = $event => _ctx.handleChange($event)),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      height: _ctx.height + 'px'
    })
  }, null, 44, CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_hoisted_4), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vModelText, _ctx.valueState]]), CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_hoisted_5])], 2);
}
;// CONCATENATED MODULE: ./src/components/CodeSnippet/CodeSnippet.vue?vue&type=template&id=07e92e14&scoped=true&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CodeSnippet/CodeSnippet.vue?vue&type=script&lang=ts


/* harmony default export */ var CodeSnippetvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqCodeSnippet",
  components: {
    OrqButton: Button
  },
  props: {
    title: {
      type: String
    },
    id: {
      type: String
    },
    value: {
      type: String
    },
    name: {
      type: String
    },
    height: {
      type: Number
    },
    inverse: {
      type: Boolean
    }
  },
  setup(props, {
    emit
  }) {
    let valueState = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.value);
    const handleChange = event => {
      valueState.value = event.target.value;
      emit("onchange", event);
    };
    const handleCopy = () => {
      navigator.clipboard.writeText(valueState.value);
      emit("onclick");
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      valueState.value = props.value;
    });
    return {
      valueState,
      handleChange,
      handleCopy,
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-code-snippet-inverse" : "")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/CodeSnippet/CodeSnippet.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/CodeSnippet/CodeSnippet.vue?vue&type=style&index=0&id=07e92e14&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/CodeSnippet/CodeSnippet.vue?vue&type=style&index=0&id=07e92e14&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/CodeSnippet/CodeSnippet.vue




;


const CodeSnippet_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CodeSnippetvue_type_script_lang_ts, [['render',CodeSnippetvue_type_template_id_07e92e14_scoped_true_ts_true_render],['__scopeId',"data-v-07e92e14"]])

/* harmony default export */ var CodeSnippet = (CodeSnippet_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ContentSwitcher/ContentSwitcher.vue?vue&type=template&id=3183bdfc&scoped=true&ts=true

const ContentSwitchervue_type_template_id_3183bdfc_scoped_true_ts_true_withScopeId = n => (_pushScopeId("data-v-3183bdfc"), n = n(), _popScopeId(), n);
const ContentSwitchervue_type_template_id_3183bdfc_scoped_true_ts_true_hoisted_1 = ["onClick"];
const ContentSwitchervue_type_template_id_3183bdfc_scoped_true_ts_true_hoisted_2 = {
  class: "orq-content-switcher__item__text"
};
function ContentSwitchervue_type_template_id_3183bdfc_scoped_true_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-content-switcher ${_ctx.sizeClass} ${_ctx.inverse ? _ctx.inverseClass : ''}`)
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.options, (option, i) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: i,
      tabIndex: "0",
      onClick: $event => !option.disabled && _ctx.onSelectedChange($event, option),
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`
        orq-content-switcher__item
        ${_ctx.getSelectedClass(option)}
        ${_ctx.getDisabledClass(option)}
    `)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ContentSwitchervue_type_template_id_3183bdfc_scoped_true_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(option.label), 1)], 10, ContentSwitchervue_type_template_id_3183bdfc_scoped_true_ts_true_hoisted_1);
  }), 128))], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 1,
    type: "content-switcher",
    loading: _ctx.loading,
    inverse: _ctx.inverse,
    rows: 1,
    cols: 1
  }, null, 8, ["loading", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/ContentSwitcher/ContentSwitcher.vue?vue&type=template&id=3183bdfc&scoped=true&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ContentSwitcher/ContentSwitcher.vue?vue&type=script&lang=ts


/* harmony default export */ var ContentSwitchervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqContentSwitcher",
  components: {
    OrqShimmer: Shimmer
  },
  props: {
    size: {
      type: String,
      default: "small"
    },
    options: {
      type: Array
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getLength() {
      return this.options?.length;
    },
    getSelectedClass(item) {
      return item.selected ? `orq-content-switcher__item--selected` : "";
    },
    getDisabledClass(item) {
      return item.disabled ? `orq-content-switcher__item--disabled` : "";
    }
  },
  setup(props, {
    emit
  }) {
    const contentOptions = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.options);
    const onSelectedChange = (event, item) => {
      emit("selected", event, item);
    };
    return {
      onSelectedChange,
      contentOptions,
      sizeClass: `orq-content-switcher--${props.size}`,
      inverseClass: `orq-content-switcher--inverse`
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/ContentSwitcher/ContentSwitcher.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ContentSwitcher/ContentSwitcher.vue?vue&type=style&index=0&id=3183bdfc&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ContentSwitcher/ContentSwitcher.vue?vue&type=style&index=0&id=3183bdfc&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/ContentSwitcher/ContentSwitcher.vue




;


const ContentSwitcher_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ContentSwitchervue_type_script_lang_ts, [['render',ContentSwitchervue_type_template_id_3183bdfc_scoped_true_ts_true_render],['__scopeId',"data-v-3183bdfc"]])

/* harmony default export */ var ContentSwitcher = (ContentSwitcher_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Divider/Divider.vue?vue&type=template&id=34bc6466&ts=true

function Dividervue_type_template_id_34bc6466_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.dividerClasses),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.verticalStyle)
  }, null, 6);
}
;// CONCATENATED MODULE: ./src/components/Divider/Divider.vue?vue&type=template&id=34bc6466&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Divider/Divider.vue?vue&type=script&lang=ts

/* harmony default export */ var Dividervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqDivider",
  props: {
    verticalSize: {
      type: Number,
      require: true,
      default: 10
    },
    inverse: {
      type: Boolean,
      default: false
    },
    orientation: {
      type: String,
      default: "horizontal"
    },
    size: {
      type: String,
      default: "thin"
    }
  },
  setup(props) {
    return {
      dividerClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        "orq-divider": true,
        "orq-divider__inverse": props.inverse,
        [`orq-divider--size-${props.size}`]: props.size,
        [`orq-divider--orientation-${props.orientation}`]: props.orientation
      })),
      verticalStyle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        height: props.orientation === "vertical" ? `${props.verticalSize}px` : ""
      }))
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Divider/Divider.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Divider/Divider.vue?vue&type=style&index=0&id=34bc6466&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Divider/Divider.vue?vue&type=style&index=0&id=34bc6466&lang=scss

;// CONCATENATED MODULE: ./src/components/Divider/Divider.vue




;


const Divider_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Dividervue_type_script_lang_ts, [['render',Dividervue_type_template_id_34bc6466_ts_true_render]])

/* harmony default export */ var Divider = (Divider_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Dropdown/Dropdown.vue?vue&type=template&id=bd52bb16&ts=true

const Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-droplist__search"
};
const Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_2 = {
  class: "orq-droplist__search__icon"
};
const Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_3 = ["placeholder"];
const Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_4 = {
  class: "orq-droplist__wrapper"
};
const Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_5 = {
  key: 0,
  class: "orq-droplist__item"
};
const Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_6 = {
  class: "orq-droplist__item__text"
};
function Dropdownvue_type_template_id_bd52bb16_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqDropdownItem = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqDropdownItem");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.dropdownClass)
  }, [_ctx.search ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "tools-search",
    size: 24,
    color: _ctx.getColor
  }, null, 8, ["color"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.innerValue = $event),
    class: "orq-droplist__search__input",
    type: "text",
    placeholder: _ctx.searchPlaceholder,
    autoComplete: "off",
    onFocus: _cache[1] || (_cache[1] = $event => _ctx.onFocus(true)),
    onBlur: _cache[2] || (_cache[2] = $event => _ctx.onFocus(false)),
    onInput: _cache[3] || (_cache[3] = $event => _ctx.handleInputChange($event))
  }, null, 40, Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_3), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vModelText, _ctx.innerValue]]), _ctx.innerValue != '' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("button", {
    key: 0,
    onClick: _cache[4] || (_cache[4] =
    //@ts-ignore
    (...args) => _ctx.clearSearch && _ctx.clearSearch(...args)),
    class: "orq-droplist__search__clear-button"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "close",
    size: 24,
    color: _ctx.getColor
  }, null, 8, ["color"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_4, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.newArray, (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqDropdownItem, {
      key: index,
      title: item.title,
      subtitle: item.subtitle,
      selected: item.selected,
      disabled: item.disabled,
      imgSrc: item.imgSrc,
      multiple: _ctx.multiple,
      type: _ctx.type,
      inverse: _ctx.inverse,
      onOnSelect: $event => _ctx.selectItem(item)
    }, null, 8, ["title", "subtitle", "selected", "disabled", "imgSrc", "multiple", "type", "inverse", "onOnSelect"]);
  }), 128)), _ctx.newArray.length === 0 && _ctx.showEmptySearch ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", Dropdownvue_type_template_id_bd52bb16_ts_true_hoisted_6, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.searchEmpty), 1)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])], 2);
}
;// CONCATENATED MODULE: ./src/components/Dropdown/Dropdown.vue?vue&type=template&id=bd52bb16&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Dropdown/DropdownItem.vue?vue&type=template&id=0ace4767&ts=true

const DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_1 = {
  class: "orq-droplist__item__data"
};
const DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_2 = {
  key: 0,
  class: "orq-droplist__item__text"
};
const DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_3 = {
  key: 1,
  class: "orq-droplist__item__subtext"
};
const DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_4 = {
  key: 1,
  class: "orq-droplist__item__checkbox"
};
const DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_5 = {
  key: 0,
  class: "orq-droplist__item__avatar"
};
const DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_6 = {
  class: "orq-droplist__item__data"
};
const DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_7 = {
  key: 0,
  class: "orq-droplist__item__text"
};
const DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_8 = {
  key: 1,
  class: "orq-droplist__item__subtext"
};
const DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_9 = {
  key: 2,
  class: "orq-droplist__item__checkbox"
};
function DropdownItemvue_type_template_id_0ace4767_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqCheckbox = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqCheckbox");
  const _component_OrqImageContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqImageContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.type === 'default' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.dropdownClass),
    ref: "elRef",
    role: "button",
    onMousedown: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.onMouseDownHandler && _ctx.onMouseDownHandler(...args)),
    onMouseup: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.onMouseUpHandler && _ctx.onMouseUpHandler(...args)),
    onClick: _cache[2] || (_cache[2] = $event => _ctx.onSelect($event))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_1, [_ctx.title ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.subtitle ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.subtitle), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), !_ctx.multiple && _ctx.selected && !_ctx.disabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    type: "none",
    name: "check",
    size: 16,
    color: _ctx.iconColor
  }, null, 8, ["color"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.multiple && !_ctx.disabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqCheckbox, {
    checked: _ctx.selected,
    inverse: _ctx.setCheckboxInverseMode(),
    disabled: _ctx.disabled,
    size: "small"
  }, null, 8, ["checked", "inverse", "disabled"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 34)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'avatar' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.dropdownClass),
    ref: "elRef",
    role: "button",
    onMousedown: _cache[3] || (_cache[3] =
    //@ts-ignore
    (...args) => _ctx.onMouseDownHandler && _ctx.onMouseDownHandler(...args)),
    onMouseup: _cache[4] || (_cache[4] =
    //@ts-ignore
    (...args) => _ctx.onMouseUpHandler && _ctx.onMouseUpHandler(...args)),
    onClick: _cache[5] || (_cache[5] = $event => _ctx.onSelect($event))
  }, [_ctx.imgSrc ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqImageContainer, {
    src: _ctx.imgSrc,
    alt: _ctx.imgSrc
  }, null, 8, ["src", "alt"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_6, [_ctx.title ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_7, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.subtitle ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_8, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.subtitle), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), !_ctx.multiple && _ctx.selected && !_ctx.disabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 1,
    type: "none",
    name: "check",
    size: 16,
    color: _ctx.iconColor
  }, null, 8, ["color"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.multiple && !_ctx.disabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", DropdownItemvue_type_template_id_0ace4767_ts_true_hoisted_9, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqCheckbox, {
    checked: _ctx.selected,
    inverse: _ctx.setCheckboxInverseMode(),
    disabled: _ctx.disabled,
    size: "small"
  }, null, 8, ["checked", "inverse", "disabled"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 34)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Dropdown/DropdownItem.vue?vue&type=template&id=0ace4767&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Dropdown/DropdownItem.vue?vue&type=script&lang=ts





/* harmony default export */ var DropdownItemvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqDropdownItem",
  components: {
    OrqImageContainer: ImageContainer,
    OrqIconContainer: IconContainer,
    OrqCheckbox: Checkbox
  },
  props: {
    type: {
      type: String,
      default: "default"
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String,
      default: ""
    },
    selected: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean
    }
  },
  mounted() {
    this.elRef = this.$refs.elRef;
  },
  methods: {
    onMouseDownHandler() {
      this.elRef.classList.add("orq-droplist__item--clicking");
    },
    onMouseUpHandler() {
      this.elRef.classList.remove("orq-droplist__item--clicking");
    }
  },
  setup(props, {
    emit
  }) {
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    const elRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const onSelect = ev => {
      emit("onSelect");
    };
    const setCheckboxInverseMode = () => {
      return props.inverse && !props.selected || !props.inverse && props.selected;
    };
    return {
      iconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return props.inverse && !props.disabled ? iconColors.value.emphasisBaseHigh : iconColors.value.emphasisBaseInverseHigh;
      }),
      dropdownClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-droplist__item": true,
          "orq-droplist__item--selected": props.selected,
          "orq-droplist__item--disabled": props.disabled
        };
      }),
      elRef,
      setCheckboxInverseMode,
      onSelect
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Dropdown/DropdownItem.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Dropdown/DropdownItem.vue?vue&type=style&index=0&id=0ace4767&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Dropdown/DropdownItem.vue?vue&type=style&index=0&id=0ace4767&lang=scss

;// CONCATENATED MODULE: ./src/components/Dropdown/DropdownItem.vue




;


const DropdownItem_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(DropdownItemvue_type_script_lang_ts, [['render',DropdownItemvue_type_template_id_0ace4767_ts_true_render]])

/* harmony default export */ var DropdownItem = (DropdownItem_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Dropdown/Dropdown.vue?vue&type=script&lang=ts



/* harmony default export */ var Dropdownvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqDropdown",
  components: {
    OrqIconContainer: IconContainer,
    OrqDropdownItem: DropdownItem
  },
  props: {
    inverse: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: true
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    searchEmpty: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "default"
    },
    multiple: {
      type: Boolean
    },
    search: {
      type: Boolean
    },
    options: {
      type: Array,
      default: () => []
    },
    showEmptySearch: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const dataItems = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    let isFocus = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    let innerValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("");
    let newArray = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.options);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeMount)(() => {
      newArray.value = props.options;
      dataItems.value = props.options;
    });
    const onFocus = bool => {
      isFocus.value = bool;
    };
    const onChangeItems = item => {
      const convertedValueLowerCase = innerValue.value.toLocaleLowerCase();
      const filterValue = item.filter(opt => {
        const title = opt.title ? opt.title.toLocaleLowerCase() : "";
        const subtitle = opt.subtitle ? opt.subtitle.toLocaleLowerCase() : "";
        return title.includes(convertedValueLowerCase) || subtitle.includes(convertedValueLowerCase);
      });
      newArray.value = filterValue;
    };
    const handleInputChange = e => {
      innerValue.value = e.target.value;
    };
    const clearSearch = () => {
      innerValue.value = "";
      onChangeItems(props.options || []);
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      onChangeItems(props.options || []);
    });
    const checkMultiple = item => {
      if (props.multiple) {
        item.selected = !item.selected;
      } else {
        newArray.value.forEach(item => {
          item.selected = false;
        });
        item.selected = true;
      }
      onChangeItems(dataItems.value);
    };
    const selectItem = item => {
      if (item.disabled) {
        return;
      }
      checkMultiple(item);
      emit("onSelect", item);
    };
    return {
      getColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return props.inverse ? "emphasis-base-high-inverse" : "emphasis-base-high";
      }),
      dropdownClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-droplist": true,
          "is-open": props.isOpen,
          "orq-droplist--inverse": props.inverse
        };
      }),
      onFocus,
      innerValue,
      clearSearch,
      handleInputChange,
      selectItem,
      dataItems,
      newArray
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Dropdown/Dropdown.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/components/Dropdown/Dropdown.vue




;
const Dropdown_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Dropdownvue_type_script_lang_ts, [['render',Dropdownvue_type_template_id_bd52bb16_ts_true_render]])

/* harmony default export */ var Dropdown = (Dropdown_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/EmptyState/EmptyState.vue?vue&type=template&id=a1863930&ts=true

const EmptyStatevue_type_template_id_a1863930_ts_true_hoisted_1 = {
  class: "orq-empty-state"
};
const EmptyStatevue_type_template_id_a1863930_ts_true_hoisted_2 = {
  class: "orq-title--box"
};
const EmptyStatevue_type_template_id_a1863930_ts_true_hoisted_3 = {
  key: 1,
  class: "orq-empty-state__page"
};
const EmptyStatevue_type_template_id_a1863930_ts_true_hoisted_4 = {
  class: "orq-empty-state__page__content"
};
const EmptyStatevue_type_template_id_a1863930_ts_true_hoisted_5 = {
  class: "orq-title--box orq-title--box__text--undefined"
};
function EmptyStatevue_type_template_id_a1863930_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqImageContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqImageContainer");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqButton = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqButton");
  const _component_OrqLink = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqLink");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("section", EmptyStatevue_type_template_id_a1863930_ts_true_hoisted_1, [_ctx.type === 'section' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.typeSectionClasses)
  }, [_ctx.hasImage && _ctx.typeImage === 'image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqImageContainer, {
    key: 0,
    shape: "rounded",
    src: _ctx.src,
    alt: _ctx.alt,
    size: _ctx.sizeVerticalImage
  }, null, 8, ["src", "alt", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.hasImage && _ctx.typeImage === 'icon' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 1,
    type: "none",
    name: _ctx.iconName,
    size: _ctx.sizeVerticalImage,
    color: _ctx.setIconColor,
    circle: _ctx.orientation === 'horizontal'
  }, null, 8, ["name", "size", "color", "circle"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.contentClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", EmptyStatevue_type_template_id_a1863930_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.typeSectionTitleClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 3)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.paragraphClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.paragraph), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqButton, {
    appearance: "line",
    iconOrientation: "right",
    iconName: "home",
    size: "compact",
    label: _ctx.actionLabel,
    inverse: _ctx.inverse
  }, null, 8, ["label", "inverse"])], 2)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'page' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", EmptyStatevue_type_template_id_a1863930_ts_true_hoisted_3, [_ctx.hasImage && _ctx.typeImage === 'image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqImageContainer, {
    key: 0,
    shape: "rounded",
    src: _ctx.src,
    alt: _ctx.alt,
    size: 160
  }, null, 8, ["src", "alt"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", EmptyStatevue_type_template_id_a1863930_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", EmptyStatevue_type_template_id_a1863930_ts_true_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.typePageTitleClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 3)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.paragraphClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.paragraph), 3), _ctx.actionType === 'link' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqLink, {
    key: 0,
    icon: "default",
    orientation: "right",
    inverse: _ctx.inverse,
    label: _ctx.actionLabel,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('onClick', $event))
  }, null, 8, ["inverse", "label"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.actionType === 'button' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqButton, {
    key: 1,
    appearance: "line",
    iconOrientation: "right",
    size: "compact",
    label: _ctx.actionLabel,
    iconName: _ctx.actionIcon,
    inverse: _ctx.inverse,
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('onClick', $event))
  }, null, 8, ["label", "iconName", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]);
}
;// CONCATENATED MODULE: ./src/components/EmptyState/EmptyState.vue?vue&type=template&id=a1863930&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/EmptyState/EmptyState.vue?vue&type=script&lang=ts






/* harmony default export */ var EmptyStatevue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqEmptyState",
  props: {
    type: {
      type: String,
      default: ""
    },
    orientation: {
      type: String,
      default: ""
    },
    hasImage: {
      type: Boolean,
      default: true
    },
    typeImage: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    },
    src: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    paragraph: {
      type: String,
      default: ""
    },
    actionLabel: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    actionType: {
      type: String,
      default: ""
    },
    iconName: {
      type: String,
      default: ""
    },
    actionIcon: {
      type: String,
      default: ""
    }
  },
  components: {
    OrqButton: Button,
    OrqIconContainer: IconContainer,
    OrqLink: Link,
    OrqImageContainer: ImageContainer
  },
  setup(props) {
    const horizontalSize = 112;
    const verticalSize = 32;
    const defaultSizeImage = 48;
    const sizeImage = props.size === "small" && props.orientation === "vertical" ? verticalSize : defaultSizeImage;
    const sizeVerticalImage = props.orientation === "horizontal" ? horizontalSize : sizeImage;
    return {
      setIconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return props.inverse ? EiconContainerColor.emphasisBaseInverseHigh : EiconContainerColor.emphasisBaseHigh;
      }),
      typeSectionClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-empty-state__section": true,
          "orq-empty-state__section--horizontal": props.type === "section" && props.orientation === "horizontal",
          "orq-empty-state__section--image": props.type === "section" && props.hasImage === true
        };
      }),
      contentClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-empty-state__section__content": true,
          "orq-empty-state__section__content--image": props.hasImage === true
        };
      }),
      typeSectionTitleClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`orq-title--title-${props.size === "small" ? "df" : "sm"}`]: props.size,
          [`orq-title--color-${props.inverse ? "light" : "dark"}`]: props.inverse
        };
      }),
      paragraphClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-empty-state__content__paragraph": true,
          "orq-empty-state__content__paragraph--large": props.size === "large",
          "orq-empty-state__content__paragraph--inverse": props.inverse
        };
      }),
      typePageTitleClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-title--title-sm": true,
          [`orq-title--color-${props.inverse ? "light" : "dark"}`]: props.inverse
        };
      }),
      sizeVerticalImage
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/EmptyState/EmptyState.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/EmptyState/EmptyState.vue?vue&type=style&index=0&id=a1863930&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/EmptyState/EmptyState.vue?vue&type=style&index=0&id=a1863930&lang=scss

;// CONCATENATED MODULE: ./src/components/EmptyState/EmptyState.vue




;


const EmptyState_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(EmptyStatevue_type_script_lang_ts, [['render',EmptyStatevue_type_template_id_a1863930_ts_true_render]])

/* harmony default export */ var EmptyState = (EmptyState_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/FileUploader/FileUploader.vue?vue&type=template&id=6271988c&ts=true

const FileUploadervue_type_template_id_6271988c_ts_true_hoisted_1 = {
  style: {
    "margin": "4rem auto 0",
    "padding": "1rem",
    "width": "350px"
  }
};
const FileUploadervue_type_template_id_6271988c_ts_true_hoisted_2 = ["disabled"];
const FileUploadervue_type_template_id_6271988c_ts_true_hoisted_3 = ["multiple", "accept", "disabled"];
const FileUploadervue_type_template_id_6271988c_ts_true_hoisted_4 = {
  class: "icon-container"
};
const FileUploadervue_type_template_id_6271988c_ts_true_hoisted_5 = {
  class: "icon-container__notification"
};
function FileUploadervue_type_template_id_6271988c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqProgressBar = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqProgressBar");
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", FileUploadervue_type_template_id_6271988c_ts_true_hoisted_1, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.mainClass)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.onSelectClick($event)),
    disabled: _ctx.disabled,
    tabindex: "0",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`
          ${_ctx.mainClass}__content
          ${_ctx.inverseClass}
          ${_ctx.disabledClass}
        `)
  }, [!_ctx.disabled && _ctx.fileList?.length < _ctx.MAX_FILE_COUNT ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("input", {
    key: 0,
    onChange: _cache[0] || (_cache[0] = $event => _ctx.handleFileSelect($event)),
    id: "input",
    type: "file",
    multiple: _ctx.maxFiles > 1,
    accept: _ctx.accept ? _ctx.accept : '*',
    disabled: _ctx.disabled,
    class: "input",
    style: {
      "display": "none"
    }
  }, null, 40, FileUploadervue_type_template_id_6271988c_ts_true_hoisted_3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", {
    htmlFor: "input",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`
            ${_ctx.mainClass}__content__paragraph
            ${_ctx.paragraphInverseClass}
            ${_ctx.paragraphDisabledClass}
          `)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.uploadButtonText), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", FileUploadervue_type_template_id_6271988c_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    color: _ctx.getIconColor(),
    size: 16,
    name: "upload"
  }, null, 8, ["color"])])], 10, FileUploadervue_type_template_id_6271988c_ts_true_hoisted_2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__notification`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", FileUploadervue_type_template_id_6271988c_ts_true_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    color: _ctx.getIconColor(),
    size: 16,
    name: "info"
  }, null, 8, ["color"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`
          ${_ctx.mainClass}__notification__paragraph
          ${_ctx.notificationInverseClass}
          ${_ctx.notificationDisabledClass}
        `)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.infoText ? _ctx.infoText : _ctx.infoTextDefault), 3)], 2), ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.fileList, (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: index,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`
          ${_ctx.mainClass}__file-display
          ${item.errorMessage ? _ctx.mainClass + '__file-display--error' : ''}
          ${_ctx.fileDisplayInverseClass}
        `)
    }, [item.file ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__file-display__content`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      type: "none",
      class: "icon-container",
      color: _ctx.getIconColorFiles(),
      size: 24,
      name: "file"
    }, null, 8, ["color"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__file-display__content__paragraph ${_ctx.fileParagraphInverseClass}`)
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.truncatedText(item.file.name)), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      type: "none",
      class: "icon-container",
      color: _ctx.getIconColorFiles(),
      size: 24,
      name: "edit-trash",
      onClick: $event => _ctx.handleFileRemove(index)
    }, null, 8, ["color", "onClick"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !item.errorMessage && _ctx.loadingProgressBar ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__file-display__progress-bar`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqProgressBar, {
      status: "ok",
      value: item.progress,
      inverse: _ctx.inverse
    }, null, 8, ["value", "inverse"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), item.errorMessage ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 2,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__error-notification`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      type: "none",
      name: "status-error",
      size: 16,
      color: item.errorMessage && !_ctx.inverse ? 'status-error' : item.errorMessage && _ctx.inverse ? 'status-error-inverse' : 'status-error'
    }, null, 8, ["color"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__error-notification__paragraph ${_ctx.errorParagraphInverseClass}`)
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.errorMessage), 3)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
  }), 128)), ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.itemsFile, (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: index,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`
          ${_ctx.mainClass}__file-display
          ${item.errorMessage ? _ctx.mainClass + '__file-display--error' : ''}
          ${_ctx.fileDisplayInverseClass}
        `)
    }, [item.file ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__file-display__content`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      type: "none",
      class: "icon-container",
      color: _ctx.getIconColorFiles(),
      size: 24,
      name: "file"
    }, null, 8, ["color"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__file-display__content__paragraph ${_ctx.fileParagraphInverseClass}`)
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.truncatedText(item.file.name)), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      type: "none",
      class: "icon-container",
      color: _ctx.getIconColorFiles(),
      size: 24,
      name: "edit-trash",
      onClick: $event => _ctx.handleFileRemove(index)
    }, null, 8, ["color", "onClick"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !item.errorMessage ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 1,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__file-display__progress-bar`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqProgressBar, {
      status: item.errorMessage ? 'error' : 'ok',
      value: item.progress,
      inverse: _ctx.inverse
    }, null, 8, ["status", "value", "inverse"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), item.errorMessage ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 2,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__error-notification`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      type: "none",
      name: "status-error",
      size: 16,
      color: item.errorMessage && !_ctx.inverse ? 'status-error' : item.errorMessage && _ctx.inverse ? 'status-error-inverse' : 'status-error'
    }, null, 8, ["color"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.mainClass}__error-notification__paragraph ${_ctx.errorParagraphInverseClass}`)
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.errorMessage), 3)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
  }), 128))], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    type: "file-uploader",
    loading: _ctx.loading,
    inverse: _ctx.inverse
  }, null, 8, ["loading", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/FileUploader/FileUploader.vue?vue&type=template&id=6271988c&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressBar/ProgressBar.vue?vue&type=template&id=e5f1b6f8&scoped=true&ts=true

const ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_withScopeId = n => (_pushScopeId("data-v-e5f1b6f8"), n = n(), _popScopeId(), n);
const ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-progress-bar"
};
const ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_hoisted_2 = {
  class: "orq-progress-bar__label"
};
const ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_hoisted_3 = {
  key: 0,
  class: "orq-progress-bar__side"
};
const ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_hoisted_4 = {
  class: "orq-progress-bar__side__info"
};
const ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_hoisted_5 = {
  class: "orq-progress-bar__side__info right"
};
function ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_hoisted_2, [_ctx.labelText ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-bar__label__header ${_ctx.inverse ? 'orq-progress-bar__label__header--inverse' : ''}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, undefined, true)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-bar__label__value ${_ctx.inverse ? 'orq-progress-bar__label__value--inverse' : ''}`)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.value) + " % ", 3)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-bar__progress-bar ${_ctx.barSize} ${_ctx.barInverse}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-bar__progress-bar__progress ${_ctx.progressStatus} ${_ctx.progressInverse} ${_ctx.progressStatusInverse}`),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(`width: ${_ctx.value}% `)
  }, null, 6)], 2), _ctx.withAdditionalInfo && _ctx.labelText && _ctx.additionalInformation ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-bar__side__info__value ${_ctx.inverse ? 'orq-progress-bar__side__info__value--inverse' : ''}`)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.additionalInformation?.start.value), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-bar__side__info__caption ${_ctx.inverse ? 'orq-progress-bar__side__info__caption--inverse' : ''}`)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.additionalInformation.start.caption), 3)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-bar__side__info__value ${_ctx.inverse ? 'orq-progress-bar__side__info__value--inverse' : ''}`)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.additionalInformation.finish.value), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-bar__side__info__caption ${_ctx.inverse ? 'orq-progress-bar__side__info__caption--inverse' : ''}`)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.additionalInformation.finish.caption), 3)])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 1,
    type: "progress-bar",
    loading: _ctx.loading,
    inverse: _ctx.inverse,
    size: _ctx.size,
    sWidth: 328,
    rows: 1,
    cols: 1
  }, null, 8, ["loading", "inverse", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/ProgressBar/ProgressBar.vue?vue&type=template&id=e5f1b6f8&scoped=true&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressBar/ProgressBar.vue?vue&type=script&lang=ts


/* harmony default export */ var ProgressBarvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqProgressBar",
  components: {
    OrqShimmer: Shimmer
  },
  props: {
    labelText: {
      type: Boolean,
      default: false
    },
    withAdditionalInfo: {
      type: Boolean,
      default: false
    },
    additionalInformation: {
      type: Object
    },
    size: {
      type: String,
      default: "small"
    },
    status: {
      type: String,
      default: "ok"
    },
    value: {
      type: Number,
      default: 0
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      barSize: "orq-progress-bar__progress-bar--" + props.size,
      barInverse: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-progress-bar__progress-bar--inverse" : ""),
      progressStatus: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.status === "error" ? "orq-progress-bar__progress-bar__progress--error" : "orq-progress-bar__progress-bar__progress"),
      progressInverse: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-progress-bar__progress-bar__progress--inverse" : ""),
      progressStatusInverse: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.status === "error" && props.inverse ? "orq-progress-bar__progress-bar__progress--" + props.status + "--inverse" : "")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/ProgressBar/ProgressBar.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressBar/ProgressBar.vue?vue&type=style&index=0&id=e5f1b6f8&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ProgressBar/ProgressBar.vue?vue&type=style&index=0&id=e5f1b6f8&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/ProgressBar/ProgressBar.vue




;


const ProgressBar_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ProgressBarvue_type_script_lang_ts, [['render',ProgressBarvue_type_template_id_e5f1b6f8_scoped_true_ts_true_render],['__scopeId',"data-v-e5f1b6f8"]])

/* harmony default export */ var ProgressBar = (ProgressBar_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/FileUploader/FileUploader.vue?vue&type=script&lang=ts






/* harmony default export */ var FileUploadervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqFileUploader",
  props: {
    accept: {
      type: String
    },
    infoText: {
      type: String
    },
    uploadButtonText: {
      type: String
    },
    acceptFileTypes: {
      type: Array,
      default: () => []
    },
    maxFiles: {
      type: Number,
      default: 5
    },
    maxFileSize: {
      type: Number,
      default: 5000
    },
    loadingProgressBar: {
      type: Boolean
    },
    errorFileType: {
      type: String
    },
    errorMaxFile: {
      type: String
    },
    fileItemList: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrqIconContainer: IconContainer,
    OrqProgressBar: ProgressBar,
    OrqShimmer: Shimmer
  },
  setup(props, {
    emit
  }) {
    let fileList = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    let itemsFile = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.fileItemList);
    const FILE_TYPES = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.acceptFileTypes);
    const MAX_FILE_SIZE = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.maxFileSize);
    const MAX_FILE_COUNT = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.maxFiles);
    const formattedFileSize = (props.maxFileSize / 1000).toFixed(2).toString() + "mb";
    const acceptedFormatText = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(".");
    const infoTextDefault = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("");
    const isDisabled = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const mainClass = "orq-file-uploader";
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      init();
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(props, () => {
      init();
    });
    const init = () => {
      acceptedFormatText.value = props.accept && props.accept.length ? `, no formato ${props.accept}` : ".";
      infoTextDefault.value = `Serão aceitos documentos com no máximo ${formattedFileSize} ${acceptedFormatText.value}`;
    };
    const onDisabled = () => {
      isDisabled.value = true;
    };
    const getIconColor = () => {
      if (isDisabled.value && !props.inverse) {
        return EiconContainerColor.emphasisBaseDisabled;
      }
      if (props.inverse && !props.disabled) {
        return EiconContainerColor.emphasisBaseInverseHigh;
      }
      if (props.disabled && !props.inverse || fileList.value.length === MAX_FILE_COUNT.value) {
        return EiconContainerColor.emphasisBaseDisabled;
      }
      if (props.inverse && props.disabled || isDisabled.value) {
        return EiconContainerColor.emphasisBaseInverseDisabled;
      }
      return EiconContainerColor.emphasisBaseHigh;
    };
    const getIconColorFiles = () => {
      if (props.inverse) {
        return EiconContainerColor.emphasisBaseInverseHigh;
      }
      return EiconContainerColor.emphasisBaseHigh;
    };
    const onSelectClick = () => {
      emit("onSelectClick");
    };
    const handleFileSelect = event => {
      const selectedFiles = event.target.files;
      if (selectedFiles) {
        for (let i = 0; i < selectedFiles.length; i++) {
          const file = selectedFiles[i];
          const uploadFile = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)({
            file,
            progress: 0,
            type: "." + file.type.split("/").pop()
          });
          if (!FILE_TYPES.value.includes(file.type)) {
            uploadFile.value.errorMessage = props.errorFileType;
            onDisabled();
          }
          if (file.size / 1000 > MAX_FILE_SIZE.value) {
            uploadFile.value.errorMessage = props.errorMaxFile;
            onDisabled();
          }
          fileList.value.push(uploadFile.value);
          const fileReader = new FileReader();
          fileReader.readAsDataURL(file);
          fileReader.onprogress = event => {
            if (event.lengthComputable) {
              const percentComplete = event.loaded / event.total * 100;
              uploadFile.value.progress = percentComplete;
            }
          };
        }
      }
      emit("onChange", event);
    };
    const handleFileRemove = index => {
      fileList.value.splice(index, 1);
      isDisabled.value = false;
    };
    const truncatedText = name => {
      const maximumTextSize = 30;
      if (name.length > maximumTextSize) {
        return name.substring(0, maximumTextSize) + "...";
      }
      return name;
    };
    return {
      disabledClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => fileList.value.length === MAX_FILE_COUNT.value || isDisabled.value || props.disabled ? `${mainClass}__content--disabled` : ""),
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? `${mainClass}__content--inverse` : ""),
      paragraphInverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? `${mainClass}__content__paragraph--inverse` : ""),
      paragraphDisabledClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => fileList.value.length === MAX_FILE_COUNT.value || isDisabled.value || props.disabled ? `${mainClass}__content__paragraph--disabled` : ""),
      notificationInverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? `${mainClass}__notification__paragraph--inverse` : ""),
      notificationDisabledClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => fileList.value.length === MAX_FILE_COUNT.value && !props.inverse || isDisabled.value || props.disabled ? `${mainClass}__notification__paragraph--disabled` : ""),
      fileDisplayInverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? `${mainClass}__file-display--inverse` : ""),
      fileParagraphInverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? `${mainClass}__file-display__content__paragraph--inverse` : ""),
      errorParagraphInverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? `${mainClass}__error-notification__paragraph--inverse` : ""),
      init,
      onDisabled,
      acceptedFormatText,
      infoTextDefault,
      truncatedText,
      isDisabled,
      mainClass,
      getIconColor,
      getIconColorFiles,
      fileList,
      itemsFile,
      FILE_TYPES,
      MAX_FILE_COUNT,
      formattedFileSize,
      onSelectClick,
      handleFileSelect,
      handleFileRemove
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/FileUploader/FileUploader.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/FileUploader/FileUploader.vue?vue&type=style&index=0&id=6271988c&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/FileUploader/FileUploader.vue?vue&type=style&index=0&id=6271988c&lang=scss

;// CONCATENATED MODULE: ./src/components/FileUploader/FileUploader.vue




;


const FileUploader_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(FileUploadervue_type_script_lang_ts, [['render',FileUploadervue_type_template_id_6271988c_ts_true_render]])

/* harmony default export */ var FileUploader = (FileUploader_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/Filter.vue?vue&type=template&id=218a8924&ts=true

const Filtervue_type_template_id_218a8924_ts_true_hoisted_1 = {
  class: "orq-filter-drawer__container"
};
const Filtervue_type_template_id_218a8924_ts_true_hoisted_2 = {
  class: "orq-filter-drawer__header"
};
const Filtervue_type_template_id_218a8924_ts_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
  class: "orq-filter-drawer__header-title"
}, "Filtros", -1);
const Filtervue_type_template_id_218a8924_ts_true_hoisted_4 = {
  class: "orq-filter-drawer__divider"
};
const Filtervue_type_template_id_218a8924_ts_true_hoisted_5 = {
  class: "orq-filter-drawer__accordion"
};
const Filtervue_type_template_id_218a8924_ts_true_hoisted_6 = {
  class: "orq-filter-drawer__divider"
};
const Filtervue_type_template_id_218a8924_ts_true_hoisted_7 = {
  class: "orq-filter-drawer__footer"
};
const Filtervue_type_template_id_218a8924_ts_true_hoisted_8 = {
  class: "orq-filter-drawer__footer-action"
};
const Filtervue_type_template_id_218a8924_ts_true_hoisted_9 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
  class: "orq-filter-drawer__lockscreen"
}, null, -1);
function Filtervue_type_template_id_218a8924_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqDivider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqDivider");
  const _component_OrqLink = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqLink");
  const _component_OrqButton = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqButton");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.filterClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Filtervue_type_template_id_218a8924_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Filtervue_type_template_id_218a8924_ts_true_hoisted_2, [Filtervue_type_template_id_218a8924_ts_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: "orq-filter-drawer__header-close",
    role: "button",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.onClose && _ctx.onClose(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "close",
    size: 24,
    color: _ctx.iconColor()
  }, null, 8, ["color"])])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Filtervue_type_template_id_218a8924_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqDivider, {
    inverse: _ctx.inverse
  }, null, 8, ["inverse"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Filtervue_type_template_id_218a8924_ts_true_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Filtervue_type_template_id_218a8924_ts_true_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqDivider, {
    inverse: _ctx.inverse
  }, null, 8, ["inverse"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Filtervue_type_template_id_218a8924_ts_true_hoisted_7, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Filtervue_type_template_id_218a8924_ts_true_hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqLink, {
    label: "Limpar",
    size: "small",
    icon: "none",
    loading: false,
    disabled: false,
    inverse: _ctx.inverse,
    underline: true,
    onClick: _ctx.onClear
  }, null, 8, ["inverse", "onClick"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqButton, {
    label: "Filtrar",
    size: _ctx.buttonSizes.default,
    inverse: _ctx.inverse,
    onClick: _ctx.onFilter
  }, null, 8, ["size", "inverse", "onClick"])])]), Filtervue_type_template_id_218a8924_ts_true_hoisted_9])], 2);
}
;// CONCATENATED MODULE: ./src/components/Filter/Filter.vue?vue&type=template&id=218a8924&ts=true

;// CONCATENATED MODULE: ./src/components/Button/models/button.enum.ts
var EButtonSize;
(function (EButtonSize) {
  EButtonSize["small"] = "small";
  EButtonSize["large"] = "large";
  EButtonSize["default"] = "default";
  EButtonSize["compact"] = "compact";
  EButtonSize["full"] = "full";
})(EButtonSize || (EButtonSize = {}));
var EButtonAppearance;
(function (EButtonAppearance) {
  EButtonAppearance["primary"] = "primary";
  EButtonAppearance["neutral"] = "neutral";
  EButtonAppearance["line"] = "line";
  EButtonAppearance["rounded"] = "rounded";
  EButtonAppearance["inline"] = "inline";
})(EButtonAppearance || (EButtonAppearance = {}));
var EButtonOrientation;
(function (EButtonOrientation) {
  EButtonOrientation["left"] = "left";
  EButtonOrientation["right"] = "right";
})(EButtonOrientation || (EButtonOrientation = {}));
var EButtonType;
(function (EButtonType) {
  EButtonType["button"] = "button";
  EButtonType["submit"] = "submit";
})(EButtonType || (EButtonType = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/Filter.vue?vue&type=script&lang=ts







/* harmony default export */ var Filtervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqFilter",
  props: {
    inverse: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrqIconContainer: IconContainer,
    OrqButton: Button,
    OrqLink: Link,
    OrqDivider: Divider
  },
  setup(props, {
    emit
  }) {
    const buttonApperances = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EButtonAppearance);
    const buttonSizes = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EButtonSize);
    const onClose = () => {
      emit("close");
    };
    const onClear = () => {
      const event = new Event("onFilterClear");
      document.dispatchEvent(event);
      emit("handleClear");
    };
    const onFilter = () => {
      emit("filter");
    };
    const iconColor = () => {
      return props.inverse ? EiconContainerColor.emphasisBaseInverseHigh : EiconContainerColor.emphasisBaseHigh;
    };
    return {
      filterClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-filter-drawer": true,
          "orq-filter-drawer--visible": props.visible,
          "orq-filter-drawer--inverse": props.inverse,
          "orq-filter-drawer-accordion--inverse": props.inverse
        };
      }),
      buttonApperances,
      buttonSizes,
      onClose,
      onClear,
      onFilter,
      iconColor
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Filter/Filter.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/Filter.vue?vue&type=style&index=0&id=218a8924&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Filter/Filter.vue?vue&type=style&index=0&id=218a8924&lang=scss

;// CONCATENATED MODULE: ./src/components/Filter/Filter.vue




;


const Filter_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Filtervue_type_script_lang_ts, [['render',Filtervue_type_template_id_218a8924_ts_true_render]])

/* harmony default export */ var Filter = (Filter_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/views/FilterItem.vue?vue&type=template&id=8d4de10a&ts=true

const FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_1 = {
  class: "orq-filter-drawer-accordion__container--label"
};
const FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_2 = {
  class: "orq-filter-drawer-accordion__container--label-title"
};
const FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_3 = {
  class: "orq-filter-drawer-accordion__container--action"
};
const FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
  class: "orq-filter-drawer-accordion__container--action-remove"
}, " remover ", -1);
const FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_5 = [FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_4];
const FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_6 = {
  class: "orq-filter-drawer-accordion__content"
};
const FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_7 = {
  class: "orq-filter-drawer-accordion__content--collapse"
};
function FilterItemvue_type_template_id_8d4de10a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqBullet = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqBullet");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.filterItemClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: "orq-filter-drawer-accordion__container",
    role: "button",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.onItemClick && _ctx.onItemClick(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_1, [_ctx.populated ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqBullet, {
    key: 0,
    appearance: "info",
    inverse: _ctx.inverse
  }, null, 8, ["inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 1)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_3, [_ctx.populated ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 0,
    role: "button",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.onRemoveItemClick && _ctx.onRemoveItemClick(...args))
  }, FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_5)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.filterItemOpenedClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    name: "chevron-down",
    size: 24,
    color: _ctx.iconColor()
  }, null, 8, ["color"])], 2)])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", FilterItemvue_type_template_id_8d4de10a_ts_true_hoisted_7, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")])])])], 2);
}
;// CONCATENATED MODULE: ./src/components/Filter/views/FilterItem.vue?vue&type=template&id=8d4de10a&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/views/FilterItem.vue?vue&type=script&lang=ts




/* harmony default export */ var FilterItemvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqFilterItem",
  props: {
    title: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    populated: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    opened: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrqBullet: Bullet,
    OrqIconContainer: IconContainer
  },
  setup(props, {
    emit
  }) {
    const onItemClick = () => {
      emit("itemclick");
    };
    const onRemoveItemClick = () => {
      emit("removeitem");
    };
    const iconColor = () => {
      return props.inverse ? EiconContainerColor.emphasisBaseInverseHigh : EiconContainerColor.emphasisBaseHigh;
    };
    return {
      filterItemClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-filter-drawer-accordion": true,
          "orq-filter-drawer-accordion--inverse": props.inverse,
          ["isOpen"]: props.opened
        };
      }),
      filterItemOpenedClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [props.opened ? "orq-filter-drawer-accordion__container--action-chevron-down" : "orq-filter-drawer-accordion__container--action-chevron"]: props.opened
        };
      }),
      onItemClick,
      onRemoveItemClick,
      iconColor
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Filter/views/FilterItem.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/views/FilterItem.vue?vue&type=style&index=0&id=8d4de10a&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Filter/views/FilterItem.vue?vue&type=style&index=0&id=8d4de10a&lang=scss

;// CONCATENATED MODULE: ./src/components/Filter/views/FilterItem.vue




;


const FilterItem_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(FilterItemvue_type_script_lang_ts, [['render',FilterItemvue_type_template_id_8d4de10a_ts_true_render]])

/* harmony default export */ var FilterItem = (FilterItem_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/views/FilterList.vue?vue&type=template&id=02357fea&ts=true

const FilterListvue_type_template_id_02357fea_ts_true_hoisted_1 = {
  class: "orq-filter-list"
};
const FilterListvue_type_template_id_02357fea_ts_true_hoisted_2 = {
  key: 0,
  class: "orq-list__item search-empty"
};
function FilterListvue_type_template_id_02357fea_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqSearch = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqSearch");
  const _component_OrqList = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqList");
  const _component_OrqFilterItem = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqFilterItem");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqFilterItem, {
    ref: "OrqFilterItemRef",
    title: _ctx.title,
    opened: _ctx.isOpen,
    inverse: _ctx.inverse,
    populated: _ctx.dataSource.filter(opt => opt.action?.selected).length > 0,
    onItemclick: _ctx.onItemClick,
    onRemoveitem: _ctx.onRemoveItemClick
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", FilterListvue_type_template_id_02357fea_ts_true_hoisted_1, [_ctx.hasSearch ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: 0
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqSearch, {
      type: _ctx.searchTypes.local,
      size: _ctx.searchSizes.small,
      placeholder: _ctx.searchPlaceholder,
      inverse: _ctx.inverse,
      background: true,
      onHandleinputchange: _ctx.handleInputChange,
      onOnclear: _ctx.onClear
    }, null, 8, ["type", "size", "placeholder", "inverse", "onHandleinputchange", "onOnclear"]), _ctx.filteredResult.length === 0 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", FilterListvue_type_template_id_02357fea_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.searchEmpty), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqList, {
      options: _ctx.filteredResult,
      inverse: _ctx.inverse,
      onActionClick: _cache[0] || (_cache[0] = $event => _ctx.handleChecked($event))
    }, null, 8, ["options", "inverse"])])]),
    _: 1
  }, 8, ["title", "opened", "inverse", "populated", "onItemclick", "onRemoveitem"]);
}
;// CONCATENATED MODULE: ./src/components/Filter/views/FilterList.vue?vue&type=template&id=02357fea&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/List.vue?vue&type=template&id=70546fea&ts=true

const Listvue_type_template_id_70546fea_ts_true_hoisted_1 = {
  key: 1,
  class: "orq-list"
};
const Listvue_type_template_id_70546fea_ts_true_hoisted_2 = {
  class: "orq-list__container__content"
};
function Listvue_type_template_id_70546fea_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqListMeta = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqListMeta");
  const _component_OrqListExtra = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqListExtra");
  const _component_OrqListAction = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqListAction");
  const _component_OrqDivider = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqDivider");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    type: "list",
    loading: _ctx.loading,
    inverse: _ctx.inverse,
    rows: _ctx.dataSource?.length,
    showListOverline: _ctx.overline !== '',
    showListAction: _ctx.actionType
  }, null, 8, ["loading", "inverse", "rows", "showListOverline", "showListAction"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Listvue_type_template_id_70546fea_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listContainerClasses)
  }, [_ctx.overline ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listOverlineClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listOverlineTitleClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.overline), 3)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.dataSource, (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Listvue_type_template_id_70546fea_ts_true_hoisted_2, [item.meta ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqListMeta, {
      key: 0,
      inverse: _ctx.inverse,
      avatar: item.meta.avatar,
      title: item.meta.title,
      subtitle: item.meta.subtitle,
      description: item.meta.description
    }, null, 8, ["inverse", "avatar", "title", "subtitle", "description"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), item.extra ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqListExtra, {
      key: 1,
      inverse: _ctx.inverse,
      title: item.extra.title,
      subtitle: item.extra.subtitle,
      description: item.extra.description
    }, null, 8, ["inverse", "title", "subtitle", "description"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), item.action ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqListAction, {
      key: 2,
      icon: item.action.icon,
      href: item.action.href,
      label: item.action.label,
      inverse: _ctx.inverse,
      type: item.action.type,
      value: item.action?.value,
      selected: item.action?.selected,
      options: item.action.options,
      radioButtonGroupName: "radio-button",
      onOnAction: () => _ctx.handleClick(index)
    }, null, 8, ["icon", "href", "label", "inverse", "type", "value", "selected", "options", "onOnAction"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), _ctx.dataSource.length > 0 && index < _ctx.dataSource.length - 1 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listContainerDividerClasses)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqDivider, {
      inverse: _ctx.inverse,
      orientation: "horizontal",
      size: "thin"
    }, null, 8, ["inverse"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
  }), 128))], 2)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/List/List.vue?vue&type=template&id=70546fea&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/views/ListMeta.vue?vue&type=template&id=4849dbbd&ts=true

const ListMetavue_type_template_id_4849dbbd_ts_true_hoisted_1 = {
  class: "orq-list__container__content__box"
};
const ListMetavue_type_template_id_4849dbbd_ts_true_hoisted_2 = {
  key: 0,
  class: "orq-list__container__content__image"
};
function ListMetavue_type_template_id_4849dbbd_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqAvatar = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqAvatar");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListMetavue_type_template_id_4849dbbd_ts_true_hoisted_1, [_ctx.avatar ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListMetavue_type_template_id_4849dbbd_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqAvatar, {
    type: "image",
    src: _ctx.avatar,
    alt: _ctx.title,
    size: 40,
    inverse: _ctx.inverse,
    loading: _ctx.loading
  }, null, 8, ["src", "alt", "inverse", "loading"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listMetaContainerBoxClass)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listMetaContainerTitleBoxClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listMetaContainerTitleClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 3)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listMetaContainerSubtitleClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.subtitle), 3), _ctx.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("h3", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listMetaContainerDescriptionClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)]);
}
;// CONCATENATED MODULE: ./src/components/List/views/ListMeta.vue?vue&type=template&id=4849dbbd&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/views/ListMeta.vue?vue&type=script&lang=ts


/* harmony default export */ var ListMetavue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqListMeta",
  props: {
    avatar: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrqAvatar: Avatar
  },
  setup(props) {
    const listMetaBoxClass = "orq-title--box";
    const listMetaContainerBoxClass = "orq-list__container__content__box__text-info";
    const inverseClass = "--inverse";
    return {
      listMetaContainerTitleBoxClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${listMetaBoxClass}`]: true,
          [`${listMetaBoxClass}__text--left`]: true
        };
      }),
      listMetaContainerTitleClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${listMetaContainerBoxClass}__title`]: true,
          [`${listMetaContainerBoxClass}__title${inverseClass}`]: props.inverse
        };
      }),
      listMetaContainerSubtitleClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${listMetaContainerBoxClass}__subtitle`]: true,
          [`${listMetaContainerBoxClass}__subtitle${inverseClass}`]: props.inverse
        };
      }),
      listMetaContainerDescriptionClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${listMetaContainerBoxClass}__label`]: true,
          [`${listMetaContainerBoxClass}__label${inverseClass}`]: props.inverse
        };
      }),
      listMetaBoxClass,
      listMetaContainerBoxClass,
      inverseClass
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/List/views/ListMeta.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/views/ListMeta.vue?vue&type=style&index=0&id=4849dbbd&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/List/views/ListMeta.vue?vue&type=style&index=0&id=4849dbbd&lang=scss

;// CONCATENATED MODULE: ./src/components/List/views/ListMeta.vue




;


const ListMeta_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ListMetavue_type_script_lang_ts, [['render',ListMetavue_type_template_id_4849dbbd_ts_true_render]])

/* harmony default export */ var ListMeta = (ListMeta_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/views/ListExtra.vue?vue&type=template&id=4d78fe9c&ts=true

const ListExtravue_type_template_id_4d78fe9c_ts_true_hoisted_1 = {
  class: "orq-list__container__content__box"
};
function ListExtravue_type_template_id_4d78fe9c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListExtravue_type_template_id_4d78fe9c_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listExtraContainerDuplicatedBoxClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listExtraContainerTitleBoxClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listExtraContainerTitleClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 3)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listExtraContainerSubtitleClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.subtitle), 3), _ctx.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("h3", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.listExtraContainerDescriptionClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)]);
}
;// CONCATENATED MODULE: ./src/components/List/views/ListExtra.vue?vue&type=template&id=4d78fe9c&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/views/ListExtra.vue?vue&type=script&lang=ts

/* harmony default export */ var ListExtravue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqListExtra",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const listExtraContainerBoxClass = "orq-list__container__content__box";
    const listExtraTitleBoxClass = "orq-list__title__box";
    const inverseClass = "--inverse";
    return {
      listExtraContainerDuplicatedBoxClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${listExtraContainerBoxClass}__text-info`]: true,
          [`${listExtraContainerBoxClass}__text-info--duplicated`]: true
        };
      }),
      listExtraContainerTitleBoxClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${listExtraTitleBoxClass}`]: true,
          [`${listExtraTitleBoxClass}__text--left`]: true
        };
      }),
      listExtraContainerTitleClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${listExtraContainerBoxClass}__text-info__title`]: true,
          [`${listExtraContainerBoxClass}__text-info__title${inverseClass}`]: props.inverse
        };
      }),
      listExtraContainerSubtitleClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${listExtraContainerBoxClass}__text-info__subtitle`]: true,
          [`${listExtraContainerBoxClass}__text-info__subtitle${inverseClass}`]: props.inverse
        };
      }),
      listExtraContainerDescriptionClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${listExtraContainerBoxClass}__text-info__label`]: true,
          [`${listExtraContainerBoxClass}__text-info__label${inverseClass}`]: props.inverse
        };
      }),
      listExtraContainerBoxClass,
      listExtraTitleBoxClass
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/List/views/ListExtra.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/views/ListExtra.vue?vue&type=style&index=0&id=4d78fe9c&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/List/views/ListExtra.vue?vue&type=style&index=0&id=4d78fe9c&lang=scss

;// CONCATENATED MODULE: ./src/components/List/views/ListExtra.vue




;


const ListExtra_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ListExtravue_type_script_lang_ts, [['render',ListExtravue_type_template_id_4d78fe9c_ts_true_render]])

/* harmony default export */ var ListExtra = (ListExtra_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/views/ListAction.vue?vue&type=template&id=a0c40b4e&ts=true

const ListActionvue_type_template_id_a0c40b4e_ts_true_hoisted_1 = {
  class: "orq-list__container__content__box"
};
function ListActionvue_type_template_id_a0c40b4e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqCheckbox = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqCheckbox");
  const _component_OrqSwitcher = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqSwitcher");
  const _component_OrqRadioButton = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqRadioButton");
  const _component_OrqButton = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqButton");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqLink = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqLink");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListActionvue_type_template_id_a0c40b4e_ts_true_hoisted_1, [_ctx.type === 'checkbox' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqCheckbox, {
    key: 0,
    size: "large",
    checked: _ctx.selected,
    value: _ctx.value,
    inverse: _ctx.inverse,
    name: _ctx.value,
    onInput: _ctx.onAction
  }, null, 8, ["checked", "value", "inverse", "name", "onInput"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'switcher' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqSwitcher, {
    key: 1,
    checked: _ctx.selected,
    value: _ctx.value,
    inverse: _ctx.inverse,
    onChange: _ctx.onAction
  }, null, 8, ["checked", "value", "inverse", "onChange"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'radio' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqRadioButton, {
    key: 2,
    options: _ctx.options,
    groupName: _ctx.radioButtonGroupName,
    value: _ctx.value,
    inverse: _ctx.inverse,
    onChange: _ctx.onAction
  }, null, 8, ["options", "groupName", "value", "inverse", "onChange"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'button' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqButton, {
    key: 3,
    size: "compact",
    label: _ctx.label,
    value: _ctx.value,
    iconName: _ctx.icon,
    inverse: _ctx.inverse,
    onClick: _ctx.onAction
  }, null, 8, ["label", "value", "iconName", "inverse", "onClick"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'link' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqLink, {
    key: 4,
    size: "small",
    icon: "default",
    href: _ctx.href,
    inverse: _ctx.inverse
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      name: _ctx.icon ? _ctx.icon : '',
      size: 24,
      inverse: _ctx.inverse
    }, null, 8, ["name", "inverse"])]),
    _: 1
  }, 8, ["href", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]);
}
;// CONCATENATED MODULE: ./src/components/List/views/ListAction.vue?vue&type=template&id=a0c40b4e&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Switcher/Switcher.vue?vue&type=template&id=51c6a76e&ts=true

const Switchervue_type_template_id_51c6a76e_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-switcher"
};
const Switchervue_type_template_id_51c6a76e_ts_true_hoisted_2 = ["tab-index", "disabled", "checked", "required", "autofocus"];
function Switchervue_type_template_id_51c6a76e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqShimmer, {
    type: "switcher",
    inverse: _ctx.inverse,
    loading: _ctx.loading,
    size: _ctx.size
  }, null, 8, ["inverse", "loading", "size"]), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Switchervue_type_template_id_51c6a76e_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
    type: "checkbox",
    "tab-index": _ctx.tabindex,
    disabled: _ctx.disabled,
    checked: _ctx.checked,
    required: _ctx.required,
    autofocus: _ctx.autofocus,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.inputClasses),
    onChange: _cache[0] || (_cache[0] = $event => _ctx.$emit('change', $event))
  }, null, 42, Switchervue_type_template_id_51c6a76e_ts_true_hoisted_2), _ctx.switcherLabel && _ctx.label ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("label", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.labelClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Switcher/Switcher.vue?vue&type=template&id=51c6a76e&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Switcher/Switcher.vue?vue&type=script&lang=ts


/* harmony default export */ var Switchervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqSwitcher",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "small"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: Number
    },
    switcherLabel: {
      type: Boolean,
      default: true
    },
    label: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrqShimmer: Shimmer
  },
  setup(props) {
    const defaultClass = "orq-switcher";
    const defaultInputClass = "orq-switcher__input";
    return {
      inputClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${defaultInputClass}`]: true,
          [`${defaultInputClass}--${props.size}`]: props.size,
          [props.inverse ? `${defaultInputClass}--inverse` : `${defaultInputClass}--default`]: true
        };
      }),
      labelClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`${defaultClass}__label`]: props.label,
          [`${defaultClass}__label--inverse`]: props.inverse,
          [`${defaultClass}__label--disabled`]: props.disabled
        };
      }),
      defaultClass,
      defaultInputClass
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Switcher/Switcher.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Switcher/Switcher.vue?vue&type=style&index=0&id=51c6a76e&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Switcher/Switcher.vue?vue&type=style&index=0&id=51c6a76e&lang=scss

;// CONCATENATED MODULE: ./src/components/Switcher/Switcher.vue




;


const Switcher_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Switchervue_type_script_lang_ts, [['render',Switchervue_type_template_id_51c6a76e_ts_true_render]])

/* harmony default export */ var Switcher = (Switcher_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/RadioButton/RadioButton.vue?vue&type=template&id=ff095c00&ts=true

const RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_1 = {
  key: 1,
  class: "orq-radio-group"
};
const RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_2 = {
  key: 0,
  class: "orq-radio-button__container"
};
const RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
  class: "orq-radio-button__outer-circle"
}, null, -1);
const RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
  class: "orq-radio-button__inner-circle"
}, null, -1);
const RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_5 = [RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_3, RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_4];
const RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_6 = {
  class: "orq-radio-button__label"
};
const RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_7 = ["value", "name", "disabled", "checked", "onChange"];
function RadioButtonvue_type_template_id_ff095c00_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    type: "radio-button",
    "radio-button-position": _ctx.alignLabel === 'left' ? 'right' : 'left',
    "type-radio-button": _ctx.type,
    loading: _ctx.loading,
    inverse: _ctx.inverse,
    rows: _ctx.options?.length
  }, null, 8, ["radio-button-position", "type-radio-button", "loading", "inverse", "rows"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_1, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.inputOptions, option => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("label", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([_ctx.radioButtonClass, _ctx.getSelectedClass(option), _ctx.getDisabledClass(option)]),
      key: option,
      tabindex: "0"
    }, [_ctx.type === 'label' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_2, RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_5)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_6, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(option.label), 1), _ctx.type !== 'label' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
      key: 1,
      type: "none",
      name: "check",
      class: "orq-radio-button__icon",
      color: _ctx.iconColor
    }, null, 8, ["color"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
      class: "orq-radio-button__input",
      type: "radio",
      value: option.value,
      name: _ctx.groupName,
      disabled: option.disabled,
      checked: option.selected,
      onChange: $event => (_ctx.onChange(option.value), _ctx.isSelected(option))
    }, null, 40, RadioButtonvue_type_template_id_ff095c00_ts_true_hoisted_7)], 2);
  }), 128))])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/RadioButton/RadioButton.vue?vue&type=template&id=ff095c00&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/RadioButton/RadioButton.vue?vue&type=script&lang=ts




/* harmony default export */ var RadioButtonvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "orq-radio-button",
  components: {
    OrqIconContainer: IconContainer,
    OrqShimmer: Shimmer
  },
  props: {
    alignLabel: {
      type: String,
      default: "left"
    },
    type: {
      type: String,
      default: "label"
    },
    loading: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    groupName: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const inputOptions = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.options);
    const isSelected = option => {
      if (option.disabled) {
        return;
      }
      const optionSelected = inputOptions.value.find(element => element.selected === true);
      if (optionSelected && !optionSelected.disabled) {
        optionSelected.selected = false;
      }
      option.selected = true;
    };
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    return {
      radioButtonClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-radio-button": true,
          "orq-radio-button--inverse": props.inverse,
          [`orq-radio-button--${props.alignLabel}`]: true,
          [`orq-radio-button--${props.type}`]: props.type !== "label"
        };
      }),
      iconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return props.inverse ? iconColors.value.emphasisBaseHigh : iconColors.value.emphasisBaseInverseHigh;
      }),
      inputOptions,
      isSelected
    };
  },
  methods: {
    getOptions() {
      return this.options?.length;
    },
    getSelectedClass(option) {
      return option.selected ? "orq-radio-button--selected" : "";
    },
    getDisabledClass(option) {
      return option.disabled ? "orq-radio-button--disabled" : "";
    },
    onChange(event) {
      this.$emit("change", event.target);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/RadioButton/RadioButton.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/RadioButton/RadioButton.vue?vue&type=style&index=0&id=ff095c00&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/RadioButton/RadioButton.vue?vue&type=style&index=0&id=ff095c00&lang=scss

;// CONCATENATED MODULE: ./src/components/RadioButton/RadioButton.vue




;


const RadioButton_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(RadioButtonvue_type_script_lang_ts, [['render',RadioButtonvue_type_template_id_ff095c00_ts_true_render]])

/* harmony default export */ var RadioButton = (RadioButton_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/views/ListAction.vue?vue&type=script&lang=ts







/* harmony default export */ var ListActionvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqListAction",
  props: {
    type: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    selected: {
      type: Boolean,
      default: false
    },
    radioButtonGroupName: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  components: {
    OrqCheckbox: Checkbox,
    OrqSwitcher: Switcher,
    OrqRadioButton: RadioButton,
    OrqButton: Button,
    OrqLink: Link,
    OrqIconContainer: IconContainer
  },
  setup(props, {
    emit
  }) {
    const onAction = () => {
      emit("onAction", props.value);
    };
    return {
      onAction
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/List/views/ListAction.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/views/ListAction.vue?vue&type=style&index=0&id=a0c40b4e&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/List/views/ListAction.vue?vue&type=style&index=0&id=a0c40b4e&lang=scss

;// CONCATENATED MODULE: ./src/components/List/views/ListAction.vue




;


const ListAction_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ListActionvue_type_script_lang_ts, [['render',ListActionvue_type_template_id_a0c40b4e_ts_true_render]])

/* harmony default export */ var ListAction = (ListAction_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/List.vue?vue&type=script&lang=ts






/* harmony default export */ var Listvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqList",
  props: {
    fullWidth: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    overline: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  components: {
    OrqShimmer: Shimmer,
    OrqDivider: Divider,
    OrqListMeta: ListMeta,
    OrqListExtra: ListExtra,
    OrqListAction: ListAction
  },
  setup(props, {
    emit
  }) {
    const dataSource = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.options);
    const actionType = dataSource.value[0].action?.type;
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      dataSource.value = props.options;
    });
    const handleClick = index => {
      const action = dataSource.value[index].action;
      if (action?.type === "checkbox" || action?.type === "switcher") {
        if (action) {
          action.selected = !action.selected;
        }
      }
      emit("actionClick", action);
    };
    return {
      listContainerClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-list__container": true,
          "orq-list__container--full-width": props.fullWidth
        };
      }),
      listOverlineClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-list__overline": true,
          "orq-list__overline--inverse": props.overline && props.inverse
        };
      }),
      listOverlineTitleClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-list__overline__title": true,
          "orq-list__overline__title--inverse": props.overline && props.inverse
        };
      }),
      listContainerDividerClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-list__container__divider": true,
          "orq-list__container__divider--spacing-between": true
        };
      }),
      dataSource,
      handleClick,
      actionType
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/List/List.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/List/List.vue?vue&type=style&index=0&id=70546fea&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/List/List.vue?vue&type=style&index=0&id=70546fea&lang=scss

;// CONCATENATED MODULE: ./src/components/List/List.vue




;


const List_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Listvue_type_script_lang_ts, [['render',Listvue_type_template_id_70546fea_ts_true_render]])

/* harmony default export */ var List = (List_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Search/Search.vue?vue&type=template&id=e11f1c74&ts=true

const Searchvue_type_template_id_e11f1c74_ts_true_hoisted_1 = {
  class: "orq-search__input-wrapper"
};
const Searchvue_type_template_id_e11f1c74_ts_true_hoisted_2 = ["disabled", "placeholder"];
const Searchvue_type_template_id_e11f1c74_ts_true_hoisted_3 = {
  key: 0,
  class: "orq-search__dropdown"
};
const Searchvue_type_template_id_e11f1c74_ts_true_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
  class: "orq-search__dropdown__item"
}, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, "Não encontramos resultados")], -1);
const Searchvue_type_template_id_e11f1c74_ts_true_hoisted_5 = [Searchvue_type_template_id_e11f1c74_ts_true_hoisted_4];
const Searchvue_type_template_id_e11f1c74_ts_true_hoisted_6 = {
  key: 1,
  class: "orq-search__dropdown",
  ref: "refDropdown"
};
const Searchvue_type_template_id_e11f1c74_ts_true_hoisted_7 = ["onClick"];
function Searchvue_type_template_id_e11f1c74_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    ref: "searchRef",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.searchClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Searchvue_type_template_id_e11f1c74_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
    type: "text",
    autoComplete: "off",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.innerValue = $event),
    disabled: _ctx.disabled,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.searchTypeGlobalAndLocalInputClasses),
    placeholder: !_ctx.isFocus ? _ctx.label : _ctx.placeholder,
    onFocus: _cache[1] || (_cache[1] = $event => _ctx.onFocus($event)),
    onInput: _cache[2] || (_cache[2] = $event => _ctx.handleInputChange($event))
  }, null, 42, Searchvue_type_template_id_e11f1c74_ts_true_hoisted_2), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vModelText, _ctx.innerValue]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    name: "tools-search",
    type: "none",
    size: 24,
    color: _ctx.setColorIcon()
  }, null, 8, ["color"]), _ctx.isFocus || _ctx.innerValue !== '' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    name: "close",
    role: "button",
    type: "none",
    size: 24,
    tabIndex: -1,
    color: _ctx.setColorIcon(),
    onClick: _cache[3] || (_cache[3] = $event => _ctx.onClear($event))
  }, null, 8, ["color"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), _ctx.type === 'autocomplete' && _ctx.renderItems.length === 0 && !_ctx.hasSearchResult && _ctx.isFocus ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Searchvue_type_template_id_e11f1c74_ts_true_hoisted_3, Searchvue_type_template_id_e11f1c74_ts_true_hoisted_5)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'autocomplete' && _ctx.isFocus ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Searchvue_type_template_id_e11f1c74_ts_true_hoisted_6, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.renderItems, (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: index,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.searchDropdownItemClasses),
      "tab-index": 0,
      onClick: $event => _ctx.onSelectedItem(item)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.text), 1)], 10, Searchvue_type_template_id_e11f1c74_ts_true_hoisted_7);
  }), 128))], 512)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/Search/Search.vue?vue&type=template&id=e11f1c74&ts=true

;// CONCATENATED MODULE: ./src/utils/functions/useOnClickOutside.ts

function useOnClickOutside(ref, handler) {
  const listener = event => {
    if (!ref.value || ref.value.contains(event.target)) {
      return;
    }
    handler(event);
  };
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
  });
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeUnmount)(() => {
    document.removeEventListener("mousedown", listener);
    document.removeEventListener("touchstart", listener);
  });
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Search/Search.vue?vue&type=script&lang=ts




/* harmony default export */ var Searchvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqSearch",
  props: {
    label: {
      label: String,
      default: ""
    },
    defaultValue: {
      type: String,
      default: ""
    },
    modelValue: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "global"
    },
    size: {
      type: String,
      default: "small"
    },
    searchList: {
      type: Array,
      default: () => []
    },
    recentSearch: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ""
    },
    hasSearchRecent: {
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OrqIconContainer: IconContainer
  },
  emits: ["update:modelValue", "focus", "handleinputchange", "onclear", "onSelectedItem"],
  setup(props, {
    emit
  }) {
    const inverseClass = props.inverse ? "orq-search--inverse" : "";
    const inverseDroplistClass = props.inverse ? "orq-search__dropdown__item--inverse" : "";
    const sizeClass = props.size === "large" ? "orq-search--large" : "";
    const backgroundClass = props.background ? "orq-search--background" : "";
    const disabledClass = props.disabled ? "orq-search--disabled" : "";
    const renderItems = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    const selectedItem = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(undefined);
    const searchRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const refDropdown = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const hasSearchResult = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(true);
    let isFocus = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    let innerValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.defaultValue);
    useOnClickOutside(searchRef, () => {
      isFocus.value = false;
    });
    const onFocus = event => {
      isFocus.value = true;
      onChangeItems(false);
      emit("focus", event);
    };
    const handleInputChange = event => {
      innerValue.value = event.target.value;
      onChangeItems();
      emit("update:modelValue", event.target.value);
      emit("handleinputchange", innerValue.value);
    };
    const onClear = event => {
      innerValue.value = "";
      isFocus.value = false;
      renderItems.value = [];
      emit("update:modelValue", "");
      emit("onclear", innerValue.value);
      if (selectedItem.value !== undefined) {
        selectedItem.value = undefined;
        emit("onSelectedItem", selectedItem.value);
      }
    };
    const onChangeItems = (hasChange = true) => {
      if (selectedItem.value !== undefined && hasChange) {
        selectedItem.value = undefined;
        emit("onSelectedItem", selectedItem.value);
      }
      if (innerValue.value.length === 0 && props.hasSearchRecent) {
        renderItems.value = props.recentSearch;
        return;
      }
      if (innerValue.value.length > 0) {
        const filterValue = props.searchList.filter(item => {
          if (item.text) {
            return item.text.toLocaleLowerCase().includes(innerValue.value.toLocaleLowerCase());
          }
        });
        hasSearchResult.value = filterValue.length > 0 ? true : false;
        renderItems.value = filterValue;
      } else {
        renderItems.value = [];
      }
    };
    const onKeyPressChange = event => {
      if (event.key === "Enter") {
        onChangeItems();
        isFocus.value = true;
      }
    };
    const onChangeValue = event => {
      const value = event.target.value;
      innerValue.value = value;
    };
    const onSelectedItem = item => {
      innerValue.value = item.text;
      renderItems.value = [];
      selectedItem.value = item;
      emit("onSelectedItem", selectedItem.value);
    };
    const setColorIcon = () => {
      if (props.disabled && props.type) {
        if (!props.inverse) {
          return EiconContainerColor.emphasisBaseDisabled;
        }
        return EiconContainerColor.emphasisBaseInverseDisabled;
      } else {
        if (!props.inverse) {
          return EiconContainerColor.emphasisBaseHigh;
        }
        return EiconContainerColor.emphasisBaseInverseHigh;
      }
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      innerValue.value = props.defaultValue || props.modelValue;
    });
    return {
      searchClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-search": true,
          [`${sizeClass}`]: props.size,
          [`${inverseClass}`]: props.inverse,
          [`${backgroundClass}`]: props.background,
          [`${disabledClass}`]: props.type && props.disabled
        };
      }),
      searchDropdownItemClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-search__dropdown__item": true,
          [`${inverseDroplistClass}`]: props.inverse
        };
      }),
      searchTypeGlobalAndLocalInputClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-search__input-wrapper": true,
          [`${inverseClass}`]: props.inverse,
          [`${backgroundClass}`]: props.background,
          [`${disabledClass}`]: props.type && props.disabled
        };
      }),
      searchRef,
      refDropdown,
      innerValue,
      isFocus,
      renderItems,
      selectedItem,
      hasSearchResult,
      handleInputChange,
      onKeyPressChange,
      onChangeValue,
      onFocus,
      onClear,
      onSelectedItem,
      setColorIcon
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Search/Search.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Search/Search.vue?vue&type=style&index=0&id=e11f1c74&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Search/Search.vue?vue&type=style&index=0&id=e11f1c74&lang=scss

;// CONCATENATED MODULE: ./src/components/Search/Search.vue




;


const Search_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Searchvue_type_script_lang_ts, [['render',Searchvue_type_template_id_e11f1c74_ts_true_render]])

/* harmony default export */ var Search = (Search_exports_);
;// CONCATENATED MODULE: ./src/components/Search/models/search.enum.ts
var EsearchType;
(function (EsearchType) {
  EsearchType["global"] = "global";
  EsearchType["local"] = "local";
  EsearchType["autocomplete"] = "autocomplete";
})(EsearchType || (EsearchType = {}));
var EsearchSize;
(function (EsearchSize) {
  EsearchSize["large"] = "large";
  EsearchSize["small"] = "small";
})(EsearchSize || (EsearchSize = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/views/FilterList.vue?vue&type=script&lang=ts





/* harmony default export */ var FilterListvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqFilterList",
  props: {
    title: {
      type: String,
      default: ""
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    searchEmpty: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    populated: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    hasSearch: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  components: {
    OrqList: List,
    OrqSearch: Search,
    OrqFilterItem: FilterItem
  },
  setup(props, {
    emit
  }) {
    const dataSource = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.options);
    const filteredResult = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    const isChecked = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const OrqFilterItemRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const isPopulated = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(isChecked.value);
    const searchTypes = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EsearchType);
    const searchSizes = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EsearchSize);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeMount)(() => {
      filteredResult.value = dataSource.value;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      if (OrqFilterItemRef.value) {
        document.addEventListener("onFilterClear", () => {
          onRemoveItemClick();
        });
      }
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
      if (OrqFilterItemRef.value) {
        document.removeEventListener("onFilterClear", () => {
          onRemoveItemClick();
        });
      }
    });
    const onItemClick = event => {
      emit("onitemclicklist", event);
    };
    const handleChecked = event => {
      isChecked.value = dataSource.value.some(item => item.action?.selected === true);
      isPopulated.value = isChecked.value;
    };
    const onRemoveItemClick = () => {
      const newData = dataSource.value.map(opt => {
        if (opt.action?.selected !== undefined) opt.action.selected = false;
        return opt;
      });
      dataSource.value = newData;
      emit("onremoveitemclick");
    };
    const handleInputChange = event => {
      if (event.length > 0) {
        const filterValue = dataSource.value.filter(item => {
          if (item.meta?.title) {
            return item.meta.title.toLocaleLowerCase().includes(event.toLocaleLowerCase());
          }
        });
        filteredResult.value = filterValue;
      } else {
        filteredResult.value = dataSource.value;
      }
    };
    const onClear = value => {
      value = "";
      filteredResult.value = dataSource.value;
    };
    return {
      OrqFilterItemRef,
      dataSource,
      filteredResult,
      isChecked,
      searchTypes,
      searchSizes,
      isPopulated,
      onItemClick,
      onRemoveItemClick,
      handleInputChange,
      handleChecked,
      onClear
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Filter/views/FilterList.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/views/FilterList.vue?vue&type=style&index=0&id=02357fea&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Filter/views/FilterList.vue?vue&type=style&index=0&id=02357fea&lang=scss

;// CONCATENATED MODULE: ./src/components/Filter/views/FilterList.vue




;


const FilterList_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(FilterListvue_type_script_lang_ts, [['render',FilterListvue_type_template_id_02357fea_ts_true_render]])

/* harmony default export */ var FilterList = (FilterList_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/views/FilterCalendar.vue?vue&type=template&id=2e7b5e85&ts=true

const FilterCalendarvue_type_template_id_2e7b5e85_ts_true_hoisted_1 = {
  class: "orq-item-calendar"
};
const FilterCalendarvue_type_template_id_2e7b5e85_ts_true_hoisted_2 = {
  key: 0,
  class: "orq-item-calendar--input"
};
const FilterCalendarvue_type_template_id_2e7b5e85_ts_true_hoisted_3 = {
  class: "orq-item-calendar--datepicker"
};
function FilterCalendarvue_type_template_id_2e7b5e85_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqInput = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqInput");
  const _component_OrqCalendar = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqCalendar");
  const _component_OrqFilterItem = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqFilterItem");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqFilterItem, {
    ref: "OrqFilterItemRef",
    inverse: _ctx.inverse,
    opened: _ctx.isOpen,
    populated: _ctx.startDateClick.length > 0,
    title: _ctx.title,
    onItemclick: _ctx.onItemClick,
    onRemoveitem: _ctx.onRemoveItemClick
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", FilterCalendarvue_type_template_id_2e7b5e85_ts_true_hoisted_1, [_ctx.range ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", FilterCalendarvue_type_template_id_2e7b5e85_ts_true_hoisted_2, [_ctx.startDateClick || _ctx.endDateClick ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: 0
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqInput, {
      type: "text",
      startIcon: "schedule",
      placeholder: "Data inicial",
      defaultValue: _ctx.startDateClick,
      modelValue: _ctx.startDateClick,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.startDateClick = $event),
      inverse: _ctx.inverse,
      maxlength: 10,
      onInputchange: _ctx.handleStartDateChange
    }, null, 8, ["defaultValue", "modelValue", "inverse", "onInputchange"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqInput, {
      type: "text",
      startIcon: "schedule",
      placeholder: "Data final",
      maxlength: 10,
      inverse: _ctx.inverse,
      defaultValue: _ctx.endDateClick,
      modelValue: _ctx.endDateClick,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.endDateClick = $event),
      onInputchange: _ctx.handleEndDateChange
    }, null, 8, ["inverse", "defaultValue", "modelValue", "onInputchange"])], 64)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: 1
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqInput, {
      type: "text",
      startIcon: "schedule",
      placeholder: "Data inicial",
      maxlength: 10,
      inverse: _ctx.inverse,
      defaultValue: _ctx.startDateState,
      onInputchange: _ctx.handleStartDateChange
    }, null, 8, ["inverse", "defaultValue", "onInputchange"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqInput, {
      type: "text",
      startIcon: "schedule",
      placeholder: "Data final",
      maxlength: 10,
      inverse: _ctx.inverse,
      defaultValue: _ctx.endDateState,
      onInputchange: _ctx.handleEndDateChange
    }, null, 8, ["inverse", "defaultValue", "onInputchange"])], 64))])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", FilterCalendarvue_type_template_id_2e7b5e85_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqCalendar, {
      ref: "refCalendar",
      startDateValue: _ctx.startDateState,
      endDateValue: _ctx.endDateState,
      type: "single",
      mode: "datepicker",
      events: _ctx.events,
      inverse: _ctx.inverse,
      weekendAvailable: _ctx.weekendAvailable,
      range: _ctx.range,
      start: _ctx.start,
      finish: _ctx.finish,
      blockDateList: _ctx.blockDateList,
      withBlockList: _ctx.withBlockList,
      allowedDateList: _ctx.allowedDateList,
      withAllowedList: _ctx.withAllowedList,
      onSelectday: _ctx.selectDay
    }, null, 8, ["startDateValue", "endDateValue", "events", "inverse", "weekendAvailable", "range", "start", "finish", "blockDateList", "withBlockList", "allowedDateList", "withAllowedList", "onSelectday"])])])]),
    _: 1
  }, 8, ["inverse", "opened", "populated", "title", "onItemclick", "onRemoveitem"]);
}
;// CONCATENATED MODULE: ./src/components/Filter/views/FilterCalendar.vue?vue&type=template&id=2e7b5e85&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Input/Input.vue?vue&type=template&id=1cf1c61d&ts=true

const Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_1 = ["aria-label", "for"];
const Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_2 = {
  class: "orq-input__container"
};
const Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_3 = {
  class: "orq-input__icon"
};
const Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_4 = {
  class: "orq-input__input-wrapper"
};
const Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_5 = ["name", "autofocus", "aria-label", "id", "type", "placeholder", "disabled", "maxLength", "required", "readonly", "autocomplete"];
const Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_6 = ["disabled"];
const Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_7 = {
  key: 1,
  class: "orq-input__description-wrapper"
};
const Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_8 = {
  class: "orq-input__icon end-icon"
};
function Inputvue_type_template_id_1cf1c61d_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqImageContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqImageContainer");
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("fieldset", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.fieldsetClasses)
  }, [_ctx.label && !_ctx.animation ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("label", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.labelClasses),
    "aria-label": _ctx.ariaLabel,
    for: _ctx.id,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      color: !_ctx.isFocus && _ctx.innerValue.length > 0 && !_ctx.disabled && !_ctx.inverse ? 'var(--emphasis-base-high)' : _ctx.inverse && !_ctx.isFocus && !_ctx.disabled && _ctx.innerValue.length > 0 ? 'var(--emphasis-base-high-inverse)' : ''
    })
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 15, Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_3, [_ctx.startIcon ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    class: "start-icon",
    type: "none",
    name: _ctx.startIcon ? _ctx.startIcon : '',
    color: _ctx.getIconColor(),
    size: _ctx.defaultSizeIcon()
  }, null, 8, ["name", "color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.prefixSuffixOptions === 'prefix' && _ctx.type !== 'password' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.paragraphPrefixClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.prefix), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
    ref: "inputRef",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.innerValue = $event),
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.inputClasses),
    name: _ctx.name,
    autofocus: _ctx.autoFocus,
    "aria-label": _ctx.ariaLabel,
    id: _ctx.id,
    type: _ctx.typeInput,
    placeholder: _ctx.animation ? '' : _ctx.placeholder,
    disabled: _ctx.disabled,
    maxLength: _ctx.maxLength,
    required: _ctx.required,
    readonly: _ctx.readOnly,
    autocomplete: _ctx.autoComplete,
    onChange: _cache[1] || (_cache[1] = $event => _ctx.onChangeEvent($event)),
    onFocus: _cache[2] || (_cache[2] = $event => _ctx.onFocus($event)),
    onBlur: _cache[3] || (_cache[3] = $event => _ctx.onBlur($event)),
    onInput: _cache[4] || (_cache[4] = $event => _ctx.handleInputChange($event)),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      color: _ctx.innerValue.length && !_ctx.disabled && !_ctx.inverse && !_ctx.error ? 'var(--emphasis-base-high)' : _ctx.inverse && _ctx.innerValue.length && !_ctx.disabled && !_ctx.error ? 'var(--emphasis-base-high-inverse)' : ''
    })
  }, null, 46, Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_5), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vModelDynamic, _ctx.innerValue]]), _ctx.animation ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 0,
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.prefixSuffixOptions === 'prefix' ? _ctx.animatePlaceholderWithPrefix() : ''),
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.placeholderAnimatedClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.placeholder), 7)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.suffix && _ctx.type !== 'password' && _ctx.prefixSuffixOptions === 'suffix' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.spanSuffixClasses),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      left: _ctx.suffixPosition + 'px'
    })
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.suffix), 7)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.endIconClasses)
  }, [!_ctx.endIcon ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {
    key: 0
  }) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.endInput === 'icon' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [_ctx.type !== 'password' && _ctx.endIcon !== 'close' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    type: "none",
    name: _ctx.endIcon ? _ctx.endIcon : '',
    color: _ctx.getIconColor(),
    size: _ctx.defaultSizeIcon()
  }, null, 8, ["name", "color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type !== 'password' && _ctx.endIcon === 'close' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 1,
    type: "none",
    name: "close",
    color: _ctx.getIconColor(),
    size: _ctx.defaultSizeIcon(),
    onClick: _cache[5] || (_cache[5] = $event => _ctx.onClear($event))
  }, null, 8, ["color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'password' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 2,
    type: "none",
    name: _ctx.typeInput === 'password' ? 'visibility-on' : 'visibility-off',
    color: _ctx.getIconColor(),
    size: _ctx.defaultSizeIcon(),
    onClick: _cache[6] || (_cache[6] = $event => _ctx.showPassword())
  }, null, 8, ["name", "color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), _ctx.endInput === 'image' && _ctx.type !== 'password' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([_ctx.endIconClasses, _ctx.disabled ? 'orq-image-container--disabled' : ''])
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqImageContainer, {
    shape: "rounded",
    src: _ctx.srcImg,
    alt: _ctx.altImg,
    inverse: _ctx.inverse,
    outline: _ctx.outlineImg,
    size: _ctx.size === 'small' ? 16 : 24
  }, null, 8, ["src", "alt", "inverse", "outline", "size"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-input__currency-flag ${_ctx.inverse ? 'orq-input__currency-flag--inverse' : ''}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("input", {
    type: "text",
    placeholder: "BRL",
    maxLength: 3,
    disabled: _ctx.disabled
  }, null, 8, Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_6)], 2)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    id: "line",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.lineClasses),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      backgroundColor: _ctx.innerValue.length > 0 && !_ctx.isFocus && !_ctx.disabled && !_ctx.inverse && !_ctx.error ? 'var(--emphasis-base-high)' : _ctx.inverse && !_ctx.isFocus && !_ctx.disabled && _ctx.innerValue.length > 0 && !_ctx.error ? 'var(--emphasis-base-high-inverse)' : ''
    })
  }, null, 6), _ctx.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_7, [_ctx.error && _ctx.size === 'large' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Inputvue_type_template_id_1cf1c61d_ts_true_hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "status-error",
    size: 16,
    color: _ctx.getIconColor()
  }, null, 8, ["color"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    ref: "refSpan",
    class: "description",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      color: _ctx.inverse && !_ctx.disabled ? 'var(--emphasis-base-medium-inverse)' : _ctx.disabled ? 'var(--emphasis-base-disabled-inverse)' : 'var(--emphasis-base-medium)'
    })
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 5)], 64)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 1,
    class: "description",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      color: !_ctx.isFocus && _ctx.innerValue.length > 0 && !_ctx.disabled && !_ctx.inverse && !_ctx.error ? 'var(--emphasis-base-high)' : _ctx.inverse && !_ctx.isFocus && !_ctx.disabled && _ctx.innerValue.length > 0 && !_ctx.error ? 'var(--emphasis-base-high-inverse)' : ''
    })
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 5))])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 1,
    type: "input",
    size: _ctx.size,
    loading: _ctx.loading,
    inverse: _ctx.inverse
  }, null, 8, ["size", "loading", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Input/Input.vue?vue&type=template&id=1cf1c61d&ts=true

;// CONCATENATED MODULE: ./src/components/Input/models/Input.enum.ts
var EinputType;
(function (EinputType) {
  EinputType["number"] = "number";
  EinputType["text"] = "text";
  EinputType["password"] = "password";
})(EinputType || (EinputType = {}));
var EendInputType;
(function (EendInputType) {
  EendInputType["icon"] = "icon";
  EendInputType["image"] = "image";
})(EendInputType || (EendInputType = {}));
var EinputPrefixSuffixOptions;
(function (EinputPrefixSuffixOptions) {
  EinputPrefixSuffixOptions["none"] = "none";
  EinputPrefixSuffixOptions["prefix"] = "prefix";
  EinputPrefixSuffixOptions["suffix"] = "suffix";
})(EinputPrefixSuffixOptions || (EinputPrefixSuffixOptions = {}));
var EinputSize;
(function (EinputSize) {
  EinputSize["small"] = "small";
  EinputSize["large"] = "large";
})(EinputSize || (EinputSize = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Input/Input.vue?vue&type=script&lang=ts






/* harmony default export */ var Inputvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqInput",
  components: {
    OrqShimmer: Shimmer,
    OrqIconContainer: IconContainer,
    OrqImageContainer: ImageContainer
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    autoComplete: {
      type: String,
      default: "off"
    },
    modelValue: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "small"
    },
    srcImg: {
      type: String,
      default: ""
    },
    altImg: {
      type: String,
      default: ""
    },
    outlineImg: {
      type: Boolean,
      default: false
    },
    endInput: {
      type: String,
      default: "icon"
    },
    name: {
      type: String,
      default: "Name"
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: "Aria label"
    },
    id: {
      type: String,
      default: "#ID"
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: "Placeholder"
    },
    maxLength: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    startIcon: {
      type: String
    },
    endIcon: {
      type: String
    },
    prefixSuffixOptions: {
      type: String,
      default: "none"
    },
    prefix: {
      type: String,
      default: "R$"
    },
    suffix: {
      type: String,
      default: "%"
    },
    animation: {
      type: Boolean,
      default: false
    },
    disableErrorAnimation: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "focus", "blur", "change", "inputchange", "clear"],
  setup(props, {
    emit
  }) {
    const inputRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const refSpan = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const fontSmall = 16;
    const fontLarge = 24;
    let typeInput = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.type);
    let suffixPosition = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0);
    let innerValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.modelValue);
    let isFocus = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      inputRef.value?.setAttribute("value", "");
      init();
      inputEvents(props.modelValue || props.placeholder);
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(props, () => {
      init();
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      innerValue.value = props.modelValue;
    });
    const init = () => {
      suffixPosition.value = getTextWidth(props.placeholder) + 10;
    };
    const onFocus = event => {
      isFocus.value = true;
      emit("focus", event);
    };
    const onBlur = event => {
      if (innerValue.value.length > 0) {
        event.target.setAttribute("value", innerValue.value);
      } else {
        event.target.setAttribute("value", "");
      }
      isFocus.value = false;
      emit("blur", event);
    };
    const getIconColor = () => {
      if (props.error && props.inverse && props.disabled || props.disabled && props.inverse) {
        return EiconContainerColor.emphasisBaseInverseDisabled;
      } else if (props.error && props.inverse) {
        return EiconContainerColor.statusErrorInverse;
      } else if (props.error && props.disabled || props.disabled) {
        return EiconContainerColor.emphasisBaseDisabled;
      } else if (props.inverse && !isFocus.value && !innerValue.value.length) {
        return EiconContainerColor.emphasisBaseInverseMedium;
      } else if (props.error) {
        return EiconContainerColor.statusError;
      } else if (!props.inverse && isFocus.value || !props.inverse && innerValue.value.length > 0) {
        return EiconContainerColor.emphasisBaseHigh;
      } else if (props.inverse && isFocus.value || props.inverse && innerValue.value.length > 0) {
        return EiconContainerColor.emphasisBaseInverseHigh;
      }
      return EiconContainerColor.emphasisBaseMedium;
    };
    const defaultSizeIcon = () => {
      return props.size === "small" ? fontSmall : fontLarge;
    };
    const getTextWidth = value => {
      if (!props.startIcon) {
        return;
      }
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      if (props.size === "small") {
        context.font = "16px Moderat";
        return props.startIcon ? context.measureText(value).width + 30 : context.measureText(value).width + 4;
      }
      if (props.size === "large") {
        context.font = "24px Moderat";
        return props.startIcon ? context.measureText(value).width + 40 : context.measureText(value).width + 7;
      }
    };
    const onChangeEvent = event => {
      emit("change", event);
    };
    const inputEvents = value => {
      if (!props.suffix) {
        return;
      }
      suffixPosition.value = getTextWidth(value) + 6;
      if (innerValue.value.length === 0) {
        suffixPosition.value = getTextWidth(props.placeholder);
      }
    };
    const handleInputChange = e => {
      inputEvents(e.target.value);
      emit("update:modelValue", e.target.value);
      emit("inputchange", e);
    };
    const animatePlaceholderWithPrefix = () => {
      const prefixWidth = getTextWidth(props.prefix);
      const style = {
        left: `${prefixWidth + 6}px`
      };
      if ((isFocus.value || inputRef?.value) && props.size === "small") {
        Object.assign(style, {
          transform: `translateY(-18px) translateX(-${prefixWidth + 6}px)`,
          "font-size": "10px",
          "font-weight": "500",
          "line-height": "15px"
        });
      }
      if ((isFocus.value || inputRef?.value) && props.size === "large") {
        Object.assign(style, {
          transform: `translateY(-20px) translateX(-${prefixWidth + 6}px)`,
          "font-size": "12px",
          "font-weight": "500",
          "line-height": "18px"
        });
      }
      return style;
    };
    const showPassword = () => {
      if (typeInput.value === EinputType.password) {
        typeInput.value = EinputType.text;
      } else {
        typeInput.value = EinputType.password;
      }
    };
    const onClear = event => {
      innerValue.value = "";
      inputRef.value?.focus();
      emit("clear", event);
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      suffixPosition.value = getTextWidth(props.placeholder) + 10;
    });
    return {
      fieldsetClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input": true,
          "orq-input--disabled": props.disabled,
          "orq-input--inverse": props.inverse,
          "orq-input--focused": isFocus.value,
          [`orq-input--${props.size}`]: props.size,
          [`orq-input--error`]: props.error && !props.disabled,
          [`orq-input--inverse--error`]: props.error && props.inverse,
          [`orq-input--${props.size}--prefix`]: props.prefix && props.prefixSuffixOptions === EinputPrefixSuffixOptions.prefix,
          [`orq-input--${props.size}--suffix`]: props.suffix && props.prefixSuffixOptions === EinputPrefixSuffixOptions.suffix,
          [`orq-input--error-no-animate`]: props.error && props.disableErrorAnimation,
          [`orq-input--${props.size}--start-icon`]: props.startIcon,
          [`orq-input--${props.size}--end-icon`]: props.endIcon
        };
      }),
      labelClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input__label": true,
          "orq-input--disabled__label": props.disabled,
          [`orq-input--inverse__label`]: props.inverse,
          [`orq-input--${props.size}__label`]: props.size
        };
      }),
      paragraphPrefixClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input__prefix-suffix": true,
          "orq-input--inverse__prefix-suffix": props.inverse,
          "orq-input__prefix-suffix--disabled": props.disabled,
          "orq-input--inverse__prefix-suffix--disabled": props.inverse && props.disabled
        };
      }),
      inputClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input__input input": true,
          "orq-input--inverse--error__input": props.error && props.inverse,
          "orq-input--inverse__input": props.inverse,
          "orq-input--error__input": props.error && !props.inverse && !props.disabled,
          [`orq-input--${props.size}__input`]: props.size
        };
      }),
      placeholderAnimatedClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input__placeholder--animated": props.animation,
          "orq-input__placeholder--animated--with-icon": props.animation && props.startIcon
        };
      }),
      spanSuffixClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input__suffix": true,
          "orq-input--inverse__suffix": props.inverse,
          [`orq-input--${props.size}__suffix`]: props.size
        };
      }),
      endIconClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "end-icon": true,
          "orq-input__icon": true,
          [`orq-input--${props.size}__end-icon`]: props.size
        };
      }),
      lineClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input__line": true,
          "orq-input--inverse__line": props.inverse,
          "orq-input--disabled__line": props.disabled,
          "orq-input--error__line": props.error && !props.disabled,
          "orq-input--error__line--disabled": props.inverse && props.disabled,
          "orq-input--inverse--error__line": props.inverse && props.error
        };
      }),
      defaultSizeIcon,
      fontSmall,
      fontLarge,
      onFocus,
      onBlur,
      getIconColor,
      getTextWidth,
      inputEvents,
      onChangeEvent,
      handleInputChange,
      animatePlaceholderWithPrefix,
      showPassword,
      onClear,
      typeInput,
      suffixPosition,
      innerValue,
      isFocus,
      inputRef,
      refSpan
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Input/Input.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Input/Input.vue?vue&type=style&index=0&id=1cf1c61d&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Input/Input.vue?vue&type=style&index=0&id=1cf1c61d&lang=scss

;// CONCATENATED MODULE: ./src/components/Input/Input.vue




;


const Input_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Inputvue_type_script_lang_ts, [['render',Inputvue_type_template_id_1cf1c61d_ts_true_render]])

/* harmony default export */ var Input = (Input_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/views/FilterCalendar.vue?vue&type=script&lang=ts




/* harmony default export */ var FilterCalendarvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqFilterCalendar",
  props: {
    title: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    populated: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    events: {
      type: Array,
      default: () => []
    },
    range: {
      type: Boolean,
      default: false
    },
    start: {
      type: String,
      default: ""
    },
    finish: {
      type: String,
      default: ""
    },
    weekendAvailable: {
      type: Boolean,
      default: true
    },
    blockDateList: {
      type: Array,
      default: () => []
    },
    withBlockList: {
      type: Boolean,
      default: true
    },
    allowedDateList: {
      type: Array,
      default: () => []
    },
    withAllowedList: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    }
  },
  components: {
    OrqInput: Input,
    OrqCalendar: Calendar,
    OrqFilterItem: FilterItem
  },
  setup(props, {
    emit
  }) {
    const startDateState = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.startDate);
    const endDateState = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.endDate);
    const isPopulated = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(!!startDateState.value || !!endDateState.value);
    const startDateClick = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("");
    const endDateClick = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("");
    const refCalendar = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const OrqFilterItemRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      if (OrqFilterItemRef.value) {
        document.addEventListener("onFilterClear", () => {
          onRemoveItemClick();
        });
      }
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onUnmounted)(() => {
      if (OrqFilterItemRef.value) {
        document.removeEventListener("onFilterClear", () => {
          onRemoveItemClick();
        });
      }
    });
    function formatDate(data) {
      const date = new Date(data);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    const selectDay = item => {
      startDateState.value = "";
      endDateState.value = "";
      if (item.length === 1) {
        startDateClick.value = formatDate(item[0]);
      }
      if (item.length === 2) {
        endDateClick.value = formatDate(item[1]);
      }
      emit("selectday", item);
    };
    const onRemoveItemClick = () => {
      startDateClick.value = "";
      endDateClick.value = "";
      startDateState.value = "";
      endDateState.value = "";
      if (refCalendar.value) {
        refCalendar.value.clearSelectedDays();
      }
      emit("onremoveitemclick");
    };
    const onItemClick = () => {
      emit("onitemclickcalendar");
    };
    const handleStartDateChange = e => {
      const value = e.target.value;
      if (/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/.test(value)) {
        startDateState.value = value;
      }
    };
    const handleEndDateChange = e => {
      const value = e.target.value;
      if (/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/.test(value)) {
        endDateState.value = value;
      }
    };
    return {
      OrqFilterItemRef,
      refCalendar,
      startDateState,
      endDateState,
      isPopulated,
      onItemClick,
      onRemoveItemClick,
      handleStartDateChange,
      handleEndDateChange,
      selectDay,
      startDateClick,
      endDateClick
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Filter/views/FilterCalendar.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Filter/views/FilterCalendar.vue?vue&type=style&index=0&id=2e7b5e85&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Filter/views/FilterCalendar.vue?vue&type=style&index=0&id=2e7b5e85&lang=scss

;// CONCATENATED MODULE: ./src/components/Filter/views/FilterCalendar.vue




;


const FilterCalendar_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(FilterCalendarvue_type_script_lang_ts, [['render',FilterCalendarvue_type_template_id_2e7b5e85_ts_true_render]])

/* harmony default export */ var FilterCalendar = (FilterCalendar_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/FloatingAction/FloatingAction.vue?vue&type=template&id=e7c4f30a&ts=true

function FloatingActionvue_type_template_id_e7c4f30a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.floatingActionClasses),
    ref: "floatingActionRef"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 2);
}
;// CONCATENATED MODULE: ./src/components/FloatingAction/FloatingAction.vue?vue&type=template&id=e7c4f30a&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/FloatingAction/FloatingAction.vue?vue&type=script&lang=ts

/* harmony default export */ var FloatingActionvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqFloatingAction",
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: "left"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "large"
    }
  },
  setup(props, {
    emit
  }) {
    let floatingActionRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    let isOpened = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.isOpen);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      isOpened.value = props.isOpen;
    });
    return {
      floatingActionClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-floating-action": true,
          "orq-floating-action--inverse": props.inverse,
          "is-open": isOpened.value,
          "orq-floating-action--small": props.size === "small",
          [`orq-floating-action--${props.direction === "right" ? "right" : "left"}`]: props.direction
        };
      }),
      isOpened,
      floatingActionRef
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/FloatingAction/FloatingAction.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/FloatingAction/FloatingAction.vue?vue&type=style&index=0&id=e7c4f30a&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/FloatingAction/FloatingAction.vue?vue&type=style&index=0&id=e7c4f30a&lang=scss

;// CONCATENATED MODULE: ./src/components/FloatingAction/FloatingAction.vue




;


const FloatingAction_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(FloatingActionvue_type_script_lang_ts, [['render',FloatingActionvue_type_template_id_e7c4f30a_ts_true_render]])

/* harmony default export */ var FloatingAction = (FloatingAction_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/FloatingAction/FloatingActionItem.vue?vue&type=template&id=ed54c3aa&ts=true

const FloatingActionItemvue_type_template_id_ed54c3aa_ts_true_hoisted_1 = ["tabindex"];
const FloatingActionItemvue_type_template_id_ed54c3aa_ts_true_hoisted_2 = {
  key: 0,
  class: "orq-floating-action-item__icon"
};
const FloatingActionItemvue_type_template_id_ed54c3aa_ts_true_hoisted_3 = {
  class: "orq-floating-action-item__text"
};
function FloatingActionItemvue_type_template_id_ed54c3aa_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    ref: "elRef",
    role: "button",
    tabindex: _ctx.tabIndex,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.floatingActionItemClasses),
    onMousedown: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.onMouseDownHandler && _ctx.onMouseDownHandler(...args)),
    onMouseup: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.onMouseUpHandler && _ctx.onMouseUpHandler(...args)),
    onFocus: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.onFocus && _ctx.onFocus(...args)),
    onBlur: _cache[3] || (_cache[3] =
    //@ts-ignore
    (...args) => _ctx.onBlur && _ctx.onBlur(...args))
  }, [_ctx.iconName ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", FloatingActionItemvue_type_template_id_ed54c3aa_ts_true_hoisted_2, [_ctx.iconName ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    class: "orq-floating-action-item__icon",
    type: "none",
    name: _ctx.iconName ? _ctx.iconName : '',
    size: _ctx.defaultIconSize(),
    color: _ctx.setIconColor(),
    inverse: _ctx.inverse
  }, null, 8, ["name", "size", "color", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", FloatingActionItemvue_type_template_id_ed54c3aa_ts_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 1)], 42, FloatingActionItemvue_type_template_id_ed54c3aa_ts_true_hoisted_1);
}
;// CONCATENATED MODULE: ./src/components/FloatingAction/FloatingActionItem.vue?vue&type=template&id=ed54c3aa&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/FloatingAction/FloatingActionItem.vue?vue&type=script&lang=ts



/* harmony default export */ var FloatingActionItemvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqFloatingActionItem",
  components: {
    OrqIconContainer: IconContainer
  },
  props: {
    iconName: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "large"
    },
    selected: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    const elRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const tabIndex = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0);
    const largeIcon = 24;
    const smallIcon = 16;
    const defaultIconSize = () => {
      return props.size === "small" ? smallIcon : largeIcon;
    };
    const onFocus = () => {
      return tabIndex.value = 1;
    };
    const onBlur = () => {
      return tabIndex.value = 0;
    };
    const onMouseUpHandler = () => {
      return elRef.value?.classList.remove("orq-floating-action-item--clicking");
    };
    const onMouseDownHandler = () => {
      return elRef.value?.classList.add("orq-floating-action-item--clicking");
    };
    const setIconColor = () => {
      if (props.inverse && props.selected) {
        return iconColors.value.emphasisBaseHigh;
      }
      if (props.inverse || props.selected) {
        return iconColors.value.emphasisBaseInverseHigh;
      }
      return iconColors.value.emphasisBaseHigh;
    };
    return {
      floatingActionItemClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-floating-action-item": true,
          "orq-floating-action-item--active": props.selected
        };
      }),
      elRef,
      tabIndex,
      onFocus,
      onBlur,
      onMouseDownHandler,
      onMouseUpHandler,
      defaultIconSize,
      setIconColor,
      iconColors,
      largeIcon,
      smallIcon
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/FloatingAction/FloatingActionItem.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/FloatingAction/FloatingActionItem.vue?vue&type=style&index=0&id=ed54c3aa&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/FloatingAction/FloatingActionItem.vue?vue&type=style&index=0&id=ed54c3aa&lang=scss

;// CONCATENATED MODULE: ./src/components/FloatingAction/FloatingActionItem.vue




;


const FloatingActionItem_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(FloatingActionItemvue_type_script_lang_ts, [['render',FloatingActionItemvue_type_template_id_ed54c3aa_ts_true_render]])

/* harmony default export */ var FloatingActionItem = (FloatingActionItem_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ImageGroup/ImageGroup.vue?vue&type=template&id=59dc387c&ts=true

function ImageGroupvue_type_template_id_59dc387c_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqImageContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqImageContainer");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    type: "image-group",
    inverse: _ctx.inverse,
    size: _ctx.size
  }, null, 8, ["inverse", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.ImageClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.GeralClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.firstClasses)
  }, [_ctx.combinations === 'image-and-icon' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqImageContainer, {
    key: 0,
    src: _ctx.srcMain,
    alt: _ctx.altMain,
    shape: 'rounded',
    size: _ctx.size === 'large' ? _ctx.sizeLargeIcon : _ctx.sizeSmallIcon
  }, null, 8, ["src", "alt", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.secondClasses)
  }, [_ctx.combinations === 'image-and-icon' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    type: "none",
    name: _ctx.iconMinor,
    circle: true,
    color: _ctx.iconColor,
    size: _ctx.secondSizeIcon
  }, null, 8, ["name", "color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.firstClasses)
  }, [_ctx.combinations === 'icon-and-image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    type: "none",
    name: _ctx.iconMain,
    circle: true,
    color: _ctx.iconColor,
    size: _ctx.size === 'large' ? _ctx.sizeLargeIcon : _ctx.sizeSmallIcon
  }, null, 8, ["name", "color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.secondClasses)
  }, [_ctx.combinations === 'icon-and-image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqImageContainer, {
    key: 0,
    src: _ctx.srcMinor,
    alt: _ctx.altMinor,
    shape: 'rounded',
    size: _ctx.secondSizeIcon
  }, null, 8, ["src", "alt", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.firstClasses)
  }, [_ctx.combinations === 'two-image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqImageContainer, {
    key: 0,
    src: _ctx.srcMain,
    alt: _ctx.altMain,
    shape: 'rounded',
    size: _ctx.size === 'large' ? _ctx.sizeLargeIcon : _ctx.sizeSmallIcon
  }, null, 8, ["src", "alt", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.secondClasses)
  }, [_ctx.combinations === 'two-image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqImageContainer, {
    key: 0,
    src: _ctx.srcMinor,
    alt: _ctx.altMinor,
    shape: 'rounded',
    size: _ctx.secondSizeIcon
  }, null, 8, ["src", "alt", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.firstClasses)
  }, [_ctx.combinations === 'two-icon' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    type: "none",
    name: _ctx.iconMain,
    circle: true,
    color: _ctx.iconColor,
    size: _ctx.size === 'large' ? _ctx.sizeLargeIcon : _ctx.sizeSmallIcon
  }, null, 8, ["name", "color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.secondClasses)
  }, [_ctx.combinations === 'two-icon' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    type: "none",
    name: _ctx.iconMinor,
    circle: true,
    color: _ctx.iconColor,
    size: _ctx.secondSizeIcon
  }, null, 8, ["name", "color", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)], 2)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/ImageGroup/ImageGroup.vue?vue&type=template&id=59dc387c&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ImageGroup/ImageGroup.vue?vue&type=script&lang=ts





/* harmony default export */ var ImageGroupvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqImageGroup",
  components: {
    OrqImageContainer: ImageContainer,
    OrqIconContainer: IconContainer,
    OrqShimmer: Shimmer
  },
  props: {
    combinations: {
      type: String,
      default: "image-and-icon"
    },
    size: {
      type: String,
      default: "large"
    },
    srcMain: {
      type: String,
      default: "https://www.btgmais.com/wp-content/uploads/2021/07/premium-image.png"
    },
    srcMinor: {
      type: String,
      default: "https://www.btgmais.com/wp-content/uploads/2021/07/premium-image.png"
    },
    altMain: {
      type: String,
      default: "https://www.btgmais.com/wp-content/uploads/2021/07/premium-image.png"
    },
    altMinor: {
      type: String,
      default: "https://www.btgmais.com/wp-content/uploads/2021/07/premium-image.png"
    },
    iconMinor: {
      type: String,
      default: ""
    },
    iconMain: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    const sizeLargeIcon = 64;
    const sizeSmallIcon = 32;
    const secondSizeIcon = 24;
    return {
      ImageClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        "orq-image-group": true
      })),
      GeralClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        "orq-image-group__general-container": true
      })),
      firstClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        "orq-image-group__container-first": true,
        "orq-image-group--inverse": props.inverse
      })),
      secondClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        "orq-image-group__container-second": true,
        "orq-image-group--bottom--large": true,
        "orq-image-group--bottom--small": true,
        "orq-image-group--inverse": props.inverse
      })),
      iconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        if (props.inverse) {
          return props.iconMinor || props.iconMain ? iconColors.value.emphasisBaseInverseHigh : iconColors.value.emphasisBaseHigh;
        }
        return props.iconMinor || props.iconMain ? iconColors.value.emphasisBaseHigh : iconColors.value.emphasisBaseInverseHigh;
      }),
      sizeLargeIcon,
      sizeSmallIcon,
      secondSizeIcon
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/ImageGroup/ImageGroup.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ImageGroup/ImageGroup.vue?vue&type=style&index=0&id=59dc387c&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ImageGroup/ImageGroup.vue?vue&type=style&index=0&id=59dc387c&lang=scss

;// CONCATENATED MODULE: ./src/components/ImageGroup/ImageGroup.vue




;


const ImageGroup_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ImageGroupvue_type_script_lang_ts, [['render',ImageGroupvue_type_template_id_59dc387c_ts_true_render]])

/* harmony default export */ var ImageGroup = (ImageGroup_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/InputTag/InputTag.vue?vue&type=template&id=6e10143a&scoped=true&ts=true

const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_withScopeId = n => (_pushScopeId("data-v-6e10143a"), n = n(), _popScopeId(), n);
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_1 = {
  class: "orq-input-tag__container"
};
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_2 = {
  ref: "inputTagRef"
};
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_3 = {
  key: 0,
  class: "orq-input-tag__content"
};
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_4 = {
  class: "orq-input-tag__content-items"
};
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_5 = {
  class: "orq-input-tag__content-item__text"
};
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_6 = {
  class: "orq-input-tag__content"
};
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_7 = {
  key: 0,
  class: "orq-input-tag__content-items"
};
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_8 = {
  class: "orq-input-tag__content-item__text"
};
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_9 = {
  class: "orq-input-tag__selected"
};
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_10 = {
  key: 0,
  class: "orq-input-tag__label"
};
const InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_11 = {
  class: "orq-input-tag__tags"
};
function InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqInput = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqInput");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqDropdown = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqDropdown");
  const _component_OrqTag = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqTag");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    type: "input",
    inverse: _ctx.inverse
  }, null, 8, ["inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.inputTagClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqInput, {
    label: "",
    prefixSuffixOptions: "none",
    modelValue: _ctx.innerValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.innerValue = $event),
    onBlur: _cache[1] || (_cache[1] = $event => _ctx.onBlur($event)),
    onFocus: _cache[2] || (_cache[2] = $event => _ctx.onFocus($event)),
    onClear: _ctx.handleClear,
    placeholder: _ctx.placeholder,
    description: _ctx.errorField,
    size: _ctx.size,
    autofocus: false,
    ariaLabel: _ctx.ariaLabel,
    maxLength: _ctx.maxLength,
    disabled: _ctx.disabled,
    startIcon: "tools-search",
    inverse: _ctx.inverse,
    loading: _ctx.loading,
    error: !_ctx.disabled && _ctx.selectedTags.length < _ctx.tagMinQuantityRef,
    endIcon: _ctx.innerValue.length > 0 ? 'close' : ''
  }, null, 8, ["modelValue", "onClear", "placeholder", "description", "size", "ariaLabel", "maxLength", "disabled", "inverse", "loading", "error", "endIcon"]), _ctx.innerValue.length > 0 && _ctx.canCreateRef && _ctx.dataItems.length === 0 && _ctx.isOpened ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    onClick: _cache[3] || (_cache[3] =
    //@ts-ignore
    (...args) => _ctx.createTag && _ctx.createTag(...args)),
    class: "orq-input-tag__content-item",
    "tab-index": 0
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    name: "add-plus",
    type: "none",
    color: _ctx.iconColor
  }, null, 8, ["color"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_5, "Criar sua Tag " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.innerValue), 1)])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_6, [_ctx.innerValue.length > 0 && _ctx.canCreateRef && _ctx.isOpened ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_7, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.renderItems.slice(0, 1), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      class: "orq-input-tag__content-item",
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_8, " A tag \"" + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.title) + "\" já está selecionada ", 1)]);
  }), 128))])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type !== 'default' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqDropdown, {
    key: 1,
    onClean: _ctx.handleClear,
    onOnSelect: _cache[4] || (_cache[4] = $event => _ctx.clickHandler($event)),
    isOpen: _ctx.isOpened,
    type: "default",
    multiple: false,
    selected: false,
    inverse: _ctx.inverse,
    options: _ctx.dataItems,
    searchEmpty: _ctx.searchEmpty,
    showEmptySearch: !_ctx.canCreate && _ctx.innerValue.length > 0 && _ctx.dataItems.length === 0
  }, null, 8, ["onClean", "isOpen", "inverse", "options", "searchEmpty", "showEmptySearch"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])], 512), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_9, [_ctx.label && _ctx.selectedTags.length > 0 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_10, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_hoisted_11, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.selectedTags, (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqTag, {
      key: index,
      onRemove: $event => _ctx.onClear(item),
      type: "search",
      loading: _ctx.loading,
      disabled: _ctx.disabled,
      inverse: _ctx.inverse
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.title), 1)]),
      _: 2
    }, 1032, ["onRemove", "loading", "disabled", "inverse"]);
  }), 128))])])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/InputTag/InputTag.vue?vue&type=template&id=6e10143a&scoped=true&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tag/Tag.vue?vue&type=template&id=585cae38&ts=true

function Tagvue_type_template_id_585cae38_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.tagClasses),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      backgroundColor: _ctx.ownColor
    }),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.onSelectedChange($event))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default"), _ctx.type === 'search' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    name: "close",
    type: "none",
    color: _ctx.disabled && !_ctx.inverse ? 'emphasis-base-disabled' : _ctx.disabled && _ctx.inverse ? 'emphasis-base-disabled-inverse' : '',
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onRemove($event))
  }, null, 8, ["color"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 6)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 1,
    type: "tag",
    inverse: _ctx.inverse,
    typeTag: _ctx.type
  }, null, 8, ["inverse", "typeTag"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Tag/Tag.vue?vue&type=template&id=585cae38&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tag/Tag.vue?vue&type=script&lang=ts



/* harmony default export */ var Tagvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqTag",
  props: {
    type: {
      type: String,
      default: "filter"
    },
    inverse: {
      type: Boolean,
      defaul: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    ownColor: {
      type: String
    }
  },
  components: {
    OrqShimmer: Shimmer,
    OrqIconContainer: IconContainer
  },
  setup(props, {
    emit
  }) {
    const selected = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const onSelectedChange = event => {
      if (props.disabled && props.inverse) return;
      if (props.type === "filter") {
        emit("selected", event);
        selected.value = !selected.value;
      }
    };
    const onRemove = event => {
      emit("remove", event);
    };
    return {
      onSelectedChange,
      onRemove,
      tagClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        "orq-tag": true,
        [`orq-tag__${props.type}`]: props.type,
        "orq-tag--inverse": props.inverse || props.ownColor,
        "orq-tag--inverse__filter": props.inverse && props.type === "filter" || props.ownColor,
        "orq-tag--light": !props.inverse || !props.ownColor,
        "orq-tag--disabled": props.disabled,
        "orq-tag--selected": selected.value
      }))
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Tag/Tag.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tag/Tag.vue?vue&type=style&index=0&id=585cae38&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Tag/Tag.vue?vue&type=style&index=0&id=585cae38&lang=scss

;// CONCATENATED MODULE: ./src/components/Tag/Tag.vue




;


const Tag_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Tagvue_type_script_lang_ts, [['render',Tagvue_type_template_id_585cae38_ts_true_render]])

/* harmony default export */ var Tag = (Tag_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/InputTag/InputTag.vue?vue&type=script&lang=ts








/* harmony default export */ var InputTagvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqInputTag",
  components: {
    OrqShimmer: Shimmer,
    OrqTag: Tag,
    OrqInput: Input,
    OrqIconContainer: IconContainer,
    OrqDropdown: Dropdown
  },
  props: {
    label: {
      type: String,
      default: "Label"
    },
    placeholder: {
      type: String,
      default: "Placeholder"
    },
    ariaLabel: {
      type: String,
      default: "Aria label"
    },
    size: {
      type: String,
      default: "small"
    },
    description: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    recentTags: {
      type: Array,
      default: () => []
    },
    maxLength: {
      type: Number,
      default: 100
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    canCreate: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "default"
    },
    searchEmpty: {
      type: String,
      default: ""
    },
    tagMinQuantity: {
      type: Number,
      default: 2
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue", "remove", "focus", "blur"],
  setup(props, {
    emit
  }) {
    const inputTagRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const optionItems = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.options);
    const dataItems = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.recentTags);
    const renderItems = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    const tagRecent = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.recentTags.map(opt => ({
      ...opt
    })));
    const selectedTags = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.modelValue);
    const canCreateRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.canCreate);
    const tagMinQuantityRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.tagMinQuantity);
    let errorField = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("");
    let isOpened = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    let innerValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("");
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      errorMessages();
    });
    useOnClickOutside(inputTagRef, () => {
      isOpened.value = false;
    });
    const errorMessages = () => {
      let message = props.description || "";
      if (selectedTags.value.length < tagMinQuantityRef.value && selectedTags.value.length !== 0) {
        message = `Adicione ao menos ${tagMinQuantityRef.value} ${tagMinQuantityRef.value <= 1 ? "tag" : "tags"}`;
      } else if (selectedTags.value.length === 0) {
        message = "O campo é obrigatório";
      }
      message;
      errorField.value = message;
    };
    const onClear = item => {
      const indexOption = selectedTags.value.findIndex(i => i.title === item.title);
      selectedTags.value.splice(indexOption, 1);
      errorMessages();
      emit("remove", item);
      emit("update:modelValue", selectedTags.value);
    };
    const createTag = () => {
      const item = {
        id: optionItems.value.length,
        title: innerValue.value,
        selected: true
      };
      clickHandler(item);
      canCreateRef.value = false;
      if (tagRecent.value) {
        canCreateRef.value = true;
      }
      isOpened.value = false;
      handleClear();
    };
    const onChangeOptionItems = () => {
      if (innerValue.value.length > 0) {
        const filterOptionValue = optionItems.value.filter(item => {
          if (item.title) {
            return item.title.toLocaleLowerCase().includes(innerValue.value.toLocaleLowerCase()) && !selectedTags.value.find(tagOption => tagOption.title === item.title);
          }
        });
        dataItems.value = filterOptionValue;
      } else {
        const optionFilter = tagRecent.value.filter(opt => {
          return !selectedTags.value.find(tagOption => tagOption.id === opt.id);
        });
        dataItems.value = optionFilter;
      }
      const tagFilter = tagRecent.value.filter(item => {
        if (tagRecent.value) {
          return item.title.toLocaleLowerCase() === innerValue.value.toLocaleLowerCase();
        }
      });
      renderItems.value = tagFilter;
    };
    const clickHandler = item => {
      const index = tagRecent.value.findIndex(opt => opt.title === item.title);
      if (index >= 0) {
        tagRecent.value.splice(index, 1);
      }
      tagRecent.value.unshift(item);
      selectedTags.value = [...selectedTags.value, item];
      emit("update:modelValue", selectedTags.value);
      isOpened.value = false;
      handleClear();
      onChangeOptionItems();
      errorMessages();
    };
    const handleClear = () => {
      innerValue.value = "";
      onChangeOptionItems();
    };
    const onFocus = event => {
      isOpened.value = true;
      onChangeOptionItems();
      emit("focus", event);
    };
    const onBlur = event => {
      onChangeOptionItems();
      emit("blur", event);
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(innerValue, () => {
      onChangeOptionItems();
    });
    return {
      createTag,
      selectedTags,
      clickHandler,
      handleClear,
      errorField,
      onClear,
      onFocus,
      canCreateRef,
      dataItems,
      innerValue,
      renderItems,
      tagMinQuantityRef,
      onBlur,
      inputTagRef,
      isOpened,
      tagRecent,
      optionItems,
      inputTagClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input-tag": true,
          "orq-input-tag--inverse": props.inverse,
          "orq-input-tag--disabled": props.disabled
        };
      }),
      iconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return props.inverse ? "emphasis-base-high-inverse" : "emphasis-base-high";
      })
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/InputTag/InputTag.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/InputTag/InputTag.vue?vue&type=style&index=0&id=6e10143a&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/InputTag/InputTag.vue?vue&type=style&index=0&id=6e10143a&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/InputTag/InputTag.vue




;


const InputTag_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(InputTagvue_type_script_lang_ts, [['render',InputTagvue_type_template_id_6e10143a_scoped_true_ts_true_render],['__scopeId',"data-v-6e10143a"]])

/* harmony default export */ var InputTag = (InputTag_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/InputTextArea/InputTextArea.vue?vue&type=template&id=45736e2e&ts=true

const InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_1 = ["htmlFor"];
const InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_2 = {
  class: "orq-input-text-area__container"
};
const InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_3 = ["id", "name", "placeholder", "maxLength", "disabled"];
const InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
  class: "orq-input-text-area__line"
}, null, -1);
const InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_5 = {
  key: 1,
  class: "orq-input-text-area__description-wrapper"
};
const InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_6 = {
  class: "orq-input-text-area__description-wrapper--description"
};
function InputTextAreavue_type_template_id_45736e2e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqProgressRing = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqProgressRing");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("fieldset", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-input-text-area ${_ctx.inverseClass} ${_ctx.disabledClass} ${_ctx.sizeClass} ${_ctx.focusClass} ${_ctx.errorClass}`)
  }, [!_ctx.animation ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("label", {
    key: 0,
    htmlFor: _ctx.id,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-input-text-area__label ${_ctx.animationClass}`),
    "aria-label": "Label"
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 11, InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.textAreaWrapperClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("textarea", {
    ref: "textAreaRef",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.valueState = $event),
    autoComplete: "off",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.textAreaClasses),
    id: _ctx.id,
    name: _ctx.name,
    placeholder: _ctx.animation ? '' : _ctx.placeholder,
    maxLength: _ctx.maxCharacters,
    disabled: _ctx.disabled,
    onInput: _cache[1] || (_cache[1] = $event => _ctx.onChangeValue($event)),
    onFocus: _cache[2] || (_cache[2] = $event => _ctx.setIsFocus($event, true)),
    onBlur: _cache[3] || (_cache[3] = $event => _ctx.setIsFocus($event, false))
  }, null, 42, InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_3), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vModelText, _ctx.valueState]]), _ctx.animation ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.animationClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.placeholder), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqProgressRing, {
    type: "step",
    size: "small",
    currentValueStep: _ctx.valueState?.length,
    totalValueStep: _ctx.maxCharacters,
    inverse: _ctx.inverse,
    loading: _ctx.loading
  }, null, 8, ["currentValueStep", "totalValueStep", "inverse", "loading"])], 2)]), InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_4, _ctx.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_5, [_ctx.error && _ctx.size === 'large' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "status-error",
    size: 16,
    color: _ctx.iconColor()
  }, null, 8, ["color"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", InputTextAreavue_type_template_id_45736e2e_ts_true_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.valueState?.length) + " / " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.maxCharacters), 1)])], 64)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.descriptionSmall)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.valueState?.length) + " / " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.maxCharacters), 1)], 2))])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 1,
    type: "input",
    inverse: _ctx.inverse
  }, null, 8, ["inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/InputTextArea/InputTextArea.vue?vue&type=template&id=45736e2e&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressRing/ProgressRing.vue?vue&type=template&id=96d0b124&ts=true

const ProgressRingvue_type_template_id_96d0b124_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-progress-ring"
};
const ProgressRingvue_type_template_id_96d0b124_ts_true_hoisted_2 = {
  class: "orq-progress-ring__track__image-container"
};
function ProgressRingvue_type_template_id_96d0b124_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqImageContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqImageContainer");
  const _component_OrqAvatar = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqAvatar");
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ProgressRingvue_type_template_id_96d0b124_ts_true_hoisted_1, [_ctx.type === 'percentage' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    id: "progress",
    role: "button",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.typePercentageAndStepClasses),
    ref: "progressRing",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.handleReloadProgress && _ctx.handleReloadProgress(...args))
  }, null, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'step' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    id: "progress",
    role: "button",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.typePercentageAndStepClasses),
    ref: "progressRing",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.handleReloadProgress && _ctx.handleReloadProgress(...args))
  }, null, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.size === 'small' && _ctx.type === 'step' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 2,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.typeStepSmall)
  }, null, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 3,
    id: "progress",
    role: "button",
    ref: "progressRing",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.typeImageOrAvatarClasses),
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.handleReloadProgress && _ctx.handleReloadProgress(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.imageContainerClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqImageContainer, {
    class: "orq-progress-ring__track__image-container",
    src: _ctx.src,
    shape: "rounded",
    alt: _ctx.alt,
    size: _ctx.imageAndAvatarSize,
    inverse: _ctx.inverse
  }, null, 8, ["src", "alt", "size", "inverse"])], 2)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'avatar' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 4,
    id: "progress",
    role: "button",
    ref: "progressRing",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.typeImageOrAvatarClasses),
    onClick: _cache[3] || (_cache[3] =
    //@ts-ignore
    (...args) => _ctx.handleReloadProgress && _ctx.handleReloadProgress(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.typeAvatarClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ProgressRingvue_type_template_id_96d0b124_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqAvatar, {
    type: _ctx.typeAvatar,
    inverse: _ctx.inverse,
    src: _ctx.src,
    alt: _ctx.alt,
    size: _ctx.imageAndAvatarSize
  }, null, 8, ["type", "inverse", "src", "alt", "size"])])], 2)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type !== 'avatar' && _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 1,
    type: "progress-ring",
    typeRing: _ctx.stepTypeRing,
    loading: _ctx.loading,
    inverse: _ctx.inverse,
    size: _ctx.size
  }, null, 8, ["typeRing", "loading", "inverse", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'avatar' && _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 2,
    type: "progress-ring",
    typeRing: _ctx.type === 'avatar' ? 'image' : _ctx.type,
    loading: _ctx.loading,
    inverse: _ctx.inverse,
    size: _ctx.size
  }, null, 8, ["typeRing", "loading", "inverse", "size"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/ProgressRing/ProgressRing.vue?vue&type=template&id=96d0b124&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressRing/ProgressRing.vue?vue&type=script&lang=ts




/* harmony default export */ var ProgressRingvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqProgressRing",
  props: {
    type: {
      type: String,
      default: "percentage"
    },
    size: {
      type: String,
      default: "medium"
    },
    value: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      default: "image.png"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    currentValueStep: {
      type: Number,
      default: 0
    },
    totalValueStep: {
      type: Number,
      default: 0
    },
    typeAvatar: {
      type: String,
      default: "image"
    },
    alt: {
      type: String,
      default: ""
    }
  },
  components: {
    OrqImageContainer: ImageContainer,
    OrqAvatar: Avatar,
    OrqShimmer: Shimmer
  },
  setup(props) {
    const inverseClass = props.inverse ? "orq-progress-ring__track--inverse" : "orq-progress-ring__track--default";
    const inverseStepSmallClass = props.inverse ? "orq-progress-ring__track__value-step-small--inverse" : "";
    const defaultSize = 48;
    const largeSize = 64;
    const imageAndAvatarSize = props.size === "large" ? largeSize : defaultSize;
    const stepTypeRing = props.type === "step" ? "percentage" : props.type;
    const progressRing = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const progressValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.value);
    const progressStep = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.currentValueStep);
    const updateProgress = () => {
      if (props.type === "step") {
        if (props.currentValueStep > progressStep.value) {
          progressStep.value = progressStep.value + 1;
        } else {
          progressStep.value = props.currentValueStep;
        }
      } else {
        if (props.value > progressValue.value) {
          progressValue.value = progressValue.value + 1;
        } else {
          progressValue.value = props.value;
        }
      }
    };
    const updateStepProgress = () => {
      if (props.type === "step") {
        setProgressStep();
        const progressPercentage = () => {
          setTimeout(() => {
            if (progressStep.value < props.currentValueStep && progressStep.value <= 100) {
              progressStep.value = progressStep.value + 1;
            } else if (progressStep.value > props.currentValueStep) {
              progressStep.value = props.currentValueStep;
            }
          }, 10);
        };
        progressPercentage();
      }
    };
    const updatePercentageProgress = () => {
      if (props.type !== "step") {
        const progressPercentage = () => {
          setTimeout(() => {
            if (progressValue.value < props.value && progressValue.value <= 100) {
              progressValue.value = props.value + 1;
            } else if (progressValue.value > props.value) {
              progressValue.value = props.value;
            }
          }, 10);
        };
        progressPercentage();
        setProgress();
      }
    };
    const updateProgressElement = (property, attribute) => {
      if (progressRing.value) {
        progressRing.value.style.setProperty("--progress", `${property}%`);
        progressRing.value.setAttribute("progress", attribute);
      }
    };
    const setProgress = () => {
      updateProgressElement(progressValue.value, `${progressValue.value}%`);
    };
    const setProgressStep = () => {
      const parseStepValue = progressStep.value / props.totalValueStep * 100;
      const attrStepValue = `${progressStep.value}/${props.totalValueStep}`;
      updateProgressElement(parseStepValue, `${attrStepValue}`);
    };
    const handleReloadProgress = () => {
      if (props.type !== "step") {
        progressValue.value = 0;
      } else {
        progressStep.value = 0;
      }
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      updateProgress();
      props.value;
      props.currentValueStep;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      updatePercentageProgress();
      progressValue.value;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      updateStepProgress();
      progressStep.value;
      progressValue.value;
    });
    return {
      typePercentageAndStepClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-progress-ring__track": true,
          [`orq-progress-ring__track--${props.type}--${props.size}`]: props.type,
          [`${inverseClass}`]: true
        };
      }),
      typeStepSmall: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-progress-ring__track__value-step-small": true,
          [`${inverseStepSmallClass}`]: true
        };
      }),
      typeImageOrAvatarClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-progress-ring__track": true,
          [props.type === "image" || props.type === "avatar" ? "orq-progress-ring__track--image" : ""]: props.type,
          [`orq-progress-ring__track--image--${props.size}`]: props.size,
          [`${inverseClass}`]: true
        };
      }),
      typeAvatarClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-progress-ring__track--image__image-container": true,
          [`orq-progress-ring__track--image__image-container--${props.size}`]: props.size,
          [props.inverse ? `orq-progress-ring__track--image__image-container--inverse` : ""]: true
        };
      }),
      imageContainerClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-progress-ring__track--image__image-container": true,
          [`orq-progress-ring__track--image__image-container--${props.size}`]: props.size,
          [props.inverse ? "orq-progress-ring__track--image__image-container--inverse" : ""]: props.inverse
        };
      }),
      imageAndAvatarSize,
      stepTypeRing,
      progressValue,
      progressRing,
      handleReloadProgress
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/ProgressRing/ProgressRing.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressRing/ProgressRing.vue?vue&type=style&index=0&id=96d0b124&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ProgressRing/ProgressRing.vue?vue&type=style&index=0&id=96d0b124&lang=scss

;// CONCATENATED MODULE: ./src/components/ProgressRing/ProgressRing.vue




;


const ProgressRing_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ProgressRingvue_type_script_lang_ts, [['render',ProgressRingvue_type_template_id_96d0b124_ts_true_render]])

/* harmony default export */ var ProgressRing = (ProgressRing_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/InputTextArea/InputTextArea.vue?vue&type=script&lang=ts





/* harmony default export */ var InputTextAreavue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqInputTextArea",
  components: {
    OrqShimmer: Shimmer,
    OrqProgressRing: ProgressRing,
    OrqIconContainer: IconContainer
  },
  props: {
    id: {
      type: String
    },
    name: {
      type: String
    },
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String
    },
    description: {
      type: String
    },
    placeholder: {
      type: String
    },
    error: {
      type: Boolean
    },
    inverse: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    animation: {
      type: Boolean
    },
    size: {
      type: String
    },
    maxCharacters: {
      type: Number,
      default: 10
    }
  },
  setup(props, {
    emit
  }) {
    const textAreaRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    let valueState = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.value);
    let isFocus = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    let progressValueState = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0);
    const handleTextAreaHeight = () => {
      textAreaRef.value.style.height = "0px";
      const scrollHeight = textAreaRef.value.scrollHeight;
      textAreaRef.value.style.height = `${scrollHeight}px`;
    };
    const onChangeValue = event => {
      let value = event.target.value;
      valueState.value = value;
      const percent = Math.min(Math.floor(value.length / props.maxCharacters * 100), 100);
      progressValueState.value = percent;
      emit("onchange", event);
      if (textAreaRef.value) {
        handleTextAreaHeight();
      }
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      if (props.disabled) {
        valueState.value = "";
      }
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      if (textAreaRef.value) {
        handleTextAreaHeight();
      }
    });
    const iconColor = () => {
      if (props.error && props.inverse && props.disabled || props.disabled && props.inverse) {
        return EiconContainerColor.emphasisBaseInverseDisabled;
      } else if (props.error && props.inverse) {
        return EiconContainerColor.statusErrorInverse;
      } else if (props.error && props.disabled || props.disabled) {
        return EiconContainerColor.emphasisBaseDisabled;
      } else if (props.inverse) {
        return EiconContainerColor.emphasisBaseInverseHigh;
      } else if (props.error) {
        return EiconContainerColor.statusError;
      }
      return EiconContainerColor.emphasisBaseHigh;
    };
    const hasValuePlaceholder = () => {
      if (valueState.value.length > 0) {
        return props.size === "small" ? "orq-input-text-area__placeholder-has-value--small" : "orq-input-text-area__placeholder-has-value--large";
      }
      return "";
    };
    const setIsFocus = (event, value) => {
      isFocus.value = value;
      emit("focus", event);
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      valueState.value = props.value;
    });
    return {
      textAreaRef,
      valueState,
      isFocus,
      progressValueState,
      hasValuePlaceholder,
      onChangeValue,
      setIsFocus,
      iconColor,
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-input-text-area--inverse" : ""),
      disabledClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.disabled ? "orq-input-text-area--disabled" : ""),
      animationClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => valueState || !props.animation ? "populated" : ""),
      focusClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => isFocus.value ? "orq-input-text-area--focused" : ""),
      errorClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.error ? "orq-input-text-area--error" : ""),
      sizeClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === "large" ? "orq-input-text-area--large" : "orq-input-text-area--small"),
      textAreaClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input-text-area__textarea": true,
          [`orq-input-text-area__textarea${props.size === "small" ? "--small" : "--large"}`]: props.size
        };
      }),
      textAreaWrapperClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input-text-area__input-wrapper": true,
          "orq-input-text-area__input-wrapper--small": props.size === "small"
        };
      }),
      animationClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input-text-area__placeholder--animated": props.animation,
          [`${hasValuePlaceholder()}`]: true
        };
      }),
      descriptionSmall: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-input-text-area__description-wrapper--description small": true
        };
      })
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/InputTextArea/InputTextArea.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/InputTextArea/InputTextArea.vue?vue&type=style&index=0&id=45736e2e&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/InputTextArea/InputTextArea.vue?vue&type=style&index=0&id=45736e2e&lang=scss

;// CONCATENATED MODULE: ./src/components/InputTextArea/InputTextArea.vue




;


const InputTextArea_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(InputTextAreavue_type_script_lang_ts, [['render',InputTextAreavue_type_template_id_45736e2e_ts_true_render]])

/* harmony default export */ var InputTextArea = (InputTextArea_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Loader/Loader.vue?vue&type=template&id=ebbf1fe8&ts=true

function Loadervue_type_template_id_ebbf1fe8_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Lottie = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("Lottie");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.loaderClasses),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      zIndex: _ctx.zIndex
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_Lottie, {
    animationData: _ctx.loaderJson,
    autoplay: true,
    loop: true,
    ariaLabel: "loader"
  }, null, 8, ["animationData"])], 6);
}
;// CONCATENATED MODULE: ./src/components/Loader/Loader.vue?vue&type=template&id=ebbf1fe8&ts=true

// EXTERNAL MODULE: ./node_modules/vue3-lottie/dist/vue3-lottie.es.js
var vue3_lottie_es = __webpack_require__(3081);
;// CONCATENATED MODULE: ./src/components/Loader/models/loader.enum.ts
var EloaderType;
(function (EloaderType) {
  EloaderType["neutral"] = "neutral";
  EloaderType["default"] = "default";
})(EloaderType || (EloaderType = {}));
;// CONCATENATED MODULE: ./src/assets/images/loader_v1.json
var loader_v1_namespaceObject = JSON.parse('{"v":"5.7.11","fr":60,"ip":0,"op":120,"w":192,"h":192,"nm":"v1","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Loader","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":120,"s":[540]}],"ix":10},"p":{"a":0,"k":[96,96,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[180,180],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":9,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.25],"y":[1]},"o":{"x":[0.25],"y":[0]},"t":16,"s":[0]},{"t":93,"s":[95]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.25],"y":[1]},"o":{"x":[0.25],"y":[0]},"t":0,"s":[5]},{"t":77,"s":[100]}],"ix":2},"o":{"a":1,"k":[{"i":{"x":[0.25],"y":[0.731]},"o":{"x":[0.55],"y":[0.197]},"t":0,"s":[0]},{"t":120,"s":[558]}],"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":600,"st":0,"bm":0}],"markers":[]}');
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Loader/Loader.vue?vue&type=script&lang=ts




/* harmony default export */ var Loadervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqLoader",
  components: {
    Lottie: vue3_lottie_es/* Vue3Lottie */.Ed
  },
  props: {
    zIndex: {
      type: Number,
      default: 0
    },
    inverse: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    return {
      loaderClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-loader": true,
          ["neutral"]: props.type === EloaderType.neutral,
          ["inverse"]: props.inverse
        };
      }),
      loaderJson: loader_v1_namespaceObject
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Loader/Loader.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Loader/Loader.vue?vue&type=style&index=0&id=ebbf1fe8&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Loader/Loader.vue?vue&type=style&index=0&id=ebbf1fe8&lang=scss

;// CONCATENATED MODULE: ./src/components/Loader/Loader.vue




;


const Loader_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Loadervue_type_script_lang_ts, [['render',Loadervue_type_template_id_ebbf1fe8_ts_true_render]])

/* harmony default export */ var Loader = (Loader_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Lockscreen/Lockscreen.vue?vue&type=template&id=693ce33e&ts=true

function Lockscreenvue_type_template_id_693ce33e_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: "orq-lockscreen",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      zIndex: _ctx.zIndex
    })
  }, null, 4);
}
;// CONCATENATED MODULE: ./src/components/Lockscreen/Lockscreen.vue?vue&type=template&id=693ce33e&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Lockscreen/Lockscreen.vue?vue&type=script&lang=ts

/* harmony default export */ var Lockscreenvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqLockscreen",
  props: {
    zIndex: {
      type: Number
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Lockscreen/Lockscreen.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Lockscreen/Lockscreen.vue?vue&type=style&index=0&id=693ce33e&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Lockscreen/Lockscreen.vue?vue&type=style&index=0&id=693ce33e&lang=scss

;// CONCATENATED MODULE: ./src/components/Lockscreen/Lockscreen.vue




;


const Lockscreen_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Lockscreenvue_type_script_lang_ts, [['render',Lockscreenvue_type_template_id_693ce33e_ts_true_render]])

/* harmony default export */ var Lockscreen = (Lockscreen_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Modal/Modal.vue?vue&type=template&id=467ed7ce&ts=true

const Modalvue_type_template_id_467ed7ce_ts_true_hoisted_1 = {
  class: "orq-modal__container"
};
const Modalvue_type_template_id_467ed7ce_ts_true_hoisted_2 = {
  className: "orq-modal--container-dialog-variation"
};
const Modalvue_type_template_id_467ed7ce_ts_true_hoisted_3 = {
  key: 4,
  className: "container-loader"
};
const Modalvue_type_template_id_467ed7ce_ts_true_hoisted_4 = {
  className: "orq-modal__container__content"
};
const Modalvue_type_template_id_467ed7ce_ts_true_hoisted_5 = {
  class: "orq-modal__container__header"
};
const Modalvue_type_template_id_467ed7ce_ts_true_hoisted_6 = {
  class: "title--box orq-title--box__text--left"
};
const Modalvue_type_template_id_467ed7ce_ts_true_hoisted_7 = {
  className: "orq-modal__container__content"
};
const Modalvue_type_template_id_467ed7ce_ts_true_hoisted_8 = {
  class: "orq-modal__container__footer__button-div"
};
const Modalvue_type_template_id_467ed7ce_ts_true_hoisted_9 = {
  class: "orq-modal__container__footer__button-div"
};
function Modalvue_type_template_id_467ed7ce_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqLoader = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqLoader");
  const _component_OrqButton = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqButton");
  return _ctx.visible ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.modalContainerClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Modalvue_type_template_id_467ed7ce_ts_true_hoisted_1, [_ctx.type === 'dialog-variation' && !!_ctx.dialogVariation ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Modalvue_type_template_id_467ed7ce_ts_true_hoisted_2, [_ctx.type === 'dialog-variation' && _ctx.dialogVariation === 'success' && !_ctx.inverse ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 0,
    type: "none",
    name: "status-success",
    color: "status-success",
    customCircleBackgroundColor: "#DAECE5",
    circle: true,
    size: 64
  })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'dialog-variation' && _ctx.dialogVariation === 'success' && _ctx.inverse ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 1,
    type: "none",
    name: "status-success",
    color: "status-success-inverse",
    customCircleBackgroundColor: "#106A40",
    circle: true,
    size: 64
  })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'dialog-variation' && _ctx.dialogVariation === 'error' && !_ctx.inverse ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 2,
    type: "none",
    name: "status-error",
    color: "status-error",
    customCircleBackgroundColor: "#FFDBDD",
    circle: true,
    size: 64
  })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'dialog-variation' && _ctx.dialogVariation === 'error' && _ctx.inverse ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqIconContainer, {
    key: 3,
    type: "none",
    name: "status-error",
    color: "status-error-inverse",
    customCircleBackgroundColor: "#8B2328",
    circle: true,
    size: 64
  })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'dialog-variation' && _ctx.dialogVariation === 'loader' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Modalvue_type_template_id_467ed7ce_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqLoader, {
    inverse: _ctx.inverse,
    type: "neutral"
  }, null, 8, ["inverse"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.titleDialogVariationClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.titleDialogVariation), 3)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Modalvue_type_template_id_467ed7ce_ts_true_hoisted_4, [_ctx.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.contentParagraphClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.wrapper ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.contentSlotInverseAndDialogClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "wrapper")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type !== 'dialog-variation' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Modalvue_type_template_id_467ed7ce_ts_true_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Modalvue_type_template_id_467ed7ce_ts_true_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.titleClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title), 3)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "close",
    role: "button",
    size: 24,
    color: _ctx.setIconColor,
    inverse: _ctx.inverse,
    onClick: _ctx.onClose
  }, null, 8, ["color", "inverse", "onClick"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Modalvue_type_template_id_467ed7ce_ts_true_hoisted_7, [_ctx.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.contentParagraphClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.wrapper ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([_ctx.contentSlotInverseAndDialogClasses, _ctx.contentSlotSizeClasses])
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "wrapper")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.$slots.wrapperXlarge && _ctx.type === 'modal' && _ctx.size === 'extended' || _ctx.$slots.wrapperXlarge && _ctx.type === 'modal' && _ctx.size === 'large' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 2,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.contentSlotInverseAndDialogClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "wrapperXlarge")], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.showActions && _ctx.type !== 'dialog-variation' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 2,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.footerClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Modalvue_type_template_id_467ed7ce_ts_true_hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqButton, {
    appearance: "line",
    size: "compact",
    label: _ctx.secondaryButtonText,
    inverse: _ctx.inverse,
    onClick: _ctx.onSecondaryClick
  }, null, 8, ["label", "inverse", "onClick"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqButton, {
    appearance: "primary",
    size: "compact",
    label: _ctx.primaryButtonText,
    inverse: _ctx.inverse,
    onClick: _ctx.onPrimaryClick
  }, null, 8, ["label", "inverse", "onClick"])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.showActions && _ctx.showOneAction && _ctx.type !== 'dialog-variation' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 3,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.footerClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Modalvue_type_template_id_467ed7ce_ts_true_hoisted_9, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqButton, {
    appearance: "primary",
    size: "compact",
    label: _ctx.primaryButtonText,
    inverse: _ctx.inverse,
    onClick: _ctx.onPrimaryClick
  }, null, 8, ["label", "inverse", "onClick"])])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/Modal/Modal.vue?vue&type=template&id=467ed7ce&ts=true

;// CONCATENATED MODULE: ./src/components/Modal/models/modal.enum.ts
var EmodalSize;
(function (EmodalSize) {
  EmodalSize["small"] = "small";
  EmodalSize["medium"] = "medium";
  EmodalSize["large"] = "large";
  EmodalSize["extended"] = "extended";
})(EmodalSize || (EmodalSize = {}));
var EmodalType;
(function (EmodalType) {
  EmodalType["dialog"] = "dialog";
  EmodalType["modal"] = "modal";
  EmodalType["dialogVariation"] = "dialog-variation";
})(EmodalType || (EmodalType = {}));
var EmodalDialogVariation;
(function (EmodalDialogVariation) {
  EmodalDialogVariation["loader"] = "loader";
  EmodalDialogVariation["success"] = "success";
  EmodalDialogVariation["error"] = "error";
})(EmodalDialogVariation || (EmodalDialogVariation = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Modal/Modal.vue?vue&type=script&lang=ts






/* harmony default export */ var Modalvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqModal",
  props: {
    type: {
      type: String,
      default: ""
    },
    titleDialogVariation: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    },
    dialogVariation: {
      type: String,
      default: ""
    },
    showActions: {
      type: Boolean,
      default: true
    },
    showOneAction: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    },
    primaryButtonText: {
      type: String,
      default: ""
    },
    secondaryButtonText: {
      type: String,
      default: ""
    }
  },
  components: {
    OrqButton: Button,
    OrqIconContainer: IconContainer,
    OrqLoader: Loader
  },
  emits: ["onClose", "onPrimaryClick", "onSecondaryClick"],
  setup(props, {
    emit
  }) {
    const onPrimaryClick = event => {
      emit("onPrimaryClick", event);
    };
    const onSecondaryClick = event => {
      emit("onSecondaryClick", event);
    };
    const onClose = event => {
      emit("onClose", event);
    };
    return {
      modalContainerClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-modal": true,
          [`orq-modal--${props.type === "dialog" || props.type === "dialog-variation" ? "dialog" : props.size}`]: true,
          "orq-modal--inverse": props.inverse
        };
      }),
      titleClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "title--title-md": true,
          "title--box--inverse": props.inverse
        };
      }),
      titleDialogVariationClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-modal--title-dialog-variation": true,
          "orq-modal--title-dialog-variation--inverse": props.inverse
        };
      }),
      contentParagraphClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-modal__container__content__paragraph": true,
          "orq-modal__container__content__paragraph--inverse": props.inverse
        };
      }),
      contentSlotInverseAndDialogClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-modal__container__content__slot": true,
          "orq-modal__container__content__slot--inverse": props.inverse,
          "orq-modal__container__content__slot--dialog": props.type === EmodalType.dialog
        };
      }),
      contentSlotSizeClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          [`orq-modal__container__content__slot--${props.size}`]: props.size
        };
      }),
      footerClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-modal__container__footer": true,
          "orq-modal__container__footer--inverse": props.inverse
        };
      }),
      setIconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? EiconContainerColor.emphasisBaseInverseHigh : EiconContainerColor.emphasisBaseHigh),
      onClose,
      onPrimaryClick,
      onSecondaryClick
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Modal/Modal.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Modal/Modal.vue?vue&type=style&index=0&id=467ed7ce&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Modal/Modal.vue?vue&type=style&index=0&id=467ed7ce&lang=scss

;// CONCATENATED MODULE: ./src/components/Modal/Modal.vue




;


const Modal_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Modalvue_type_script_lang_ts, [['render',Modalvue_type_template_id_467ed7ce_ts_true_render]])

/* harmony default export */ var Modal = (Modal_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Notification/Notification.vue?vue&type=template&id=5a60a808&ts=true

const Notificationvue_type_template_id_5a60a808_ts_true_hoisted_1 = {
  class: "orq-notification__wrapper"
};
const Notificationvue_type_template_id_5a60a808_ts_true_hoisted_2 = {
  key: 0,
  class: "orq-notification__link"
};
function Notificationvue_type_template_id_5a60a808_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqLink = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqLink");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    type: "notification",
    loading: _ctx.loading,
    inverse: _ctx.inverse,
    rows: 1,
    cols: 1
  }, null, 8, ["loading", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`
      orq-notification
      ${_ctx.typeClass}
      ${_ctx.inverseClass}
      ${_ctx.sizeClasses}
      `),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      backgroundColor: _ctx.statusBackgroundColor
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Notificationvue_type_template_id_5a60a808_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification__icon ${_ctx.iconName} ${_ctx.statusIconColor} ${_ctx.iconSizeClasses}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: _ctx.EiconContainerType.none,
    style: {
      marginRight: '1rem'
    },
    name: _ctx.iconNameClass || '',
    size: _ctx.handleIconContainerSize(),
    color: _ctx.statusIconColor
  }, null, 8, ["type", "name", "size", "color"])], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification__content ${_ctx.contentTypeClass}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`
          orq-notification__label
          ${_ctx.labelTypeClass}
          ${_ctx.labelSizeClass}
          ${_ctx.inverseLabelClass}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default", {}, () => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 1)])], 2), _ctx.link && _ctx.notificationType === 'fixed' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Notificationvue_type_template_id_5a60a808_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqLink, {
    icon: "default",
    label: _ctx.linkOptions?.linkLabel || '',
    href: _ctx.linkOptions?.href,
    underline: !_ctx.linkOptions?.hasIcon,
    target: _ctx.linkOptions?.target,
    inverse: _ctx.inverse,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onClick($event))
  }, null, 8, ["label", "href", "underline", "target", "inverse"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)])], 6)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Notification/Notification.vue?vue&type=template&id=5a60a808&ts=true

;// CONCATENATED MODULE: ./src/components/Notification/models/notification.enum.ts
var ENotificationLabelSize;
(function (ENotificationLabelSize) {
  ENotificationLabelSize[ENotificationLabelSize["dp12"] = 12] = "dp12";
  ENotificationLabelSize[ENotificationLabelSize["dp14"] = 14] = "dp14";
})(ENotificationLabelSize || (ENotificationLabelSize = {}));
var ENotificationSize;
(function (ENotificationSize) {
  ENotificationSize["small"] = "small";
  ENotificationSize["large"] = "large";
})(ENotificationSize || (ENotificationSize = {}));
var ENotificationType;
(function (ENotificationType) {
  ENotificationType["default"] = "default";
  ENotificationType["fixed"] = "fixed";
})(ENotificationType || (ENotificationType = {}));
var ENotificationKind;
(function (ENotificationKind) {
  ENotificationKind["default"] = "placeholder";
  ENotificationKind["warning"] = "warning";
  ENotificationKind["error"] = "error";
  ENotificationKind["success"] = "success";
  ENotificationKind["info"] = "info";
})(ENotificationKind || (ENotificationKind = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Notification/Notification.vue?vue&type=script&lang=ts






/* harmony default export */ var Notificationvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqNotification",
  props: {
    label: {
      type: String,
      default: ""
    },
    iconName: {
      type: String,
      default: ""
    },
    iconSize: {
      type: Number,
      default: EiconContainerSize.dp24
    },
    inverse: {
      type: Boolean,
      default: false
    },
    notificationType: {
      type: String,
      default: ENotificationType.default
    },
    loading: {
      type: Boolean,
      default: false
    },
    link: {
      type: Boolean,
      default: false
    },
    linkOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    kind: {
      type: String,
      default: ENotificationKind.default
    },
    size: {
      type: String,
      default: ENotificationSize.large
    }
  },
  components: {
    OrqIconContainer: IconContainer,
    OrqLink: Link,
    OrqShimmer: Shimmer
  },
  emits: ["click"],
  setup(props, {
    emit
  }) {
    const handleIconContainerSize = () => {
      return props.kind === ENotificationKind.default ? props.iconSize === EiconContainerSize.dp16 || EiconContainerSize.dp24 : EiconContainerSize.dp16;
    };
    const onClick = event => {
      emit("click", event);
    };
    return {
      EiconContainerType: EiconContainerType,
      handleIconContainerSize,
      onClick,
      typeClass: `orq-notification--${props.notificationType}`,
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? `orq-notification--${props.notificationType}--inverse` : ""),
      sizeClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === "small" ? "orq-notification--fixed--small" : "orq-notification--fixed--large"),
      iconNameClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        const iconsMap = {
          [ENotificationKind.warning]: "status-warning",
          [ENotificationKind.error]: "status-error",
          [ENotificationKind.success]: "status-success",
          [ENotificationKind.info]: "info-on"
        };
        return props.kind === ENotificationKind.default ? props.iconName : iconsMap[props.kind];
      }),
      statusIconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        props.inverse ? EiconContainerColor.emphasisBaseInverseHigh : EiconContainerColor.emphasisBaseHigh;
        const colorsMap = {
          [ENotificationKind.default]: EiconContainerColor.emphasisBaseHigh,
          [ENotificationKind.warning]: EiconContainerColor.statusWarning,
          [ENotificationKind.error]: EiconContainerColor.statusError,
          [ENotificationKind.success]: EiconContainerColor.statusSuccess,
          [ENotificationKind.info]: EiconContainerColor.statusInformative
        };
        const colorsMapInverse = {
          [ENotificationKind.default]: EiconContainerColor.emphasisBaseInverseHigh,
          [ENotificationKind.warning]: EiconContainerColor.statusWarningInverse,
          [ENotificationKind.error]: EiconContainerColor.statusErrorInverse,
          [ENotificationKind.success]: EiconContainerColor.statusSuccessInverse,
          [ENotificationKind.info]: EiconContainerColor.statusInformativeInverse
        };
        const map = !props.inverse ? colorsMap : colorsMapInverse;
        return map[props.kind];
      }),
      iconSizeClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.size === "small" ? "orq-notification__icon--small" : "orq-notification__icon--large"),
      statusBackgroundColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        if (props.notificationType !== ENotificationType.fixed) {
          return;
        }
        if (props.kind === ENotificationKind.default) {
          return;
        }
        const colorsMap = {
          [ENotificationKind.warning]: "warning",
          [ENotificationKind.error]: "error",
          [ENotificationKind.success]: "success",
          [ENotificationKind.info]: "informative"
        };
        return `var(--${colorsMap[props.kind]}-surface${props.inverse ? "-inverse" : ""})`;
      }),
      labelTypeClass: `orq-notification__label--${props.notificationType}`,
      inverseLabelClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-notification__label--inverse" : ""),
      labelSizeClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        const labelSize = props.size === ENotificationSize.large ? ENotificationLabelSize.dp14 : ENotificationLabelSize.dp12;
        return `orq-notification__label--default--size-${labelSize}`;
      }),
      contentTypeClass: `orq-notification__content--${props.notificationType}`
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Notification/Notification.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Notification/Notification.vue?vue&type=style&index=0&id=5a60a808&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Notification/Notification.vue?vue&type=style&index=0&id=5a60a808&lang=scss

;// CONCATENATED MODULE: ./src/components/Notification/Notification.vue




;


const Notification_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Notificationvue_type_script_lang_ts, [['render',Notificationvue_type_template_id_5a60a808_ts_true_render]])

/* harmony default export */ var Notification = (Notification_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/NotificationFloater/NotificationFloater.vue?vue&type=template&id=245b2ae4&ts=true

const NotificationFloatervue_type_template_id_245b2ae4_ts_true_hoisted_1 = ["inverse"];
const NotificationFloatervue_type_template_id_245b2ae4_ts_true_hoisted_2 = {
  key: 0
};
function NotificationFloatervue_type_template_id_245b2ae4_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqLink = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqLink");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: "orq-notification-floater",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      zIndex: _ctx.zindex
    })
  }, [_ctx.showNotificationRef ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.notificationfloaterAbsoluteClass),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      margin: 'inherit',
      marginLeft: _ctx.xPosition || 0
    }),
    inverse: _ctx.inverse
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.notificationfloaterwrapperClass)
  }, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    inverse: _ctx.inverse,
    type: "notification",
    rows: 1,
    size: "small"
  }, null, 8, ["inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.notificationfloaterIconClass),
    style: {
      "width": "13%"
    }
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: _ctx.status,
    size: 24,
    inverse: _ctx.inverse,
    color: _ctx.iconInverse ?? _ctx.status
  }, null, 8, ["name", "inverse", "color"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 2,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.notificationfloaterContentClass)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.notificationfloaterLabelClass)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.title) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    role: "button",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onRemove($event))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "close",
    size: 24,
    inverse: _ctx.inverse,
    color: _ctx.iconColor
  }, null, 8, ["inverse", "color"])])], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.notificationfloaterDescriptionClass)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 3), _ctx.hasLink ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationFloatervue_type_template_id_245b2ae4_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqLink, {
    orientation: "right",
    icon: _ctx.linkOptions?.hasIcon ? 'default' : 'none',
    label: _ctx.linkOptions?.linkLabel,
    href: _ctx.linkOptions?.href,
    underline: false,
    inverse: _ctx.inverse,
    loading: false
  }, null, 8, ["icon", "label", "href", "inverse"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)], 14, NotificationFloatervue_type_template_id_245b2ae4_ts_true_hoisted_1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 4);
}
;// CONCATENATED MODULE: ./src/components/NotificationFloater/NotificationFloater.vue?vue&type=template&id=245b2ae4&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/NotificationFloater/NotificationFloater.vue?vue&type=script&lang=ts





/* harmony default export */ var NotificationFloatervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqNotificationFloater",
  props: {
    showNotification: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    inverse: {
      type: Boolean,
      default: false
    },
    hasClosingTime: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number
    },
    status: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    xPosition: {
      type: String
    },
    zindex: {
      type: Number
    },
    hasLink: {
      type: Boolean,
      default: true
    },
    linkOptions: {
      type: Object
    }
  },
  components: {
    OrqIconContainer: IconContainer,
    OrqShimmer: Shimmer,
    OrqLink: Link
  },
  setup(props, {
    emit
  }) {
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    const showNotificationRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.showNotification);
    const onRemove = event => {
      showNotificationRef.value = false;
      emit("remove", event);
    };
    setTimeout(() => {
      if (props.hasClosingTime) {
        showNotificationRef.value = false;
      }
    }, props.timeout);
    return {
      onRemove,
      showNotificationRef,
      notificationfloaterClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-notification-floater": true,
          "orq-notification-floater--inverse": props.inverse
        };
      }),
      notificationfloaterAbsoluteClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-notification-floater": true,
          "orq-notification-floater--absolute": true,
          "orq-notification-floater--absolute--inverse": props.inverse
        };
      }),
      notificationfloaterwrapperClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          " orq-notification-floater__wrapper": true,
          "orq-notification-floater__wrapper--without-link": true,
          "orq-notification-floater--inverse": props.inverse
        };
      }),
      notificationfloaterIconClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-notification-floater__icon": true,
          "orq-notification-floater__icon--warning": props.status === "status-warning" ?? true,
          "orq-notification-floater__icon--error": props.status === "status-error" ?? true,
          "orq-notification-floater__icon--success": props.status === "status-success" ?? false,
          "orq-notification-floater__icon--inverse--warning": (props.inverse === true && props.status === "status-warning") ?? true,
          "orq-notification-floater__icon--inverse--error": (props.inverse === true && props.status === "status-error") ?? true,
          "orq-notification-floater__icon--inverse--success": (props.inverse === true && props.status === "status-success") ?? true
        };
      }),
      notificationfloaterContentClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-notification-floater__content": true,
          "orq-notification-floater__content--absolute": true,
          "orq-notification-floater--inverse": props.inverse
        };
      }),
      notificationfloaterLabelClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-notification-floater__label": true,
          "orq-notification-floater__label--absolute": true,
          "orq-notification-floater__label--inverse": props.inverse
        };
      }),
      notificationfloaterDescriptionClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-notification-floater__description": true,
          "orq-notification-floater__description--absolute": true,
          "orq-notification-floater--inverse": props.inverse,
          "orq-notification-floater__description--inverse": props.inverse
        };
      }),
      iconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        if (props.inverse) {
          return props.inverse ? iconColors.value.emphasisBaseInverseHigh : iconColors.value.emphasisBaseHigh;
        } else return "";
      }),
      iconInverse: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        if (props.status === "info") {
          return props.status && props.inverse ? iconColors.value.emphasisBaseInverseHigh : iconColors.value.emphasisBaseHigh;
        } else return "";
      })
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/NotificationFloater/NotificationFloater.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/NotificationFloater/NotificationFloater.vue?vue&type=style&index=0&id=245b2ae4&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/NotificationFloater/NotificationFloater.vue?vue&type=style&index=0&id=245b2ae4&lang=scss

;// CONCATENATED MODULE: ./src/components/NotificationFloater/NotificationFloater.vue




;


const NotificationFloater_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(NotificationFloatervue_type_script_lang_ts, [['render',NotificationFloatervue_type_template_id_245b2ae4_ts_true_render]])

/* harmony default export */ var NotificationFloater = (NotificationFloater_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/NotificationHub/NotificationHub.vue?vue&type=template&id=20a50b26&scoped=true&ts=true

const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_withScopeId = n => (_pushScopeId("data-v-20a50b26"), n = n(), _popScopeId(), n);
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_1 = {
  key: 0
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_2 = {
  key: 0
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_3 = {
  class: "orq-notification-hub__notifications"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_4 = {
  class: "orq-notification-hub__date--parg"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_5 = ["tabIndex", "onClick"];
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_6 = {
  key: 0,
  class: "orq-notification-hub__wrapper--profile"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_7 = {
  key: 1,
  class: "orq-notification-hub__wrapper--profile"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_8 = {
  key: 2,
  class: "orq-notification-hub__wrapper--profile"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_9 = {
  key: 0,
  class: "orq-notification-hub__wrapper--label"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_10 = {
  class: "orq-notification-hub__wrapper--description"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_11 = {
  class: "orq-notification-hub__wrapper--description--content"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_12 = {
  class: "orq-notification-hub__wrapper--description--date"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_13 = {
  class: "orq-notification-hub__wrapper--action"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_14 = {
  key: 0
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_15 = {
  class: "orq-notification-hub__wrapper--action--link"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_16 = {
  class: "orq-notification-hub__link orq-notification-hub__read-all"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_17 = {
  key: 1
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_18 = {
  class: "orq-notification-hub__notifications"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_19 = {
  class: "orq-notification-hub__date--parg"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_20 = ["tabIndex", "onClick"];
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_21 = {
  key: 0,
  class: "orq-notification-hub__wrapper--profile"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_22 = {
  key: 1,
  class: "orq-notification-hub__wrapper--profile"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_23 = {
  key: 2,
  class: "orq-notification-hub__wrapper--profile"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_24 = {
  key: 0
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_25 = {
  key: 0,
  class: "orq-notification-hub__wrapper--label"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_26 = {
  class: "orq-notification-hub__wrapper--description"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_27 = {
  class: "orq-notification-hub__wrapper--description--content"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_28 = {
  class: "orq-notification-hub__wrapper--description--date"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_29 = {
  key: 2,
  class: "orq-notification-hub__wrapper--action"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_30 = {
  key: 0
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_31 = {
  class: "orq-notification-hub__wrapper--action--link"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_32 = {
  class: "orq-notification-hub__wrapper--action--link--label"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_33 = {
  class: "orq-notification-hub__link orq-notification-hub__read-all"
};
const NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_34 = {
  class: "orq-notification-hub__wrapper--profile"
};
function NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqLink = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqLink");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqAvatar = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqAvatar");
  const _component_OrqImageContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqImageContainer");
  const _component_OrqBadge = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqBadge");
  const _component_OrqBullet = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqBullet");
  const _component_OrqButton = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqButton");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub ${_ctx.inverseNotification}`),
    "data-testid": "orq-notification-hub"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__component ${_ctx.inverseComponent} `)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__component--title ${_ctx.inverseTitleComponent}`)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.titleNotification), 3), _ctx.href ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqLink, {
    key: 0,
    icon: "default",
    href: _ctx.href,
    target: _ctx.target,
    label: _ctx.descriptionAllNotifications,
    inverse: _ctx.inverse
  }, null, 8, ["href", "target", "label", "inverse"])) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqLink, {
    key: 1,
    icon: "default",
    label: _ctx.descriptionAllNotifications,
    inverse: _ctx.inverse,
    onClick: _ctx.showOptions
  }, null, 8, ["label", "inverse", "onClick"]))], 2), _ctx.state === 'full' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_1, [_ctx.viewComponent ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_3, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.itemNotification, item => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: item.id
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__date ${_ctx.inverseDateComponent}`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.date), 1)], 2), ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(item.children, itemChild => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        key: itemChild.key
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        role: "button",
        onFocus: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _ctx.handleFocus && _ctx.handleFocus(...args)),
        onBlur: _cache[1] || (_cache[1] =
        //@ts-ignore
        (...args) => _ctx.handleBlur && _ctx.handleBlur(...args)),
        tabIndex: _ctx.tabIndex,
        onClick: $event => _ctx.readNotification(item.id, itemChild.key),
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__wrapper ${_ctx.inverseWrapperComponent}`)
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [itemChild.profile === 'icon' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
        name: itemChild.iconName,
        inverse: _ctx.inverse,
        circle: true,
        size: 40,
        color: _ctx.iconColors
      }, null, 8, ["name", "inverse", "color"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), itemChild.profile === 'avatar' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_7, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqAvatar, {
        type: "initials",
        alt: itemChild.alt,
        size: 40,
        outline: true,
        inverse: _ctx.inverse
      }, null, 8, ["alt", "inverse"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), itemChild.profile === 'image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqImageContainer, {
        src: itemChild.src,
        alt: itemChild.altImage,
        shape: "rounded"
      }, null, 8, ["src", "alt"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [itemChild.badge ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_9, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqBadge, {
        appearance: "default",
        color: itemChild.colorBadge,
        label: itemChild.badgeText,
        size: "small"
      }, null, 8, ["color", "label"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), itemChild.title ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        key: 1,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__wrapper--title ${_ctx.inverseWrapperTitle}`)
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(itemChild.titleText), 1)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_10, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_11, [itemChild.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", {
        key: 0,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__wrapper--description--content--textAll ${_ctx.inverseTextDescription}`)
      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(itemChild.description), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_12, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__wrapper--description--date--time ${_ctx.inverseTimeDateDescription}`)
      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(itemChild.date), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [!itemChild.read ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqBullet, {
        key: 0,
        appearance: "info",
        inverse: _ctx.inverse
      }, null, 8, ["inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_13, [itemChild.button ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_14, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqButton, {
        type: "button",
        size: "compact",
        label: itemChild.buttonName,
        onClick: _ctx.handleClick
      }, null, 8, ["label", "onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_15, [itemChild.link ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqLink, {
        key: 0,
        icon: "default",
        orientation: "right",
        underline: false,
        loading: false,
        inverse: _ctx.inverse,
        href: itemChild.linkHref,
        label: itemChild.linkName
      }, null, 8, ["inverse", "href", "label"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])])], 42, NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_5)]);
    }), 128))])]);
  }), 128))]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_16, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqLink, {
    icon: "none",
    underline: true,
    label: _ctx.descriptionAllRead,
    inverse: _ctx.inverse,
    onClick: _ctx.readAllNotifications
  }, null, 8, ["label", "inverse", "onClick"])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.viewComponent ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_17, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_18, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.itemNotification, item => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: item.id
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__date ${_ctx.inverseDateComponent}`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_19, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.date), 1)], 2), ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(item.children, itemChild => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        key: itemChild.key
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
        role: "button",
        onFocus: _cache[2] || (_cache[2] =
        //@ts-ignore
        (...args) => _ctx.handleFocus && _ctx.handleFocus(...args)),
        onBlur: _cache[3] || (_cache[3] =
        //@ts-ignore
        (...args) => _ctx.handleBlur && _ctx.handleBlur(...args)),
        tabIndex: _ctx.tabIndex,
        onClick: $event => _ctx.readNotification(item.id, itemChild.key),
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__wrapper ${_ctx.inverseWrapperComponent}`)
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [itemChild.profile === 'icon' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_21, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
        name: itemChild.iconName,
        inverse: _ctx.inverse,
        circle: true,
        size: 40,
        color: _ctx.iconColors
      }, null, 8, ["name", "inverse", "color"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), itemChild.profile === 'avatar' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_22, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqAvatar, {
        type: "initials",
        alt: itemChild.alt,
        size: 40,
        outline: true,
        inverse: _ctx.inverse
      }, null, 8, ["alt", "inverse"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), itemChild.profile === 'image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_23, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqImageContainer, {
        src: itemChild.src,
        alt: itemChild.altImage,
        shape: "rounded"
      }, null, 8, ["src", "alt"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [itemChild.allAction ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_24, [itemChild.badge ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_25, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqBadge, {
        appearance: "default",
        color: itemChild.colorBadge,
        label: itemChild.badgeText,
        size: "small"
      }, null, 8, ["color", "label"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), itemChild.title ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
        key: 1,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__wrapper--title ${_ctx.inverseWrapperTitle}`)
      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(itemChild.titleText), 1)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_26, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_27, [itemChild.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", {
        key: 0,
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__wrapper--description--content--text ${_ctx.inverseTextDescription}`)
      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(itemChild.description), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_28, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__wrapper--description--date--time ${_ctx.inverseTimeDateDescription}`)
      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(itemChild.date), 3), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [!itemChild.read ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqBullet, {
        key: 0,
        appearance: "info",
        inverse: _ctx.inverse
      }, null, 8, ["inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])]), itemChild.allAction ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_29, [itemChild.button ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_30, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqButton, {
        type: "button",
        size: "compact",
        label: itemChild.buttonName,
        onClick: _ctx.handleClick
      }, null, 8, ["label", "onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_31, [itemChild.link ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqLink, {
        key: 0,
        orientation: "right",
        href: itemChild.linkHref,
        underline: false,
        inverse: _ctx.inverse,
        loading: false
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_32, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(itemChild.label), 1)]),
        _: 2
      }, 1032, ["href", "inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])], 42, NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_20)]);
    }), 128))]);
  }), 128))]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_33, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqLink, {
    icon: "none",
    underline: true,
    label: _ctx.descriptionAllRead,
    inverse: _ctx.inverse,
    onClick: _ctx.readAllNotifications
  }, null, 8, ["label", "inverse", "onClick"])])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.state !== 'full' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__wrapper ${_ctx.inverseWrapperComponent}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_hoisted_34, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    name: "empty",
    inverse: _ctx.inverse,
    circle: true,
    size: 40,
    color: _ctx.colorIconEmpty,
    customCircleBackgroundColor: _ctx.backgroundColorEmpty
  }, null, 8, ["inverse", "color", "customCircleBackgroundColor"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-notification-hub__wrapper--empty ${_ctx.colorEmpty}`)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.descriptionEmpty), 1)], 2)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/NotificationHub/NotificationHub.vue?vue&type=template&id=20a50b26&scoped=true&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/NotificationHub/NotificationHub.vue?vue&type=script&lang=ts








/* harmony default export */ var NotificationHubvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqNotificationHub",
  components: {
    OrqImageContainer: ImageContainer,
    OrqIconContainer: IconContainer,
    OrqAvatar: Avatar,
    OrqButton: Button,
    OrqBullet: Bullet,
    OrqBadge: Badge,
    OrqLink: Link
  },
  props: {
    state: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    titleNotification: {
      type: String,
      default: ""
    },
    descriptionEmpty: {
      type: String,
      default: ""
    },
    descriptionAllNotifications: {
      type: String,
      default: ""
    },
    descriptionAllRead: {
      type: String,
      default: ""
    },
    itemsNotificationHub: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  setup(props, {
    emit
  }) {
    const itemNotification = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.itemsNotificationHub);
    const actionClick = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0);
    const viewComponent = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const showOptions = () => {
      viewComponent.value = !viewComponent.value;
    };
    const readNotification = (id, key) => {
      const children = itemNotification.value?.[0].children;
      const selectedChild = children?.find(child => child.key === key);
      if (selectedChild) {
        selectedChild.read = true;
      }
      emit("readNotification", id, key);
    };
    const readAllNotifications = () => {
      const children = itemNotification.value?.[0].children;
      if (children) {
        for (let i = 0; i < children.length; i++) {
          children[i].read = true;
        }
      }
      emit("readAllNotifications");
    };
    const handleClick = () => {
      emit("onClick");
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => props.itemsNotificationHub, (nv, olv) => {
      itemNotification.value = nv;
    });
    const handleFocus = () => {
      tabIndex = 1;
    };
    const handleBlur = () => {
      tabIndex = 0;
    };
    let tabIndex = actionClick.value ? 1 : 0;
    return {
      itemNotification,
      actionClick,
      viewComponent,
      showOptions,
      readNotification,
      readAllNotifications,
      handleFocus,
      handleBlur,
      handleClick,
      tabIndex,
      inverseNotification: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-notification-hub--inverse" : ""),
      inverseWrapperComponent: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-notification-hub__wrapper--inverse" : ""),
      inverseWrapperTitle: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-notification-hub__wrapper--title--inverse" : ""),
      inverseComponent: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-notification-hub__component--inverse" : ""),
      inverseTitleComponent: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-notification-hub__component--title--inverse" : ""),
      inverseDateComponent: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-notification-hub__date--inverse" : ""),
      inverseTimeDateDescription: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-notification-hub__wrapper--description--date--time--inverse" : ""),
      inverseTextDescription: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "orq-notification-hub__wrapper--description--content--text--inverse" : ""),
      iconColors: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "emphasis-base-high-inverse" : "emphasis-base-high"),
      colorIconEmpty: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? `emphasis-base-high` : `emphasis-base-high-inverse`),
      colorEmpty: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? `orq-notification-hub__wrapper--empty--inverse` : `orq-notification-hub__wrapper--empty`),
      backgroundColorEmpty: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? "var(--primary-base-inverse)" : "var(--primary-base)")
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/NotificationHub/NotificationHub.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/NotificationHub/NotificationHub.vue?vue&type=style&index=0&id=20a50b26&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/NotificationHub/NotificationHub.vue?vue&type=style&index=0&id=20a50b26&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/NotificationHub/NotificationHub.vue




;


const NotificationHub_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(NotificationHubvue_type_script_lang_ts, [['render',NotificationHubvue_type_template_id_20a50b26_scoped_true_ts_true_render],['__scopeId',"data-v-20a50b26"]])

/* harmony default export */ var NotificationHub = (NotificationHub_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/NotificationInline/NotificationInline.vue?vue&type=template&id=2e6a3438&ts=true

const NotificationInlinevue_type_template_id_2e6a3438_ts_true_hoisted_1 = {
  class: "orq-notification-inline"
};
const NotificationInlinevue_type_template_id_2e6a3438_ts_true_hoisted_2 = {
  class: "orq-notification-inline__icon"
};
function NotificationInlinevue_type_template_id_2e6a3438_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", NotificationInlinevue_type_template_id_2e6a3438_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", NotificationInlinevue_type_template_id_2e6a3438_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: _ctx.iconContainerName,
    size: _ctx.size,
    inverse: _ctx.inverse,
    color: _ctx.setColorIcon()
  }, null, 8, ["name", "size", "inverse", "color"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.notificationInlineLabel)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 3)]);
}
;// CONCATENATED MODULE: ./src/components/NotificationInline/NotificationInline.vue?vue&type=template&id=2e6a3438&ts=true

;// CONCATENATED MODULE: ./src/components/NotificationInline/models/notificationInline.enum.ts
var ENotificationInlineSize;
(function (ENotificationInlineSize) {
  ENotificationInlineSize[ENotificationInlineSize["dp12"] = 12] = "dp12";
  ENotificationInlineSize[ENotificationInlineSize["dp16"] = 16] = "dp16";
})(ENotificationInlineSize || (ENotificationInlineSize = {}));
var ENotificationInlineIconType;
(function (ENotificationInlineIconType) {
  ENotificationInlineIconType["placeholder"] = "placeholder";
  ENotificationInlineIconType["attention"] = "attention";
  ENotificationInlineIconType["success"] = "status-success";
  ENotificationInlineIconType["error"] = "status-error";
  ENotificationInlineIconType["info"] = "info";
})(ENotificationInlineIconType || (ENotificationInlineIconType = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/NotificationInline/NotificationInline.vue?vue&type=script&lang=ts




/* harmony default export */ var NotificationInlinevue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqNotificationInline",
  props: {
    label: {
      type: String,
      default: ""
    },
    iconName: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 16
    },
    iconType: {
      type: String,
      default: ""
    }
  },
  components: {
    OrqIconContainer: IconContainer
  },
  setup(props) {
    const setColorIcon = () => {
      if (props.iconName && props.iconType === ENotificationInlineIconType.placeholder && props.disabled && props.inverse) {
        return EiconContainerColor.emphasisBaseInverseDisabled;
      } else if (props.iconName && props.iconType === ENotificationInlineIconType.placeholder && props.disabled) {
        return EiconContainerColor.emphasisBaseDisabled;
      } else if (props.iconName && props.iconType === ENotificationInlineIconType.placeholder && props.inverse) {
        return EiconContainerColor.emphasisBaseInverseHigh;
      } else if (props.disabled && !props.inverse) {
        return EiconContainerColor.emphasisBaseDisabled;
      } else if (props.disabled && props.inverse) {
        return EiconContainerColor.emphasisBaseInverseDisabled;
      } else if (props.iconType === ENotificationInlineIconType.attention) {
        return props.inverse ? EiconContainerColor.statusWarningInverse : EiconContainerColor.statusWarning;
      } else if (props.iconType === ENotificationInlineIconType.success) {
        return props.inverse ? EiconContainerColor.statusSuccessInverse : EiconContainerColor.statusSuccess;
      } else if (props.iconType === ENotificationInlineIconType.error) {
        return props.inverse ? EiconContainerColor.statusErrorInverse : EiconContainerColor.statusError;
      } else if (props.iconType === ENotificationInlineIconType.info) {
        return props.inverse ? EiconContainerColor.statusInformativeInverse : EiconContainerColor.statusInformative;
      }
      return EiconContainerColor.emphasisBaseHigh;
    };
    return {
      iconContainerName: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return props.iconType === ENotificationInlineIconType.placeholder ? props.iconName : props.iconType;
      }),
      notificationInlineLabel: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          " orq-notification-inline__label": true,
          [`orq-notification-inline__label--size-${props.size}`]: true,
          " orq-notification-inline__label--disabled--inverse": props.disabled && props.inverse,
          " orq-notification-inline__label--disabled": props.disabled && !props.inverse,
          " orq-notification-inline__label--inverse": props.inverse && !props.disabled
        };
      }),
      setColorIcon
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/NotificationInline/NotificationInline.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/NotificationInline/NotificationInline.vue?vue&type=style&index=0&id=2e6a3438&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/NotificationInline/NotificationInline.vue?vue&type=style&index=0&id=2e6a3438&lang=scss

;// CONCATENATED MODULE: ./src/components/NotificationInline/NotificationInline.vue




;


const NotificationInline_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(NotificationInlinevue_type_script_lang_ts, [['render',NotificationInlinevue_type_template_id_2e6a3438_ts_true_render]])

/* harmony default export */ var NotificationInline = (NotificationInline_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Pagination/Pagination.vue?vue&type=template&id=15d16092&ts=true

const Paginationvue_type_template_id_15d16092_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-pagination__content-right"
};
const Paginationvue_type_template_id_15d16092_ts_true_hoisted_2 = {
  class: "orq-pagination__content-left"
};
const Paginationvue_type_template_id_15d16092_ts_true_hoisted_3 = {
  key: 0,
  class: "orq-pagination__counter"
};
const Paginationvue_type_template_id_15d16092_ts_true_hoisted_4 = {
  class: "orq-pagination__pagination"
};
const Paginationvue_type_template_id_15d16092_ts_true_hoisted_5 = {
  class: "icon-container"
};
const Paginationvue_type_template_id_15d16092_ts_true_hoisted_6 = ["onClick"];
const Paginationvue_type_template_id_15d16092_ts_true_hoisted_7 = {
  key: 1,
  class: "orq-pagination__pagination__item orq-pagination__pagination__item--ellipsis",
  role: "button"
};
const Paginationvue_type_template_id_15d16092_ts_true_hoisted_8 = {
  class: "icon-container"
};
function Paginationvue_type_template_id_15d16092_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqSelectInline = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqSelectInline");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.inverseClass)
  }, [_ctx.selectPages ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Paginationvue_type_template_id_15d16092_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqSelectInline, {
    modelValue: _ctx.itemsPerPageState,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.itemsPerPageState = $event),
    inverse: _ctx.inverse,
    items: _ctx.items,
    labelPosition: "right",
    label: _ctx.label,
    isOpen: _ctx.isOpenedRef,
    onOnClick: _ctx.handleClick
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("code", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.handleDefaultPage()), 1)]),
    _: 1
  }, 8, ["modelValue", "inverse", "items", "label", "isOpen", "onOnClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Paginationvue_type_template_id_15d16092_ts_true_hoisted_2, [_ctx.pagesInfo ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Paginationvue_type_template_id_15d16092_ts_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.showFrom()) + " - " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.showUntil()) + " de " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.totalItemsState), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", Paginationvue_type_template_id_15d16092_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.prevButtonDisabledClass),
    role: "button"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    role: "button",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.prevPage && _ctx.prevPage(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Paginationvue_type_template_id_15d16092_ts_true_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "chevron-left",
    size: 24,
    inverse: _ctx.inverse,
    color: _ctx.setColorIcon
  }, null, 8, ["inverse", "color"])])])], 2), ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.pages(), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: index
    }, [item !== -1 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      role: "button",
      ref_for: true,
      ref: "elRef",
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-pagination__pagination__item ${_ctx.currentPageState === item ? 'orq-pagination__pagination__item--active' : ''}`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      role: "button",
      onClick: $event => _ctx.changePage(item)
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item), 9, Paginationvue_type_template_id_15d16092_ts_true_hoisted_6)], 2)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Paginationvue_type_template_id_15d16092_ts_true_hoisted_7, " ... "))], 64);
  }), 128)), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.nextButtonDisabledClass),
    role: "button"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    role: "button",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.nextPage && _ctx.nextPage(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Paginationvue_type_template_id_15d16092_ts_true_hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: "chevron-right",
    size: 24,
    color: _ctx.setColorIcon
  }, null, 8, ["color"])])])], 2)])])], 2);
}
;// CONCATENATED MODULE: ./src/components/Pagination/Pagination.vue?vue&type=template&id=15d16092&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/SelectInline/SelectInline.vue?vue&type=template&id=16d1d73a&ts=true

const SelectInlinevue_type_template_id_16d1d73a_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-select-inline__field__text"
};
const SelectInlinevue_type_template_id_16d1d73a_ts_true_hoisted_2 = {
  key: 1,
  class: "orq-select-inline__field__text"
};
const SelectInlinevue_type_template_id_16d1d73a_ts_true_hoisted_3 = {
  class: "orq-select-inline__field__icon"
};
const SelectInlinevue_type_template_id_16d1d73a_ts_true_hoisted_4 = {
  id: "orq-select-inline-floating-action"
};
function SelectInlinevue_type_template_id_16d1d73a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqDropdown = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqDropdown");
  return _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    inverse: _ctx.inverse,
    type: "select-inline"
  }, null, 8, ["inverse"])) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectInlineClass),
    ref: "selectInlineRef"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: "orq-select-inline__field",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.handleSetIsOpened && _ctx.handleSetIsOpened(...args)),
    role: "button"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectInlinePositionLabelclass),
    htmlFor: "orq-select-inline-floating-action"
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 3), _ctx.isSingle ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", SelectInlinevue_type_template_id_16d1d73a_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.currentTitle), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.isMulti ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", SelectInlinevue_type_template_id_16d1d73a_ts_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.selectedItems), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", SelectInlinevue_type_template_id_16d1d73a_ts_true_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    name: "chevron-down",
    type: "none",
    color: _ctx.iconColor,
    size: 24
  }, null, 8, ["color"])])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", SelectInlinevue_type_template_id_16d1d73a_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqDropdown, {
    isOpen: _ctx.isOpened,
    type: _ctx.type,
    inverse: _ctx.inverse,
    search: _ctx.search,
    options: _ctx.dataItems,
    searchPlaceholder: _ctx.searchPlaceholder,
    multiple: _ctx.multiple,
    onOnSelect: _ctx.clickHandler
  }, null, 8, ["isOpen", "type", "inverse", "search", "options", "searchPlaceholder", "multiple", "onOnSelect"])])], 2));
}
;// CONCATENATED MODULE: ./src/components/SelectInline/SelectInline.vue?vue&type=template&id=16d1d73a&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/SelectInline/SelectInline.vue?vue&type=script&lang=ts







/* harmony default export */ var SelectInlinevue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqSelectInline",
  components: {
    OrqIconContainer: IconContainer,
    OrqDropdown: Dropdown,
    OrqShimmer: Shimmer
  },
  props: {
    labelPosition: {
      type: String,
      default: "left"
    },
    label: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    search: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "default"
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const dataItems = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.items);
    const isSingle = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(dataItems.value.filter(item => item?.selected)?.length === 1);
    const isMulti = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(dataItems.value.filter(item => item?.selected)?.length > 1);
    const selectedItems = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(dataItems.value.filter(item => item?.selected)?.length + " Selecionados");
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    const isOpened = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.isOpen);
    const currentTitle = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.title);
    const selectInlineRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const options = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      dataItems.value.map((item, index) => {
        if (item.selected) {
          currentTitle.value = item["title"];
          options.value.push({
            ...item
          });
        }
      });
    });
    const selectSingleItem = item => {
      currentTitle.value = item["title"];
      options.value = [item];
      isOpened.value = false;
    };
    const selectMultiItems = item => {
      if (item.selected) {
        currentTitle.value = item["title"];
        options.value.push(item);
      } else {
        const indexOption = options.value.findIndex(i => i.title === item.title);
        options.value.splice(indexOption, 1);
        currentTitle.value = options.value[0]?.title;
      }
    };
    const clickHandler = item => {
      if (!props.multiple) {
        selectSingleItem(item);
      } else {
        selectMultiItems(item);
      }
      emit("onClick", item);
    };
    const handleSetIsOpened = () => {
      isOpened.value = !isOpened.value;
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      isSingle.value = options.value.length === 1;
      isMulti.value = options.value.length > 1;
      selectedItems.value = options.value.length + " Selecionados";
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      isOpened.value = props.isOpen;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      dataItems.value = props.items;
    });
    useOnClickOutside(selectInlineRef, () => {
      isOpened.value = false;
      emit("onClose");
    });
    return {
      selectInlineClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-select-inline": true,
          "orq-select-inline--expanded": isOpened.value,
          "orq-select-inline--inverse": props.inverse
        };
      }),
      selectInlinePositionLabelclass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-select-inline__field__label": true,
          "orq-select-inline__field__label--right": props.labelPosition === "right"
        };
      }),
      iconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return props.inverse ? iconColors.value.emphasisBaseInverseHigh : iconColors.value.emphasisBaseHigh;
      }),
      isSingle,
      isMulti,
      selectedItems,
      handleSetIsOpened,
      currentTitle,
      isOpened,
      dataItems,
      clickHandler,
      options,
      selectInlineRef
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/SelectInline/SelectInline.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/SelectInline/SelectInline.vue?vue&type=style&index=0&id=16d1d73a&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/SelectInline/SelectInline.vue?vue&type=style&index=0&id=16d1d73a&lang=scss

;// CONCATENATED MODULE: ./src/components/SelectInline/SelectInline.vue




;


const SelectInline_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SelectInlinevue_type_script_lang_ts, [['render',SelectInlinevue_type_template_id_16d1d73a_ts_true_render]])

/* harmony default export */ var SelectInline = (SelectInline_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Pagination/Pagination.vue?vue&type=script&lang=ts




/* harmony default export */ var Paginationvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqPagination",
  props: {
    inverse: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalItems: {
      type: Number,
      default: 100
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    pageOptions: {
      type: Array,
      default: () => []
    },
    selectPages: {
      type: Boolean,
      default: false
    },
    pagesInfo: {
      type: Boolean,
      default: false
    },
    isOpened: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ""
    }
  },
  components: {
    OrqIconContainer: IconContainer,
    OrqSelectInline: SelectInline
  },
  setup(props, {
    emit
  }) {
    const currentPageState = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.currentPage);
    const totalItemsState = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.totalItems);
    const itemsPerPageState = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.itemsPerPage);
    const items = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.pageOptions);
    const totalItems = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.totalItems);
    const isOpenedRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.isOpened);
    const handleDefaultPage = () => {
      items.value.map(i => {
        if (i.selected) {
          itemsPerPageState.value;
        }
        itemsPerPageState.value;
      });
    };
    const setColorIcon = () => {
      if (!props.inverse) {
        return EiconContainerColor.emphasisBaseHigh;
      }
      return EiconContainerColor.emphasisBaseInverseHigh;
    };
    const handleClick = value => {
      itemsPerPageState.value = parseInt(value.title);
      if (value.selected) {
        isOpenedRef.value = false;
      }
      emit("clickPerPage", value);
    };
    const numberOfPages = () => {
      return Math.ceil(totalItemsState.value / itemsPerPageState.value);
    };
    const prevPage = () => {
      if (currentPageState.value >= 2) {
        currentPageState.value -= 1;
      }
      emit("prevpage", currentPageState.value);
    };
    const nextPage = () => {
      if (currentPageState.value < numberOfPages()) {
        currentPageState.value += 1;
      }
      emit("nextpage", currentPageState.value);
    };
    const showUntil = () => {
      const value = currentPageState.value * itemsPerPageState.value;
      return value > totalItemsState.value ? totalItems.value : value;
    };
    const showFrom = () => {
      const value = currentPageState.value * itemsPerPageState.value;
      return value > itemsPerPageState.value ? value - itemsPerPageState.value : 1;
    };
    const pages = () => {
      if (numberOfPages() <= 7) {
        return [...Array(numberOfPages()).keys()].map(x => ++x);
      }
      if (currentPageState.value > 5) {
        if (currentPageState.value >= numberOfPages() - 4) {
          return [1, -1, numberOfPages() - 4, numberOfPages() - 3, numberOfPages() - 2, numberOfPages() - 1, numberOfPages()];
        } else {
          return [1, -1, currentPageState.value - 1, currentPageState.value, currentPageState.value + 1, -1, numberOfPages()];
        }
      }
      return [1, 2, 3, 4, 5, -1, numberOfPages()];
    };
    const changePage = page => {
      currentPageState.value = page;
      emit("changepage", page);
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      currentPageState.value = props.currentPage;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      totalItemsState.value = props.totalItems;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      itemsPerPageState.value = props.itemsPerPage;
    });
    return {
      inverseClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-pagination": true,
          "orq-pagination--inverse": props.inverse
        };
      }),
      prevButtonDisabledClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-pagination__pagination__item": true,
          "orq-pagination__pagination__item--prev": true,
          "orq-pagination__pagination__item--disabled": currentPageState.value === 1
        };
      }),
      nextButtonDisabledClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-pagination__pagination__item--next": true,
          "orq-pagination__pagination__item": true,
          "orq-pagination__pagination__item--disabled": currentPageState.value >= numberOfPages()
        };
      }),
      setColorIcon,
      currentPageState,
      totalItemsState,
      itemsPerPageState,
      prevPage,
      nextPage,
      showUntil,
      showFrom,
      pages,
      changePage,
      items,
      handleClick,
      isOpenedRef,
      handleDefaultPage
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Pagination/Pagination.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Pagination/Pagination.vue?vue&type=style&index=0&id=15d16092&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Pagination/Pagination.vue?vue&type=style&index=0&id=15d16092&lang=scss

;// CONCATENATED MODULE: ./src/components/Pagination/Pagination.vue




;


const Pagination_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Paginationvue_type_script_lang_ts, [['render',Paginationvue_type_template_id_15d16092_ts_true_render]])

/* harmony default export */ var Pagination = (Pagination_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressTracker/ProgressTracker.vue?vue&type=template&id=3dbc07a1&scoped=true&ts=true

const ProgressTrackervue_type_template_id_3dbc07a1_scoped_true_ts_true_withScopeId = n => (_pushScopeId("data-v-3dbc07a1"), n = n(), _popScopeId(), n);
const ProgressTrackervue_type_template_id_3dbc07a1_scoped_true_ts_true_hoisted_1 = {
  class: "orq-progress-tracker__step--wrapper"
};
function ProgressTrackervue_type_template_id_3dbc07a1_scoped_true_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-tracker ${_ctx.isInverse}`)
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.refSteps, (step, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
      key: index
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ProgressTrackervue_type_template_id_3dbc07a1_scoped_true_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-tracker__step ${_ctx.isStepCurrent(step)} ${_ctx.isStepCompleted(step)} ${_ctx.getPendingClass(step, 'step')} ${_ctx.getShownClass(index, 'step')}`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-tracker__status ${_ctx.getShownClass(index, 'status')}`)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      ref_for: true,
      ref: "elRef",
      type: "none",
      name: "check",
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-tracker__status__icon ${_ctx.isIconShown(step)}`),
      color: _ctx.iconColor
    }, null, 8, ["class", "color"])], 2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-tracker__label ${_ctx.isLabelActive(step)} ${_ctx.getShownClass(index, 'label')}`)
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(step.label), 3)], 2)]), index + 1 !== _ctx.steps?.length ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: 0,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`orq-progress-tracker__track ${_ctx.isTrackActive(step)} ${_ctx.getShownClass(index, 'track')} ${_ctx.getPendingClass(step, 'track')}`)
    }, null, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
  }), 128))], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 1,
    type: "progress-tracker",
    loading: _ctx.loading,
    inverse: _ctx.inverse,
    rows: 1,
    cols: _ctx.steps?.length
  }, null, 8, ["loading", "inverse", "cols"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/ProgressTracker/ProgressTracker.vue?vue&type=template&id=3dbc07a1&scoped=true&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressTracker/ProgressTracker.vue?vue&type=script&lang=ts




/* harmony default export */ var ProgressTrackervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqProgressTracker",
  components: {
    OrqShimmer: Shimmer,
    OrqIconContainer: IconContainer
  },
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    setCurrentStep: {
      type: Number,
      default: 1
    }
  },
  setup(props, {
    emit
  }) {
    const getShownClass = (index, el) => {
      return refSteps.value.length > index ? `orq-progress-tracker__${el}--show` : "";
    };
    const getPendingClass = (step, el) => {
      return !step.current && !step.completed ? `orq-progress-tracker__${el}--pending` : "";
    };
    const isStepCurrent = step => {
      return step.current ? "orq-progress-tracker__step--current" : "";
    };
    const isStepCompleted = step => {
      return step.completed ? "orq-progress-tracker__step--completed" : "";
    };
    const isLabelActive = step => {
      return step.current ? "orq-progress-tracker__label--active" : "";
    };
    const isTrackActive = step => {
      return step.completed ? "orq-progress-tracker__track--active" : "orq-progress-tracker__track--pending";
    };
    const isIconShown = step => {
      return step.completed ? "orq-progress-tracker__status__icon--show" : "";
    };
    const refSteps = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.steps);
    const refStepActiveCurrent = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.setCurrentStep);
    const currentStep = refSteps.value[refStepActiveCurrent.value - 1];
    const buildProgressTracker = () => {
      let newSteps = [];
      refSteps.value.forEach((step, index) => {
        let activeCurrentStep = refStepActiveCurrent.value;
        if (activeCurrentStep == refSteps.value?.length) {
          step.completed = true;
          step.current = false;
        } else if (activeCurrentStep <= refSteps.value?.length && activeCurrentStep >= 1) {
          if (index + 1 < activeCurrentStep) {
            step.completed = true;
            step.current = false;
          } else if (index + 1 === activeCurrentStep) {
            step.completed = false;
            step.current = true;
          } else {
            step.completed = false;
            step.current = false;
          }
        }
        newSteps.push(step);
      });
      refSteps.value = newSteps;
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(refStepActiveCurrent, () => {
      buildProgressTracker();
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      buildProgressTracker();
    });
    const nextStep = () => {
      if (refStepActiveCurrent.value < refSteps.value.length) {
        refStepActiveCurrent.value++;
        emit("stepChanged", currentStep);
      }
    };
    const previousStep = () => {
      if (refStepActiveCurrent.value > 1) {
        refStepActiveCurrent.value--;
        emit("stepChanged", currentStep);
      }
    };
    const completeSteps = () => {
      refStepActiveCurrent.value = refSteps.value.length;
      emit("completed", refSteps.value);
    };
    const resetSteps = () => {
      refStepActiveCurrent.value = 1;
      emit("stepChanged", currentStep);
    };
    const setCurrentSteps = step => {
      refStepActiveCurrent.value = step;
      emit("stepChanged", currentStep);
    };
    return {
      isInverse: props.inverse ? `orq-progress-tracker--inverse` : "orq-progress-tracker--default",
      iconColor: props.inverse ? "emphasis-base-high" : "emphasis-base-high--inverse",
      getShownClass,
      getPendingClass,
      isStepCurrent,
      isStepCompleted,
      isLabelActive,
      isTrackActive,
      isIconShown,
      refStepActiveCurrent,
      nextStep,
      previousStep,
      completeSteps,
      resetSteps,
      refSteps,
      setCurrentSteps
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/ProgressTracker/ProgressTracker.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressTracker/ProgressTracker.vue?vue&type=style&index=0&id=3dbc07a1&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ProgressTracker/ProgressTracker.vue?vue&type=style&index=0&id=3dbc07a1&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/ProgressTracker/ProgressTracker.vue




;


const ProgressTracker_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ProgressTrackervue_type_script_lang_ts, [['render',ProgressTrackervue_type_template_id_3dbc07a1_scoped_true_ts_true_render],['__scopeId',"data-v-3dbc07a1"]])

/* harmony default export */ var ProgressTracker = (ProgressTracker_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressIndicator/ProgressIndicator.vue?vue&type=template&id=2446ec8e&scoped=true&ts=true

const ProgressIndicatorvue_type_template_id_2446ec8e_scoped_true_ts_true_withScopeId = n => (_pushScopeId("data-v-2446ec8e"), n = n(), _popScopeId(), n);
const ProgressIndicatorvue_type_template_id_2446ec8e_scoped_true_ts_true_hoisted_1 = {
  class: "orq-progress-indicator"
};
function ProgressIndicatorvue_type_template_id_2446ec8e_scoped_true_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ProgressIndicatorvue_type_template_id_2446ec8e_scoped_true_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`${_ctx.progressAppearance}`)
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.items, ({
    active,
    i
  }) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
      key: i,
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(`
            ${_ctx.progressAppearance}__item
            ${active && _ctx.progressAppearance + '__item--active'}
            ${_ctx.inverse && active ? _ctx.progressInverseActive : _ctx.progressInverse}
        `)
    }, null, 2);
  }), 128))], 2)]);
}
;// CONCATENATED MODULE: ./src/components/ProgressIndicator/ProgressIndicator.vue?vue&type=template&id=2446ec8e&scoped=true&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressIndicator/ProgressIndicator.vue?vue&type=script&lang=ts

/* harmony default export */ var ProgressIndicatorvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqProgressIndicator",
  props: {
    appearance: {
      type: String,
      default: "bar"
    },
    inverse: {
      type: Boolean,
      default: false
    },
    items: {
      type: Object
    }
  },
  setup(props) {
    return {
      progressAppearance: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.appearance ? `orq-progress-indicator__${props.appearance}` : ""),
      progressInverse: `orq-progress-indicator__${props.appearance}__item--inverse`,
      progressInverseActive: `orq-progress-indicator__${props.appearance}__item--active--inverse`
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/ProgressIndicator/ProgressIndicator.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ProgressIndicator/ProgressIndicator.vue?vue&type=style&index=0&id=2446ec8e&lang=scss&scoped=true
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ProgressIndicator/ProgressIndicator.vue?vue&type=style&index=0&id=2446ec8e&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/ProgressIndicator/ProgressIndicator.vue




;


const ProgressIndicator_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ProgressIndicatorvue_type_script_lang_ts, [['render',ProgressIndicatorvue_type_template_id_2446ec8e_scoped_true_ts_true_render],['__scopeId',"data-v-2446ec8e"]])

/* harmony default export */ var ProgressIndicator = (ProgressIndicator_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Select/Select.vue?vue&type=template&id=1ef9d5af&ts=true

const Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-select__field__image-container"
};
const Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_2 = {
  key: 1,
  class: "orq-select__field__image-container"
};
const Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_3 = {
  class: "orq-select__field__content",
  role: "button"
};
const Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_4 = {
  key: 0,
  class: "orq-select__field__content__text"
};
const Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_5 = {
  key: 2,
  class: "orq-select__field__content__text"
};
const Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_6 = {
  role: "button",
  class: "orq-select__icon",
  "tab-index": 0
};
const Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_7 = {
  class: "orq-select__icon-expand"
};
const Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_8 = {
  key: 0,
  class: "orq-select__error"
};
const Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_9 = {
  class: "orq-select__description__message"
};
function Selectvue_type_template_id_1ef9d5af_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqImageContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqImageContainer");
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqDropdown = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqDropdown");
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [!_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)([_ctx.selectClasses, _ctx.ImageAndTwoLineClasses()]),
    ref: "selectRef"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: "orq-select__field",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onFocus($event)),
    role: "button"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectFieldLabelClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 3), _ctx.variation === 'image' && _ctx.selectedItem.imgSrc && _ctx.selectMode !== 'multi' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqImageContainer, {
    src: _ctx.selectedItem.imgSrc,
    size: 40,
    alt: _ctx.alt
  }, null, 8, ["src", "alt"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.variation === 'image' && _ctx.items.length === 1 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqImageContainer, {
    src: _ctx.items[0]?.imgSrc,
    size: 40,
    alt: _ctx.alt
  }, null, 8, ["src", "alt"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_3, [_ctx.selectMode !== 'multi' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectFieldTextClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.singleTextMode), 3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.variation !== 'default' && _ctx.items.length === 1 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [_ctx.selectMode === 'multi' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.selectedItem[0]?.title), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectFieldSubTextClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.singleSubTextMode), 3)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.selectMode === 'multi' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_5, [_ctx.items.length > 1 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.items.length + " Selecionados"), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.items.length === 1 && _ctx.variation === 'default' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 1
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.selectedItem[0]?.title), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_7, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    name: "chevron-down",
    type: "none",
    size: _ctx.size === 'large' || _ctx.variation !== 'default' ? 24 : 16,
    color: _ctx.getIconColor()
  }, null, 8, ["size", "color"])])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectFieldLineClasses)
  }, null, 2)]), _ctx.error && _ctx.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectDescriptionClasses)
  }, [_ctx.size === 'large' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
    key: 0
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    class: "orq-select__error__message__icon",
    name: "status-error",
    type: "none",
    size: 16,
    color: _ctx.getErrorIconColor()
  }, null, 8, ["color"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("label", {
    ref: "refLabel",
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectErrorLabelClasses),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.getDescriptionColor())
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 7)], 64)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("label", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectErrorLabelClasses)
  }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 3))], 2)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.error && _ctx.description ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.selectDescriptionClasses)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", Selectvue_type_template_id_1ef9d5af_ts_true_hoisted_9, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.description), 1)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqDropdown, {
    type: _ctx.handleDefaultType(),
    multiple: _ctx.selectMode === 'multi',
    isOpen: _ctx.isOpened,
    inverse: _ctx.inverse,
    search: _ctx.innerSearch,
    searchPlaceholder: _ctx.searchPlaceholder,
    disabled: _ctx.disabled,
    options: _ctx.renderItems,
    onOnSelect: _ctx.handleClick
  }, null, 8, ["type", "multiple", "isOpen", "inverse", "search", "searchPlaceholder", "disabled", "options", "onOnSelect"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 1,
    inverse: _ctx.inverse,
    type: "select"
  }, null, 8, ["inverse"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Select/Select.vue?vue&type=template&id=1ef9d5af&ts=true

;// CONCATENATED MODULE: ./src/components/Select/models/select.enum.ts
var EselectVariation;
(function (EselectVariation) {
  EselectVariation["default"] = "default";
  EselectVariation["image"] = "image";
  EselectVariation["twoLines"] = "twoLines";
})(EselectVariation || (EselectVariation = {}));
var EselectSize;
(function (EselectSize) {
  EselectSize["large"] = "large";
  EselectSize["small"] = "small";
})(EselectSize || (EselectSize = {}));
var EselectMode;
(function (EselectMode) {
  EselectMode["single"] = "single";
  EselectMode["multi"] = "multi";
})(EselectMode || (EselectMode = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Select/Select.vue?vue&type=script&lang=ts









/* harmony default export */ var Selectvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqSelect",
  props: {
    variation: {
      type: String,
      default: "default"
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    inverse: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    focus: {
      type: Boolean,
      default: false
    },
    innerSearch: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "large"
    },
    selectMode: {
      type: String,
      default: "single"
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  components: {
    OrqIconContainer: IconContainer,
    OrqImageContainer: ImageContainer,
    OrqDropdown: Dropdown,
    OrqShimmer: Shimmer
  },
  setup(props, {
    emit
  }) {
    const refLabel = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const renderItems = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.options);
    const selectRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    const selectedItem = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)();
    const isOpened = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.focus);
    const items = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    const selectModeRef = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.selectMode);
    const singleTextMode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(selectedItem.value && items.value.length === 1 ? selectedItem.value[0]?.title : selectedItem.value?.title);
    const singleSubTextMode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(selectedItem.value && items.value.length === 1 ? selectedItem.value[0]?.subtitle : selectedItem.value?.subtitle);
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      renderItems.value.map((item, index) => {
        if (item.selected) {
          items.value.push({
            ...item,
            key: index
          });
        }
      });
    });
    const handleDefaultType = () => {
      return props.variation === EselectVariation.image ? "avatar" : EselectVariation.default;
    };
    const onFocus = event => {
      if (!props.disabled) {
        isOpened.value = !isOpened.value;
      }
      emit("onFocus", event);
    };
    const ImageAndTwoLineClasses = () => {
      if (props.variation === "image") {
        return "orq-select--image";
      }
      if (props.variation === "twoLines") {
        return "orq-select--two-lines";
      }
      return "";
    };
    const getIconColor = () => {
      if (props.inverse && !props.disabled) {
        return EiconContainerColor.emphasisBaseInverseHigh;
      }
      if (props.disabled && !props.inverse) {
        return EiconContainerColor.emphasisBaseDisabled;
      }
      if (props.inverse && props.disabled) {
        return EiconContainerColor.emphasisBaseInverseDisabled;
      }
      return EiconContainerColor.emphasisBaseHigh;
    };
    const getErrorIconColor = () => {
      if (props.error && props.inverse && props.disabled || props.disabled && props.inverse) {
        return EiconContainerColor.emphasisBaseInverseDisabled;
      } else if (props.error && props.inverse) {
        return EiconContainerColor.statusErrorInverse;
      } else if (props.error && props.disabled || props.disabled) {
        return EiconContainerColor.emphasisBaseDisabled;
      } else if (props.inverse) {
        return EiconContainerColor.emphasisBaseInverseHigh;
      } else if (props.error) {
        return EiconContainerColor.statusError;
      }
      return EiconContainerColor.emphasisBaseHigh;
    };
    const getDescriptionColor = () => {
      if (props.inverse && !props.disabled) {
        refLabel.value?.style.setProperty("color", "var(--emphasis-base-low-inverse)");
      } else if (props.inverse && props.disabled) {
        refLabel.value?.style.setProperty("color", "var(--emphasis-base-disabled-inverse)");
      } else if (props.disabled && !props.inverse) {
        refLabel.value?.style.setProperty("color", "var(--emphasis-base-disabled)");
      } else {
        refLabel.value?.style.setProperty("color", "var(--emphasis-base-medium)");
      }
    };
    const selectMulti = item => {
      if (item.selected) {
        items.value.push(item);
      } else {
        const index = items.value.findIndex(i => i.title === item.title);
        items.value.splice(index, 1);
      }
    };
    const returnDefaultSelected = item => {
      const index = renderItems.value.findIndex(i => i.title === item.title);
      renderItems.value[index].selected = false;
      renderItems.value[0].selected = true;
      items.value = [renderItems.value[0]];
      isOpened.value = false;
    };
    const selectSingle = item => {
      let defaultOptionSelected = item.title !== renderItems.value[0].title && items.value.length > 0 && item.title === items.value[0].title;
      if (defaultOptionSelected) {
        returnDefaultSelected(item);
      } else {
        items.value = [item];
        isOpened.value = false;
      }
    };
    const handleClick = item => {
      const multiple = props.selectMode === "multi";
      if (multiple) {
        selectMulti(item);
      } else {
        selectSingle(item);
      }
      emit("onClick", item);
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      selectedItem.value = renderItems.value.filter(item => item.selected);
      singleTextMode.value = selectedItem.value && items.value.length === 1 ? selectedItem.value[0]?.title : selectedItem.value?.title;
      singleSubTextMode.value = selectedItem.value && items.value.length === 1 ? selectedItem.value[0]?.subtitle : selectedItem.value?.subtitle;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      isOpened.value = props.focus;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watchEffect)(() => {
      renderItems.value = props.options;
    });
    useOnClickOutside(selectRef, () => {
      isOpened.value = false;
      emit("onClose");
    });
    return {
      selectClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-select": true,
          "orq-select--inverse": props.inverse,
          "orq-select--disabled": props.disabled,
          "orq-select--two-lines": props.variation !== "default",
          "orq-select--small": props.size === "small" && props.variation === "default",
          "orq-select--has-value": items.value.length > 0
        };
      }),
      selectFieldLabelClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-select__field__label": true,
          "orq-select__field__label--error": props.error,
          "orq-select__field__label--focus": isOpened.value,
          "orq-select__field__label--disabled": props.disabled
        };
      }),
      selectFieldTextClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-select__field__content__text": true,
          "orq-select__error__message__label--image-two-line": props.error && !props.disabled,
          "orq-select__field__content__text--disabled": props.disabled
        };
      }),
      selectFieldSubTextClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-select__field__content__sub-text": true,
          "orq-select__field__content__sub-text--disabled": props.disabled,
          "orq-select__error__message__label--image-two-line": props.error && !props.disabled
        };
      }),
      selectErrorLabelClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-select__description__message": true,
          "orq-select__field__label--error": props.error && !props.disabled
        };
      }),
      selectFieldLineClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-select__field__line": true,
          "orq-select__field__line--error": props.error,
          "orq-select__field__line--disabled": props.disabled,
          "orq-select__field__line--focus": isOpened.value
        };
      }),
      selectDescriptionClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-select__description": true,
          "orq-select__field__label--error": props.error && !props.disabled,
          "orq-select__description--inverse": props.inverse,
          "orq-select__description--disabled": props.disabled,
          "orq-select__description--inverse-disabled": props.inverse && props.disabled
        };
      }),
      refLabel,
      selectRef,
      selectedItem,
      selectModeRef,
      singleTextMode,
      singleSubTextMode,
      isOpened,
      renderItems,
      items,
      ImageAndTwoLineClasses,
      getDescriptionColor,
      getErrorIconColor,
      getIconColor,
      handleDefaultType,
      onFocus,
      handleClick
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Select/Select.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Select/Select.vue?vue&type=style&index=0&id=1ef9d5af&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Select/Select.vue?vue&type=style&index=0&id=1ef9d5af&lang=scss

;// CONCATENATED MODULE: ./src/components/Select/Select.vue




;


const Select_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Selectvue_type_script_lang_ts, [['render',Selectvue_type_template_id_1ef9d5af_ts_true_render]])

/* harmony default export */ var Select = (Select_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/Tab.vue?vue&type=template&id=3469833d&ts=true

const Tabvue_type_template_id_3469833d_ts_true_hoisted_1 = {
  class: "orq-tabs__header"
};
const Tabvue_type_template_id_3469833d_ts_true_hoisted_2 = {
  key: 0,
  class: "orq-tabs__body"
};
function Tabvue_type_template_id_3469833d_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqShimmer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqShimmer");
  const _component_OrqTabHeader = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqTabHeader");
  const _component_OrqTabShowMore = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqTabShowMore");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, [_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqShimmer, {
    key: 0,
    type: "tab",
    inverse: _ctx.inverse,
    tabItems: _ctx.maxShowingTabs
  }, null, 8, ["inverse", "tabItems"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.orqTabClass)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", Tabvue_type_template_id_3469833d_ts_true_hoisted_1, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.tabs.slice(0, _ctx.maxShowingTabs), (item, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqTabHeader, {
      key: index,
      onClick: $event => _ctx.selectTab(index),
      onIsSelect: item.props.active,
      type: _ctx.type,
      label: item.props.label,
      value: 0,
      active: item.props.active,
      alt: item.props.alt,
      imgSrc: item.props.imgSrc ?? item.props.imgSrc,
      iconName: item.props.iconName ?? item.props.iconName,
      labelTootip: item.props.labelTootip ?? item.props.labelTootip,
      tooltipIconColor: item.props.tooltipIconColor ?? item.props.tooltipIconColor,
      inverse: _ctx.inverse,
      orientation: _ctx.orientation
    }, null, 8, ["onClick", "onIsSelect", "type", "label", "active", "alt", "imgSrc", "iconName", "labelTootip", "tooltipIconColor", "inverse", "orientation"]);
  }), 128)), _ctx.maxShowingTabs < _ctx.tabs.length ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.orqTabsActive),
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.showMore && _ctx.showMore(...args))
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqTabShowMore, {
    inverse: _ctx.inverse,
    tabItems: _ctx.showMore(),
    onOnSelected: _cache[0] || (_cache[0] = args => _ctx.selectTab(args.index + _ctx.maxShowingTabs))
  }, null, 8, ["inverse", "tabItems"])], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), !_ctx.loading ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", Tabvue_type_template_id_3469833d_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/Tab/Tab.vue?vue&type=template&id=3469833d&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/TabHeader.vue?vue&type=template&id=1d9461a3&ts=true

const TabHeadervue_type_template_id_1d9461a3_ts_true_hoisted_1 = {
  key: 0,
  class: "orq-tabs__tab__icon"
};
const TabHeadervue_type_template_id_1d9461a3_ts_true_hoisted_2 = {
  key: 1,
  class: "orq-tabs__tab__image"
};
const TabHeadervue_type_template_id_1d9461a3_ts_true_hoisted_3 = {
  class: "orq-tabs__tab__text"
};
const TabHeadervue_type_template_id_1d9461a3_ts_true_hoisted_4 = {
  key: 2,
  class: "orq-tabs__tab__tooltip"
};
const TabHeadervue_type_template_id_1d9461a3_ts_true_hoisted_5 = {
  class: "orq-tabs__tab__icon"
};
function TabHeadervue_type_template_id_1d9461a3_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqIconContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqIconContainer");
  const _component_OrqImageContainer = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqImageContainer");
  const _component_OrqTooltip = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqTooltip");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.activeTabsClasses)
  }, [_ctx.type === 'icon' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", TabHeadervue_type_template_id_1d9461a3_ts_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
    type: "none",
    name: _ctx.iconName || '',
    size: 24,
    color: _ctx.iconColor
  }, null, 8, ["name", "color"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.type === 'image' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", TabHeadervue_type_template_id_1d9461a3_ts_true_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqImageContainer, {
    src: _ctx.imgSrc || '',
    alt: _ctx.alt || '',
    size: 24,
    inverse: _ctx.inverse
  }, null, 8, ["src", "alt", "inverse"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", TabHeadervue_type_template_id_1d9461a3_ts_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.label), 1), _ctx.labelTootip ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", TabHeadervue_type_template_id_1d9461a3_ts_true_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqTooltip, {
    trigger: "hover",
    placement: "right",
    inverse: _ctx.inverse,
    label: _ctx.labelTootip
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", TabHeadervue_type_template_id_1d9461a3_ts_true_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqIconContainer, {
      type: "none",
      name: _ctx.iconName || '',
      size: 24,
      color: _ctx.tooltipIconColor
    }, null, 8, ["name", "color"])])]),
    _: 1
  }, 8, ["inverse", "label"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)], 2);
}
;// CONCATENATED MODULE: ./src/components/Tab/TabHeader.vue?vue&type=template&id=1d9461a3&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/TabHeader.vue?vue&type=script&lang=ts





/* harmony default export */ var TabHeadervue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqTabHeader",
  components: {
    OrqIconContainer: IconContainer,
    OrqImageContainer: ImageContainer,
    OrqTooltip: Tooltip
  },
  props: {
    inverse: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: true
    },
    iconName: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: 0
    },
    imgSrc: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    labelTootip: {
      type: String,
      default: ""
    },
    tooltipIconColor: {
      type: String,
      default: ""
    },
    orientation: {
      type: String,
      default: "horizontal"
    },
    type: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    return {
      activeTabsClasses: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-tabs__tab": true,
          "orq-tabs__tab--active": props.active,
          "orq-tabs--inverse": props.inverse,
          [`orq-tabs__tab--${props.orientation}`]: props.orientation
        };
      }),
      iconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => props.inverse ? iconColors.value.emphasisBaseInverseHigh : iconColors.value.emphasisBaseHigh)
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Tab/TabHeader.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/TabHeader.vue?vue&type=style&index=0&id=1d9461a3&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Tab/TabHeader.vue?vue&type=style&index=0&id=1d9461a3&lang=scss

;// CONCATENATED MODULE: ./src/components/Tab/TabHeader.vue




;


const TabHeader_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TabHeadervue_type_script_lang_ts, [['render',TabHeadervue_type_template_id_1d9461a3_ts_true_render]])

/* harmony default export */ var TabHeader = (TabHeader_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/TabShowMore.vue?vue&type=template&id=49d77a5a&ts=true

const TabShowMorevue_type_template_id_49d77a5a_ts_true_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
  class: "orq-tabs__tab__text"
}, "...Ver mais ", -1);
const TabShowMorevue_type_template_id_49d77a5a_ts_true_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
  class: "orq-tabs__line"
}, null, -1);
const TabShowMorevue_type_template_id_49d77a5a_ts_true_hoisted_3 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", {
  class: "orq-tabs__line--selected"
}, null, -1);
function TabShowMorevue_type_template_id_49d77a5a_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrqFloatingActionItem = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqFloatingActionItem");
  const _component_OrqFloatingAction = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("OrqFloatingAction");
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(_ctx.showmoreClass),
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.showMore && _ctx.showMore(...args)),
    ref: "tabShowMore"
  }, [TabShowMorevue_type_template_id_49d77a5a_ts_true_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_OrqFloatingAction, {
    direction: "right",
    isOpen: _ctx.showFloatingAction,
    inverse: _ctx.inverse
  }, {
    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(() => [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.tabItems, (item, index) => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_OrqFloatingActionItem, {
        key: index,
        selected: item.active,
        inverse: _ctx.inverse,
        iconName: item.iconName || item.imgSrc,
        label: item.label,
        tabIndex: index,
        onClick: $event => _ctx.onClick(item, index)
      }, null, 8, ["selected", "inverse", "iconName", "label", "tabIndex", "onClick"]);
    }), 128))]),
    _: 1
  }, 8, ["isOpen", "inverse"])]), TabShowMorevue_type_template_id_49d77a5a_ts_true_hoisted_2, TabShowMorevue_type_template_id_49d77a5a_ts_true_hoisted_3], 2);
}
;// CONCATENATED MODULE: ./src/components/Tab/TabShowMore.vue?vue&type=template&id=49d77a5a&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/TabShowMore.vue?vue&type=script&lang=ts





/* harmony default export */ var TabShowMorevue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqTabShowMore",
  components: {
    OrqFloatingAction: FloatingAction,
    OrqFloatingActionItem: FloatingActionItem
  },
  props: {
    tabItems: {
      type: Array
    },
    inverse: {
      type: Boolean
    }
  },
  setup(props, {
    emit
  }) {
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    const showFloatingAction = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const tabShowMore = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(null);
    useOnClickOutside(tabShowMore, () => {
      showFloatingAction.value = false;
    });
    const showMore = () => {
      showFloatingAction.value = !showFloatingAction.value;
    };
    const onClick = (item, index) => {
      emit("onSelected", {
        item,
        index
      });
    };
    return {
      tabShowMore,
      showFloatingAction,
      onClick,
      showMore,
      showmoreClass: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
        return {
          "orq-tabs__tab": false,
          "orq-tabs--inverse": props.inverse
        };
      }),
      iconColor: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
        iconInverseColor: props.inverse ? iconColors.value.emphasisBaseHigh : iconColors.value.emphasisBaseInverseHigh
      }))
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Tab/TabShowMore.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/TabShowMore.vue?vue&type=style&index=0&id=49d77a5a&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Tab/TabShowMore.vue?vue&type=style&index=0&id=49d77a5a&lang=scss

;// CONCATENATED MODULE: ./src/components/Tab/TabShowMore.vue




;


const TabShowMore_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TabShowMorevue_type_script_lang_ts, [['render',TabShowMorevue_type_template_id_49d77a5a_ts_true_render]])

/* harmony default export */ var TabShowMore = (TabShowMore_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/Tab.vue?vue&type=script&lang=ts





/* harmony default export */ var Tabvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqTab",
  props: {
    value: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ""
    },
    orientation: {
      type: String,
      default: ""
    },
    maxShowingTabs: {
      type: Number,
      default: 5
    },
    inverse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  components: {
    OrqTabHeader: TabHeader,
    OrqTabShowMore: TabShowMore,
    OrqShimmer: Shimmer
  },
  setup(props, {
    slots,
    emit
  }) {
    const state = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)({
      selectedIndex: 0,
      tabs: [],
      count: 0
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.provide)("TabsProvider", state);
    const selectTab = i => {
      state.selectedIndex = i;
      const newItems = state.tabs.map((tab, tabIndex) => {
        return {
          ...tab,
          props: {
            ...tab.props,
            active: i === tabIndex
          }
        };
      });
      emit("changeTab", i);
      state.tabs = [...newItems];
    };
    const showMore = () => {
      const slicedTabs = state.tabs.slice(props.maxShowingTabs, state.tabs.length - 1);
      const showMoreTabs = slicedTabs.map(tab => {
        return {
          ...tab.props
        };
      });
      return showMoreTabs;
    };
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeMount)(() => {
      if (slots.default) {
        if (slots.default()[0].children.default) {
          state.tabs = slots.default().filter(child => child.type.name === "OrqTabItem");
        } else {
          state.tabs = slots.default()[0].children.filter(child => child.type.name === "OrqTabItem");
        }
      }
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)(() => {
      state.selectedIndex = 0;
    });
    const maxshow = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(props.maxShowingTabs);
    const iconColors = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(EiconContainerColor);
    const orqTabsActive = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return {
        "orq-tabs__tab": true,
        "orq-tabs__tab--active": state.selectedIndex >= maxshow.value,
        "orq-tabs--inverse": props.inverse
      };
    });
    const orqTabClass = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => {
      return {
        "orq-tabs": true,
        "orq-tabs--inverse": props.inverse
      };
    });
    const iconColor = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => ({
      iconInverseColor: props.inverse ? iconColors.value.emphasisBaseHigh : iconColors.value.emphasisBaseInverseHigh
    }));
    return {
      ...(0,external_commonjs_vue_commonjs2_vue_root_Vue_.toRefs)(state),
      selectTab,
      showMore,
      orqTabsActive,
      orqTabClass,
      iconColor
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Tab/Tab.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-67.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-67.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-67.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-67.use[3]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/Tab.vue?vue&type=style&index=0&id=3469833d&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Tab/Tab.vue?vue&type=style&index=0&id=3469833d&lang=scss

;// CONCATENATED MODULE: ./src/components/Tab/Tab.vue




;


const Tab_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Tabvue_type_script_lang_ts, [['render',Tabvue_type_template_id_3469833d_ts_true_render]])

/* harmony default export */ var Tab = (Tab_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/TabItem.vue?vue&type=template&id=fa7ec668&ts=true

function TabItemvue_type_template_id_fa7ec668_ts_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 512)), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.isActive]]);
}
;// CONCATENATED MODULE: ./src/components/Tab/TabItem.vue?vue&type=template&id=fa7ec668&ts=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/@vue/cli-plugin-typescript/node_modules/ts-loader/index.js??clonedRuleSet-86.use[2]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Tab/TabItem.vue?vue&type=script&lang=ts

/* harmony default export */ var TabItemvue_type_script_lang_ts = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqTabItem",
  setup() {
    const index = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(0);
    const isActive = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    const tabs = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)("TabsProvider");
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.watch)(() => tabs.selectedIndex, () => {
      isActive.value = index.value === tabs.selectedIndex;
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onBeforeMount)(() => {
      index.value = tabs.count;
      tabs.count++;
      isActive.value = index.value === tabs.selectedIndex;
    });
    return {
      index,
      isActive
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Tab/TabItem.vue?vue&type=script&lang=ts
 
;// CONCATENATED MODULE: ./src/components/Tab/TabItem.vue




;
const TabItem_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TabItemvue_type_script_lang_ts, [['render',TabItemvue_type_template_id_fa7ec668_ts_true_render]])

/* harmony default export */ var TabItem = (TabItem_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-85.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Theme/Theme.vue?vue&type=template&id=46278670

function Themevue_type_template_id_46278670_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)(_ctx.colorTokens)
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderSlot)(_ctx.$slots, "default")], 4);
}
;// CONCATENATED MODULE: ./src/components/Theme/Theme.vue?vue&type=template&id=46278670

;// CONCATENATED MODULE: ./src/theme/default.theme.ts
const defaultTheme = {
  name: "Light Btg Theme",
  properties: {
    "--primary-base": "#195ab4ff",
    "--primary-base-inverse": "#b1d2ffff",
    "--primary-extended-10": "#d2e5ffff",
    "--primary-extended-20": "#b1d2ffff",
    "--primary-extended-30": "#87baffff",
    "--primary-extended-40": "#6baaffff",
    "--primary-extended-50": "#549cffff",
    "--primary-extended-60": "#307ae0ff",
    "--primary-extended-70": "#195ab4ff",
    "--primary-extended-80": "#10408dff",
    "--primary-extended-90": "#0b2859ff",
    "--primary-extended-100": "#05132aff",
    "--secondary-base": "#0fa5adff",
    "--secondary-base-inverse": "#8cedf2ff",
    "--main-state-enabled": "#195ab4ff",
    "--main-state-hover": "#5081c6ff",
    "--main-state-focus": "#195ab4ff",
    "--main-state-pressed": "#134489ff",
    "--main-state-selected": "#195ab4ff",
    "--main-state-disabled": "#ebebebff",
    "--main-state-enabled-inverse": "#b1d2ffff",
    "--main-state-hover-inverse": "#c4ddffff",
    "--main-state-focus-inverse": "#b1d2ffff",
    "--main-state-pressed-inverse": "#87a0c2ff",
    "--main-state-selected-inverse": "#b1d2ffff",
    "--main-state-disabled-inverse": "#1e3966ff",
    "--secondary-state-enabled": "#0fa5adff",
    "--secondary-state-hover": "#48bbc1ff",
    "--secondary-state-focus": "#0fa5adff",
    "--secondary-state-pressed": "#0b7e84ff",
    "--secondary-state-selected": "#0fa5adff",
    "--secondary-state-disabled": "#ebebebff",
    "--secondary-state-enabled-inverse": "#8cedf2ff",
    "--secondary-state-hover-inverse": "#a8f1f5ff",
    "--secondary-state-focus-inverse": "#8cedf2ff",
    "--secondary-state-pressed-inverse": "#6bb4b8ff",
    "--secondary-state-selected-inverse": "#8cedf2ff",
    "--secondary-state-disabled-inverse": "#1e3966ff",
    "--neutral-state-enabled": "#ffffffff",
    "--neutral-state-hover": "#ebebebff",
    "--neutral-state-focus": "#ffffffff",
    "--neutral-state-pressed": "#c2c2c2ff",
    "--neutral-state-selected": "#ffffffff",
    "--neutral-state-disabled": "#ebebebff",
    "--neutral-state-enabled-inverse": "#0b2859ff",
    "--neutral-state-hover-inverse": "#1e3966ff",
    "--neutral-state-focus-inverse": "#0b2859ff",
    "--neutral-state-pressed-inverse": "#071b3cff",
    "--neutral-state-selected-inverse": "#0b2859ff",
    "--neutral-state-disabled-inverse": "#1e3966ff",
    "--emphasis-base-high": "#000000ff",
    "--emphasis-base-medium": "#000000b3",
    "--emphasis-base-low": "#00000080",
    "--emphasis-base-disabled": "#0000004d",
    "--emphasis-base-high-inverse": "#ffffffff",
    "--emphasis-base-medium-inverse": "#ffffffb3",
    "--emphasis-base-low-inverse": "#ffffff80",
    "--emphasis-base-disabled-inverse": "#ffffff4d",
    "--success": "#53821bff",
    "--success-inverse": "#9bc868ff",
    "--warning": "#9f4f2bff",
    "--warning-inverse": "#ff905eff",
    "--error": "#ce363fff",
    "--error-inverse": "#f2757cff",
    "--informative": "#195ab4ff",
    "--informative-inverse": "#b1d2ffff",
    "--neutral-base": "#ffffffff",
    "--neutral-base-inverse": "#0b2859ff",
    "--neutral-extended-10": "#ffffffff",
    "--neutral-extended-20": "#f4f5f7ff",
    "--neutral-extended-30": "#e6e7eaff",
    "--neutral-extended-40": "#cbced4ff",
    "--neutral-extended-50": "#abb0baff",
    "--neutral-extended-60": "#7a8291ff",
    "--neutral-extended-70": "#4f5869ff",
    "--neutral-extended-80": "#394254ff",
    "--neutral-extended-90": "#202a3dff",
    "--neutral-extended-100": "#081329ff",
    "--outline": "#0000001a",
    "--outline-inverse": "#ffffff1a",
    "--outline-focus": "#a02795ff",
    "--outline-focus-inverse": "#f217deff",
    "--background-base": "#f5f5f6ff",
    "--background-base-inverse": "#05132aff",
    "--support-blue-10": "#d2e5ffff",
    "--support-blue-20": "#b1d2ffff",
    "--support-blue-30": "#87baffff",
    "--support-blue-40": "#6baaffff",
    "--support-blue-50": "#549cffff",
    "--support-blue-60": "#307ae0ff",
    "--support-blue-70": "#195ab4ff",
    "--support-blue-80": "#174e9fff",
    "--support-blue-90": "#123570ff",
    "--support-blue-100": "#0b2859ff",
    "--support-aqua-10": "#d8f0f5ff",
    "--support-aqua-20": "#bee6eeff",
    "--support-aqua-30": "#87d0dfff",
    "--support-aqua-40": "#5abed3ff",
    "--support-aqua-50": "#45b6cdff",
    "--support-aqua-60": "#329fb5ff",
    "--support-aqua-70": "#328495ff",
    "--support-aqua-80": "#2f7482ff",
    "--support-aqua-90": "#29636eff",
    "--support-aqua-100": "#22515aff",
    "--support-lime-10": "#eefbe0ff",
    "--support-lime-20": "#daefc3ff",
    "--support-lime-30": "#bcdc98ff",
    "--support-lime-40": "#9bc868ff",
    "--support-lime-50": "#7eb63eff",
    "--support-lime-60": "#6baa23ff",
    "--support-lime-70": "#629c20ff",
    "--support-lime-80": "#53821bff",
    "--support-lime-90": "#416616ff",
    "--support-lime-100": "#395913ff",
    "--support-green-10": "#e7f3eeff",
    "--support-green-20": "#d0ebdfff",
    "--support-green-30": "#9dd8bcff",
    "--support-green-40": "#62c395ff",
    "--support-green-50": "#2db071ff",
    "--support-green-60": "#149a5aff",
    "--support-green-70": "#128850ff",
    "--support-green-80": "#107444ff",
    "--support-green-90": "#0e613aff",
    "--support-green-100": "#0d5734ff",
    "--support-orange-10": "#ffd8c7ff",
    "--support-orange-20": "#ffc7aeff",
    "--support-orange-30": "#ffab86ff",
    "--support-orange-40": "#ff905eff",
    "--support-orange-50": "#ff7e44ff",
    "--support-orange-60": "#ef7640ff",
    "--support-orange-70": "#c46135ff",
    "--support-orange-80": "#9f4f2bff",
    "--support-orange-90": "#783c21ff",
    "--support-orange-100": "#5d2f1aff",
    "--support-yellow-10": "#fff5daff",
    "--support-yellow-20": "#ffeab5ff",
    "--support-yellow-30": "#ffdf8cff",
    "--support-yellow-40": "#ffd15bff",
    "--support-yellow-50": "#ffca43ff",
    "--support-yellow-60": "#e8b73dff",
    "--support-yellow-70": "#c79c34ff",
    "--support-yellow-80": "#a37e2bff",
    "--support-yellow-90": "#795c20ff",
    "--support-yellow-100": "#674d1bff",
    "--support-red-10": "#ffe5e6ff",
    "--support-red-20": "#fccaccff",
    "--support-red-30": "#f79ea3ff",
    "--support-red-40": "#f2757cff",
    "--support-red-50": "#ed515aff",
    "--support-red-60": "#eb3e48ff",
    "--support-red-70": "#ce363fff",
    "--support-red-80": "#a92c33ff",
    "--support-red-90": "#7a1f24ff",
    "--support-red-100": "#60181cff",
    "--support-pink-10": "#f1e5edff",
    "--support-pink-20": "#ebd4e3ff",
    "--support-pink-30": "#deabcdff",
    "--support-pink-40": "#d289baff",
    "--support-pink-50": "#c768a7ff",
    "--support-pink-60": "#c0549cff",
    "--support-pink-70": "#a94a89ff",
    "--support-pink-80": "#853b6cff",
    "--support-pink-90": "#5e2a4dff",
    "--support-pink-100": "#49213cff",
    "--support-violet-10": "#e6e2f0ff",
    "--support-violet-20": "#d6cdeaff",
    "--support-violet-30": "#bcabe0ff",
    "--support-violet-40": "#9b80d4ff",
    "--support-violet-50": "#8562cbff",
    "--support-violet-60": "#754cc5ff",
    "--support-violet-70": "#6a46b2ff",
    "--support-violet-80": "#563b90ff",
    "--support-violet-90": "#3d2d66ff",
    "--support-violet-100": "#322652ff",
    "--support-purple-10": "#d2d7f0ff",
    "--support-purple-20": "#c0c6ebff",
    "--support-purple-30": "#9ba3e0ff",
    "--support-purple-40": "#7b84d6ff",
    "--support-purple-50": "#5b66cdff",
    "--support-purple-60": "#4854c7ff",
    "--support-purple-70": "#3b46afff",
    "--support-purple-80": "#232d84ff",
    "--support-purple-90": "#111962ff",
    "--support-purple-100": "#091051ff",
    "--support-brown-10": "#ede7e4ff",
    "--support-brown-20": "#e4d9d3ff",
    "--support-brown-30": "#d0b8adff",
    "--support-brown-40": "#be9989ff",
    "--support-brown-50": "#aa7a64ff",
    "--support-brown-60": "#9e664dff",
    "--support-brown-70": "#8d5a43ff",
    "--support-brown-80": "#714733ff",
    "--support-brown-90": "#533122ff",
    "--support-brown-100": "#3a2014ff",
    "--support-grey-10": "#f2f2f2ff",
    "--support-grey-20": "#e5e5e5ff",
    "--support-grey-30": "#cacacaff",
    "--support-grey-40": "#b2b2b2ff",
    "--support-grey-50": "#9a9a9aff",
    "--support-grey-60": "#909090ff",
    "--support-grey-70": "#808080ff",
    "--support-grey-80": "#626262ff",
    "--support-grey-90": "#484848ff",
    "--support-grey-100": "#373737ff",
    "--fixed-white": "#ffffffff",
    "--fixed-black": "#000000ff"
  }
};
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-85.use[1]!./node_modules/@vue/cli-service/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/Theme/Theme.vue?vue&type=script&lag=ts&lang=js


/* harmony default export */ var Themevue_type_script_lag_ts_lang_js = ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.defineComponent)({
  name: "OrqTheme",
  setup() {
    return {
      colorTokens: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(() => defaultTheme.properties)
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Theme/Theme.vue?vue&type=script&lag=ts&lang=js
 
;// CONCATENATED MODULE: ./src/components/Theme/Theme.vue




;
const Theme_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(Themevue_type_script_lag_ts_lang_js, [['render',Themevue_type_template_id_46278670_render]])

/* harmony default export */ var Theme = (Theme_exports_);
;// CONCATENATED MODULE: ./src/orquestra-web-vue.js
















































































































;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=orquestra-web-vue.umd.js.map